import { Component, OnInit,AfterViewInit, ElementRef, Renderer2, ViewChild,NgZone,ViewEncapsulation,OnChanges, OnDestroy,Input, Output,EventEmitter} from '@angular/core';
import {BrowserModule, DomSanitizer, Title} from '@angular/platform-browser'
import {Observable, fromEvent } from 'rxjs';
import { HostListener } from '@angular/core';
import { environment } from '../../environments/environment';
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import { FmeService } from '../inservice/fme.service';
import { FrmService } from '../inservice/frm.service';
import {Utils} from '../_util/utils';
import { ChangeDetectorRef, AfterContentChecked} from '@angular/core';
import { InjectDirective } from '../_directive/inject.directive';
import {CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl, ValidatorFn, Validators} from '@angular/forms';
import * as XLSX from 'xlsx'
import { Md5 } from 'ts-md5/dist/md5';
import { read, utils, writeFile } from 'xlsx';
import { DatePipe} from '@angular/common';
import * as fileSaver from 'file-saver';
import * as i from 'src/assets/scripts/htmldiff';
import { get } from 'http';
import { parse } from 'path';

//import { HtmlDiffer } from 'html-differ';
//import { logger } from'html-differ/lib/logger';
declare var WEBSPELLCHECKER: any;
declare var replaceEvent:any;
declare var $: any;
declare var htmldiff:any;
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ReportComponent implements OnInit {
	myForm = new FormGroup({});
	closerForm = new FormGroup({});
  	proId:string;
	logoInfo=[];
	userInfo:any;
	userId:string;
	userName="User";
	r:string;
	public logOutFlag=0;
	public showLogo=0;
	reportInfo:any;
	addon:string;
	types=[];
	libraries=[];
	libLabels=[];
	slots=[];
	tempSlots=[];
	curSlots=[];
	rangeIndex=0;
	curLibs=[];
	itemIndex=0;
	cols1:any[];
	cols2:any[];
	cols3:any[];
	cols4:any[];
	cols5:any[];
	cols6:any[];
	cols7:any[];
	selectedSlot:any;
	selectedRptType:string;
	selectedType="";
	selectedCover={'COPIED_FROM_ID':null,'COVERPAGE_ID':null, 'COVERPAGE_TITLE':null};
	selectedHeader={'COPIED_FROM_ID':null,'HEADER_ID':null, 'HF_TITLE':null};
	selectedFooter={'COPIED_FROM_ID':null,'FOOTER_ID':null, 'HF_TITLE':null};
	selectedTHeader={'COPIED_FROM_ID':null,'TOC_HEADER_ID':null, 'HF_TITLE':null};
	selectedTFooter={'COPIED_FROM_ID':null,'TOC_FOOTER_ID':null, 'HF_TITLE':null};
	selectedFrmFooter={'COPIED_FROM_ID':null,'FRM_FOOTER_ID':null, 'HF_TITLE':null};
	selectedWatermarker={'WATERMARK_ID':null,'WM_TITLE':null};
	selectedProfile=-1;
	selectedIden="";
	frontpages=[];
	contents:any[];
	appendices={'SECTION_SEQUENCE': "",'SECTION_TITLE': 'APPENDICES','SUB_SECTIONS':[]};
	xmlContent:any;
	xmlName='';
	curIndex=[];
	pageIndex=[];
	slotCategories:any[];
	slotTypes:any[];
	groupSlots=[];
	templateSlots=[];
	public expandedRows = {};
	isExpanded=false;
	slotCheckAll=false;
	seleltedCat='CATEGORY';
	//curTemp:any;
	spinnerConfirm:false;
	addedLib=[];
	libToSlot=false;
	slotToLib=false;
	curLib=[];
	curLibId=[];
	curSlot=[];
	rangeSlot=[];
	rangeLib=[];
	curSlotId=[];
	newSlotLabel="";
	newSlotCat="";
	newSlotType="";
	newSlotMultiple="N";
	newSlotFile={'url':'', 'name':'', 'ext':''};
	newSlotContent="";
	newSlotOp="";
	newSlotOps=[];
	slotTableType=-1;
	erisSlots=[];
	tableSlots=[];
	//narrSlots=[];
	filteredData:any[];
	otherTypes=['TABLE','MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE','SEALS','SIGNS','PDFSEC', 'PISUMMARY','PITABLE','PCASUMMARY','COST'];
	noImportTypes=['MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE','PDFSEC', 'PISUMMARY','PITABLE','PCASUMMARY','COST'];
	curTableData:any;
	curCostTable:any;
	rowNo=0;
	colNo=0;
	colType=[];
	newLibPara=[];
	addedItem:any;
	addBefore=false;
	addLibWarn=false;
	allEditor=[];
	selectedCell:any;
	selectedRow:number;
	inputLabels='';
	isEven=true;
	rPercentage=0;
	wPercentage=0;
	imgGroup='other';
	uploadFiles=0;
	uploadTotal=0;
	uploadNo=0;
	//public current:any;
	public reports=[];
	public curReport:any;
	public covers=[];
	public covercopy=[];
	//public tmps=[];
	public bks=[];
	public others=[];
	public photos=[];
	public logos=[];
	public headers=[];
	public headercopy=[];
	public footers=[];
	public footercopy=[];
	public projectFiles=[];
	public selectedEditor:string;
	public selectedIndex:number;
	public selectedContainer;
	public selectedImage;
	public selectedInsert=[];
	
	private fileReader: FileReader;
	public pageMargin={'top':'0', 'bottom':"0", 'left':"25", 'right':"25"};
	public tocMargin={'top':'0', 'bottom':"0", 'left':"25", 'right':"25"};
	public portraitSize={'width':'816','height':'1056'};
	public landscapeSize={'width':'1056','height':'816'};
	public legalPortraitSize={'width':'816','height':'1344'};
	public legalLandscapeSize={'width':'1344','height':'816'};
	public ledgerPortraitSize={'width':'1056','height':'1632'};
	public ledgerLandscapeSize={'width':'1632','height':'1056'};
	public selectpage={'type':'portrait', 'size':{'width':'816','height':'1056'}};
	public selectPdi='96';
	public selectFont="times new roman";
	public lineSpace="0";
	public content='';
	public rowData;
	public savedData:any;
	public uploadType:string;
	public logoUrl='';
	public bimageurl='';
	public paraIndex=0;
	showCover=false;
	slotGroup='T';
	libGroup='A';
	addLib=false;
	appOp='O';
	definedSlotGroup=[];
	definedLibGroup=[];
	loading=false;
	pdfs=[];
	tableContent=[];
	tableContent1=[];
	editOrder=false;
	watermarkers=[];
	erisPdfs=[];
	curSec:any;
	cellShow=false;
	date:string;
	curDoc:any;
	optionShow=false;
	pageOPShow=false;
	tableToolShow=false;
	commShow=false;
	//libInfoShow=false;
	public currencies=[];//['USD','CAD','EUR','GBP','CHF','MXN','YEN'];
	public multipliers:any;
	public pcaOp={'term':'Include','multiplier':"",'quantity':0, 'reserve':10, 'age':0, 'decimal':0,'currency':'USD','inflation':2.5,'round':'Round'};
	public pcaLibraries=[];
	public costTables=[];
	public curCosts=[];
	public curCost:any;
	public curCostId=[];
	public addedCost=[];
	public rowItem={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'Immediate': 0,'Short': 0, 'EFF':0,'EUL':0,'RUL':0,'RULtext':'', "Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10, 'data':{'COST':[]}, 'NTCHK':false,'DMCHK':false, 'CRCHK':false,'LSCHK':false, 'NT':'','LS':0, 'CR':0, 'DM':0,'LSBD':'', 'CRBD':'', 'DMBD':'', 'shortCat':'','long':'','longCat':'', 'catItem':-1, 'selectedYear':[],'shortCHK':false,'immiCHK':false,};
	public newRow={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'Immediate': 0,'Short': 0, 'EFF':0,'EUL':0,'RUL':0,'RULtext':'', "Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10,'data':{'COST':[]}, 'NTCHK':false,'DMCHK':false, 'CRCHK':false,'LSCHK':false, 'NT':'','LS':0, 'CR':0, 'DM':0,'LSBD':'', 'CRBD':'', 'DMBD':'', 'shortCat':'','long':'','longCat':'', 'catItem':-1, 'selectedYear':[], 'shortCHK':false,'immiCHK':false,};
	public frmrowItem={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'EFF':0,'EUL':0,'RUL':0,'RULtext':'', "Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10,'data':{'COST':[]}, 'CRCHK':false,'PRCHK':false, 'PR90CHK':false,'ORCHK':false,'PR':0, 'CR':0, 'PR90':0,'PRBP':'', 'CRBP':'', 'PR90BP':'','MOComm':'', 'CRBD':'', 'CPRComm':'', 'ORBP':'','selectedYear':[],"ItemType":"","CatType": "","CatSubtype":"","EstUsefulLifeYrCountRangeValue":"","RatingType":"","RemainingUsefulLifeYrRangeValue":"","RepairPriorityType":"","CommentText":"",'condition':'','area':'', 'ACTION':[], 'actions':[],'actiontext':'','PRQuantity':"", 'CRQuantity':"", 'PR90Quantity':"", 'RRQuantity':""};
	public newFrmRow={'index':[],'Item': '','Quantity': 0,'Unit': '','Cost': 0,'Cycle': 0,'Percent': 100,'EFF':0,'EUL':0,'RUL':0,'RULtext':'', "Total":0, 'Reserve':0,'reserve':0,'averageReserve':0,'inReserve':0,'averageINReserve':0,'allocate':[],'allow':false,'Year':10,'data':{'COST':[]}, 'CRCHK':false,'PRCHK':false, 'PR90CHK':false,'ORCHK':false,'PR':0, 'CR':0, 'PR90':0,'PRBP':'', 'CRBP':'', 'PR90BP':'','MOComm':'', 'CRBD':'', 'CPRComm':'', 'ORBP':'','selectedYear':[],"ItemType":"","CatType": "","CatSubtype":"","EstUsefulLifeYrCountRangeValue":"","RatingType":"","RemainingUsefulLifeYrRangeValue":"","RepairPriorityType":"","CommentText":"",'condition':'','area':'', 'ACTION':[], 'actions':[],'actiontext':'','PRQuantity':"", 'CRQuantity':"", 'PR90Quantity':"", 'RRQuantity':""};
	public costCols1=['Item','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Reserve Total','Immediate Total','Short Term Total'];
	public costKeys1=['Item','Quantity','Unit','Cost','Cycle','Percent','Reserve','Immediate','Short'];
	public costCols2=['Recommendation','EUL','EFF AGE','RUL','Year','Cost'];
	public costKeys2=['Item','EUL','EFF','RUL','Year','Total'];
	public units=[];
	public reserveWarn=false;
	public validateWarn=false;
	public validateWarn1=false;
	public quantityWarn=false;
	public totalCost=['','','','','','','',''];
	public repairData:any;
	public currSign='$';
	public savedRepair:any;
	public uploading=false;
	public addedPdfs=[];
	public clipBoard:any;
	public addedPhotos=[];
	public addedSeals=[];
	selectedFilters:any;
	filterShow=false;
	filterData=[];
	allSlotInfo=[];
	allSlots=[]
	ifPhoto=false;
	ifAppPdf=false;
	ifImage=false;
	addPdfIndex=[];
	saveTimer:any;
	start:number;
	end:number;
	//gap=15000;
	history=[];
	historyNo=1;
	curHisNo=1;
	totalShow=10;
	secHistory=[];
	fileShow=false;
	filterSlot:string;
	filtering=false;
	autoFlag=false;
	fromTemplate=false;
	curId:string;
	erisUpdated=false;
	updatedSlots=[];
	exSlots=[];
	expanded=false;
	seals=[];
	signs=[];
	intext=false;
	onlyCost=false;
	allRow=false;
	allCol=false;
	onlyWCompete=false;
	onlyRCompete=false;
	hideSection=false;
	lpagesize="legal-landscape";
	pdfType:any;
	commIds=[];
	head1:string;
	head2:string;
	head3:string;
	head1Space='1';
	head2Space='1';
	head3Space='1';
	listid:string;
	listTitle:string;
	listLocked:boolean;
	onlock='';
	errMsg='';
	noPrint=false;
	blackText=false;
	acceptType=[];
	profiles=[];
	printnodataforAppendix='Y';
	summaryCategory=[];//["Executive Summary","Code Information and Accessibility", "Site Improvements", "Architectural and Structural Systems", "Interior Components"];
	preShow=false;
	isOnline = navigator.onLine;
	defaultSign:any;
	noEditableFmeSec=['fme_exec_sum_ul_0','fme_exec_sum_cost_estimates_0','fme_exec_sum_ir_1','fme_exec_sum_ir_2','fme_exec_sum_ir_3','fme_exec_sum_ir_4','fme_exec_sum_ir_5','fme_exec_sum_capital_needs_1'];
	allowFmeInput='Y';
	rrCols=[1,1,1,1,1];
	rrRows=[1,1,1];
	
	@ViewChild(InjectDirective) injectComp: InjectDirective;
	@ViewChild("viewer") viewer: ElementRef;
	@ViewChild("outContent") outContent: ElementRef;
	@ViewChild('file') file: ElementRef;
	@ViewChild('file1') file1: ElementRef;
	@ViewChild('file2') file2: ElementRef;
	@ViewChild('file3') file3: ElementRef;
	@ViewChild('file4') file4: ElementRef;
	@ViewChild('file5') file5: ElementRef;
	@ViewChild('pdfmsg') pdfmsg: ElementRef;
	@ViewChild('pdfspin') pdfspin: ElementRef;
	@ViewChild('op120') op120: any;
	@ViewChild('hotkeyIcon') hotkeyIcon: ElementRef;
	//@ViewChild('edittable') edittable: ElementRef;
	@ViewChild('edittableContainer') edittableContainer: ElementRef;
	constructor(private datePipe:DatePipe, private location: Location,private titleService :Title, public sanitizer: DomSanitizer, private router: Router, public reportService: ReportService, private zone: NgZone, private cookieService:CookieService,private route: ActivatedRoute,private cdref: ChangeDetectorRef, public fmeService:FmeService, public frmService:FrmService, private ngZone: NgZone) {
		this.titleService.setTitle("Report");
		if(this.reportService.autoSaveFlag=='Y'){
			this.autoFlag=true;
		}
		this.acceptType=this.reportService.acceptFileType.split(',');
		let w = Math.floor(Utils.mmToPx(279, this.reportService.dpi)); //console.log(w);
		let h = Math.floor(Utils.mmToPx(216, this.reportService.dpi)); //console.log(h);
			this.cols1 = [
			//{ field: 'SLOT_ID', header: 'Id' },
				{ field: 'KEY', header: 'label', width: '20%' },
			{ field: 'CONTENT', header: 'Content', width: '50%' },
			{ field: 'CATEGORY', header: 'Category', width: '20%' },
			{ field: '', header: '' , width: '10%' },

		];
		this.cols2 = [
			{ field: 'CATEGORY', header: 'Category', width: '92%' },
			//{ field: '', header: '' , width: '10%' },

		];
		this.cols3 = [
			{ field: 'KEY', header: 'label', width: '30%' },
			{ field: 'CONTENT', header: 'Content', width: '60%' },
			{ field: '', header: '' , width: '10%' },

		];
		this.cols4 = [
			{ field: 'LABELS', header: 'Title', width: '92%' },
			//{ field: '', header: '' , width: '10%' },

		];
		this.cols5 = [
			//{ field: 'SLOT_ID', header: 'Id' },
				{ field: 'ITEM_TITLE', header: 'label', width: '10%' },
			{ field: 'LABELS', header: 'Content', width: '10%' },
			{ field: 'INSTRUCTIONS', header: 'Category', width: '30%' },
			{ field: 'CONTENT', header: '' , width: '50%' },

		];
		this.cols6 = [
			//{ field: 'SLOT_ID', header: 'Id' },
				{ field: 'FILE_NAME', header: 'File Name', width: '40%' },
			{ field: 'FILE_TYPE', header: 'File Type', width: '11%' },
			{ field: 'PROJECT_NUMBER', header: 'Project Name', width: '15%' },
			{ field: 'REPORT_CATEGORY', header: 'Report Type ' , width: '14%' },
			{ field: 'UPDATED_BY', header: 'Upload By ' , width: '12%' },
			{ field: 'DATE_UPDATED', header: 'Date ' , width: '8%' },

		];
		this.cols7 = [
			//{ field: 'SLOT_ID', header: 'Id' },
				{ field: 'REPORT_TITLE', header: 'Report Name', width: '20%' },
			{ field: 'PROJECT_NUMBER', header: 'Project Number', width: '15%' },//{ field: 'PROJECT_NUMBER', header: 'Project Name', width: '15%' },
			{ field: 'PROPERTY_NAME', header: 'Property Name', width: '15%' },
			{ field: 'ADDRESS_LINE1', header: 'Address', width: '15%' },
			{ field: 'DATE_CREATED', header: 'Created Date ' , width: '15%' },
			{ field: 'LAST_UPDATED', header: 'Last Updated' , width: '15%' },
			{ field: 'STATUS', header: 'Status ' , width: '5%' },

		];
	}
	private async initReport() {
		this.router.events.subscribe(s => {
			if (s instanceof NavigationEnd) {
				const tree = this.router.parseUrl(this.router.url);
				if (tree.fragment) {
					const element = document.getElementById(tree.fragment);// document.querySelector(tree.fragment);
					if (element) { element.scrollIntoView(); }
				}
			}
		});
		let id = decodeURI(this.route.snapshot.paramMap.get('id'));
		this.proId = decodeURI(this.route.snapshot.paramMap.get('project'));
		if (this.cookieService.getCookie("userID")) {
			this.userInfo = JSON.parse(this.cookieService.getCookie("userInfo"));
			this.userId = this.cookieService.getCookie("userID");
			this.userName = this.cookieService.getCookie("userName");
			this.r = this.cookieService.getCookie("r");
			if (!isNaN(parseInt(id))) {
				let startJson = { "PROCEDURE": "getreportreadonly", "USER_ID": this.userId, "REPORT_ID": id }
				const response = await this.reportService.univeralService(JSON.stringify(startJson)).toPromise();
				
				if (response.RESPONSE_STATUS == 'Y') {
					if (response.READ_ONLY == 'N') {
						await this.getRpt(id);
						await this.getAllSlots(id);
						this.getGroupSlots(id);
						this.getSlots(id);
						this.getSlotPara();
						this.getslotType();
						this.getTableSlots(parseInt(this.userId));
						this.getCommId(id);
						this.checkPermit(id);
						this.getCompanyProfiles(id);
						this.getSignStyles(id);
						this.getSignInfo(id);
						this.getCompanySettings();
						//this.getLibraries();
						//this.getLibLabels();
					} else {
						if(response.ERROR_MESSAGE&&response.ERROR_MESSAGE.length>0){
							$('#overlay').css('display', 'none');
							Swal.fire({
								icon:'info',
								title: response.ERROR_MESSAGE,
								text:"Please close this browser tab to return to your dashboard.",
								showCancelButton: false,
								showConfirmButton: false, 
								backdrop:true,
								//showConfirmButton: false, //hide OK button
    							allowOutsideClick: false,
								//preConfirm: () => {
								//	this.router.navigate(['/']);
								//	return
								//}
							})
						}else{
							this.router.navigate(['complete-rpt/' + this.proId + '/' + id])
							.then(nav => {
								//console.log(nav); // true if navigation is successful
							}, err => {
								//console.log(err) // when there's an error
							});
						}
						
					}
				} else {
					$('#overlay').css('display', 'none');
					this.throwError(response)
				}
			} else {
				$('#overlay').css('display', 'none');
				Swal.fire({
					html: ' <span style="color:red">Report not found.</span>'
				})
			}
		}else{
			this.router.navigate(['/']);
		}
	}
	getCommId(id){
		let inputJson={"PROCEDURE":"getreportsectionswithcomments","USER_ID":parseInt(this.userId),"REPORT_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				this.commIds=[];
				let comms=data.SECTION_LIST;
				for(let comm of data.SECTION_LIST){
					this.commIds.push(comm.SECTION_ID)
				}
				
			}else{
				this.throwError(data)
			}
		})
	}
	getWatermarkers(){
		let inputJson={"PROCEDURE":"getwatermarks", "USER_ID":parseInt(this.userId)};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.watermarkers=data.RW_WATERMARKS; 
			  }
		})
	}
	getSlots(id){
		let inputJson={"PROCEDURE":"getslotsbyreport", "USER_ID":parseInt(this.userId), "REPORT_ID":parseInt(id)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.tempSlots=data.RW_SLOTS;
			this.rangeSlot=this.tempSlots;
			this.rangeIndex=1;
			this.slotGroup='T';
			if(data.RW_SLOTS&&data.RW_SLOTS.length==0){
				this.slotGroup='A';
				this.rangeIndex=2;
			}
		}
			
		})
		
	}
	getGroupSlots(id){
		let inputJson={"PROCEDURE":"getallslotsbyreport", "USER_ID":parseInt(this.userId),"REPORT_ID": parseInt(id)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			
			if(data.RESPONSE_STATUS&&data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			
			}else{
				this.groupSlots=data.RW_SLOT_CATEGORIES;
			}
		})
	}
	getSlotPara(){
		let inputJson={"PROCEDURE":"getslotcategories","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slotCategories=data.RW_SLOT_CATEGORIES;
			  }
		})
		
	}
	getslotType(){
		let inputJson={"PROCEDURE":"getslottypes","CREATE_NEW_RF":"Y"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.slotTypes=data.RW_SLOT_TYPES;
			  }
		})
	}
	/*toGroup(data, key){
		return data.reduce(function(rv, x) {	
			(rv[x[key]] = rv[x[key]] || []).push(x);
			return rv;
		}, {});
	}*/
	getLibraries(){
		this.loading=true
		this.zone.run(()=>{this.loading=true;})
		let id=parseInt(this.userId);
		//let inputJson={"PROCEDURE":"getlibrary", "USER_ID":id, "KEYWORD":"", "REPORT_TYPE":"ESA","REPORT_ID":this.curReport.REPORT_ID,};
		let inputJson={"PROCEDURE":"getlibrarysimple", "USER_ID":id, "KEYWORD":"", "REPORT_TYPE":"ESA","REPORT_ID":this.curReport.REPORT_ID,};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
				this.libraries=data.RW_LIBRARY;
				this.filted=false;
			  }
			this.zone.run(()=>{this.loading=false;})
		})
		
	}
	getLibLabels(){
		let id=parseInt(this.userId);
		let inputJson={"PROCEDURE":"getlibrarylabels","USER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.libLabels=[];
			let that=this;
			data.RW_LABELS.forEach(name => {
				that.libLabels.push({ label: name.LABEL, value: name.LABEL });
			});
		}
		})
	}
	allowDrag='Y';
	allowAdd='Y';
	allowLock='N';
	allowDragMsg:string;
	allowAddMsg:string;

	checkPermit(id){
		let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"REPORT_ID":id,"FUNCTION_ID":14};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION){;
					this.allowDrag=data.USER_PERMISSION;
				}
				this.allowDragMsg=data.MESSAGE;
			}else{
				this.throwError(data)
			}
		})
		let inputJson1={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"REPORT_ID":id,"FUNCTION_ID":16};
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION){;
					this.allowAdd=data.USER_PERMISSION;
				}
				this.allowAddMsg=data.MESSAGE;
			}else{
				this.throwError(data)
			}
		})
		let inputJson2={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"REPORT_ID":id,"FUNCTION_ID":53};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
			if(data.RESPONSE_STATUS=='Y'){
				if(data.USER_PERMISSION){;
					this.allowLock=data.USER_PERMISSION;
				}
				//conthis.allowAddMsg=data.MESSAGE;
			}else{
				this.throwError(data)
			}
		})
	}
	async checkUserPermit(functionid){
		let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"FUNCTION_ID":functionid};
		const data= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			if(data.RESPONSE_STATUS=='Y'){
				return data;
			}else{
				this.throwError(data)
			}
		
		
	}
	getTableSlots(id){
		let inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":id,"SLOT_TYPE":"Table"};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.erisSlots=data.RW_SLOTS;
			  }
		})
	}
	
	getProjectFiles(){
		let inputJson= {"PROCEDURE":"getfilesbyproject","USER_ID":parseInt(this.userId),"PROJECT_ID":parseInt(this.proId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.projectFiles=data.RW_UPLOAD_FILES;
			  }
		})
	}
	psmodalele:any;
	async ngOnInit() {
		this.isOnline = navigator.onLine;
		await this.initReport();
		

		if (environment.api.autoSave.toUpperCase() == "Y"){
			let that=this;
			window.clearInterval(that.saveTimer);
			that.saveTimer = window.setInterval(function () {
				that.autoSave('auto save');
			}, environment.api.autoSaveInterval);
		}

		let id=decodeURI(this.route.snapshot.paramMap.get('id'));
		let project=decodeURI(this.route.snapshot.paramMap.get('project')); 
		$(document).ready(function () {
			$('#tableModal').draggable();
			//$('#fileModal').draggable();
			$('#costDetailModal').draggable();
			$('#costZoomModal').draggable();
			$('#historyModal').draggable();
			$('#frmZoomModal').draggable();
		});	
	}
	ngAfterContentChecked() {
		this.cdref.detectChanges();
	}
	public onInfo(e){
	  //this.getOrderDetail();
	}
	onSavedLogo(e){
		
		this.showLogo = e;
    
	}
	onEditReport(e){
		
	}
	logOut(){
		this.logOutFlag++; 
	}
	@HostListener('window:offline', [])
	onOffline() {
	  this.isOnline = false;
	  console.warn('Lost internet connection');
	
	  Swal.fire({
		icon: 'warning',
		title: 'Internet Connection Lost!',
		html: `

			<p>Please <b>do not</b> close this browser window.</p><br>
            <p>Check your Wi-Fi or network settings to restore your connection.</p><br>
            <p>
              Click "<b>Confirm</b>" once your internet connection is restored and
              <b>save your work immediately to avoid data loss</b>.
            </p>

		`,
		confirmButtonText: 'Confirm',
		confirmButtonColor: '#C2D63F',
		customClass: {
		  confirmButton: 'swal2-confirm-black-text'
		},
		allowOutsideClick: false,
		footer: `
		  <div style="border-top:none; margin-top:20px; font-size:12px; color:#6c757d;">
			-Scriva Support (866) 517-5204 Ext. 4-<br>
			-9AM - 8PM EST-
		  </div>
		`,
		didRender: () => {
		  const footer = document.querySelector('.swal2-footer') as HTMLElement;
		  if (footer) {
			footer.style.borderTop = 'none';
		  }
		}
	  });
	}

	@HostListener('window:online', [])
	onOnline() {
		this.isOnline = true;
		console.log('✅ Internet connection restored');
		/*Swal.fire({
			icon:'info',
			html: ' <span>your interent is back</span>'
		})*/
	}
	@HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
		this.exitReport(this.userId);
	}
	@HostListener('document:keydown', ['$event'])
	handleTheKeyboardEvent(event: KeyboardEvent) {
		if(this.tableShow&&this.preCell&&(!this.curCell)&&event.ctrlKey){
			switch (event.key) {
				case "ArrowRight":
					this.naviCell(event.key);
					event.preventDefault();
					break;
				
				case "ArrowDown":
					this.naviCell(event.key);
					event.preventDefault();
					break;
				
				case "ArrowLeft":
					this.naviCell(event.key);
					event.preventDefault();
					break;
				
				case "ArrowUp":
					this.naviCell(event.key);
					event.preventDefault();
					break;

				case "Enter":
					this.editCell();
					event.preventDefault();
					break;

				case "c":
					this.shortCut('c');
					event.preventDefault();
					break;
				
				case "v":
					this.shortCut('v');
					event.preventDefault();
					break;
				
				case " ":
					this.shortCut(' ');
					event.preventDefault();
					break;
				
				case "m":
						this.shortCut('m');
						event.preventDefault();
						break;
			}
		
		}else if(this.tableShow&&this.preCell&&this.curCell&&event.ctrlKey){
			switch (event.key) {
				case "m":
						this.shortCut('m');
						event.preventDefault();
						break;
			}
				
		}else if(this.tableShow&&this.preCell&&this.curCell&&event.altKey){
			switch (event.key) {
				case "s":
					$('#overlay2').css('display','block');
					this.saveCell(this.curSec);
					this.zone.run(()=>{
						$('#overlay2').css('display','none');
					})
					event.preventDefault();
					break;
				
				/*case "c":
					this.closeCell();
					event.preventDefault();
					break;
				*/
				case "ArrowRight":
					$('#overlay2').css('display','block');
					this.itemIndex++;
					this.curCell['reqIndex']=this.itemIndex;
					this.toCell(this.curSec.id);					
					setTimeout(() => {				
						this.naviCell(event.key);
						this.editCell();
						$('#overlay2').css('display','none');
					}, 300);	
					
					event.preventDefault();
					break;
				
				case "ArrowDown":
					$('#overlay2').css('display','block');
					this.saveCell(this.curSec);
					setTimeout(() => {				
						this.naviCell(event.key);
						this.editCell();
						$('#overlay2').css('display','none');
					}, 300);	
					event.preventDefault();
					break;
				
				case "ArrowLeft":
					$('#overlay2').css('display','block');
					this.saveCell(this.curSec);
					setTimeout(() => {				
						this.naviCell(event.key);
						this.editCell();
						$('#overlay2').css('display','none');
					}, 300);	
					event.preventDefault();
					break;
				
				case "ArrowUp":
					$('#overlay2').css('display','block');
					this.saveCell(this.curSec);
					setTimeout(() => {				
						this.naviCell(event.key);
						this.editCell();
						$('#overlay2').css('display','none');
					}, 300);	
					event.preventDefault();
					break;

				/*case "n":
					$('#overlay').css('display','block');
					this.toCell(this.curSec.id);					
					this.zone.run(()=>{
						this.toNextCell();
						this.editCell();
						$('#overlay').css('display','none');
					})
					event.preventDefault();
					break;*/
			}
		}
		
	}
	 private saveCell(doc){
		this.itemIndex++;
		this.curCell['reqIndex']=this.itemIndex;
		this.toCell(doc.id);	
	}
	startEdit=false
	public textData(e, id, title){
		let secIndex=this.getIdIndex(id);
		if(e.length==0){
			this.allEditor.push(id);
		}
		if(!this.startEdit){
			if(this.curIndex[0]==secIndex[0]){
				this.startEdit=true;
			}
		}
		if(this.startEdit){
			let data=this.sanitizer.bypassSecurityTrustHtml(e);
			this.toContentData('text', e, '',secIndex);
			this.toContentData('htmltext', data, '', secIndex);
			this.toContentData('suggestions', [], '',secIndex);
			this.toContentData('comments', [], '',secIndex);
			this.toContentData('tcusers', [], '',secIndex);
			let ids=this.getAllSlotId(e); 
			if(ids&&ids.length>0){
				this.updateRptSlotlist(ids);
			}
			let docSlot=[];
			if(ids&&ids.length>0){
				for(let id of ids){
					let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
					if(index>-1){
						docSlot.push(this.allSlots[index]);
					}
					
				}
				this.toContentData('slots', docSlot, '', secIndex);
			}
			this.autoSave('modify',id, title, 'O');
	
		}
	}
	textSuggest(e, id, title){
		//console.log(e, id, title);
		let secIndex=this.getIdIndex(id);
		if(e['html'].length==0){
			this.allEditor.push(id);
		}
		if(!this.startEdit){
			if(this.curIndex[0]==secIndex[0]){
				this.startEdit=true;
			}
		}
		if(this.startEdit){
		let users=[];
		if(e['suggestions']&&e['suggestions'].length>0 ){
			for(let item of e['suggestions']){
				if(!users.includes(item.authorId)){
					users.push(item.authorId);	
				}
			}
		}
		if(e['comments']&&e['comments'].length>0 ){
			for(let item of e['comments']){
				for(let comm of item['comments']){
					if(!users.includes(comm.authorId)){
						users.push(comm.authorId);	
					}
				}
			}
		}
		let htmlcontent=e['html'];
		if(users.length>0){
			this.toContentData('tcusers', users, '',secIndex);
			this.toContentData('comments', e['comments'], '',secIndex);
			this.toContentData('suggestions', e['suggestions'], '',secIndex);
		}else{
			this.toContentData('tcusers', [], '',secIndex);
			this.toContentData('comments', [], '',secIndex);
			this.toContentData('suggestions', [], '',secIndex);
			htmlcontent=this.trackErrorFix(htmlcontent);				
		}
		
		let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);
			this.toContentData('text', htmlcontent, '',secIndex);
			this.toContentData('htmltext', data, '', secIndex);
			let ids=this.getAllSlotId(htmlcontent); 
			if(ids&&ids.length>0){
				this.updateRptSlotlist(ids);
			}
			let docSlot=[];
			if(ids&&ids.length>0){
				for(let id of ids){
					let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
					if(index>-1){
						docSlot.push(this.allSlots[index]);
					}
					
				}
				this.toContentData('slots', docSlot, '', secIndex);
			}
			setTimeout(() => {
				this.autoSave('modify',id, title, 'O');
			}, 200);
			
		//let sid:string;
		//let stitle:string;
		//this.autoSave('modify',sid, stitle, 'F');	
		}
	}
	getAllCover(){
		let inputJson={"PROCEDURE":"getallcoverpages", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.covers=data.RW_COVERPAGES;	
			  }				
		})

	}
	getAllHeader(){
		let inputJson={"PROCEDURE":"getallheaders", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.headers=data.RW_HEADERS;
			  }			
		})
	}
	getAllFooter(){
		let inputJson={"PROCEDURE":"getallfooters", "USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.footers=data.RW_FOOTERS;
			  }
		})
	}
	getAllBk(){
		let inputJson={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"BKIMAGE"}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.bks=data.RW_UPLOAD_FILES;
			  }
		})
		let inputJson1={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"IMAGE"}
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.others=data.RW_UPLOAD_FILES;
			  }
		})
		let inputJson2={"PROCEDURE":"getcompanyfiles","USER_ID":this.userInfo.USER_ID,"FILE_TYPE":"LOGO"};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.logoInfo=data;
			this.logos=data.RW_UPLOAD_FILES;
			  }
		})
	}
	getPhotos(){
		let inputJson={"PROCEDURE":"GetPhotosByReport","USER_ID":this.userInfo.USER_ID,"REPORT_ID":this.curReport.REPORT_ID};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			  }else{
			this.photos=data.RW_UPLOAD_FILES;
			  }
		})
 
	}
	async getTemplate(tmp, id, temp?){
		let inputJson={"PROCEDURE":"gettemplate", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":tmp.TEMPLATE_ID};
	
		const response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if (response.RESPONSE_STATUS=='N') {
            this.throwError(response)
			return
        }
		
				if(temp){
					let inputJson1={"PROCEDURE":"gettempreportdata","USER_ID":parseInt(this.userId),"REPORT_ID":id};
					const result = await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
					if (result.RESPONSE_STATUS=='N') {
						this.throwError(result)
						return
					}
					response.TEMPLATE_DATA=result.TEMP_REPORT_DATA; 
					response.BEFORE_TOC=result.TEMP_BEFORE_TOC; 
				}
				
		if(response.BEFORE_TOC&&response.BEFORE_TOC.length>0){
			this.frontpages=JSON.parse(response.BEFORE_TOC); 				
		}else{
			this.frontpages=[];
		}
		if(response.PCA_DATA.length>0){
				let pca=JSON.parse(response.PCA_DATA); 
				this.pcaOp.term=pca.term;
				this.pcaOp.multiplier=pca.multiplier;
				this.pcaOp.decimal=pca.decimal;
				this.pcaOp.currency=pca.currency;
				this.pcaOp.inflation=parseFloat(pca.inflation);
				this.pcaOp.round=pca.round;
				if(pca.quantity){
					this.pcaOp.quantity=pca.quantity;
					this.pcaQuantity=this.pcaOp.quantity;					
				}
				if(pca.reserve){
					this.pcaOp.reserve=pca.reserve;
					this.reserveTerm=pca.reserve;
				}
				if(pca.EFF){
					this.pcaOp.age=pca.EFF;
				}
				
			}
		if(response.TEMPLATE_DATA.length>0){
			this.contents=JSON.parse(response.TEMPLATE_DATA);//console.log(this.contents)
			this.summaryStatus=this.haveSummary();
			this.generateSeq();
			if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
				await this.slotTableGetData()
			};
			if(this.allSlots.length>0){
				let that=this;
				setTimeout(() => {
					that.fromTemplate=false;
				}, 2000);
				await this.replaceSlots();
				
				setTimeout(() => {
					that.saveIniReport();
				}, 4000);
			}else{
				this.fromTemplate=true;
			}
			if(this.reportInfo.PCA_INDICATOR=='frm1105'){
				this.iniFrmCostData()				
			}else if(this.reportInfo.PCA_INDICATOR&&this.reportInfo.PCA_INDICATOR=='frm1104'){
				this.toFlat();
			}else if(this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=='1103'){
				this.toFlat();
			}
			//console.log('tempFrm')
			this.summaryStatus=this.haveSummary();
		}else{
			this.contents=[];
			if(this.frontpages.length>0){
				if(this.allSlots.length>0){
					let that=this;
					setTimeout(() => {
						that.fromTemplate=false;
					}, 2000);
					await this.replaceSlots();
					//$('#overlay').css('display','none');
					setTimeout(() => {
						that.saveIniReport();
					}, 4000);
				}else{
					this.fromTemplate=true;
				}
			}else{
				Swal.fire({
					icon:'info',
					html: ' <span>Template is empty</span>'
				})
				$('#overlay').css('display','none');
				
				
			}
		}
			
			this.curIndex=[this.addon,this.addon,this.addon];
			if(response.APPENDIX_DATA.length>0){
				this.appendices=JSON.parse(response.APPENDIX_DATA); 
				
				for(let item of this.appendices.SUB_SECTIONS){
					if (item.RF&&item.RF.length>0){
						let slots='';
						for(let p of item.RF){
							if(p.SLOT_ID){
								slots+=p.SLOT_ID+',';
							}
						}
					
						let inputJson2={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":slots,"REPORT_ID":parseInt(id)};
						const data =await this.reportService.univeralService(JSON.stringify(inputJson2)).toPromise()//ubscribe(data => {
							
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)
								
							}else{
							let info=data.RW_SLOTS;
							item.app=[];
							for(let p of item.RF){
								let index=info.findIndex(s=>s.SLOT_ID==p.SLOT_ID);
								if(index>-1){
									let selected=true;
									if(info[index].FILE_EXTENSION!='PDF'){
										selected=false;
									}
									p={"url":info[index].CONTENT,"name":info[index].KEY, 'type':info[index].FILE_EXTENSION,'selectedfile':selected, 'ERIS_FILE':info[index].ERIS_FILE};
									item.app.push(p);
								}
								
							}
						
							this.updatePdfs();
							this.updatePhotolog();
							//this.update1103();
						}
						
					}
				}
				
			}
				
			/*if(response.BEFORE_TOC&&response.BEFORE_TOC.length>0){
				this.frontpages=JSON.parse(response.BEFORE_TOC); 				
			}*/
			if(response.PDF_FILE_NAME&&response.PDF_FILE_NAME.length>0){
				this.pdfFname=JSON.parse(response.PDF_FILE_NAME);
				if(!this.pdfFname.reqIndex){
					this.pdfFname.reqIndex=0;
				}
				let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":parseInt(id),"PDF_FILE_NAME":response.PDF_FILE_NAME};
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						if (data.RESPONSE_STATUS=='N') {
							this.throwError(data)							
						}
					
				})
			}
			
			/*if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
				await this.slotTableGetData()
			};
			this.saveIniReport();*/
	}
	async getAllSlots(id){
		
		let tempJson={"PROCEDURE":"getslotsbyreportnocategory", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		
		const response = await this.reportService.univeralService(JSON.stringify(tempJson)).toPromise();
		
		if(response.RESPONSE_STATUS=="N"){
			this.throwError(response)
			this.allSlots=[];
			$('#overlay').css('display','none');
		}else{
			
			this.allSlots=response.RW_SLOTS; 
			if(this.fromTemplate){
				await this.replaceSlots();
				let that=this;
				//$('#overlay').css('display','none');
				setTimeout(() => {
					if(that.reportInfo.COPIED_REPORT=='Y' && that.reportInfo.COPIED_REPORT_OPENED=='N'){
						that.saveCopiedReport();
					}else{
						that.saveIniReport();
					}
					
				}, 2000);
				
			};
			
		}
	}
	private locations(substring,string){
		var a=[],i=-1;
		while((i=string.indexOf(substring,i+1)) >= 0) a.push(i);
		return a;
	}
	private formatPhoneNumber(phoneNumberString) {
		var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
		var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
		if (match) {
		  return '(' + match[1] + ') ' + match[2] + '-' + match[3];
		}
		return null;
	  }
	stateList=['AL',
		'AK',
		'AZ',
		'AR',
		'CA',
		'CO',
		'CT',
		'DE',
		'FL',
		'GA',
		'HI',
		'ID',
		'IL',
		'IN',
		'IA',
		'KS',
		'KY',
		'LA',
		'ME',
		'MD',
		'MA',
		'MI',
		'MN',
		'MS',
		'MO',
		'MT',
		'NE',
		'NV',
		'NH',
		'NJ',
		'NM',
		'NY',
		'NC',
		'ND',
		'OH',
		'OK',
		'OR',
		'PA',
		'RI',
		'SC',
		'SD',
		'TN',
		'TX',
		'UT',
		'VT',
		'VA',
		'WA',
		'WV',
		'WI',
		'WY']
	async preview(type?, id?){
		if(type!='apponly'){
			if(this.reportInfo.PCA_INDICATOR=='frm1105'){
				/*PropertyConditionAssessmentPropertyCoreCharacteristics[0]
				"Mortgage, Consultant and Property Information"
				PptyFloorCount  "Number of stories"
				PptyBuildingAgeYrCount "Age of buildings (in years)"
				PptyNonRsdntlBuildingCount "Number of other buildings"
				PptyRsdntlBuildingCount "Number of apartment buildings"
				--PropertyConditionAssessment[0]
				--InspectorPhoneNumber "Telephone number"
				--OnsiteContactPhoneNumber  "On-site contact telephone number"
				--PropertyAsReportedHTML?.PartyBusinessAccountId  "Seller/Servicer number" frmData.PropertyAsReported.PartyBusinessAccountId
				*/
				let msg="";
				let secdata=this.getSecbyId(this.contents, 'frm_sec');
				let dataset1=secdata.frmData.PropertyConditionAssessmentHTML;//console.log(dataset1.OnsiteContactPhoneNumber)
				let dataset2=secdata.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
				let dataset3=secdata.frmData.PropertyAsReportedHTML;
				if(dataset1.OnsiteContactPhoneNumber.html.length>0){
					let item=dataset1.OnsiteContactPhoneNumber;
					let input=item.html.replace('<p>','').replace('</p>','');
					if($(item.html.replace('<p>','').replace('</p>',''))[0]){
						input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
					}
					let index1=dataset1.OnsiteContactPhoneNumber.html.indexOf('data-status="N"');
					let index2=dataset1.OnsiteContactPhoneNumber.html.indexOf('data-status="Y"');
					if(index1>-1&&index2>-1){
						const childStatus = $(dataset1.OnsiteContactPhoneNumber.html)
						.find('.placeholder')
						.data('status');
						if(childStatus=='N'){
							index1=0;
						}else{
							index1=-1;
						}				
					}
					if(index1==-1){
						if(index2>-1){
							input=input.replace(/<[^>]*>/g, "");
						}
						let phoneNo=this.formatPhoneNumber(input);
						if(!isNaN(input)&&input.length==10&&phoneNo){
							dataset1.OnsiteContactPhoneNumber['formateText']=phoneNo;
						}else{
							let info="On-site contact telephone number: "+input+"<br>";
							msg+=info;
						}
					}else{
						dataset1.OnsiteContactPhoneNumber['formateText']=input.replace(/<[^>]*>/g, "");
					}
										
				}else{
					dataset1.OnsiteContactPhoneNumber['formateText']='';
				}
				
				if(dataset1.InspectorPhoneNumber.html.length>0){
					let item=dataset1.InspectorPhoneNumber;
					let input=item.html.replace('<p>','').replace('</p>','');
					if($(item.html.replace('<p>','').replace('</p>',''))[0]){
						input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
					}
					let index1=dataset1.InspectorPhoneNumber.html.indexOf('data-status="N"');
					let index2=dataset1.InspectorPhoneNumber.html.indexOf('data-status="Y"');
					if(index1>-1&&index2>-1){
						const childStatus = $(dataset1.InspectorPhoneNumber.html)
						.find('.placeholder')
						.data('status');
						if(childStatus=='N'){
							index1=0;
						}else{
							index1=-1;
						}				
					}
					if(index1==-1){
						if(index2>-1){
							input=input.replace(/<[^>]*>/g, "");
						}
						let phoneNo=this.formatPhoneNumber(input);
						if(!isNaN(input)&&input.length==10&&phoneNo){
							dataset1.InspectorPhoneNumber['formateText']=phoneNo;
						}else{
							let info="Telephone number: "+input+"<br>";					
							msg+=info;
						}
					}else{
						dataset1.InspectorPhoneNumber['formateText']=input.replace(/<[^>]*>/g, "");
					}
										
				}else{
					dataset1.InspectorPhoneNumber['formateText']='';
				}
				if(dataset3.PartyBusinessAccountId.html.length>0){
					let item=dataset3.PartyBusinessAccountId;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");						
							if(input.length!=6||isNaN(input)){				
								let info="Seller/Servicer number: "+input+"<br>";	
								msg+=info;
							}		
						}	
					/*let input=item.html.replace('<p>','').replace('</p>','');
					if($(item.html.replace('<p>','').replace('</p>',''))[0]){
						input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
					}				
					if(input.length!=6||isNaN(input)){				
						let info="Seller/Servicer number: "+input+"<br>";	
						msg+=info;
					}	*/				
				}
				if(dataset2.PptyFloorCount.html.length>0){
					let item=dataset2.PptyFloorCount;	
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");						
							if(isNaN(input)){				
								let info="Number of stories: "+input+"<br>";	
								msg+=info;
							}		
						}
					/*let input=item.html.replace(/<[^>]*>/g, "");				
					if(isNaN(input)){				
						let info="Number of stories: "+input+"<br>";	
						msg+=info;
					}*/					
				}
				if(dataset2.PptyBuildingAgeYrCount.html.length>0){
					let item=dataset2.PptyBuildingAgeYrCount;	
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){							
							/*let input=item.html.replace('<p>','').replace('</p>','');
							if($(item.html.replace('<p>','').replace('</p>',''))[0]){
								input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
							}*/
							let input=item.html.replace(/<[^>]*>/g, "");						
							if(isNaN(input)){				
								let info="Year(s) of construction: "+input+"<br>";	 //Age of buildings (in years)
								msg+=info;
							}		
						}
									
				}
				if(dataset2.PptyNonRsdntlBuildingCount.html.length>0){
					let item=dataset2.PptyNonRsdntlBuildingCount;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){							
							/*let input=item.html.replace('<p>','').replace('</p>','');
							if($(item.html.replace('<p>','').replace('</p>',''))[0]){
								input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
							}*/
							let input=item.html.replace(/<[^>]*>/g, "");						
							if(isNaN(input)){				
								let info="Number of other buildings: "+input+"<br>";	
								msg+=info;
							}		
						}
					/*let input=item.html.replace('<p>','').replace('</p>','');
					if($(item.html.replace('<p>','').replace('</p>',''))[0]){
						input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
					}							
					if(isNaN(input)){				
						let info="Number of other buildings: "+input+"<br>";	
						msg+=info;
					}*/					
				}
				if(dataset2.PptyRsdntlBuildingCount.html.length>0){
					let item=dataset2.PptyRsdntlBuildingCount;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){							
							/*let input=item.html.replace('<p>','').replace('</p>','');
							if($(item.html.replace('<p>','').replace('</p>',''))[0]){
								input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
							}*/
							let input=item.html.replace(/<[^>]*>/g, "");						
							if(isNaN(input)){				
								let info="Number of apartment buildings: "+input+"<br>";		
								msg+=info;
							}		
						}
					/*let input=item.html.replace('<p>','').replace('</p>','');
					if($(item.html.replace('<p>','').replace('</p>',''))[0]){
						input=$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
					}						
					if(isNaN(input)){				
						let info="Number of apartment buildings: "+input+"<br>";	
						msg+=info;
					}*/					
				}
				//console.log(msg)
				if(msg.length>0){
					let title="The following value does not match the data validation restrictions defined for these cell(s):<br>";
					let sec="<b>Section: Mortgage, Consultant and Property Information</b><br>";
					Swal.fire({
						icon:'info',
						html: '<div style="text-align:left">'+title+ sec +msg+'</div>',	
						width: '800px'					
					})
					return
				}
			}else if(this.reportInfo.PCA_INDICATOR=='frm1104'){
				/* Mortgage and Property Information: State, Zip
				--contents[0].SUB_SECTIONS[0].data?.StateUspsCode
				--contents[0].SUB_SECTIONS[0].data?.PostalCode
				contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId
				Consultant Information
				==contents[0].SUB_SECTIONS[1].data?.FirmPhoneNumber
				==contents[0].SUB_SECTIONS[1].data?.FirmPhoneExt
				
				contents[0].SUB_SECTIONS[1].data?.FirmStateUspsCode
				contents[0].SUB_SECTIONS[1].data?.FirmPostalCode
				contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId "Seller/Servicer number"
				*/
				let msg="";
				let msg1="";
				if(this.contents[0].SUB_SECTIONS[0].data.FrmLoanNo.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[0].data.FrmLoanNo;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId.text.trim();					
							if(input.length!=9||isNaN(input)){				
								let info="Freddie Mac loan number: "+input+"<br>";	
								msg1+=info;					
							}	
						}
					
				}
				if(this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber.text.trim().length>0){
					let input=this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber.text;
					let index1=this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber.html.indexOf('data-status="N"');
					let index2=this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber.html.indexOf('data-status="Y"');
					if(index1>-1&&index2>-1){
						const childStatus = $(this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber.html)
						.find('.placeholder')
						.data('status');
						if(childStatus=='N'){
							index1=0;
						}else{
							index1=-1;
						}				
					}
					if(index1==-1){
						if(index2>-1){
							input=input.replace(/<[^>]*>/g, "");
						}
						let phoneNo=this.formatPhoneNumber(input);
						if(!isNaN(input)&&input.length==10&&phoneNo){
							this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber['formateText']=phoneNo;
						}else{
							let info="Telephone number: "+input+"<br>";					
							msg+=info;
						}
					}else{
						this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber['formateText']=input.replace(/<[^>]*>/g, "");
					}
										
				}else{
					this.contents[0].SUB_SECTIONS[1].data.FirmPhoneNumber['formateText']='';
				}
				if(this.contents[0].SUB_SECTIONS[1].data.FirmStateUspsCode.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[1].data.FirmStateUspsCode;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[1].data.FirmStateUspsCode.text.trim();					
							if(this.stateList.indexOf(input.toUpperCase())==-1){				
								let info="State: "+input+"<br>";	
								msg+=info;
							}		
						}
					
				}
				if(this.contents[0].SUB_SECTIONS[1].data.FirmPostalCode.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[1].data.FirmPostalCode;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[1].data.FirmPostalCode.text.trim();					
							if(input.length!=5||isNaN(input)){				
								let info="Zip: "+input+"<br>";
								msg+=info;					
							}
						}					
				}
				//console.log(msg)
				if(msg.length>0){
					msg="<b>Section: Consultant Information</b><br>"+msg;							
				}
				if(this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId.text.trim();					
							if(input.length!=6||isNaN(input)){				
								let info="Seller/Servicer number: "+input+"<br>";	
								msg1+=info;					
							}	
						}
					
				}
				if(this.contents[0].SUB_SECTIONS[0].data.StateUspsCode.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[0].data.StateUspsCode;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[0].data.StateUspsCode.text.trim();					
							if(this.stateList.indexOf(input.toUpperCase())==-1){				
								let info="State: "+input+"<br>";	
								msg1+=info;					
							}
						}					
				}
				if(this.contents[0].SUB_SECTIONS[0].data.PostalCode.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[0].data.PostalCode;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[0].data.PostalCode.text.trim();					
							if(input.length!=5||isNaN(input)){				
								let info="Zip: "+input+"<br>";	
								msg1+=info;					
							}
						}					
				}
				if(msg1.length>0){
					msg1="<b>Section: Mortgage and Property Information</b><br>"+msg1;							
				}
				if(msg.length>0||msg1.length>0){
					let title="The following value does not match the data validation restrictions defined for these cell(s):<br>";
					Swal.fire({
						icon:'info',
						html: '<div style="text-align:left">'+title+msg1+msg+'</div>',	
						width: '800px'					
					})
					return
				}
			}else if(this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=='1103'){
				let msg="";
				if(this.contents[0].SUB_SECTIONS[0].data.FrmLoanNo.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[0].data.FrmLoanNo;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId.text.trim();					
							if(input.length!=9||isNaN(input)){				
								let info="Freddie Mac loan number: "+input+"<br>";	
								msg+=info;					
							}	
						}
					
				}
				if(this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo.text.trim().length>0){
					let input=this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo.text;
					let index1=this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo.html.indexOf('data-status="N"');
					let index2=this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo.html.indexOf('data-status="Y"');
					if(index1>-1&&index2>-1){
						const childStatus = $(this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo.html)
						.find('.placeholder')
						.data('status');
						if(childStatus=='N'){
							index1=0;
						}else{
							index1=-1;
						}				
					}
					if(index1==-1){
						if(index2>-1){
							input=input.replace(/<[^>]*>/g, "");
						}
						let phoneNo=this.formatPhoneNumber(input);
						if(!isNaN(input)&&input.length==10&&phoneNo){
							this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo['formateText']=phoneNo;
						}else{
							let info="On-site contact telephone number: "+input+"<br>";	
							msg+=info;						}	
					}else{
						this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo['formateText']=input.replace(/<[^>]*>/g, "");;
					}
									
				}else{
					this.contents[0].SUB_SECTIONS[0].data.OnsitePhoneNo['formateText']='';
				}
				
				if(this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber.text.trim().length>0){
					let input=this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber.text;
					let index1=this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber.html.indexOf('data-status="N"');
					let index2=this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber.html.indexOf('data-status="Y"');
					if(index1>-1&&index2>-1){
						const childStatus = $(this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber.html)
						.find('.placeholder')
						.data('status');
						if(childStatus=='N'){
							index1=0;
						}else{
							index1=-1;
						}				
					}
					if(index1==-1){
						if(index2>-1){
							input=input.replace(/<[^>]*>/g, "");
						}
						let phoneNo=this.formatPhoneNumber(input);
						if(!isNaN(input)&&input.length==10&&phoneNo){
							this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber['formateText']=phoneNo;
						}else{
							let info="Telephone number: "+input+"<br>";					
							msg+=info;
						}
					}else{
						this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber['formateText']=input.replace(/<[^>]*>/g, "");;
					}
										
				}else{
					this.contents[0].SUB_SECTIONS[0].data.FirmPhoneNumber['formateText']='';
				}
				if(this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId.text.trim().length>0){
					let item=this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId;
					const childStatus = $(item.html)
						.find('.placeholder')
						.data('status');
						if(childStatus!='N'){
							let input=item.html.replace(/<[^>]*>/g, "");	
							//let input=this.contents[0].SUB_SECTIONS[0].data.PartyBusinessAccountId.text.trim();					
							if(input.length!=6||isNaN(input)){				
								let info="Seller/Servicer number: "+input+"<br>";	
								msg+=info;
							}
						}					
				}
				//console.log(msg)
				if(msg.length>0){
					let title="The following value does not match the data validation restrictions defined for these cell(s):<br>";
					let sec="<b>Section: Mortgage, Consultant and Property Information</b><br>";
					Swal.fire({
						icon:'info',
						html: '<div style="text-align:left">'+title+sec+msg+'</div>',		
						width: '800px'				
					})
					return
				}
				/*"Mortgage, Consultant and Property Information"
				contents[0].SUB_SECTIONS[0].data?.OnsitePhoneNo.text

				"On-site contact telephone number"
				contents[0].SUB_SECTIONS[0].data?.FirmPhoneNumber
				"Telephone number"
				contents[0].SUB_SECTIONS[0].data?.PartyBusinessAccountId "Seller/Servicer number"
				*/
			}else if(this.reportInfo.PCA_INDICATOR=='Y'){
				let splitCheck=this.checkPcaTableSplit();
				if(!splitCheck){
					Swal.fire({
						icon:'info',
						title: 'Please check PCA table "split years for PDF" setting in section "Replacement Repair Cost Table" Options',
					})
					return
				}
			}

		}
		if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			let secdata=this.getSecbyId(this.contents, 'frm_sec');
			let dataset=secdata.frmData.PropertyConditionAssessment[0].PropertySeismicRiskAssessment[0];
			if(dataset.SeismicRiskFactorInd=='Y'){
				const values = Object.values(dataset);
				for(let value of values){
					if(!value){
						Swal.fire({
							icon:'info',
							html: ' <span>Required input needed</span>'
						})
						this.scroll('frm_sec0_5');
						return
					}
				}
			}			
		}
		if(type&&type=='xml'){
			this.passed='';
			if(this.fmeInputQuestion.length==0){
				await this.getFMEinput();
			}else{
				$("#fmeModal").modal('show');
			}	
			setTimeout(() => {
				this.passed=this.fmeInputValidate('print');
				if(this.passed=='Y'){
					this.printXml();
					$("#fmeModal").modal('hide');
				}
			}, 1000);
			
			setTimeout(() => {
				if(this.passed!='Y'){
					return
				}
				
				this.errMsg='';
				this.itemIndex++;
				this.pdfType={'index':this.itemIndex, 'type':type};

			}, 1000);
			
			
		}else{
			this.errMsg='';
			this.itemIndex++;
			this.pdfType={'index':this.itemIndex, 'type':type};
		}
		
		
		
	}
	
	public upload(type?) {//console.log(type)
		if(type){
			this.uploadType=type;
		}
		if(this.uploadType=='PHOTO'||this.uploadType=='IMAGE'||this.uploadType=='LOGO'||this.uploadType=='BKIMAGE'){
			this.file.nativeElement.click();
		}else if(this.uploadType=='FILE'){
			this.appOp='U';
			this.file1.nativeElement.click();
		}else if(this.uploadType=='slot'){
			this.file3.nativeElement.click();
		}else if(this.uploadType=='pdf'){
			this.file4.nativeElement.click();
		}
	}

	public uploadImage() {
	
	let that=this;
	this.uploadFiles=0;
		this.uploadNo=0;
    //const file = this.file.nativeElement.files[0];
	const files = this.file.nativeElement.files; //console.log(files);
    /*this.file.nativeElement.value = null;
    const ext = file.name.replace(/.+\./, '');
    if (['png','PNG', 'jpg','JPG', 'jpeg','JPEG'].indexOf(ext) === -1) {
      Swal.fire('Oops...', 'Only support .png|.jpg|.jpeg', 'error');
      return;
    }*/
	 if(files.length==0){
		this.loading=false;
      return
    }
	this.uploading=true;
	const total=files.length;
		this.uploadNo=total;
	 for(let i=0; i<files.length; i++){//console.log(files[0]);
      //this.file.nativeElement.value = null;
      const ext = files[i].name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
		   this.loading=false;
       return;
      }
    }
   	for (let file of files)  //for multiple files
    {   
		let reader = new FileReader();
        reader.onloadend = function(e) {
			let image = e.target.result.toString().split(',')[1]; //upload service
			let inputJson:any;
					
			if(that.uploadType=='BKIMAGE'){//console.log('bk image');
				//inputJson={"UploadFileName":file.name,"customerid":that.userId,"logoData":image};
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"BKIMAGE","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.bks.push(result);
					that.uploadFiles++	
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='PHOTO'){//console.log('report image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"PHOTO","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.photos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='IMAGE'){//console.log('other image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"IMAGE","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.others.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}else if(that.uploadType=='LOGO'){//console.log('LOGO image');
				inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"LOGO","filetitle":"","fdata":image};
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					that.uploading=false;
					if (result.RESPONSE_STATUS=='N') {
						that.throwError(result);
						return										
					}
					that.logos.push(result);
					that.uploadFiles++
					that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
					
			})
			}
			//console.log(inputJson)
			//that.reportService.uploadBkService(inputJson).subscribe(result=>{
			
		}
		reader.readAsDataURL(file);
		}
  }
  
	uploadFile(){
		
		let that=this;
		this.uploadFiles=0;
		this.uploadNo=0;
		const files = this.file1.nativeElement.files; //console.log(files);
		if(files.length==0){
			this.loading=false;
		return
		}
		for(let i=0; i<files.length; i++){
            const ext = files[i].name.replace(/.+\./, '');
			if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.uploading=false;
				return;
			}
		}
		this.uploading=true;
		const total=files.length;
		this.uploadNo=total;
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='N'){
					
						that.throwError(result);
						that.uploading=false;
						//console.log(result.ERRORCODE)
					}else{
						that.projectFiles.push(result);
						that.uploadFiles++
						that.uploadTotal=(that.uploadFiles/total)*100; ////console.log(that.uploadTotal)
						that.uploading=false;
					}
				})
		}
		reader.readAsDataURL(file);
		}
  }
  uploadFile1(){
		this.uploading=true;
		let that=this;
		const files = this.file3.nativeElement.files; //console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for(let i=0; i<files.length; i++){
            const ext = files[i].name.replace(/.+\./, '');
			if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.loading=false;
				return;
			}
		}
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.throwError(result);
						that.uploading=false;
						//console.log(result.ERRORCODE)
					}else{
						that.newSlotFile.name=result.FILE_NAME;
						that.newSlotFile.url=result.FILE_URL;
						that.newSlotFile.ext=result.FILE_EXTENSION;//console.log(that.newSlotFile);
						that.uploading=false;
					}
				})
		}
		reader.readAsDataURL(file);
		}
  }
  uploadPdf(){//console.log(this.selectIndex);
		this.uploading=true;
		let that=this;
		const files = this.file4.nativeElement.files; //console.log(files);
		if(files.length==0){
			this.uploading=false;
		return
		}
		for(let i=0; i<files.length; i++){
            const ext = files[i].name.replace(/.+\./, '');
			if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			this.loading=false;
				return;
			}
		}
		for (let file of files)  //for multiple files
		{
			let reader = new FileReader();
			reader.onloadend = function(e) {
				
				let filedata = e.target.result.toString().split(',')[1];//
				let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='N'){
						that.throwError(result);
						that.uploading=false;
						//console.log(result.ERRORCODE)
					}else{//console.log(that.selectIndex);
						that.curDoc.pdf=result.FILE_URL;
						that.curDoc.pdfName=result.FILE_NAME;
						that.uploading=false;//console.log(that.frontpages);
					}
				})
		}
		reader.readAsDataURL(file);
		}
  }
	selectImg(bk){
		//console.log(bk);
		this.selectedImage=bk;
		this.selectedContainer.src=bk.BKIMAGE_URL;
		//console.log(this.savedData.ht);
		const nodes = this.viewer.nativeElement.querySelectorAll('div.comp');//console.log(nodes)
		const nodes1 = this.viewer.nativeElement.querySelectorAll('div.ckContainer');//console.log(nodes1)
		let html='';
		nodes.forEach(node => {
          html += `${node.innerHTML}`;
        });
		//console.log(html);
	}
	public selectPage(type){
		let page:any;
		if(type=='portrait'){
			page=this.portraitSize;
		}else if(type=='landscape'){
			page=this.landscapeSize;
		}
		this.selectpage={'type':type, 'size':page};//console.log(this.selectpage)
	}
	/*private toStyle(data){//console.log(data);
		let html="";
		let p1=this.locations('<figure',data); //console.log(p1);
		let p2=this.locations('</figure>',data); //console.log(p2);
		for(let i=0; i<p1.length; i++){//console.log(i);
			if(i==0){
				html+=data.substring(0,p1[i]);
				let subContent=this.convertFigure(data.substring(p1[i], p2[i]+9))
				//console.log(subContent);
				html+=subContent;
			}else{//console.log(p2[i-1]+9);//console.log(p1[i]);
				html+=data.substring((p2[i-1]+9),p1[i]);
				let subContent=this.convertFigure(data.substring(p1[i], p2[i]+9))
				//console.log(subContent);
				html+=subContent;
			}
		}
		html+=data.substring((p2[p1.length-1]+9));
	
	 return html;
	}*/
	/*private convertFigure(node){//console.log(node);
		let value='';
		if($(node)[0].tagName=="FIGURE"){
			let item=$(node);//console.log(item)
			if(item.hasClass('image-style-align-left')){//console.log(item[0].style);
				item[0].style.float='left';
			}else if(item.hasClass('image-style-align-right')){//console.log(item[0].style);
				item[0].style.float='right';
			}else if(item.hasClass('image-style-align-center')){//console.log(item[0].style);
				item[0].style.display='block';
				item[0].style.margin='auto';
			}else{//console.log(item[0].style);
				item[0].style.display='block';
				item[0].style.margin='auto';
				if(!item[0].style.width){
					item[0].style.width='30%';
				}
			}
			item.children('img')[0].style.width='100%';
			//console.log(item.children('figcaption'));
			if(item.children('figcaption')[0]){
				item.children('figcaption')[0].style.textAlign = "center"
			}
			//console.log(item[0].outerHTML);
			value=item[0].outerHTML;
		 }
		 return value;
	}*/
	addFPage(){
		if (this.blockMultiUser()) return;
		let item={'TYPE':'FRONT','SECTION_TITLE': "Front Page", 'TEXT':'', 'pageSrc':'letter_style', 'header':null, 'footer':null,'SUB_SECTIONS':[], 'OSNAME':true};
		item['id']=Utils.uniqueIdGenerator();
		this.frontpages.push(item);
		this.listid=item['id'];
		this.selectedEditor='F';
		this.pageIndex=this.getFrontIdIndex(item['id']);
		this.listTitle=item['SECTION_TITLE'];
		this.curId=item['id'];
		this.curIndex=[];
		setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
		this.autoSave('add', item['id'], "Front Page", 'F');
			
	}
	addFSections(type?){
		if (this.blockMultiUser()) return;
		let item={'TYPE':'FIXED_SECTION','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Section Title",'SUB_SECTIONS':[]};
		
		if(type=='root'){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else if(type=='app'){
			let index=this.contents.findIndex(sec=>sec.SECTION_TITLE=='APPENDICES');
			if(index==-1){
				this.curIndex=[this.addon,this.addon,this.addon];
				item={'TYPE':'FIXED_SECTION','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "APPENDICES",'SUB_SECTIONS':[]};
			}else{
				return
			}
		}
		this.selectedEditor='O';
		this.addToContent(item, 'root');
		this.autoSave('add', item['id'], "Section Title", 'O');
	}
	addPara(){
		//await this.autoSave('manual save');
		let item={'TYPE':'PARA','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Text Section",'SUB_SECTIONS':[], 'OSNAME':true, 'TOC':true};
		this.addToContent(item);
	}
	addTable(){
		//this.autoSave('manual save');
		let item={'TYPE':'TABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Customized Table",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':true};
		this.addToContent(item);
	}
	addMap(){
		let item={'TYPE':'MAP','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Map",'SUB_SECTIONS':[]};
		this.addToContent(item);
	}
	summaryStatus=false;
	/*addSummary(){
		this.summaryStatus=this.haveSummary();
		if(this.summaryStatus){
			Swal.fire({
				html:'Project Summary exist already.'
			})
			return
		}else{
			let item={'id':'project_summary', 'TYPE':'SUMMARY','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "PCA Project Summary",'SUB_SECTIONS':[],'OTNAME':true, 'TOC':false, 'summaryData':0, "NEW":true};
			if(this.reportInfo.PCA_INDICATOR=='Y'){
				item['tableClass']=='PCA'
			}else if(this.reportInfo.TEMPLATE.length>0&&this.reportInfo.TEMPLATE[0].SUBCATEGORY_NAME=="Phase I"){
				item['tableClass']=='PHASE1'
			}
			this.addToContent(item);
			
		}
		
	}*/
	addPhotos(){
		//this.autoSave('manual save');
		let item={'TYPE':'PHOTOS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Photo",'SUB_SECTIONS':[], "photos":[]};
		this.addToContent(item);
	}
	addSeals(){
		let item={'TYPE':'SEALS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Seals",'SUB_SECTIONS':[], "seals":[],"OSNAME":true};
		this.addToContent(item);
	}
	addSigns(){
		let item={'TYPE':'SIGNS','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Signatures",'SUB_SECTIONS':[], "signs":[],"OSNAME":true};
		this.addToContent(item);
	}
	addPdfSec(){
		let item={'TYPE':'PDFSEC','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "PDF Section",'SUB_SECTIONS':[], "pageSrc":'pdf',"OSNAME":true };
		this.addToContent(item);		
	}
	/*addToContent(item, type?){
		if(this.allowAdd!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowAddMsg,
			})
			return
		}
		if(this.selectedEditor=='F'){//console.log(this.pageIndex)
			item['id']=Utils.uniqueIdGenerator();
			//this.listid=item['id'];
			//item['OSNAME']=false;
			if(type=='PARA'){
				this.allEditor.push(item['id'])
			}
			if(this.pageIndex[1]>-1){
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.splice(this.pageIndex[1]+1,0, item);
			}else{
				if(!this.frontpages[this.pageIndex[0]].SUB_SECTIONS){
					this.frontpages[this.pageIndex[0]]['SUB_SECTIONS']=[];
				}
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.push(item);
			}
			//console.log(this.frontpages[this.pageIndex[0]])
			this.autoSave('add', item['id'], item['SECTION_TITLE'], 'F');
			this.pageIndex=this.getFrontIdIndex(item['id']);
			this.curIndex=[];
			this.listid=item['id'];
			this.curId=item['id'];
		}else if(this.selectedEditor=='O'){
			
		
		if(this.curIndex[0]>-1||type=='root'){
		item['id']=Utils.uniqueIdGenerator();
		//this.listid=item['id'];
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			//this.curIndex=[index1,index2,index3+1];
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3+1,0, item);
		}else if(index2>-1&&!index3){
			//this.curIndex=[index1,index2+1,this.addon];
			//this.contents[index1].SUB_SECTIONS.splice(index2+1,0, item);
			
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(0,0,item);
				//this.curIndex=[index1,index2,0];
			}else{
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS=[item];
				//this.curIndex=[index1,index2+1,this.addon]
			}
			
		}else if(index1>-1&&!index2&&!index3){
			//this.curIndex=[index1+1,this.addon,this.addon];
			//this.contents.splice(index1+1,0,item);
			
			if(this.contents[index1].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS.splice(0,0,item);
				//this.curIndex=[index1,0,this.addon];
			}else{
				this.contents[index1].SUB_SECTIONS=[item];
				
			}
		}else{
			if(!this.contents){
				this.contents=[];
			}
			this.curIndex=[this.contents.length,this.addon,this.addon];
			this.contents.push(item);
			
		}
			this.generateSeq();
			if(item.TYPE!='COSTTABLE'){
				this.autoSave('add', item['id'], item['SECTION_TITLE'], 'O');
			}
			this.curIndex=this.getIdIndex(item['id']);
			this.pageIndex=[];
			this.listid=item['id'];
			this.curId=item['id'];
		}else{
			Swal.fire({
					icon:'info',
					text: 'Please select a position for your section.',
			})
			return
		}
		}
	}*/
	addToContent(item, type?){
		if(this.allowAdd!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowAddMsg,
			})
			return
		}
		
		if(this.selectedEditor=='F'){//console.log(this.pageIndex)
			item['id']=Utils.uniqueIdGenerator();
			item['TOC']=true;
			//this.listid=item['id'];
			//item['OSNAME']=false;
			if(type=='PARA'){
				this.allEditor.push(item['id'])
			}
			if(this.pageIndex[1]>-1){
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.splice(this.pageIndex[1]+1,0, item);
				item['SUB_SECTIONS']=null;
			}else{
				if(!this.frontpages[this.pageIndex[0]].SUB_SECTIONS){
					this.frontpages[this.pageIndex[0]]['SUB_SECTIONS']=[];
				}
				this.frontpages[this.pageIndex[0]].SUB_SECTIONS.push(item);
			}
			//console.log(this.frontpages[this.pageIndex[0]])
			this.autoSave('add', item['id'], item['SECTION_TITLE'], 'F');
			this.pageIndex=this.getFrontIdIndex(item['id']);
			this.curIndex=[];
			this.listid=item['id'];
			this.listTitle=item['SECTION_TITLE'];
			this.curId=item['id'];
			this.curDoc=item;
			this.curSec=item;
			setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
			if(item['TYPE']=='TABLE'){
				$("#tableModal").modal('show');
				this.selectedRow=-1;
				this.selectedCell=null;
				this.toCreateTable(item['id']);
			}
			/*if(item['TYPE']=='SEALS'||item['TYPE']=='SEALS'){
				item.hash=this.getHash(item);
			}*/
		}else if(this.selectedEditor=='O'){		
		if(this.curIndex[0]>-1||type=='root'){
		item['id']=Utils.uniqueIdGenerator();
		//this.listid=item['id'];
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			//this.curIndex=[index1,index2,index3+1];
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3+1,0, item);
		}else if(index2>-1&&!index3){
			//this.curIndex=[index1,index2+1,this.addon];
			//this.contents[index1].SUB_SECTIONS.splice(index2+1,0, item);
			
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(0,0,item);
				//this.curIndex=[index1,index2,0];
			}else{
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS=[item];
				//this.curIndex=[index1,index2+1,this.addon]
			}
			
		}else if(index1>-1&&!index2&&!index3){
			//this.curIndex=[index1+1,this.addon,this.addon];
			//this.contents.splice(index1+1,0,item);
			
			if(this.contents[index1].SUB_SECTIONS&&this.contents[index1].SUB_SECTIONS.length>0){
				this.contents[index1].SUB_SECTIONS.splice(0,0,item);
				//this.curIndex=[index1,0,this.addon];
			}else{
				this.contents[index1].SUB_SECTIONS=[item];
				
			}
		}else{
			if(!this.contents){
				this.contents=[];
			}
			this.curIndex=[this.contents.length,this.addon,this.addon];
			this.contents.push(item);
			
		}
			this.generateSeq();
			if(this.summaryStatus){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}	
			}	
			if(item.TYPE!='COSTTABLE'&&type!='root'){
				this.autoSave('add', item['id'], item['SECTION_TITLE'], 'O');
			}
			this.curIndex=this.getIdIndex(item['id']);
			this.pageIndex=[];
			this.listid=item['id'];
			this.listTitle=item['SECTION_TITLE'];
			this.curId=item['id'];
			this.curDoc=item;
			this.curSec=item;
			setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
			if(item['TYPE']=='PDFSEC'){
				this.optionShow=true;
			}
			if(item['TYPE']=='TABLE'){
				$("#tableModal").modal('show');
				this.selectedRow=-1;
				this.selectedCell=null;
				this.toCreateTable(item['id']);
			}
			
			/*if(item['TYPE']=='SEALS'||item['TYPE']=='SEALS'){
				item.hash=this.getHash(item);
			}*/
		}else{
			Swal.fire({
					icon:'info',
					text: 'Please select a position for your section.',
			})
			return
		}
		}
	}
	toggleChild(e){//console.log($(e.target))
		e.stopPropagation();
		let child=$(e.target).parents('a').next('div');//console.log(child);
		child.toggle();
		if(child[0].offsetHeight>0){
			$(e.target).removeClass('fa-angle-down');
			$(e.target).addClass('fa-angle-right');
		}else{
			$(e.target).removeClass('fa-angle-right');
			$(e.target).addClass('fa-angle-down');
		}
	}
	toggleChild1(e){//console.log($(e.target).parent("div"))
		e.stopPropagation();
		//let child=$(e.target).next().next('div');//
		let child=$(e.target).parent("div").next("div").first();//console.log(child);
		child.toggle();
		if($(e.target).hasClass('fa-angle-down')){
			$(e.target).removeClass('fa-angle-down');
			$(e.target).addClass('fa-angle-right');
		}else{
			$(e.target).removeClass('fa-angle-right');
			$(e.target).addClass('fa-angle-down');
		}
	}
	getId(type,index1){
		let ids=[];
		if(type=='front'){
			ids.push(this.frontpages[index1].id);
			for(let item of this.frontpages[index1].SUB_SECTIONS){
				ids.push(item.id)
			}
			/*if(index2>-1){
				ids.push(this.frontpages[index1].SUB_SECTIONS[index2].id);
			}*/
		}else{
			ids.push(this.contents[index1].id);
			for(let items of this.contents[index1].SUB_SECTIONS){
				ids.push(items.id);
				for(let item of items['SUB_SECTIONS']){
					ids.push(item.id);
				}
			}
			/*if(index2>-1){
				ids.push(this.contents[index1].SUB_SECTIONS[index2].id);
			}
			if(index3>-1){
				ids.push(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].id);
			}*/
		}
		return ids
	}
	removeSec(type, data, index1?, index2?, index3?){//console.log(data);
		
		if(this.allowAdd!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowAddMsg,
			})
			return
		}
		if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			let ifLinked=false;
			if(data.TYPE=='COSTTABLE'){
				ifLinked=this.checkFrmItem(data.id);				
			}
			if(!ifLinked&&data.SUB_SECTIONS&&data.SUB_SECTIONS.length>0){
				for(let sec of data.SUB_SECTIONS){
					if(!ifLinked&&sec.TYPE=='COSTTABLE'){
						ifLinked=this.checkFrmItem(sec.id);						
					}
					if(!ifLinked&&sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
						for(let sec1 of sec.SUB_SECTIONS){
							if(!ifLinked&&sec1.TYPE=='COSTTABLE'){
								ifLinked=this.checkFrmItem(sec1.id);								
							}
						}						
					}
				}				
			}			
			if(ifLinked){
				Swal.fire({
					icon:'info',
					title: 'This section or child section is referenced by Freddie Mac Section, Please remove the reference first.',
				})
				return
			}
			
		}
		if(type=='app'){
			Swal.fire({
				icon:'warning',
				title: 'Are you sure you want to delete this item?',
				confirmButtonText: 'Delete',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:true,
				preConfirm: () => {
					if(data['resume']){
						this.appendices['addedResume'] = false;
					}
					this.appendices.SUB_SECTIONS.splice(index1,1);
					this.autoSave('appendix update',"appendix update","appendix update");
					return
				}
			})
		}else{
		if (this.blockMultiUser()) return;
		let that=this;
		let ids=this.getId(type,index1);//console.log(ids)
			let idsString=ids.join(',');
			let inputJson={"PROCEDURE":"checksectionlock","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_LIST":idsString};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				//console.log(response);
				if(response.RESPONSE_STATUS=='Y'){
					Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:true,
		preConfirm: () => {
			if(type=='front'){
				if(index2>-1){
				this.frontpages[index1].SUB_SECTIONS.splice(index2,1);
			}else{
				this.frontpages.splice(index1,1);
			}
			this.selectedEditor="F";
			this.autoSave('delete',data.id, data.SECTION_TITLE, 'F', data.SECTION_SEQUENCE);
			this.listid=null;
			return
		}
		let datas=this.contents;
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.splice(index3,1);
			//that.curIndex[2]-=1;
		}else if(index2>-1){
			datas[index1].SUB_SECTIONS.splice(index2,1);
			//that.curIndex[1]-=1;
		}else{
			//this.removeCount(data.SECTION_TITLE)
			datas.splice(index1,1);
			//that.curIndex[0]-=1;
		}
		console.log(this.contents)
		this.selectedEditor="O";
		this.autoSave('delete',data.id, data.SECTION_TITLE, 'O', data.SECTION_SEQUENCE);
		this.listid=null;
		this.curIndex=[this.addon,this.addon,this.addon];
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}	
		//that.getTotalCost();
		}
		})
					
				}else{
					this.throwError(response)
				}
			})
		}
	}
	addChild(e,type, data, index1?, index2?){
		e.stopPropagation();
		if(this.allowAdd!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowAddMsg,
			})
			return
		}
		/*if(type!='app'){			
			if(this.listid){
				//this.selectedEditor='O';
				let type=this.getContentData('TYPE');
				
					if(type=='COSTTABLE'){
						this.autoSave('cost update',this.listid, this.listTitle);
					}else if(type!='PCATABLE'&&type!='UNITTABLE'){
						this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
					}
				
			
			}
		}*/
		let datas=this.contents;
		if(type=='app'){
			let item={'SECTION_TITLE': 'Appendix', 'nodata':true};
			this.appendices.SUB_SECTIONS.push(item);//console.log('appendix update',this.appendices.SUB_SECTIONS.length,"appendix update")
			this.autoSave('appendix update',this.appendices.SUB_SECTIONS.length.toString(),"appendix update");
			return
		}else{
			if (this.blockMultiUser()) return;
			if(index2>-1){
			
			this.curIndex=[index1,index2,datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length];////console.log(this.curIndex);
			let item={'TYPE':'FIXED_SECTION','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Section Title",'SUB_SECTIONS':[]};
			if(type=='content'){
				item['id']=Utils.uniqueIdGenerator();
				this.curId=item['id'];
				this.listid=item['id'];
				this.curDoc=item;
				setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
			
			}
		
			
			
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.push(item);
			
			//this.curIndex=[datas.length-1,datas[index1].SUB_SECTIONS.length-1,datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS.length];//console.log(this.curIndex);
			this.autoSave('add', item['id'], 'Section Title', 'O');
			this.selectedEditor='O';
		}else{
			
			this.curIndex=[index1,datas[index1].SUB_SECTIONS.length,this.addon];////console.log(this.curIndex);
			let item={'TYPE':'FIXED_SECTION','DISPLAY_SEQUENCE': "Y",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Section Title",'SUB_SECTIONS':[]};
			if(type=='content'){
				item['id']=Utils.uniqueIdGenerator();
				this.curId=item['id'];
				this.listid=item['id'];
				this.curDoc=item;
				setTimeout(() => {
				this.scroll(item['id']+'content');
			},500);
			
			}
			
			
			datas[index1].SUB_SECTIONS.push(item);
			
			this.autoSave('add', item['id'], 'Section Title', 'O');
			this.selectedEditor='O';
			}
		let child=$(e.target).parent('a').next('div');////console.log(child);
		if(child[0].offsetHeight==0){			
			$(e.target).next().removeClass('fa-angle-down');
			$(e.target).next().addClass('fa-angle-right');
			child.css('display','block');
		}
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}	
		}
	}
	changeTitle(type, e, index1?, index2?, index3?){//console.log(index1, index2, index3);
		this.selectedRow=-1;
		if(type=='front'){
			this.selectedEditor='F';
			if(index2>-1){
				this.frontpages[index1].SUB_SECTIONS[index2].SECTION_TITLE=e;
			}else if(index1>-1){
				this.frontpages[index1].SECTION_TITLE=e;
			//this.autoSave();
			}
			this.autoSave('modify',this.frontpages[index1].id, this.frontpages[index1].SECTION_TITLE, this.selectedEditor);
			//this.autoSave('front title',id, title );
			return
		}
		if(type=='app'){
			if(index1>-1){
				if(index2>-1){//console.log(this.appendices.SUB_SECTIONS[index1]);
					if(this.appendices.SUB_SECTIONS[index1].app[index2].name){
						this.appendices.SUB_SECTIONS[index1].app[index2].name=e;
					}else if(this.appendices.SUB_SECTIONS[index1].app[index2].text){
						this.appendices.SUB_SECTIONS[index1].app[index2].text=e;
					}
				}else{
					this.appendices.SUB_SECTIONS[index1].SECTION_TITLE=e;
				}
			}else{
				this.appendices.SECTION_TITLE=e;
			}
			this.autoSave('appendix update',"appendix update","appendix update");
			return
		}
		let datas=this.contents;
		this.selectedEditor='O';
		let doc:any;
		if(index3>-1){
			doc=datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3];
			doc.SECTION_TITLE=e;
			if(doc['ul']){
				doc['ul']['Item']=doc.SECTION_TITLE;
			}
			this.checkSummary(doc);
		}else if(index2>-1){
			doc=datas[index1].SUB_SECTIONS[index2];
			doc.SECTION_TITLE=e;
			if(doc['ul']){
				doc['ul']['Item']=doc.SECTION_TITLE;
			}
			this.checkSummary(doc);
		}else{
			doc=datas[index1];
			doc.SECTION_TITLE=e;
			if(doc['ul']){
				doc['ul']['Item']=doc.SECTION_TITLE;
			}
			this.checkSummary(doc);
		}
		this.curIndex=[index1, index2, index3];//console.log(this.curIndex);		
		if(this.reportInfo.PCA_INDICATOR=='4099e'){
			this.getTotalUl();
			this.getTotalCost1();
		}else if(this.reportInfo.PCA_INDICATOR=='Y'){
			this.getTotalCost();								
		}
		this.autoSave('modify',doc.id, doc.SECTION_TITLE, this.selectedEditor);
	}
	checkSummary(doc){
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'&&doc['pisummarydata']){
				if((doc.OSNAME||doc.SECTION_TITLE.length==0)&&doc.SECTION_SEQUENCE.length==0){
					delete doc.pisummarydata;
				}
				this.toTatalPISummary();																				
			}else if(this.summaryType=='PCA'&&doc['pcasummarydata']){
				if((doc.OSNAME||doc.SECTION_TITLE.length==0)&&doc.SECTION_SEQUENCE.length==0){
					delete doc.pcasummarydata;							
				}
				this.getTotalSummary();												
			}
		}
	}
  drop(event: CdkDragDrop<string[]>) {
	moveItemInArray(this.selectedSlot, event.previousIndex, event.currentIndex);
  }
   dropLib(event: CdkDragDrop<string[]>) {
	moveItemInArray(this.addedLib, event.previousIndex, event.currentIndex);
  }
	dropCol(event: CdkDragDrop<string[]>) {////console.log(event.previousIndex);//console.log(event.currentIndex)
		moveItemInArray(this.curTableData.cols, event.previousIndex+1, event.currentIndex+1);
		for(let row of this.curTableData.rows){
			this.array_move(row,event.previousIndex+1, event.currentIndex+1 )
		}
	}
	array_move(arr, old_index, new_index) {
	new_index =((new_index % arr.length) + arr.length) % arr.length;
	arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
	return arr; // for testing
	}
	dropApp(event: CdkDragDrop<string[]>) {
		if(this.allowAdd!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowAddMsg,
			})
			return
		}
		moveItemInArray(this.appendices.SUB_SECTIONS, event.previousIndex, event.currentIndex);
	}
  dropItem(event: CdkDragDrop<string[]>) {
	  if(this.allowDrag!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowDragMsg,
			})
			return
		}
		if (this.blockMultiUser()) return;
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
	this.generateSeq();
	if(this.summaryStatus){
		if(this.summaryType=='PHASE I'){
			this.toTatalPISummary();
		}else if(this.summaryType=='PCA'){
			this.getTotalSummary();
		}	
	}	
	this.curIndex=[this.addon,this.addon,this.addon];
		
  }
	dropFItem(event: CdkDragDrop<string[]>) {
		if(this.allowDrag!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowDragMsg,
			})
			return
		}
		if (this.rptUser.length > 1) {
			Swal.fire({
				icon: 'error',
				title: 'This action is not allowed in multi-user mode.'
			});
		}else{ 
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
	this.pageIndex=[];
		}
  }
	getConnectedList(): any[] {
		return this.contents.map(x => `${x.id}`);
	}
	getFConnectedList(): any[] {
		return this.frontpages.map(x => `${x.id}`);
	}
	dropFront(event: CdkDragDrop<string[]>) {
		if(this.allowDrag!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowDragMsg,
			})
			return
		}
		if (this.blockMultiUser()) return; 
		moveItemInArray(this.frontpages, event.previousIndex, event.currentIndex);
		this.pageIndex=[];
		
	}
	dropGroups(event: CdkDragDrop<string[]>) {
		if(this.allowDrag!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowDragMsg,
			})
			return
		}
		if (this.blockMultiUser()) return;
			moveItemInArray(this.contents, event.previousIndex, event.currentIndex);
			this.generateSeq();
			if(this.summaryStatus){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}	
			}		
			this.curIndex=[this.addon,this.addon,this.addon];
		
	}
	dropGroup(event: CdkDragDrop<string[]>, index) {
		if(this.allowDrag!='Y'){
			Swal.fire({
				icon:'info',
				title: this.allowDragMsg,
			})
			return
		}
		if (this.blockMultiUser()) return;
		moveItemInArray(this.contents[index].SUB_SECTIONS, event.previousIndex, event.currentIndex);
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}		
		this.curIndex=[this.addon,this.addon,this.addon];
		
	}
	getFListPosition(doc, e,i?,j?){//console.log(doc, this.listid, this.selectedEditor)
		$(e.target).focus();
		if(e && e.target){
			e.stopPropagation();
		}
		if(this.pageOPShow){
			this.pageOPShow=false;
		}
		if(this.optionShow){
			this.optionShow=false;
		}
		if(this.tableShow&&doc.id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		let id=doc.id;
		let tempId=id+'';//replacement listid
		let title=doc.SECTION_TITLE;

		doc.hash=this.getHash(doc);
		//console.log(this.listid);
		
		if(this.listid != id){
			sessionStorage.clear();console.log("clear track change paremeter in report")
			if(this.selectedEditor=='O'){
			let type=this.getContentData('TYPE');
			if(type=='COSTTABLE'){
					this.autoSave('cost update',this.listid, this.listTitle,'O');
				}else if(type!='PCATABLE'&&type!='UNITTABLE'){
					this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
				}
			
			}else if(this.selectedEditor=='F'){
					this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
				
			}
			this.listLocked = true;
		}
		this.selectedEditor='F';
		this.listid=tempId;//replacement listid
		//this.listid=id;
		this.listTitle=title;
		this.curIndex=[];
		let status=$(e.target).hasClass('active'); //console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.pageIndex=[i,j];
			this.scroll(id+'content');
		}
		this.addLib=false;
		this.selectedCell=null;
		if (this.listLocked) this.logUsers(id, title);
		setTimeout(() => {
			this.selectedEditor='F';
		},	1000);
				
	}
	getListPosition(doc, e,i?,j?,k?){//console.log(doc, i,j,k, this.listid)
		$(e.target).focus();
		if(e && e.target){
			e.stopPropagation();
		}
		if(this.pageOPShow){
			this.pageOPShow=false;
		}
		if(this.optionShow){
			this.optionShow=false;
		}
		if(this.tableShow&&doc.id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		let id=doc.id;
		let tempId=id+'';//replacement listid
		let title=doc.SECTION_TITLE;
		doc.hash=this.getHash(doc);

		if(this.listid != id){
			sessionStorage.clear();console.log("clear track change paremeter in report")
			if(this.selectedEditor=='O'){
			let type=this.getContentData('TYPE');
		
				if(type=='COSTTABLE'){
					this.autoSave('cost update',this.listid, this.listTitle,'O');
				}else if(type!='PCATABLE'&&type!='UNITTABLE'){
					this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
				}
			
			}else if(this.selectedEditor=='F'){
					this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
				
			}
			this.listLocked = true;
		}
	
		this.listid=tempId;//replacement listid
		//this.listid=id;
		this.listTitle=title;
		this.selectedEditor="O";
		this.curId=id; //console.log(id);
		
		let status=$(e.target).hasClass('active'); //console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			this.curIndex=[i,j,k];//console.log(this.curIndex);
			this.pageIndex=[];
			let posi=id;
			/*if(k>-1){
				posi=(i+1)+'.'+(j+1)+'.'+(k+1);
			}else if(j>-1){
				posi=(i+1)+'.'+(j+1);
			}else if(i>-1){
				posi=(i+1).toString();
			}*/
			//console.log(posi);
			if(doc.TYPE=='1105'&&doc.id!='frm_sec'){
				this.scroll(doc.id);				
			}else if(doc.TYPE=='frm1104'||doc.TYPE=='frm1103'){
				this.scroll(doc.id);
				this.listid=doc.id;
			}else{
				this.scroll(posi+'content');
			}
			
			//this.scrollPanel(posi+'list')
		}
		if (this.listLocked) this.logUsers(id, title);
		/*if(k>-1){
			this.curIndex=i+"-"+j+"-"+k;//console.log(this.curIndex);
		}else if(j>-1&&!k){
			this.curIndex=i+"-"+j+"-";//console.log(this.curIndex);
		}else{
			this.curIndex=i+"--";//console.log(this.curIndex);
		}*/
		this.selectedCell=null;
		this.addLib=false;
		//console.log(this.curIndex[1]);
	}
	getFPosition(doc, e,i?,j?){console.log(doc, this.listid, this.onlock)
		if(e && e.target){
			e.stopPropagation();
		}
		
		if(this.pageOPShow){
			this.pageOPShow=false;
		}
		if(this.optionShow){
			this.optionShow=false;
		}
		if(this.tableShow&&doc.id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		let id=doc.id;
		let tempId=id+'';//replacement listid
		let switchedSec=false
		let title=doc.SECTION_TITLE;
		doc.hash=this.getHash(doc);
		if(this.listid!=id){
			sessionStorage.clear();console.log("clear track change paremeter in report")
			/*if(this.listid){
				this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
			}*/
			if(this.listid){
				if(this.selectedEditor=='O'){
				let type=this.getContentData('TYPE');
				if(type=='COSTTABLE'){
						this.autoSave('cost update',this.listid, this.listTitle,'O');
					}else if(type!='PCATABLE'&&type!='UNITTABLE'){
						this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
					}
				
				}else if(this.selectedEditor=='F'){
					
						this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
					
				}
			}
			this.listLocked = true;
			switchedSec=true
		}
		this.selectedEditor='F';
		this.listid=tempId;//replacement listid
		//this.listid=id;
		this.listTitle=title;
		let posi=id;
		let that=this;
		if(j>-1){
			$('.exDiv1').each(function(){
				let id=that.frontpages[i].id+'panel';
				let list=$(this).attr("data-id")
				if(list==id){
					$(this).css('display','block');
				}else{
					$(this).css('display','none');
				}
			})
		}else if(i>-1){
			j=this.addon;
		}
		this.scrollPanel(posi+'list');
		if(switchedSec){
			this.scrollPage(posi+'content');
		}
		this.selectedCell=null;
		this.pageIndex=[i,j];//console.log(this.pageIndex);
		this.curIndex=[];
		if (this.listLocked) this.logUsers(id, title);
		if(doc.libs&&doc.libs.length>-1){
			this.showSavedLib1(doc.libs)
		}else{
			this.showSavedLib1([])
		}
		if(doc.slots&&doc.slots.length>-1){
			this.showsavedSlot(doc.slots, true)
		}else{
			this.showsavedSlot([], true)
		}
		
	}
	getPosition(doc, e,i?,j?,k?){//console.log(doc,e,i,j,k, this.listid)
		if(e && e.target){
			e.stopPropagation();
		}
		if(this.pageOPShow){
			this.pageOPShow=false;
		}
		if(this.optionShow){
			this.optionShow=false;
		}
		if(this.tableShow&&doc.id!=this.listid){
			Swal.fire({
				icon:'info',
				html:'You are switching section, Please save your editing and close table editing window to prevent data lost.'}
			);
			return
		}
		let id=doc.id;
		let tempId=id+'';//replacement listid
		let title=doc.SECTION_TITLE;
		let switchedSec=false
		doc.hash=this.getHash(doc);
		if(this.listid!=id){	
			sessionStorage.clear();console.log("clear track change paremeter in report")	
			if(this.listid){
				if(this.selectedEditor=='O'){
				let type=this.getContentData('TYPE');
					if(type=='COSTTABLE'){
						this.autoSave('cost update',this.listid, this.listTitle,'O');
					}else if(type!='PCATABLE'&&type!='UNITTABLE'){
						this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
					}else if(type=='1105'&&id!='frm_sec'){
						this.autoSave('frm1105 update',this.listid, title, this.selectedEditor);
					}
				
				}else if(this.selectedEditor=='F'){
					
						this.autoSave('modify',this.listid, this.listTitle, this.selectedEditor);
					
				}
			}
			this.listLocked = true;
			switchedSec=true;
		}
		this.selectedEditor='O';
		this.listid=tempId;//replacement listid
		//this.listid=id;
		this.listTitle=title;
		//this.logUsers(id, title);
		
		let status=$(e.target).hasClass('active'); ////console.log(status)
		if(status){
			this.curIndex=[this.addon,this.addon,this.addon];
		}else{
			let posi=id;
			let that=this;
			if(k>-1){
				
				$('.exDiv1').each(function(index){
					let id=that.contents[i].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
				$('.exDiv2').each(function(){
					let id=that.contents[i].SUB_SECTIONS[j].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
			}else if(j>-1){
				k=this.addon;
				$('.exDiv1').each(function(){
					let id=that.contents[i].id+'panel';
					let list=$(this).attr("data-id")
					if(list==id){
						$(this).css('display','block');
					}else{
						$(this).css('display','none');
					}
				})
			}else if(i>-1){
				k=this.addon;
				j=this.addon;
				//posi=(i+1).toString();
			}
			////console.log(posi);
			if(switchedSec){
				this.scrollPage(posi+'content');
			}
			this.scrollPanel(posi+'list');
			this.curIndex=[i,j,k];//console.log(this.curIndex);
			this.pageIndex=[];
		}
		if(this.curId!=id){
				this.selectedRow=-1;
				this.curId=id; //console.log(id);
				let type=this.getContentData('TYPE'); //console.log(type);
				if(type=='TABLE'){
					let data=this.getContentData('data');
					if(data&&(!data.erisName)){
						for(let row of data.rows){
							if(row.items&&row.items.length>0){
								row.selected=false;
							}
						}
						this.selectedRow=-1;
					}
				}
		}
		this.addLib=false;
		this.selectedCell=null;
		if (this.listLocked) this.logUsers(id, title);
		if(doc.libs&&doc.libs.length>-1){
			this.showSavedLib1(doc.libs)
		}else{
			this.showSavedLib1([])
		}
		if(doc.slots&&doc.slots.length>-1){
			this.showsavedSlot(doc.slots, true)
		}else{
			this.showsavedSlot([], true)
		}
		//console.log(this.curIndex);
		//if(autoFlag){
			//let secTitle=this.getContentData('SECTION_TITLE'); //console.log(secTitle)
			//this.autoSave('out section',id, secTitle);
		//}
		if(doc.TYPE=='PCATABLE'&&doc['ZOOM']){
			if(!doc.tableSize){
				doc.tableSize='all';
				
			}
			this.pcaTableSize=doc.tableSize;
			if(doc.tableSize=='split'&&doc['pcaTableSetting']){
				this.pcaTableSetting=doc['pcaTableSetting'];	
			}		
		}
	}
	scrollPage(id) {
		////console.log(`scrolling to ${id}`);
		let el = document.getElementById(id);//console.log(el);
		if(el){
			el.scrollIntoView({block: "nearest", inline: "nearest"});
		}
	}
	scroll(id) {
		////console.log(`scrolling to ${id}`);
		let el = document.getElementById(id);//console.log(el);
		if(el){
			el.scrollIntoView({block: "center", inline: "nearest"});
		}
	}
	scrollPanel(id) {
		////console.log(`scrolling to ${id}`);
		let el = document.getElementById(id);////console.log(el);
		el.scrollIntoView({block: "center", inline: "nearest"});
	}
	scrollTo(id, index){console.log(id)
		this.curIndex=this.getIdIndex(id);		
		console.log(this.curIndex);
		let posi=id;
		//console.log(posi);
		this.scroll(posi+'content');
	}
	addEditor(id){//console.log(this.curIndex)
		if(this.allEditor.indexOf(id)==-1){
			this.allEditor.push(id); //console.log(this.allEditor);
			this.selectedCell=null;
			this.toContentData('text','','');
		}
	}
	expandToggle(e){
		let level=$(e.target).prevAll('select').val();
		if(!$(e.target).hasClass('active')){
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','block');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','block');
				})
			}
			$(e.target).addClass('active');
			$(e.target).text('Collapse');
		}else{
			if(level=='1'){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
			}else if(level==2){
				$('.exDiv1').each(function(){
					$(this).css('display','none');
				})
				$('.exDiv2').each(function(){
					$(this).css('display','none');
				})
			}
			$(e.target).removeClass('active');
			$(e.target).text('Expand');
		}
		
	}
	missingSlot;
	missingSlotMessage='';
	createSlot(e, op?){
		if(!(this.newSlotType.length==0||this.newSlotLabel.trim()=== ''||this.newSlotCat.length==0||(this.newSlotType=='Selection'&&this.newSlotOps.length==0)||(this.newSlotType=='File'&&this.newSlotFile.url.length==0))){
		this.missingSlot=false;
		if(this.newSlotLabel.trim().length>0){
			let id=null;
			let slotContent='';
			let opContent='';
			let ext='';
			let name='';
			if(this.reportInfo.TEMPLATE[0]){
				id=this.reportInfo.TEMPLATE[0].TEMPLATE_ID;
			}
			if(this.newSlotType=='Selection'){
				opContent=this.newSlotOps.join(';;');
				/*if(this.newSlotMultiple=='Y'){
					slotContent=opContent;
				}else{
					slotContent=this.newSlotOps[0];
				}*/
				
				
			}else if(this.newSlotType=='File'){
				if(this.newSlotFile.url.length>0){
					slotContent=this.newSlotFile.url;
					ext=this.newSlotFile.ext;
					name=this.newSlotFile.name;
				}
			}else{
				slotContent=this.newSlotContent;
				//this.newSlotMultiple=null;
			}
			/*
			let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(that.userId), "KEY":that.newSlotLabel,"TYPE":that.newSlotType,"CONTENT":slotContent,"CATEGORY":that.newSlotCat,"MULTIPLE_CHOICE":that.newSlotMultiple,"TEMPLATE_ID":id,"SELECTION_CHOICES":opContent};
						let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(that.userId), "KEY":"Land Usage","TYPE":"File","CONTENT":"...","CATEGORY":"Property Specific","MULTIPLE_CHOICE":"","TEMPLATE_ID":null,"SELECTION_CHOICES":"","FILE_EXTENSION":"DOCX"}
							//console.log(inputJson);
							that.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
								//console.log(data);//{"PROCEDURE":"insertslot","USER_ID":213223,"TEMPLATE_ID":null,"KEY":"test","TYPE":"Text","CONTENT":"fgdhdjj","CATEGORY":"Company Information","SLOT_ID":226}
						
							})
			
			*/
			//console.log(slotContent);
			let inputJson:any;
			if(this.newSlotType=='File'){
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"SELECTION_CHOICES":opContent, "FILE_EXTENSION":ext, 'FILE_NAME':name};
			}else{
				inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":this.newSlotLabel,"TYPE":this.newSlotType,"CONTENT":slotContent,"CATEGORY":this.newSlotCat,"MULTIPLE_CHOICE":this.newSlotMultiple,"SELECTION_CHOICES":opContent};
			}
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);//{"PROCEDURE":"insertslot","USER_ID":213223,"TEMPLATE_ID":null,"KEY":"test","TYPE":"Text","CONTENT":"fgdhdjj","CATEGORY":"Company Information","SLOT_ID":226}
				let info=JSON.parse(data);
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(info.RESPONSE_STATUS=='Y'){
				//this.selectedSlot=JSON.parse(data);
			/*let item={'CATEGORY': info.CATEGORY,
					'CONTENT': info.CONTENT,
					'KEY': info.KEY,
					'SLOT_ID': info.SLOT_ID,
					'TYPE': info.TYPE,
					"TEMPLATE_ID":info.TEMPLATE_ID,
			}
			*/
			let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==info.CATEGORY);
			if(index>-1){
				this.groupSlots[index].RW_SLOTS.push(info);
				//this.groupSlots[index].TOTAL_SLOTS+=1;
				//this.groupSlots[index].TOTAL_TEMPLATE_SLOTS+=1;
			}else{
				this.groupSlots.push({'CATEGORY':info.CATEGORY,'RW_SLOTS':[info],'TOTAL_SLOTS': 1,'TOTAL_TEMPLATE_SLOTS': 1});
			}
			//this.curTemp.TOTAL_SLOTS+=1;
			this.allSlots.push(info);
			Toast.fire({
					icon: 'success',
					title: info.MESSAGE,
				})
			this.resetNewSlot();
			if(op){
				op.hide();
			}
				}else{
					this.throwError(info)
				}
		})
		}
		}else{
			this.missingSlot=true
			this.missingSlotMessage = "* "
			if(this.newSlotLabel==null||this.newSlotLabel.trim()=== ''){
				this.missingSlotMessage = this.missingSlotMessage + "Identifier"
			}
			if(this.newSlotCat.length==0){
				if(this.newSlotLabel==null||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Category"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Category"
				}
			}
			if(this.newSlotType==''){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Type"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Type"

				}
			}
			if(this.newSlotType=='Selection'&&this.newSlotOps.length==0){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", Selection"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "Selection"

				}
			}
			if(this.newSlotType=='File'&&this.newSlotFile.url.length==0){
				if(this.newSlotLabel==null||this.newSlotCat.length==0||this.newSlotLabel.trim()=== ''){
					this.missingSlotMessage = this.missingSlotMessage + ", File"
				} else {
					this.missingSlotMessage = this.missingSlotMessage + "File"

				}
			}
			this.missingSlotMessage = this.missingSlotMessage + " not valid"
		}
	}
	selectSlot(slot){
		//console.log(slot);
		this.selectedSlot=slot;
	}
	/*addSlotPosi(i?,j?,k?){
		this.selectedSlot=[];
		if(k>-1){
			this.curIndex=[i,j,k];
		}else if(j>-1){
			this.curIndex=[i,j,this.addon];
		}else if(i>-1){
			this.curIndex=[i,this.addon,this.addon];
		}
		//console.log(this.curIndex);
	}*/
	frmShow=false;
	curFrm={'data':'','html':'', 'secHtml':null, 'addedItem':null,'text':''};
	async addRepeat(type, info){//console.log(type, info)
		//console.log(this.selectedEditor)
		if(type=='lib'){
			await this.getLibContent(info);
		}
		let that=this;
		let content='';
		if(type=='slot'){
			if(info.length>0||info.CONTENT.length==0){
				let obj:any;
				if(info=='signature'){
					obj={'name':'signature', 'dataId':'signature'+this.itemIndex, 'dataType':'text', 'status':'N'};
				}else if(info=='seal'){
					obj={'name':'seal', 'dataId':'seal'+this.itemIndex, 'dataType':'text', 'status':'N'};
				}else{
					obj={'name':info.KEY, 'dataId':info.SLOT_ID, 'dataType':'text', 'status':'N'};//console.log(obj)
				}
				content=JSON.stringify(obj);
				this.itemIndex++;
				let data={'index':this.itemIndex,'content':content, 'type':type};
				if(this.selectedEditor=='P'){//console.log(this.selectIndex);
					this.pdfFname['addedItem']=data;
					this.pdfFname['reqIndex']=this.itemIndex;
				}else if(this.cellShow||this.tableShow){
					this.curSec['addedItem']=data;
					this.curSec['reqIndex']=this.itemIndex;
					//this.toContentData(type, info, '');
				}else if(this.frmShow){
					this.curFrm['addedItem']=data;
					this.curFrm['reqIndex']=this.itemIndex;					
				}else if(this.pisummaryShow){
					this.itemIndex++;
					this.picurSummaryItem['addedItem']=data;
					this.picurSummaryItem['reqIndex']=this.itemIndex;
					console.log(this.picurSummaryItem)
				}else if(this.selectedEditor=='F'){
					this.toFContentData('addedItem', data, '');
					this.toFContentData(type, info, '');
					this.toFContentData('reqIndex', this.itemIndex, '');
				}else{
				this.toContentData('addedItem', data, '');
				this.toContentData(type, info, '');
				this.toContentData('reqIndex', this.itemIndex, '');
				}
			}else{
				let obj={'name':info.CONTENT, 'dataId':info.SLOT_ID, 'dataType':'text', 'status':'Y'};//console.log(obj)
				content=JSON.stringify(obj);
				this.itemIndex++;
				let data={'index':this.itemIndex,'content':content, 'type':type};
				if(this.selectedEditor=='P'){//console.log(this.selectIndex);
					this.pdfFname['addedItem']=data;
					this.pdfFname['reqIndex']=this.itemIndex;
				}else if(this.cellShow||this.tableShow){
					this.curSec['addedItem']=data;
					this.curSec['reqIndex']=this.itemIndex;
					//this.toContentData(type, info, '');
				}else if(this.frmShow){
					this.curFrm['addedItem']=data;
					this.curFrm['reqIndex']=this.itemIndex;
					
				}else if(this.pisummaryShow){
					this.itemIndex++;
					this.picurSummaryItem['addedItem']=data;
					this.picurSummaryItem['reqIndex']=this.itemIndex;
					console.log(this.picurSummaryItem)
				}else if(this.selectedEditor=='F'){//console.log(this.selectIndex);
					this.toFContentData('addedItem', data, '');
					this.toFContentData(type, info, '');
					this.toFContentData('reqIndex', this.itemIndex, '');
				}else{
					this.toContentData('addedItem', data, '');
					this.toContentData(type, info, '');
					this.toContentData('reqIndex', this.itemIndex, '');
				}
			}
			
		}else if(type=='lib'){
			let ids=[];
			let content=info.CONTENT;
			if(info.CONTENT_HTML&&info.CONTENT_HTML.length>0){
				let text: string = info.CONTENT_HTML;////console.log(text)
				let oricontent=text;
				ids=this.getAllSlotId(text); //console.log(ids)
				if(ids.length>0){//console.log(info.CONTENT_HTML)
					let text1=info.CONTENT_HTML;//.substring(3,info.CONTENT_HTML.length-4);//console.log(text1)
					let oricontent1=text1;
					content=this.getRFforLib(oricontent1);
				}else{
					content=oricontent;
				}
			}
			this.itemIndex++;
			let data={'index':this.itemIndex,'content':content, 'type':type};
				if(this.cellShow||this.tableShow){
					this.curSec['addedItem']=data;
					this.curSec['reqIndex']=this.itemIndex;
				}else if(this.selectedEditor=='F'){//console.log(this.selectIndex);
					this.toFContentData('addedItem', data, '');
					this.toFContentData('reqIndex', this.itemIndex, '');
				}else{
					this.toContentData('addedItem', data, '');
					this.toContentData('reqIndex', this.itemIndex, '');
				}
		}else if(type=='newLib'){
			let obj={'name':info.KEY, 'dataId':info.SLOT_ID, 'dataType':'text', 'status':'N'};
			content=JSON.stringify(obj);
			this.addedItem={'index':this.itemIndex,'content':content, 'type':'slot'};console.log(this.addedItem);
			this.itemIndex++;
		}else if(type=='FO'){
			if(this.defaultShow){
				let data={'index':this.itemIndex,'content':info, 'type':type};
				this.itemIndex++;
				this.eriscurcol.DefaultFO['addedItem']=data;
				this.eriscurcol.DefaultFO['reqIndex']=this.itemIndex;				
			}
		}	
				
	}
	private getRFforLib(data){////console.log(data);
		let that=this;
		let slots=$(data).find('.placeholder'); ////console.log('slots',slots);
		if (slots.length==0){
			return ''
		}
		let newDom="";
		for(let slot of slots){
			let id=$(slot).data('id'); ////console.log(id);
			let indexAll=that.allSlots.findIndex(slot=>slot.SLOT_ID==id);////console.log(indexAll);
			
			if(indexAll>-1&&id>-1){
				let key=$(slot)[0].innerText; ////console.log(key);
				let oldDom=$(slot)[0].outerHTML; ////console.log(oldDom);
				let index=that.allSlots.findIndex(slot=>slot.SLOT_ID==id);////console.log(index);
				let replaceText="";
				
				if(index>-1){
					if(that.allSlots[index].CONTENT.length>0){
						let content=that.allSlots[index].CONTENT;////console.log(content);
						//console.log(data)
						newDom=oldDom.replace('data-status="N"','data-status="Y"').replace(key, content); ////console.log(newDom);
						data=data.replaceAll(oldDom, newDom);//console.log(data)
					}
				}
			}
		}
		return	data
	}
	/*addSlot(){//console.log(this.selectedSlot)
		let content='';
		let data:any
		if(this.selectedCell){
			for(let item of this.selectedSlot){
				let itemHtml='<span>'+item.CONTENT+', '+'</span>';
				content+=itemHtml;
				data=content;
			}
		}else{
			for(let item of this.selectedSlot){
				let itemHtml='<span style="background-color:#ffffff;">'+item.CONTENT+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
				content+=itemHtml;
			}
			//console.log(content);
			this.itemIndex+=this.itemIndex;
			data={'index':this.itemIndex,'content':content}
		}
		this.toContentData('addedItem', data, 'addSlotModal');
		//$('#addSlotModal').modal('hide');
		this.selectedSlot=[];
	}
	addSlotPrep(){
		this.slotToLib=true;
		this.filteredData=null;
		this.selectedSlot=[];
		this.curLib=[];
		this.curLibId=[];
	}
	addSlotToLib(){//console.log(this.selectedSlot)
		let content='';
		for(let item of this.selectedSlot){
			let itemHtml='<span class="reportTag" data-id="'+item.SLOT_ID+'" data-name="'+item.KEY+'" data-original-title="This Report Tag has no value" data-value="undefined" style="background-color:#C2D63F;">'+'{{'+item.KEY+'}}'+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
			content+=itemHtml;
		}
		this.itemIndex+=this.itemIndex;
		this.addedItem={'index':this.itemIndex,'content':content}; //this.selectedSlot;
		$('#addSlotModal').modal('hide');
	}
	showSlot(slots){
		this.selectedSlot=slots;
		$('#showSlotModal').modal('show');
	}*/
	
	/*deleteSlot(id, item){//console.log(item)
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
			let inputJson={"PROCEDURE":"deleteslot","USER_ID":parseInt(this.userId),"SLOT_ID":parseInt(id)};
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
				let info=JSON.parse(data);
				let msg=info.MESSAGE;
				let Toast=Swal.mixin({
						toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				if(info.STATUS=='Y'){
					let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==item.CATEGORY);
					if(index>-1){
						let index1=this.groupSlots[index].RW_SLOTS.findIndex(slot=>slot.SLOT_ID==id);
						if(index1>-1){
							this.groupSlots[index].RW_SLOTS.splice(index1,1);
						}
						let index2=this.groupSlots[index].RW_TEMPLATE_SLOTS.findIndex(slot=>slot.SLOT_ID==id);
						if(index2>-1){
							this.groupSlots[index].RW_TEMPLATE_SLOTS.splice(index2,1);
						}
					}
					Toast.fire({
						icon: 'success',
						title: msg
					})
				}else{
					Toast.fire({
						icon: 'error',
						title: msg
					})
				}
			})
		}
		})
	}*/
	expandAll() {
    if(!this.isExpanded){
      this.groupSlots.forEach(data =>{
        this.expandedRows[data.CATEGORY] = true;
      })
	  this.isExpanded=true
	  //console.log(this.expandedRows);
    } else {
      this.expandedRows={};
	  this.isExpanded = false;
    }
    //this.isExpanded = !this.isExpanded;
  }
  /*slotChkToggle(){
	 this.slotCheckAll=!this.slotCheckAll;
  }
  nameValidate(event){
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
  }*/
	
	async selLib(item){//console.log(item)
		await this.getLibContent(item);
		let index=this.curLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
		if(index>-1){
			this.curLib.splice(index,1);
			this.curLibId.splice(index,1);
		}else{
			this.curLib.push(item);
			this.curLibId.push(item.LIBRARY_ID);
		}
				
	}
	
	addSelLib(){
		if(this.curLib.length>0){
			for(let item of this.curLib){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
				if(index==-1){
					this.addedLib.push(item);
				}
			}
			this.curLib=[];
			this.curLibId=[];
		}
		
	}
	async addAllSelLib(){//console.log(this.addedLib);
	//console.log(this.filteredData)
		if(this.libraries.length<11&&!this.filteredData){
			for(let flib of this.libraries){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					await this.getLibContent(flib);
					this.addedLib.push(flib);
				}
			}
		}else if(this.filteredData&&this.filteredData.length<11){
			//this.addedLib = [...this.addedLib, ...this.filteredData]; //console.log(this.addedLib);
			for(let flib of this.filteredData){
				let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==flib.LIBRARY_ID);
				if(index==-1){
					await this.getLibContent(flib);
					this.addedLib.push(flib);
				}
			}
		}
		this.curLib=[];
		this.curLibId=[];
	}
	rmvAddedLib(){
		for(let item of this.curLib){
			let index=this.addedLib.findIndex(lib=>lib.LIBRARY_ID==item.LIBRARY_ID);
			if(index>-1){
				this.addedLib.splice(index,1);
			}
		}
		this.curLib=[];
		this.curLibId=[];
	}
	clearAddedLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
	}
	cancleLib(){
		this.addedLib=[];
		this.curLib=[];
		this.curLibId=[];
		$('#libraryModal').modal('hide');
	}
	/*deleteLib(data){//console.log(data)
		let inputJson={"PROCEDURE":"deletelibraryentry", "USER_ID":parseInt(this.userId), "LIBRARY_ID":data.LIBRARY_ID}
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			//console.log(response);//{"STATUS":"Y","MESSAGE":"Deletion of Library Entry was successful"}
			let info=JSON.parse(response);
			let msg=info.MESSAGE;
			if(info.STATUS=="Y"){
				let index=this.libraries.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
				if(index>-1){
					this.libraries.splice(index,1);
				}
				if(this.filteredData){
					let index1=this.filteredData.findIndex(lib=>lib.LIBRARY_ID==data.LIBRARY_ID);
					if(index1>-1){
						this.filteredData.splice(index1,1);
					}
				}
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: msg
				})
				
          }else{
            Swal.fire({
				icon: 'error',
				title: 'Oops...',
				text: msg

            })
          }
		})
			
	}
	selSlot(item){//console.log(item)
		let index=this.curSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
		if(index>-1){
			this.curSlot.splice(index,1);
			this.curSlotId.splice(index,1);
		}else{
			this.curSlot.push(item);
			this.curSlotId.push(item.SLOT_ID);
		}
		//console.log(this.curSlotId)
	}
	addSelSlot(){
		if(this.curSlot.length>0){
			for(let item of this.curSlot){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(item);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
		
	}
	addAllSelSlot(){
		if(this.slots.length<11&&!this.filteredData){
			for(let fslot of this.slots){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
			
		}else if(this.filteredData&&this.filteredData.length<11){
			for(let fslot of this.filteredData){
				let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==fslot.SLOT_ID);
				if(index==-1){
					this.selectedSlot.push(fslot);
				}
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}
	rmvAddedSlot(){
		for(let item of this.curSlot){
			let index=this.selectedSlot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
			if(index>-1){
				this.selectedSlot.splice(index,1);
			}
		}
		this.curSlot=[];
		this.curSlotId=[];
	}*/
	clearAddedSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
	}
	/*cancleSlot(){
		this.selectedSlot=[];
		this.curSlot=[];
		this.curSlotId=[];
		$('#addSlotModal').modal('hide');
	}

	changeCat(cat){
		//console.log(cat)
	}*/
	resetNewSlot(){
		this.missingSlot=false;
		this.missingSlotMessage='';
		this.newSlotLabel="";
		this.newSlotCat="";
		this.newSlotType="";
		this.newSlotMultiple='N';
		this.newSlotFile.name='';
		this.newSlotFile.url='';
		this.newSlotFile.ext='';
		this.newSlotContent="";
		this.tableContent=[];
		this.newSlotOps=[];
		this.resetLib();
	}
	addLibToSlot(){
		if(this.newSlotType=='Selection'){
			this.newSlotOps=[];
			for(let lib of this.addedLib){
				this.newSlotOps.push(lib.CONTENT);
			}
			$('.slotBtn')[0].classList.add("disabled");
		}else{
			this.newSlotContent="";
			for(let lib of this.addedLib){
				this.newSlotContent+=lib.CONTENT;
			}
		}
		$('#libraryModal').modal('hide');
		this.resetLib();
	}
	resetLib(){
		this.addedLib=[];
		this.filteredData=null;
	}
	secSetting(e){
		//e.stopPropagation();
	}
	addLibToDoc(){
		/*let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3]['libs']=this.addedLib;
		}else if(index2>-1){
			this.contents[index1].SUB_SECTIONS[index2]['libs']=this.addedLib;;
		}else if(index1>-1){
			this.contents[index1]['libs']=this.addedLib;
		}*/
		let content='';
		let data:any
		if(this.selectedCell){
			for(let item of this.addedLib){
				let itemHtml='<p>'+item.CONTENT+'</p>';
				content+=itemHtml;
				data=content;
			}
		}else{
			for(let item of this.addedLib){
				let itemHtml='<span style="background-color:#ffffff;">'+item.CONTENT+'</span>'+'<span style="background-color:none;">'+' '+'</span> ';
				content+=itemHtml;
			}
			//console.log(content);
			this.itemIndex+=this.itemIndex;
			data={'index':this.itemIndex,'content':content};
		}
		this.toContentData('addedItem', data, 'libraryModal');
		this.resetLib();
		this.clearAddedLib();
	}
	showLib(libs){
		this.addedLib=libs;
		$('#showLibModal').modal('show');
	}
	
	generateSeq(){console.log(this.contents)
		let neecCal=false;
		if(this.reportInfo.PCA_INDICATOR=="Y"||this.reportInfo.PCA_INDICATOR=='4099e'){
			neecCal=true;
		}
		if(this.contents.length>0){
			let i=0;
			let h=0;
			for (let item1 of this.contents){
				
				if(item1.DISPLAY_SEQUENCE=='Y'){
					i++;
					if(this.head1){
						item1.SECTION_SEQUENCE=this.head1.replace('{index}', i.toString());
					}else{
						item1.SECTION_SEQUENCE=i+'.';
					}
					if(item1['ul']){
						item1.ul.SecRef=item1.SECTION_SEQUENCE;
					}
					if(item1.SUB_SECTIONS&&item1.SUB_SECTIONS.length>0){
						let j=0;
						let o=0;
						for (let item2 of item1.SUB_SECTIONS){
							if(item2.DISPLAY_SEQUENCE=='Y'){
								j++;
								if(this.head2){
									item2.SECTION_SEQUENCE=this.head2.replace('{index}', i.toString()).replace('{index2}', j.toString());
								}else{
									item2.SECTION_SEQUENCE=i+'.'+j;
								}
								
								if(item2['ul']){
									item2.ul.SecRef=item2.SECTION_SEQUENCE;
								}					
								if(item2.SUB_SECTIONS&&item2.SUB_SECTIONS.length>0){
									let k=0;
									let p=0;
									for (let item3 of item2.SUB_SECTIONS){
										if(item3.DISPLAY_SEQUENCE=='Y'){
											k++;
											if(this.head3){
												item3.SECTION_SEQUENCE=this.head3.replace('{index}', i.toString()).replace('{index2}', j.toString()).replace('{index3}', k.toString());
											}else{
												item3.SECTION_SEQUENCE=i+'.'+j+'.'+k;
											}
											
											if(item3['ul']){
												item3.ul.SecRef=item3.SECTION_SEQUENCE;
											}									
											if(item3.SUB_SECTIONS&&item3.SUB_SECTIONS.length>0){
												let l=0;
												for (let item4 of item3.SUB_SECTIONS){
													if(item4.DISPLAY_SEQUENCE=='Y'){
														l++;
														item4.SECTION_SEQUENCE=i+'.'+j+'.'+k+'.'+l;
														if(item4['ul']){
															item4.ul.SecRef=item4.SECTION_SEQUENCE;
														}
														if(item4.SUB_SECTIONS&&item4.SUB_SECTIONS.length>0){
															let m=0;
															for (let item5 of item4.SUB_SECTIONS){
																if(item5.DISPLAY_SEQUENCE=='Y'){
																	m++;
																	item5.SECTION_SEQUENCE=i+'.'+j+'.'+k+'.'+l+'.'+m;
																}else{
																	item5.SECTION_SEQUENCE='';
																}
															}
														}
													
													}else{
														item4.SECTION_SEQUENCE='';
													}
												}
											}
										
										}else{
											item3.SECTION_SEQUENCE='';
											if(item3.TYPE=='COSTTABLE'){//console.log(item3)
												if(item3.data&&item3.data.COST){
												for(let costItem3 of item3.data.COST){
													costItem3.index=[h,o,p];//console.log(costItem3)
												}
												if(this.reportInfo.PCA_INDICATOR=='4099e'){
													this.getTotalCost1();
												}else if(this.reportInfo.PCA_INDICATOR=='Y'){
													this.getTotalCost();
													if(this.summaryStatus){
														this.getTotalSummary();	
													}
												}
												neecCal=false;
												}
												
											}
										}
										p++;
									}
									
								}
							
							}else{
								//console.log(h, o)
								item2.SECTION_SEQUENCE='';
								if(item2.TYPE=='COSTTABLE'){//console.log(item2)
									if(item2.data&&item2.data.COST){
									for(let costItem2 of item2.data.COST){
										costItem2.index=[h,o,this.addon];//console.log(costItem2)
									}
									if(this.reportInfo.PCA_INDICATOR=='4099e'){
										this.getTotalCost1();
									}else if(this.reportInfo.PCA_INDICATOR=='Y'){
										this.getTotalCost();
										if(this.summaryStatus){
											this.getTotalSummary();	
										}
									}
									neecCal=false;
									}
									
								}
							}
							o++;
						}
						
					}
				
				}else{
					item1.SECTION_SEQUENCE='';
				}
			h++	;
			}
		}
		console.log(neecCal)
		if(this.reportInfo.PCA_INDICATOR=='4099e'){
			this.getTotalUl();
			if(neecCal){
				this.getTotalCost1();
			}
			

		}else if(this.reportInfo.PCA_INDICATOR=="Y"){
			if(neecCal){
				this.getTotalCost();
			}
			
		}
		
	}
	onFilter(event, dt) { 
		this.filteredData = event.filteredValue; //console.log(this.filteredData);
	}
	
	toCreateTable(i?, j?, k?, l?, m?){//console.log(i,j,k)
		this.curTableData=null;
		this.colNo=0;
		this.rowNo=0;
		if(this.selectedEditor=='F'){
			this.curTableData=this.getFContentData('data');
		}else if(this.selectedEditor=='O'){
			//this.curTableData=this.getContentData('data');
		
		if(k>-1){
			this.curIndex=[i,j,k];
			if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].data){
				this.curTableData=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].data;	//console.log(this.curTableData)
			}
		}else if(j>-1){
			this.curIndex=[i,j,this.addon];
			if(this.contents[i].SUB_SECTIONS[j].data){
				this.curTableData=this.contents[i].SUB_SECTIONS[j].data;//console.log(this.curTableData)
			};
		}else if(i>-1){
			this.curIndex=[i,this.addon,this.addon];
			if(this.contents[i].data){
				this.curTableData=this.contents[i].data;
			};
		}
		}
		if(!this.curTableData){
			this.curTableData={'cols':[],'rows':[]};
			if(this.selectedEditor=='F'){
				this.slotTableType=0;
			}else if(this.selectedEditor=='O'){
				this.slotTableType=1;
			}
		}else{
			this.slotTableType=this.curTableData.src;
			this.colNo=this.curTableData.cols.length;
			this.rowNo=this.curTableData.rows.length;
		}
		
		//console.log(this.curIndex);
		$("#tableModal").modal('show');
	}
	createTable(){//console.log(this.curTableData);//console.log(this.curIndex);
		if((!this.curTableData.erisName&&this.rowNo<1)||this.curTableData.cols.length==0){
			Swal.fire({
				icon: 'info',
				title: "Columns and Rows must be more than 0."
			})
			return
		}
		if(this.curTableData.rows.length==0){			
				if(this.slotTableType==1){
					this.curTableData.src=this.slotTableType;
					this.rowNo=0;
					if(this.curTableData.cols[0].INTERNALNAME=="ES_RID"){
						this.curTableData.cols[0]['hide']=true;
					}else{
						let firstCol={'INTERNALNAME': "ES_RID",'NAME': "ID",'TYPE': "text",'unit': "%",'width': 0, 'hide':true};
						this.curTableData.cols.unshift(firstCol);
					}
				}else if(this.slotTableType==2){
					this.curTableData.src=this.slotTableType;
					//console.log(this.curTableData);
				}else{
					this.curTableData.SLOT_ID=null;
					this.curTableData.src=this.slotTableType;
					
				}
		if(this.slotTableType==0){			
		for(let i=0; i<this.rowNo; i++){
			let row=[];
			let rowData={'items':[]};
			for(let j=0; j<this.curTableData.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':''};
				
				item.COLUMNINTERNALNAME=this.curTableData.cols[j].INTERNALNAME;
				rowData[this.curTableData.cols[j].INTERNALNAME]='';
				if(this.curTableData.cols[j]['hide']){
					item['hide']=true;
				}
				//console.log(item)
				row.push(item);
			}
			rowData.items=row;
			this.curTableData.rows.push(rowData);
			
		}
		}else{
		for(let i=0; i<this.rowNo; i++){
			let row=[]
			for(let j=0; j<this.curTableData.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':''};
				item.COLUMNINTERNALNAME=this.curTableData.cols[j].INTERNALNAME;
				if(this.curTableData.cols[j]['hide']){
					item['hide']=true;
				}
				//console.log(item)
				row.push(item);
			}
			this.curTableData.rows.push(row);
			
		}
		}
		//console.log(this.curTableData);Customized Table
		}else{
			for(let header of this.headertype){
				if(this.curTableData[header]&&this.curTableData[header].length>0){
					for(let hrow of this.curTableData[header]){
						if(hrow.length==1){
							if(!hrow[0]['colspan']){
								hrow[0]['colAlign']=this.curTableData.cols[0].colAlign;
							}							
						}else{
							for(let i=0; i<this.curTableData.cols.length; i++){
								hrow[i]['colAlign']=this.curTableData.cols[i].colAlign;
								hrow[i]['unit']=this.curTableData.cols[i].unit;
								hrow[i]['width']=this.curTableData.cols[i].width;
							}
						}							
					}
				}				
			}
		}
			if(this.curTableData.slotName&&this.curTableData.slotName.length>-1){
				if(this.selectedEditor=='F'){
					let oldtitle=this.getFContentData('SECTION_TITLE');
					if(oldtitle=='Customized Table'){
						this.changeTitle('front',this.curTableData.slotName,this.pageIndex[0],this.pageIndex[1]);
					}					
				}else if(this.selectedEditor=='O'){
					let oldtitle=this.getContentData('SECTION_TITLE');
					if(oldtitle=='Customized Table'){
						if(this.curIndex[2]>-1){
							this.changeTitle('content',this.curTableData.slotName,this.curIndex[0],this.curIndex[1],this.curIndex[2]);
						}else{
							this.changeTitle('content',this.curTableData.slotName,this.curIndex[0],this.curIndex[1]);
						}
					}
					
				}
			}
			if(this.curTableData.erisName&&this.curTableData.erisName.length>-1){
				let oldtitle=this.getContentData('SECTION_TITLE');
				if(this.selectedEditor=='F'){
					let oldtitle=this.getFContentData('SECTION_TITLE');
					if(oldtitle=='Customized Table'){
						this.changeTitle('front',this.curTableData.erisName,this.pageIndex[0],this.pageIndex[1]);
					}
					
				}else if(this.selectedEditor=='O'){
					let oldtitle=this.getContentData('SECTION_TITLE');
					if(oldtitle=='Customized Table'){
						if(this.curIndex[2]>-1){
							this.changeTitle('content',this.curTableData.erisName,this.curIndex[0],this.curIndex[1],this.curIndex[2]);
						}else{
							this.changeTitle('content',this.curTableData.erisName,this.curIndex[0],this.curIndex[1]);
						}
					}
					
				}
			}
		
		
		//this.curTableData.cols=item;
		//this.curTableData.rows=[item1,item2, item3, item4];
		$("#tableModal").modal('hide');
		let sid:string;
		let stitle:string;
		//console.log(this.selectedEditor)
		if(this.selectedEditor=='F'){
			this.toFContentData('data', this.curTableData, 'tableModal');
			sid=this.getFContentData('id');
			stitle=this.getFContentData('SECTION_TITLE');
		}else if(this.selectedEditor=='O'){
			this.toContentData('data', this.curTableData, 'tableModal');
			sid=this.getContentData('id');
			stitle=this.getContentData('SECTION_TITLE');
		}
		//this.toContentData('data', this.curTableData, 'tableModal')
		//console.log(this.curIndex);
		this.autoSave("modify", sid, stitle,this.selectedEditor);
	}
	updateErisHeader(){
		//console.log(this.curTableData)
		if(this.curTableData.SLOT_ID&&this.curTableData.SLOT_ID>-1){
			let data=this.curTableData;
		let headers=[];
		for(let col of data.cols){
			let item={"INTERNALNAME":col.INTERNALNAME,"NAME":col.NAME,"TYPE":col.TYPE};
			if(col.FO&&col.FO.length>0){
				item['FO']=col.FO;
			}
			if(col.DefaultFO&&col.DefaultFO.data.length>0){
				item['DefaultFO']=col.DefaultFO;
			}
			headers.push(item)
		}
		let inputJson={"PROCEDURE":"setSlotReportHeader","USER_ID":parseInt(this.userId),"SLOT_ID":data.SLOT_ID,"TABLE_HEADERS":headers,"REPORT_ID":this.curReport.REPORT_ID, "TEMPLATE_ID":this.reportInfo.TEMPLATE[0].TEMPLATE_ID,"REPORT_SECTION_ID":this.curId};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
			}else{
				let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
				Toast.fire({
					icon: 'success',
					title: 'Update successful.',
				})
			}
		})
		}
		
	}
	/*addOption(e, index){
		let val=$(e.target).val();
		this.curTableData.cols[index].push(val);
	}*/
	addCol(){
		if(this.curTableData['locked']&&this.curTableData['locked']['header']){
			Swal.fire('Table header is locked, can not add column');
			return
		}
		let id='col'+this.curTableData.cols.length.toString();
		//let item={'INTERNALNAME':id, 'name':'','type':'text'};
		let item={'INTERNALNAME':id,'NAME':'Header'+this.curTableData.cols.length.toString(),'TYPE':'text', 'width':null, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
		item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
		item['text']=item.NAME;
		this.curTableData.cols.push(item);
		
		if(this.curTableData.rows.length>0){
			for(let row of this.curTableData.rows){////console.log(row)
				if(row.items){
					row[id]='';
					if(row.items.length==1&&row.items[0].colspan){
						row.items[0].colspan++;
					}else{
						row.items.push({'COLUMNINTERNALNAME':id, 'DATA':''});
					}
				}else{
					row.push({'COLUMNINTERNALNAME':id, 'DATA':''});
				}
											
			}
		}
		this.colNo++;
		if(this.isEven||(this.curTableData.row[0].items&&this.curTableData.row[0].items.length>1)){
			let width=Math.floor((96/this.curTableData.cols.length)*100)/100;//console.log(width);
			for(let i=0; i<this.curTableData.cols.length; i++){
				this.curTableData.cols[i].width=width;
				this.curTableData.cols[i].unit='%';
			}
		}
		for(let header of this.headertype){
			if(this.curTableData[header]&&this.curTableData[header].length>0){
				for(let row of this.curTableData[header]){console.log(row)
					if(row.length==1&&row[0].colspan){
							row[0].colspan++;
					}else{
						let no=this.curTableData.cols.length-1;
						let item={'INTERNALNAME':id,'NAME':'<p>Header'+no+'</p>', 'text':'Header'+no, 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header'+no+'</p>'}};
						item.INTERNALNAME=this.curTableData.cols[no].INTERNALNAME;
						row.push(item);
						for(let i=0; i<row.length; i++){
							row[i]['colAlign']=this.curTableData.cols[i].colAlign;
							row[i]['unit']=this.curTableData.cols[i].unit;
							row[i]['width']=this.curTableData.cols[i].width;
						}
					}
												
				}	
				//console.log(this.curTableData[header])		
			}
		}
	}
	deleteCol(index){
		let that=this;
		Swal.fire({
		icon:'warning',
		title: 'Are you sure you want to delete this item?',
		confirmButtonText: 'Delete',
		showLoaderOnConfirm: true,
		showCancelButton: true,
		backdrop:false,
		preConfirm: () => {
			let id=that.curTableData.cols[index].INTERNALNAME;
			if(that.curTableData.cols.length>1){
				that.curTableData.cols.splice(index, 1);
				for(let header of that.headertype){
					if(that.curTableData[header]&&that.curTableData[header].length>0){
						for(let row of that.curTableData[header]){
							if(row.length==1&&row[0].colspan){
									row[0].colspan--;
							}else{
								row.splice(index, 1);
							}
						}	
					}
				}
				if(that.curTableData.rows.length>0){
					let index1=-1;
					if(that.curTableData.rows[0].items){
				
					}else{
						index1=that.curTableData.rows[0].findIndex(item=>item.COLUMNINTERNALNAME==id);//console.log(index1)
					}
					for(let row of that.curTableData.rows){
						if(row.items&&row.items.length>0){
							row[id]=null;
							let index2=row.items.findIndex(item=>item.COLUMNINTERNALNAME==id);//console.log(index2)
							if(index2>-1){//console.log(row)
								if(row.items.length==1&&row.items[0].colspan){//console.log(row)
									row.items[0].COLUMNINTERNALNAME=that.curTableData.cols[0].INTERNALNAME;
									row.items[0].colspan--;
								}else{//console.log(row)
									row.items.splice(index2, 1);
								}
							}else{
								if(row.items.length==1&&row.items[0].colspan){
									row.items[0].colspan--;
								}
							}
					
						}else{
							if(index1>-1){
								row.splice(index1, 1);
							}
						}
					}
					if(that.curTableData.rows[0].items){
						that.curTableData.rows=that.curTableData.rows.filter(row => row.items.length>0);
						//console.log(that.curTableData.rows);
					}
				}
				if(!that.curTableData.erisName&&(!that.curTableData.slotName)){
					this.reorderTableData(that.curTableData)
				}
				
				if(that.isEven||(this.curTableData.row[0].items&&this.curTableData.row[0].items.length>1)){
					//let width=96/that.curTableData.cols.length;
					if(this.curTableData.erisName){
						let totalCols= this.curTableData.cols.length-1
						let width=Math.floor((96/totalCols)*100)/100;//console.log(width)
						for(let i=0; i<that.curTableData.cols.length; i++){
							if(i>0){
								that.curTableData.cols[i].width=width;
							}else{
								that.curTableData.cols[i].width=0;
							}
							
							that.curTableData.cols[i].unit='%';
						}
					}else{
						let width=Math.floor((96/this.curTableData.cols.length)*100)/100;;//console.log(width)
						for(let i=0; i<that.curTableData.cols.length; i++){
							that.curTableData.cols[i].width=width;
							that.curTableData.cols[i].unit='%';
						}
					}				
				}
			}else{
				//console.log(that.curTableData.cols);
				alert('Column can no be deleted since only 1 column left!');
				
			}
		}
		})
	}
	changeLabel(e, index1?){console.log(e)
		//this.selectedCell={'row':index1,'col':index2};
		this.selectedRow=-1;
		if(index1>-1){
			this.curTableData.cols[index1].NAME=e;
			this.curTableData.cols[index1].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
	
		}else{//console.log()
			this.toContentData('DATA', e, "")
		}
		let data=this.getContentData('data');console.log(data)
		if(data.erisName&&data.erisName.length>0){
			let sid=this.listid;//console.log(sid)
			let stitle=this.getContentData('SECTION_TITLE');
			this.autoSave("modify", sid, stitle,'O');			
		}
		//let sid=this.listid;console.log(sid)
		//let stitle=this.getContentData('SECTION_TITLE');
		//this.autoSave("header change", sid, stitle);
		/*if(index2){
			this.curTableData.rows[index2][index1].name=e;////console.log(this.curTableData.rows[index2][index1].name);
		}else{
			this.curTableData.cols[index1].name=e;////console.log(this.curTableData.cols[index1].name);
		}*/
	}
	selCell(i,j?){//console.log(i, j);
		if(j!=null){
			this.selectedCell={'row':i,'col':j};
		}else{
			this.selectedCell={'row':null,'col':i};
		}
	}
	getRow(h){
		if(this.selectedRow==h){
			this.selectedRow=null;
		}else{
			this.selectedRow=h;
		}
	}
	toContentData(field, data, pop, preIndex?){console.log(this.curIndex);
		
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(preIndex){//console.log(preIndex);
			index1=preIndex[0];
			index2=preIndex[1];
			index3=preIndex[2];
		}
		if(!this.selectedCell){			
			if(index3>-1){
				if(field=='slot'){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots){
						let index=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.push(data);
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots=[];
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs){
						let index=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);
						}
						//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs=[];
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].libs.push(data);
					}
				}else{//console.log(data)
				this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][field]=data;
				}
			}else if(index2>-1){
				if(field=='slot'){
					if(this.contents[index1].SUB_SECTIONS[index2].slots){
						let index=this.contents[index1].SUB_SECTIONS[index2].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].slots.push(data);
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].slots=[];
						this.contents[index1].SUB_SECTIONS[index2].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].SUB_SECTIONS[index2].libs){
						let index=this.contents[index1].SUB_SECTIONS[index2].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].SUB_SECTIONS[index2].libs.push(data);
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].libs=[];
						this.contents[index1].SUB_SECTIONS[index2].libs.push(data);
					}
				}else{
				this.contents[index1].SUB_SECTIONS[index2][field]=data;//console.log(data);
				}
			}else if(index1>-1){
				if(field=='slot'){
					if(this.contents[index1].slots){
						let index=this.contents[index1].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){						
							this.contents[index1].slots.push(data);
						}
					}else{
						this.contents[index1].slots=[];
						this.contents[index1].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.contents[index1].libs){
						let index=this.contents[index1].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.contents[index1].libs.push(data);
						}
					}else{
						this.contents[index1].libs=[];
						this.contents[index1].libs.push(data);
					}
				}else{
				this.contents[index1][field]=data;
				}
			}
		}else{//console.log(this.selectedCell, field)
			if(index3>-1){
				if(data instanceof Array){
					if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
					}						
				}else{//console.log(data, field)
					if(this.selectedCell.row>-1){
						if(field=='htmltext'){
							if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
								let row=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row];
								let celldata=row[this.selectedCell.col];
								if(celldata['cal0']||celldata['cal1']){
									let that=this;
									if(celldata['cal0']){
										setTimeout(() => {
											let a=parseInt(celldata.data);//console.log(a)
											let b=parseInt(row[that.selectedCell.col+1].data);//console.log(b)
											if(a>0&&b>0){
												row[that.selectedCell.col+2].data=(a-b).toString();;
												row[that.selectedCell.col+3].data=that.getRound(100*(a-b)/a,this.pcaOp.decimal)+'%';
											}
										}, 500);
										
									}else if(celldata['cal1']){
										
										setTimeout(() => {
										let b=parseInt(celldata.data);//console.log(b)
										let a=parseInt(row[that.selectedCell.col-1].data);//console.log(a)
										if(a>0&&b>0){
											row[that.selectedCell.col+1].data=(a-b).toString();
											row[that.selectedCell.col+2].data=that.getRound(100*(a-b)/a,this.pcaOp.decimal)+'%';
										}
										}, 500);
									}
																		
								}
								
							}else{
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
							}
						}else if(field.length>0){//console.log(field)
							//if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
							//	this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							//}else{
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							//}
						}else{
							if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].TYPE=='4099e'){
								this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data;
								
							}else{
							this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data;
							}
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.cols[this.selectedCell.col].NAME=data
					}
					//this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3].data.rows[this.selectedCell.row][this.selectedCell.col].name=data
				}
			}else if(index2>-1){//console.log(this.contents[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					if(this.contents[index1].SUB_SECTIONS[index2].tableClass&&this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row]){
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
					}
					 //console.log(data)
				}else{//console.log(this.selectedCell.row);
					if(this.selectedCell.row!=null){//console.log(this.contents[index1].SUB_SECTIONS[index2].data.rows)
						if(field=='htmltext'){
							if(this.contents[index1].SUB_SECTIONS[index2].id=='pca_summary_0'){
								this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							}else{
								this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
							}
							
						}else if(field.length>0){//console.log(field)
							this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
							
						}else{
							this.contents[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data;							
						}
					}else{
						this.contents[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.contents[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
		//console.log(this.contents);
	}
	toFContentData(field, data, pop, preIndex?){console.log(this.pageIndex)
		let index1=this.pageIndex[0];
		let index2=this.pageIndex[1];
		if(!this.selectedCell){			
			if(index2>-1){
				if(field=='slot'){
					if(this.frontpages[index1].SUB_SECTIONS[index2].slots){
						let index=this.frontpages[index1].SUB_SECTIONS[index2].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){
							this.frontpages[index1].SUB_SECTIONS[index2].slots.push(data);
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].slots=[];
						this.frontpages[index1].SUB_SECTIONS[index2].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.frontpages[index1].SUB_SECTIONS[index2].libs){
						let index=this.frontpages[index1].SUB_SECTIONS[index2].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.frontpages[index1].SUB_SECTIONS[index2].libs.push(data);
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].libs=[];
						this.frontpages[index1].SUB_SECTIONS[index2].libs.push(data);
					}
				}else{
					this.frontpages[index1].SUB_SECTIONS[index2][field]=data;//console.log(data);
				}
			}else if(index1>-1){
				if(field=='slot'){
					if(this.frontpages[index1].slots){
						let index=this.frontpages[index1].slots.findIndex(item=>item.SLOT_ID==data.SLOT_ID); //console.log(index);
						if(index==-1){						
							this.frontpages[index1].slots.push(data);
						}
					}else{
						this.frontpages[index1].slots=[];
						this.frontpages[index1].slots.push(data);
					}
				}else if(field=='lib'){
					if(this.frontpages[index1].libs){
						let index=this.frontpages[index1].libs.findIndex(item=>item.LIBRARY_ID==data.LIBRARY_ID); //console.log(index);
						if(index==-1){
							this.frontpages[index1].libs.push(data);
						}
					}else{
						this.frontpages[index1].libs=[];
						this.frontpages[index1].libs.push(data);
					}
				}else{
				this.frontpages[index1][field]=data;
				}
			}
		}else{//console.log(this.selectedCell)
			if(index2>-1){//console.log(this.frontpages[index1].SUB_SECTIONS[index2]);
				if(data instanceof Array){
					this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data; //console.log(data)
				}else{//console.log(this.selectedCell.row);
					if(this.selectedCell.row!=null){//console.log(this.frontpages[index1].SUB_SECTIONS[index2].data.rows)
						if(field=='htmltext'){
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col][field]=data;
						}else if(field.length>0){//console.log(field)
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row][this.selectedCell.col][field]=data;
						}else{
							this.frontpages[index1].SUB_SECTIONS[index2].data.rows[this.selectedCell.row].items[this.selectedCell.col].DATA=data
						}
					}else{
						this.frontpages[index1].SUB_SECTIONS[index2].data.cols[this.selectedCell.col].NAME=data
					}
				}
			}else if(index1>-1){
				if(data instanceof Array){
					this.frontpages[index1].data.rows[this.selectedCell.row][this.selectedCell.col].choice=data;
				}else{
					this.frontpages[index1].data.rows[this.selectedCell.row][this.selectedCell.col].DATA=data
				}
			}
		}
		if(pop.length>0){
			let dom='#'+pop;
			$(dom).modal('hide');
		}
		//console.log(this.frontpages);
	}
	getFContentData(source){//console.log(this.frontpages);
		let index1=this.pageIndex[0];////console.log(index1);
		let index2=this.pageIndex[1];////console.log(index2);
		let dest:any;
		if(index2>-1){
			if(this.frontpages[index1].SUB_SECTIONS[index2]&&this.frontpages[index1].SUB_SECTIONS[index2][source]){
				dest=this.frontpages[index1].SUB_SECTIONS[index2][source];
			};
		}else if(index1>-1){////console.log(index1);
			if(this.frontpages[index1]&&this.frontpages[index1][source]){
				dest=this.frontpages[index1][source];
			};
		}
		return dest;
	}
	getContentData(source){//console.log(this.curIndex);
		let index1=this.curIndex[0];////console.log(index1);
		let index2=this.curIndex[1];////console.log(index2);
		let index3=this.curIndex[2];////console.log(index3);
		let dest:any;
		
		if(index3>-1){
			if(this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][source]){
				dest=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][source];
			}
		}else if(index2>-1){
			if(this.contents[index1].SUB_SECTIONS[index2][source]){
				dest=this.contents[index1].SUB_SECTIONS[index2][source];
			};
		}else if(index1>-1){////console.log(index1);
			if(this.contents[index1][source]){
				dest=this.contents[index1][source];
			};
		}
		return dest;
	}
	addLabel(e){
		let text=$("#libLabel").val(); console.log(text);
		let arr=text.split(';');
		for (let ar of arr) {
			if(ar.trim().length>0){
				if(this.inputLabels.length>0){
					this.inputLabels+=';'+ar.trim();
				}else{
					this.inputLabels+=ar.trim();
				}
			}
		}
		$('#libLabel').val('');
	}
	removeLabel(index){//console.log(index);
		let labels=this.inputLabels.split(';');
		labels.splice(index, 1);
		this.inputLabels=labels.join(';');
		//console.log(this.inputLabels);
	}
	moveUp(index, tabledata?){
		let data:any;//this.getContentData('data');
		if(tabledata){
			data=tabledata
		}else{
			data=this.curSec.data;
		}
		if(index>0){
			this.array_move(data.rows,index, index-1 );
			this.selectedRow-=1;
		}
	}
	moveDown(index, tabledata?){
		let data:any;//this.getContentData('data');
		if(tabledata){
			data=tabledata
		}else{
			data=this.curSec.data;
		}
		if(index<(data.rows.length-1)){
			this.array_move(data.rows,index, index+1 );
			this.selectedRow+=1;
		}
	}
	async deleteRow(index,sec?){console.log(index);//console.log(type);
		if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			this.deleteFrmRow(index,sec)
			return
		}
		let type:string;
		let tabledata:any;
		if(sec){
			if(sec.rows){
				tabledata=sec.rows;
			}else{
				type=sec.TYPE;
			}
			
		}		
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: async () => {
				let data:any;
				if(tabledata){
					data=tabledata
				}else{
					data=that.getContentData('data');//console.log(data);
				}
				//let i=data.COST.findIndex(item=>item.id==id);
				if(data.version=='2'){
					let id=data.rows[index][0].costId;
					data.rows=data.rows.filter(row => row[0].costId!=id);
					data.COST=data.COST.filter(item => item.costId!=id);
					if(this.pcaOp.quantity==0){
						await this.getPCAData();
						let ifOpen=$('.nav-tabs a[href="#pca"]').hasClass('active');
						if(ifOpen){
							this.logTab('PCA','noPop');
							
						}else{
							this.logTab('PCA');
						}
						$('.nav-tabs a[href="#pca"]').tab('show');
					}else{
						if(that.reportInfo.PCA_INDICATOR=='4099e'){
							
							that.getTotalCost1();
							that.getTotalUl();
						}else{
							that.getTotalCost();
							if(this.summaryStatus){
								this.getTotalSummary();	
							}
						}
					}
					this.autoSave('modify',sec.id, sec.SECTION_TITLE,'O');
					/*let v2Index=0
					for(let i=0; i<data.rows.length; i++){//console.log(i)
						if(data.rows[i].KEEP){
							v2Index++;
							if(i==index){
								break;
							}
					
						}
					}
					let count=0;
					if(data.COST[v2Index-1].Immediate>0){
						count++;
					}
					if(data.COST[v2Index-1].Short>0){
						count++;
					}
					for(let item of data.COST[v2Index-1].allocate){
						if(item>0){
							count++;
						}
					}
					data.rows.splice(index,count);
					data.COST.splice(v2Index,1);*/
				}else if(type&&type=="COSTTABLE"){					
					if(index>-1){
						data.COST.splice(index-1,1);
						data.rows.splice(index,1);
					}
					if(this.pcaOp.quantity==0){
						await this.getPCAData();
						let ifOpen=$('.nav-tabs a[href="#pca"]').hasClass('active');
						if(ifOpen){
							this.logTab('PCA','noPop');
							
						}else{
							this.logTab('PCA');
						}
						$('.nav-tabs a[href="#pca"]').tab('show');
					}else{
						if(that.reportInfo.PCA_INDICATOR=='4099e'){
							
							that.getTotalCost1();
							that.getTotalUl();
						}else{
							that.getTotalCost();
							if(this.summaryStatus){
								this.getTotalSummary();	
							}
						}
						
					}
					this.autoSave('modify',sec.id, sec.SECTION_TITLE,'O');
				}else{
					data.rows.splice(index,1);
				}
				
			}
		})
	}
	hideRow(index,tabledata){
		let data:any;//this.getContentData('data');
		if(tabledata){
			data=tabledata
		}else{
			data=this.getContentData('data');
		}
		if(data.rows[index].hide&&data.rows[index].hide=='Y'){
			data.rows[index].hide='N';
		}else{
			data.rows[index].hide='Y';
		}
	}
	addSub(e, tabledata?){console.log(tabledata)
		let posi=$(e.target).prev('select').val();//console.log(posi)
		let data:any;//this.getContentData('data');
		if(tabledata){
			data=tabledata
		}else{
			data=this.getContentData('data');
		}
		//console.log(data);
		let row=[{'COLUMNINTERNALNAME':'','data':'', 'celAllign':posi}];
		if(this.selectedRow>-1){
			if(this.addBefore){
						data.rows.splice(this.selectedRow,0,row);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,row);
					}
		}
	}
	addRows(e, tabledata?){console.log(tabledata)
		let no=$(e.target).prevAll('input').val(); //console.log($(e.target).prev('input'));//console.log(no);
		if(no>0){
			let data:any;//this.getContentData('data');
			if(tabledata){
				data=tabledata
			}else{
				data=this.getContentData('data');
			}
			//console.log(data);
			for(let i=0; i<no; i++){
				let row=[]
				for(let j=0; j<data.cols.length; j++){
					let item={'COLUMNINTERNALNAME':'','DATA':''};
					item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
					if(data.cols[j].type=="dropdown"){
						item['choice']=[];
					}
					//console.log(item)
					
					row.push(item);
				}
				row[0]['hide']=true;
				if(this.selectedRow>-1){
					if(this.addBefore){
						data.rows.splice(this.selectedRow,0,row);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,row);
					}
				}else{
					data.rows.push(row);
				}
				
			}
		}
	}
	addSlotPrep(type?){
		this.slotToLib=true;
		this.filteredData=null;
		this.selectedSlot=[];
		this.curLib=[];
		this.curLibId=[];
		if(type&&type=='new'){
			//this.newLib=true;
			this.addLib=false;
		}else{
			this.newLib=false;
		}
	}
	showSlots(){
		$('.nav-tabs a[href="#slot"]').tab('show');
		this.slotGroup='A';
		this.clearAddedSlot();
		//this.curSlots=[];
		//this.expandAll();
		this.addLib=true;
		this.newLib=false;
		this.groupSlots.forEach(data =>{
			this.expandedRows[data.CATEGORY] = true;
		})
		this.isExpanded=true
	}
	addToIden(label, id){
		let ele='#'+id;
		let text=$(ele).val();console.log(text);
		if(text.length>0){
			text=text+'; '+label;
		}else{
			text=label;
		}
		$(ele).val(text);		
	}
	newLib=false;
	dragDisabled=true;
	addLibShow=false;
	async toNewLib(){
		const permit:any=await this.checkUserPermit(35); console.log(permit)
		if(permit.USER_PERMISSION=='N'){
			Swal.fire({
				icon:'info',
				html: '<span>'+permit.MESSAGE+'</span>'							
			})
			return
		}	
		this.newLibPara=[];
		this.inputLabels='';
		this.addLibShow=true;
		this.addLib=false;
			
		
	}
	resetNewLibrary(){
		this.addLibWarn=false;
		$('#libTitle').val('');
		$('#libLabel').val('');		
		this.inputLabels='';
		this.newLibPara[0]='';
		this.newLibPara[2]='';
		this.newLibPara[3]='';
		this.newLibPara[1]='';
		this.newLibPara[4]='';
		this.newLibPara[5]='';
	}
	createLibrary(e, type?){
		let that=this;
		setTimeout(function(){ 
			
		console.log('delay')
		this.addLibWarn=false;
		let ele=$(e.target).siblings('input');
		const title=ele[0].value;
		if(title.length==0){
			that.addLibWarn=true;
			return
			
		}
		const label=that.inputLabels;
		const instr=that.newLibPara[0];
		const content=that.newLibPara[2];
		const eleContent=that.newLibPara[3];
		const eleInstruction=that.newLibPara[1];
		let inputJson={"PROCEDURE":"insertlibraryentry", "USER_ID":parseInt(that.userId), "ITEM_TITLE":title, "CONTENT":content, "INSTRUCTIONS":instr, "LABELS":label, 'CONTENT_HTML':eleContent, 'INSTRUCTIONS_HTML':eleInstruction };
		console.log(inputJson);
		that.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				that.throwError(data)
			}else{
				if (data.LIBRARY_ID){
					that.libraries.splice(0,0, data);
				}
				if(type=='new'){
					that.addLibShow=false;
				}else{
					that.resetNewLibrary()
				}
			}
		})
	}, 500);
	}
	libPara1(e, index){
		//console.log(e)
		this.newLibPara[index]=e;//console.log(this.newLibPara);
		if(index==1){
			this.newLibPara[4]=e;
		}else if(index==3){
			this.newLibPara[5]=e;
		}
	}
	libPara2(e, index){
		//console.log(e)
		this.newLibPara[index]=e;//console.log(this.newLibPara);
	}
	libPara(e, id?){
		//console.log(e)
		//console.log(this.curCol)
		//console.log(this.curSec);
		//console.log(id)
		let key=this.curCol.INTERNALNAME;//console.log(key)
		let secIndex=this.getIdIndex(id);//console.log('first',secIndex);
		this.toContentData(key, e, '',secIndex);
		//this.newLibPara[index]=e;////console.log(this.newLibPara);
	}
	savePDFconfig(size){//console.log(this.lpagesize);//console.log(this.pageMargin);//console.log(this.selectpage)
		//let reportStyle={'pagesize':size, 'margin':this.pageMargin, "bk":this.bimageurl, "orientation":this.selectpage}; //console.log(reportStyle);
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"PCA_PAGE_SETUP":size};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)							
			}else{
				this.lpagesize=size;
			}
			
		})
	}
	newPcaTableSetting=[{'start':1, 'end':this.pcaOp.reserve, 'selected':false}, {'start':null, 'end':null, 'selected':false}, {'start':null, 'end':null, 'selected':false}];
	pcaTableSetting:any[]
	pcaTableValidate=true;
	pcaTableSize='all';
	savePcaTableConfig(e, type){//console.log(type, value)
		let val=e.target.value;		
		this.pcaTableSize=val;
		if(val=='split'){
			if(!this.curDoc['pcaTableSetting']){
				this.pcaTableSetting=this.newPcaTableSetting
				if(this.pcaOp.reserve>24){
					this.pcaTableSetting[0]={'start':1, 'end':12, 'selected':true};
					this.pcaTableSetting[1]={'start':13, 'end':24, 'selected':true};
					this.pcaTableSetting[2]={'start':25, 'end':this.pcaOp.reserve, 'selected':true};
				}else if(this.pcaOp.reserve>12){
					this.pcaTableSetting[0]={'start':1, 'end':12, 'selected':true};
					this.pcaTableSetting[1]={'start':13, 'end':this.pcaOp.reserve, 'selected':true};					
				}else{
					this.pcaTableSetting[0]={'start':1, 'end':this.pcaOp.reserve, 'selected':true};
				}
			}
		}
	}
	setPcaTablePage(e, tableNum:number){
		if(e.target.checked){
			let val1=parseInt($('#start'+tableNum).val());
			let val2=parseInt($('#end'+tableNum).val());
			if(!this.pcaTableSetting[tableNum]){
				this.pcaTableSetting[tableNum]={'start':null, 'end':null, 'selected':true}
			}
			this.pcaTableSetting[tableNum]['selected']=true;
			this.pcaTableSetting[tableNum]['start']=isNaN(val1) ? null : val1;
			this.pcaTableSetting[tableNum]['end']=isNaN(val2) ? null : val2;
		}else{
			this.pcaTableSetting[tableNum]['selected']=false;
		}
	}
	savePcaTablePage(){
		let ifvalid = true;
		if(this.pcaTableSize=='split'){
			ifvalid=this.validatePcaTableSetting();
		}
		if(ifvalid){
			this.curDoc.tableSize=this.pcaTableSize;
			if(this.pcaTableSize=='split'){
				this.curDoc['pcaTableSetting']=this.pcaTableSetting;
			}else{
				delete this.curDoc['pcaTableSetting']
			}			
			this.autoSave('modify',this.curDoc.id, this.curDoc.SECTION_TITLE, this.selectedEditor);
			this.optionShow=false
		}
	}
	validatePcaTableSetting(){
		this.pcaTableValidate=true;
		if(this.pcaTableSetting.length>0){
			for(let tableset of this.pcaTableSetting){
				if(tableset.selected){
					if(!tableset.start||!tableset.end){
						this.pcaTableValidate=false;
					}else if(tableset.start>tableset.end){
						this.pcaTableValidate=false;
					}else if(tableset.start<1||tableset.end>this.pcaOp.reserve){
						this.pcaTableValidate=false;
					}
				}
			}
			if(this.pcaTableSetting[2].selected){
				if(this.pcaTableSetting[0].selected&&this.pcaTableSetting[1].selected){
					if((this.pcaTableSetting[0].end!=this.pcaTableSetting[1].start-1)||(this.pcaTableSetting[1].end!=this.pcaTableSetting[2].start-1)||this.pcaTableSetting[2].end<this.pcaOp.reserve){
						this.pcaTableValidate=false;
					}
				}else{
					this.pcaTableValidate=false;
				}
			}else if(this.pcaTableSetting[1].selected){
				if(this.pcaTableSetting[0].selected){
					if(this.pcaTableSetting[0].end!=this.pcaTableSetting[1].start-1||this.pcaTableSetting[1].end<this.pcaOp.reserve){
						this.pcaTableValidate=false;
					}
				}else{
					this.pcaTableValidate=false;
				}
			}else if(this.pcaTableSetting[0].selected){
				if(this.pcaTableSetting[0].end<this.pcaOp.reserve){
					this.pcaTableValidate=false;
				}
			}
		}
		return this.pcaTableValidate;
	}
	checkPcaTableSplit(){
		for(let sec of this.contents){
			if(sec.TYPE=='COST'){
				let rrtable=sec.SUB_SECTIONS[1];
				if(rrtable.tableSize=='split'){
					this.pcaTableSetting=rrtable['pcaTableSetting'];
					if(!this.validatePcaTableSetting()){
						return false
					}else{
						return true	
					}
				}else{
					return true
				}
			}
		}

	}
	async saveIniReport(){console.log('initiate save')
		let beforeToc='';
			if(this.frontpages.length>0){
				beforeToc=JSON.stringify(this.frontpages);
			}
			let app=JSON.stringify(this.appendices);
			let pdfInfo={'text':this.pdfFname['text'], "name":this.pdfFname.name};
			let inputJson:any;
			if(this.curReport){
				inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":this.curReport.REPORT_ID,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(this.contents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":app,'PCA_DATA':JSON.stringify(this.pcaOp), 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'', "PERCENT_COMPLETE":'0%',"REVIEWER_PROGRESS":'0%'};
				//console.log(inputJson);
			}
			const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			//console.log(data);
			console.log('iniatesaved')
			$('#overlay').css('display','none');
			if (data.RESPONSE_STATUS=='N') {
			
				this.throwError(data);
				return							
			}

			if (environment.api.autoSave.toUpperCase() == "Y"){
				
				let that=this;
				window.clearInterval(that.saveTimer);
				window.setTimeout(function() {}, environment.api.autoSaveInterval);
				that.saveTimer = window.setInterval(function () {
					that.autoSave('auto save');
				}, environment.api.autoSaveInterval);
			}
	}
	//getSecbyId(id); setSecbyId(id)
	lastid:string;
	lasttype:string;
	lasttime:number;
	laststatus:string;
	async saveReport(type, sid?, stitle?, editor?, doc?, status?, field?,complete?){//console.log(this.curReport);
		//console.log(type, sid, stitle, editor, doc, status, field,complete)
		/*if(this.lastid&&this.lastid==sid&&this.lasttype==type){//console.log("Loop:", type, sid, stitle, editor)
			return
		}
		if(sid){
			this.lastid=sid;
		}
		if(type){
			this.lasttype=type;
		}*/
		let start=new Date().getTime();
		if(this.lasttime){
			const diff = (start-this.lasttime)/1000;
			if(status){
				if(diff<.5&&this.lastid==sid&&this.lasttype==type&&this.laststatus==status){console.log('loop interval',type, sid,this.lastid, stitle, editor, diff )
					return
				}	
			}else{
				if(diff<.5&&this.lastid==sid&&this.lasttype==type){console.log('loop interval',type, sid,this.lastid, stitle, editor, diff )
					return
				}
			}
		}
		
		this.lasttime=start;
		if(sid){
			this.lastid=sid;
		}
		if(type){
			this.lasttype=type;
		}
		if(status){
			this.laststatus=status;
		}
		let secTitle='';
		let secId='';

		try {
			const latestVersionId = await this.updateEdits();
			//this.listid=this.listid.replace('','');//replacement listid
			for(let a of this.contents){
				if(a.addedItem){ 
					a.addedItem='';
				}
				for(let b of a.SUB_SECTIONS){
					if(b.addedItem){
						b.addedItem='';
						for(let c of b.SUB_SECTIONS){
							if(c.addedItem){
								c.addedItem='';
							}
						}
					}
				}
			}
			
			//console.log(this.pcaOp)
			//console.log(this.curIndex);
			let overwrite='N';
			let modifyType="";
			let secData='';
			/*if(type&&type=='auto'){
				overwrite='Y';
				modifyType="autosave";
			}else{*/
				secData=this.checkSaveType(type, sid, stitle, editor);//console.log(secData)
				if(type=='slot update'){
					secTitle=type;
				}else{
					secTitle=stitle;
				}
				if(type=='modify'||type=='manualsave-section'||type=='autosave-section'||type=='cost update'){
					let status=(doc && secData) ? this.checkHash(doc, secData) : false;//console.log(status)
					if(!status){
						if (latestVersionId) {
							let inputJson = { "PROCEDURE": "resetreportuserversion", "USER_ID": parseInt(this.userId), "REPORT_ID": this.curReport.REPORT_ID, "VERSION_ID": latestVersionId };
							const data1=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
							if (data1.RESPONSE_STATUS=='N') {
								this.throwError(data1)
								return											
							}

						}
						return;
					}
				}
				//console.log(secTitle);
				secId=sid;//console.log(secId);
				modifyType=type;
			/*}else{
				secTitle=this.getContentData('SECTION_TITLE'); //console.log(secTitle);
				secId=this.getContentData('id');//console.log(secId);
			}
			if(modifyType=='ERIS Data Update'){
				setTimeout(function(){ 
					//console.log('ERIS Data Update')
				}, 5000);
			}
			
			if(secTitle==''){
				overwrite='Y';
			}*/
			//console.log(this.contents)
			let beforeToc='';
			if(this.frontpages.length>0){
				beforeToc=JSON.stringify(this.frontpages);
			}
			let app=JSON.stringify(this.appendices);
			let pdfInfo={'text':this.pdfFname['text'], "name":this.pdfFname.name};
			//console.log(this.frontpages)
			//console.log(this.contents)
			let inputJson:any;//=savereportdata {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"PROJECT_ID":2,"PORTFOLIO_ID":null,APPENDIX_DATA"PROJECT_NAME":"New number ntest","REPORT_ID":1,"REPORT_TITLE":"Test Update","ASSESSOR_DUE_DATE":"15-JUN-2021"};
			if(this.curReport){
				inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":this.curReport.REPORT_ID,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(this.contents),"SECTION_ID":secId, "SECTION_TITLE":secTitle, "APPENDIX_DATA":app,'PCA_DATA':JSON.stringify(this.pcaOp), 'OVERWRITTEN':overwrite,"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':modifyType,'SECTION_DATA':secData, "PERCENT_COMPLETE":this.wPercentage+'%',"REVIEWER_PROGRESS":this.rPercentage+'%'};
				/*if(status&&status.length>0){
					inputJson["SECTION_STATUS"]=status;
					inputJson[field]=complete;//+'%'
					
				}*/
				
			}
			console.log('regular save')
			//console.log(inputJson)
			const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return							
			}
			//console.log(data)
			let secInfo=JSON.parse(secData)
			if(secInfo.data&&doc){
				const newHash = this.getHash(secInfo.data);
				doc.hash = newHash;
			}
			this.loading=false;
			if (environment.api.autoSave.toUpperCase() == "Y"){
				let that=this;
				window.clearInterval(that.saveTimer);
				window.setTimeout(function() {}, environment.api.autoSaveInterval);
				that.saveTimer = window.setInterval(function () {
					that.autoSave('auto save');
				}, environment.api.autoSaveInterval);
			}

		} catch (e) {
			console.log('Sync Error: ' + e);
		}
	}
	async updateEdits(){//console.log(this.curReport)
		let inputJson={"PROCEDURE":"getreportedits","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();console.log(data)
		if(data.RESPONSE_STATUS=='Y'){
			const edits=data.EDIT_SECTIONS;
			if(edits&&edits.length>0){
				try {
					for(let item of edits){
						if(item.SECTION_ID!=this.onlock){
						if(item.SECTION_MODIFIED=='modify'||item.SECTION_MODIFIED=='manualsave-section'||item.SECTION_MODIFIED=='autosave-section'||item.SECTION_MODIFIED=='cost update'){
							let id=item.SECTION_ID;
							const content:any=JSON.parse(item.SECTION_DATA); 
							let dataset:any;
							if(content.editor&&content.editor=='F'){
								dataset=this.frontpages;
							}else if(content.editor&&content.editor=='O'){
								dataset=this.contents;
							}
							if(dataset.length==0){
								return
							}
							let sec=this.getSecbyId(dataset, id);
							if (!sec) continue;
							let subSec:any;
							if(sec&&sec.SUB_SECTIONS){
								subSec=JSON.parse(JSON.stringify(sec.SUB_SECTIONS));
							}
							if(sec.SECTION_TITLE!=content.data.SECTION_TITLE){
								sec.SECTION_TITLE=content.data.SECTION_TITLE;
								if(this.summaryStatus){
									if(this.summaryType=='PHASE I'){
										this.toTatalPISummary();																	
									}else if(this.summaryType=='PCA'){console.log('change')
										this.getTotalSummary();									
									}
								}
								if(this.reportInfo.PCA_INDICATOR=='4099e'){
									this.getTotalCost1();
									this.getTotalUl();
								}else if(this.reportInfo.PCA_INDICATOR=='Y'){
									this.getTotalCost();								
								}
							}
							if(this.reportInfo.PCA_INDICATOR=='frm1105'){
								if(sec.id.indexOf('frm_sec')>-1){
									if(sec['data']!=content.data.data){
										sec['data']=content.data.data;
										this.secToFrmdata(sec);
									}
								}
								if(content.data.cat&&sec.cat!=content.data.cat){
									sec.cat=content.data.cat;
								}
								/*if(content.frmData){
									if(sec['frmData']!=content.frmData){
										sec['frmData']==content.frmData
									}
								}*/
							}
							if(content.data.data){
								sec.data=content.data.data;
							}
							if(this.reportInfo.PCA_INDICATOR=='frm1104'){
								if(sec.id.indexOf('frm1104-3')>-1||sec.id.indexOf('frm1104-2')>-1){
									this.getAllDeficiencies('', '');
								}
								if(sec.data.PropertyResidentialRentalUnit){
									this.toFlat();
								}
							}
							if(this.reportInfo.PHASE1_TYPE=='1103'){
								if(sec.data.units){
									this.toFlat();
								}
							}
							if(sec.required!=content.data.required){
								sec.required=content.data.required;
							}
							if(sec.htmltext!=content.data.htmltext){
								sec.htmltext=content.data.htmltext;
							}
							if(sec['tcflag']!=content.data['tcflag']){
								if(content.data['tcflag']){
									sec['tcflag']=true;
								}else{
									delete sec['tcflag'];
								}
							}
							if(sec['tcusers']!=content.data['tcusers']){
								if(!content.data.tcusers){
									if(sec.tcusers){
										if(sec.tcusers){
											delete sec.tcusers;
										}
										if(sec.suggestions){
											delete sec.suggestions;
										}
										if(sec.comments){
											delete sec.comments;
										}
									}
								}else if(content.data.tcusers.length==0){
									sec['tcusers']=[];
									sec['suggestions']=[];
									sec['comments']=[];
								}else{
									sec['tcusers']=content.data.tcusers;
									if(sec['suggestions']!=content.data['suggestions']){
										if(!content.data.suggestions){
											delete sec.suggestions
										}else if(content.data.suggestions.length==0){
											sec['suggestions']=[];
										}else{
											sec['suggestions']=content.data.suggestions;
										}
										
									}
									if(sec['comments']!=content.data['comments']){
										if(!content.data.comments){
											if(sec.comments){
												delete sec.comments
											}
										}else if(content.data.comments.length==0){
											sec['comments']=[];
										}else{
											sec['comments']=content.data.comments;
										}								
									}
								}								
							}
							
							
							if(typeof(content.data.text) === 'string'){
								sec.text=content.data.text;
								if((!sec['tcusers']||sec['tcusers'].length==0)&&((sec['comments']&&sec['comments'].length>0)||(sec['suggestions']&&sec['suggestions'].length>0))){
									if(sec.tcusers){
										delete sec.tcusers;
									}
									if(sec.suggestions){
										delete sec.suggestions;
									}
									if(sec.comments){
										delete sec.comments;
									}
									sec.text=this.trackErrorFix(sec.text);
									sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);									
								}
							}
							
							if(sec.libs!=content.data.libs){
								sec.libs=content.data.libs;
							}
							if(sec.slots!=content.data.slots){
								sec.slots=content.data.slots;
							}
							if(sec.photos!=content.data.photos){
								sec.photos=content.data.photos;
							}
							if(sec.comm!=content.data.comm){
								sec.comm=content.data.comm;
							}
							if(sec.wcompleted!=content.data.wcompleted){
								sec.wcompleted=content.data.wcompleted;
								
							}
							if(sec.rcompleted!=content.data.rcompleted){
								sec.rcompleted=content.data.rcompleted;
								
							}
							if(subSec){
								sec['SUB_SECTIONS']=subSec;
							}
							if(sec.TOC!=content.data.TOC){
								sec.TOC=content.data.TOC;
							}
							if(sec.OTABLE!=content.data.OTABLE){
								sec.OTABLE=content.data.OTABLE;
							}
							if(sec.OTNAME!=content.data.OTNAME){
								sec.OTNAME=content.data.OTNAME;
							}
							if(sec.OPNAME!=content.data.OPNAME){
								sec.OPNAME=content.data.OPNAME;
							}
							if(sec.OSNAME!=content.data.OSNAME){
								sec.OSNAME=content.data.OSNAME;
							}
							if(sec.OHEADER!=content.data.OHEADER){
								sec.OHEADER=content.data.OHEADER;
							}
							if(sec.HIDE!=content.data.HIDE){
								sec.HIDE=content.data.HIDE;
							}
							if(sec.NEW!=content.data.NEW){
								sec.NEW=content.data.NEW;
							}
							if(sec.pageSrc!=content.data.pageSrc){
								sec.pageSrc=content.data.pageSrc;
							}
							if(sec.header!=content.data.header){
								sec.header=content.data.header;
							}
							if(sec.footer!=content.data.footer){
								sec.footer=content.data.footer;
							}
							if(sec['fFooter']!=content.data['fFooter']){
								if(content.data['fFooter']){
									sec['fFooter']=content.data['fFooter'];															
								}else{
									delete sec['fFooter'];									
								}
							}	
							if(sec['fHeader']!=content.data['fHeader']){
								if(content.data['fHeader']){
									sec['fHeader']=content.data['fHeader'];															
								}else{
									delete sec['fHeader'];									
								}
							}														
							if(sec.intro!=content.data.intro){
								sec.intro=content.data.intro;
							}
							if(sec['borderClass']!=content.data['borderClass']){
								sec['borderClass']=content.data['borderClass'];
							}
							if(content.data.TYPE){
								sec.TYPE=content.data.TYPE;
							}
							if(sec.SECTION_SEQUENCE!=content.data.SECTION_SEQUENCE){
								sec.SECTION_SEQUENCE=content.data.SECTION_SEQUENCE;
							}
							//if(sec.READ_ONLY||content.data.READ_ONLY){
							//	sec.READ_ONLY=content.data.READ_ONLY;
							//}
							if(sec.filted!=content.data.filted){
								sec.filted=content.data.filted;
							}
							if(sec.pageSrc!=content.data.pageSrc){
								sec.pageSrc=content.data.pageSrc;
							}
							if(sec.pdf!=content.data.pdf){
								sec.pdf=content.data.pdf;
							}
							if(sec.pdfName!=content.data.pdfName){
								sec.pdfName=content.data.pdfName;
							}
							if(sec.selectedFilters!=content.data.selectedFilters){
								sec.selectedFilters=content.data.selectedFilters;
							}
							if(sec.signs!=content.data.signs){
								sec.signs=content.data.signs;
							}
							if(sec.seals!=content.data.seals){
								sec.seals=content.data.seals;
							}
							if(sec.filted!=content.data.filted){
								sec.filted=content.data.filted;
							}
							if(sec.selectedFilters!=content.data.selectedFilters){
								sec.selectedFilters=content.selectedFilters;
							}
							if(sec.ul!=content.data.ul){
								sec.ul=content.data.ul;
							}
							if(sec.long!=content.data.long){
								sec.long=content.data.long;
							}
							if(this.reportInfo.PCA_INDICATOR=='Y'){
							if(sec['tableSize']!=content.data.tableSize){
										if(!content.data.tableSize&&sec.tableSize){
											delete sec.tableSize
										}else{
											sec['tableSize']=content.data.tableSize
										}										
									}
									if(sec['pcaTableSetting']!=content.data.pcaTableSetting){
										if(!content.data.pcaTableSetting&&sec['pcaTableSetting']){
											delete sec['pcaTableSetting'];
										}else{
											sec['pcaTableSetting']=content.data.pcaTableSetting
										}
									}
							}	
							if(this.summaryStatus){
								let changed=false;
								if(this.summaryType=='PHASE I'){
									if(content.data['pisummarydata']){
										if(!sec['pisummarydata']&&content.data['pisummarydata']){
											sec['pisummarydata']=content.data['pisummarydata'];
											this.toTatalPISummary()
										}else{
											for(let i=0; i<sec['pisummarydata'].length; i++){
												if(sec['pisummarydata'][i].data!=content.data['pisummarydata'][i].data){
													sec['pisummarydata'][i].data=content.data['pisummarydata'][i].data;
													changed=true;
												}
												if(sec['pisummarydata'][i]['html']!=content.data['pisummarydata'][i]['html']){
													sec['pisummarydata'][i]['html']=content.data['pisummarydata'][i]['html'];
													sec['pisummarydata'][i]['secHtml']=content.data['pisummarydata'][i]['secHtml'];
													changed=true;
												}											
											}
											if(changed){
												this.toTatalPISummary()
											}
										}
									}else{
										if(sec['pisummarydata']){
											delete sec.pisummarydata;
											this.toTatalPISummary()
										}
									}
								}else if(this.summaryType=='PCA'){
									if(content.data['pcasummarydata']){
										if(!sec['pcasummarydata']&&content.data['pcasummarydata']){
											sec['pcasummarydata']=content.data['pcasummarydata'];
											this.getTotalSummary()
										}else{
											for(let i=0; i<sec['pcasummarydata'].length; i++){
												if(sec['pcasummarydata'][i].data!=content.data['pcasummarydata'][i].data){
													sec['pcasummarydata'][i].data=content.data['pcasummarydata'][i].data;
													changed=true;
												}
												if(sec['pcasummarydata'][i]['html']!=content.data['pcasummarydata'][i]['html']){
													sec['pcasummarydata'][i]['html']=content.data['pcasummarydata'][i]['html'];
													sec['pcasummarydata'][i]['secHtml']=content.data['pcasummarydata'][i]['secHtml'];
													changed=true;
												}
												if(sec['pcasummarydata'][i]['cat']!=content.data['pcasummarydata'][i]['cat']){
													sec['pcasummarydata'][i]['cat']=content.data['pcasummarydata'][i]['cat'];
													changed=true;
												}											
											}
											if(changed){
												this.getTotalSummary()
											}
										}
									}else{
										if(sec['pcasummarydata']){
											delete sec.pcasummarydata;
											this.getTotalSummary()
										}
									}
								}
								
							}
							if(sec.DISPLAY_SEQUENCE!=content.data.DISPLAY_SEQUENCE){
								sec.DISPLAY_SEQUENCE=content.data.DISPLAY_SEQUENCE;
								this.generateSeq();	
								if(this.summaryStatus){
									if(this.summaryType=='PHASE I'){
										this.toTatalPISummary();
									}else if(this.summaryType=='PCA'){
										this.getTotalSummary();
									}	
								}	
							}
							
							if(item.SECTION_MODIFIED=='cost update'){
								if(this.reportInfo.PCA_INDICATOR=='4099e'){
									this.getTotalCost1();
									this.getTotalUl();
								}else if(this.reportInfo.PCA_INDICATOR=='frm1105'){
									this.getAllCostTable()
								}else{
									this.getTotalCost();
									if(this.summaryStatus){
										if(content.data['summaryCat']){
											sec['summaryCat']=content.data['summaryCat'];											
										}else{
											if(sec['summaryCat']){
												delete sec['summaryCat'];
											}
										}										
										this.getTotalSummary();	
									}
								}
								
							}							
							sec.hash=this.getHash(sec);
						}else if(item.SECTION_MODIFIED=='slot update'){
							let data=JSON.parse(item.SECTION_DATA);
							this.setLocalSlot(data, 'edit');
						}else if(item.SECTION_MODIFIED=='ERIS Data Update'){
							this.reportInfo.ORDER_NUM=item.SECTION_DATA;
							this.slotTableGetData('edit');
							this.editOrder=false;
							let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":item.SECTION_DATA}
							
							this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result=>{
								if (result.RESPONSE_STATUS=='N') {
									this.throwError(result)
																				
								}else{
								this.pdfs=result.REPORT_LINKS;
								this.updatePdfs();
								}
							})
						}else if(item.SECTION_MODIFIED=='erisDataUpdate'){
							let id=JSON.parse(item.SECTION_DATA).id;
							let iftc=JSON.parse(item.SECTION_DATA)['tcflag']?'Y':'N';
							this.updateErisTable(id, iftc);
						}else if(item.SECTION_MODIFIED=='appendix update'){
							this.appendices=JSON.parse(item.SECTION_DATA);
						}else if(item.SECTION_MODIFIED=='appendix Factor update'){
							this.printnodataforAppendix=JSON.parse(item.SECTION_DATA).printnodata;
						}else if(item.SECTION_MODIFIED=='PCA Factor Update'){
							let newOP=JSON.parse(item.SECTION_DATA);console.log(newOP);
							console.log(this.pcaOp.multiplier)
							if(this.pcaOp.multiplier!=newOP.multiplier){
								this.pcaOp.multiplier=newOP.multiplier;
								if(this.reportInfo.PCA_INDICATOR=='Y'){
									for(let sec of this.contents){
										if(sec.TYPE=='COST'){
											for(let sec1 of sec.SUB_SECTIONS){
												if(sec1.TYPE=='UNITTABLE'){
													let rows=sec1.data.rows;//console.log(rows)
													rows[1][0].DATA="Total "+ this.pcaOp.multiplier;
													rows[2][0].DATA='Reserve per '+this.pcaOp.multiplier+' per Year (Uninflated)';
													rows[3][0].DATA='Reserve per '+this.pcaOp.multiplier+' per Year (Inflated)';
												}
											}
										}
									}
									this.changeOpItem();
								}else if(this.reportInfo.PCA_INDICATOR=='4099e'){
										let table=this.getSecbyId(this.contents,'fme_exec_sum_capital_needs_1');
										for(let row of table.data.rows){console.log(row)		
											if(row[1].KEY=='AU'){
												row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Uninflated)'
											}
											if(row[1].KEY=='AI'){
												row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Inflated)'
											}			
										}
									}
								/*for(let sec of this.contents){
									if(sec.TYPE=='COST'){
										for(let sec1 of sec.SUB_SECTIONS){
											if(sec1.TYPE=='UNITTABLE'){
												let rows=sec1.data.rows;
												rows[1][0].DATA="Total "+ this.pcaOp.multiplier;
												rows[2][0].DATA='Reseve per '+this.pcaOp.multiplier+' per year(Uninflated)';
												rows[3][0].DATA='Reseve per '+this.pcaOp.multiplier+' per year(inflated)';
											}
										}
									}
								}*/
							}else if(this.pcaOp.term!=newOP.term){
								this.pcaOp.term=newOP.term;
								if(this.reportInfo.PCA_INDICATOR!=='frm1105'){
									this.setCostTableTitle('update');
								}
							}else{
								this.pcaOp=newOP;
								if(this.reportInfo.PCA_INDICATOR=='4099e'){
									this.getTotalCost1();
								}else if(this.reportInfo.PCA_INDICATOR!=='frm1105'){
									this.getTotalCost();
									if(this.summaryStatus){
										if(this.summaryType=='PCA'){
											this.changeOpItem();
											this.getTotalSummary();
											
										}
									}
								}
							
							}
							
							/*if(this.pcaOp.inflation!=newOP.inflation){
								this.pcaOp.inflation=newOP.inflation;
								this.getTotalCost();
							}
							this.pcaOp=newOP;*/
						}else if(item.SECTION_MODIFIED=='delete'){
							const id=item.SECTION_ID;
							let index=[]
							const content:any=JSON.parse(item.SECTION_DATA);
							let dataset:any;
							if(content.editor&&content.editor=='F'){
								dataset=this.frontpages
								index=this.getFrontIdIndex(id);
							}else{
								dataset=this.contents;
								index=this.getIdIndex(id);
							}
							
							if(index[2]>-1){
								dataset[index[0]].SUB_SECTIONS[index[1]].SUB_SECTIONS.splice(index[2],1);
							}else if(index[1]>-1){
								dataset[index[0]].SUB_SECTIONS.splice(index[1],1);
							}else if(index[0]>-1){
								dataset.splice(index[0],1);
							}
							
							this.generateSeq();
							if(this.summaryStatus){
								if(this.summaryType=='PHASE I'){
									this.toTatalPISummary();
								}else if(this.summaryType=='PCA'){
									this.getTotalSummary();
								}	
							}else if(this.reportInfo.PCA_INDICATOR!=='frm1105'){
								this.getAllCostTable();
							}	
						}else if(item.SECTION_MODIFIED=='add'){
							let id=item.SECTION_ID;
							let content:any=JSON.parse(item.SECTION_DATA);
							let index=[]
							if(content.editor&&content.editor=='F'){
								index=this.getFrontIdIndex(id);
							}else{
								index=this.getIdIndex(id);
							}
							if (index.length == 0) {
								let dataset:any;
								if(content.editor&&content.editor=='F'){
									dataset=this.frontpages;
								}else{
									dataset=this.contents;
								}
								let info:any=content.data;
								let position=content.position;
								if(position.parent){
									let id1=position.parent;
									let sec=this.getSecbyId(dataset, id1);
									if(sec&&sec.SUB_SECTIONS){
									sec.SUB_SECTIONS.splice(0,0,info);
									}
								}else if(position.sibling){
									let id1=position.sibling;
									let index=[]
									if(content.editor&&content.editor=='F'){
										index=this.getFrontIdIndex(id1);
									}else{
										index=this.getIdIndex(id1);
									}
									
									if(index[2]>-1){
										dataset[index[0]].SUB_SECTIONS[index[1]].SUB_SECTIONS.splice(index[2]+1,0,info);
									}else if(index[1]>-1){
										dataset[index[0]].SUB_SECTIONS.splice(index[1]+1,0,info);
									}else if(index[0]>-1){
										dataset.splice(index[0]+1,0,info);
									}else{

									}
								}else{
									dataset.push(info)
								}
							}
							this.generateSeq();
							if(this.summaryStatus){
								if(this.summaryType=='PHASE I'){
									this.toTatalPISummary();
								}else if(this.summaryType=='PCA'){
									this.getTotalSummary();
								}	
							}	

						}
					}
					}
					if(data.REVIEWER_PROGRESS.length>0){
						this.rPercentage=parseFloat(data.REVIEWER_PROGRESS.replace("%", ''));
					}
					if(data.PERCENT_COMPLETE.length>0){
						this.wPercentage=parseFloat(data.PERCENT_COMPLETE.replace("%", ''));
					}				
					
				} catch (e) {
					throw e;
				}
				
			}
			return data.LATEST_VERSION_ID;
		}else{
			this.throwError(data)
		}
	}
	checkSaveType(type, sid?, stitle?, editor?){//console.log(type, sid, stitle, editor)
		if (!sid) return;

		let secData="";
		if(type=='modify'||type=='manualsave-section'||type=='autosave-section'||type=="cost update"){
			let sec:any;
			if(editor=="F"){
				sec=this.getSecbyId(this.frontpages, sid);
			}else if(editor=="O"){
				if(sid.indexOf('frm_sec')>-1){
					//sec=this.getSecbyId(this.contents, "frm_sec");
					sec=this.getSecbyId(this.contents, sid);
				}else{
					sec=this.getSecbyId(this.contents, sid);
				}
				
			}
			
			let newsec=JSON.parse(JSON.stringify(sec));
			if(newsec.SUB_SECTIONS&&newsec.SUB_SECTIONS.length>0){
				newsec.SUB_SECTIONS=[];
			}
			newsec.hash="";
			let item={'editor':editor, 'data':newsec}
			secData=JSON.stringify(item);
		}else if(type=="delete"){
			let item={'editor':editor};
			secData=JSON.stringify(item)
		}else if(type=="add"){
			let sec:any;
			let position:any;
			if(editor=="F"){
				sec=this.getSecbyId(this.frontpages, sid);
				position=this.getIndexbyid(this.frontpages,sid);
			}else if(editor=="O"){
				sec=this.getSecbyId(this.contents, sid);
				position=this.getIndexbyid(this.contents,sid);
			}
			
			let item={'editor':editor,'position':position, 'data':sec}
			secData=JSON.stringify(item)
			this.logUsers(sid, stitle);
		}else if(type=="ERIS Data Update"){
			secData=this.reportInfo.ORDER_NUM;
		}else if(type=="slot update"){
			secData=JSON.stringify(stitle);
		}else if(type=="appendix update"){
			
			secData=JSON.stringify(this.appendices);
			
		}else if(type=="appendix Factor update"){
			let info={'printnodata':this.printnodataforAppendix}
			secData=JSON.stringify(info);			
		}else if(type=="PCA Factor Update"){
			secData=JSON.stringify(this.pcaOp)
		}else if(type=="erisDataUpdate"){
			let tcflag=this.getContentData('tcflag'); //console.log(tcstatus)
			let item={'id':sid};
			if(tcflag){
				item['tcflag']=tcflag;
			}
			secData=JSON.stringify(item);
		}
		//console.log(secData)
		return secData
	}
	getIndexbyid(editor, id){
		let position={'parent':'', 'sibling':'', 'index':[]};
		for(let i=0; i<this.frontpages.length; i++){
			if(this.frontpages[i].id==id){
				if(i>0){
					position.sibling=this.frontpages[i-1].id;
					position.index=[i, this.addon, this.addon];
				}
				break
			}
			if(this.frontpages[i].SUB_SECTIONS&&this.frontpages[i].SUB_SECTIONS.length>0){
				for(let j=0; j<this.frontpages[i].SUB_SECTIONS.length; j++){
					if(this.frontpages[i].SUB_SECTIONS[j].id==id){
						position.index=[i,j, this.addon]
						
						if(j>0){
							position.sibling=this.frontpages[i].SUB_SECTIONS[j-1].id;
							break
						}else{
							position.parent=this.frontpages[i].id;
							break
						}
					}
					
				}
			}
		}
		for(let i=0; i<this.contents.length; i++){
			if(this.contents[i].id==id){
				if(i>0){
					position.sibling=this.contents[i-1].id;
					position.index=[i, this.addon, this.addon];
				}
				break
			}
			if(this.contents[i].SUB_SECTIONS&&this.contents[i].SUB_SECTIONS.length>0){
				for(let j=0; j<this.contents[i].SUB_SECTIONS.length; j++){
					if(this.contents[i].SUB_SECTIONS[j].id==id){
						position.index=[i, j, this.addon];
						if(j>0){
							position.sibling=this.contents[i].SUB_SECTIONS[j-1].id;
							break
						}else{
							position.parent=this.contents[i].id;
							break
						}
					}
					if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS&&this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS.length>0){
						for(let k=0; k<this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS.length; k++){
							if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].id==id){
								position.index=[i, j, k];
								if(k>0){
									position.sibling=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k-1].id;
									break
								}else{
									position.parent=this.contents[i].SUB_SECTIONS[j].id;
									break
								}
							}
					
						}
					}
					
				}
			}
		}
		return position
	}
	async getRpt(id){//console.log(id);
		$('#overlay').css('display','block');
		let inputJson= {"PROCEDURE":"loadreportgetdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};// Optional Version_ID - select most recent version if version_id is null
		//console.log(JSON.stringify(inputJson));
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		//console.log('reportdata',data);
		if(data.ERRORCODE){
			this.throwError(data)
			return
		}
		this.curReport=data;
		if(data.PCA_DATA&&data.PCA_DATA.length>0){
			let pca=JSON.parse(data.PCA_DATA); //console.log(pca);
			this.pcaOp.term=pca.term;
			this.pcaOp.multiplier=pca.multiplier;
			this.pcaOp.decimal=pca.decimal;
			this.pcaOp.currency=pca.currency;
			this.pcaOp.inflation=pca.inflation;
			this.pcaOp.round=pca.round;
			if(pca.quantity){
				this.pcaOp.quantity=pca.quantity;
				this.pcaQuantity=this.pcaOp.quantity;	
			}
			if(pca.reserve){
				this.pcaOp.reserve=pca.reserve;
				this.reserveTerm=pca.reserve;
			}
			if(pca.EFF){
				this.pcaOp.age=pca.EFF;
			}
			//console.log(this.pcaOp);
		}
		if((data.REPORT_DATA&&data.REPORT_DATA.length>0)||(data.BEFORE_TOC&&data.BEFORE_TOC.length>0)){
			this.contents=JSON.parse(data.REPORT_DATA); console.log('content',this.contents);
			if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
				this.frontpages=JSON.parse(data.BEFORE_TOC); console.log('front', this.frontpages)
			}
		}else{
			this.contents=[];
			this.frontpages=[];
		}
		//this.contents=[];
		//this.frontpages=[];
		if((this.contents.length>0)||(this.frontpages.length>0)){
		//if(this.frontpages.length>0){//for replaced report test
			this.contents=JSON.parse(data.REPORT_DATA); console.log('content',this.contents);
			this.summaryStatus=this.haveSummary();
			if(data.ERIS_UPDATE=='Y'){
				this.erisUpdated=true;
			}else if(data.ERIS_UPDATE=="N"){
				this.erisUpdated=false;				
			}
			let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
			const response = await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return							
			}
			console.log('report',response);
			this.reportInfo=response;
			if(this.reportInfo.COPIED_REPORT=='Y'&&this.reportInfo.COPIED_REPORT_OPENED=="N"){
				this.initCopiedReport();				
			}
			if(this.reportInfo.SIGNATURE_STYLE&&this.reportInfo.SIGNATURE_STYLE.SIGNATURE_STYLE_ID>-1){
				this.defaultSign=JSON.parse(JSON.stringify(this.reportInfo.SIGNATURE_STYLE));
				this.getSignContent(this.defaultSign['SIGNATURE_STYLE_ID']);
			}
			if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
				await this.getErisUpdate(id);
			};
			if(response.REPORT_PDF_SETTING){
				let setInfo=JSON.parse(response.REPORT_PDF_SETTING); //console.log(setInfo)
				if(setInfo.margin){
					this.pageMargin=setInfo.margin;
				}
				if(setInfo.orientation){
					this.selectpage=setInfo.orientation;
				}
				//this.bimageurl=setInfo.bk;
			}
			if(response.HEADING1_DESIGN&&response.HEADING1_DESIGN.length>0){
					this.head1=response.HEADING1_DESIGN; //console.log(this.head1);
				}
				if(response.HEADING2_DESIGN&&response.HEADING2_DESIGN.length>0){
					this.head2=response.HEADING2_DESIGN;//console.log(this.head2);
				}
				if(response.HEADING3_DESIGN&&response.HEADING3_DESIGN.length>0){
					this.head3=response.HEADING3_DESIGN;//console.log(this.head3);
				}
				if(response.HEADING1_SPACING&&response.HEADING1_SPACING.length>0){
					this.head1Space=response.HEADING1_SPACING; //console.log(this.head1Space);
				}
				if(response.HEADING2_SPACING&&response.HEADING2_SPACING.length>0){
					this.head2Space=response.HEADING2_SPACING
				}
				if(response.HEADING3_SPACING&&response.HEADING3_SPACING.length>0){
					this.head3Space=response.HEADING3_SPACING
				}
			this.pageMargin.top=response.REPORT_MARGIN_TOP;
			this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
			this.pageMargin.left=response.REPORT_MARGIN_LEFT;
			this.pageMargin.right=response.REPORT_MARGIN_RIGHT;
			this.tocMargin.top=response.TOC_MARGIN_TOP;
			this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
			this.tocMargin.left=response.TOC_MARGIN_LEFT;
			this.tocMargin.right=response.TOC_MARGIN_RIGHT;
			if(response.SUMMARY_CATEGORY&&response.SUMMARY_CATEGORY.length>0){
				this.summaryCategory=response.SUMMARY_CATEGORY.split(',');
			}
			if(response.PCA_PAGE_SETUP){
				this.lpagesize=response.PCA_PAGE_SETUP;
			}
			if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
				this.frontpages=JSON.parse(data.BEFORE_TOC); console.log('front', this.frontpages)
			}
			if(response.COVERPAGE&&response.COVERPAGE.length>0){
				this.selectedCover=response.COVERPAGE[0]//.COVERPAGE_ID;//console.log('cover',this.selectedCover);
				//this.selectedCover=response.COVERPAGE[0].COPIED_FROM_ID;
				this.getCoverData(this.selectedCover.COVERPAGE_ID);
			}
			if(response.HEADER&&response.HEADER.length>0){
				this.selectedHeader=response.HEADER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedHeader.HEADER_ID)
			}
			if(response.FOOTER&&response.FOOTER.length>0){
				this.selectedFooter=response.FOOTER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedFooter.FOOTER_ID)
			}
			if(response.TOC_HEADER&&response.TOC_HEADER.length>0){
				this.selectedTHeader=response.TOC_HEADER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedHeader.HEADER_ID)
			}
			if(response.TOC_FOOTER&&response.TOC_FOOTER.length>0){
				this.selectedTFooter=response.TOC_FOOTER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedFooter.FOOTER_ID)
			}
			if(response.FRM_FOOTER&&response.FRM_FOOTER.length>0){
				this.selectedFrmFooter.FRM_FOOTER_ID=response.FRM_FOOTER[0].FRM_FOOTER_ID;	
				this.selectedFrmFooter.HF_TITLE=response.FRM_FOOTER[0].HF_TITLE;			
			}
			if(response.COMP_PROFILE_ID&&response.COMP_PROFILE_ID>-1){
				this.selectedProfile=response.COMP_PROFILE_ID;
			}
			if(response.WATERMARK&&response.WATERMARK.length>0){
				this.selectedWatermarker=response.WATERMARK[0];//.WATERMARK_ID;
			}
			if(response.PDF_FILE_NAME&&response.PDF_FILE_NAME.length>0){
				this.pdfFname=JSON.parse(response.PDF_FILE_NAME);//console.log(this.pdfFname)
				if(!this.pdfFname.reqIndex){
					this.pdfFname.reqIndex=0;
				}
			}
			if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
				this.blackText=true;
			}else{
				this.blackText=false;
			}
			if(response.BODYINDENT_SAME_STITLE&&response.BODYINDENT_SAME_STITLE=='Y'){
				this.contentIndent=true;
			}else{
				this.contentIndent=false;
			}	
			if(response.APPENDIX_NODATA_MESSAGE){
				this.printnodataforAppendix=response.APPENDIX_NODATA_MESSAGE;
			}			
			if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='Y'){
				await this.getPCAData();
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='4099e'){
				
				this.capitalCategory=this.fmeService.capitalCategory;
				this.immiCategory=this.fmeService.immiCategory;	
				this.ratingOps=this.fmeService.ratingOps;
				this.actionItemOps=this.fmeService.actionItemOps;
				this.capitalItems=this.fmeService.capitalItems;
				await this.getFMEtable();			
				await this.getPCAData();
				//this.getCostLib();
				//this.contents=[]
				//this.iniFme();
				
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=="frm1105"){
				//this.contents=[]
				//this.iniFrm1105();
				this.getAllCostTable();
				this.capitalCategory=this.frmService.capitalCategory;
				this.conditionOps=this.frmService.conditionOps;
				this.actionItemOps=this.frmService.actionItemOps;
				await this.getPCAData();
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='frm1104'){
				this.toFlat();
			}else if(response.PHASE1_TYPE&&response.PHASE1_TYPE=='1103'){
				this.toFlat();
			}
			if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
				let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};
				this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result=>{
					//console.log('link',result);
					if (result.RESPONSE_STATUS=='N') {
						this.throwError(result)
											
					}else{
						this.pdfs=result.REPORT_LINKS;
						if(!(this.reportInfo.COPIED_REPORT=='Y'&&this.reportInfo.COPIED_REPORT_OPENED=="N")){
							this.updatePdfs();
						}
					}	
					
				})
				let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};//console.log(inputJson6);
				this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						this.throwError(result)
												
					}else{
						this.erisPdfs=result.PRODUCT_LINKS;
					}
					
				})
			}
			this.titleService.setTitle("Report" + 
				' - ' + this.reportInfo.PROJECT_NUMBER +
				' - ' + (this.reportInfo.ADDRESS_LINE1 + ' ' + this.reportInfo.ADDRESS_LINE2).trim() +
				' - ' + (this.reportInfo.REPORT_TITLE)
			);
			if(!this.reportInfo.PERCENT_COMPLETE||this.reportInfo.PERCENT_COMPLETE.length==0){
				this.wPercentage=0;
			}else{
			this.wPercentage=parseFloat(this.reportInfo.PERCENT_COMPLETE.replace('%',''));
			}
			if(!this.reportInfo.REVIEWER_PROGRESS||this.reportInfo.REVIEWER_PROGRESS.length==0){
				this.rPercentage=0;
			}else{
				this.rPercentage=parseFloat(this.reportInfo.REVIEWER_PROGRESS.replace('%',''));
			}
			
			this.location.go('/report/'+this.reportInfo.PROJECT_ID.toString()+'/'+id.toString());
			$('#overlay').css('display','none');

			//this.slotTableGetData();
			//Update the URL
			let inputJson4= {"PROCEDURE":"getreportappendix","USER_ID":parseInt(this.userId),"REPORT_ID":id};
			//console.log('app', inputJson4);
			this.reportService.univeralService(JSON.stringify(inputJson4)).subscribe(response => {
				//console.log('app',response);
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)
											
				}else{
					if(response.APPENDIX_DATA&&response.APPENDIX_DATA.length>0){
					this.appendices=JSON.parse(response.APPENDIX_DATA);
					if(this.reportInfo.COPIED_REPORT=='Y'&&this.reportInfo.COPIED_REPORT_OPENED=="N"){
						this.copiedAppendix();
						this.copiedPhotoLog();
					}else{
						this.updatePdfs();
					}
				}
				}
				
			})
			
			
		}else{
			let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
			//console.log('reportJson',JSON.stringify(inputJson1));
			const response = await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
			console.log('report', response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return							
			}
			this.reportInfo=response;
			if(this.reportInfo.SIGNATURE_STYLE&&this.reportInfo.SIGNATURE_STYLE.SIGNATURE_STYLE_ID>-1){
				this.defaultSign=JSON.parse(JSON.stringify(this.reportInfo.SIGNATURE_STYLE));
				this.getSignContent(this.defaultSign['SIGNATURE_STYLE_ID']);
			}
			if(response.HEADING1_DESIGN&&response.HEADING1_DESIGN.length>0){
					this.head1=response.HEADING1_DESIGN; //console.log(this.head1);
				}
				if(response.HEADING2_DESIGN&&response.HEADING2_DESIGN.length>0){
					this.head2=response.HEADING2_DESIGN;
				}
				if(response.HEADING3_DESIGN&&response.HEADING3_DESIGN.length>0){
					this.head3=response.HEADING3_DESIGN;
				}
				if(response.HEADING1_SPACING&&response.HEADING1_SPACING.length>0){
					this.head1Space=response.HEADING1_SPACING; //console.log(this.head1Space);
				}
				if(response.HEADING2_SPACING&&response.HEADING2_SPACING.length>0){
					this.head2Space=response.HEADING2_SPACING
				}
				if(response.HEADING3_SPACING&&response.HEADING3_SPACING.length>0){
					this.head3Space=response.HEADING3_SPACING
				}
				this.pageMargin.top=response.REPORT_MARGIN_TOP;
				this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
				this.pageMargin.left=response.REPORT_MARGIN_LEFT;
				this.pageMargin.right=response.REPORT_MARGIN_RIGHT;
				this.tocMargin.top=response.TOC_MARGIN_TOP;
				this.tocMargin.bottom=response.TOC_MARGIN_BOTTOM;
				this.tocMargin.left=response.TOC_MARGIN_LEFT;
				this.tocMargin.right=response.TOC_MARGIN_RIGHT;
				if(response.SUMMARY_CATEGORY&&response.SUMMARY_CATEGORY.length>0){
					this.summaryCategory=response.SUMMARY_CATEGORY.split(',');
				}
				if(response.PCA_PAGE_SETUP){
					this.lpagesize=response.PCA_PAGE_SETUP;
				}
			if(response.COVERPAGE&&response.COVERPAGE.length>0){
				this.selectedCover=response.COVERPAGE[0];//.COVERPAGE_ID;//console.log('cover',this.selectedCover);
				this.getCoverData(this.selectedCover.COVERPAGE_ID);
			}
			if(response.HEADER&&response.HEADER.length>0){
				this.selectedHeader=response.HEADER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedHeader.HEADER_ID)
			}
			if(response.FOOTER&&response.FOOTER.length>0){
				this.selectedFooter=response.FOOTER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedFooter.FOOTER_ID)
			}
			if(response.TOC_HEADER&&response.TOC_HEADER.length>0){
				this.selectedTHeader=response.TOC_HEADER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedHeader.HEADER_ID)
			}
			if(response.TOC_FOOTER&&response.TOC_FOOTER.length>0){
				this.selectedTFooter=response.TOC_FOOTER[0];//.HEADERFOOTER_ID;
				//this.getHF(this.selectedFooter.FOOTER_ID)
			}
			if(response.FRM_FOOTER&&response.FRM_FOOTER.length>0){
				this.selectedFrmFooter.FRM_FOOTER_ID=response.FRM_FOOTER[0].FRM_FOOTER_ID;
				this.selectedFrmFooter.HF_TITLE=response.FRM_FOOTER[0].HF_TITLE;					
			}
			if(response.COMP_PROFILE_ID&&response.COMP_PROFILE_ID>-1){
				this.selectedProfile=response.COMP_PROFILE_ID;
			}
			if(response.WATERMARK&&response.WATERMARK.length>0){
				this.selectedWatermarker=response.WATERMARK[0];//.WATERMARK_ID;
			}
			if(response.PRINT_BLACKWHITE&&response.PRINT_BLACKWHITE=='Y'){
				this.blackText=true;
			}else{
				this.blackText=false;
			}
			if(response.BODYINDENT_SAME_STITLE&&response.BODYINDENT_SAME_STITLE=='Y'){
				this.contentIndent=true;
			}else{
				this.contentIndent=false;
			}	
			if(response.APPENDIX_NODATA_MESSAGE){
				this.printnodataforAppendix=response.APPENDIX_NODATA_MESSAGE;
			}
			if(response.PDF_FILE_NAME&&response.PDF_FILE_NAME.length>0){
				this.pdfFname=JSON.parse(response.PDF_FILE_NAME);//console.log(this.pdfFname)
				if(!this.pdfFname.reqIndex){
					this.pdfFname.reqIndex=0;
				}
			}
			if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='Y'){
				await this.getPCAData();
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=='4099e'){
				
				//this.getCostLib();
				//this.contents=[]
				//this.iniFme();
				
				this.capitalCategory=this.fmeService.capitalCategory;
				this.immiCategory=this.fmeService.immiCategory;
				this.ratingOps=this.fmeService.ratingOps;
				this.actionItemOps=this.fmeService.actionItemOps;
				this.capitalItems=this.fmeService.capitalItems;
				await this.getFMEtable();
				await this.getPCAData();
			}else if(response.PCA_INDICATOR&&response.PCA_INDICATOR=="frm1105"){
				//this.contents=[]
				//this.iniFrm1105();
				this.getAllCostTable();
				this.capitalCategory=this.frmService.capitalCategory;
				this.conditionOps=this.frmService.conditionOps;
				this.actionItemOps=this.frmService.actionItemOps;
			}
			if(response.TEMPLATE&&response.TEMPLATE.length>0){
				if(response.TEMP_REPORT_DATA=='N'){
					await this.getTemplate(response.TEMPLATE[0], id);
				}else if(response.TEMP_REPORT_DATA=='Y'){
					await this.getTemplate(response.TEMPLATE[0], id, response.TEMP_REPORT_DATA);
				}
	
			}
			if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
				let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM}
				this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result=>{
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						this.throwError(result)											
					}else{
						this.pdfs=result.REPORT_LINKS;
					this.updatePdfs();
					}
					
				})
				let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM};//console.log(inputJson6);
				this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
					//console.log(result);
					if (result.RESPONSE_STATUS=='N') {
						this.throwError(result)											
					}else{
					this.erisPdfs=result.PRODUCT_LINKS;
					}
				})
			}
			this.titleService.setTitle("Report"+' - '+this.reportInfo.REPORT_TITLE);
			if(this.reportInfo.PERCENT_COMPLETE&&this.reportInfo.PERCENT_COMPLETE.length==0){
				this.wPercentage=0;
			}else{
				this.wPercentage=parseFloat(this.reportInfo.PERCENT_COMPLETE.replace('%',''));
			}
			if(this.reportInfo.REVIEWER_PROGRESS&&this.reportInfo.REVIEWER_PROGRESS.length==0){
				this.rPercentage=0;
			}else{
				this.rPercentage=parseFloat(this.reportInfo.REVIEWER_PROGRESS.replace('%',''));
			}
			//Update the URL
			this.location.go('/report/'+this.reportInfo.PROJECT_ID.toString()+'/'+id.toString());
			/*if(this.allSlots.length>0){
				$('#overlay').css('display','none');
			}*/				
		}
		
		/*if(data.PDF_FILE_NAME&&data.PDF_FILE_NAME.length>0){
			this.pdfFname=JSON.parse(data.PDF_FILE_NAME);//console.log(this.pdfFname)
		}*/
		this.curIndex=[this.addon,this.addon,this.addon];
		this.logUsers(null, null);
	}
	/*deleteRpt(id){
		let that=this;
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		let inputJson= {"PROCEDURE":"deletereport","USER_ID":parseInt(that.userId),"REPORT_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
				let msg=data.MESSAGE;
			let Toast=Swal.mixin({
					toast: true,						
					position: 'center',
					showConfirmButton: false,
					timer: 3000
				})
			if(data.STATUS=='Y'){
				let index=that.reports.findIndex(rpt=>rpt.REPORT_ID==id);
				if(index>-1){
					that.reports.splice(index, 1)
				}
				Toast.fire({
					icon: 'success',
					title: msg
				})
			}else{
				Toast.fire({
					icon: 'error',
					title: msg
				})
			}
		})
		}
			})
	}*/
	 /*public addPagebreak(){
	 let newId="Break-"+this.docList.length;
	  	let index=this.docList.indexOf(this.currentDocIndex)+1;
		this.currentDocIndex=newId;
		this.docList.splice(index, 0, newId);
		let doc={
			'type':"pagebreak",
			'id':newId,
			'index':null,
		}
		this.docs.splice(index, 0, doc);
		
  }*/
  /*public reportNodes(){
	  let innerData=this.viewer.nativeElement.innerHTML;
  }
  function day(item) {
  var data = item.getAttribute('data-value');
  document.getElementById('time-wrap').innerHTML = document.getElementById(data).innerHTML;
  document.querySelectorAll('[data-promo="1"]').forEach(function(element) {
    element.parentNode.removeChild(element);
  });
}*/
showSavedLib1(data){
	this.rangeIndex=0;
	this.clearAddedLib();
	if(data&&data.length>0){
		data=this.updateLibs(data);
	}else{
		this.curLibs=[];
		this.definedLibGroup;
	}
	this.addLib=true;
  }
  showSavedLib(data, type?){//console.log('libs',data)
	//this.addedLib=data.libs;
	//this.checkLib();
	this.rangeIndex=0;////console.log(this.rangeIndex)
	this.clearAddedLib();
	if(data&&data.length>0){
		data=this.updateLibs(data);
		/*this.curLibs=data;
		this.rangeLib=data;
		this.rangeIndex=0;
		this.definedLibGroup=data;
		this.libGroup='D';*/
	}else{
		this.curLibs=[];
		this.rangeLib=this.libraries;
		this.rangeIndex=1;
		this.libGroup='A';
		if(this.libraries.length==0){
			this.refreshLibs()
		}
	}
	//console.log(this.definedLibGroup)
	//$('#libraryModal').modal('show');
	this.addLib=true;
	if(type){
		return
	}
	$('.nav-tabs a[href="#lib"]').tab('show');
	
  }
  showsavedSlot(data, type?){//console.log(data)
	this.rangeIndex=0;////console.log(this.rangeIndex)
	this.clearAddedSlot()
	if(data&&data.length>0){
		let ids='';
		for(let item of data){
			ids+=','+item.SLOT_ID;
		}
		//console.log(ids);
		ids=ids.slice(1);//console.log(ids);
		let inputJson={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":ids,"REPORT_ID":this.curReport.REPORT_ID};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			//console.log(response)
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
			if(response.RW_SLOTS&&response.RW_SLOTS.length>0){
				this.curSlots=response.RW_SLOTS;
				this.definedSlotGroup=response.RW_SLOTS;
				this.rangeSlot=response.RW_SLOTS;
			}else{
				this.curSlots=[];
				this.rangeSlot=data;
				this.definedSlotGroup=data;
			}
		}
		})
		 //this.curSlots=data;
		//this.rangeSlot=data;
		this.rangeIndex=0;
		//this.definedSlotGroup=data;
		this.slotGroup='D';
	}else if(this.tempSlots&&this.tempSlots.length>0){
		this.curSlots=[];
		this.rangeSlot=this.tempSlots;
		this.rangeIndex=1;
		this.slotGroup='T';
	}else{
		this.curSlots=[];
		this.rangeSlot=this.slots;
		this.rangeIndex=2;
		this.slotGroup='A';
		this.groupSlots.forEach(data =>{
			this.expandedRows[data.CATEGORY] = true;
		})
		this.isExpanded=true
	}
	this.addLib=true;
	if(type){
		return
	}
	$('.nav-tabs a[href="#slot"]').tab('show');
	
	//$('#addSlotModal').modal('show');
  }
  getSlotRange(index){////console.log(index)
	  
	  this.rangeIndex=index;
	  if(index==0){
		this.rangeSlot=this.curSlots;
	  }else if(index==1){
		 this.rangeSlot=this.tempSlots;
	  }else if(index==2){
		this.rangeSlot=this.slots;
	  }
	  ////console.log(this.rangeSlot);
	   
  }
	getLibRange(index){
	  this.rangeIndex=index;
	  if(index==0){
		this.rangeLib=this.curLibs;
	  }else if(index==1){
		 this.rangeLib=this.libraries;
	  }
	  ////console.log(this.rangeSlot);
	   
  }
  /*addChoice(data, e){//console.log(data)
	let ele=$(e.target).siblings('input:checked'); //console.log(ele);
	let content='';
	for(let item of ele){//console.log(parseInt(item.defaultValue));
		let options=data[parseInt(item.defaultValue)];
		let text=data[parseInt(item.defaultValue)].CONTENT;
		if(text){
			if(text.length>0){
			if(data[0].LIBRARY_ID>-1){
				content+='<span>'+text+'</span><br>';
			}else{
				content+='<span>'+text+'</span>'+', ';
			}
			}
		}else{
			content+='<span>'+options+'</span>'+', ';
		}
	}
	if(data[0].SLOT_ID>-1){
		content=content.slice(1).trim();
	}
	//console.log(content);
	this.toContentData('addedItem', content, "");
	this.autoSave();
  }*/
  selSlotGroup(type){
	  if(this.slotGroup==type){
		 this.slotGroup='';
	  }else{
		 this.slotGroup=type;
	  }
  }
  selLibGroup(type){
	  if(this.libGroup==type){
		 this.libGroup='';
	  }else{
		 this.libGroup=type;
		 if(type=='A'&&this.libraries.length==0){
			this.refreshLibs()
		}
	  }
  }
  appSetting(e){
	}
 /* appsave(e, op?, index?, index2?){//console.log(index);
		this.loading=true;
		
	  if(this.appOp=='U'){
		let ele=$(e.target).siblings('input[type="file"]').files;
		let that=this;
		let file:any
		
			file = $(e.target).siblings('input[type="file"]')[0].files[0];//console.log(file)
			$(e.target).siblings('input[type="file"]').val(null);
			const ext = file.name.replace(/.+\./, '');
		if (['pdf','Pdf', 'PDF'].indexOf(ext) === -1) {
			Swal.fire('Oops...', 'Only support .PDF', 'error');
			this.loading=false;
			return;
		}
		let reader = new FileReader();
        reader.onloadend = function(e) {
			let filedata = e.target.result.toString().split(',')[1];//
			let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata};
				//console.log(inputJson);
			that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
				//console.log(result);
				let url=result.FILE_URL;
					let name=result.FILE_NAME;
					let info={"url":url,"name":name};
					//that.toContentData('app', info, '');
					//that.appendices.SUB_SECTIONS[index].app=info;
					that.appendices.SUB_SECTIONS[index].app[index2]=info;
					
					op.hide();
				that.loading=false;
			})
		}
		reader.readAsDataURL(file);
	 }else if(this.appOp=='O'){
		let ele=$(e.target).siblings('select').val() ; //console.log(ele)
		let info={'url':this.pdfs[parseInt(ele)].REPORT_URL, "name":this.pdfs[parseInt(ele)].REPORT_NAME};
		//this.toContentData('app', info, '');
		//this.appendices.SUB_SECTIONS[index].app=info;
		this.appendices.SUB_SECTIONS[index].app[index2]=info;
		this.loading=false;
		if(op){
			op.hide();
		}
	 }else if(this.appOp=='D'){
		 let ele=$(e.target).siblings('textarea').val() ; //console.log(ele)
		 let info={"text":"No Data Available", 'desc':ele};
		 //this.toContentData('app', info, '');
		 //this.appendices.SUB_SECTIONS[index].app=info;
		 this.appendices.SUB_SECTIONS[index].app[index2]=info;
		 this.loading=false;
		 if(op){
		 op.hide();
		 }
	 }else{
		 this.loading=false;
	 }
	this.autoSave();
  }*/
	/*getOrderPdf(e){
		let no=$(e.target).siblings('input[type="text"]').val().trim();//console.log(this.curReport);
		let inputJson={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":no};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
				//console.log(result);
				this.pdfs=result.REPORT_LINKS;
				this.updatePdfs();
				
				let inputJson1={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"ORDER_NUM":no};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response=>{
					//console.log(response);
				})
		})
		let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":no};//console.log(inputJson6);
						this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
							//console.log(result);
							this.erisPdfs=result.PRODUCT_LINKS;
						})
	}*/
	getTable(type, data){//console.log(type); //console.log(data);
		this.tableContent=[];
		this.tableContent1=[];
		if(type=='Table'){
			this.tableContent=JSON.parse(data.CONTENT).HEADERS;
		}else if(type=='Selection'){
			this.tableContent1=data.CONTENT.split(', ');
			this.tableContent=data.SELECTION_CHOICES.split(';;');
		}
		//console.log(this.tableContent);
		//console.log(this.tableContent1);
	}
	addOpItem(e){
		if(this.newSlotOp.length>0){
			this.newSlotOps.push(this.newSlotOp)
			this.newSlotOp='';
			//$('.slotBtn')[1].classList.add("disabled");
		}
	}
	
	clearOpItem(){
		this.newSlotOps=[];
		$('.slotBtn').each(function(){
			if($(this).hasClass('disabled')){
				$(this).removeClass('disabled');
			}
		})
	}
	setTableSrc(type){
		this.slotTableType=type;
		this.curTableData={'cols':[],'rows':[]};
		if(type==0){			
			for(let i=0; i<this.colNo; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':5, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
				item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				item['text']=item.NAME;
				this.curTableData.cols.push(item)
			}
			this.curTableData.slotName=null;
			this.curTableData.erisName=null;
		}else if(type==2){			
			this.curTableData.SLOT_ID=null;
			this.curTableData.slotName='';
		}else{
			this.curTableData.SLOT_ID=null;
			this.curTableData.erisName='';
		}
	}
	getTables(type){
		this.erisSlots=[];
		this.tableSlots=[];
		let inputJson:any;
		if(type=='eris'){
			inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":"Table", "ERIS_TABLE":"Y"};
		}else{
			inputJson={"PROCEDURE":"getslotsbytype", "USER_ID":parseInt(this.userId), "SLOT_TYPE":"Table", "ERIS_TABLE":"N"};
		}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)											
			}else{
			if(type=='eris'){
				this.erisSlots=data.RW_SLOTS;
			}else{
				this.tableSlots=data.RW_SLOTS;
			}
		}
		})
	}
	/*getSlotTable(e){
		let index=$(e.target).val();//console.log(index);
			if(index>-1){
				this.curTableData.cols=JSON.parse(this.tableSlots[parseInt(index)].CONTENT).HEADERS; //console.log(this.curTableData.cols);
				this.curTableData.SLOT_ID=this.tableSlots[parseInt(index)].SLOT_ID;
				this.curTableData.slotName=this.tableSlots[parseInt(index)].KEY;
				this.curTableData.rows=[];
				this.colNo=this.curTableData.cols.length;
				if(this.isEven){
					let width=Math.floor(100/this.colNo);
					for(let i=0; i<this.colNo; i++){
						this.curTableData.cols[i].width=width;
						this.curTableData.cols[i].unit='%';
					}
				}
			}else{
				this.curTableData={'cols':[],'rows':[]}; //console.log(this.curTableData.cols);
				this.curTableData.SLOT_ID=null;
				this.curTableData.slotName='';
				this.colNo=0;
				this.curTableData.rows=[];
			}
		
	
	}*/
	getErisTable(e){//console.log(this.erisSlots);
		let index=$(e.target).val();//console.log(index);
		if(index>-1){
			console.log(JSON.parse(this.erisSlots[parseInt(index)].CONTENT).HEADERS)
			this.curTableData.cols=JSON.parse(this.erisSlots[parseInt(index)].CONTENT).HEADERS; //console.log(this.curTableData.cols);
			this.curTableData.SLOT_ID=this.erisSlots[parseInt(index)].SLOT_ID;
			this.curTableData.erisName=this.erisSlots[parseInt(index)].KEY;
			/*this.colNo=this.curTableData.cols.length;
			if(this.isEven){
				//let width=Math.floor(100/this.colNo);
				let width=Math.floor((96/this.colNo)*100)/100;//console.log(width);
				for(let i=0; i<this.colNo; i++){
					this.curTableData.cols[i].width=width;
					this.curTableData.cols[i].unit='%';
				}
			}*/
			let id=this.getContentData('id');
			let inputJson={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":this.curTableData.SLOT_ID.toString(),"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':id,'SHOW_HIDDEN_RECORD':'N',};
						console.log(inputJson);
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
						console.log(response);
						if (response.RESPONSE_STATUS=='N') {
							this.throwError(response)											
						}else{
						if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
						let info=JSON.parse(response.RW_SLOTS[0].CONTENT); console.log(info);
						let arr=[];
						if(info.headers){
							this.curTableData.cols=JSON.parse(JSON.stringify(info.headers));console.log(this.curTableData.cols)
						}
						
						this.colNo=this.curTableData.cols.length;
						if(this.isEven){
							//let width=Math.floor(100/this.colNo);
							let width=Math.floor((96/(this.colNo-1))*100)/100;//console.log(width);
							for(let i=0; i<this.colNo; i++){
								if(i>0){
									this.curTableData.cols[i].width=width;
								}else{
									this.curTableData.cols[i].width=0;
								}
								
								this.curTableData.cols[i].unit='%';
							}
						}
						for(let col of this.curTableData.cols){
							if(col.INTERNALNAME=='ES_RID'){
								col['hide']=true;
							}
							col['colAlign']='Center';
							col['celAllign']='Left';
						}
						if(info.rows&&info.rows.length>0){
							/*if(this.curTableData.cols[0].INTERNALNAME=="ES_RID"){
								this.curTableData.cols[0]['hide']=true;
							}else{
								let firstCol={'INTERNALNAME': "ES_RID",'NAME': "ID",'TYPE': "text",'unit': "%",'width': 0, 'hide':true};
								this.curTableData.cols.unshift(firstCol);
							}*/
						//let firstCol={'INTERNALNAME': "ES_RID",'NAME': "ID",'TYPE': "text",'unit': "%",'width': 0, 'hide':true};
						//this.curTableData.cols.unshift(firstCol);
						
						for(let row of info.rows){
							let arr1=[];
							for(let col of this.curTableData.cols){
								let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
								if(col.INTERNALNAME=='ES_RID'){
									row[index]['hide']=true;
								}
								arr1.push(row[index]);
							}
							arr.push(arr1);
						}
						//console.log(arr);
						}
						this.curTableData.rows=arr; //console.log(this.curTableData.rows)
						if(info.filters&&info.filters.length>0){							
							this.curTableData['filters']=info.filters;
						}
						if(info.parent_table){
							this.curTableData['parent_table']=info.parent_table;
						}else{
							this.curTableData['parent_table']=info.PARENT_TABLE;
						}
						}else{
							Swal.fire({
								icon:'warning',
								title: 'No Data',
							})
							this.curTableData.rows=[];
							}
						}	
					})
				//console.log(this.curTableData.erisName);
		}else{
			this.curTableData={'cols':[],'rows':[]}; //console.log(this.curTableData.cols);
			this.curTableData.SLOT_ID=null;
			this.curTableData.erisName='';
			this.colNo=0;
		}
	}
	async slotTableGetData(type?){//console.log(this.contents)
		if(this.contents){
			for(let item1 of this.contents){
				for(let item2 of item1.SUB_SECTIONS){
					if (item2.TYPE=='TABLE'&&item2.data&&item2.data.SLOT_ID&&item2.data.SLOT_ID>-1&&item2.data.erisName){////console.log(item2);
						if(!item2.data.disableCopiedEris){
							let id2=item2.data.SLOT_ID;
							let inputJson2={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":id2.toString(),"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':item2.id, 'SHOW_HIDDEN_RECORD':'N',};
							//console.log(inputJson2);
							const response =  await this.reportService.univeralService(JSON.stringify(inputJson2)).toPromise() //subscribe(response => {
							//console.log('tableslot',response);
							//item2.data.rows=[];
							if (response.RESPONSE_STATUS=='N') {
								this.throwError(response)											
							}else{
								let data=[];
								if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
									let info=JSON.parse(response.RW_SLOTS[0].CONTENT);//console.log(info);
									data=info.rows; //console.log(JSON.stringify(data));
									//item2.data.cols=JSON.parse(response.RW_SLOTS[0].CONTENT).headers;							
									let arr=[];							
									if(data&&data.length>0){
										for(let row of data){
											let arr1=[];
											for(let col of item2.data.cols){
												let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
												if(col.INTERNALNAME=="ES_RID"){
													row[index]['hide']=true;
												}
												arr1.push(row[index]);											
											}
											arr.push(arr1);
										}
									}
									////console.log(arr);
									item2.data.rows=arr;//.push(data.slice(0, 11));
									item2.data['parent_table']=info.parent_table;
									if(info.filters&&info.filters.length>0){
										item2.data['filters']=info.filters;
									}
								}
							}
						
						}else{
							console.log('copied eris table, skip update')
						}
					}
						if(item2.SUB_SECTIONS&&item2.SUB_SECTIONS.length>0){
							for(let item3 of item2.SUB_SECTIONS){
								if (item3.TYPE=='TABLE'&&item3.data&&item3.data.SLOT_ID&&item3.data.SLOT_ID>-1&&item3.data.erisName){////console.log(item3);
									if(!item3.data.disableCopiedEris){
										let id3=item3.data.SLOT_ID;
										let inputJson3={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":id3.toString(),"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':item3.id,'SHOW_HIDDEN_RECORD':'N',};
											//console.log(inputJson3);
										let response = await this.reportService.univeralService(JSON.stringify(inputJson3)).toPromise();//subscribe(response => {
											console.log('tableslot',response);
										if (response.RESPONSE_STATUS=='N') {
											this.throwError(response)											
										}else{
											let data=[];
											if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
												let info=JSON.parse(response.RW_SLOTS[0].CONTENT);//console.log(info)
												data=info.rows; ////console.log(data);
												//item3.data.cols=JSON.parse(response.RW_SLOTS[0].CONTENT).headers;
												let arr=[];
												if(data&&data.length>0){	
													for(let row of data){
														let arr1=[];
														for(let col of item3.data.cols){////console.log(col)
															let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
															if(col.INTERNALNAME=="ES_RID"){
																row[index]['hide']=true;
															}
															arr1.push(row[index]);
														}
														arr.push(arr1);
													}
												}
												item3.data.rows=arr;
												item3.data['parent_table']=info.parent_table;
												if(info.filters&&info.filters.length>0){
													item3.data['filters']=info.filters;
												}
											}
										}

									}else{
										console.log('copied eris table, skip update')
									}
								}
						
							}
						}
					
				}
			}
			this.removeErisUpdateStatus();
			let that=this;
			if(!type||type!='edit'){
				this.zone.run(()=>{
					setTimeout(function(){ 		
						that.autoSave('ERIS Data Update','eris','ERIS Data Update');
						//console.log('loaded');
					}, 5000);
				})
			}
		}
	}
	removeErisUpdateStatus(){
		let that=this;
		if(this.erisUpdated){
			let inputJson={"PROCEDURE":"seterisupdate","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"ERIS_UPDATE":"N"};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
				//console.log(response);
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)											
				}else{
				if(response.ERIS_UPDATE=="N"){
					this.erisUpdated=false;
				}else if(response.ERIS_UPDATE=="Y"){
					this.erisUpdated=true;
				}
			}
				
			})
		}
	}
	addOrder(e){
		if (this.blockMultiUser()) return;
		let no=$(e.target).siblings('input[type="text"]').val().trim();
		if(no.length>0){
			let inputJson1={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"ORDER_NUM":no};
			this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response=>{console.log(response);
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)
					this.editOrder=false;
					return											
				}else{
				//console.log(response);
				if(response.ORDER_NUM==''){
					Swal.fire({
						icon:'warning',
						title: 'No such order number',
					})
					return;
				}
				
				let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM}
				//console.log(JSON.stringify(inputJson2));
				 this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(appresult=>{
					//console.log(result);
					if (appresult.RESPONSE_STATUS=='N') {
						this.throwError(appresult)											
					}else{
						this.pdfs=appresult.REPORT_LINKS;
						if(this.reportInfo.COPIED_REPORT =='Y'&&!this.reportInfo.ORDER_NUM){
							this.addCopiedErisPdfs();
						}else{
							this.updatePdfs();
						}				
					}
					this.reportInfo.ORDER_NUM=response.ORDER_NUM;
				})
				this.erisUpdated=true;
				this.slotTableGetData();
				
				this.editOrder=false;
				let inputJson3={"PROCEDURE":"getErisTextSlotByReport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
				this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(slotResult=>{
					//console.log(slotResult);
					if (slotResult.RESPONSE_STATUS=='N') {
						this.throwError(slotResult)
																			
					}else{
							let updatedSlots=slotResult.RW_SLOTS;
							for(let slot of updatedSlots){
								this.setLocalSlot(slot, 'local')
							}
							
						}
					})
				
				//})	
				let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":no};//console.log(inputJson6);
					this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
						//console.log(result);
						if (result.RESPONSE_STATUS=='N') {
							this.throwError(result)											
						}else{
						this.erisPdfs=result.PRODUCT_LINKS;
					}
				});
			}
				//this.zone.run(()=>{this.autoSave('ERIS Data Update','eris','ERIS Data Update');})
			});
			
		}
	}
	updateOrder(e) {
		if (this.blockMultiUser()) return;
		this.op120.toggle(e);
		this.loading=false;
		this.appSetting(e);
	}
	setCol(){
		if(this.colNo>0){
			//let width=Math.floor(95/this.colNo);
			let width=Math.floor((96/this.colNo)*100)/100;//console.log(width);
			this.curTableData.cols=[];
			for(let i=0; i<this.colNo; i++){
				let item:any
				if(this.isEven){
					item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':width, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
					item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
					item['text']=item.NAME;
				}else{
					item={'INTERNALNAME':'col'+i,'NAME':'Header'+i,'TYPE':'text', 'width':'', 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left',};
					item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
					item['text']=item.NAME;
				}
				this.curTableData.cols.push(item)
			}
			let last=(95-width*(this.colNo-1)); //console.log(last);
		}
	}
	updateSlotContent(e, data){//console.log($(e.target).prev(), $(e.target).siblings());
		if (this.blockMultiUser()) return; 
		let id=data.SLOT_ID;
		let content="";
		if(data.TYPE=='Selection'){
			content=this.tableContent1.join(', ');
		}else{
		  content=$(e.target).siblings('textarea').val().trim(); //console.log(content);
		}
		this.updateSlot(id, content, 'local');
		
	}
	async updateSlot(id, content, type?){//console.log(id, content, type)
		let inputJson={"PROCEDURE":"updateslotcontent","USER_ID":parseInt(this.userId),"SLOT_ID":id,"SLOT_CONTENT":content,'REPORT_ID':parseInt(this.reportInfo.REPORT_ID)};
		//await  this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			let response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();//subscribe(response => {
				//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
			this.setLocalSlot(response, type);
			}			
		//})
	}
	setLocalSlot(response, type?){
		//console.log(response, type);
		let index1=this.definedSlotGroup.findIndex(item=>item.SLOT_ID==response.SLOT_ID);//console.log(index1)
			if(index1>-1){
				this.definedSlotGroup[index1].CONTENT=response.CONTENT;
				this.definedSlotGroup[index1].SHORT_CONTENT=response.SHORT_CONTENT;
				if(response.SELECTION_CHOICES.length>0){
					this.definedSlotGroup[index1].SELECTION_CHOICES=response.SELECTION_CHOICES;
					this.definedSlotGroup[index1].MULTIPLE_CHOICE=response.MULTIPLE_CHOICE;
				}
			}
			let index2=this.tempSlots.findIndex(item=>item.SLOT_ID==response.SLOT_ID);//console.log(index2)
			if(index2>-1){
				this.tempSlots[index2].CONTENT=response.CONTENT;
				this.tempSlots[index2].SHORT_CONTENT=response.SHORT_CONTENT;
				if(response.SELECTION_CHOICES.length>0){
					this.tempSlots[index2].SELECTION_CHOICES=response.SELECTION_CHOICES;
					this.tempSlots[index2].MULTIPLE_CHOICE=response.MULTIPLE_CHOICE
				}
			}
			let index3=this.groupSlots.findIndex(item=>item.CATEGORY==response.CATEGORY);//console.log(index3)
			if(index3>-1){
				let cat=this.groupSlots[index3].RW_SLOTS;//console.log(cat);
				if(cat.length>0){
				let index4=cat.findIndex(item=>item.SLOT_ID==response.SLOT_ID);//console.log(index4);
				if(index4>-1){
					this.groupSlots[index3].RW_SLOTS[index4].CONTENT=response.CONTENT;
					this.groupSlots[index3].RW_SLOTS[index4].SHORT_CONTENT=response.SHORT_CONTENT;
					if(response.SELECTION_CHOICES.length>0){
					this.groupSlots[index3].RW_SLOTS[index4].SELECTION_CHOICES=response.SELECTION_CHOICES
					this.groupSlots[index3].RW_SLOTS[index4].MULTIPLE_CHOICE=response.MULTIPLE_CHOICE
				}
				}
				}
			
			}
			let index4=this.allSlots.findIndex(item=>item.SLOT_ID==response.SLOT_ID);//console.log(index4);
			if(index4>-1){
				this.allSlots[index4].CONTENT=response.CONTENT;
				this.allSlots[index4].SHORT_CONTENT=response.SHORT_CONTENT;
				if(response.SELECTION_CHOICES.length>0){
					this.allSlots[index4].SELECTION_CHOICES=response.SELECTION_CHOICES;
					this.allSlots[index4].MULTIPLE_CHOICE=response.MULTIPLE_CHOICE;
				}
			}
			if(type&&type=='local'){
				//this.replaceSlot(response, 'local');
				this.newreplaceContent(response, 'local');
			}else if(type&&type=='edit'){
				this.newreplaceContent(response, 'edit');
				//this.replaceSlot(response, 'edit');
			}
		
	}
	selUp(index){//console.log(index);
		//this.newSlotOps
		moveItemInArray(this.newSlotOps, index-1, index);
			//this.array_move(this.newSlotOps,index-1, index )
		
	}
	selDown(index){//console.log(index);
		moveItemInArray(this.newSlotOps, index+1, index);
			//this.array_move(this.newSlotOps,index+1, index )
		
	}
	selRemove(index){//console.log(index);
	let that=this;
			Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
		that.newSlotOps.splice(index, 1);
		}
			})
	}
	addPdfs(e,i,pdf){//console.log(pdf);
	//console.log(i);
	//console.log(this.appendices)
		//let info={'CATEGORY': "ERIS Data",'CONTENT': "",'KEY': "",'LABEL': "",'SHORT_CONTENT': "",'TYPE': "PDF"}; //console.log(info)
		let ifCheck=$(e.target).prop('checked');
		let info={"url":'',"name":'', 'type':'', 'selectedfile':false, 'selected':true};
		let noItem:any;
		/*if(!pdf){//console.log(info);//console.log(i)
			if(!this.appendices.SUB_SECTIONS[i].app){
				this.appendices.SUB_SECTIONS[i].app=[]
			}
			let noData={"text":"No Data Available", 'desc':''};
			this.appendices.SUB_SECTIONS[i].app.push(noData);
			return
			
		}*/
		if(pdf&&pdf.REPORT_URL&&pdf.REPORT_URL.length>=0){
			info={"url":pdf.REPORT_URL,"name":pdf.REPORT_NAME,'selected':true, 'type':pdf.FILE_EXTENSION, 'selectedfile':false};
			info['ERIS_FILE']=pdf['ERIS_FILE'];
		}else if(pdf&&pdf.FILE_URL&&pdf.FILE_URL.length>=0){
			info={"url":pdf.FILE_URL,"name":pdf.FILE_NAME,'selected':true, 'type':pdf.FILE_EXTENSION, 'selectedfile':false};
		}else if(pdf&&pdf.PHOTOLOG_URL&&pdf.PHOTOLOG_URL.length>=0){
			info={"url":pdf.PHOTOLOG_URL,"name":'Photo log','selected':true,'type':'PDF', 'selectedfile':false};
		}else if(pdf&&pdf.MAP_REPORT_URL&&pdf.MAP_REPORT_URL.length>=0){
			info={"url":pdf.MAP_REPORT_URL,"name":pdf.MAP_REPORT_TITLE,'selected':true, 'type':pdf.FILE_EXTENSION, 'selectedfile':false};
			info['MAP_REPORT_ID']=pdf['MAP_REPORT_ID'];
		}
		if(!pdf.FILE_EXTENSION||(pdf.FILE_EXTENSION&&pdf.FILE_EXTENSION.toUpperCase()=='PDF')){
			info.selectedfile=true;
		}
		//if(ifCheck||(pdf&&pdf.PHOTOLOG_URL)){
		if(pdf){
		if(ifCheck){
			if(this.appendices.SUB_SECTIONS[i].app){
				this.appendices.SUB_SECTIONS[i].app.push(info);
			}else{
				this.appendices.SUB_SECTIONS[i].app=[];
				this.appendices.SUB_SECTIONS[i].app.push(info);
			}
		}else{
			let index=this.appendices.SUB_SECTIONS[i].app.findIndex(item=>item.url==info.url||!item.COPIED);
			if(index>-1){
				this.appendices.SUB_SECTIONS[i].app.splice(index,1);
			}
		}
		}
		this.checkNoData(this.appendices.SUB_SECTIONS[i]);
		/*if(this.appendices.SUB_SECTIONS[i].app.length>0){
			let nodata=true;
			for(let sec of this.appendices.SUB_SECTIONS[i].app){
				if(sec.selectedfile&&sec.url.length>0){
					nodata=false;
					break
				}
				
			}
			if(nodata){
				this.appendices.SUB_SECTIONS[i].SECTION_TITLE+=' - No Data Available'
			}
		}*/
		//console.log(this.appendices.SUB_SECTIONS[i]);
		this.autoSave('appendix update',info.name,"appendix update");
	}
	checkNoData(secs){
		if(secs.app&&secs.app.length>0){
			secs['nodata']=true;
			for(let sec of secs.app){
				if(sec.selectedfile&&((sec.url&&sec.url.length>0)||(sec['RESUME_URL']&&sec['RESUME_URL'].length>0))){
					secs['nodata']=false;
					break
				}				
			}
		}else{
			secs['nodata']=true;
		}
	}
	/*addPdf(i, j, file){//console.log(file)
		let info={"url":'',"name":'', 'type':'', 'selectedfile':false};
		if(file.REPORT_URL){
			info={"url":file.REPORT_URL,"name":file.REPORT_NAME, 'type':file.FILE_EXTENSION, 'selectedfile':false};
			//info['tag']='ERIS';
		}else if(file.FILE_URL){
			info={"url":file.FILE_URL,"name":file.FILE_NAME, 'type':file.FILE_EXTENSION, 'selectedfile':false};
		}else if(file.PHOTOLOG_URL){
			info={"url":file.PHOTOLOG_URL,"name":'Photo log','type':'PDF', 'selectedfile':true};
		}
		if(!file.FILE_EXTENSION||file.FILE_EXTENSION.toUpperCase()=='PDF'){
			info.selectedfile=true;
		}
		this.appendices.SUB_SECTIONS[i].app[j]=info;
		this.autoSave('appendix update',"appendix","appendix update");
	}*/
	removePdf(i, j){
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				this.appendices.SUB_SECTIONS[i].app.splice(j, 1);
				this.checkNoData(this.appendices.SUB_SECTIONS[i]);//console.log(this.appendices.SUB_SECTIONS[i]);
				this.autoSave('appendix update',"appendix update","appendix update");
			}
		})
	}
	rComplete(doc?){//console.log(doc)
		if(doc.id!=this.onlock){
			return
		}
		if(doc.rcompleted==true){
			doc.rcompleted=false;
			this.toContentData('rcompleted', false, '');//console.log(doc)
		}else{
			doc.rcompleted=true
			this.toContentData('rcompleted', true, '');//console.log(doc)
		}
		let that=this;
		setTimeout(function(){ 		
			let data=that.getPercentage('rcompleted');
			if(data!=that.rPercentage){
				that.rPercentage=data;
				that.autoSave('modify', doc.id, doc.SECTION_TITLE, 'O', doc, 'Review Complete','REVIEWER_PROGRESS', that.rPercentage);
			}
		}, 500);
	}
	wComplete(doc?){//console.log(doc)
		if(doc.id!=this.onlock){
			return
		}
		if(doc.wcompleted==true){
			doc.wcompleted=false;
			this.toContentData('wcompleted', false, '');//console.log(doc)
		}else{
			doc.wcompleted=true
			this.toContentData('wcompleted', true, '');//console.log(doc)
		}
		let that=this;
		setTimeout(function(){ 
		let data=that.getPercentage('wcompleted');
		if(data!=that.wPercentage){
			that.wPercentage=data;
			that.autoSave('modify', doc.id, doc.SECTION_TITLE, 'O', doc, 'Writer Complete',"PERCENT_COMPLETE", that.wPercentage);
		}
		}, 500);
		
	}
	getPercentage(field){
		let percentage=0;
		let total=0;
		let checked=0;
		for(let sec of this.contents){
			total++;
			if(sec[field]){
				checked++;
			}
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					total++;
					if(sec1[field]){
						checked++;
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							total++;
							if(sec2[field]){
								checked++;
							}
						}
					}
				}
			}
		}
		percentage=Math.floor((checked/total)*1000)/10; //console.log('percentage',total, checked, percentage);
		return percentage
	}
	exportExcel(tableData){console.log(tableData);
		let rows=[];
		let cols=[];
		let title=tableData.SECTION_SEQUENCE+" "+tableData.SECTION_TITLE
			
		if(tableData.TYPE=="COSTTABLE"||tableData.TYPE=="PCATABLE"||tableData.TYPE=="UNITTABLE"){
			let rowsdata=JSON.parse(JSON.stringify(tableData.data.rows));
			if(tableData.TYPE=="COSTTABLE"){
				rowsdata.shift();
			}
			//cols=tableData.data.cols;DATA
			cols = tableData.data.cols.map(obj=>obj.NAME);
			console.log(cols)
			for(let row of rowsdata){
				let items=[];
				for(let i=0; i<row.length; i++){
					let item={};
					let key=tableData.data.cols[i].NAME;
					item[key]=row[i].DATA;
					
					/*let item={'COLUMNINTERNALNAME':'','DATA':''};
					item.COLUMNINTERNALNAME=row.items[i].COLUMNINTERNALNAME;
					item.DATA=row.items[i].data;*/
					items.push(item);
				}
				rows.push(items);
			}
			
		}else if(tableData.TYPE=="TABLE"){
			if(tableData.data.erisName){
				//rows=tableData.data.rows;
				//cols=tableData.data.cols;
				cols = tableData.data.cols.map(obj=>obj.NAME);console.log(cols)
				cols.shift();
			console.log(cols)
				for(let row of tableData.data.rows){
					let items=[];
					for(let i=1; i<row.length; i++){
						let item={};
						let key=tableData.data.cols[i].NAME;
						item[key]=row[i].DATA;
						/*let item={'COLUMNINTERNALNAME':'','DATA':''};
						item.COLUMNINTERNALNAME=row.items[i].COLUMNINTERNALNAME;
						item.DATA=row.items[i].data;*/
						items.push(item);
					}
					rows.push(items);
				}
			}else{
				/*for(let col of tableData.data.cols){
					let item={'INTERNALNAME':'','NAME':''};
					item.INTERNALNAME=col.INTERNALNAME;
					item.NAME=col.text;
					cols.push(item);
				}*/
				//cols = tableData.data.cols.map(obj=>obj.text);console.log(cols)

				for(let col of tableData.data.cols){
					if(col.text&&col.text.length>0){
						cols.push(col.text)
					}else{
						cols.push(col.NAME.replace(/<(?:.|\n)*?>/gm, ' ').replace(/ +(?= )/g,'').replace(/&nbsp;/gi," ").replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\n\n"));
					}
					
				}
				for(let row of tableData.data.rows){
					let items=[];
					for(let i=0; i<row.items.length; i++){
						let item={};
						let key=cols[i];//tableData.data.cols[i].text;
						if(row.items[i].data&&row.items[i].data.length>0){
							item[key]=row.items[i].data;
						}else{
							if(row.items[i].htmltext){//replace(/<\/?[^>]+(>|$)/g, "");
								let plain=row.items[i].htmltext.replace(/<(?:.|\n)*?>/gm, ' ').replace(/ +(?= )/g,'').replace(/&nbsp;/gi," ").replace(/(?:(?:\r\n|\r|\n)\s*){2,}/gim, "\n\n");
								item[key]=plain;
							}else{
								item[key]='';
							}
							
						}
						
						/*let item={'COLUMNINTERNALNAME':'','DATA':''};
						item.COLUMNINTERNALNAME=row.items[i].COLUMNINTERNALNAME;
						item.DATA=row.items[i].data;*/
						items.push(item);
					}
					rows.push(items);
				}
			}
		}
		//console.log(rows);DATA
		if(rows.length==0){
			Swal.fire({
					icon: 'info',
					title: "Table has no row data!"
				})
			return
		}
		//let data={'headers':cols, 'rows':rows, 'tablename':tableData.SECTION_TITLE};console.log(data);
		let data= {'cols':cols,'rows':rows};console.log(data);
		/*let inputJson={"user_id":this.userId,"company_id":this.userInfo.COMPANY_ID.toString(),"filetitle":tableData.SECTION_TITLE,"exceljson":JSON.stringify(data)};
		//console.log(JSON.stringify(inputJson));
		this.reportService.exportExcel(inputJson).subscribe(response => {
			//console.log(response);
			if(response.status=='Y'){
				window.open(response.fileurl, '_blank');
			}else{
				Swal.fire({
					html: ' <span style="color:red; text-align:left">'+response.emessage+'</span>'							
				})
			}
		})*/
		let outRows=[];
					for(let row of data.rows){
						let multi={};
						for(let obj of row){
							multi= Object.assign({}, multi, obj)
						}
						outRows.push(multi)
					}
		this.exportAsExcelFile(outRows, title, cols);
	}
	tableToSlot(e,tableData, op){//console.log(tableData)
		let label=$(e.target).prev('div').prev('div').children('input').val();//console.log(label);
		let type='N';
		if(label.trim().length>0&&this.newSlotCat.length>0){
			let category=this.newSlotCat;//$(e.target).prev('div').children('select').val();//console.log(category);
			let headers=[];
			let Toast=Swal.mixin({
					toast: true,						
						position: 'center',
						showConfirmButton: false,
						timer: 3000
					})
			if(tableData.data){
			for(let col of tableData.data.cols){
				let item={'INTERNALNAME': col.INTERNALNAME.toUpperCase(),'NAME': col.NAME,'TYPE': col.TYPE};
				headers.push(item);
			}
			let content={"HEADERS":headers}; //console.log(content);
			if(tableData.data.erisName&&tableData.data.erisName.length>0){
				content['PARENT_TABLE']=tableData.data['parent_table'];
				category='ERIS Data';
				type='Y';
			}
			/*if(tableData.data['filters']&&tableData.data['filters'].length>0){
				content['FILTERS']=tableData.data['filters'];
			}*/
			let id=null;
			let slotContent=JSON.stringify(content);
			if(this.reportInfo.TEMPLATE[0].TEMPLATE_ID){
				id=this.reportInfo.TEMPLATE[0].TEMPLATE_ID.TEMPLATE_ID;
			}
			//console.log(slotContent);
			let inputJson={"PROCEDURE":"insertslot", "USER_ID":parseInt(this.userId), "KEY":label, "TYPE":'Table', "CONTENT":slotContent,"CATEGORY":category,"ERIS_TABLE":type};
			//console.log(inputJson);
			this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
				//console.log(response);//{"PROCEDURE":"insertslot","USER_ID":213223,"TEMPLATE_ID":null,"KEY":"test","TYPE":"Text","CONTENT":"fgdhdjj","CATEGORY":"Company Information","SLOT_ID":226}
				
				let info=JSON.parse(response);
				if(info.RESPONSE_STATUS=='Y'){
					
				
				//this.selectedSlot=JSON.parse(data);
			let item={'CATEGORY': info.CATEGORY,
					'CONTENT': info.CONTENT,
					'KEY': info.KEY,
					'SLOT_ID': info.SLOT_ID,
					'TYPE': info.TYPE,
					"TEMPLATE_ID":info.TEMPLATE_ID,
			}
			let index=this.groupSlots.findIndex(slot=>slot.CATEGORY==info.CATEGORY);
			if(index>-1){
				this.groupSlots[index].RW_SLOTS.push(item);
				//this.groupSlots[index].TOTAL_SLOTS+=1;
				//this.groupSlots[index].TOTAL_TEMPLATE_SLOTS+=1;
			}else{
				this.groupSlots.push({'CATEGORY':info.CATEGORY,'RW_SLOTS':[item],'TOTAL_SLOTS': 1,'TOTAL_TEMPLATE_SLOTS': 1});
			}
			Toast.fire({
					icon: 'success',
					title: 'saved'
				})
				op.hide();
			}else{
					this.throwError(info)
				}
		})
			}else{
				Toast.fire({
					icon: 'error',
					title: 'Table has no data!'
				})
			}
		}
	}
	deleteFile(item, type){
		//console.log(item)
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson={"PROCEDURE":"deleteuploadfilev2","USER_ID":parseInt(that.userId),"FILE_ID":item.FILE_ID};
				this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
					//console.log(JSON.parse(response))
					if(JSON.parse(response).RESPONSE_STATUS=="Y"){
						let data=[];
						if(type=="FILE"){
							data=that.projectFiles
						}else if(type=="PHOTO"){
							data=that.photos
						}else if(type=="IMAGE"){
							data=that.others
						}else if(type=="BKIMAGE"){
							data=that.bks
						}else if(type=="LOGO"){
							data=that.logos
						}
						let index=data.findIndex(file=>file.FILE_ID==item.FILE_ID); //console.log(index);
						if(index>-1){
							data.splice(index,1);
							Swal.fire({
								icon:'success',
								title: JSON.parse(response).MESSAGE,
							})
						}
					}else{
						this.throwError(JSON.parse(response));
				
				}
				})
			}
		})
	}
	updateFile(item, type, e? ){
		let data=$('#imagelabbel').val();
		let inputJson={"PROCEDURE":"updateuploadfilev2","USER_ID":parseInt(this.userId),"FILE_ID":item.FILE_ID,"FILE_NAME":item.FILE_NAME,"FILE_DESCRIPTION":data};
		
		this.reportService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
			
			let file=JSON.parse(response);
			if (file.RESPONSE_STATUS=='N') {
				this.throwError(file)											
			}else{
			if(type=='PHOTO'){
				let index=this.photos.findIndex(photo=>photo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.photos[index]=file;
				}
			}else if(type=='IMAGE'){
				let index=this.others.findIndex(other=>other.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.others[index]=file;
				}
			}else if(type=='BKIMAGE'){
				let index=this.bks.findIndex(bk=>bk.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.bks[index]=file;
				}
			}else if(type=='LOGO'){
				let index=this.logos.findIndex(logo=>logo.FILE_ID==file.FILE_ID);
				if(index>-1){
					this.logos[index]=file;
				}
			}
		}
		})
	}
	copyRpt(id){
		
	}
	async getPCAData(){
		let that=this;
		let id=this.reportInfo.REPORT_ID;
		if(this.currencies.length==0){
			//console.log('pca')
			let inputJson1={"PROCEDURE":"getPCACostTableMultipler","USER_ID":parseInt(this.userId),"REPORT_ID":parseInt(id)};
			//console.log(inputJson1);
			let response = await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return											
			}
			this.multipliers=response.PCA_COST_MULTIPLIER;

			let inputJson={"PROCEDURE":"getcurrency"};
			//console.log(inputJson);
			response = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return											
			}
			this.currencies=response.RW_CURRENCYS;
			//console.log(this.currencies);

			let inputJson2={"PROCEDURE":"getcostunit", "USER_ID":parseInt(this.userId)};
			response = await this.reportService.univeralService(JSON.stringify(inputJson2)).toPromise();
			//console.log(response)
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
				return											
			}
			this.units=response.COST_UNITS;
			if(this.reportInfo.PCA_INDICATOR=='4099e'){//console.log(this.fmeService.fmeUnit)
				//let fmeUnits=this.fmeService.fmeUnit;
				this.units=this.fmeService.fmeUnit;//this.units.filter(item=>fmeUnits.indexOf(item.COST_UNIT_NAME.toUpperCase())>-1);
			}

			/*let inputJson3={"PROCEDURE":"getreportpca", "USER_ID":parseInt(this.userId),'REPORT_ID':id};
			this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(response => {
				//console.log('pca', response)
				if(response.PCA_DATA.length>0){
					let pca=JSON.parse(response.PCA_DATA);//console.log(pca);
					this.pcaOp.term=pca.term;
					this.pcaOp.multiplier=pca.multiplier;
					this.pcaOp.decimal=pca.decimal;
					this.pcaOp.currency=pca.currency;
					this.pcaOp.inflation=pca.inflation;
					this.pcaOp.round=pca.round;
					//console.log(this.pcaOp);
					if(pca.quantity){
						this.pcaOp.quantity=pca.quantity;
					}
					if(pca.reserve){
						this.pcaOp.reserve=pca.reserve;
					}
					if(pca.EFF){
						this.pcaOp.age=pca.EFF;
					}
					this.getTotalCost();
				}
				
			})*/
			if(this.reportInfo.PCA_INDICATOR=='4099e'){
				await this.getTotalCost1();				
			}else if(this.reportInfo.PCA_INDICATOR=='Y'){
				await this.getTotalCost();
				if(this.summaryStatus){
					this.getTotalSummary();	
				}
			}
		}else{
			if(this.reportInfo.PCA_INDICATOR=='4099e'){
				await this.getTotalCost1();				
			}else if(this.reportInfo.PCA_INDICATOR=='Y'){
				await this.getTotalCost();
				if(this.summaryStatus){
					this.getTotalSummary();	
				}
			}
			
		}
	}
	setCostTableTitle(type){//console.log(this.contents);
		//console.log(this.pcaOp.term);
		for(let sec of this.contents){
			if(sec.TYPE=='COST'){console.log(sec)
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='PCATABLE'){
						let index=sec1.data.cols.findIndex(col=>col.KEY=='Short');
						if(this.pcaOp.term=='Exclude'){
							if(index>-1){
								sec1.SECTION_TITLE="Immediate Repair Cost Table";
								sec1.data.cols[index]['hide']='Y';
								for(let row of sec1.data.rows){
									if(row[index]){
										row[index].hide='Y';
									}									
									if(row[0]['subheader']){
										row[0]['colspan']-=1;
									}
									
								}
							}
						}else{
							if(index>-1){
								sec1.SECTION_TITLE="Immediate and Short Term Repair Cost Table";
								sec1.data.cols[index].hide='N';
								for(let row of sec1.data.rows){
									if(row[index]){
									row[index].hide='N';
									}
									if(row[0]['subheader']){
										row[0]['colspan']+=1;
									}	
								}								
							}
						}
					}
				}
				//console.log(sec);
				/*let index=sec.SUB_SECTIONS[0].data.cols.findIndex(col=>col.NAME=='Short Term Total');console.log(index)
				if(this.pcaOp.term=='Exclude'){
					sec.SUB_SECTIONS[0].SECTION_TITLE="Immediate Repair cost Table";
					if(index>-1){
					sec.SUB_SECTIONS[0].data.cols[index]['hide']='Y';
					for(let row of sec.SUB_SECTIONS[0].data.rows){
						row[index].hide='Y';
					}
					}
				}else{
					sec.SUB_SECTIONS[0].SECTION_TITLE="Immediate and Short Term Repair Cost Table";
					if(index>-1){
						sec.SUB_SECTIONS[0].data.cols[index].hide='N';
						for(let row of sec.SUB_SECTIONS[0].data.rows){
							row[index].hide='N';
						}
					}
				}*/
			}
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						console.log(sec1);
						let index=sec1.data.cols.findIndex(col=>col.KEY=='Short');console.log(index)
						if(this.pcaOp.term=='Exclude'){
							if(index>-1){
							sec1.data.cols[index]['hide']='Y';
							for(let row of sec1.data.rows){
								row[index].hide='Y';
							}
							}
						}else{
							if(index>-1){
							sec1.data.cols[index].hide='N';
							for(let row of sec1.data.rows){
								row[index].hide='N';
							}
						}
						}
					}else if(sec1.id=='pca_summary_1'){
						//let index=sec1.data.cols.findIndex(col=>col.NAME=='Short Term Repairs');console.log(index)
						let index=sec1.data.cols.findIndex(col=>col.KEY=='Short');console.log(index)
						if(this.pcaOp.term=='Exclude'){
							if(index>-1){
								sec1.data.cols[index]['hide']=true;
								for(let row of sec1.data.rows){
									if(row[index]){
										row[index]['hide']=true;
									}else{
										if(row[0]['colspan']==8){
											row[0]['colspan']=7;
										}else if(row[0]['colspan']==5){
											row[2]['hide']=true;
										}
										
									}
									
								}
							}
						}else{
							if(index>-1){
								sec1.data.cols[index]['hide']=false;
								for(let row of sec1.data.rows){
									if(row[index]&&row[index]['hide']){
										row[index]['hide']=false;
									}else{
										if(row[0]['colspan']==7){
											row[0]['colspan']=8;
											
										}else if(row[0]['colspan']==5){
											row[2]['hide']=false;
										}
										
									}
								}
							}
						}

					}else if(sec1.id=='pca_summary_2'){
						if(this.pcaOp.term=='Exclude'){
							sec1.data.rows[1][0]['rowhide']=true;
						}else{
							sec1.data.rows[1][0]['rowhide']=false;
						}

					}else{
						if(sec1.SUB_SECTIONS){
							for(let sec2 of sec1.SUB_SECTIONS){
								if(sec2.TYPE=='COSTTABLE'){console.log(sec2.data.cols);
									let index=sec2.data.cols.findIndex(col=>col.KEY=='Short');console.log(index)
									if(this.pcaOp.term=='Exclude'){
										if(index>-1){
											sec2.data.cols[index]['hide']='Y';
											for(let row of sec2.data.rows){
												row[index].hide='Y';
											}
										}
									}else{
										if(index>-1){
										sec2.data.cols[index].hide='N';
										for(let row of sec2.data.rows){
											row[index].hide='N';
										}
									}
									}
								}
				
							}
						}
					}
				}
			}
		
		}
		//console.log(this.contents);
		console.log(!type)
		if(!type){
			this.autoSave('PCA Factor Update',"Title","PCA Factor Update");
		}
		
	}
	async getCostData(id){console.log(this.rowItem)
		//console.log(this.curIndex);
		////console.log(this.contents);
		let that=this;
		await this.getPCAData();
		let ifOpen=$('.nav-tabs a[href="#pca"]').hasClass('active');
		if(ifOpen){
			this.logTab('PCA','noPop');
			
		}else{
			this.logTab('PCA');
		}
		$('.nav-tabs a[href="#pca"]').tab('show');
		setTimeout(function(){
			if(that.pcaOp.quantity>0){
				if(that.reportInfo.PCA_INDICATOR=='frm1105'){
					that.getFrmCostData(id)
					return
				}
			that.rrRows=new Array(Math.ceil(that.pcaOp.reserve/that.rrCols.length)).fill(1)
			$("#costDetailModal").modal('show');
			let data=that.getContentData('data'); console.log(data);
			/*this.rowItem=JSON.parse(JSON.stringify(this.newRow));
			this.curCost=null;
			this.rowItem.data[1].data=this.pcaOp.quantity;
			this.rowItem.age=this.pcaOp.age;*/
			that.resetCostTable();
			that.rowItem.index=that.curIndex;
			that.rowItem['id']=id;
			if(that.reportInfo.PCA_INDICATOR=='4099e'){
				that.rowItem['ACTION']='';
			}
			if(data&&data.rows){
				that.curCosts=data.rows[0][0].choice;
			}
			 //console.log(that.curCosts);
			let cat=that.getContentData('long'); console.log(cat);
			console.log(that.capitalCategory);
			let catIndex=that.capitalCategory.findIndex(item=>item.id==cat); console.log(catIndex)
			if(catIndex>-1){
				that.rowItem['catIndex']=catIndex;
				that.rowItem['catLabel']=that.capitalCategory[catIndex].label; console.log(that.rowItem['catLabel'])
			}
			const sec=that.getSecbyId(that.contents, id); console.log(sec);
			if(sec.NTCHK){
				that.rowItem.NTCHK=sec.NTCHK;
			}
			if(sec.NT&&sec.NT.length>0){
				that.rowItem.NT=sec.NT;
			}
			if(sec.LSCHK){
				that.rowItem.NTCHK=sec.NTCHK;
				
			}
			if(sec.LS&&sec.LS>0){
				that.rowItem.LS=sec.LS;
			}
			if(sec.LSBD&&sec.LSBD>0){
				that.rowItem.LSBD=sec.LSBD;
			}
			if(sec.CRBD&&sec.CRBD>0){
				that.rowItem.CRBD=sec.CRBD;
			}
			if(sec.DMBD&&sec.DMBD>0){
				that.rowItem.DMBD=sec.DMBD;
			}
			if(sec.DMCHK){
				that.rowItem.DMCHK=sec.DMCHK;
			}
			if(sec.DM&&sec.DM>0){
				that.rowItem.DM=sec.DM;
			}
			
			if(sec.CRCHK){
				that.rowItem.CRCHK=sec.CRCHK;
			}
			if(sec.CR&&sec.CR>0){
				that.rowItem.CR=sec.CR;
			}
			
			if(sec.long){
				that.rowItem.long=sec.long;
			}
			if(sec.longCat){
				that.rowItem.longCat=sec.longCat;
			}
			if(sec.shortCat){
				that.rowItem.shortCat=sec.shortCat;
			}
			if(sec.catItem>-1){
				that.rowItem.catItem=sec.catItem;
			}else{
				that.rowItem.catItem=-1;
			}			
			//console.log(that.rowItem);
			/*let allocate=[];
			if(this.pcaOp.reserve>0){
				let single={};
				for(let i=0; i<this.pcaOp.reserve; i++){
					single[i]= 0;
					allocate.push(single);
				}
				
			}
			this.rowItem.allocate=allocate;*/
			//console.log(that.rowItem);
			that.reserveWarn=false;
			that.validateWarn=false;
			that.validateWarn1=false;
		}else{
			Swal.fire({
				icon: 'info',
				text: "Please check 'Cost Table Multiplier' and 'Quantity for Cost Table Multiplier' value",				
            })
		}
		}, 500);
	}
	selCost(e){
		let index=$(e.target).val();//console.log(index);
		//this.curCost=this.curCosts[index];//console.log(this.curCost);
		let id=this.curCosts[index].COST_LIBRARY_ID.toString();
		let inputJson={"PROCEDURE":"getpcacostlibraryentrybyidlist","USER_ID":parseInt(this.userId),"COST_LIBRARY_LIST":id}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				this.curCost=data.RW_PCA_COST_LIBRARIES[0]
				this.rowItem.Item=this.curCost.ITEM_TITLE;
				let unitIndex=this.units.findIndex(unit=>unit.COST_UNIT_NAME==this.curCost.UNIT);
				if(unitIndex>-1){
					this.rowItem.Unit=this.curCost.UNIT;
				}
				//console.log(parseFloat(this.curCost.COST))
				if(!isNaN(parseFloat(this.curCost.COST))){
					this.rowItem.Cost=parseFloat(this.curCost.COST);
				}else{
					this.rowItem.Cost=0;
				}
				if(!isNaN(parseInt(this.curCost.EUL))){
					this.rowItem.EUL=parseInt(this.curCost.EUL);
				}else{
					this.rowItem.EUL=0;
				}
				//this.rowItem.Immediate=0;
				//this.rowItem.Short=0;
				if(this.reportInfo.PCA_INDICATOR=='4099e'){
					this.getReserve1();
				}else{
					this.getReserve();
				}
			}
		})
				
	}
	selUnit(e){
		let unit=$(e.target).val();////console.log(unit);
		if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			this.frmrowItem.Unit=unit;
		}else{
			this.rowItem.Unit=unit;
		}
		
	}
	setInflation(e){
		let val=$(e.target).val();//console.log(val);
		this.pcaOp.inflation=parseFloat(val);
		//if(this.reportInfo.PCA_INDICATOR=='4099e'){
		//	this.getTotalCost1();
		//}else{
			this.getTotalCost();
			//setTimeout(() => {
				if(this.summaryStatus){
					this.getTotalSummary();
					this.changeOpItem();
				}
				
			//}, 1000);
		//}
		this.autoSave('PCA Factor Update',val.toString(),"PCA Factor Update");
	}
	getReserve(key?){
		if(this.reportInfo.PCA_INDICATOR=='4099e'){
			if(key){
				this.getReserve1(key);
			}else{
				this.getReserve1();
			}
			
		}else{

		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		if(key){
			if(key=='Cost'){
				let rounded=this.getRound(this.rowItem[key],2);
				this.rowItem[key]=rounded;
			}else if(key=='Quantity'){
				let rounded=this.getRound(this.rowItem[key],0);
				this.rowItem[key]=rounded;
			}else{
				let rounded=this.getRound(this.rowItem[key],this.pcaOp.decimal);
				this.rowItem[key]=rounded;
			}
		}
		let rate=this.pcaOp.inflation/100;////console.log(rate);
		this.rowItem.Cycle=this.getRound(this.rowItem.Quantity*this.rowItem.Cost,this.pcaOp.decimal)
		this.rowItem.Total=this.getRound(this.rowItem.Percent*this.rowItem.Quantity*this.rowItem.Cost/100,this.pcaOp.decimal);
		if(!this.rowItem.Short){
			this.rowItem.Short=0
		}
		if(!this.rowItem.Immediate){
			this.rowItem.Immediate=0
		}
		let immishort=0;
		if(this.rowItem.immiCHK){
			immishort+=this.rowItem.Immediate;
		}
		if(this.rowItem.shortCHK){
			immishort+=this.rowItem.Short
		}
		let val=this.rowItem.Total-immishort;//this.rowItem.Immediate-this.rowItem.Short;
		this.rowItem.Reserve=this.getRound(val,this.pcaOp.decimal)
		let selectedYear=[];
		$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
			if($(this).prop('checked')){
				selectedYear.push(parseInt($(this).val()));
			}
		})
		this.rowItem['selectedYear']=selectedYear;
		//let remain=val%selectedYear.length;
		/*if(this.pcaOp.decimal==2){
			remain=(val*100%selectedYear.length)/100;
		}*/
		let data=this.getRound(val/selectedYear.length,this.pcaOp.decimal);
		 ////console.log(remain);
		let otherTotal=0;
		if(this.pcaOp.reserve>0){
			for(let i=0; i<this.pcaOp.reserve; i++){////console.log(selectedYear.indexOf(i+1));
				if(selectedYear.indexOf(i+1)>-1){
					if(selectedYear[0]==i+1){
						this.rowItem.allocate[i]= data;//this.getRound(data+remain,this.pcaOp.decimal);
					}else{
						this.rowItem.allocate[i]= data;
						otherTotal+=data
					}
				}else{
					this.rowItem.allocate[i]= 0;
				}
			}
			this.rowItem.allocate[selectedYear[0]-1]=this.getRound(val-otherTotal,this.pcaOp.decimal);
		}
		/*let data=this.getRound(val/this.pcaOp.reserve);//console.log(this.rowItem.reserve);
		let remain=this.getRound(val%this.pcaOp.reserve); //console.log(remain);
		if(this.pcaOp.reserve>0){
			for(let i=0; i<this.pcaOp.reserve; i++){
				if(i==0){
					this.rowItem.allocate[i]= data+remain;
				}else{
					this.rowItem.allocate[i]= data;
				}
			}
		}*/		
		////console.log(this.rowItem);
		if(selectedYear.length>0){
			this.rowItem.reserve=0;
		}else{
			this.rowItem.reserve=this.getRound(val,this.pcaOp.decimal);
		}
		this.rowItem.averageReserve=this.getRound(val/this.rowItem.Quantity/this.pcaOp.reserve,2);
		let total=0;
		for(let i=0; i<this.rowItem.allocate.length; i++){
			if(i==0){
				total+=this.rowItem.allocate[i];
			}else{
				total+=this.getRound(this.rowItem.allocate[i]*this.getRound(Math.pow((1+rate),i),3),2);
			}
			////console.log(total)
		}
		this.rowItem.inReserve=this.getRound(total,2);
		this.rowItem.averageINReserve=this.getRound(this.rowItem.inReserve/this.rowItem.Quantity/this.pcaOp.reserve,2);
		////console.log(val);
		if(this.rowItem.reserve!=0){
			this.reserveWarn=true;
		}
		//if(!this.rowItem.Immediate){
		//	this.rowItem.Immediate=0
		//}
		if(this.reserveWarn){
			if(!this.rowItem.allow){
				return
			}
		}
	}
	}
	addV(row, year, cost, keep, id){
		let newRow=JSON.parse(JSON.stringify(row));
		if(year==0){
			for(let item of newRow){
				if(item.KEY=='Year'){
					item.DATA='';
				}else if(item.KEY=='Total'){
					item.DATA=cost;
					item.sign=this.currSign;
				}else if(item.KEY=='Item'){
					item.DATA='Total';
				}else{
					if(!keep){
					item.DATA='';
					}
				}
			}
		}else{
			for(let item of newRow){
				if(item.KEY=='Year'){
					item.DATA=year;
				}else if(item.KEY=='Total'){//console.log(cost);
					item.DATA=cost;
					item.sign=this.currSign;
				}else{
					if(!keep){
					item.DATA='';
					}
				}
			}
		}
		newRow[0]['KEEP']=keep;
		newRow[0]['costId']=id;
		//console.log(newRow);
		return newRow
	}
	addPcaRow(type?){//console.log(type)
		//console.log(JSON.stringify(this.rowItem));
		if(!(this.rowItem.Short>=0)){
			this.rowItem.Short=0;
		}
		if(!(this.rowItem.Immediate>=0)){
			this.rowItem.Immediate=0;
		}
		if(this.reserveWarn){
			if(!this.rowItem.allow){
				return
			}
		}
		
		//if(this.rowItem.Item==''||this.rowItem.Quantity==0||this.rowItem.Unit==''||this.rowItem.Cost==0){
		if(this.rowItem.Item==''||this.rowItem.Quantity==0||this.rowItem.Unit==''){
			this.validateWarn1=true;
			return
		}
		//this.rowItem.Cycle=this.getRound(this.rowItem.Quantity*this.rowItem.Cost,2);
		this.rowItem.RUL=this.getRound(this.rowItem.EUL-this.rowItem.EFF, 0);//this.rowItem.EUL-this.rowItem.EFF;
		this.rowItem.Year=this.pcaOp.reserve;
		let data=this.getContentData('data'); console.log(data);
		let id=this.getContentData('id');
		let title=this.getContentData('SECTION_TITLE');
		//console.log(data);
		let info=JSON.parse(JSON.stringify(this.rowItem));
			info['costId']=Utils.uniqueIdGenerator();
		if(!data){
			
		}
		if(!data['COST']){
			data['COST']=[];
			data['COST'].push(info);
		}else{
			data['COST'].push(info);
		}
		let row=[]
		let total=this.rowItem.Total;
		for(let col of data.cols){
			let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'', 'KEY':''};
			item.COLUMNINTERNALNAME=col.INTERNALNAME;
			if(this.rowItem[col.KEY]||this.rowItem[col.KEY]==0){
				if(!this.rowItem.immiCHK&&col.KEY=='Immediate'){
					item.DATA='';
				}else if(!this.rowItem.shortCHK&&col.KEY=='Short'){
					item.DATA='';
				}else{
					item.DATA=this.rowItem[col.KEY].toString();
				}
				
			}
			item.KEY=col.KEY;
			if(col.KEY=='Cost'||col.KEY=='Cycle'||col.KEY=='Immediate'||col.KEY=='Short'||col.KEY=='Reserve'){
				item.sign=this.currSign;
			}else if(col.KEY=='Percent'){
				item.sign='%';
			}
			if((this.pcaOp.term=='Exclude')&&(col.KEY=='Short')){
				item['hide']='Y';
			}
			if(col.KEY=='Cycle'||col.KEY=='Percent'){
				item['hide']='Y';
			}
			if(col.KEY=='RUL'){
				if(this.rowItem.RULtext){
					item.DATA=this.rowItem.RULtext;
				}
			}
			//console.log(item)
			row.push(item);
		}
		//if(this.pcaOp.term=='Exclude'){
		//	row['Immediate']['hide']='Y';
		//}
		let rowBase=JSON.parse(JSON.stringify(row));
		if(data.version&&data.version=='2'){
			let keep=true;
			if(this.rowItem.Immediate>=0&&this.rowItem.immiCHK){
				let val1='Immediate';
				let val2=this.rowItem.Immediate;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId'] );
				
				data.rows.push(v2row);
				keep=false;
			}/*else{
				if(this.rowItem.immiCHK){
					let val1='Immediate';
					let val2=0;;
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId'] );console.log(v2row)				
					data.rows.push(v2row);
					keep=false;
					
				}				
			}*/
			if(this.rowItem.Short>=0&&this.rowItem.shortCHK){
				let val1='Short';
				let val2=this.rowItem.Short;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				
				data.rows.push(v2row);
				keep=false;
			}/*else{
				
				if(this.rowItem.shortCHK){
					let val1='Short';
					let val2:any;
					val2=0;
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);console.log(v2row)				
					data.rows.push(v2row);
					keep=false;
				}
				
				
			}*/
			/*if(info.allocate){
				for(let i=0; i<info.allocate.length; i++){
					if(info.allocate[i]>=0){//console.log(info.allocate[i])
						let val1=i+1;
						let val2=info.allocate[i];//console.log(val1,val2)
						let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
						
						data.rows.push(v2row);
						keep=false;
					}
					
				}
			}*/
			//console.log(info.selectedYear, info.allocate)
			if(info.selectedYear.length>0&&info.allocate){
				for(let i of info.selectedYear){
					let val1=i;
					let val2=0; 
					if(info.allocate[i-1]>0){
						val2=info.allocate[i-1];
					}
					//console.log(val1,val2)
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
					
					data.rows.push(v2row);
					keep=false;
				}
			}
			if((!this.rowItem.shortCHK)&&(!this.rowItem.immiCHK)&&info.selectedYear.length==0){
					let val1='N/A';
					let val2=0;//console.log(val1,val2)
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
					data.rows.push(v2row);
					keep=false;

			}
			/*if(this.rowItem.Immediate>0||this.rowItem.Short>0||info.allocate){
				let last=this.addV(rowBase,0,total);
				data.rows.push(last);
			}*/
		}else{//console.log('hello')
			row[0]['costId']=info['costId'];
			data.rows.push(row);
		}
		
		
		if(type&&type=='new'){
			this.resetCostTable();
		}else{
			$('#costDetailModal').modal('hide');
		}
		this.getTotalCost();
		if(this.summaryStatus){
			this.getTotalSummary()
		}
		this.autoSave('modify',id, title, "O" );
		//this.toSummarySec(data['COST']);
	}
	createUnitData(){
		//console.log(this.pcaOp.multiplier);
		let table={'cols':[],'rows':[]}
		let rowLabel=['Evaluation Period','Total Quantity','Reserve per '+this.pcaOp.multiplier+' per Year (Uninflated)','Reserve per '+this.pcaOp.multiplier+' per Year (Inflated)'];
		if(this.pcaOp.multiplier.length>0){
			let index=this.multipliers.findIndex(item=>item.LABEL==this.pcaOp.multiplier);
			if(index>-1){
				rowLabel[1]="Total "+ this.multipliers[index].FULL_LABEL;
			}
			
		}
		let cols=['Item','Data'];
			for(let i=0; i<cols.length; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':cols[i],'TYPE':'text', 'width':50, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'left',};
				table.cols.push(item)
			}
		
		for(let i=0; i<4; i++){
			let row=[]
			for(let j=0; j<table.cols.length; j++){
				let item:any;
				if(j==0){
					item={'COLUMNINTERNALNAME':'','DATA':rowLabel[i]};
					item.COLUMNINTERNALNAME=table.cols[j].INTERNALNAME;
				}else{
					item={'COLUMNINTERNALNAME':'','DATA':0, 'sign':''};
					item.COLUMNINTERNALNAME=table.cols[j].INTERNALNAME;
					if(i>1){
						item.sign=this.currSign;
					}
				}
				
				row.push(item);
			}
			table.rows.push(row)
		}
		
		return table;
	}
	getTotalCost(){//console.log(this.contents)
		let allpca=[];
		let pcaTable:any;
		let repairTable:any
		let sid:string;
		let stitle:string;
		let pcatables=[];
		if (this.contents)
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						allpca.push(sec1);//console.log(sec1)
						
					}else if(sec1.TYPE=='PCATABLE'){
						if(sec1.data.cols.length>9){
							sec1.data.rows=[];
						}else{
							pcatables[0]=sec1;
							sec1.data.rows=[]
						}
						//pcas.push(sec1)
					}else if(sec1.TYPE=='UNITTABLE'){
						for(let i=2; i<sec1.data.rows.length; i++){
							sec1.data.rows[i][1].DATA='';
						}
					}
						if(sec1.SUB_SECTIONS){
							for(let sec2 of sec1.SUB_SECTIONS){
								if(sec2.TYPE=='COSTTABLE'){
									allpca.push(sec2);//console.log(sec2)
								}
				
							}
						}					
				}
			}
		}
		
		if(allpca.length==0){
			return
		}
		let totalItem=0;
		for(let pcaItem of allpca){
			if(pcaItem.data&&pcaItem.data.rows&&pcaItem.data.rows.length>0){
			totalItem+=pcaItem.data.rows.length;
			}
		}
		if(totalItem==0){
			return
		}
		for(let sec of this.contents){
			if(sec.TYPE=='COST'){
				sid=sec.id;
				stitle=sec.SECTION_TITLE;
				let pcas=[null, null];
				let units=[];
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='PCATABLE'){
						if(sec1.data.cols.length>9){
							pcas[1]=sec1;
						}else{
							pcas[0]=sec1;
						}
						//pcas.push(sec1)
					}else if(sec1.TYPE=='UNITTABLE'){
						units.push(sec1)
					}
				}
				//console.log(pcas)
				pcaTable=pcas[0].data;
				this.savedRepair=JSON.parse(JSON.stringify(pcas[1].data));
				let repairs=this.createRepairTable(this.savedRepair, allpca);
				pcas[1].data=repairs[0];
				pcas[1]['ZOOM']=true;
				repairTable=pcas[1].data;
				let unitTable:any
				if(units.length==0){
					let uid=Utils.uniqueIdGenerator();
					let table={'TYPE':'UNITTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Unit Cost Table",'SUB_SECTIONS':[],"NEW":false, 'id':uid};
					table['data']=this.createUnitData();
					sec.SUB_SECTIONS.push(table);
					unitTable=table['data'];
				}else{
					unitTable=units[0].data;
				}
				for(let i=0; i<unitTable.rows.length; i++){
					unitTable.rows[i][1].DATA=repairs[1][i];
					if(i>1){
						unitTable.rows[i][1].sign=this.currSign;
					}
				}
			}
		}
		let rows=[];
		let totalShort=0;
		let totalImmi=0;
		for(let pca of allpca){
			let totalShort1=0;
			let totalImmi1=0;
			if(pca.data&&pca.data.COST&&pca.data.COST.length>0){
				let index=pca.data.COST[0].index;
				let firstrow=[];
				for(let i=0; i<pcaTable.cols.length; i++){
					if(i==0){
					let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':''};
					item.COLUMNINTERNALNAME=pcaTable.cols[i].INTERNALNAME;
					item['KEY']=pcaTable.cols[i].KEY;
					item['hide']=pcaTable.cols[i].hide;
					if(pcaTable.cols[i].KEY=='Item'){								
						item.DATA=this.getItem(index);
						item['bold']='bold';
						item['index']=index;
						item['id']=pca.id;
					}
					item['colspan']=pcaTable.cols.length-1;//console.log(pcaTable.cols.length);
					item['subheader']=true;//console.log(item);
					firstrow.push(item);
					break
				}
				}
				
				if(this.pcaOp.term=='Exclude'){
					if(firstrow['Short']){
						firstrow['Short']['hide']='Y';
						
					}
					if(firstrow[0]['subheader']){
						firstrow[0]['colspan']-=1;
					}
				}
				for(let item of pca.data.COST){
					if(item.immiCHK||item.shortCHK){
						rows.push(firstrow);
						break
					}
				}				
				let v2Index=0;
				for(let j=0; j<pca.data.rows.length; j++){
					if(j>0&&((!pca.data.version)||pca.data.rows[j][0]['KEEP'])){
						let row=[];
						for(let col of pcaTable.cols){
						let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'','KEY':''};
							item.COLUMNINTERNALNAME=col.INTERNALNAME;
							item['KEY']=col.KEY;
							if(col.hide){
								item['hide']=col.hide;
							}
							if(pca.data.version&&pca.data.version=='2'){
								if(pca.data.COST[v2Index][col.KEY]){
									item.DATA=pca.data.COST[v2Index][col.KEY].toString();
									if(!pca.data.COST[v2Index]['immiCHK']&&col.KEY=='Immediate'){
										item.DATA='0';										
									}else if(!pca.data.COST[v2Index]['shortCHK']&&col.KEY=='Short'){
										item.DATA='0';	
									}
								}else{
									item.DATA='0';
								}
							}else{
								if(pca.data.COST[j-1][col.KEY]){
									item.DATA=pca.data.COST[j-1][col.KEY].toString();
									if(!pca.data.COST[j-1]['immiCHK']&&col.KEY=='Immediate'){
										item.DATA='0';										
									}else if(!pca.data.COST[j-1]['shortCHK']&&col.KEY=='Short'){
										item.DATA='0';	
									}
								}else{
									item.DATA='0';
								}
							}
							if(col.KEY=='Short'&&this.pcaOp.term=='Exclude'){
								item['hide']='Y';
							}
							if(col.KEY=='Short'||col.KEY=='Immediate'||col.KEY=='Cycle'||col.KEY=='Cost'){
								item.sign=this.currSign;
							}
							if(col.KEY=='Percent'){
								item.sign='%';
							}
							if(col.KEY=='Cost'){
								item.DATA=pca.data.COST[v2Index][col.KEY].toFixed(2);
							}
							row.push(item); 
						}
						if(pca.data.version&&pca.data.version=='2'){
							//if((pca.data.COST[v2Index]['Immediate']+pca.data.COST[v2Index]['Short'])>=0){
							if((pca.data.COST[v2Index]['immiCHK']||pca.data.COST[v2Index]['shortCHK'])){
								rows.push(row);
							}
							if(pca.data.COST[v2Index]['Immediate']>=0&&pca.data.COST[v2Index]['immiCHK']){
								totalImmi+=pca.data.COST[v2Index]['Immediate'];
								totalImmi1+=pca.data.COST[v2Index]['Immediate'];
							};
							if(pca.data.COST[v2Index]['Short']>=0&&pca.data.COST[v2Index]['shortCHK']){
								totalShort+=pca.data.COST[v2Index]['Short'];
								totalShort1+=pca.data.COST[v2Index]['Short'];
							}
						}else{
							//if((pca.data.COST[j-1]['Immediate']+pca.data.COST[j-1]['Short'])>=0){
							if((pca.data.COST[v2Index]['immiCHK']||pca.data.COST[v2Index]['shortCHK'])){
								rows.push(row);
							}
							if(pca.data.COST[j-1]['Immediate']>=0&&pca.data.COST[v2Index]['immiCHK']){
								totalImmi+=pca.data.COST[j-1]['Immediate'];
								totalImmi1+=pca.data.COST[j-1]['Immediate'];
							};
							if(pca.data.COST[j-1]['Short']>=0&&pca.data.COST[v2Index]['shortCHK']){
								totalShort+=pca.data.COST[j-1]['Short'];
								totalShort1+=pca.data.COST[j-1]['Short'];
							}
						}
						v2Index++;
					}
				}
				/*if((totalImmi1+totalShort1)==0){
					rows.pop();
				}*/
			}
				
		}
		totalShort=this.getRound(totalShort, this.pcaOp.decimal);
		totalImmi=this.getRound(totalImmi, this.pcaOp.decimal); 
		if(pcaTable){
			pcaTable.rows=rows;
			let lastRow=[];
			for(let i=0; i<pcaTable.cols.length; i++){
					let item={'COLUMNINTERNALNAME':'','DATA':'','sign':''};
					item.COLUMNINTERNALNAME=pcaTable.cols[i].INTERNALNAME;
					item['KEY']=pcaTable.cols[i].KEY;
					item['hide']=pcaTable.cols[i].hide;
					if(pcaTable.cols[i].KEY=='Item'){								
						item.DATA='Total';
					}
					if(pcaTable.cols[i].KEY=='Immediate'){
						item.DATA=totalImmi.toString();
						item.sign=this.currSign;
							
					}
					if(pcaTable.cols[i].KEY=='Short'){
						item.DATA=totalShort.toString();
						item.sign=this.currSign;
					}
					lastRow.push(item);
			}
			//this.totalCost[0]=this.getRound(totalShort, this.pcaOp.decimal).toFixed(2);
			this.totalCost[0]=totalShort.toFixed(2);
			this.totalCost[1]=this.getRound(totalShort*this.pcaOp.inflation/100, this.pcaOp.decimal).toFixed(2);
			//this.totalCost[2]=this.getRound(totalImmi, this.pcaOp.decimal).toFixed(2);
			this.totalCost[2]=totalImmi.toFixed(2);
			this.totalCost[3]=this.getRound(totalImmi*this.pcaOp.inflation/100, this.pcaOp.decimal).toFixed(2);
			if(this.pcaOp.term=='Exclude'){
				if(lastRow['Short']){
						lastRow['Short']['hide']='Y';
				}
			}
			if(pcaTable.rows.length>0){
				pcaTable.rows.push(lastRow);
			}
		}
		
	}
	getItem(index,type?){
		let index1=index[0];////console.log(index1);
		let index2=index[1];////console.log(index2);
		let index3=index[2];////console.log(index3);
		let dest:string;
		if(this.contents&&index3&&index3>-1){
			for(let i=index3; i>-1; i--){
				//if(this.contents[index1].SUB_SECTIONS[index2]&&this.contents[index1].SUB_SECTIONS[index2].length>0){
					if(this.contents[index1].SUB_SECTIONS[index2]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].DISPLAY_SEQUENCE=='Y'){
						if(type){
							dest=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].SECTION_SEQUENCE;
						}else{
							dest=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].SECTION_SEQUENCE+" "+this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].SECTION_TITLE;
						}
						//console.log(dest);
						break;
					}
				//}
			}
		}
		if(!dest){
			for(let i=index2; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[i]&&this.contents[index1].SUB_SECTIONS[i].DISPLAY_SEQUENCE=='Y'){
					if(type){
						dest=this.contents[index1].SUB_SECTIONS[i].SECTION_SEQUENCE;
					}else{
						dest=this.contents[index1].SUB_SECTIONS[i].SECTION_SEQUENCE+" "+this.contents[index1].SUB_SECTIONS[i].SECTION_TITLE;
					}
					
					//console.log(dest);
					break;
				}
			}
			if(!dest){
				for(let i=index1; i>-1; i--){
					if(this.contents[i].DISPLAY_SEQUENCE=='Y'){
						if(type){
							dest=this.contents[i].SECTION_SEQUENCE;
						}else{
							dest=this.contents[i].SECTION_SEQUENCE+" "+this.contents[i].SECTION_TITLE;
						}
						
						break;
						
					}
				}
			}
		}
					
		return dest;
	
	}
	getrepairwidth(){
		let width=[];
		let total=42;
		for(let i=0; i<this.pcaOp.reserve; i++){
			if(i<this.pcaOp.reserve-1){
				let base=Math.floor(42*10/this.pcaOp.reserve)/10;
				total-=base;
				width.push(base.toString())
			}else{
				total=Math.floor(total*10)/10;
				width.push(total.toString())
			}
			
		}
		return width
	}
	createRepairTable(tempPca, allpca){
		let savedCols=JSON.parse(JSON.stringify(tempPca.cols.slice(0, -2))).slice(0,9);
		let data={'cols':savedCols,'rows':[]};
		let cols=[];
		for(let i=0; i<this.pcaOp.reserve; i++){
			cols.push('Year'+" "+(i+1).toString());
		}
		cols.push('Total Cost');
		for(let i=0; i<cols.length; i++){
			let width=this.getrepairwidth();//console.log(width);
			let item={'INTERNALNAME':'col'+(9+i).toString(),'NAME':cols[i],'TYPE':'text', 'width':width[i], 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Right',};
			if(i>2){
				item['hide']=true;
			};
			data.cols.push(item);
		}
		for(let pca of allpca){
			if(pca.data&&pca.data.COST&&pca.data.COST.length>0){
				let index=pca.data.COST[0].index;
				let firstrow=[];
				for(let i=0; i<data.cols.length; i++){
					if(i==0){
						let item={'COLUMNINTERNALNAME':'','DATA':'','sign':'' };
						item.COLUMNINTERNALNAME=data.cols[i].INTERNALNAME;
						item['KEY']=data.cols[i].KEY;
						item['hide']=data.cols[i].hide;
						if(data.cols[i].KEY=='Item'){								
							item.DATA=this.getItem(index);
							item['bold']='bold';
							item['index']=index;
							item['id']=pca.id;
						}
						if(data.cols[i]['hide']){
							item['hide']=data.cols[i]['hide'];
						}
						item['colspan']=data.cols.length;
						item['subheader']=true;
					
						firstrow.push(item);
						break
					}
				}
				
				data.rows.push(firstrow);
				let secRows=0;
				for(let j=0; j<pca.data.COST.length; j++){console.log(pca.data.COST[j])
					if(pca.data.COST[j].selectedYear&&pca.data.COST[j].selectedYear.length>0){
						let row=[];
						for(let i=0; i<9; i++){
							let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':''};
							item.COLUMNINTERNALNAME=data.cols[i].INTERNALNAME;
							if(data.cols[i].KEY){
								item['KEY']=data.cols[i].KEY;
							}
							if(data.cols[i]['hide']){
								item['hide']=data.cols[i]['hide'];
							}
							if(data.cols[i].KEY=="Cycle"||data.cols[i].KEY=="Cost"){								
								item['sign']=this.currSign;
							}
							if(data.cols[i].KEY=="Percent"){								
								item['sign']='%';
							}
							item.DATA=pca.data.COST[j][data.cols[i].KEY];
							if(data.cols[i].KEY=='Cost'){
								item.DATA=pca.data.COST[j][data.cols[i].KEY].toFixed(2);
							}
							if(data.cols[i].KEY=='RUL'){
								if(pca.data.COST[j].RULtext){
									item.DATA=pca.data.COST[j].RULtext;
								}else{
									item.DATA=pca.data.COST[j].RUL;
								}
							}
							row.push(item);
						}
						
						let total=0
						for(let k=0; k<this.pcaOp.reserve; k++){
							let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':''};
							if(pca.data.COST[j].allocate[k]>=0){
								item.COLUMNINTERNALNAME=data.cols[k+8].INTERNALNAME;
								item.DATA=pca.data.COST[j].allocate[k];
								item.sign=this.currSign;
								total+=pca.data.COST[j].allocate[k];
								if(k>2){
									item['hide']=true;
								}
							}else if(!pca.data.COST[j].allocate[k]){//30 years pca process added
								item.COLUMNINTERNALNAME=data.cols[k+8].INTERNALNAME;
								item.DATA='0';
								item.sign=this.currSign;
								if(k>2){
									item['hide']=true;
								}
							}
							row.push(item)
						}
						
						let lastItem={'COLUMNINTERNALNAME':'','DATA':'', 'sign':''};
						lastItem.COLUMNINTERNALNAME=data.cols[data.cols.length-1].INTERNALNAME;
						lastItem.DATA=this.getRound(total,this.pcaOp.decimal).toString();
						lastItem.sign=this.currSign;
						if(this.pcaOp.reserve>2){
							lastItem['hide']=true;
						}
						
						row.push(lastItem);
						if(total>=0){
							data.rows.push(row);
							secRows++
						}
					}
					}
					if(secRows==0){
						data.rows.pop();
					}
				}						
		}
		let totalRow1=[];
		let totalRow2=[];
		let totalRow3=[];
		let item:any
		
		for(let i=0; i<data.cols.length; i++){
			item={'COLUMNINTERNALNAME':'','DATA':''};
			if(i>8){
				item={'COLUMNINTERNALNAME':'','DATA':0, 'sign':''};
			}
			item.COLUMNINTERNALNAME=data.cols[i].INTERNALNAME;
			totalRow1.push(item);
		}
		totalRow2=JSON.parse(JSON.stringify(totalRow1));
		totalRow3=JSON.parse(JSON.stringify(totalRow1));
		totalRow1[0].DATA='Total (Uninflated)';
		totalRow2[0].DATA='Inflation Factor';
		totalRow3[0].DATA='Total (Inflated)';
		console.log(data.rows)
		for(let row of data.rows){
			for(let i=9; i<row.length; i++){
				if(data.cols[i]['hide']){
						totalRow1[i]['hide']=data.cols[i]['hide'];
						totalRow2[i]['hide']=data.cols[i]['hide'];
						totalRow3[i]['hide']=data.cols[i]['hide'];
				}
				if(row[i].DATA>=0){
					if(parseFloat(row[i].DATA)>0){
						totalRow1[i].DATA=this.getRound(parseFloat(totalRow1[i].DATA)+parseFloat(row[i].DATA),this.pcaOp.decimal);
					}
					totalRow1[i].sign=this.currSign;
					if(i==9){
						totalRow2[i].DATA=1;
						totalRow3[i].DATA=totalRow1[i].DATA;
						totalRow3[i].sign=this.currSign;
					}else if(i<row.length-1){
						totalRow2[i].DATA=this.getRound(totalRow2[i-1].DATA*(1+this.pcaOp.inflation/100), 3);
						totalRow3[i].DATA=this.getRound(totalRow1[i].DATA*totalRow2[i].DATA,this.pcaOp.decimal);
						totalRow3[i].sign=this.currSign;
					}else{
						totalRow2[i].DATA='';
						let no=0;
						for(let i=9; i<row.length-1; i++){
							no+=totalRow3[i].DATA;
						}
						totalRow3[i].DATA=this.getRound(no,this.pcaOp.decimal);
						totalRow3[i].sign=this.currSign;
					}
				}
			}
			
		}
		this.totalCost[4]=this.getRound(totalRow1[totalRow1.length-1].DATA, this.pcaOp.decimal).toFixed(2);;
		this.totalCost[6]=this.getRound(totalRow3[totalRow3.length-1].DATA, this.pcaOp.decimal).toFixed(2);;
		let endrows=[totalRow1,totalRow2,totalRow3]; 
		if(data.rows.length>0){
		data.rows.push(...endrows);
		}
		
		let units=[this.pcaOp.reserve, this.pcaOp.quantity,'',''];
		if(totalRow1[totalRow1.length-1].DATA>0&&this.pcaOp.quantity>0&&this.pcaOp.reserve>0){
			units[2]=this.getRound(totalRow1[totalRow1.length-1].DATA/this.pcaOp.quantity/this.pcaOp.reserve,2).toFixed(2);
		}
		if(totalRow3[totalRow3.length-1].DATA>0&&this.pcaOp.quantity>0&&this.pcaOp.reserve>0){
			units[3]=this.getRound(totalRow3[totalRow3.length-1].DATA/this.pcaOp.quantity/this.pcaOp.reserve,2).toFixed(2);
		}
		this.totalCost[5]=this.getRound(units[2], 2).toFixed(2);
		this.totalCost[7]=this.getRound(units[3], 2).toFixed(2);
		return [data, units];
	}
	checkTotal(){
		
		let total=0;
		let val = 0;
		for(let i=0; i<this.rowItem.allocate.length; i++){
			if(this.rowItem.selectedYear.indexOf(i+1)>-1){
				total+=this.rowItem.allocate[i];
			}else{
				this.rowItem.allocate[i]=0;				
			}
		}
		//console.log(this.rowItem.allocate);
		if(this.reportInfo.PCA_INDICATOR=='4099e'){
			this.rowItem.Immediate=0
			if(this.rowItem.DMCHK){
				this.rowItem.Immediate+=this.rowItem.DM;			
			}
			if(this.rowItem.CRCHK){
				this.rowItem.Immediate+=this.rowItem.CR;
			}
			if(this.rowItem.LSCHK){
				this.rowItem.Immediate+=this.rowItem.LS;
			}
			val=this.rowItem.Total-this.rowItem.Immediate
					
		}else{
			let immishort=0;
			if(this.rowItem.immiCHK){
				immishort+=this.rowItem.Immediate
			}
			if(this.rowItem.shortCHK){
				immishort+=this.rowItem.Short
			}	
			val=this.rowItem.Percent*this.rowItem.Quantity*this.rowItem.Cost/100-immishort;//this.rowItem.Immediate-this.rowItem.Short;			
		}
		this.rowItem.reserve=this.getRound(val-total, 2);
		if(this.rowItem.reserve==0){
			this.reserveWarn=false;
		}else{
			this.reserveWarn=true;
		}
	}
	getRound(val, decimal){
		let data=0;
		if(this.pcaOp.round=='Round'){
			if(decimal==3){
				data=Math.round(val*1000)/1000;
			}else if(decimal==2){
				data=Math.round(val*100)/100;
			}else if(decimal==0){
				data=Math.round(val);
			}
			
		}else if(this.pcaOp.round=='Round Up'){
			if(decimal==3){
				data=Math.ceil(val*1000)/1000;
			}else if(decimal==2){
				data=Math.ceil(val*100)/100;
			}else if(decimal==0){
				data=Math.ceil(val);
			}
			
		}else if(this.pcaOp.round=='Round Down'){
			if(decimal==3){
				data=Math.floor(val*1000)/1000;
			}else if(decimal==2){
				data=Math.floor(val*100)/100;
			}else if(decimal==0){
				data=Math.floor(val);
			}
			
		}
		
		return data;
	}

	USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		//trailingZeroDisplay: 'stripIfInteger',
	});
	resetCostTable(){
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		this.rowItem=JSON.parse(JSON.stringify(this.newRow));
		this.rowItem.EFF=this.pcaOp.age;
		//this.rowItem.data[1].data=this.pcaOp.quantity
		
		for(let i=0; i<this.pcaOp.reserve; i++){
			this.rowItem.allocate.push(0);
		}
		this.curCost=null;
		$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
			$(this).prop('checked', false);
		})
		$("#costDetailModal textarea").each(function(e){
			$(this)[0].style.height = "40px";
		});
	}
	customInput(e){
		if(this.reportInfo.PCA_INDICATOR!='frm1105') return	
		let val=e.target.value.toUpperCase();
		/*this.getAddedItems();
		if(this.frmrowItem['addedItem']){
			for(let item of this.frmrowItem['addedItem']){
				let itemvalue=item.toUpperCase()
				if(val==itemvalue){
					Swal.fire({
						icon: 'info',
						title: 'This item is already added, Please revise your Cost Recommendation',
					})
					this.frmrowItem.Item='';			
					return
				}
			}
		}*/
		//resetCostTable();
			
		if(this.frmrowItem['parent']){
			delete this.frmrowItem['parent'];
		}		
		if(this.frmrowItem['other']){
			delete this.frmrowItem['other']
			delete this.frmrowItem['otherInput']
		}		
		if(this.frmrowItem['describe']){
			delete this.frmrowItem['describe']
			delete this.frmrowItem['describeInput']
		}
		this.getSameItem(this.frmrowItem);				
	}
	async editCostRow(index){
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		this.quantityWarn=false;
		//console.log(index);
		let data=this.getContentData('data');
		//console.log(data);
		this.curCosts=data.rows[0][0].choice; //console.log(this.curCosts);
		if(data.version&&data.version=='2'){
			let id=data.rows[index][0].costId;//console.log(id);
			let v2Index=data.COST.findIndex(item=>item.costId==id);//console.log(v2Index);
			this.rowItem=JSON.parse(JSON.stringify(data.COST[v2Index]));//console.log(this.rowItem);
		}else{
			this.rowItem=JSON.parse(JSON.stringify(data.COST[index-1]));//console.log(this.rowItem);
		}
		let that=this;
		//console.log(this.rowItem);
		/*if(this.rowItem.EUL>0){
			if(!Number.isInteger(this.rowItem.EUL)){
				this.rowItem.EUL=Math.ceil(this.rowItem.EUL);
			}
			
		}else{
			this.rowItem.EUL=1;
		}
		if(this.rowItem.EFF>0){
			if(!Number.isInteger(this.rowItem.EFF)){
				this.rowItem.EFF=Math.ceil(this.rowItem.EFF);
			}
			
		}else{
			this.rowItem.EFF=1;
		}*/
		this.rowItem['edit']=true;
		this.rowItem['editIndex']=index;
		if(!this.rowItem['NTCHK']){
			setTimeout(() => {
				let years=$('input.yearbox');//console.log(years);
				for(let i=0; i<years.length; i++){//for(let i=0; i<this.rowItem.allocate.length; i++){
					if(years[i]){
						if(that.rowItem.selectedYear.indexOf(i+1)>-1){
							years[i].checked=true;
						}else{
							years[i].checked=false;
						}
					}
				}
			}, 200);
		
		}
		
		//console.log(this.rowItem);
		await this.getPCAData();
		this.rrRows=new Array(Math.ceil(this.pcaOp.reserve/this.rrCols.length)).fill(1)
		$("#costDetailModal").modal('show');
	}
	editPcaRow(index){console.log(index)
		//console.log(this.rowItem);
		if(!this.rowItem.allow&&this.rowItem.reserve>0){
			this.reserveWarn=true;
			return
		}
		this.rowItem.RUL=this.getRound(this.rowItem.EUL-this.rowItem.EFF, 0);//this.rowItem.EUL-this.rowItem.EFF;
		if(this.reserveWarn){
			if(!this.rowItem.allow){
				return
			}
		}
		//if(this.rowItem.Item==''||this.rowItem.Quantity==0||this.rowItem.Unit==''||this.rowItem.Cost==0){
		if(this.rowItem.Item==''||this.rowItem.Quantity==0||this.rowItem.Unit==''){
			this.validateWarn1=true;
			return
		}
		//this.rowItem.Cycle=this.getRound(this.rowItem.Quantity*this.rowItem.Cost,2);
		let data=this.getContentData('data');
		let id=this.getContentData('id');
		let title=this.getContentData('SECTION_TITLE');
		//console.log(data);
		let info=JSON.parse(JSON.stringify(this.rowItem));
		if(data.version&&data.version=='2'){
			let id=data.rows[index][0].costId;
			let v2Index=data.COST.findIndex(item=>item.costId==id);
			data.rows = data.rows.filter(row => row[0].costId!=id);
			//console.log(data.rows);
			let row=[]
			for(let col of data.cols){
			let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'', 'KEY':''};
			item.COLUMNINTERNALNAME=col.INTERNALNAME;
			if(this.rowItem[col.KEY]||this.rowItem[col.KEY]==0){
				item.DATA=this.rowItem[col.KEY].toString();
			}
			item.KEY=col.KEY;
			if(col.KEY=='Cost'||col.KEY=='Cycle'||col.KEY=='Immediate'||col.KEY=='Short'){
				item.sign=this.currSign;
			}else if(col.KEY=='Percent'){
				item.sign='%';
			}
			if((this.pcaOp.term=='Exclude')&&(col.KEY=='Short')){
				item['hide']='Y';
			}
			if(col.KEY=='Cycle'||col.KEY=='Percent'){
				item['hide']='Y';
			}
			if(col.KEY=='RUL'){
				if(this.rowItem.RULtext){
					item.DATA=this.rowItem.RULtext;
				}
			}
			//console.log(item)
			row.push(item);
			
		}
		let rowBase=JSON.parse(JSON.stringify(row));
			let keep=true;
			if(this.rowItem.Immediate>=0&&this.rowItem.immiCHK){
				let val1='Immediate';
				let val2=this.rowItem.Immediate;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);//console.log(v2row)
				
				data.rows.splice(index, 0, v2row);
				keep=false;
				index++
			}/*else{
				
				if(this.rowItem.immiCHK){
					let val1='Immediate';
					let val2=0;					
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);console.log(v2row)
					data.rows.splice(index, 0, v2row);
					keep=false;
					index++
				}			
				
			}*/
			if(this.rowItem.Short>=0&&this.rowItem.shortCHK){
				let val1='Short';
				let val2=this.rowItem.Short;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);//console.log(v2row)
				
				data.rows.splice(index, 0, v2row);
				keep=false;
				index++
			}/*else{
				if(this.rowItem.shortCHK){
				let val1='Short';
				let val2=0;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);console.log(v2row)
				
				data.rows.splice(index, 0, v2row);
				keep=false;
				index++
				}
			}*/
			/*if(info.allocate){//console.log(info.allocate)
				for(let i=0; i<info.allocate.length; i++){
					if(info.allocate[i]>0){//console.log(info.allocate[i])
						let val1=i+1;
						let val2=info.allocate[i];//console.log(val1,val2)
						let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
						
						data.rows.splice(index, 0, v2row);
						index++;
						keep=false;
					}
					
					
				}
			}*/
			if(info.selectedYear.length>0&&info.allocate){
				for(let i of info.selectedYear){
					if(i<(this.pcaOp.reserve+1)){
						let val1=i;
						let val2=0; 
						if(info.allocate[i-1]>0){
							val2=info.allocate[i-1];
						}
						//console.log(val1,val2)
						let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
						data.rows.splice(index, 0, v2row);
						index++
						keep=false;
					}
				}
			}
			if((!this.rowItem.shortCHK)&&(!this.rowItem.immiCHK)&&info.selectedYear.length==0){
				let val1='N/A';
				let val2=0;//console.log(val1,val2)
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				data.rows.push(v2row);
				keep=false;

		}
			data.COST[v2Index]=info;
		}else{
			for(let i=0; i<data.rows[index].length; i++){
				if(this.rowItem[data.rows[index][i].KEY]>=0||this.rowItem[data.rows[index][i].KEY].length>0){//console.log(data.rows[index][i].KEY)
					if(!this.rowItem.immiCHK&&data.rows[index][i].KEY=='Immediate'){
						data.rows[index][i].DATA='0';
					}else if(!this.rowItem.shortCHK&&data.rows[index][i].KEY=='Short'){
						data.rows[index][i].DATA='0';
					}else{
						data.rows[index][i].DATA=this.rowItem[data.rows[index][i].KEY].toString();
					}
					
				}
			}
			data.COST[index-1]=info;
			//console.log(data)
		}
		$('#costDetailModal').modal('hide');
		
		this.getTotalCost();
		if(this.summaryStatus){
			this.getTotalSummary()
		}
		this.autoSave('modify',id, title, "O" );
		//this.toSummarySec(data['COST']);
	}
	tableZoom(data, type?){
		//console.log(data)
		$("#costZoomModal").modal('show');
		if(type){
			this.repairData=data;
			this.repairData['TYPE']=type;
		}else{
			this.repairData=data;
		}
		//console.log(this.repairData)
	}
	checkAllocate(action){//console.log(this.reportInfo.PCA_INDICATOR)
		let type=false;
		if(action=='Y'){
			type=true;
		}
		$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
			if(!$(this).prop('disabled')){
				$(this).prop('checked', type);
			}
		})
		if(this.reportInfo.PCA_INDICATOR=='4099e'){
			this.getReserve1();
		}else if(this.reportInfo.PCA_INDICATOR=='Y'){
			this.getReserve();
		}		
	}
	checkFrmAllocate(action){//console.log(this.reportInfo.PCA_INDICATOR)
		let type=false;
		if(action=='Y'){
			type=true;
		}
		$('input.yearbox1').each(function(e){////console.log($(this)[0].checked);
			if(!$(this).prop('disabled')){
				$(this).prop('checked', type);
			}
		})
		this.getReserve2();				
	}
	changeUnit(){
		if(this.reportInfo.PCA_INDICATOR=='Y'){
		for(let sec of this.contents){
			if(sec.TYPE=='COST'){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='UNITTABLE'){
						let rows=sec1.data.rows;//console.log(rows)
						rows[1][0].DATA="Total "+ this.pcaOp.multiplier;
						rows[2][0].DATA='Reserve per '+this.pcaOp.multiplier+' per Year (Uninflated)';
						rows[3][0].DATA='Reserve per '+this.pcaOp.multiplier+' per Year (Inflated)';
					}
				}
			}
		}
		if(this.summaryStatus){
			this.changeOpItem();
		}
	}else if(this.reportInfo.PCA_INDICATOR=='4099e'){
			let table=this.getSecbyId(this.contents,'fme_exec_sum_capital_needs_1');
			for(let row of table.data.rows){//console.log(row)		
				if(row[1].KEY=='AU'){
					row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Uninflated)'
				}
				if(row[1].KEY=='AI'){
					row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Inflated)'
				}			
			}
		}
		
		//if(this.autoFlag){
			this.autoSave('PCA Factor Update',this.pcaOp.multiplier,"PCA Factor Update");
//};
	}
	updatePdfs(){
		
		for(let item of this.appendices.SUB_SECTIONS){
			if(item.app&&item.app.length>0){
				for(let rf of item.app){//console.log(rf)
					if(!rf.url||rf.url.length==0){
						if(this.pdfs&&this.pdfs.length>0){
						let name=rf.name;//console.log()
						let index=this.pdfs.findIndex(slot=>slot.REPORT_NAME==name);
							if(index>-1&&!rf.COPIED){
								rf['url']=this.pdfs[index].REPORT_URL;
							}//else{
							//rf['url']="";
						//}
						}
					}else if(rf.url&&rf.url.length>0){
						let name=rf.name;//console.log();
						if(name!="Photo log"&&name!="Photo Log"){
							if(this.pdfs&&this.pdfs.length>0){
								let index=this.pdfs.findIndex(slot=>slot.REPORT_NAME==name&&!rf.COPIED);//console.log(index)
								if(index>-1){
									rf['url']=this.pdfs[index].REPORT_URL;
								}else if(!rf.COPIED&&rf.ERIS_FILE=="Y"){
									rf['url']="";
								}
							}else{
								if(!rf.COPIED&&rf.ERIS_FILE=="Y"){
									rf['url']="";
								}
							}
						}
					}
				}
			}
			this.checkNoData(item)
		}
		//console.log(this.appendices)
		//this.autoSave('appendix update');
	}
	getAddedPdf(info){//console.log(info);
		this.addedPdfs=[];
		if(info.app&&info.app.length>0){
			for(let data of info.app){
				this.addedPdfs.push(data.url);
			}
		}
		//console.log(this.addedPdfs);
	}
	private getIndices(str, substr){
		let indices=[];
		let index = str.indexOf(substr);
		while(index !== -1) {
			indices.push(index);
			index = str.indexOf(substr, index + 1);
		}
		////console.log(indices);
		return indices;
	}
	private getAllSlotId(str){////console.log(str)
		if(!str)return
		let indices1=this.getIndices(str,'data-id=');////console.log(indices1);
		let indices2=this.getIndices(str, 'data-type="text" data-status');////console.log(indices2);
		let ids=[];
		for(let i=0; i<indices1.length; i++){
			let text=str.substring(indices1[i],indices2[i]).split('"')[1]; ////console.log(text)
			let id=parseInt(text);
			if(id>-1&&ids.indexOf(id)==-1){
			ids.push(parseInt(text));
			}
		}
		////console.log(ids);
		return ids
	}
	private getAllSlotInfo(){////console.log(this.allSlots)
		let that=this;
		let slots=$('#inputContent').find('.placeholder'); ////console.log('toslot',slots);
		let pdfnameslots=$('#pdfEditor').find('.placeholder'); //console.log(pdfnameslots);
		if(pdfnameslots.length>0){
			for(let p of pdfnameslots ){
				slots.push(p);
			} ////console.log('toslot1',slots);
		}
		let allInfo=[];
		slots.each(function(){////console.log(this);
			let id=$(this).data('id'); ////console.log(id);
			let indexAll=allInfo.findIndex(slot=>slot.SLOT_ID==id);////console.log(indexAll)
			if(indexAll==-1&&id>-1){
				//let test=$(this)[0].innerHTML;console.log(test)
				//let status=$(this).data('status');console.log(status)
				//let text=$(this).prop("outerHTML").replace(' ck-widget','').replace(' ck-widget_selected','').replace(' contenteditable="false"','').replace('"','\"').trim(); ////console.log(text);
				let index=that.allSlots.findIndex(slot=>slot.SLOT_ID==id);////console.log(index);
				//let replaceText="";
				if(index>-1){
					allInfo.push(that.allSlots[index]);
						/*if(that.allSlots[index].CONTENT.length>0){
						let content=' data-status="Y">'+that.allSlots[index].CONTENT+'<';////console.log(content);
						replaceText=text.replace(' data-status="N"','').replace(' data-status="Y"','').replace(/\>(.*?)\</, content); ////console.log(replaceText);
						let info={'SLOT_ID':id, 'oldText':text, 'replaceText':replaceText};
						allInfo.push(info);
					
					}else if(that.allSlots[index].CONTENT.length==0){
						let info={'SLOT_ID':id, 'oldText':text, 'replaceText':''};////console.log(info);
						allInfo.push(info);
					
					}*/
				}
			}
		})
		//console.log(allInfo)
		return allInfo;
	}
	private async newReplace(data, type){
		/*let slots=$('#inputContent').find('.placeholder');
		slots.each(function(){
				let id=$(this).data('id');
				if(id==data.SLOT_ID){	
					let test=$(this)[0].innerHTML;//console.log(test)
					let status=$(this).data('status');//console.log(status)				
					if(data.CONTENT.length>0){
						$(this)[0].innerHTML=data.CONTENT;
						$(this).attr('data-status','Y');
					}else if(data.CONTENT.length==0){
						$(this).attr('data-status','N');
						let text='{'+data.KEY+'}';
						$(this)[0].innerHTML=text;
					}
				}
			})*/
			await this.newreplaceContent(data, type);
		
	}
	replaceSlotText(info, sec, key1, key2? ){
		let allPlaceholder=$(sec[key1]).find('.placeholder');
		let that = this; 
		allPlaceholder.each(function(){
			let id=$(this).data('id');
			if(id==info.SLOT_ID){	
				let test=$(this)[0].innerHTML;
				let test1=$(this)[0].outerHTML;	
				if(info.CONTENT.length>0&&test!=info.CONTENT){
					$(this)[0].innerHTML=info.CONTENT;
					$(this).attr('data-status','Y');
					let test2=$(this)[0].outerHTML;
					sec[key1]=sec[key1].replaceAll(test1, test2);
					if(key2){
						sec[key2]=that.sanitizer.bypassSecurityTrustHtml(sec[key1]);
					}					
				}else if(info.CONTENT.length==0&&test!=info.CONTENT){
					$(this).attr('data-status','N');
					let text='{'+info.KEY+'}';
					$(this)[0].innerHTML=text;
					let test2=$(this)[0].outerHTML;	
					sec[key1]=sec[key1].replaceAll(test1, test2);
					if(key2){
						sec[key2]=that.sanitizer.bypassSecurityTrustHtml(sec[key1]);
					}
				}
			}
		})
		return sec
	}
	async newreplaceContent(info, type){
		if(this.pdfFname && this.pdfFname['text'] && this.pdfFname['text'].length>0){
			let slotIds=this.getAllSlotId(this.pdfFname['text']);
			if(slotIds&&slotIds.length>0){
				if(slotIds.indexOf(info.SLOT_ID)>-1){
					this.pdfFname=this.replaceSlotText(info, this.pdfFname, 'text');console.log(this.pdfFname);
					console.log($('<div>'+this.pdfFname['text']+'</div>')[0].innerText);
					let val=$('<div>'+this.pdfFname['text']+'</div>')[0].innerText
					this.pdfFname['name']=val;console.log(this.pdfFname);
					await this.savepdf();
				}
			}
		}
		if(this.curCellBK&&this.curCellBK['htmltext']&&this.curCellBK['htmltext'].length>0){
			let slotIds=this.getAllSlotId(this.curCellBK.htmltext);
			if(slotIds&&slotIds.length>0){
				if(slotIds.indexOf(info.SLOT_ID)>-1){
					this.curCellBK=this.replaceSlotText(info, this.curCellBK, 'htmltext','DATA');
				}
			}
		}
		for(let sec of this.frontpages){
			if(sec.text&&sec.text.length>0){
				//sec=this.replaceSlotText(info, sec, 'text', 'htmltext');
				let slotIds=this.getAllSlotId(sec.text);
				if(slotIds&&slotIds.length>0){
					if(slotIds.indexOf(info.SLOT_ID)>-1){
						sec=this.replaceSlotText(info, sec, 'text', 'htmltext')
					}
				}
			}
			if(sec.SUB_SECTIONS){
			for(let sec1 of sec.SUB_SECTIONS){
				if(sec1.text&&sec1.text.length>0){
					let slotIds1=this.getAllSlotId(sec1.text);
					if(slotIds1&&slotIds1.length>0){
						if(slotIds1.indexOf(info.SLOT_ID)>-1){
							sec1=this.replaceSlotText(info, sec1, 'text', 'htmltext')
						}
					}
				}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])&&(sec1.id!='phaseI_project_summary_table')){
					for(let row of sec1.data.rows){
						if(row.items&&row.items.length>0){
							for(let item of row.items){//console.log(item)
								if(item.slots&&item.slots.findIndex(a=>a.SLOT_ID==info.SLOT_ID)>-1){
									item=this.replaceSlotText(info, item, 'htmltext','DATA');

								}
							}
						}
					}
					
				}else if(sec1.id=='phaseI_project_summary_table'){
					for(let row of sec1.data.rows){//console.log(row)
						for(let item of row){//console.log(item)
							if(item.slots&&item.slots.length>0){
								if(item.slots.indexOf(info.SLOT_ID)>-1){
									item=this.replaceSlotText(info, item, 'html', 'secHtml')
								}
							}
						}
						
					}
				}
			}
			}
		}
		for(let sec of this.contents){
			if(sec.id=='frm_sec'){
				let allHtml=this.frmService.frmHtmlCat;
				let allSubHtml=this.frmService.frmHtmlSubCat;
				for(let frmhtml of allHtml){//console.log(sec.frmData[frmhtml])
					for(let subCate of allSubHtml[frmhtml]){
						if(sec.frmData[frmhtml]){
							let frmsec=sec.frmData[frmhtml][subCate];//console.log(frmsec);console.log(frmsec.html)
							let slotIds=this.getAllSlotId(frmsec.html);
							if(slotIds&&slotIds.length>0){
								if(slotIds.indexOf(info.SLOT_ID)>-1){
									//for(let item of slotIds){
									//	let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);
									//	if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
											frmsec=this.replaceSlotText(info, frmsec, 'html', 'secHtml'); //console.log(frmsec)
										//}					
									//}
								}
							}
						}
						
					}
				}
				if(sec.frmData.AccountNameHTML){
					let slotIds=this.getAllSlotId(sec.frmData.AccountNameHTML.html);
					if(slotIds&&slotIds.length>0){
						if(slotIds&&slotIds.indexOf(info.SLOT_ID)>-1){
							//for(let item of slotIds){
							//	let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);
							//	if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
									sec.frmData.AccountNameHTM=this.replaceSlotText(info, sec.frmData.AccountNameHTML, 'html', 'secHtml')
								//}					
							//}
						}
					}
				}
				
			}else if(sec.text&&sec.text.length>0){
				let slotIds=this.getAllSlotId(sec.text);
				if(slotIds&&slotIds.length>0){
					if(slotIds.indexOf(info.SLOT_ID)>-1){
						sec=this.replaceSlotText(info, sec, 'text', 'htmltext')
					}
				}

			}
			if(sec.pisummarydata&&sec.pisummarydata.length>1){
				for(let item of sec.pisummarydata){//console.log(row)
					if(item.slots&&item.slots.length>0){
						if(item.slots.indexOf(info.SLOT_ID)>-1){
							item=this.replaceSlotText(info, item, 'html', 'secHtml'); 
						}
					}					
				}
			}
			/*if(sec.summaryData&&sec.summaryData.length>1){console.log(sec.summaryData)
				for(let row of sec.summaryData[0].data.rows){
					for(let item of row){
						if(item.slots&&item.slots.length>0){
							if(item.slots&&item.slots.findIndex(a=>a==info.SLOT_ID)>-1){
								item=this.replaceSlotText(info, item, 'html','secHtml');

							}
						}
					}
					
				}
			}*/
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
			for(let sec1 of sec.SUB_SECTIONS){
				
				if(sec1.text&&sec1.text.length>0){
					let slotIds1=this.getAllSlotId(sec1.text);
					if(slotIds1.indexOf(info.SLOT_ID)>-1){
						sec=this.replaceSlotText(info, sec1, 'text', 'htmltext')
					}
				}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])){
					for(let row of sec1.data.rows){
						if(row.items&&row.items.length>0){
						for(let item of row.items){
							if(item.slots&&item.slots.findIndex(a=>a.SLOT_ID==info.SLOT_ID)>-1){
								item=this.replaceSlotText(info, item, 'htmltext','DATA');

							}
						}
						}
					}
				
				}else if(sec1.id=='phaseI_project_summary_table'){
					for(let row of sec1.data.rows){//console.log(row)
						for(let item of row){//console.log(item)
							if(item.slots&&item.slots.length>0){
								if(item.slots.indexOf(info.SLOT_ID)>-1){
									item=this.replaceSlotText(info, item, 'html', 'secHtml')
								}
							}
						}
						
					}
				}else if(sec1.id=='pca_summary_0'){
					for(let row of sec1.data.rows){//console.log(row)
						for(let item of row){//console.log(item)
							if(item.slots&&item.slots.length>0){
								let index=item.slots.findIndex(slot=>slot.SLOT_ID==info.SLOT_ID);
								if(index>-1){
									item=this.replaceSlotText(info, item, 'htmltext', 'secHtml')
								}
							}
						}
						
					}
				}else if(sec1.TYPE=='frm1104'){
						if(sec1.id=='frm1104-2-2'){
							let items=sec1.data.sub[10].otherDetail.providers;				
								for(let item of items){
									let slots=this.getAllSlotId(item.html);
									if(slots&&slots.length>0){
										if(slots.indexOf(info.SLOT_ID)>-1){
											item=this.replaceSlotText(info, item, 'html', 'secHtml');
											item.text=item.html.replace(/<[^>]*>/g, "");//$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
										}									
									}
								}							
						}else{
							let ids=['frm1104-0-0','frm1104-0-1','frm1104-0-2','frm1104-0-3'];
							if(ids.indexOf(sec1.id)>-1){
								let items=sec1.data;						
									let keys=Object.keys(items);
									for(let key of keys){
										let item=items[key];
										let slots=this.getAllSlotId(item.html);
										if(slots&&slots.length>0){
											if(slots.indexOf(info.SLOT_ID)>-1){
												item=this.replaceSlotText(info, item, 'html', 'secHtml');
												item.text=item.html.replace(/<[^>]*>/g, "");//$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
											}									
										}
									}
									
								
							}
						}
				}else if(sec1.TYPE=='frm1103'){
					if(sec1.id=='frm1103-0-0'||sec1.id=='frm1103-2-1'){
						let items=sec1.data;console.log(items)						
							let keys=Object.keys(items);
							for(let key of keys){
								let item=items[key];
								let slots=this.getAllSlotId(item.html);
								if(slots&&slots.length>0){
									if(slots.indexOf(info.SLOT_ID)>-1){
										item=this.replaceSlotText(info, item, 'html', 'secHtml');
										item.text=item.html.replace(/<[^>]*>/g, "");//$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;
									}									
								}
							}
							
						
					}
				}
				if(sec1.pisummarydata&&sec1.pisummarydata.length>1){
					for(let item of sec1.pisummarydata){//console.log(row)
						if(item.slots&&item.slots.length>0){
							if(item.slots.indexOf(info.SLOT_ID)>-1){
								item=this.replaceSlotText(info, item, 'html', 'secHtml')
							}
						}					
					}
				}
				if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
				for(let sec2 of sec1.SUB_SECTIONS){					
					if(sec2.text&&sec2.text.length>0){
						let slotIds2=this.getAllSlotId(sec2.text);
						if(slotIds2.indexOf(info.SLOT_ID)>-1){
							sec2=this.replaceSlotText(info, sec2, 'text', 'htmltext')
						}

					}else if(sec2.TYPE=='TABLE'&&sec2.data&&(!sec2.data['erisName'])){
					for(let row of sec2.data.rows){
						if(row.items&&row.items.length>0){
						for(let item of row.items){
							if(item.slots&&item.slots.findIndex(a=>a.SLOT_ID==info.SLOT_ID)>-1){
								item=this.replaceSlotText(info, item, 'htmltext','DATA');
							}
						}
						}
					}
				
					}else if(sec2.TYPE=='4099e'){
						for(let row of sec2.data.rows){
							for(let cell of row){
								if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==info.SLOT_ID)>-1){
									cell=this.replaceSlotText(info, cell, 'htmltext','DATA');
									let val=$('<div>'+cell['htmltext']+'</div>')[0].innerText
									cell.data=val;console.log(cell.data);									
								}							
							}					
						}
			
					}
					if(sec2.pisummarydata&&sec2.pisummarydata.length>1){
						for(let item of sec2.pisummarydata){//console.log(row)
							if(item.slots&&item.slots.length>0){
								if(item.slots.indexOf(info.SLOT_ID)>-1){
									item=this.replaceSlotText(info, item, 'html', 'secHtml')
								}
							}					
						}
					}
			
				}
			}}
			}
		}
		//console.log(info);
		if(type&&type=='local'){
			this.autoSave('slot update',info.SLOT_ID, info);
		}
	}
	
	updateSlots(){/*//console.log(this.exSlots);
	//console.log(this.updatedSlots);
	Swal.fire({
			icon:'info',
			title: 'Are you sure you want to change these items?',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			confirmButtonText: "Yes",
			cancelButtonText: "No",
			backdrop:false,
			preConfirm: () => {
				if(this.exSlots.length>0){
		let k=0;
		for(let item of this.exSlots){
			k++;//console.log(k);
			let inputJson={"PROCEDURE":"addslottoreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SLOT_ID":item.SLOT_ID,"SLOT_CONTENT":item.SLOT_CONTENT};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=='N'){
					Swal.fire({
						html: ' <span style="color:red; text-align:left">'+data.MESSAGE+'</span>'							
					})
				}else{
					if(k==this.exSlots.length&&this.updatedSlots.length==0){
						Swal.fire({
							icon:'success',
							text: data.MESSAGE
						})
						this.loading=false;
					}
				}
			})
		}
	}
	if(this.updatedSlots.length>0){
		this.loading=true;
		let i=0;
		for(let item of this.updatedSlots){
			i++;//console.log(i);
			this.updateSlot(item.SLOT_ID, item.CONTENT);
			if(i==this.updatedSlots.length){//console.log(i)
				let selectedslot=[];
		//if(slot){
		//	selectedslot.push(slot);
		//}else{
			selectedslot=this.updatedSlots;
		//}
		this.allSlotInfo=[];
		setTimeout(() => {
		let allitems=this.getAllSlotInfo();
		for(let item of allitems){
			let index=selectedslot.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
			if(index>-1){
				item['KEY']=selectedslot[index].SLOT_KEY;
				item['CONTENT']=selectedslot[index].SLOT_NEW_VALUE;
				this.allSlotInfo.push(item)
			}
		}
		//console.log(this.allSlotInfo);
		let that=this;
		
			that.replaceContents('update');
		},1500);
		//this.replaceContents('update');
		}
		}
	}
				
		if(this.updatedSlots.length==0&&this.exSlots.length==0){
			Swal.fire({
				icon: 'info',
				title: 'Please selected Repeat Field first',
			})
		}
			}
		})*/
	
	}
	async replaceSlots(){//console.log('replace')
		this.allSlotInfo=this.getAllSlotInfo();
		////console.log(this.allSlotInfo);
		await this.replaceContents();
	}
	async replaceContents(type?){
		if(this.pdfFname && this.pdfFname['text'] && this.pdfFname['text'].length>0){
			let slotIds=this.getAllSlotId(this.pdfFname['text']);
			if(slotIds&&slotIds.length>0){
				for(let item of slotIds){
					let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);
					if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
						this.pdfFname=this.replaceSlotText(this.allSlotInfo[index], this.pdfFname, 'text');
						//console.log($('<div>'+this.pdfFname['text']+'</div>')[0].innerText);
						let val=$('<div>'+this.pdfFname['text']+'</div>')[0].innerText;
						this.pdfFname['name']=val;						
						/*this.pdfFname['text']=this.pdfFname['text'].replaceAll(this.allSlotInfo[index].oldText,this.allSlotInfo[index].replaceText);
						this.pdfFname['name']=$('<div>'+this.pdfFname['text']+'</div>')[0].innerText;*/
								
					}
				}
				//this.pdfFname.reqIndex++;
				await this.savepdf();
			}
		}
		for(let page of this.frontpages){
			if(page.text&&page.text.length>0){
				let slotIds=this.getAllSlotId(page.text);
				if(slotIds&&slotIds.length>0){
					for(let item of slotIds){
						let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);
						if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
							page=this.replaceSlotText(this.allSlotInfo[index], page, 'text', 'htmltext')
							/*let abc=page.text.indexOf(this.allSlotInfo[index].oldText);////console.log(abc);
							page.text=page.text.replaceAll(this.allSlotInfo[index].oldText,this.allSlotInfo[index].replaceText);
							page.htmltext=this.sanitizer.bypassSecurityTrustHtml(page.text);*/
						}
								
					
				}
				}
			}
		}
		for(let sec of this.frontpages){
			if(sec.text&&sec.text.length>0){
				let slotIds=this.getAllSlotId(sec.text); ////console.log(slotIds);
				if(slotIds&&slotIds.length>0){
					for(let item of slotIds){
						let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);////console.log(index);
						if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
							sec=this.replaceSlotText(this.allSlotInfo[index], sec, 'text', 'htmltext')
							/*let abc=sec.text.indexOf(this.allSlotInfo[index].oldText);////console.log(abc);
							sec.text=sec.text.replaceAll(this.allSlotInfo[index].oldText,this.allSlotInfo[index].replaceText);
							sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);*/
						}
					}
				}
			}
			if(sec.SUB_SECTIONS){
			for(let sec1 of sec.SUB_SECTIONS){
				if(sec1.text&&sec1.text.length>0){
					let slotIds1=this.getAllSlotId(sec1.text); ////console.log(slotIds1);
					if(slotIds1&&slotIds1.length>0){
						for(let item of slotIds1){						
							let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);////console.log(index);
							if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
								sec1=this.replaceSlotText(this.allSlotInfo[index], sec1, 'text', 'htmltext')
								/*let abc=sec1.text.indexOf(this.allSlotInfo[index].oldText);////console.log(abc);
								sec1.text=sec1.text.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
								sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);*/
							}
						}
					}
				}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])&&sec1.id!='phaseI_project_summary_table'){//console.log(sec1)
					for(let row of sec1.data.rows){//console.log(row)
						if(row.items&&row.items.length>0){
						for(let item of row.items){//console.log(item)
							if(item.slots&&item.slots.length>0){
								for(let cell of item.slots){//console.log(cell)
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell.SLOT_ID);////console.log(index);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										item=this.replaceSlotText(this.allSlotInfo[index], item, 'htmltext','DATA');
										//item.htmltext=item.htmltext.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
										//item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
								
									}
								}
							}
						}
						}
					}
					
				}else if(sec1.id=='phaseI_project_summary_table'){
					for(let row of sec1.data.rows){//console.log(row)
						for(let item of row){//console.log(item)
							if(item.slots&&item.slots.length>0){
								for(let cell of item.slots){//console.log(cell)
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);////console.log(index);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
								
									}
								}
							}
						}
						
					}
				}
				
			
			}
			}
		}
		for(let sec of this.contents){
			if(sec.id=='frm_sec'){
				let allHtml=this.frmService.frmHtmlCat;
				let allSubHtml=this.frmService.frmHtmlSubCat;
				for(let frmhtml of allHtml){//console.log(sec.frmData[frmhtml])
					if(sec.frmData[frmhtml]){
						for(let subCate of allSubHtml[frmhtml]){						
							let frmsec=sec.frmData[frmhtml][subCate];
							let slotIds=this.getAllSlotId(frmsec.html);
							if(slotIds&&slotIds.length>0){
								for(let item of slotIds){
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										frmsec=this.replaceSlotText(this.allSlotInfo[index], frmsec, 'html', 'secHtml'); console.log(frmsec)
									}					
								}
							}
						}
						
					}
				}
				if(sec.frmData.AccountNameHTML){
					let slotIds=this.getAllSlotId(sec.frmData.AccountNameHTML.html);
					if(slotIds&&slotIds.length>0){
						for(let item of slotIds){
							let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);
							if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
								sec.frmData.AccountNameHTM=this.replaceSlotText(this.allSlotInfo[index], sec.frmData.AccountNameHTML, 'html', 'secHtml')
							}					
						}
					}
				}	


				
			}else if(sec.text&&sec.text.length>0){
				let slotIds=this.getAllSlotId(sec.text); ////console.log(slotIds);
				if(slotIds&&slotIds.length>0){
				for(let item of slotIds){
					
						let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);////console.log(index);
						if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
							sec=this.replaceSlotText(this.allSlotInfo[index], sec, 'text', 'htmltext')
						
							/*let abc=sec.text.indexOf(this.allSlotInfo[index].oldText);////console.log(abc);
							sec.text=sec.text.replaceAll(this.allSlotInfo[index].oldText,this.allSlotInfo[index].replaceText);
							sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);*/
					
						}
								
					
				}
				}
			}
			if(sec.pisummarydata&&sec.pisummarydata.length>1){//console.log(sec.pisummarydata)
				for(let item of sec.pisummarydata){//console.log(row)
					
						if(item.slots&&item.slots.length>0){
							for(let cell of item.slots){//console.log(cell)
								let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);////console.log(index);
								if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
									item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
						
								}
							}
						}
					
					
				}
			}
			
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
			for(let sec1 of sec.SUB_SECTIONS){
				if(sec1.text&&sec1.text.length>0){
					let slotIds1=this.getAllSlotId(sec1.text); ////console.log(slotIds1);
					if(slotIds1&&slotIds1.length>0){
					for(let item of slotIds1){						
							let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);////console.log(index);
							if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
								sec1=this.replaceSlotText(this.allSlotInfo[index], sec1, 'text', 'htmltext')
								
							}
						
					}
					}
				}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])){//console.log(sec1)
					for(let row of sec1.data.rows){//console.log(row)
						if(row.items&&row.items.length>0){
						for(let item of row.items){//console.log(item)
							if(item.slots&&item.slots.length>0){
								for(let cell of item.slots){//console.log(cell)
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell.SLOT_ID);////console.log(index);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										item=this.replaceSlotText(this.allSlotInfo[index], item, 'htmltext','DATA');
										/*item.htmltext=item.htmltext.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
										item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);*/
								
									}
								}
							}
						}
						}
					}
					
				}else if(sec1.id=='phaseI_project_summary_table'){console.log(sec1)
					for(let row of sec1.data.rows){//console.log(row)
						for(let item of row){//console.log(item)
							if(item.slots&&item.slots.length>0){
								for(let cell of item.slots){//console.log(cell)
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);////console.log(index);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
								
									}
								}
							}
						}
						
					}
				}else if(sec1.id=='pca_summary_0'){
					for(let row of sec1.data.rows){//console.log(row)
						for(let item of row){
							if(item.slots&&item.slots.length>0){
								for(let cell of item.slots){
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell.SLOT_ID);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										item=this.replaceSlotText(this.allSlotInfo[index], item, 'htmltext','secHtml');
										//item.htmltext=item.htmltext.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
										//item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
								
									}
								}
							}
						}
						
					}
				}else if(sec1.TYPE=='frm1104'){
					if(sec1.id=='frm1104-2-2'){
						let items=sec1.data.sub[10].otherDetail.providers;				
							for(let item of items){
								let slots=this.getAllSlotId(item.html);
								if(slots&&slots.length>0){
									for(let cell of slots){
										let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);
										if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
											item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
											item.text=item.html.replace(/<[^>]*>/g, "");//$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;	
										}
									}									
								}
							}							
					}else{
					let ids=['frm1104-0-0','frm1104-0-1','frm1104-0-2','frm1104-0-3'];
					if(ids.indexOf(sec1.id)>-1){
						let items=sec1.data;						
							let keys=Object.keys(items);
							for(let key of keys){
								let item=items[key];
								let slots=this.getAllSlotId(item.html);
								if(slots&&slots.length>0){
									for(let cell of slots){
										let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);
										if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
											item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
											item.text=item.html.replace(/<[^>]*>/g, "");//$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;	
										}
									}
								}
							}
							
						
					}
				}
				}else if(sec1.TYPE=='frm1103'){
					if(sec1.id=='frm1103-0-0'||sec1.id=='frm1103-2-1'){
						let items=sec1.data;						
							let keys=Object.keys(items);
							for(let key of keys){
								let item=items[key];
								let slots=this.getAllSlotId(item.html);
								if(slots&&slots.length>0){
									for(let cell of slots){
										let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);
										if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
											item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
											item.text=item.html.replace(/<[^>]*>/g, "");//$(item.html.replace('<p>','').replace('</p>',''))[0].innerHTML;	
										}
									}
								}
							}
						
					}
				}
				if(sec1.pisummarydata&&sec1.pisummarydata.length>1){//console.log(sec1.pisummarydata)
					for(let item of sec1.pisummarydata){//console.log(row)
						
							if(item.slots&&item.slots.length>0){
								for(let cell of item.slots){//console.log(cell)
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);////console.log(index);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');
								
									}
								}
							}
						
						
					}
				}
				
				if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
				for(let sec2 of sec1.SUB_SECTIONS){
					if(sec2.text&&sec2.text.length>0){
						let slotIds2=this.getAllSlotId(sec2.text);// //console.log(slotIds2);
						if(slotIds2&&slotIds2.length>0){
							for(let item of slotIds2){
						
								let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item);////console.log(index);
								if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
									sec2=this.replaceSlotText(this.allSlotInfo[index], sec2, 'text', 'htmltext')
									/*let abc=sec2.text.indexOf(this.allSlotInfo[index].oldText);////console.log(abc);
									sec2.text=sec2.text.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
									sec2.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec2.text);*/
								}
						
							}
						}
					}else if(sec2.TYPE=='TABLE'&&sec2.data&&(!sec2.data['erisName'])){
						for(let row of sec2.data.rows){
							if(row.items&&row.items.length>0){
								for(let item of row.items){
									if(item.slots&&item.slots.length>0){
										for(let cell of item.slots){
											let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell.SLOT_ID);////console.log(index);
											if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
												item=this.replaceSlotText(this.allSlotInfo[index], item, 'htmltext','DATA');
												//item.htmltext=item.htmltext.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
												//item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
								
											}
										}
									}
								}
							}
						}
					
					}else if(sec2.TYPE=='4099e'){
						for(let row of sec2.data.rows){
							for(let cell of row){
							if(cell.slots&&cell.slots.length>0){
								for(let item of cell.slots){
									let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);////console.log(index);
									if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
										cell=this.replaceSlotText(this.allSlotInfo[index], cell, 'htmltext','DATA');
										let val=$('<div>'+cell['htmltext']+'</div>')[0].innerText;
										cell.data=val;
										/*let key='{'+this.allSlotInfo[index].KEY+"}";
										cell.data=cell.data.replaceAll(key, this.allSlotInfo[index].CONTENT);
										cell.htmltext=cell.htmltext.replaceAll(this.allSlotInfo[index].oldText, this.allSlotInfo[index].replaceText);
										cell.DATA=this.sanitizer.bypassSecurityTrustHtml(cell.htmltext);*/
								
									}
								}
									
							}
						}						
						}
						
					
					}
					if(sec2.pisummarydata&&sec2.pisummarydata.length>1){//console.log(sec2.pisummarydata)
						for(let item of sec2.pisummarydata){//console.log(row)
							
								if(item.slots&&item.slots.length>0){
									for(let cell of item.slots){//console.log(cell)
										let index=this.allSlotInfo.findIndex(slot=>slot.SLOT_ID==cell);////console.log(index);
										if(index>-1&&this.allSlotInfo[index].CONTENT.length>0){
											item=this.replaceSlotText(this.allSlotInfo[index], item, 'html','secHtml');

									
										}
									}
								}
							
							
						}
					}
			
				}
				}
			}
			}
		}
		
		if(type&&type=='update'){
			let that=this;
			if(this.allSlotInfo.length>0){
				for(let info of this.allSlotInfo){
					await that.autoSave('slot update',info.SLOT_ID, info);//console.log('updated slot');
				}
				Swal.fire({
					icon:"success",
					text: "Successfully updated select Repeat Fields.",							
				})
			}
			
			/*let inputJson={"PROCEDURE":"SetUpdateSlotNoForReport", "USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID, 'SLOT_UPDATE':'N'};
				//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				this.loading=false;
				if(data.RESPONSE_STATUS=='N'){
					Swal.fire({
							html: ' <span style="color:red; text-align:left">'+data.MESSAGE+'</span>'							
						})
				}else{
					for(let item of this.allSlotInfo){
						let index=this.updatedSlots.findIndex(slot=>slot.SLOT_ID==item.SLOT_ID);
						if(index>-1){
							this.updatedSlots.splice(index,1)
						}
					}
					Swal.fire({
							icon:"success",
							text: data.MESSAGE,							
						})
				}
			})*/
		}
	}
	tableFilter(filters){//console.log(filters)
		//this.filterShow=true;
		//this.filtering=true;
		//console.log(this.selectedFilters);
		let filterSet=[];
		for(let i=0; i<filters.length; i++){
			let chked={};
			chked['INTERNALNAME']=filters[i].INTERNALNAME;
			chked['DISPLAY_NAME']=filters[i].DISPLAY_NAME;
			chked['FILTER_ITEM']=this.selectedFilters[i];
			filterSet.push(chked);
		}
		//console.log(filterSet);
		let inputJson={'PROCEDURE':'filterslotreport',
				'USER_ID':parseInt(this.userId),
				'REPORT_ID':this.curReport.REPORT_ID,
				'SLOT_ID':this.filterSlot,
				'ORDER_NUM':this.reportInfo.ORDER_NUM,
				'FILTER':filterSet,
				'REPORT_SECTION_ID':this.curEris.id,
				'SHOW_HIDDEN_RECORD':this.showHidden?'Y':'N',
			}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			
			//this.toContentData('', data.rows, '')
			if(data.RESPONSE_STATUS=='N'){
				//console.log(data.MESSAGE);
				//this.filterShow=false;
				this.throwError(data)
								
			}else{
				/*let selectedTable=this.getContentData('data');
				selectedTable.rows=data.rows;*/
				/*let filteredRowId=[]
				for(let row of data.rows){
					let index=row.findIndex(datas=>datas.COLUMNINTERNALNAME=="ES_RID");
					if(index>-1){
						filteredRowId.push(row[index].DATA);
					}
				}*/
				this.curErisData.rows=[];
				let arr=[]
				for(let row of data.rows){
					let arr1=[];
					for(let col of this.curErisData.cols){
						let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
						if(col.INTERNALNAME=='ES_RID'){
							row[index]['hide']=true;
						}
						arr1.push(row[index]);
					}
					arr.push(arr1);
				}
				this.curErisData.rows=arr;
				//console.log(filteredRowId);
				//this.toContentData('filted', filteredRowId, '');
				this.toContentData('selectedFilters', this.selectedFilters, '');
				this.filtering=false;
				this.filterShow=false;
				//this.curErisData.rows=JSON.parse(JSON.stringify(data.row));
				this.erispage=Math.ceil(arr.length/50);
				this.erisstart=0;
				this.erisend=50;
				this.getPageData(0);
				//let sid=this.getContentData('id');
				//let stitle=this.getContentData('SECTION_TITLE');
				this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);
			}
		
		})
	}
	resetTable(filters){console.log(filters);
	//console.log(this.selectedFilters);
		this.toContentData('filted', null, '');
		this.selectedFilters=[];
			for(let filter of filters){
				let chked=[];
				for(let item of filter.FILTER_ITEM){
					if(item.CHECKED=='Y'){
						chked.push(item);
					}
				}
				this.selectedFilters.push(chked);
			}
		this.toContentData('selectedFilters', this.selectedFilters, '');
		//this.filterShow=!this.filterShow;
		//let sid=this.getContentData('id');
		//let stitle=this.getContentData('SECTION_TITLE');
		//this.autoSave('eris filter', sid, stitle);
	}
	resetFilters(filters, id?){//console.log(filters);
	
		this.filterData=filters;
		this.filterSlot=id.toString();
		this.filterShow=!this.filterShow;
		this.selectedFilters=this.getContentData('selectedFilters');
		if(!this.selectedFilters){
			this.selectedFilters=[];
			for(let filter of filters){
				let chked=[];
				for(let item of filter.FILTER_ITEM){
					if(item.CHECKED=='Y'){
						chked.push(item);
					}
				}
				this.selectedFilters.push(chked);
			}
		}
		let sid=this.getContentData('id');
		let stitle=this.getContentData('SECTION_TITLE');
		//this.autoSave('eris filter', sid, stitle);
	}
	copyTableData(data){//console.log(data);
		this.clipBoard=data;
			Swal.fire({
				icon: 'success',
				title: "Table copied! Choose an existing table or create a new table to paste the copied table."
			})
	}
	pasteTableData(){
		let that=this;
		if(this.clipBoard){
			Swal.fire({
			icon:'warning',
			title: 'Existing table content will be overwritten by the copied table content upon pasting. Would you like to continue?',
			confirmButtonText: 'Paste',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
			//let data=that.getContentData('data'); //console.log(data);
			//data=this.clipBoard.data;
			this.selectedCell=null;
			let copied=JSON.parse(JSON.stringify(that.clipBoard));
			let toID=this.getContentData('id');
			let toFID=this.getFContentData('id');
			if(toFID){
				if(copied.data&&copied.data.SLOT_ID){
					Swal.fire({
						icon:'info',
						title: 'ERIS Table is not supported before the Table of Contents section.',
						})
					return
				} 
				this.toFContentData('data', copied.data, '');
				if(that.clipBoard.SECTION_TITLE){
					this.toFContentData('SECTION_TITLE', copied.SECTION_TITLE, '');
				}
				this.ngZone.run(()=>{this.autoSave('modify',that.curDoc.id, that.curDoc.SECTION_TITLE, "F" );})
			}else if(toID){
				if(copied.data&&copied.data.SLOT_ID){
					$('#overlay2').css('display','block');
					let inputJson={"PROCEDURE":"pasteSlotReport",
					"USER_ID":parseInt(this.userId),
					"REPORT_ID":this.curReport.REPORT_ID,
					"SLOT_ID":copied.data.SLOT_ID.toString(),
					"ORDER_NUM":this.reportInfo.ORDER_NUM,
					"REPORT_SECTION_ID":toID,
					"DETAILS_LIST":copied.data.rows};
					//console.log(inputJson)
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						
						$('#overlay2').css('display','none');
						if(data.RESPONSE_STATUS=='N'){
							this.throwError(data)						
						}else{
							copied.data.rows=data.rows;
							for(let row of copied.data.rows){
								if(row[0].COLUMNINTERNALNAME=='ES_RID'){
									row[0]['hide']=true;
								}
							}
						}
					})
				}
				this.toContentData('data', copied.data, '');
				if(that.clipBoard.filted&&that.clipBoard.filted.length>0){
					this.toContentData('filted', copied.filted, '');
				}
				if(that.clipBoard.landscape){
					this.toContentData('landscape', copied.landscape, '');
				}
				if(that.clipBoard.selectedFilters&&that.clipBoard.selectedFilters.length>0){
					this.toContentData('selectedFilters', copied.selectedFilters, '');
				}
				if(that.clipBoard.SECTION_TITLE){
					this.toContentData('SECTION_TITLE', copied.SECTION_TITLE, '');
				}
			//setTimeout(() => {
				this.ngZone.run(()=>{this.autoSave('modify',that.curDoc.id, that.curDoc.SECTION_TITLE, "O" );})
				//this.autoSave('modify',that.curDoc.id, that.curDoc.SECTION_TITLE, "O" );
								
			//},3000);
			
		}
		}
		})
		}else{
			Swal.fire({
			icon:'info',
			title: 'Please copy a table first.',
			})
		}
	}
	dragStart(e){////console.log(e)
		$('#tableModal').draggable("disable");
	}
	dragEnd(e){////console.log(e)
		$('#tableModal').draggable("enable");
	}
	noSeq=false;
	checkParentSeq(doc1, doc2?){
		if(this.optionShow){
			this.optionShow=false;
		}
		this.noSeq=false;
		if(doc1=='N'){
			this.noSeq=true;
		}
		if(doc2&&doc2=='N'){
			this.noSeq=true;			
		}
		
	}
	ifSeq(e, doc){
		let config=$(e.target).prop('checked'); //console.log(config)
		let data='Y';
		if(config){
			data='N';
			if(this.summaryStatus){
				if(doc.OSNAME||doc.SECTION_TITLE.length==0){
					if(doc.pisummarydata){
						delete doc.pisummarydata;
					}else if(doc.pcasummarydata){
						delete doc.pcasummarydata;
					}
				}
				
			}
		}
		this.toContentData('DISPLAY_SEQUENCE', data, '');
		this.generateSeq();
		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}		
		/*if(this.summaryStatus){
			this.getTotalSummary();	
		}*/
	}
	ifSecTitle(e, doc){
		let config=$(e.target).prop('checked');
		if(config){
			doc.OSNAME=true;
		}else{
			delete doc.OSNAME;
		}
		if((config||(!doc.SECTION_TITLE)||doc.SECTION_TITLE.length==0)&&doc.SECTION_SEQUENCE.length==0){			
			if(this.summaryStatus){
				if(doc.pisummarydata){
					delete doc.pisummarydata;
				}else if(doc.pcasummarydata){
					delete doc.pcasummarydata;
				}
			}
		}

		if(this.summaryStatus){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}	
		}		
	}
	selectedSign:number;
	signStyles=[];
	getSignStyles(id){
		let inputJson={"PROCEDURE":"getsignaturestylelist","USER_ID":parseInt(this.userId), "REPORT_ID":parseInt(id)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				
				this.signStyles=data.RW_SIGNATURE_STYLES;
			}
		})	
	}
	signInfo:any;
	companySettings:any;
	getSignInfo(id){
		let inputJson={"PROCEDURE":"getsignaturerelatedinfo","USER_ID":parseInt(this.userId),"REPORT_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.signInfo=data;				
			}
		})
	}
	
	getCompanySettings(){
		let inputJson={"PROCEDURE":"getcompanyinfo","USER_ID":parseInt(this.userId)};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				this.companySettings=data;				
			}
		})
	}
	
	/*get isSignAsDraftDisabled(): boolean {
		return this.companySettings && 
			   this.companySettings.RW_PROFILE_SETTINGS && 
			   this.companySettings.RW_PROFILE_SETTINGS[0] && 
			   this.companySettings.RW_PROFILE_SETTINGS[0].SIGN_ONBEHALF_OTHERS !== 'Y';
	}*/
	
	async getSignContent(id){
		let inputJson={"PROCEDURE":"getsignaturestyle","USER_ID":parseInt(this.userId),"SIGNATURE_STYLE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if (data.RESPONSE_STATUS == 'N') {
				this.throwError(data)
			}else {
				let htmlstring=atob(data.SIGNATURE_STYLE_TEMPLATE);
				//let html=htmlstring.replace('{{NAME}}', "Add Your Name Here").replace('{{TITLE}}', "Add Your Title Here")
				//this.defaultSign['SIGNATURE_STYLE_ID']=id;
				this.defaultSign['SIGNATURE_STYLE_TEMPLATE_HTML']=htmlstring;
				this.defaultSign['SIGNATURE_STYLE_TEMPLATE']=this.sanitizer.bypassSecurityTrustHtml(htmlstring);		
				//console.log(this.defaultSign)	
			}
		})
	}
	selectPhoto(){
		this.coverImages=[];
		this.coverChange=false;
		this.coverImageIndex=-1;
		this.ifPhoto=true;
		this.ifAppPdf=false;
		//$('#fileModal').modal('show');
		this.fileShow=true;
		$('.nav-tabs a[href="#photos"]').tab('show');
		this.getPhotos();
		this.uploadType="PHOTO";
		//$('.nav-tabs a[href="#files"]').tab('show');
		this.addedPhotos=[];
		let added=[]
		if(this.selectedEditor=='F'){
			added=this.getFContentData('photos');//console.log(added)
		}else{
			added=this.getContentData('photos');//console.log(added)
		}
		if(added.length>0){
			for(let item of added){
				this.addedPhotos.push(item.FILE_ID)
			}
		}
		
	}
	setSignRoleName(e){
		let index=this.signInfo.RW_SIGNATURE_LABELS.findIndex(item=>item.SIGNATURE_LABEL_ID==this.curSign['role']);
		if(index>-1){
			this.curSign['roleName']=this.signInfo.RW_SIGNATURE_LABELS[index].SIGNATURE_LABEL_NAME;
		}		
	}
	setnewSignRoleName(e){
		if(!e){
			this.newsign['role']='';
			this.newsign['roleName']='';
			return
		}
		let index=this.signInfo.RW_SIGNATURE_LABELS.findIndex(item=>item.SIGNATURE_LABEL_ID==this.newsign['role']);
		if(index>-1){
			this.newsign['roleName']=this.signInfo.RW_SIGNATURE_LABELS[index].SIGNATURE_LABEL_NAME;
		}		
	}
	saveSign(){
		let htmlstring=this.curSign['html'];
		let ele=$(htmlstring).find('#sig-label')[0];
		if(ele){
			let oldLabel=ele.innerHTML;
			this.curSign['html']=htmlstring.replace(oldLabel, this.curSign['label']);
			this.curSign['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(this.curSign['html']);
		}		
	}
	async replaceSeal(photo, index){
		//console.log(photo);
		this.logUsers(null, null);
		if(photo.TYPE=="seal"){
			await this.getSeal();
		}else if(photo.TYPE=="signature"){
			await this.getSign();
			
		}
		this.curSign=photo;
		this.curSignIndex=index;
	}
	removeSeal(type, photo, index){
		//console.log(photo);
	//console.log(this.curIndex)
		let added=[];
		if(this.selectedEditor=='F'){
			added=this.getFContentData(type);//console.log(added)
		}else if(this.selectedEditor=='O'){
			added=this.getContentData(type);//console.log(added);
		}
		//let index=added.findIndex(item=>item.FILE_URL==photo.FILE_URL);//console.log(index)
		if(index>-1){
			added.splice(index, 1);
			this.addedSeals.splice(index, 1);
		}
		if(this.selectedEditor=='F'){
			this.toFContentData(type, added, '');//console.log(added)
		}else if(this.selectedEditor=='O'){
			this.toContentData(type, added, '');
		}
	}
	sigPara=["#sig-img","#sig-label","#sig-name","#sig-title","#sig-date"];
	updateSeal(e,type, photo, name){//console.log(photo)
		//let align=$(e.target).siblings('select').val(); 
		let idname="#"+name;
		let align=$(e.target).siblings(idname).val();console.log(align);
		let item={'TITLE':photo.JOB_TITLE, 'FILE_URL':"", 'NAME':photo.FULL_NAME, 'TYPE':type};
		let field='seals';
		let index=this.curSignIndex;
		if(type=='seal'){
			item.FILE_URL=photo.SEAL_URL;
			if(align){
				item['ALIGN']=align;
			}
		}else if(type=='signature'){
			if($("#allSigRole").prop('checked')){
				this.logUsers(null, null);
				if(this.rptUser.length>1){
					$("#allSigRole").prop('checked', false);
					Swal.fire({
					icon:'warning',
					html: `<div style="text-align:left; font-size:1rem;">
							<h5 style="margin:1rem 0">IMPORTANT: There are now multiple users in this report!</h5>
							<p style="margin:1rem 0">To protect your work, the following operations have been temporarily limited:</p>
							<ul>
								<li>Updating <u>Repeat Fields</u></li>
								<li>Adding, deleting, or rearranging <u>Sections</u> and <u>Tables</u></li>
								<li><u>Importing</u> data from a different report</li>
								<li>Updating your ERIS Order Number</li>
								<li>Restoring your report to a previous version in full</li>
								<li>Find and Replace</li>
								<li>Spelling Check for Entire Report</li>
								<li>Update All Signatures with Same Role</li>
							</ul>
						</div>`
					});
					return;
				}
				/*if (this.blockMultiUser(true)) {
					$("#allSigRole").prop('checked', false)
					
				}*/
			}
			item.FILE_URL=photo.SIGNATURE_URL;
			field='signs';
			let dateChk=$(e.target).prevAll('div').children('input').prop('checked');//console.log(dateChk);
			if(dateChk){
				item['DATE']=this.date;
			}
			if(!this.curSign['signatureTemplate']&&align){
				item['ALIGN']=align;
			}
			if(this.curSign['signatureTemplate']){
				if(!$("#draftSigRole").prop('checked')){
					this.addResume(photo);		
				}
			}		
			
		}
		let added=[];
		if(this.selectedEditor=='F'){
			added=this.getFContentData(field);console.log(added)
		}else if(this.selectedEditor=='O'){
			added=this.getContentData(field);console.log(added);
		}
		//added.findIndex(item=>item.FILE_URL==this.curSign.FILE_URL);console.log(index)
		if(index>-1){
			if(this.reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'){
				if(added[index]['AUTHOR']){
					item['AUTHOR']=added[index]['AUTHOR'];
				}else{
					item['AUTHOR']='Author';
				}
				item['ALIGN']='L'
				

			}else if(this.reportInfo&&(!isNaN(this.reportInfo['SPECIAL_SIGNATURE_FORMAT']))){
				item['signlabel']='';//
				item['signlabelfontweight']='bold';
				item['signlabelfontsize']='11px';
				item['signlabelfontfamily']='Arial';
				item['signImgLabel']='';
				item['ALIGN']='L';
				item['fontweight']='bold';
				item['fontsize']='11px';
				item['fontfamily']='Calibri';
				item['textmargin']='0';
				item['labelImgunderline']=false;
				item['underline']=true;
				item['signmargin']='0';
				item['height']='40px';
				item['lineheight']='40px';				
			}
			if(this.curSign['signatureTemplate']){				
				if($("#draftSigRole").prop('checked')){
					item.FILE_URL="/assets/images/sig-blank.png"//`${environment.api.blankSignature}`;
				}
				//this.curSign['html']=this.mockhtml;
				let htmlstring=this.curSign['html'];
				let oldarr=[];
				let newarr=[];
				let hasDate=false;
				for(let eleid of this.sigPara){
					this.curSign['html']=this.curSign['html'].replace(" >", ">");
					let ele=$(htmlstring).find(eleid)[0];
					if(ele){
						let oldContent=ele.outerHTML;//console.log(oldContent)
						oldarr.push(oldContent);
						if(eleid=='#sig-img'){
							ele.src=item.FILE_URL;
						}else if(eleid=='#sig-label'){
							ele.innerHTML=this.curSign.label;
							//ele.style.alignItems = 'flex-end';
						}else if(eleid=='#sig-name'){
							ele.innerHTML=item['NAME']
						}else if(eleid=='#sig-title'){
							ele.innerHTML=item['TITLE']
						}else if(eleid=='#sig-date'){							
							ele.innerHTML=this.date;
							hasDate=true;
						}
						let newContent=ele.outerHTML;//console.log(newContent);
						newarr.push(newContent);
					}					
				}
				if($("#hideDate").prop('checked')==true){
					this.curSign['hideDate']=true;
				}else{
					this.curSign['hideDate']=false;
				}
				for(let i=0; i<oldarr.length; i++){
					this.curSign['html']=this.curSign['html'].replace(oldarr[i], newarr[i]);
				}
				if(hasDate){
					this.curSign['html']=this.checkDateshow(this.curSign);							
				}
				this.curSign['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(this.curSign['html']);
				/*let ele1=$(htmlstring).find('#sig-label')[0];
				let ele2=$(htmlstring).find('#sig-img')[0];
				let ele3=$(htmlstring).find('#sig-name')[0];
				let ele4=$(htmlstring).find('#sig-title')[0];
				let ele5=$(htmlstring).find('#sig-date')[0];
				let oldPhoto=ele2.outerHTML;console.log(oldPhoto)
				ele2.src=item.FILE_URL;
				//let oldLabel=ele1.innerHTML;
				let newPhoto=ele2.outerHTML;console.log(newPhoto)
				this.curSign['html']=htmlstring.replace(oldPhoto, newPhoto);
				this.curSign['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(this.curSign['html'])
				item=this.curSign;				
				//this.curSign['html']=htmlstring.replace(oldLabel, this.curSign['label']);
				//this.curSign['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(this.curSign['html']);
				//return*/
				item['html']=this.curSign['html'];
				item['htmlSec']=this.curSign['htmlSec'];
				item['role']=this.curSign['role'];	
				item['DATE']=this.date;					
				item['signatureTemplate']=true;
				item['label']=this.curSign['label'];		
				item['roleName']=this.curSign['roleName'];
				item['ALIGN']=this.curSign['ALIGN'];
				item['hideDate']=this.curSign['hideDate'];
				if($("#allSigRole").prop('checked')){
					this.toAllSigRole(item);
				}				
			}
			added[index]=item
			return
		}
		if(this.selectedEditor=='F'){
			this.toFContentData(field, added, '');//console.log(added)
		}else if(this.selectedEditor=='O'){
			this.toContentData(field, added, '');
		}
		this.curSign=item; console.log(this.curSign)
	}
	checkDateshow(sign){
		let eleDate=$(sign['html']).find('#sig-date').parent('label');
		const oldhtml=eleDate[0].outerHTML;
		if(sign['hideDate']){
			eleDate.css('display', 'none');
		}else{
			eleDate.css('display', '');
		}
		sign['html']= sign['html'].replace(oldhtml, eleDate[0].outerHTML);
		return sign['html'];									
	}
	toAllSigRole(baseSign){		
		for(let sec of this.frontpages){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='SIGNS'&&sec1.signs.length>0){
						for(let item of sec1.signs){
							if(item['signatureTemplate']&&item.role&&item.role==baseSign.role){
								item['html']=baseSign['html'];
								item['htmlSec']=baseSign['htmlSec'];	
								item['DATE']=baseSign['DATE'];  
								if(item['hideDate']!=baseSign['hideDate']){
									item['html']=this.checkDateshow(item);	
									item['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(item['html']);								
								}       
								if(item['label']&&item['label']!==baseSign['label']){
									let ele=$(item['html']).find('#sig-label')[0];
									if(ele){
										item['html']=item['html'].replace(ele.innerHTML,item['label']);
										item['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(item['html']);
									}
								}									
							}
						}
					}
				}
			}		
		}
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='SIGNS'&&sec1.signs.length>0){
						for(let item of sec1.signs){
							if(item.role&&item.role==baseSign.role){
								item['html']=baseSign['html'];
								item['htmlSec']=baseSign['htmlSec'];	
								item['DATE']=baseSign['DATE']; 
								if(item['hideDate']!=baseSign['hideDate']){
									item['html']=this.checkDateshow(item);	
									item['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(item['html']);								
								}
								if(item['label']&&item['label']!==baseSign['label']){
									let ele=$(item['html']).find('#sig-label')[0];
									if(ele){
										item['html']=item['html'].replace(ele.innerHTML,item['label']);
										item['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(item['html']);
									}
								}								
							}
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.TYPE=='SIGNS'&&sec2.signs.length>0){
								for(let item1 of sec2.signs){
									if(item1.role&&item1.role==baseSign.role){
										item1['html']=baseSign['html'];
								item1['htmlSec']=baseSign['htmlSec'];	
								item1['DATE']=baseSign['DATE']; 
								if(item1['hideDate']!=baseSign['hideDate']){
									item1['html']=this.checkDateshow(item1);	
									item1['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(item1['html']);								
								}
								if(item1['label']&&item1['label']!==baseSign['label']){
									let ele=$(item1['html']).find('#sig-label')[0];
									if(ele){
										item1['html']=item1['html'].replace(ele.innerHTML,item1['label']);
										item1['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(item1['html']);
									}
								}
									}
								}
							}				
						}
					}
				}
			}			
		}		
	}
	closeSign(){
		this.sealShow=false;
		if(this.selectedSignField){
			this.selectedSignField='';
		}
		if(this.newsign){
			this.newsign=null;
		}
	}
	frmSign:any;
	addFrmSign(photo){//console.log(photo)
		if(this.reportInfo.PCA_INDICATOR=='frm1104'){
			if(this.selectedSignField){console.log(this.selectedSignField)
				this.contents[0].SUB_SECTIONS[7].data[this.selectedSignField].sign=photo.SIGNATURE_URL;
				this.contents[0].SUB_SECTIONS[7].data[this.selectedSignField].name=photo.FULL_NAME;
				this.contents[0].SUB_SECTIONS[7].data[this.selectedSignField].title=photo.JOB_TITLE;
				this.contents[0].SUB_SECTIONS[7].data[this.selectedSignField].date=new Date();
				this.selectedSignField='';
				return
			}else{
				Swal.fire({
					icon:'info',
					text: 'Please select a position for your signature/seal.',
				})
				return
			}
		}else if(this.reportInfo.PHASE1_TYPE=='1103'){console.log(photo)
			this.contents[2].SUB_SECTIONS[1].data['sign']=photo.SIGNATURE_URL;
			this.contents[2].SUB_SECTIONS[1].data['name']=photo.FULL_NAME;
			this.contents[2].SUB_SECTIONS[1].data['title']=photo.JOB_TITLE;
			//this.contents[2].SUB_SECTIONS[1].data['firm']=photo.COMPANY_NAME;
			this.contents[2].SUB_SECTIONS[1].data['date']=new Date();
			return	
		}else if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			let sec=this.getSecbyId(this.contents, 'frm_sec');
			this.curIndex=this.getIdIndex('frm_sec')
			if(photo.SIGNATURE_URL){
				//this.getListPosition(sec,'', this.curIndex[0]);	
				this.frmSign={'SIGNATURE_URL':photo.SIGNATURE_URL, 'FULL_NAME':photo.FULL_NAME, 'JOB_TITLE':photo.JOB_TITLE, "COMPANY_NAME":photo.COMPANY_NAME};
				//this.scroll('frm_sec0_5');			
			}
		}		
	}
	editAuthor(e, photo){
		if(e.length>0){
			photo['AUTHOR']=e;
		}else{
			photo['AUTHOR']='Author';
		}
	}
	
	extractPositionFromHtml(htmlString: string): { offsetX: number } {
		if (!htmlString) return { offsetX: 0 };
		
		let offsetX = 0;
		
		const transformMatch = htmlString.match(/transform:\s*translateX\(([^)]+)\)/gi);
		if (transformMatch) {
			transformMatch.forEach(match => {
				const values = match.match(/translateX\(([^)]+)\)/i);
				if (values && values[1]) {
					const value = values[1].trim();
					offsetX = parseFloat(value) || 0;
				}
			});
		}
		
		return { offsetX };
	}
	
	getSignaturePosition(photo: any): { offsetX: number } {
		if (photo) {
			if (photo.html) {
				return this.extractPositionFromHtml(photo.html);
			}
		}
		return { offsetX: 0 };
	}
	newsign:any;
	addSeal(e, type, photo, name){//console.log(photo)
		if(this.coversignShow){
			this.toCoverSign(photo);
			this.sealShow=false;
			return
		}
		this.selectedCell=null;
		if(this.pageIndex[0]>-1||this.curIndex[0]>-1){
		let item={'TITLE':photo.JOB_TITLE, 'FILE_URL':"", 'NAME':photo.FULL_NAME, 'TYPE':type};
		let field="";
		let idname="#"+name;
		let align=$(idname).val(); //console.log(align);
		if(type=='seal'){
			item.FILE_URL=photo.SEAL_URL;
			field='seals';
			if(align){
				item['ALIGN']=align;
			}
		}else if(type=='signature'){
			item.FILE_URL=photo.SIGNATURE_URL;
			field='signs';
			let dateChk=$(e.target).prevAll('div').children('input').prop('checked');//console.log(dateChk);
			if(dateChk){
				item['DATE']=this.date;
			}
			if(align){
				item['ALIGN']=align;
			}
			if(this.newsign['SIGNATURE_STYLE_ID']){	
				if(!$("#draftSigRole").prop('checked')){
					this.addResume(photo);					
				}
				//this.newsign=JSON.parse(JSON.stringify(this.defaultSign))
				item['signatureTemplate']=true;
				//this.newsign['html']=this.newsign['SIGNATURE_STYLE_TEMPLATE_HTML'];
				//this.newsign['htmlSec']=this.newsign['SIGNATURE_STYLE_TEMPLATE'];	
				//this.newsign['html']=this.mockhtml;
				item['label']=this.newsign['label'];		
				item['role']=this.newsign['role'];
				item['roleName']=this.newsign['roleName'];
				item['ALIGN']=this.newsign['ALIGN'];		
				let htmlstring=this.newsign['html'];
				let oldarr=[];
				let newarr=[];
				for(let eleid of this.sigPara){
					this.newsign['html']=this.newsign['html'].replace(" >", ">");
					let ele=$(htmlstring).find(eleid)[0];
					if(ele){
						let oldContent=ele.outerHTML;//console.log(oldContent)
						oldarr.push(oldContent);
						if(eleid=='#sig-img'){
							ele.src=item.FILE_URL;
						}else if(eleid=='#sig-label'){
							ele.innerHTML=this.newsign.label;
							//ele.style.alignItems = 'flex-end';
						}else if(eleid=='#sig-name'){
							ele.innerHTML=item['NAME']
						}else if(eleid=='#sig-title'){
							ele.innerHTML=item['TITLE']
						}else if(eleid=='#sig-date'){
							ele.innerHTML=this.date;
						}
						let newContent=ele.outerHTML;//console.log(newContent);
						newarr.push(newContent);
					}					
				}
				
				for(let i=0; i<oldarr.length; i++){
					this.newsign['html']=this.newsign['html'].replace(oldarr[i], newarr[i]);
				}				
				this.newsign['htmlSec']=this.sanitizer.bypassSecurityTrustHtml(this.newsign['html']);				
				item['html']=this.newsign['html'];
				item['htmlSec']=this.newsign['htmlSec'];
				item['DATE']=this.date;			
							
			}else{
				
				if(this.reportInfo['SPECIAL_SIGNATURE_FORMAT']=='Y'){
					item['AUTHOR']='Author';
					item['ALIGN']='L';
				}else if(this.reportInfo&&(!isNaN(this.reportInfo['SPECIAL_SIGNATURE_FORMAT']))){
					item['signlabel']='';//Present by:
					item['signlabelfontweight']='bold';
					item['signlabelfontsize']='11px';
					item['signlabelfontfamily']='Arial';
					item['signImgLabel']='';
					item['ALIGN']='L';
					item['fontweight']='bold';
					item['fontsize']='11px';
					item['fontfamily']='Calibri';
					item['textmargin']='0';
					item['labelImgunderline']=false;
					item['underline']=true;
					item['signmargin']='0';
					item['height']='40px';
					item['lineheight']='40px';				
				}
			}			
			//this.reportInfo['SPECIAL_SIGNATURE_FORMAT']=16;			
		}
		let added=[];
		if(this.selectedEditor=='F'){
			let type1=this.getFContentData('TYPE'); //console.log(type1);
			if((type1=='SEALS'&&type=='seal')||(type1=='SIGNS'&&type=="signature")){
				added=this.getFContentData(field);//console.log(added);
			}else{
				if(type=='seal'){
					this.addSeals();
				}else if(type=='signature'){
					this.addSigns();
				}
			}			
		}else if(this.selectedEditor=='O'){
			let type1=this.getContentData('TYPE'); //console.log(type1);
			if((type1=='SEALS'&&type=='seal')||(type1=='SIGNS'&&type=="signature")){
				added=this.getContentData(field);//console.log(added)
			}else{
				if(type=='seal'){
					this.addSeals();
				}else if(type=='signature'){
					this.addSigns();
				}
			}
			
		}
		//let index=added.findIndex(item=>item.FILE_ID==photo.FILE_ID);//console.log(index)
		//if(index==-1){
			added.push(JSON.parse(JSON.stringify(item)));
			//this.addedSeals.push(photo.FILE_URL);
		//}
		//setTimeout(() => {
			if(this.selectedEditor=='F'){
				this.toFContentData(field, added, '');//console.log(added)
			}else if(this.selectedEditor=='O'){
				this.toContentData(field, added, '');
			}
			
		//},1000);
		}else{
			Swal.fire({
					icon:'info',
					text: 'Please select a position for your signature/seal.',
			})
			return
		}
	}
	addPhoto(photo){//console.log(photo);
		let added=[];
		if(this.selectedEditor=='F'){
			added=this.getFContentData('photos');//console.log(added)
		}else if(this.selectedEditor=='O'){
			added=this.getContentData('photos');//console.log(added)
		}
		let index=added.findIndex(item=>item.FILE_ID==photo.FILE_ID);//console.log(index)
		if(index==-1){
			added.push(JSON.parse(JSON.stringify(photo)));
			this.addedPhotos.push(photo.FILE_ID);
		}
		if(this.selectedEditor=='F'){
			this.toFContentData('photos', added, '');//console.log(added)
		}else if(this.selectedEditor=='O'){
			this.toContentData('photos', added, '');
		}
	}
	removePhoto(photo){//console.log(photo);
	//console.log(this.curIndex)
		let added=[];
		if(this.selectedEditor=='F'){
			added=this.getFContentData('photos');//console.log(added)
		}else if(this.selectedEditor=='O'){
			added=this.getContentData('photos');//console.log(added);
		}
		let index=added.findIndex(item=>item.FILE_ID==photo.FILE_ID);//console.log(index)
		if(index>-1){
			added.splice(index, 1);
			this.addedPhotos.splice(index, 1);
		}
		if(this.selectedEditor=='F'){
			this.toFContentData('photos', added, '');//console.log(added)
		}else if(this.selectedEditor=='O'){
			this.toContentData('photos', added, '');
		}
		//this.autoSave();
	}
	changeDesc(type, field,index, e, index1?, index2?, index3?){//console.log(type, field,index, e, index1, index2, index3);
		this.selectedRow=-1;
		let datas:any;
		if(this.selectedEditor=='F'){
			datas=this.frontpages;
			this.pageIndex=[index1, index2, index3];
		
		}else if(this.selectedEditor=='O'){
			datas=this.contents;
			this.curIndex=[index1, index2, index3];//console.log(this.curIndex)
		
		}
		if(index3>-1){
			datas[index1].SUB_SECTIONS[index2].SUB_SECTIONS[index3][type][index][field]=e;
		}else if(index2>-1){
			datas[index1].SUB_SECTIONS[index2][type][index][field]=e;
		}else{
			datas[index1][type][index][field]=e;
		}
		//this.autoSave();
	}
	async opPrjFile(){
		const permit:any=await this.checkUserPermit(8);
		if(permit.USER_PERMISSION=='N'){
			Swal.fire({
				icon:'info',
				html: '<span>'+permit.MESSAGE+'</span>'							
			})
			return
		}	
		this.coverImages=[];
		this.coverChange=false;
		this.coverImageIndex=-1;
		this.ifPhoto=false;
		this.ifAppPdf=false;
		this.uploadType="FILE";
		//$('#fileModal').modal('show');
		this.fileShow=true;
		this.getProjectFiles();
		$('.nav-tabs a[href="#files"]').tab('show');
	}
	
	appSelect(e, i, j){
		if($(e.target).prop('checked')){
			this.appendices.SUB_SECTIONS[i].app[j].selectedfile=true;
		}else{
			this.appendices.SUB_SECTIONS[i].app[j].selectedfile=false;
		}
		this.autoSave('appendix update',j.toString(),"appendix update");
	}
	private rgba2hex(orig) {
		let a, isPercent,
		rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
		alpha = (rgb && rgb[4] || "").trim(),
		hex = rgb ?
		(rgb[1] | 1 << 8).toString(16).slice(1) +
		(rgb[2] | 1 << 8).toString(16).slice(1) +
		(rgb[3] | 1 << 8).toString(16).slice(1) : orig;

		if (alpha !== "") {
			a = alpha;
		} else {
			a = 0o1;
		}
		// multiply before convert to HEX
		a = ((a * 255) | 1 << 8).toString(16).slice(1)
		hex = hex + a;

		return hex;
	}
	replaceOutcontent(){
		let eles=$("span[data-status='N']");//console.log(eles)
		eles.each(function(){
			$(this).text('');
		})
		let eles1=$('#outContent').find("span[data-status='Y']");//console.log(eles1)
		eles1.each(function(){
			let slotText=$(this).text().slice(1,-1);//console.log(slotText);
			$(this).text(slotText);
			$(this).removeClass('placeholder')
		})
	}
	async autoSave(type?, sid?, stitle?, editor?, doc?, status?, field?, complete?){
		/*if(this.reportInfo.PCA_INDICATOR=='frm1104'||(this.reportInfo&&this.reportInfo.PHASE1_TYPE=='1103')){
			console.log(type, sid, stitle, editor, doc, status, field, complete)
			this.singleUserSaveRpt();
			return
		} */
		if(!stitle){
			stitle='No Title';
		}
		if(type=="modify"||type=="manual save"||type=="auto save"){
			let saved = false;
			let updatetype=type;
			if(type!="modify"){
				updatetype=type.replace(' ', '').toLowerCase() + "-section";
			}
			
			if(this.listid){
				const set1=this.getSecbyId(this.frontpages, this.listid);
				const set2=this.getSecbyId(this.contents, this.listid);
				if(set1){
					if(set1.TYPE=='COSTTABLE'){
						await this.saveReport('cost update',this.listid, set1.SECTION_TITLE, 'F', set1, status,field, complete);
					}else{
						await this.saveReport(updatetype,this.listid, set1.SECTION_TITLE, 'F', set1, status,field, complete);
					}
					saved = true;
				}else if(set2){
					if(set2.TYPE=='COSTTABLE'){
						await this.saveReport('cost update',this.listid, set2.SECTION_TITLE, 'O', set2, status,field, complete);
					}else if(sid=="fme_exec_sum_ul_0"||sid=='fme_exec_sum_title_2'){
						await this.saveReport(updatetype,sid, stitle, 'O', set2, status,field, complete);	
					}else if(this.listid&&this.listid.indexOf("frm_sec")>-1){
					if(sid){
							doc=this.getSecbyId(this.contents, sid)							
							let title="Freddie Mac";
							if(sid!="frm_sec"){
								title="Freddie Mac -- "+ stitle;
							}
							await this.saveReport("modify", sid, title, 'O', doc, status, field, complete);
						}else{
							doc=this.getSecbyId(this.contents, this.listid);
							let title="Freddie Mac -- "+ doc.SECTION_TITLE;
							await this.saveReport("modify", this.listid, title, 'O', doc, status, field, complete);
						}
						
					}else{
						await this.saveReport(updatetype,this.listid, set2.SECTION_TITLE, 'O', set2, status,field, complete);
					}
					saved = true;
				}
			}
				if (!saved) await this.saveReport(updatetype,sid,stitle, editor, doc, status, field, complete);
			
			
		}else if(type=='frm'){
			doc=this.getSecbyId(this.contents, 'frm_sec')
			await this.saveReport("modify",'frm_sec',"Freddie Mac", 'O', doc, status, field, complete);
		}else{
			await this.saveReport(type,sid,stitle, editor, doc, status, field, complete);
		}
		
	}
	
	updateRpt(type, e?){console.log(this.selectedTFooter)
		let inputJson:any
		if(type=="cover"){
			inputJson = {"PROCEDURE":"updatecoverpageforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"COVERPAGE_ID":parseInt(this.selectedCover.COPIED_FROM_ID)};
		}else if(type=="header"){
			inputJson = {"PROCEDURE":"updateheaderforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"HEADER_ID":parseInt(this.selectedHeader.COPIED_FROM_ID)};
		}else if(type=="footer"){
			inputJson = {"PROCEDURE":"updatefooterforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"FOOTER_ID":parseInt(this.selectedFooter.COPIED_FROM_ID)};
		}else if(type=="theader"){
			inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"TOC_HEADER_ID":parseInt(this.selectedTHeader.TOC_HEADER_ID)};
		}else if(type=="tfooter"){
			inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"TOC_FOOTER_ID":parseInt(this.selectedTFooter.TOC_FOOTER_ID)};
		}else if(type=="Ffooter"){
			inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"FRM_FOOTER_ID":parseInt(this.selectedFrmFooter.FRM_FOOTER_ID)};
		}else if(type=="Profile"){
			let id=$(e.target).val(); console.log(id)
			inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID,"COMP_PROFILE_ID":parseInt(id)};
		}
		
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				if(type=='cover'){
					//let info=data.COVERPAGE[0];
					this.selectedCover.COVERPAGE_ID=data.COVERPAGE_ID;
					//this.reportInfo=data;//.COVERPAGE[0]=this.selectedCover;
					//console.log(!data.COVERPAGE_ID)
						//this.selectedCover=response.COVERPAGE[0].COPIED_FROM_ID;
						if(data.COVERPAGE_ID){
							this.getCoverData(data.COVERPAGE_ID);
						}
				}else if(type=="header"){
					//let info=data.HEADER[0];
					this.selectedHeader.HEADER_ID=data.HEADERFOOTER_ID;
					//this.reportInfo=data; //.HEADER[0]=this.selectedHeader;
					if(data.HEADERFOOTER_ID){
						this.getHF(data.HEADERFOOTER_ID);
					}
				}else if(type=="footer"){
					//let info=data.FOOTER[0];
					this.selectedFooter.FOOTER_ID=data.HEADERFOOTER_ID;
					//this.reportInfo=data; //.FOOTER[0]=this.selectedFooter;
					if(data.HEADERFOOTER_ID){
						this.getHF(data.HEADERFOOTER_ID);
					}
				}else if(type=="theader"){
					let info=data.TOC_HEADER[0];
					//this.selectedTHeader.TOC_HEADER_ID=info.TOC_HEADER_ID;
					this.reportInfo=data; //.TOC_HEADER[0]=this.selectedTHeader;
					if(info&&info.TOC_HEADER_ID){
						this.getHF(info.TOC_HEADER_ID);
					}
				}else if(type=="tfooter"){
					let info=data.TOC_FOOTER[0];
					//this.selectedTFooter.TOC_FOOTER_ID=info.TOC_FOOTER_ID;
					this.reportInfo=data; //.TOC_FOOTER[0]=this.selectedTFooter;
					if(info&&info.TOC_FOOTER_ID){
						this.getHF(info.TOC_FOOTER_ID);
					}
				}
			}else{
				if(type=='cover'){
					this.selectedCover.COVERPAGE_ID='';
							
				}else if(type=="header"){
					this.selectedHeader.HEADER_ID='';
				
				}else if(type=="footer"){
					this.selectedFooter.FOOTER_ID='';
					
				}else if(type=="theader"){
					this.selectedTHeader.TOC_HEADER_ID='';
				
				}else if(type=="tfooter"){
					this.selectedTFooter.TOC_FOOTER_ID='';
					
				}else if(type=="Ffooter"){
					this.selectedFrmFooter.FRM_FOOTER_ID='';
					this.selectedFrmFooter.HF_TITLE='';	
				}
			
				this.throwError(data)
			}
			//this.reportInfo=data;
			//this.selectedCover=data.COVERPAGE[0].COVERPAGE_ID;
			//this.selectedHeader=data.HEADER[0].HEADERFOOTER_ID;
			//this.selectedFooter=data.FOOTER[0].HEADERFOOTER_ID;
		})
	}
	filterSlots(e){
		////console.log(e.target);
		let key="";
		if(e.target.tagName=='INPUT'){
			key=e.target.value.trim();;
		}else if(e.target.tagName=='I'){
			key=$(e.target).prev('input').val().trim();
		}
		//console.log(key);
		let inputJson={"PROCEDURE":"searchslotsforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SLOT_KEYWORD":key};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
				
			}else{
				this.groupSlots=data.RW_SLOT_CATEGORIES;
			}
			//this.slots=data.RW_SLOTS;
			if(!this.isExpanded){
				this.groupSlots.forEach(data =>{
					this.expandedRows[data.CATEGORY] = true;
				})
				this.isExpanded=true
				//console.log(this.expandedRows);
			}
		})
	}
	filted=false;
	filterLibs(e){
		this.loading=true
		this.zone.run(()=>{this.loading=true;})
		let key="";
		if(e.target.tagName=='INPUT'){
			key=e.target.value.trim();;
		}else if(e.target.tagName=='I'){
			key=$(e.target).prev('input').val().trim();
		}else{
			key=$(e.target).val();
		}
		console.log(key)
		//let inputJson={"PROCEDURE":"getlibrary","USER_ID":parseInt(this.userId),"KEYWORD":key,"REPORT_ID":this.curReport.REPORT_ID,}
		let inputJson={"PROCEDURE":"getlibrarysimple", "USER_ID":parseInt(this.userId), "KEYWORD":key, "REPORT_ID":this.curReport.REPORT_ID,};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
				
			}else{
				this.libraries=data.RW_LIBRARY;
				if(key.length>0){
					this.filted=true;
				}else{
					this.filted=false;
				}
			}
			this.zone.run(()=>{this.loading=false;})
		})
	}
	trackByFuntion(index, item) {
		return index;
	}
	getHistory(pageno, doc?, type?){console.log(pageno, doc)
		this.historyNo=1;
		this.curHisNo=1;
		this.history=[];
		this.secHistory=[];
		let inputJson:any;
		if(doc){
			//console.log(doc);
			if(doc.TYPE=='TABLE'&&doc.data.erisName){
				let that=this;
				Swal.fire({
					icon:'warning',
					html: '<b>WARNING:</b> Resetting this ERIS table will erase all edits previously made, including comments and filters.',
					confirmButtonText: 'Continue to Reset',
					showCancelButton: true,
					backdrop:false,
					preConfirm: () => {
						let id=doc.data.SLOT_ID;
				let inputJson3={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(that.userId),"SLOT_LIST":id.toString(),"REPORT_ID":that.curReport.REPORT_ID, 'REPORT_SECTION_ID':doc.id,'SHOW_HIDDEN_RECORD':'N',};
				//console.log(inputJson3);
				that.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(response => {
					//console.log(response);
					if (response.RESPONSE_STATUS=='N') {
						that.throwError(response)
																
					}else{
					let data=[];
					if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
						let info=JSON.parse(response.RW_SLOTS[0].CONTENT);////console.log(info)
						data=info.rows; //console.log(data);
						//item3.data.cols=JSON.parse(response.RW_SLOTS[0].CONTENT).headers;
						let arr=[];
						if(data&&data.length>0){	
							for(let row of data){
								let arr1=[];
									for(let col of doc.data.cols){////console.log(col)
										let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
										if(col.INTERNALNAME=="ES_RID"){
											row[index]['hide']=true;
										}
										arr1.push(row[index]);
									}
									arr1['hide']='N';
									arr.push(arr1);
								
							}
						}	////console.log(arr);
						doc.data.rows=arr;
						//doc.data['parent_table']=info.parent_table;
						if(info.filters&&info.filters.length>0){//console.log(info.filters);
							doc.data['filters']=info.filters;
						}
						doc.selectedFilters=null;
						doc.filted=null;
						that.autoSave('modify',doc.id, doc.SECTION_TITLE, 'O');
					}
				}
				})
		
					}
				});
				//if (item3.TYPE=='TABLE'&&item3.data&&item3.data.SLOT_ID&&item3.data.SLOT_ID>-1){////console.log(item3);
				
						
			}else{
				inputJson = {"PROCEDURE":"getreporthistorybysection","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_ID":doc.id};
				console.log(inputJson)
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					console.log(data);
					if(data.RESPONSE_STATUS="Y"){
						this.secHistory=data.REPORT_SECTION_HISTORY;
						//this.secHistory['SECTION_ID']=data.SECTION_ID;
						
						$('.nav-tabs a[href="#menu1"]').tab('show');
						if(this.optionShow){
							this.optionShow=false
						}else if(this.pageOPShow){
							this.pageOPShow=false;
						}
					}else{
						this.throwError(data)
					}
			})
			}
		}else{
			let no=1;
			if(pageno){
				no=pageno;
			}
			inputJson = {"PROCEDURE":"getreportdatahistory","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"PAGE_NUMBER":no}
			//inputJson = {"PROCEDURE":"getreportdatahistory","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {
					this.throwError(data)
																
				}else{
					$('.nav-tabs a[href="#menu1"]').tab('show');
				this.history=data.REPORT_DATA_HISTORY;//.reverse();;
				this.historyNo=Math.ceil(data.TOTAL/100);//console.log(this.historyNo);
				this.curHisNo=pageno;
				}
			})
		}
		
	}
	searhHis(e){
		//console.log(e.target.value)
	}
	goHisPage(e){
		e.target.style.color='black';
		let no=parseInt(e.target.value);//console.log(no);
		if(no>0&&no<this.historyNo+1){
			this.getHistory(no);
		}else{
			e.target.style.color='red';
		}
		
	}
	secHistoryData:any;
	getSecVersion(id, secId, user){
		//console.log(id, secId);
		$('#overlay').css('display','block');
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":this.curReport.REPORT_ID,"USER_ID":parseInt(this.userId),"VERSION_ID":id};
		//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				$('#overlay').css('display','none');
				this.throwError(data)
			}
			if(data.SECTION_DATA&&data.SECTION_DATA.length>0){
				//let content=JSON.parse(data.SECTION_DATA);//console.log(content);
				//let secContent=this.getSecbyId(content, secId);//:any;
				let secContent=JSON.parse(data.SECTION_DATA);console.log(secContent)
				if(secContent){
					this.secHistoryData=secContent.data;
					this.secHistoryData['user']=user;
					this.secHistoryData['timestamp']=data.UPDATE_TIMESTAMP;
					$('#historyModal').modal('show');
				/*}else if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
					let content1=JSON.parse(data.BEFORE_TOC);//console.log(content1);
					let secContent1=this.getSecbyId(content1, secId);//:any;
					if(secContent1){
						this.secHistoryData=secContent1;
						this.secHistoryData['user']=user;
						this.secHistoryData['timestamp']=data.UPDATE_TIMESTAMP;
						$('#historyModal').modal('show');
					}else{
						this.secHistoryData=null;
					}*/
				}else{
					this.secHistoryData=null;
				}
				//console.log(this.secHistoryData);
			}
			$('#overlay').css('display','none');
		})
	}
	getFrontIdIndex(id){
		let secIndex=[];
		for(let i=0; i<this.frontpages.length; i++){
			if(this.frontpages[i].id==id){
				secIndex=[i,this.addon];
				break;
			}else{
				if(this.frontpages[i].SUB_SECTIONS){
				for(let j=0; j<this.frontpages[i].SUB_SECTIONS.length; j++){
					if(this.frontpages[i].SUB_SECTIONS[j].id==id){
						secIndex=[i,j];
						break;
					}
				}
				}
			}
		}
		if(secIndex.length>0){
			this.selectedEditor='F';
		}
		//console.log(secIndex);
		return secIndex;
	}
	getIdIndex(id){
		let secIndex=[];
		for(let i=0; i<this.contents.length; i++){
			if(this.contents[i].id==id){
				secIndex=[i,this.addon,this.addon];
				break;
			}else{
				if(this.contents[i].SUB_SECTIONS){
					for(let j=0; j<this.contents[i].SUB_SECTIONS.length; j++){
						if(this.contents[i].SUB_SECTIONS[j].id==id){
							secIndex=[i,j,this.addon];
							break;
						}else{
							if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS){
								for(let k=0; k<this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS.length; k++){
									if(this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k].id==id){
										secIndex=[i,j,k];
										break;
									}
								}
							}
							
						}
					}
				}
			}
		}
		if(secIndex.length>0){
			this.selectedEditor='O';
		}
		//console.log(secIndex);
		return secIndex;
	}
	getVersion(id){
		console.log(id)
		if (this.blockMultiUser()) return;
			let that=this;
			Swal.fire({
				icon:'info',
				title: 'Ready to restore the entire report to an earlier version?',
				confirmButtonText: 'Load',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					//console.log('starting load');
					//this.saveReport();
					that.getVersionData(this.curReport.REPORT_ID, id);
				}
			});
		
	}
	getVersionData(id, version){
		$('#overlay').css('display','block');
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":version};
		//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.ERRORCODE){
				$('#overlay').css('display','none');
				this.throwError(data)
				return
			}
			this.curReport=data;
			if(data.REPORT_DATA&&data.REPORT_DATA.length>0){//console.log(JSON.parse(data.REPORT_DATA))
				this.contents=JSON.parse(data.REPORT_DATA); console.log(this.contents);
			}
			if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
				this.frontpages=JSON.parse(data.BEFORE_TOC); //console.log(this.frontpages);
			}
			if(data.APPENDIX_DATA&&data.APPENDIX_DATA.length>0){
				this.appendices=JSON.parse(data.APPENDIX_DATA); //console.log(this.appendices);
			}
			if(data.PCA_DATA.length>0){
				let pca=JSON.parse(data.PCA_DATA);//console.log(pca);
				this.pcaOp.term=pca.term;
				this.pcaOp.multiplier=pca.multiplier;
				this.pcaOp.decimal=pca.decimal;
				this.pcaOp.currency=pca.currency;
				this.pcaOp.inflation=pca.inflation;
				this.pcaOp.round=pca.round;
				//console.log(this.pcaOp);
				if(pca.quantity){
					this.pcaOp.quantity=pca.quantity;
					this.pcaQuantity=this.pcaOp.quantity;	
				}
				if(pca.reserve){
					this.pcaOp.reserve=pca.reserve;
					this.reserveTerm=pca.reserve;
				}
				if(pca.EFF){
					this.pcaOp.age=pca.EFF;
				}
				this.generateSeq()
				//this.getTotalCost();
			}
			if(!data.PERCENT_COMPLETE||data.PERCENT_COMPLETE.length==0){
				this.wPercentage=0;
			}else{
			this.wPercentage=parseFloat(data.PERCENT_COMPLETE.replace('%',''));
			}
			if(!data.REVIEWER_PROGRESS||data.REVIEWER_PROGRESS.length==0){
				this.rPercentage=0;
			}else{
				this.rPercentage=parseFloat(data.REVIEWER_PROGRESS.replace('%',''));
			}
			this.setVersionId(data.VERSION_ID);
			$('#overlay').css('display','none');
			$('.nav-tabs a[href="#home"]').tab('show');
			
		})
	}
	setVersionId(id){
		let inputJson={"PROCEDURE":"rollbackreporthistory","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"VERSION_ID":id}
		//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}
		})
	}
	restoreContent(){
		//console.log(this.secHistoryData);
		let that=this;
		Swal.fire({
			icon:'info',
			title: 'Ready to restore this section?',
			confirmButtonText: 'Restore',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				//console.log('starting load');
				let editor:string;
				let index=this.getIdIndex(this.secHistoryData.id);//console.log(index)
				let index1=this.getFrontIdIndex(this.secHistoryData.id);//console.log(index1)
				
				let secContent:any;
				if(index.length>0){
					if(index[2]>-1){
						secContent=this.contents[index[0]].SUB_SECTIONS[index[1]].SUB_SECTIONS[index[2]];
					}else if(index[1]>-1){
						secContent=this.contents[index[0]].SUB_SECTIONS[index[1]]
					}else{
						secContent=this.contents[index[0]]
					}
					editor='O';
				}else if(index1.length>0){
					if(index1[1]>-1){
						secContent=this.frontpages[index1[0]].SUB_SECTIONS[index1[1]]
					}else{
						secContent=this.frontpages[index1[0]]
					}
					editor=='F';
				}
				//console.log(secContent);
				let type=this.secHistoryData.TYPE;
				secContent.SECTION_TITLE=this.secHistoryData.SECTION_TITLE;
				if(type&&type=='TABLE'){
					if(this.secHistoryData['data']){
						secContent['data']=this.secHistoryData['data']
					}
					
				}else{
					if(this.secHistoryData['text']){
						secContent['text']=this.secHistoryData['text'];
					}else{
						secContent['text']='';
					}
					if(this.secHistoryData['htmltext']){
						secContent['htmltext']=this.secHistoryData['htmltext'];
					}else{
						secContent['htmltext']='';
					}
					if(!this.secHistoryData['tcusers']){
						if(secContent['tcusers']){
							delete secContent['tcusers'];
						}
					}else if(this.secHistoryData['tcusers'].length==0){
						secContent['tcusers']=[];
						if((this.secHistoryData['suggestions']&&this.secHistoryData['suggestions'].length>0)||(this.secHistoryData['comments']&&this.secHistoryData['comments'].length>0)){
							secContent['text']=this.trackErrorFix(secContent['text']);	
							secContent['htmltext']=this.sanitizer.bypassSecurityTrustHtml(secContent['text']);
							secContent['comments']=[];
							secContent['suggestions']=[];
						}
						
					}else if(this.secHistoryData['tcusers']&&this.secHistoryData['tcusers'].length>0){
						secContent['tcusers']=this.secHistoryData['tcusers'];
						if(this.secHistoryData['suggestions']){
							secContent['suggestions']=this.secHistoryData['suggestions'];
						}
						if(this.secHistoryData['comments']){
							secContent['comments']=this.secHistoryData['comments'];
						}	
						
					}								
				}
				//secContent.hash=this.getHash(secContent);
				$('#historyModal').modal('hide');	
				this.autoSave('modify', secContent.id, secContent.SECTION_TITLE, editor)			
			}
		})
	}
	secComments=[];
	secComment='';
	secCommId=-1;
	reComment(id, title){
		//console.log('comment',this.secComment);
		let inputJson={"PROCEDURE":"savesectioncomment","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_ID":id,"COMMENT_CONTENT":this.secComment,"COMMENT_STATUS":"New"};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				this.secComments=data.RW_COMMENTS;
				this.secComment='';
				//if(this.secComments.length==1){
					this.toContentData('comm', 'Y', '');
					this.commIds.push(id);
					//this.autoSave('comment', id, title);
				//}
			}else{
					this.throwError(data)
				}
		})
	}
	updateStatus(id){
		let inputJson={"PROCEDURE":"updatecommentstatus","USER_ID":parseInt(this.userId),"COMMENT_ID":id,"COMMENT_STATUS":"Resolved"}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=="Y"){			
				let index=this.secComments.findIndex(comm=>comm.COMMENT_ID==id);
				if(index>-1){
					this.secComments[index].COMMENT_STATUS='Resolved';
				}
			}else{
				this.throwError(data)
				}
			
		})
	}
	getSecComments(doc, id){//console.log(doc);
		let inputJson={"PROCEDURE":"getcommentsbysection","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_ID":id}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='Y'){
				this.secComments=data.RW_COMMENTS;
				this.secComment='';
			}else{
				this.throwError(data)
				}
		})
	}
	async getLibContent(lib){
		let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":lib.LIBRARY_ID,"REPORT_ID":this.curReport.REPORT_ID,};
		//console.log(inputJson);
		let data=await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
														
			}else{
				lib['CONTENT']=data.RW_LIBRARY[0].CONTENT;
				lib['CONTENT_HTML']=data.RW_LIBRARY[0].CONTENT_HTML;
				lib['INSTRUCTIONS']=data.RW_LIBRARY[0].INSTRUCTIONS;
				lib['INSTRUCTIONS_HTML']=data.RW_LIBRARY[0].INSTRUCTIONS_HTML;					
			}
	
	}
	updateLibs(libs){//console.log(libs);
		let libarray=[];
		//let updatedLibs=[];
		for(let lib of libs){
			libarray.push(lib.LIBRARY_ID);
		}
		let libstring=libarray.join(',');
		//let inputJson={"PROCEDURE":"getlibraryentrybyidlist","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring,"REPORT_ID":this.curReport.REPORT_ID};
		let inputJson={"PROCEDURE":"getlibraryentrybyidlistsimple","USER_ID":parseInt(this.userId),"LIBRARY_LIST":libstring,"REPORT_ID":this.curReport.REPORT_ID};
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('liblist',data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
														
			}else{
			let updatedLibs=data.RW_LIBRARY;
			this.toContentData('libs', updatedLibs, '');
			this.curLibs=updatedLibs;
			this.rangeLib=updatedLibs;
			this.rangeIndex=0;
			this.definedLibGroup=updatedLibs;
			this.libGroup='D';
			}
			//return updatedLibs;
		})
	}
	setWatermarker(type){
		if(type=="watermarker"){
			//console.log(this.selectedWatermarker);
			let id:number;
			if(this.selectedWatermarker.WATERMARK_ID){
				id=parseInt(this.selectedWatermarker.WATERMARK_ID)
			}else{
				id=-1;
			}
			let	inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"WATERMARK_ID":id};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=="Y"){
					this.reportInfo=data;
				}else{
					this.throwError(data)
				}
			})
		}
	}
	maps=[];
	addedMaps=[];
	getMap(){
		let inputJson={"PROCEDURE":"getmapreportsbyreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=='Y'){
					this.maps=data.RW_MAP_REPORTS;//console.log(this.maps);
				}else{
					this.throwError(data)
				
				}
			})

	}
	getPhotolog(type, rf?){//console.log('photo')
		//if((!this.reportInfo?.PHOTOLOG_LIST)||this.reportInfo?.PHOTOLOG_LIST.length==0){
		if(rf&&rf['COPIED']){
			window.open(rf.url, '_blank');
			return
		}
			let inputJson={"PROCEDURE":"getphotologurlforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=='Y'){
					let photolog=[{'PHOTOLOG_ID':data.PHOTOLOG_ID, "PHOTOLOG_URL":data.PHOTOLOG_URL}];
					this.reportInfo['PHOTOLOG_LIST']=photolog;
					let url=data.PHOTOLOG_URL;
					if(rf){
						rf['url']=url;
					}
					if(type&&type=='app'&&url.length>0){
						window.open(url, '_blank');
					}else if(type&&!url){
						url="/photolog/"+this.reportInfo.PROJECT_ID+'/'+this.reportInfo.REPORT_ID;
						window.open(url, '_blank');
					}					
					//this.reportInfo['PHOTOLOG_LIST']=[];
				}else{
					if(type){
						let url="/photolog/"+this.reportInfo.PROJECT_ID+'/'+this.reportInfo.REPORT_ID;
						window.open(url, '_blank');
					}
				}
			})
		//}
	}
	new1103show=false;
	frm1103Temps=[];
	selectedTemp='';
	frm1103Proj=-1;
	frm1103url="";
	frm1103Warn=false;
	get1103(type?){
		this.new1103show=false;
		this.frm1103Temps=[];
		this.selectedTemp='';
		this.frm1103Proj=-1;
		this.frm1103url="";
		this.frm1103Warn=false;
		let inputJson={"PROCEDURE":"getfrm1103urlforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=='Y'){
					if(data.FRM1103_URL&&data.FRM1103_URL.length>0){
						let url=data.FRM1103_URL;
						for(let item of this.appendices.SUB_SECTIONS){
							if(item.app&&item.app.length>0){
								for(let rf of item.app){//console.log(rf)
									if(rf.name=='Phase I - Freddie Mac 1103'){
										rf['url']=url;
										item['nodata']=false;
									}
								}
							}
						}
						if(type&&type=='app'){
							window.open(url, '_blank');
						}
					}else if(data.REPORT_ID){
						let url="/report/"+data.PROJECT_ID+'/'+data.REPORT_ID;
						window.open(url, '_blank');
					}else{
						this.new1103show=true;
						this.frm1103Temps=this.getAllTempByTypeIDSimple();
						this.frm1103Proj=data.PROJECT_ID;
					}					
				}else{
					this.throwError(data);
				}
		})
	}
	getAllTempByTypeIDSimple() {
		let inputJson={"PROCEDURE":"gettemplatesbytypesimple", "USER_ID":parseInt(this.userId), "TEMPLATE_TYPE_ID":71};
		let typeIdTemplates=[];
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log("getAllTempByTypeIDSimple",data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				
				return										
			}
			for (let obj of data.RW_TEMPLATES) {
				typeIdTemplates.push(obj);
			}

		});
		console.log('typeIdtemplatesSimple',typeIdTemplates);
		return typeIdTemplates;
	}
	addnewFrm1103(){
		let inputJson={"PROCEDURE":"createfrm1103report","USER_ID":parseInt(this.userId),"PROJECT_ID":this.frm1103Proj,"TEMPLATE_ID":this.selectedTemp};
		console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data);
				this.frm1103Warn=true;
				return										
			}
			this.frm1103url="/report/"+data.PROJECT_ID+'/'+data.REPORT_ID;
		});
	}
	secUser=[];
	rptUser=[];
	secTitle='';
	appEditable="Y";
	PCAEditable="Y";
	async logUsers(id, title){//console.log(id, title)
		//{"PROCEDURE":"loguserinreportsection","USER_ID":5,"REPORT_ID":386,"SECTION_ID":"...."}
		//{"PROCEDURE":"getuserlistbyreportsection","USER_ID":5,"REPORT_ID":386,"SECTION_ID":"...."}
		let inputJson={"PROCEDURE":"loguserinreportsection","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SECTION_ID":id,'SECTION_TITLE':title};
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		//this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=='Y'){
					this.secUser=data.RW_SECTION_USERS;
					this.secTitle=data.SECTION_TITLE;
					this.rptUser=data.RW_REPORT_USERS;
					if(data.ALLOWED_TO_EDIT=='Y'){
						this.listLocked = false;
						/*let id=data.SECTION_ID; //console.log(id)
						if(id=='appendix'&&this.allowAdd){
							this.appEditable='Y';
						}else if(id=='PCA'&&this.allowAdd){
							this.PCAEditable='Y';
						}else{*/
							this.selectedCell=null;
							this.onlock=id;
						//}
					}else if(data.ALLOWED_TO_EDIT=='N'){
						this.listLocked = true;
						let id=data.SECTION_ID; //console.log(id)
						/*if(id=='appendix'){
							this.appEditable='N';
						}else if(id=='PCA'){
							this.PCAEditable='N';
						}else{*/ 
							this.selectedCell=null;
							this.onlock='';
						//}
						let users="other user";
							for (let user of this.secUser){
								if(user.ALLOWED_TO_EDIT=="Y"){
									users=user.USER_FULLNAME;
									break;
								}
							}
							//console.log('log fire')
							Swal.fire({
								icon: 'info',
								title: 'Section is locked by '+users+' who is currently working on it.' ,
							});
					}
				}else{
					this.throwError(data)
				}
			//});
	}
	getHF(id){
		let inputJson2={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
															
			}else{
			if(data.TYPE=="HEADER"){
				this.headercopy.push(data);
			}else if(data.TYPE=="FOOTER"){
				this.footercopy.push(data);
			}
		}		
		})
	}
	getCoverData(id){
		let inputJson={"PROCEDURE":"getcoverpage", "USER_ID":parseInt(this.userId), "COVERPAGE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
			//console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
															
			}else{
			this.covercopy.push(response)
			}		
		})
	}
		
/*saveHF(type, id, hfdata){	////console.log(hfdata.text)
		let that=this;
		
		let html='';
		if(this.selectpage.type=='portrait'){
			html = this.reportService.a4PortraitForHF;
		}else if(this.selectpage.type=='landscape'){
			html = this.reportService.a4LandscapeForHF;
		}
		////console.log(html)
		html += `<div>`;
		let hi='20px';
		html +=`<div style="margin:0; width:90%">`
		//let content="";
		let hHeight=80;
		html+=hfdata.text;
	    html += `</div></div>`;
		html += this.reportService.tagEnd;////console.log("eric", html);
		let allhtml=btoa(html.replace(/[\u00A0-\u2666]/g, function(c) {
				return '&#' + c.charCodeAt(0) + ';';
		}));
		////console.log(allhtml);
		return allhtml;
	

	}*/
	/*exportSecText(doc){//console.log(doc)
		let a = document.createElement("a");
		a.href = window.URL.createObjectURL(new Blob([doc.text], {type: "text/plain"}));//htmltext
		a.download = doc.SECTION_TITLE+'.txt';//"demo.txt";
		a.click();
	}
	importSecId:string;
	importSecText(id){
		//console.log(id);
		this.file2.nativeElement.click();
		this.importSecId=id;
	}*/
	importFile(){
		let that=this;
		const file = this.file2.nativeElement.files[0]; //console.log(file);
		const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
			return;
		}
		let reader = new FileReader();
			reader.onloadend = function(e) {				
				let filedata = e.target.result.toString().split(',')[1];//console.log(filedata)//
				let dec = atob(filedata); //console.log(dec);
				let data=that.sanitizer.bypassSecurityTrustHtml(dec);
				that.toContentData('text', dec, '');
				that.toContentData('htmltext', data, '');
				/*let inputJson={"filename":file.name,"user_id":that.userInfo.USER_ID.toString(),"company_id":that.userInfo.COMPANY_ID.toString(),"report_id":that.curReport.REPORT_ID.toString(),"project_id":that.reportInfo.PROJECT_ID.toString(),"file_desc":"","file_type":"FILE","filetitle":"","fdata":filedata}
				//console.log(inputJson);
				that.reportService.uploadFile2(inputJson).subscribe(result=>{//console.log(result);
					//console.log(result);
					if(result.RESPONSE_STATUS=='Y'){
						const url=result.FILE_URL;	//console.log(url)
						fetch(url)
						.then( r => r.text() )
						.then( t => {//console.log(t)
							let data=that.sanitizer.bypassSecurityTrustHtml(t);
							that.toContentData('text', t, '');
							that.toContentData('htmltext', data, '');
						
						})//process your text! )
						
					}else{
						Swal.fire({
							icon: 'error',
							title: result.MESSAGE
						})
					}
									
				})*/				
		}
		reader.readAsDataURL(file);
		
	}
	secToggle(docs){
		for(let doc of docs.SUB_SECTIONS){
			if(doc['HIDESEC']){
				doc['HIDESEC']=!doc['HIDESEC'];
				docs['HIDESUB']=!docs['HIDESUB'];
			}else{
				doc['HIDESEC']=true;
				docs['HIDESUB']=true;
			}
		}
		//console.log(docs['HIDESUB']);
		
	}
	erisToggle(doc){
		if(doc['HIDEERIS']){
			doc['HIDEERIS']=!doc['HIDEERIS'];
		}else{
			doc['HIDEERIS']=true;
		}
		//console.log(doc['HIDEERIS']);
	}
	
	async refreshSlots(){
		await this.getAllSlots(this.curReport.REPORT_ID.toString());
		this.getGroupSlots(this.curReport.REPORT_ID.toString());
	}
	refreshLibs(){
		this.getLibraries();
		this.getLibLabels();
	}
	async getSftContent(data){
		await this.getLibContent(data);
		if(data.CONTENT_HTML&&data.CONTENT_HTML.length>0){
			data.htmltext=this.sanitizer.bypassSecurityTrustHtml(data.CONTENT_HTML);
		}
	
	}
	updateEris(){
		if (this.blockMultiUser()) return;
		Swal.fire({
			icon:'warning',
			html: 'Your ERIS Order has been updated outside of this report.	Do you want to update your report with the new ERIS Data?<br><br><b>WARNING:</b> Importing new data may reset edits made to ERIS tables in this report (including comments and filters added).',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
					//console.log('report',response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
																	
					}else{
					let no=response.ORDER_NUM;
					this.reportInfo.ORDER_NUM=no;
					this.editOrder=false;
					let inputJson3={"PROCEDURE":"getErisTextSlotByReport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
					this.reportService.univeralService(JSON.stringify(inputJson3)).subscribe(result=>{
						//console.log(result);
						if (result.RESPONSE_STATUS=='N') {
							this.throwError(result)
																		
						}else{
							let updatedSlots=result.RW_SLOTS;
							for(let slot of updatedSlots){
								this.setLocalSlot(slot, 'local')
							}
						}
					})
					let inputJson2={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":response.ORDER_NUM}
					this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result=>{
						//console.log(result);
						if (result.RESPONSE_STATUS=='N') {
							this.throwError(result)
																		
						}else{
						this.pdfs=result.REPORT_LINKS;
						this.updatePdfs();
						}
					})
					let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":no};//console.log(inputJson6);
					this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result1=>{
						//console.log(result);
						if (result1.RESPONSE_STATUS=='N') {
							this.throwError(result1)
																		
						}else{
						this.erisPdfs=result1.PRODUCT_LINKS;
						}
					})
					this.erisUpdated=true;
					this.slotTableGetData();
				}
				})

			}
		});
	}
	checkLib(){console.log('checkLib')
		if(this.libraries.length==0||this.filted){
			this.refreshLibs();
		}
	}
	getUpdated(){
		let inputJson={"PROCEDURE":"getupdatedreportinfo", "USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('updated', data);
			if(data.RESPONSE_STATUS=='Y'){
				if(data.PHOTOLOG_URL.length>0){
					let info={'PHOTOLOG_URL':data.PHOTOLOG_URL};
					this.reportInfo.PHOTOLOG_LIST[0]=info;
					this.updatePhotolog();					
				}
				if(data.ERIS_UPDATE=='Y'){
					this.erisUpdated=true;
					//this.updatePdfs();
				}
				this.update1103();
			}else{
				this.throwError(data)
				}
		})
		this.getMap();
	}
	updatePhotolog(){
		if(this.reportInfo.PHOTOLOG_LIST[0]&&this.reportInfo.PHOTOLOG_LIST[0].PHOTOLOG_URL.length>0){
			//console.log(this.pdfs);
			for(let item of this.appendices.SUB_SECTIONS){
				if(item.app&&item.app.length>0){
					for(let rf of item.app){//console.log(rf)
						if(!rf['COPIED']&&(rf.name=="Photo Log"||rf.name=="Photo log")){
							rf['url']=this.reportInfo.PHOTOLOG_LIST[0].PHOTOLOG_URL;
							item['nodata']=false;
						}
					}
				}
			}
			//console.log(this.appendices)
			//this.autoSave('appendix update');
		}
	}
	update1103(){
		let inputJson={"PROCEDURE":"getfrm1103urlforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
			if(data.RESPONSE_STATUS=='Y'){
				if(data.FRM1103_URL&&data.FRM1103_URL.length>0){
					for(let item of this.appendices.SUB_SECTIONS){
						if(item.app&&item.app.length>0){
							for(let rf of item.app){//console.log(rf)
								if(rf.name=='Phase I - Freddie Mac 1103'){
									rf['url']=data.FRM1103_URL;
									item['nodata']=false;
								}
							}
						}
					}
				}		
			}else{
				this.throwError(data)
			}
		})
	}
	updateShow=false;
	projectRpts=[];
	compareRpts=[];
	compareTitles=[];
	compareSlots=[];
	loading3=false;
	getProjectRpts(){
		this.updateShow=true;
		this.loading3=true;
		this.compareRpts=[];
		let inputJson={"PROCEDURE":"getreportsforproject", "USER_ID":parseInt(this.userId), "PROJECT_ID":parseInt(this.proId)};
			//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			this.loading3=false;
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				this.projectRpts = data.RW_REPORTS;
				let index=this.projectRpts.findIndex(rpt=>rpt.REPORT_ID==this.curReport.REPORT_ID);//console.log(index)
				if(index>-1){
					let self=this.projectRpts[index];
					this.projectRpts.splice(index,1);
					this.projectRpts.splice(0,0, self);
					this.compareRpts[0]=self.REPORT_ID;//console.log(this.compareRpts);
					this.compareTitles[0]=self.REPORT_TITLE;//console.log(this.compareTitles);
									
				}				
			}
		})
		
	}
	loading2=false;
	addCompareRpt(e, rpt){//console.log(e.target.checked)
		if(e.target.checked){
			//this.loading2=true;
			this.compareRpts.push(rpt.REPORT_ID);
			this.compareTitles.push(rpt.REPORT_TITLE);
		
		}else{
			let index=this.compareRpts.indexOf(rpt.REPORT_ID);//console.log(index)
				if(index>-1){
					this.compareRpts.splice(index, 1);
					this.compareTitles.splice(index, 1);
				}
				
				
		}
	}
	getCompareRpts(){//console.log(this.compareTitles);
		this.loading2=true;
		let rpts=this.compareRpts.join(',');
		let inputJson={"PROCEDURE":"getrfcomparisontable", "USER_ID":parseInt(this.userId), "REPORT_LIST":rpts};
			//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			this.loading2=false;
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				this.compareSlots=data.RF_TABLE_LIST;
			}
		})
	}
	updaterpts(e, list, i){//console.log(i, list);
		let index=parseInt($(e.target).val()); //console.log(index);
		let id=this.compareRpts[i]; //console.log(id);
		let content=list.REPORT_VALUE_LIST[index].RF_CONTENT;
		//let slot={'SLOT_ID':list.SLOT_ID,'SLOT_KEY':list.SLOT_KEY,'SLOT_TYPE':list.SLOT_TYPE,'RF_CONTENT':content};
		let slot={'SLOT_ID':list.SLOT_ID,'SLOT_KEY':list.SLOT_KEY,'SLOT_TYPE':list.SLOT_TYPE,'CONTENT':content};
		this.updateFunction(id, slot,e);
	}
	
	clearStatus(i){//console.log(this.compareSlots);
		for(let item of this.compareSlots){
			if(item&&item.length>0){
				item[i]['selected']=false;
			}
		}
	}
	updateRptSlotlist(slots){
		if(slots.length>0){
		let ids=slots.join(','); //console.log(ids);
		let inputJson={"PROCEDURE":"addslotlisttoreport", "USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID, "SLOT_LIST":ids};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
				
				//console.log('addslotlisttoreport', data.MESSAGE);
			}else{
				this.loading=false;
			}
		})
		}
	}
	getReports(){
		if (this.blockMultiUser(true))
			return;
		//let id=this.reportInfo.TEMPLATE[0].TEMPLATE_ID;//SUBCATEGORY_NAME
		let cat=this.reportInfo.TEMPLATE[0].CATEGORY_NAME;
		//let inputJson={"PROCEDURE":"getreportlistbytemplate","USER_ID":parseInt(this.userId),"TEMPLATE_ID":id}
		//let inputJson={"PROCEDURE":"getreportlistbycategory","USER_ID":parseInt(this.userId),"CATEGORY":cat}
		//let inputJson={"PROCEDURE":"getreportlistbyreporttemplate","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		let inputJson={"PROCEDURE":"getreportlistforimportreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
															
			}else{
			this.reports=response.RW_REPORTS; //console.log('reportlist', this.reports)
			}
		})
	}
	expandcollapse() {
		this.compareShow=false;
		this.expanded =! this.expanded;
		if(!this.expanded){
			//console.log($('#reportList'))
			$('#reportList').css('right', '360px');
			$('#reportList').css('transform', '');
		
		}else{
			$('#reportList').css('right', '5vw');
		}
	  }
	openRpts(){
		if (this.blockMultiUser(true))
			return;
		this.compareShow=false;
		this.getReports();
		this.expanded=true;
	}
	getallIds(doc){
		let ids=[];
		for(let sec of doc){
			ids.push(sec.id);
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					ids.push(sec1.id);
					if(sec1.SUB_SECTIONS){
						for(let sec2 of sec1.SUB_SECTIONS){
							ids.push(sec2.id);
						}
						
					}
				}
				
			}
		}
		return ids
	}
	changeId(newdoc){
		let doc=JSON.parse(JSON.stringify(newdoc));
		doc.id=Utils.uniqueIdGenerator();		
		return doc
	}
	importContents=[];
	compareShow=false;
	inclApp=false;
	importAll=false;
	importRptInfo=null;
	allimportIds=[];
	allsrcIds=[];
	importPorj='';
	importRpt(info){
		//console.log(info);
		if (this.blockMultiUser(true))
			return;
		this.loading=true;
		this.importCancel();
		this.compareShow=true;
		this.curSrcItem=null;
		this.curLevel=null;
		this.inclApp=false;
		this.importAll=false;
		this.allimportIds=[];
		this.importPorj=info.PROJECT_NUMBER;
		this.allsrcIds=this.getallIds(this.contents); //console.log(this.allsrcIds)
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":info.REPORT_ID,"USER_ID":parseInt(this.userId),"VERSION_ID":null};// Optional Version_ID - select most recent version if version_id is null
		//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log('importedData',data);
			if(data.ERRORCODE){
					this.throwError(data)
					this.loading=false;
				return
			}
			if(data.REPORT_DATA&&data.REPORT_DATA.length>0){
				this.importContents=JSON.parse(data.REPORT_DATA); console.log(this.importContents)
				this.allimportIds=this.getallIds(this.importContents);
				
			}else{
				this.importContents=[];
			}
			this.loading=false;
			//console.log(this.allimportIds)
		
		})
		let inputJson1= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":info.REPORT_ID};
				this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
					//console.log('importedRpt',response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
																	
					}else{
					this.importRptInfo=response;
					this.compareShow=true;
					}
				})
		this.expanded=false;
		//this.zone.run(()=>{this.loading=false;})

		
	}
	curSrcItem:any;
	curLevel:number;
	getSrcItem(e, doc, level){//console.log(doc);
		if(e.target.checked){
			//doc['replaced']=true;
			if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
				for(let doc1 of doc.SUB_SECTIONS){
					doc1['replaced']=false;
					if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
						for(let doc2 of doc1.SUB_SECTIONS){
							doc2['replaced']=false;
						}
					}
				}
			}
			this.curSrcItem=doc;
			this.curLevel=level;
		}else{
			this.curSrcItem=doc;
			this.curLevel=level;
			if(this.curSrcItem['replaceBy']&&this.curSrcItem['replaceBy'].length>-1){
				let id=this.curSrcItem['replaceBy'];
				let target=this.getSecbyId(this.importContents,id); console.log(target);
				target['replaceTo']=null;
				target['replaced']=false;
			}
			this.curSrcItem=null;
			//this.curLevel=null;
			doc['replaceBy']=null;
		}
	}
	presetReplaceId(){
		let ids=this.allimportIds;
		for(let sec of this.contents){
			if(this.noImportTypes.indexOf(sec.TYPE)==-1&&ids.indexOf(sec.id)>-1){
				let targetSec=this.getSecbyId(this.importContents, sec.id);
				if(targetSec){
					sec['replaceBy']=sec.id;
				}
			}
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(!sec1.tableClass&&this.noImportTypes.indexOf(sec1.TYPE)==-1&&ids.indexOf(sec1.id)>-1){
						let targetSec=this.getSecbyId(this.importContents, sec1.id);
						if(targetSec){
							if((sec1.data&&sec1.data.erisName)||(targetSec.data&&targetSec.data.erisName)){
								delete sec1['replaceBy'];
								continue
							}
							if(!targetSec.tableClass&&this.noImportTypes.indexOf(targetSec.TYPE)==-1){
								sec1['replaceBy']=sec1.id;
							}
						}
						
						
					}
					if(sec1.SUB_SECTIONS){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(!sec2.tableClass&&this.noImportTypes.indexOf(sec2.TYPE)==-1&&ids.indexOf(sec2.id)>-1){
								let targetSec=this.getSecbyId(this.importContents, sec2.id);
								if(targetSec){
									if((sec2.data&&sec2.data.erisName)||(targetSec.data&&targetSec.data.erisName)){
										delete sec2['replaceBy'];
										continue
									}
									if(!targetSec.tableClass&&this.noImportTypes.indexOf(targetSec.TYPE)==-1){
										sec2['replaceBy']=sec2.id;
									}
								}
																
							}
						}
					}
				}
			}
		}
		console.log(this.contents)		
	}
	clearReplaceId(){
		for(let sec of this.contents){
			if(sec['replaceBy']){
				delete sec['replaceBy']
			}
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1['replaceBy']){
						delete sec1['replaceBy']
					}
					if(sec1.SUB_SECTIONS){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2['replaceBy']){
								delete sec2['replaceBy']
							}
						}
					}
				}
			}
		}
	}
	setReplaceId(e, doc){
		let id=e.target.value;
		if(id){
			doc['replaceBy']=id;
		}else{
			delete doc['replaceBy']
		}
	}
	setTargetItem(e, doc){//console.log(doc);
		if(this.curSrcItem){
			if(e.target.checked){
				if(this.curSrcItem['replaceBy']&&this.curSrcItem['replaceBy'].length>0){console.log(this.curSrcItem['replaceBy']);
					let old=this.getSecbyId(this.importContents,this.curSrcItem['replaceBy']);console.log(old)
					old['replaceTo']=null;
					old['replaced']=false;
				}
				this.curSrcItem['replaceBy']=doc.id;console.log(doc);
				doc['replaceTo']=this.curSrcItem.id;console.log(this.curSrcItem)
			}else{
				this.curSrcItem['replaceBy']=null;//console.log(doc);
				doc['replaceTo']=null;//console.log(this.curSrcItem)
			}
		}else{
			Swal.fire({
				icon: 'info',
				text: 'Please select a section to replace.'
			})
			doc['replaceTo']=null;
			e.target.checked=false;
		}
	}
	selSrcItem(doc,index){
		if(doc['replaced']){
			this.curSrcItem=doc;
		}
		this.curLevel=index;
		}
	importCancel(){
		for(let doc of this.contents){
			if(doc['replaceBy']){
				//delete doc.replaced;
				delete doc.replaceBy;
				//delete doc.replaceTo;
			}
			if(doc.SUB_SECTIONS.length>0){
				for(let doc1 of doc.SUB_SECTIONS){
					if(doc1['replaceBy']){
						//delete doc1.replaced;
						delete doc1.replaceBy;
						//delete doc1.replaceTo;
					}
					if(doc1.SUB_SECTIONS.length>0){
						for(let doc2 of doc1.SUB_SECTIONS){
							if(doc2['replaceBy']){
								//delete doc2.replaced;
								delete doc2.replaceBy;
								///delete doc2.replaceTo;
							}
						}
					}
				}
			}
		}
		this.compareShow=false;
		this.curSrcItem=null;
		this.curLevel=null;
		this.inclApp=false;
		this.importAll=false;
		this.importContents=[];
		this.importRptInfo=null;
	}
	importTo(){//console.log(this.inclApp); //console.log(this.importAll);
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to import into your new report? This action will overwrite any language already in sections.',
			confirmButtonText: 'Import',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
			if(that.importAll){
				$('#overlay').css('display','block');
				that.importAllRptData();
			}else{
				that.importData();
			}
			if(that.inclApp){
				that.importApp();
			}
		}
		})
	}
	importAllRptData(){
		$('#overlay').css('display','block');
		this.contents=[];
		for(let sec of this.importContents){
			
			if(sec.TYPE=='COST'){
				continue
			}
			if(sec['replaced']){
				delete sec.replaced;
				delete sec.replaceTo;
				delete sec.replaceBy;
			}
			if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					delete sec.replaced;
					delete sec.replaceTo;
					delete sec.replaceBy;
					if(sec1.SUB_SECTIONS){
						for(let sec2 of sec1.SUB_SECTIONS){
							delete sec2.replaced;
							delete sec2.replaceTo;
							delete sec2.replaceBy;
						}
						
					}
				}
				
			}
			
			let newsec=this.checkRF(sec);
			this.contents.push(newsec);
		}
		//this.replaceSlots();
		this.slotTableGetData();
		this.generateSeq();
		let that=this;
		this.zone.run(()=>{
			this.compareShow=false;
			$('#overlay').css('display','none');
			Swal.fire({
			icon:'success',
			title: "Success! The Source Report content has been copied into the selected section(s) of your Current Report.",
			confirmButtonText: 'OK',
			showLoaderOnConfirm: true,
			showCancelButton: false,
			backdrop:false,
			preConfirm: () => {
				that.autoSave('Report Imported','Report Imported','Report Imported');
			}
		})
		})
		
	}
	importApp(){
		let inputJson= {"PROCEDURE":"getreportappendix","USER_ID":parseInt(this.userId),"REPORT_ID":this.importRptInfo.REPORT_ID};
				//console.log('app', inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
					//console.log('app',response);
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)
																	
					}else{
					if(response.APPENDIX_DATA&&response.APPENDIX_DATA.length>0){
						this.appendices=JSON.parse(response.APPENDIX_DATA);//console.log(this.appendices);
						this.updatePdfs();
						this.zone.run(()=>{
							//this.autoSave('Appendix Imported','Appendix Imported','Appendix Imported');
						})
						
					}
				}
				})
	}
	replaceItems(sec1, sec2){
		let subSec:any;
		if(sec1&&sec1.SUB_SECTIONS){
			subSec=JSON.parse(JSON.stringify(sec1.SUB_SECTIONS));
		}
		//if(sec1.SECTION_TITLE!=sec1.SECTION_TITLE){
		//	sec1.SECTION_TITLE=sec2.SECTION_TITLE;	
		//}
		if(sec2.data){
			sec1['data']=sec2.data;
		}else if(sec1['data']){
			sec1['data']=null;
		}
		
		if(sec1.required!=sec2.required){
			sec1.required=sec2.required;
		}
		if(sec2.htmltext){
			if(sec1.htmltext!=sec2.htmltext){
				sec1.htmltext=sec2.htmltext;
			}
		}else if(sec1.htmltext){
			sec1.htmltext=null;
		}
		
		if(typeof(sec2.text) === 'string'){
			sec1.text=sec2.text;
		}else if(!sec2.text){
			if(sec1.text){
				sec1.text='';
			}
		}
		if(sec1.libs!=sec2.libs){
			sec1.libs=sec2.libs;
		}
		if(sec1.slots!=sec2.slots){
			sec1.slots=sec2.slots;
		}
		if(sec1.comm!=sec2.comm){
			sec1.comm=sec2.comm;
		}
		if(sec1['tcusers']!=sec2['tcusers']){
			if(!sec2.tcusers){
				delete sec1.tcusers
			}else if(sec2.tcusers.length==0){
				sec1['tcusers']=[];
			}else{
				sec1['tcusers']=sec2.tcusers;
			}								
		}
		if(sec1['suggestions']!=sec2['suggestions']){
			if(!sec2.suggestions){
				delete sec1.suggestions
			}else if(sec2.suggestions.length==0){
				sec1['suggestions']=[];
			}else{
				sec1['suggestions']=sec2.suggestions;
			}
			
		}
		if(sec1['comments']!=sec2['comments']){
			if(!sec2.comments){
				delete sec1.comments
			}else{
				sec1['comments']=sec2.comments;
			}								
		}
		if(sec1['signs']!=sec2['signs']){
			sec1['signs']=sec2['signs'];
		}
		if(sec1['seals']!=sec2['seals']){
			sec1['seals']=sec2['seals'];
		}
		if(subSec){
			sec1['SUB_SECTIONS']=subSec;
		}
		if(sec1.TOC!=sec2.TOC){
			sec1.TOC=sec2.TOC;
		}
		if(sec1.OTABLE!=sec2.OTABLE){
			sec1.OTABLE=sec2.OTABLE;
		}
		if(sec1.OTNAME!=sec2.OTNAME){
			sec1.OTNAME=sec2.OTNAME;
		}
		if(sec1.OPNAME!=sec2.OPNAME){
			sec1.OPNAME=sec2.OPNAME;
		}
		if(sec1.OSNAME!=sec2.OSNAME){
			sec1.OSNAME=sec2.OSNAME;
		}
		if(sec1.OHEADER!=sec2.OHEADER){
			sec1.OHEADER=sec2.OHEADER;
		}
		if(sec1.HIDE!=sec2.HIDE){
			sec1.HIDE=sec2.HIDE;
		}
		//if(sec1.NEW!=sec2.NEW){
		//	sec1.NEW=sec2.NEW;
		//}
		if(sec1.intro!=sec2.intro){
			sec1.intro=sec2.intro;
		}
		sec1.TYPE=sec2.TYPE;
		/*if(sec1.SECTION_SEQUENCE!=sec2.SECTION_SEQUENCE){
			sec1.SECTION_SEQUENCE=sec2.SECTION_SEQUENCE;
		}*/
									
		sec1.hash=this.getHash(sec1);
	}
	async importData(){console.log(this.importContents);
		if (this.blockMultiUser(true))
			return;
		await this.singleUserSaveRpt('addcopy');
		try{
		for(const [index,doc] of this.contents.entries()){
			//if(doc['replaced']&&doc['replaceBy']&&doc['replaceBy'].length>0){//console.log(doc)
			if(doc['replaceBy']&&doc['replaceBy'].length>0){//console.log(doc)
				let newDoc=this.getDoc(doc['replaceBy']);//console.log(newDoc);
				if(newDoc){
					if(doc.id!=doc['replaceBy']&&this.allsrcIds.indexOf(doc['replaceBy'])>-1){
						newDoc=this.changeId(newDoc);
					}
					/*if(newDoc['pisummarydata']){
						delete newDoc['pisummarydata']
					}
					if(newDoc['pcasummarydata']){
						delete newDoc['pcasummarydata']
					}
					if(newDoc['hash']){
						delete newDoc['hash']
					}*/
					//this.contents[index]=newDoc;
					this.replaceItems(this.contents[index], newDoc);
					//this.checkEris(this.contents[index]);
					delete doc.replaced;
					delete doc.replaceBy;
					delete doc.replaceTo;
					//this.contents[0]=newDoc;
				}
			}
			if(doc.SUB_SECTIONS.length>0){
				for(const [index1,doc1] of doc.SUB_SECTIONS.entries()){
					if(doc1['replaceBy']&&doc1['replaceBy'].length>0){//console.log(doc1)
						let newDoc=JSON.parse(JSON.stringify(this.getDoc(doc1['replaceBy'])));//console.log(newDoc);
						if(newDoc){
							if(doc1.id!=doc1['replaceBy']&&this.allsrcIds.indexOf(doc1['replaceBy'])>-1){
								newDoc=this.changeId(newDoc);
							}
							/*if(newDoc['pisummarydata']){
								delete newDoc['pisummarydata']
							}
							if(newDoc['pcasummarydata']){
								delete newDoc['pcasummarydata']
							}
							if(newDoc['hash']){
								delete newDoc['hash']
							}*/
							//this.contents[index].SUB_SECTIONS[index1]=newDoc;
							this.replaceItems(this.contents[index].SUB_SECTIONS[index1], newDoc);
							//this.checkEris(this.contents[index].SUB_SECTIONS[index1]);
							delete doc1.replaced;
							delete doc1.replaceBy;
							delete doc1.replaceTo;
							//this.contents[0]=newDoc;
						}					
					}
					if(doc1.SUB_SECTIONS.length>0){
						for(const [index2,doc2] of doc1.SUB_SECTIONS.entries()){
							if(doc2['replaceBy']&&doc2['replaceBy'].length>0){//console.log(doc2)
									let newDoc=JSON.parse(JSON.stringify(this.getDoc(doc2['replaceBy'])));//console.log(newDoc);
									if(newDoc){
										if(doc2.id!=doc2['replaceBy']&&this.allsrcIds.indexOf(doc2['replaceBy'])>-1){
											newDoc=this.changeId(newDoc);
										}
										/*if(newDoc['pisummarydata']){
											delete newDoc['pisummarydata']
										}
										if(newDoc['pcasummarydata']){
											delete newDoc['pcasummarydata']
										}*/
										//this.contents[index].SUB_SECTIONS[index1].SUB_SECTIONS[index2]=newDoc;
										this.replaceItems(this.contents[index].SUB_SECTIONS[index1].SUB_SECTIONS[index2], newDoc);
										//this.checkEris(this.contents[index].SUB_SECTIONS[index1].SUB_SECTIONS[index2]);
										delete doc2.replaced;
										delete doc2.replaceBy;
										delete doc2.replaceTo;
									}					
								}								
								
							}
						}
					}
				}
			}
		} catch (e) {
			console.log('Import repor Error: ' + e);
			Swal.fire({
				icon: 'info',
				text: "Report importing encounter some errors, please try again",				
			})
			return
			//this.importCancel();
		}
			
		this.compareShow=false;
		this.curId=null;
		if(this.optionShow){
			this.optionShow=false;
			this.curIndex=[this.addon,this.addon,this.addon];
		}
		Swal.fire({
			icon:'success',
			title: 'Success! The Source Report content has been copied into the selected section(s) of your Current Report.',
			confirmButtonText: 'OK',
			showLoaderOnConfirm: true,
			showCancelButton: false,
			backdrop:false,
			preConfirm: () => {
				//this.autoSave('Report Imported','Report Imported','Report Imported');
				this.singleUserSaveRpt('import');
			}
		})
	}
	getDoc(id){console.log(id)
		let selectedDoc:any;
		let sec=this.getSecbyId(this.importContents, id);
		if(sec){
			selectedDoc=this.checkRF(sec);
		}
		
		//console.log(selectedDoc);
		if(selectedDoc){
			return selectedDoc;
		}else{
			return null;
		}
	}
	checkRF(sec){//console.log(sec)
		let newsec=JSON.parse(JSON.stringify(sec));
		if((newsec.slots&&newsec.slots.length>0)&&(newsec.text&&newsec.text.length>0)){			
			newsec=this.updateRF(newsec, 'text', 'htmltext'); //console.log(newsec.text);
			//newsec.htmltext=this.sanitizer.bypassSecurityTrustHtml(newsec.text);
		}
		if(newsec.TYPE=='TABLE'&&newsec.data&&(!newsec.data['erisName'])){
			for(let row of newsec.data.rows){
				if(row.items&&row.items.length>0){
				for(let item of row.items){
					if(item.slots&&item.slots.length>0){
						item=this.updateRF(item, 'htmltext','DATA');//this.replaceSlotText(info, item, 'htmltext','DATA');

					}
				}
				}
			}
		
		}
		
	return newsec;
			
	}
	/*checkEris(sec){
		if(sec.TYPE=='TABLE'&&sec.data&&sec.data.parent_table&&sec.data.parent_table.length>0){
			this.getEris(sec);//console.log(sec.data)
		}
		if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
			for(const [index,doc] of sec.SUB_SECTIONS.entries()){
				if(doc.TYPE=='TABLE'&&doc.data.parent_table&&doc.data.parent_table.length>0){
					this.getEris(doc);//console.log(doc.data)
				}
				if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
					for(const [index1,doc1] of doc.SUB_SECTIONS.entries()){
						if(doc1.TYPE=='TABLE'&&doc1.data&&doc1.data.parent_table&&doc1.data.parent_table.length>0){
							this.getEris(doc1);	//console.log(doc1.data)
						}
					}
				}
			}
			
		}
	}
	getEris(doc){
		//let newdata=JSON.parse(JSON.stringify(tabledata));//console.log(newdata);
		let newdata=doc.data
		if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){
			let id=newdata.SLOT_ID;
			let inputJson={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":id.toString(),"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':doc.id,'SHOW_HIDDEN_RECORD':'N',};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				//console.log('tableslot',response);
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)
																
				}else{
				let data=[];
				if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
					let info=JSON.parse(response.RW_SLOTS[0].CONTENT);//console.log(info);
					data=info.rows;
					let arr=[];
					if(data&&data.length>0){
						for(let row of data){
							let arr1=[];
							for(let col of newdata.cols){
								let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
								if(col.INTERNALNAME=="ES_RID"){
									row[index]['hide']=true;
								}
								arr1.push(row[index]);
									
							}
							arr.push(arr1);
						}
					}
					newdata.rows=arr;
					newdata['parent_table']=info.parent_table;
					if(info.filters&&info.filters.length>0){
						newdata['filters']=info.filters;
					}
					//console.log(newdata)
					return newdata
				}
			}
			})
		}else{
			return newdata
		}
	}*/
	private updateRF(item, key1, key2){////console.log(data)
		let slots=$(item[key1]).find('.placeholder'); ////console.log('slots',slots);
		for(let slot of slots){
			let id=$(slot).data('id'); //console.log(id)
			let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);////console.log(index);
			if(index>-1){
				let info=this.allSlots[index];
				item=this.replaceSlotText(info, item, key1, key2);//'htmltext','DATA');					
			}			
		}
		return item;
	}

	getSecbyId(dataset, secId){////console.log(secId); //console.log(dataset);
		let secContent:any
		for(let item of dataset){
			if(item.id==secId){////console.log(item)
				secContent=item;
				break;
			}else{
				for(let item1 of item.SUB_SECTIONS){
					if(item1.id==secId){////console.log(item1)
						secContent=item1;
						break;
					}else{
						if(item1.SUB_SECTIONS){
						
						for(let item2 of item1.SUB_SECTIONS){
							if(item2.id==secId){////console.log(item2)
								secContent=item2;
								break;
							}
						}
						}
					}
				}
			}
		}
		////console.log(secContent)
		return secContent;
	}
	setSecbyId(dataset, secId, secdata){
		let newContent:any
		for(let item of dataset){
			if(item.id==secId){
				item=secdata;//console.log(item)
				break;
			}else{
				for(let item1 of item.SUB_SECTIONS){
					if(item1.id==secId){
						item1=secdata;
						break;
					}else{
						for(let item2 of item1.SUB_SECTIONS){
							if(item2.id==secId){
								item2=secdata;
								break;
							}
						}
					}
				}
			}
		}
		newContent=dataset;
		return newContent;
	}


	public toPhotoTable(photos, columns) {
		let rows = [];
		let row = [];
		for (let i = 0; i < photos.length; i++) {
			if (i % columns == 0 && row.length > 0) {
				rows.push(row);
				row = [];
			}
			row.push(photos[i]);
		}
		if (row.length > 0) {
			rows.push(row);
			row = [];
		}
		return rows;
	}
	opt=[];
	selOP(e, item,type? ){
		if(type=='Y'){
			 let ele=$(e.target).parent('div').parent('div').children('div');//console.log(ele)
			 this.tableContent1=[];
				for(let i=0; i<ele.length; i++){//console.log(ele[i].children[0]);
					if(ele[i].children[0].checked){
						this.tableContent1.push(this.tableContent[i]);
					}
				}
			
		}else{
			if(e.target.checked){
				this.tableContent1=[item];
			}else{
				this.tableContent1=[];
			}
		}
		//console.log(this.tableContent1)
	}
	curRF:any;
	slotShow=false;
	//signShow=false;
	sealShow=false;
	curtype='';
	curSign:any;
	curSignIndex:-1;
	selectedRF(e){//console.log(e);
		if (this.blockMultiUser()) return;		
		let idstring=e;
		if(Number(e)>-1){
			idstring=e.toString();
		}
		if(idstring.length>0||idstring>0){
			/*if(idstring.indexOf('signature')>-1){
				this.getSign();
				this.curSign={'type':'signature', 'id':idstring};
				this.signShow=true;
			}else if(idstring.indexOf('seal')>-1){
				this.getSeal();
				this.curSign={'type':'seal', 'id':idstring};
				this.signShow=true;
			}else{*/
				let id=parseInt(idstring); //console.log(id);
				let index=this.allSlots.findIndex(item=>item.SLOT_ID==id);
				if(index>-1){
					this.curRF=this.allSlots[index]; //console.log(this.curRF);
					this.getTable(this.curRF.TYPE, this.curRF);
					this.slotShow=true;
				}
			//}
		}
		
	}
	async getSign(field?){
		const permit:any=await this.checkUserPermit(24);
		if(permit.USER_PERMISSION=='N'){
			Swal.fire({
				icon:'info',
				html: '<span>'+permit.MESSAGE+'</span>'							
			})
			return
		}		
		this.curSign=null;
		this.curSignIndex=-1
		this.getCompanySettings();
		let inputJson={"PROCEDURE":"getreportsignatures","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				console.log(response);
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)
																
				}else{
				this.signs=response.RW_USER_LIST;
				this.seals=[];
				this.sealShow=true;
				this.curtype='sign';
				this.date=new Date().toLocaleDateString();
				if(this.reportInfo.PCA_INDICATOR=='frm1104'){
					this.selectedSignField=field;
				}
				if(field=='add'&&this.defaultSign['SIGNATURE_STYLE_ID']){
					this.newsign={};
					this.newsign['signatureTemplate']=true;
					this.newsign['SIGNATURE_STYLE_ID']=this.defaultSign['SIGNATURE_STYLE_ID']
					this.newsign['html']=this.defaultSign['SIGNATURE_STYLE_TEMPLATE_HTML'];
					this.newsign['htmlSec']=this.defaultSign['SIGNATURE_STYLE_TEMPLATE'];	
					this.newsign['label']="Signature Label";		
					this.newsign['role']='';
					this.newsign['roleName']='';
					this.newsign['ALIGN']=this.reportInfo.SIGNATURE_ALIGNMENT_CODE;	
					}
				}
		})
	}
	async getSeal(){
		const permit:any=await this.checkUserPermit(24);
		if(permit.USER_PERMISSION=='N'){
			Swal.fire({
				icon:'info',
				html: '<span>'+permit.MESSAGE+'</span>'							
			})
			return
		}	
		this.curSign=null;
		this.curSignIndex=-1;
		this.getCompanySettings();
		let inputJson={"PROCEDURE":"getcompanyseals","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID};
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
				//console.log(response);
				if (response.RESPONSE_STATUS=='N') {
					this.throwError(response)
																
				}else{
				this.seals=response.RW_USER_LIST;
				this.signs=[];
				this.sealShow=true;
				this.curtype='seal';
				}
		})
	}
	showItem(item){
		if(!item.omit){
			item.omit=false;
		}
	}
	closeCell(){
		setTimeout(() => {console.log(this.curCellBK)
			this.curCell=null;
			this.cellShow=false;
			let id=this.curSec.id;
			let text="";			
			if(this.curCellBK['tcusers']&&this.curCellBK['tcusers'].length>0){
				let item={'html':this.curCellBK['htmltext'], 'text':'', 'tcusers':[], 'suggestions':[], 'comments':[]};
				if(this.curCellBK['text']){
					item['text']=this.curCellBK['text'];
				}
				if(this.curCellBK['tcusers']){
					item['tcusers']=this.curCellBK['tcusers'];
				}
				if(this.curCellBK['suggestions']){
					item['suggestions']=this.curCellBK['suggestions'];
				}
				if(this.curCellBK['comments']){
					item['comments']=this.curCellBK['comments'];
				}
				this.cellSuggest(item, id);
				//this.curSec.tcflag=true;
			}else if(this.curCellBK['htmltext']){
				text=this.curCellBK['htmltext']
				this.cellData(text, id);
				//this.checkTc(this.curSec, 'row')
			}else{
				this.cellData('', id);
				//this.checkTc(this.curSec, 'row')
			}			
			this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
			this.curCellBK=null;
			}, 200);
		
	}
	cellSuggest(e, id){console.log(e)
		this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
		let stitle="";
		this.selectedRow=-1;
		let users=[];
		if(e['suggestions']&&e['suggestions'].length>0 ){
			for(let item of e['suggestions']){
				if(!users.includes(item.authorId)){
					users.push(item.authorId);	
				}
			}
		}
		if(e['comments']&&e['comments'].length>0 ){
			for(let item of e['comments']){
				for(let comm of item['comments']){
					if(!users.includes(comm.authorId)){
						users.push(comm.authorId);	
					}
				}
			}
		}	
		
		let htmlcontent=e['html'];		
		if(this.pageIndex[0]>-1){
			if(users.length>0){
				this.toFContentData('suggestions', e['suggestions'], '',this.pageIndex);
				this.toFContentData('comments', e['comments'], '', this.pageIndex);	
				this.toFContentData('tcusers', users, '', this.pageIndex);
			}else{
				htmlcontent=this.trackErrorFix(htmlcontent)
			}
			let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);			
			this.toFContentData('htmltext', htmlcontent, '',this.pageIndex);
			this.toFContentData('', data, '', this.pageIndex);			
		}else if(this.curIndex[0]>-1){
			if(users.length>0){
				this.toContentData('suggestions', e['suggestions'], '',this.curIndex);
				this.toContentData('comments', e['comments'], '', this.curIndex);
				this.toContentData('tcusers', users, '', this.curIndex);	
			}else{
				htmlcontent=this.trackErrorFix(htmlcontent)
			}	
			let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);		
			this.toContentData('htmltext', htmlcontent, '',this.curIndex);
			this.toContentData('', data, '', this.curIndex);		
		}
		let ids=this.getAllSlotId(htmlcontent); //console.log(ids);
		if(ids&&ids.length>0){
			this.updateRptSlotlist(ids);
		}
		let docSlot=[];
		if(ids&&ids.length>0){
		for(let id of ids){
			let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
			if(index>-1){
				docSlot.push(this.allSlots[index]);
				this.selectedRow=-1
			}
		}
		//console.log(docSlot)
		if(docSlot.length>0){
			if(this.pageIndex[0]>-1){
				this.toFContentData('slots', docSlot, '', this.pageIndex);
			}else if(this.curIndex[0]>-1){
				this.toContentData('slots', docSlot, '', this.curIndex);
			}
		}
	}		
	}
	cellData(e, id?){console.log(e)
		//console.log(this.selectedCell);
		//console.log(this.pageIndex);
		this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
		//console.log('first',this.curIndex);
		let stitle="";
		this.selectedRow=-1;//this.selectedCell.row;
		let tableclass=this.getContentData('tableClass');//console.log('tableclass',tableclass);
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		if(this.pageIndex[0]>-1){
			this.toFContentData('htmltext', e, '',this.pageIndex);
			this.toFContentData('', data, '', this.pageIndex);
			this.toFContentData('suggestions', [], '',this.pageIndex);
			this.toFContentData('comments', [], '', this.pageIndex);	
			this.toFContentData('tcusers', [], '', this.pageIndex);
			if(this.pageIndex[1]>-1){
				stitle=this.frontpages[this.pageIndex[0]].SUB_SECTIONS[this.pageIndex[1]].SECTION_TITLE;
			}else{
				stitle=this.frontpages[this.pageIndex[0]].SECTION_TITLE;
			}
		}else if(this.curIndex[0]>-1){
			if(tableclass){
				this.toContentData('htmltext', e, '',this.curIndex);
				this.toContentData('secHtml', data, '', this.curIndex);
			}else{
				this.toContentData('htmltext', e, '',this.curIndex);
				this.toContentData('', data, '', this.curIndex);
				this.toContentData('suggestions', [], '',this.curIndex);
				this.toContentData('comments', [], '', this.curIndex);	
				this.toContentData('tcusers', [], '', this.curIndex);
			}
			stitle=this.getContentData('SECTION_TITLE')
		}
		let ids=this.getAllSlotId(e); //console.log(ids);
		if(ids&&ids.length>0){
			this.updateRptSlotlist(ids);
		}
		let docSlot=[];
		if(ids&&ids.length>0){
		for(let id of ids){
			let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
			if(index>-1){
				docSlot.push(this.allSlots[index]);
				this.selectedRow=-1
			}
		}
		//console.log(docSlot)
		if(docSlot.length>0){
			if(this.pageIndex[0]>-1){
				this.toFContentData('slots', docSlot, '', this.pageIndex);
			}else if(this.curIndex[0]>-1){
				this.toContentData('slots', docSlot, '', this.curIndex);
			}
		}		
	}		
  }
	toCell(id){
		//console.log(this.curCell.bkcolor)
		//console.log(this.allRow);
		//console.log(this.allCol);
		//console.log(this.selectedCell);
		this.cellsaveErr=false;
		setTimeout(() => {
			if(this.curCell['DATA']&&(this.curCell['htmltext']!=this.curCell['DATA']['changingThisBreaksApplicationSecurity'])){
				this.cellsaveErr=true;
				return
			}
	let data:any;
	this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
	this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex);
	if(this.pageIndex[0]>-1){
		//this.pageIndex=this.getFrontIdIndex(id);//console.log('first',this.pageIndex);
		data=this.getFContentData('data'); //console.log(data);
	}else if(this.curIndex[0]>-1){
		//this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex);
		data=this.getContentData('data'); //console.log(data);
	}
		if(this.allRow){
			for(let row of data.rows[this.selectedCell.row].items){
				row.bkcolor=this.curCell.bkcolor
			}
		}
		if(this.allCol){
			for(let row of data.rows){
				if(row.items[this.selectedCell.col]){
					row.items[this.selectedCell.col].bkcolor=this.curCell.bkcolor
				}
			}
		}
		console.log(this.curCell)
		if(this.curCell['suggestions']&&this.curCell['suggestions'].length>0){
			this.curSec['tcflag']=true;
		}else{
			if(this.curSec['tcflag']){
				this.checkTc(this.curSec, 'row');
			}
			
		}	
		this.curCell=null;
		let overallRatecell=data.rows[this.selectedCell.row][this.selectedCell.col]; console.log(overallRatecell)		
		if(overallRatecell&&overallRatecell.KEY=="overallRating"){
			let titletable=this.getSecbyId(this.contents, 'fme_exec_sum_title_2');
			for(let row of titletable.data.rows){console.log(row)
				for(let item of row){
					if (item.KEY=="overallRating"){
						item.data=overallRatecell.data;
						delete item.htmltext;
						delete item.DATA;
					}
				}
			}
			this.autoSave('modify','fme_exec_sum_title_2', '','O');					
		}else if(overallRatecell&&(overallRatecell.KEY=="Source"||overallRatecell.KEY=="Srouce")){
			let id=data.rows[this.selectedCell.row][0].id;
			let ulItem=this.getSecbyId(this.contents, id);console.log(ulItem)
			ulItem.ul['Source']=overallRatecell.data;	
			this.autoSave('modify',id, ulItem.SECTION_TITLE,'O');				
		}
		this.curCellBK=null;
		console.log('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
		this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);		
		this.cellShow=false;
		
	},200)
	}
	curCol:any;
	curCell:any;
	curCellBK:any;
	curColBK:any;
	curHeader=false
	selectCell(doc, i, col, cell, table?){
		if(doc.TYPE=='4099e'&&(cell.ops||(!(cell.RF||cell.Manual)))||(doc['tableClass']=='PCA'&&doc.id!='pca_summary_0')){
			return
		}
		this.cellsaveErr=false;
		this.curId=doc.id;
		this.listid=doc.id;
		if(!this.tableShow){
			this.cellShow=true;
		}else if(this.curHeader){
			this.curHeader=false;
		}
		this.curSec=doc;
		this.curCol=col;
		this.curCell=cell;
		//if(this.curCap){
		//	this.curCap=null;
		//}
		this.curCellBK=JSON.parse(JSON.stringify(cell))
		this.allRow=false;
		this.allCol=false;
		let x=i;
		let y=doc.data.cols.findIndex(data=>data.INTERNALNAME==col.INTERNALNAME);
		this.selectedCell={'row':x,'col':y}; console.log(this.curCell);
		if(this.tableShow){
			this.preCell={'row':i,'col':y};
		}
	}
	headerShow=false;
	colIndex=-1;
	headerIndex=-1
	selectCol(doc, i, col, type?, hindex?){
		console.log(doc, i, col, type);
		if(doc.data['locked']){
			if(type){
				if(doc.data['locked'][type].indexOf(hindex)>-1){
					//Swal.fire('Header is locked!');
					return	
				}
				
			}else if(doc.data['locked']['header']){
				//Swal.fire('Header is locked!');
				return
			}
		}
		if(!this.tableShow){
			this.headerShow=true;
		}else if(this.curCell){
			this.curCell=null;
		}
		//if(this.curCap){
		//	this.curCap=null;
		//}
		
		this.curSec=doc;
		if(type){
			this.selectedHeaderType=type;
			this.curHeader=true;			
			this.curCol=col;
			this.curColBK=JSON.parse(JSON.stringify(col))
			this.colIndex=i;
			this.headerIndex=hindex;
		}else{
			this.selectedHeaderType='';
			this.headerIndex=-1;
			/*if(col['VH']){
				this.ifVH=true;
			}else{
				this.ifVH=false;
			}*/
			this.curHeader=true;			
			this.curCol=col;
			this.curColBK=JSON.parse(JSON.stringify(col))
			this.colIndex=i;
		}
		/*setTimeout(() => {
			this.hotkeyIcon.nativeElement.click();
		},1000)*/
	}
	colText(e, type?){
		//console.log(this.curSec);
		if(e.length>=0&&this.colIndex>-1){
			////console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			if(type){
				this.curSec.data[type][this.headerIndex][this.colIndex].text=e;
			}else{
				this.curSec.data.cols[this.colIndex].text=e;
			}
			
		}
	}
	colSuggest(e, id, vh?, type?){
		if(e['html'].length>=0&&this.colIndex>-1){
			this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
			//console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			let users=[];
			if(e['suggestions']&&e['suggestions'].length>0 ){
				for(let item of e['suggestions']){
					if(!users.includes(item.authorId)){
						users.push(item.authorId);	
					}
				}
			}
			if(e['comments']&&e['comments'].length>0 ){
				for(let item of e['comments']){
					for(let comm of item['comments']){
						if(!users.includes(comm.authorId)){
							users.push(comm.authorId);	
						}
					}
				}
			}
			let htmlcontent=e['html'];	
			if(type){
				if(users.length>0){
					this.curSec.data[type][this.headerIndex][this.colIndex]['suggestions']=e['suggestions'];
					this.curSec.data[type][this.headerIndex][this.colIndex]['comments']=e['comments'];
					this.curSec.data[type][this.headerIndex][this.colIndex]['tcusers']=users;
				}else{
					htmlcontent=this.trackErrorFix(htmlcontent)
				}
				let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);
				this.curSec.data[type][this.headerIndex][this.colIndex].NAME=htmlcontent;
				this.curSec.data[type][this.headerIndex][this.colIndex].htmltext=data;
				this.curSec.data[type][this.headerIndex][this.colIndex]['text']=e['text'];	
				console.log(this.curSec.data)					
			}else{
				if(users.length>0){
					this.curSec.data.cols[this.colIndex]['suggestions']=e['suggestions'];
					this.curSec.data.cols[this.colIndex]['comments']=e['comments'];
					this.curSec.data.cols[this.colIndex]['tcusers']=users;
				}else{
					htmlcontent=this.trackErrorFix(htmlcontent)
				}
				let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);
				this.curSec.data.cols[this.colIndex].NAME=htmlcontent;
				this.curSec.data.cols[this.colIndex].htmltext=data;
				this.curSec.data.cols[this.colIndex]['text']=e['text'];		
				if(vh){
					this.curSec.data.cols[this.colIndex]['VH']=vh;
				}else{
					if(this.curSec.data.cols[this.colIndex]['VH']){
						delete this.curSec.data.cols[this.colIndex]['VH'];
					}
				}
			}
			
		}		
	}
	colData(e, id, type?){console.log(e, id, type, this.colIndex)
		//console.log(this.curSec);
		if(e.length>=0&&this.colIndex>-1){
			this.curIndex=this.getIdIndex(id);//console.log('first',this.curIndex)
			//console.log('first',this.curIndex);
			this.selectedRow=-1;//this.selectedCell.row;
			if(type){
				this.curSec.data[type][this.headerIndex][this.colIndex].NAME=e;
				this.curSec.data[type][this.headerIndex][this.colIndex].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
				if(this.curSec.data[type][this.headerIndex][this.colIndex]['tcusers']){
					delete this.curSec.data[type][this.headerIndex][this.colIndex]['suggestions'];
					delete this.curSec.data[type][this.headerIndex][this.colIndex]['comments'];
					delete this.curSec.data[type][this.headerIndex][this.colIndex]['tcusers'];
				}
			}else{
				this.curSec.data.cols[this.colIndex].NAME=e;
				this.curSec.data.cols[this.colIndex].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
				if(this.curSec.data.cols[this.colIndex]['tcusers']){
					delete this.curSec.data.cols[this.colIndex]['suggestions'];
					delete this.curSec.data.cols[this.colIndex]['comments'];
					delete this.curSec.data.cols[this.colIndex]['tcusers'];
				}	
			}
			console.log(this.curSec.data)				
		}
	
	}
	toCol(id, type?){
		this.headerShow=false;
		this.curColBK=null;
		if(type){
			if(this.curSec.data[type][this.headerIndex][this.colIndex]['suggestions']&&this.curSec.data[type][this.headerIndex][this.colIndex]['suggestions'].length>0){
				this.curSec['tcflag']=true;
			}else{
				if(this.curSec['tcflag']){
					this.checkTc(this.curSec, 'col');
				}				
			}
		}else{
			/*if(this.ifVH){
				this.curSec.data.cols[this.colIndex]['VH']=true;
			}else{
				if(this.curSec.data.cols[this.colIndex]['VH']){
					delete this.curSec.data.cols[this.colIndex]['VH'];
				}
			}*/
			if(this.curSec.data.cols[this.colIndex]['suggestions']&&this.curSec.data.cols[this.colIndex]['suggestions'].length>0){
				this.curSec['tcflag']=true;
			}else{
				if(this.curSec['tcflag']){
					this.checkTc(this.curSec, 'col');
				}
				
			}
		}
		
		/*if(this.autoFlag){
			this.autoSave('header save', id, title);
		};*/
		this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
	}
	closeCol(type?){console.log(this.curColBK, type)
		setTimeout(() => {
			let id=this.curSec.id;			
			if(this.curColBK['tcusers']){
				let item={'html':'', 'text':'', 'tcusers':[], 'suggestions':[], 'comments':[], 'VH':false};
				if(this.curColBK['NAME']){
					item['html']=this.curColBK['NAME']
				}
				if(this.curColBK['text']){
					item['text']=this.curColBK['text'];
				}
				if(this.curColBK['tcusers']){
					item['tcusers']=this.curColBK['tcusers'];
				}
				if(this.curColBK['suggestions']){
					item['suggestions']=this.curColBK['suggestions'];
				}
				if(this.curColBK['comments']){
					item['comments']=this.curColBK['comments'];
				}
				if(this.curColBK['VH']){
					item['VH']=this.curColBK['VH'];
				}
				if(this.curColBK['VH']){
					this.colSuggest(item, id,this.curColBK['VH']);
				}else{
					this.colSuggest(item, id, type);
				}
				
			}else{
				let text="";
				if(this.curColBK['NAME']){
					text=this.curColBK['NAME'];
					this.colData(text, id, type);					
				}	
				
			}
			this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
			this.curColBK=null;
			}, 200);
		
	}
	/*ifVH=false;
	secVH(e){
		//if(this.curColBK){
			if(e.target.checked){			
				this.ifVH=true;
			}else{
				this.ifVH=false;
			}
		//}
	}*/
	setLock(e, cell){
		if(e.target.checked){			
			cell['lock']=true;
		}else{
			cell['lock']=false;
		}		
	}
	setrowLock(e, type, index?){
		e.preventDefault(); 
		if(this.allowLock!='Y') return;
		let data=this.curSec.data;
		this.resetProp(this.curSec);
		this.resetProp(this.curSec, this.headertype[0])
		this.resetProp(this.curSec, this.headertype[1])
		this.curHeader=false;
		
		if(!data['locked']){
			data['locked']={'beforeHeaders':[],'afterHeaders':[],'header':false};
		}
		let lockedrow=data['locked'];
		if(type=='beforeHeaders'){
			let rindex=lockedrow['beforeHeaders'].indexOf(index);
			if(rindex>-1){
				lockedrow['beforeHeaders'].splice(rindex, 1);
			}else{
				lockedrow['beforeHeaders'].push(index);
			}
		}else if(type=='afterHeaders'){
			let rindex=lockedrow['afterHeaders'].indexOf(index);
			if(rindex>-1){
				lockedrow['afterHeaders'].splice(rindex, 1);
			}else{
				lockedrow['afterHeaders'].push(index);
			}
		}else if(type=='header'){
			lockedrow['header']=!lockedrow['header']

		}else if(type=='row'){
			if(data.rows[index]&&data.rows[index]['lock']){
			//let rindex=lockedrow['row'].indexOf(index);
			//if(rindex>-1){
				//lockedrow['row'].splice(rindex, 1);
				delete data.rows[index]['lock'];
			}else{
				//lockedrow['row'].push(index);
				data.rows[index]['lock']=true;
			}
		}
		this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
	}
   colReorder(e, id){
		for(let row of this.curSec.data.rows){
			moveItemInArray(row.items, e.dragIndex, e.dropIndex);
			
		}
		this.reorderTableData(this.curSec.data)
   }
   rowReorder(e){//console.log(e);dragIndex:, dropIndex

   }
   colResize(e, doc){////console.log(e);
	   ////console.log(e.element);
	   this.curSec=doc;
	   let ele=e.element;
	   let wi=ele.style.width; ////console.log(wi);
	   let pagewidth=816-parseInt(this.pageMargin.right)-parseInt(this.pageMargin.left);
	   let items=$(ele).parent().children(); ////console.log(items);
	   for(let i=1; i<items.length; i++){
		   let cellWidth=items[i].offsetWidth; ////console.log(cellWidth)
		   let val=Math.round(cellWidth/pagewidth*100); //console.log(val)
		   this.curSec.data.cols[i-1].width=val;
		   this.curSec.data.cols[i-1].unit='%';
	   }
		
   }
   selectedHeaderType='';
   selectedHRow=-1;
   headertype=['beforeHeaders','afterHeaders'];
	selectToggle(e, doc, index, type){//console.log(doc, index)
		e.stopPropagation();
		if(type){
			if(doc.data['locked']&&doc.data['locked'][type].indexOf(index)>-1){
				//Swal.fire('This header is locked!');
				return
			}
			this.resetProp(doc);
			if(this.headertype.indexOf(type)>0){
				this.resetProp(doc, this.headertype[0])
			}else{
				this.resetProp(doc, this.headertype[1])
			}
			let selectedrows=[];
			this.selectedRow=-1;
			this.selectedHeaderType=type;
			let selectedHRows=[];
			this.selectedHRow=index;
			if(e.ctrlKey){
				doc.data[type][index]['selected']=!doc.data[type][index]['selected'];
				for(let i=0; i<doc.data[type].length; i++){
					if(doc.data[type][i]['selected']){
						selectedHRows.push(i);
					}
				}
				////console.log(selectedrows)
				if(selectedHRows.length==1){
					this.selectedHRow=selectedHRows[0];
				}else{
					this.selectedHRow=-1;
				}
			}else{
				for(let i=0; i<doc.data[type].length; i++){
					if(i!=index){
						doc.data[type][i]['selected']=false
					}else{
						doc.data[type][i]['selected']=!doc.data[type][i]['selected'];
						if(doc.data[type][i]['selected']){
							this.selectedHRow=index;
						}
					}
				}
			}
			console.log(this.selectedHeaderType,this.selectedHRow, selectedHRows )
		}else{
			/*if(doc.data['locked']&&doc.data['locked']['row'].indexOf(index)>-1){
				Swal.fire('This row is locked!');
				return
			}*/
			if(doc.data&&doc.data.rows[index]&&doc.data.rows[index]['lock']){
				//Swal.fire('Row is locked!');
				return
			}
			this.resetProp(doc, this.headertype[0])
			this.resetProp(doc, this.headertype[1])
			this.selectedHeaderType=''
			let selectedrows=[];
			this.selectedRow=-1;
			if (e.ctrlKey) {
				doc.data.rows[index]['selected']=!doc.data.rows[index]['selected'];
				for(let i=0; i<doc.data.rows.length; i++){
					if(doc.data.rows[i]['selected']){
						selectedrows.push(i);
					}
				}
				////console.log(selectedrows)
				if(selectedrows.length==1){
					this.selectedRow=selectedrows[0];
				}else{
					this.selectedRow=-1;
				}				
			}else{
				for(let i=0; i<doc.data.rows.length; i++){
					if(i!=index){
						doc.data.rows[i]['selected']=false
					}else{
						doc.data.rows[i]['selected']=!doc.data.rows[i]['selected'];
						if(doc.data.rows[i]['selected']){
							this.selectedRow=index;
						}
					}
				}
			}
		}
		
		this.curSec=doc;
		this.preCell={'row':0,'col':0};
		if(this.curCell){
			this.curCell=null;			
		}else if(this.curHeader){
			this.curHeader=null
		}//else if(this.curCap){
		//	this.curCap=null;
		//}

   }
	deleteRows(doc){//console.log(doc)
	   	let totals=[];
		for(let i=0; i<doc.data.rows.length; i++){
			if(doc.data.rows[i].selected){
				totals.push(i);
			}
		}
		let that=this;
		if(totals.length>0){
			Swal.fire({
				icon:'info',
				title: 'Are you sure you want to delete '+totals.length+' item(s)?',
				confirmButtonText: 'Delete',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					doc.data.rows=doc.data.rows.filter(row => row.selected!=true);
					if(this.tableShow){
						this.preCell={'row':0,'col':0};
						this.curCell=null;
					}
				}
			})
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to delete.',
			})
		}
   }
	addCSub(e){
		let posi=$(e.target).prev('select').val();//console.log(posi)
		let data=this.curSec.data;//this.getContentData('data'); //console.log(data);
		let rowData={'items':[]};
		let row=[{'COLUMNINTERNALNAME':data.cols[0].INTERNALNAME,'data':'','celAllign':posi, 'colspan':data.cols.length, 'DATA': {changingThisBreaksApplicationSecurity: ''},htmltext: ""}];
		let key=data.cols[0].INTERNALNAME;
		rowData[key]='';
		rowData.items=row;
		if(this.selectedRow>-1){
			if(this.addBefore){
						data.rows.splice(this.selectedRow,0,rowData);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,rowData);
					}
		}else{
			if(this.addBefore){
						data.rows.splice(data.rows.length-1,0,rowData);
						//this.selectedRow=data.rows.length;//console.log(this.selectedRow);
					}else{
						data.rows.splice(data.rows.length,0,rowData);
						//this.selectedRow=data.rows.length+1;
					}
		}
		if(this.tableShow){
			this.preCell={'row':0,'col':0};
			this.curCell=null;
		}
	}
	addCRows(e){
		let no=$(e.target).prevAll('input').val(); //console.log($(e.target).prev('input'));//console.log(no);
		if(no>0){
			let data=this.curSec.data;//this.getContentData('data'); //console.log(data);
			if(this.curSec.id=='pca_summary_0'){
				let data=this.curSec.data;
				for(let i=0; i<no; i++){
        			let baserow=JSON.parse(JSON.stringify(this.reportService.summaryTable[0].baserow));
       				if(this.selectedRow>-1){
						if(this.addBefore){
							data.rows.splice(this.selectedRow,0,baserow);
							this.selectedRow+=1;
						}else{
							data.rows.splice(this.selectedRow+1,0,baserow);
						}
					}else{
						if(this.addBefore){
							data.rows.splice(data.rows.length-1,0,baserow);							
						}else{
							data.rows.push(baserow);
						}
						
					}
				
				}
			}else{
			for(let i=0; i<no; i++){
				let row=[];
				let rowData={'items':[]};
				for(let j=0; j<data.cols.length; j++){//console.log(data.cols[j])
					let item={'COLUMNINTERNALNAME':'','data':''};
					item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
					rowData[data.cols[j].INTERNALNAME]='';
					if(data.cols[j].DefaultFO&&data.cols[j].DefaultFO.html){
						item.data=data.cols[j].DefaultFO.data
						item['htmltext']=data.cols[j].DefaultFO.html;
						item['DATA']=this.sanitizer.bypassSecurityTrustHtml(item['htmltext']);
						item['slots']=data.cols[j].DefaultFO.slots;

					}					
					//console.log(item)
					row.push(item);
				}
				rowData.items=row;
				if(this.selectedRow>-1){
					if(this.addBefore){
						data.rows.splice(this.selectedRow,0,rowData);
						this.selectedRow+=1;
					}else{
						data.rows.splice(this.selectedRow+1,0,rowData);
					}
				}else{
					if(this.addBefore){
						data.rows.splice(data.rows.length-1,0,rowData);
						
					}else{
						data.rows.push(rowData);
					}
				}
				
			}
		}
		if(this.tableShow){
			this.preCell={'row':0,'col':0};
			this.curCell=null;
		}
		}
	}
	hideRows(doc){
		let totals=[];
		for(let i=0; i<doc.data.rows.length; i++){
			if(doc.data.rows[i].selected){
				totals.push(i);
			}
		}
		let that=this;
		if(totals.length>0){
			for(let row of doc.data.rows){
				if(row.selected){
					row['hide']=!row['hide'];
					//row.selected=false;
				}
			}
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to hide.',
			})
		}
		
	}
	resetProp(doc, type?){
		if(type){
			if((doc.TYPE=='TABLE'&&doc.data&&(!doc.erisName))){
				this.curSec=doc;
				this.curCell=null;
				if(doc.data[type]&&doc.data[type].length>0){
					for(let header of doc.data[type]){
						header.selected=false;
					}
				}
				
			}
		}else{
			if((doc.TYPE=='TABLE'&&doc.data&&(!doc.erisName))||doc.tableClass){
				this.curSec=doc;
				this.curCell=null;
				for(let row of doc.data.rows){
					row.selected=false;
				}
			}	
		}
		
	}
	withBorder:false;
	addHBefore:false;
	addHeaders(e){
		let data=this.curSec.data;
		let posi=$(e.target).prev('select').val();
		let targetset=[]
		if(this.addHBefore){
			if(!data['beforeHeaders']){
				data['beforeHeaders']=[];
			}
			targetset=data['beforeHeaders'];
		}else{
			if(!data['afterHeaders']){
				data['afterHeaders']=[];
			}
			targetset=data['afterHeaders'];
		}
		let headerRow=[]
		for(let j=0; j<data.cols.length; j++){//console.log(data.cols[j])
			let item={'INTERNALNAME':'','NAME':'<p>Header'+j+'</p>', 'text':'Header'+j, 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header'+j+'</p>'}};
			item.INTERNALNAME=data.cols[j].INTERNALNAME;
			item['colAlign']=data.cols[j].colAlign;
			item['unit']=data.cols[j].unit;
			item['width']=data.cols[j].width;
			headerRow.push(item);
		}
		targetset.push(headerRow);		console.log(targetset)		
}
	addHSub(e){
		let data=this.curSec.data;
		let posi=$(e.target).prev('select').val();console.log(posi)
		let targetset=[]
		if(this.addHBefore){
			if(!data['beforeHeaders']){
				data['beforeHeaders']=[];
			}
			targetset=data['beforeHeaders'];
		}else{
			if(!data['afterHeaders']){
				data['afterHeaders']=[];
			}
			targetset=data['afterHeaders'];console.log(targetset)
		}
		let headerRow=[]
		//for(let j=0; j<data.cols.length; j++){//console.log(data.cols[j])
			//let item={'COLUMNINTERNALNAME':'','data':'', 'text':'', 'htmltext':'', 'celAllign':posi, 'colspan':data.cols.length};
			//let item={'COLUMNINTERNALNAME':'','data':'<p>Header</p>', 'text':'Header', 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header</p>', 'celAllign':posi, 'colspan':data.cols.length}};
			let item={'INTERNALNAME':'','NAME':'<p>Header</p>', 'text':'Header', 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Header</p>'}, 'colAlign':posi, 'colspan':data.cols.length};
			item.INTERNALNAME=data.cols[0].INTERNALNAME;
			//item['colAlign']=data.cols[j].colAlign;
			//item['unit']=data.cols[j].unit;
			//item['width']=data.cols[j].width;
			headerRow.push(item);
		//}
		targetset.push(headerRow);		console.log(targetset)
	}
	/*-addCap(e, doc){
		let data=this.curSec.data;
		if(e.target.checked){
			data['caption']={'NAME':'<p>Table Caption</p>', 'text':'Table Caption', 'htmltext':{changingThisBreaksApplicationSecurity: '<p>Table Caption</p>'}, 'border':false, 'align':'center'};		
			this.curCell=null;
			this.selectedCell=null;
			this.curCap=data['caption'];
		}else{
			this.deleteCap(doc);
		}		
	}
	deleteCap(doc){
		let data=this.curSec.data;
		if(data['caption']){
			this.curSec.data['caption']=null;
			delete data['caption'];
			this.curCap=null;
		}
	}
	curCap=null;
	selectCap(doc){
		console.log(doc);
		if(this.headerShow){
			this.headerShow=false;
		}else if(this.curCell){
			this.curCell=null;
		}else if(this.curHeader){
			this.curHeader=false
		}
		if(this.selectedHeaderType){
			this.selectedHeaderType='';
		}
		this.curCapBK=JSON.parse(JSON.stringify(doc.data['caption']));
		this.curCap=doc.data['caption'];
		this.curSec=doc;
	}
	capData(e, id){
		if(e.length>=0){
			this.curSec.data['caption'].NAME=e;
			this.curSec.data['caption'].htmltext=this.sanitizer.bypassSecurityTrustHtml(e);
			this.curSec.data['caption'].border=this.curCap.border;
			if(this.curSec.data['caption']['tcusers']){
				delete this.curSec.data['caption']['suggestions'];
				delete this.curSec.data['caption']['comments'];
				delete this.curSec.data['caption']['tcusers'];
			}				
		}
	}
	capText(e, id){
		if(e.length>=0){
			this.curSec.data['caption']['text']=e;			
		}
	}
	capSuggest(e, id){
		if(e['html'].length>=0){
			this.selectedRow=-1;//this.selectedCell.row;
			let users=[];
			if(e['suggestions']&&e['suggestions'].length>0 ){
				for(let item of e['suggestions']){
					if(!users.includes(item.authorId)){
						users.push(item.authorId);	
					}
				}
			}
			if(e['comments']&&e['comments'].length>0 ){
				for(let item of e['comments']){
					for(let comm of item['comments']){
						if(!users.includes(comm.authorId)){
							users.push(comm.authorId);	
						}
					}
				}
			}
			let htmlcontent=e['html'];	
			if(users.length>0){
				this.curSec.data['caption']['suggestions']=e['suggestions'];
				this.curSec.data['caption']['comments']=e['comments'];
				this.curSec.data['caption']['tcusers']=users;
			}else{
				htmlcontent=this.trackErrorFix(htmlcontent)
			}
			let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);
			this.curSec.data['caption'].NAME=htmlcontent;
			this.curSec.data['caption'].htmltext=data;
			this.curSec.data['caption']['text']=e['text'];		
			if(this.curCap['border']){
				this.curSec.data['caption']['border']=this.curCap['border'];
			}else{
				if(this.curSec.data['caption']['border']){
					delete this.curSec.data['caption']['border'];
				}
			}
		}				
	}
	curCapBK=null;
	closeCap(){
		setTimeout(() => {
			let id=this.curSec.id;			
			if(this.curCapBK['tcusers']){
				let item={'NAME':'', 'htmltext':'', 'text':'', 'tcusers':[], 'suggestions':[], 'comments':[], 'border':false};
				if(this.curCapBK['NAME']){
					item['NAME']=this.curCapBK['NAME']
				}
				if(this.curCapBK['text']){
					item['text']=this.curCapBK['text'];
				}
				if(this.curCapBK['htmltext']){
					item['htmltext']=this.curCapBK['htmltext'];
				}
				if(this.curCapBK['tcusers']){
					item['tcusers']=this.curCapBK['tcusers'];
				}
				if(this.curCapBK['suggestions']){
					item['suggestions']=this.curCapBK['suggestions'];
				}
				if(this.curCapBK['comments']){
					item['comments']=this.curCapBK['comments'];
				}
				if(this.curCapBK['border']){
					item['border']=this.curCapBK['border'];
				}
				this.capSuggest(item, id);				
			}else{
				let text="";
				if(this.curCapBK['NAME']){
					let item={'NAME':'', 'text':'', 'htmltext':{changingThisBreaksApplicationSecurity: '', 'border':false}};		
					if(this.curCapBK['NAME']){
						item['html']=this.curCapBK['NAME']
					}
					if(this.curCapBK['text']){
						item['text']=this.curCapBK['text'];
					}
					if(this.curCapBK['htmltext']){
						item['htmltext']=this.curCapBK['htmltext'];
					}
					if(this.curCapBK['border']){
						item['border']=this.curCapBK['border'];
					}
					this.capData(text, id);					
				}	
				
			}
			this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
			this.curCapBK=null;
			this.curCap=null;
			}, 200)
	}
	toCap(id){
		setTimeout(() => {
			this.headerShow=false;
			this.curCapBK=null;
			if(this.curSec.data['caption']['suggestions']&&this.curSec.data['caption']['suggestions'].length>0){
				this.curSec['tcflag']=true;
			}else{
				if(this.curSec['tcflag']){
					this.checkTc(this.curSec, 'cap');
				}			
			}
			this.curCap=null;
			this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
		}, 200)
	}*/
	deleteHeaders(doc){
		let totals=[];
		for(let type of this.headertype){
			if(doc.data[type]&&doc.data[type].length>0){
				for(let i=0; i<doc.data[type].length; i++){
					if(doc.data[type][i].selected){
						totals.push(i);
					}
				}
			}
		}
		
		
		let that=this;
		if(totals.length>0){
			Swal.fire({
				icon:'info',
				title: 'Are you sure you want to delete '+totals.length+' item(s)?',
				confirmButtonText: 'Delete',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:false,
				preConfirm: () => {
					for(let type of this.headertype){
						if(doc.data[type]&&doc.data[type].length>0){
							doc.data[type]=doc.data[type].filter(header => header.selected!=true);
						}						
					}
					
					if(this.tableShow){
						this.preCell={'row':0,'col':0};
						this.curCell=null;
					}
				}
			})
		}else{
			Swal.fire({
				icon:'info',
				title: 'Please select row(s) you want to delete.',
			})
		}
	}
	resetHProp(doc){
		if((doc.TYPE=='TABLE'&&doc.data&&(!doc.erisName))||doc.tableClass){
			this.curSec=doc;
			this.curCell=null;
			for(let row of doc.data.rows){
				row.selected=false;
			}
		}
	}
	selectHToggle(e, doc, index){//console.log(doc, index)
		e.stopPropagation();
		let selectedrows=[];
		this.selectedRow=-1;
		if (e.ctrlKey) {
			doc.data.rows[index]['selected']=!doc.data.rows[index]['selected'];
			for(let i=0; i<doc.data.rows.length; i++){
				if(doc.data.rows[i]['selected']){
					selectedrows.push(i);
				}
			}
			////console.log(selectedrows)
			if(selectedrows.length==1){
				this.selectedRow=selectedrows[0];
			}else{
				this.selectedRow=-1;
			}
			
		}else{
			for(let i=0; i<doc.data.rows.length; i++){
				if(i!=index){
					doc.data.rows[i]['selected']=false
				}else{
					doc.data.rows[i]['selected']=!doc.data.rows[i]['selected'];
					if(doc.data.rows[i]['selected']){
						this.selectedRow=index;
					}
				}
			}
		}
		this.curSec=doc;

   }
	changeSrc(e, page, src){
		if($(e.target).prop('checked')){
			page['pageSrc']=src;
		}else{
			page['pageSrc']='letter_style';
		}
	}
	/*setFirstHF(e, page){
		if($(e.target).prop('checked')){
			page['firstHF']=true;
		}else{
			page['firstHF']=false;
			//if(page['fHeader']){
				delete page['fHeader']
			//}
			//if(page['fFooter']){
				delete page['fFooter']
			//}			
		}
		console.log(page)
	}*/
	public insertImage(){
		this.ifPhoto=false;
		this.ifAppPdf=false;
		this.ifImage=true;
		this.fileShow=true;
		$('.nav-tabs a[href="#images"]').tab('show');
		this.getAllBk();
		this.uploadType="IMAGE";
	}
	selectIndex:number;
	pageData(e, index, index1?){//console.log(this.frontpages)
		//console.log('page', e, index);
		this.curIndex=[this.addon,this.addon,this.addon];
		let data=this.sanitizer.bypassSecurityTrustHtml(e);
		let sid:string;
		let stitle:string;
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['text']=e;
			this.frontpages[index].SUB_SECTIONS[index1]['htmltext']=data;
			sid=this.frontpages[index].SUB_SECTIONS[index1].id
			stitle=this.frontpages[index].SUB_SECTIONS[index1].SECTION_TITLE;
			if(this.frontpages[index].SUB_SECTIONS[index1]['tcusers']){
				delete this.frontpages[index].SUB_SECTIONS[index1]['suggestions']
				delete this.frontpages[index].SUB_SECTIONS[index1]['comments']
				delete this.frontpages[index].SUB_SECTIONS[index1]['tcusers']
			}
			
		}else{
			this.frontpages[index]['text']=e;
			this.frontpages[index]['htmltext']=data;
			sid=this.frontpages[index].id
			stitle=this.frontpages[index].SECTION_TITLE;
			if(this.frontpages[index]['tcusers']){
				delete this.frontpages[index]['suggestions'];
				delete this.frontpages[index]['comments'];
				delete this.frontpages[index]['tcusers'];
			}		
		}
		let ids=this.getAllSlotId(e); //console.log(ids);
		if(ids&&ids.length>0){
			this.updateRptSlotlist(ids);
		}
		let docSlot=[];
		if(ids&&ids.length>0){
			for(let id of ids){
				let sindex=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
				if(sindex>-1){
					docSlot.push(this.allSlots[sindex]);
				}
			
			}
		}
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['slots']=docSlot;
		}else{
			this.frontpages[index]['slots']=docSlot;
		}
		this.autoSave('modify',sid, stitle, 'F');
	
	}
	pageSuggest(e, index, index1?){//console.log(this.frontpages)
		console.log('page', e, index);
		this.curIndex=[this.addon,this.addon,this.addon];
		let sid:string;
		let stitle:string;
		let users=[];
		if(e['suggestions']&&e['suggestions'].length>0 ){
			for(let item of e['suggestions']){
				if(!users.includes(item.authorId)){
					users.push(item.authorId);	
				}
			}
		}
		if(e['comments']&&e['comments'].length>0 ){
			for(let item of e['comments']){console.log(item)
				for(let comm of item['comments']){
					if(!users.includes(comm.authorId)){
						users.push(comm.authorId);	
					}
				}
				
			}
		}
		console.log(users)
		let htmlcontent=e['html'];
		if(users.length>0){
			if(index1>-1){
				this.frontpages[index].SUB_SECTIONS[index1]['suggestions']=e['suggestions'];
				this.frontpages[index].SUB_SECTIONS[index1]['comments']=e['comments'];
				this.frontpages[index].SUB_SECTIONS[index1]['tcusers']=users;			
			}else{
				this.frontpages[index]['suggestions']=e['suggestions'];
				this.frontpages[index]['comments']=e['comments'];
				this.frontpages[index]['tcusers']=users;			
			}
		}else{
			htmlcontent=this.trackErrorFix(htmlcontent);			
		}
		let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);
		if(index1>-1){
			this.frontpages[index].SUB_SECTIONS[index1]['text']=htmlcontent;
			this.frontpages[index].SUB_SECTIONS[index1]['htmltext']=data;
			sid=this.frontpages[index].SUB_SECTIONS[index1].id;
			stitle=this.frontpages[index].SUB_SECTIONS[index1].SECTION_TITLE
		}else{
			this.frontpages[index]['text']=htmlcontent;
			this.frontpages[index]['htmltext']=data;
			sid=this.frontpages[index].id
			stitle=this.frontpages[index].SECTION_TITLE
		
		}
		let ids=this.getAllSlotId(htmlcontent); //console.log(ids);
		if(ids&&ids.length>0){
			this.updateRptSlotlist(ids);
		}
			let docSlot=[];
			if(ids&&ids.length>0){
				for(let id of ids){
					let sindex=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
					if(sindex>-1){
						docSlot.push(this.allSlots[sindex]);
					}
				
				}
			}
			if(index1>-1){
				this.frontpages[index].SUB_SECTIONS[index1]['slots']=docSlot;
			}else{
				this.frontpages[index]['slots']=docSlot;
			}			
			setTimeout(() => {
				this.autoSave('modify',sid, stitle, 'F');
			}, 200);
	}
	pdfFname={ "name":'','reqIndex':0,};
	pdfedit=false;
	pdfData(e){
		//console.log(e)
		this.pdfFname['text']=e;
	}
	pdfPara(e){
		//console.log(e);
		if(e.length>0){
			this.pdfFname.name=e;
		}
	}
	async savepdf(){console.log(this.pdfFname)
		//this.pdfFname.reqIndex++;		
		let pdfInfo={'text':this.pdfFname['text'], "name":this.pdfFname.name};
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"PDF_FILE_NAME":JSON.stringify(pdfInfo)};
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if (data.RESPONSE_STATUS=='N') {
			this.throwError(data)
												
		}
		//console.log(data);
		this.reportInfo=data;
	}
	addCost(type){
		if(this.selectedEditor=='O'){
		let pca=this.checkPca();
		if(pca){
			if(type=='A'){
				this.addCostTable()
			}else if(type=='B'){
				this.addCostTable2()
			}
		}else{
			Swal.fire({
				icon: 'info',
				title: "There is no PCA Cost Table in this template."
			})
		}
		}else{
			Swal.fire({
				icon:'info',
				title: "A Cost Recommendation table must be added to a section. Select a report section from the Sections tab on the left sidebar of your report.",
			})
		}
	}
	checkPca(){
		let pca=false
		let index=this.contents.findIndex(sec=>sec.TYPE=='COST');
		if(index>-1){
			pca=true;
		}else{
			pca=false;
		}
		return pca
	}
	addCostTable(){
		let item={'TYPE':'COSTTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Cost Recommendation Table",'SUB_SECTIONS':[]};
		this.addToContent(item);

		this.createCostTable();
	}
	addCostTable2(){
		let item={'TYPE':'COSTTABLE','DISPLAY_SEQUENCE': "N",'SECTION_SEQUENCE': "",'SECTION_TITLE': "Cost Recommendation Table",'SUB_SECTIONS':[]};
		this.addToContent(item);
	
		this.createCostTable('cost2');
	}
	setCurIndex(){
		let index1=this.curIndex[0];
		let index2=this.curIndex[1];
		let index3=this.curIndex[2];
		if(index3>-1){
			this.curIndex=[index1,index2,index3+1];
		}else if(index2>-1&&!index3){
			this.curIndex=[index1,index2,0];
		}else if(index1>-1&&!index2&&!index3){
			this.curIndex=[index1,0,this.addon];
		}
	}
	createCostTable(type?){
		this.curCostTable={'cols':[],'rows':[]};
		let cols:any;
		let keys=[];
		if(type&&type=='cost2'){
			cols=this.costCols2; //['Item','EUL','EFF AGE','RUL','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Year x', 'Total'];
			keys=this.costKeys2;//['Item','EUL','EFF','RUL','Quantity','Unit','Cost','Cycle','Percent','Year', 'Total'];
			this.curCostTable['version']='2';
		}else{
			cols=this.costCols1;//['Item','Quantity','Unit','Unit Cost','Cycle Replacement','Replacement Percent','Reserve Total','Short Term Total'];
			//cols.splice(7,0,'Immediate Total');
			keys=this.costKeys1;//['Item','Quantity','Unit','Cost','Cycle','Percent','Reserve','Immediate','Short']
			
		}
			for(let i=0; i<cols.length; i++){
				let item={'INTERNALNAME':'col'+i,'NAME':cols[i],'TYPE':'text', 'width':null, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left','KEY':keys[i]};
				if(!type){
					if(item.KEY=='Cycle'||item.KEY=='Percent'){
						item['hide']=true;
					}
					if(item.KEY=='Short'&&this.pcaOp.term=='Exclude'){
						item['hide']=true;
					}
				}else if(type&&type=='pca'){
					if(item.KEY=='Reserve'){
						item['hide']=true;
					}
				}
				//console.log(item);
				this.curCostTable.cols.push(item)
			}
			let row=[]
			for(let j=0; j<this.curCostTable.cols.length; j++){
				let item={'COLUMNINTERNALNAME':'','data':'', 'KEY':''};
				item.COLUMNINTERNALNAME=this.curCostTable.cols[j].INTERNALNAME;
				if(!type){
					if(this.curCostTable.cols[j].KEY=='Cycle'||this.curCostTable.cols[j].KEY=='Percent'){
						item['hide']=true;
					}
				
				}else if(type&&type=='pca'){
					if(this.curCostTable.cols[j].KEY=='Reserve'){
						item['hide']=true;
					}
				}
				//console.log(item);
				row.push(item);
			}
			this.curCostTable.rows.push(row);
			//console.log(this.curCostTable)
			this.toContentData('data', this.curCostTable, '')
			let table={'data':this.curCostTable, 'index':this.curIndex};
			this.getAllCostTable();
			let id=this.getContentData('id');////console.log(id)
			let title=this.getContentData('SECTION_TITLE');////console.log(title)
			this.autoSave('add', id, title, 'O');
	}
	sideNavWidth = '60px'
	toggleSideBarVar = false
	toggleSideBar(){
		if(this.toggleSideBarVar == false) {
			this.sideNavWidth = '400px'
			this.toggleSideBarVar = true
		} else if(this.toggleSideBarVar == true) {
			this.sideNavWidth = '60px'
			this.toggleSideBarVar = false
		}
	}

	public openMapTools() {
		const r = this.cookieService.getCookie("r") || '';
		const name = this.cookieService.getCookie("userName") || '';
		const rid = this.route.snapshot.paramMap.get('id') || '';
		const token = JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
		const questString = `r=${r}&rid=${rid}&name=${name}&token=${token}`;
		const base64Url = environment.mapTools_host + btoa(questString);console.log(base64Url);

		window.open(base64Url, '_blank');
	}
	costParents=[];
	getParent(e){//console.log(this.onlyCost)
		if(this.onlyCost){
		for(let item of this.contents){
			for(let item1 of item.SUB_SECTIONS){
				if(item1.TYPE=='COSTTABLE'){//console.log(item1.data);
				}
				if(item1.SUB_SECTIONS&&item1.SUB_SECTIONS.length>0){
					for(let item2 of item1.SUB_SECTIONS){
						if(item2.TYPE=='COSTTABLE'){//console.log(item2.data);
							if(this.costParents.indexOf(item.id)<0){
								this.costParents.push(item.id);
							}
							if(this.costParents.indexOf(item1.id)<0){
								this.costParents.push(item1.id);
							}
						}
					}
				}
				
			}
		}
		}
	}
	updateFunction(id, slot,e){console.log(id, slot)
		let newContent=slot.CONTENT;//console.log(newContent);
		$(e.target).next('span').css('display','inline-block');
		$(e.target).prop('disabled','disabled');
		if(this.curReport.REPORT_ID==id){
			this.updateSlot(slot.SLOT_ID, newContent, 'local');
			setTimeout(() => {
				$(e.target).prev('span').text(newContent);
				$(e.target).prev('span').css('color','#F78181');
				$(e.target).next('span').css('display','none');
				$(e.target).prop('disabled',false);
			},3000);
					
			return
		}
		let inputJson1={"PROCEDURE":"updateslotcontent","USER_ID":parseInt(this.userId),"SLOT_ID":slot.SLOT_ID,"SLOT_CONTENT":slot.CONTENT,'REPORT_ID':id};
		this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
			//console.log(response);
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response)
			}
		})
		/*no sure if need to update pdf name slot?*/
		let inputJson2= {"PROCEDURE":"getreport", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(result => {
			if (result.RESPONSE_STATUS=='N') {
				this.throwError(result)
				return							
			}
			if(result.PDF_FILE_NAME&&result.PDF_FILE_NAME.length>0){
				let pdfnameObj=JSON.parse(result.PDF_FILE_NAME);
				if(pdfnameObj['text'].length>0){
					let slotIds=this.getAllSlotId(pdfnameObj['text']);
					if(slotIds.indexOf(slot.SLOT_ID)>-1){
						pdfnameObj=this.replaceSlotText(slot, pdfnameObj, 'text');
						console.log($('<div>'+pdfnameObj['text']+'</div>')[0].innerText);
						let val=$('<div>'+pdfnameObj['text']+'</div>')[0].innerText
						pdfnameObj['name']=val;
						let pdfInfo={'text':pdfnameObj['text'], "name":pdfnameObj.name};console.log(pdfInfo);
						let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":id,"PDF_FILE_NAME":JSON.stringify(pdfInfo)};
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
							if (data.RESPONSE_STATUS=='N') {
								this.throwError(data)														
							}
						});
					}
				}				
			}
		})
		
		let inputJson= {"PROCEDURE":"getreportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"VERSION_ID":null};// Optional Version_ID - select most recent version if version_id is null
		//console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log('otherdata',data);
			if(data.ERRORCODE){
					this.throwError(data)
					$(e.target).next('span').css('display','none');
					$(e.target).prop('disabled',false);
				return
			}
			//this.curReport=data;
			let slotInfo:any;
			let desContents=[];
			let desfronts=[];			
			if(data.REPORT_DATA&&data.REPORT_DATA.length>0){
				desContents=JSON.parse(data.REPORT_DATA); //console.log('content',desContents);
				for(let sec of desContents){
					if(sec.text&&sec.text.length>0){
						let ids=this.getAllSlotId(sec.text); //console.log(ids);
						if(ids.indexOf(slot.SLOT_ID>-1)){
							sec=this.replaceSlotText(slot, sec, 'text', 'htmltext');
						}					
					}
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.text&&sec1.text.length>0){
							let ids1=this.getAllSlotId(sec1.text); //console.log(ids);
							if(ids1.indexOf(slot.SLOT_ID>-1)){
								sec1=this.replaceSlotText(slot, sec1, 'text', 'htmltext');
							}
						}
						if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data.erisName)){
							for(let row of sec1.data.rows){
								if(row.items&&row.items.length>0){
									for(let cell of row.items){
										if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==slot.SLOT_ID)>-1){
											cell=this.replaceSlotText(slot, cell, 'htmltext','DATA');
										}
									}
								}
							}
						}
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.text&&sec2.text.length>0){
								let ids2=this.getAllSlotId(sec2.text); //console.log(ids);
								if(ids2.indexOf(slot.SLOT_ID>-1)){
									sec2=this.replaceSlotText(slot, sec2, 'text', 'htmltext');
								}								
							}
							if(sec2.TYPE=='TABLE'&&sec2.data&&(!sec2.data.erisName)){
							for(let row of sec2.data.rows){
								for(let cell of row.items){////console.log(cell)
									if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==slot.SLOT_ID)>-1){
										cell=this.replaceSlotText(slot, cell, 'htmltext','DATA');
									}
								}
							}
						}
						}
					}
				}
				
			}
			if(data.BEFORE_TOC&&data.BEFORE_TOC.length>0){
				desfronts=JSON.parse(data.BEFORE_TOC); 
				for(let sec of desfronts){
					if(sec.text&&sec.text.length>0){
						let ids=this.getAllSlotId(sec.text);
						if(ids.indexOf(slot.SLOT_ID>-1)){
							sec=this.replaceSlotText(slot, sec, 'text', 'htmltext');
						}
					}
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.text&&sec1.text.length>0){
							let ids1=this.getAllSlotId(sec1.text);
							if(ids1.indexOf(slot.SLOT_ID>-1)){
								sec1=this.replaceSlotText(slot, sec1, 'text', 'htmltext');
							}
						}
						if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data.erisName)){
							for(let row of sec1.data.rows){
								for(let cell of row.items){
									if(cell.slots&&cell.slots.findIndex(a=>a.SLOT_ID==slot.SLOT_ID)>-1){
										cell=this.replaceSlotText(slot, cell, 'htmltext','DATA');
									}
								}
							}
						}
					}
				}
			}
			if(data.REPORT_DATA&&data.REPORT_DATA.length>0){	
				let beforeToc=JSON.stringify(desfronts)
				let inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":id,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(desContents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":data.APPENDIX_DATA,'PCA_DATA':data.PCA_DATA, 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'',"PERCENT_COMPLETE":data.PERCENT_COMPLETE+'%',"REVIEWER_PROGRESS":data.REVIEWER_PROGRESS+'%'};
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
					if(data.RESPONSE_STATUS=='N'){
						this.throwError(data);
					}else{
						$(e.target).prev('span').text(newContent);
						$(e.target).prev('span').css('color','#F78181');
					}
					$(e.target).next('span').css('display','none');
					$(e.target).prop('disabled',false);
					
				})
			}else{
				$(e.target).next('span').css('display','none');
				$(e.target).prop('disabled',false);
				$(e.target).prev('span').text(newContent);
				$(e.target).prev('span').css('color','#F78181');
			}
		})
	}
	updatedesc(field, item, e){
		item[field]=e
	}
	clipboardText='';
	clipboardTC:any
	copyCell(data){
		//console.log(data)
		if(data.htmltext){
			this.clipboardText=data.htmltext;
			if(data.tcusers){
				this.clipboardTC={'tcusers':data.tcusers};
				if(data.suggestions&&data.suggestions.length>0){
					this.clipboardTC['suggestions']=data.suggestions;
				}
				if(data.comments&&data.comments.length>0){
					this.clipboardTC['comments']=data.comments;
				}
			}else{
				this.clipboardTC=null;
			}
		}
		
	}
	pasteCell(data){
		//console.log(data,this.preCell, this.curSec.data)
		/*if(this.curSec.data&&this.curSec.data['locked']){
			let lockedrow=this.curSec.data['locked']['row'];
			if(lockedrow.indexOf(this.preCell['row'])>-1){
				Swal.fire('Row is locked, can not edit');
			return
			}
		}*/
		if(this.curSec.data&&this.curSec.data.rows[this.preCell['row']]&&this.curSec.data.rows[this.preCell['row']]['lock']){
			//Swal.fire('Row is locked, can not edit');
			return
		}
		if(this.curSec.data&&(!data['colspan']&&this.curSec.data.cols[this.preCell['col']]['lock'])){
			//Swal.fire('Column is locked, can not edit');
			return
		}
		if(data['lock']){
			//Swal.fire('Cell content is locked, can not edit');
			return
		}
		if(!data.htmltext){
			data.htmltext='';
		}
		if(this.clipboardText.length>0){
			data['htmltext']=this.clipboardText;
			data.DATA=this.sanitizer.bypassSecurityTrustHtml(data.htmltext);
			let ids=this.getAllSlotId(this.clipboardText); //console.log(ids);
			if(ids&&ids.length>0){
				let docSlot=[];
				for(let id of ids){
					let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);
					if(index>-1){
						docSlot.push(this.allSlots[index]);
					}
					
				}
				if(docSlot.length>0){
					data['slots']=docSlot;
				}
			}
			if(this.clipboardTC){
				data['tcusers']=this.clipboardTC['tcusers'];
				if(this.clipboardTC['suggestions']&&this.clipboardTC['suggestions'].length>0){
					data['suggestions']=this.clipboardTC['suggestions'];
					this.curSec['tcflag']=true;
				}
				if(this.clipboardTC['comments']&&this.clipboardTC['comments'].length>0){
					data['comments']=this.clipboardTC['comments'];
				}
			}
		}
		
	}
	addCheckmark(data){
		//console.log(data)
		if(!data.htmltext){
			data.htmltext='';
		}
		data.htmltext=data.htmltext+'<span>✓</span>'
		data.DATA=this.sanitizer.bypassSecurityTrustHtml(data.htmltext);
	}
	clearCheckmark(data){
		data.data='';
		data.htmltext='';
		data.DATA=null;		
		delete data['suggestions'];
		delete data['comments'];
		delete data['tcusers'];
		if(this.curSec['tcflag']){
			this.checkTc(this.curSec, 'row')
		}	
	}
	reserveTerm=12;
	pcaQuantity=0;
	changeFactor(no, type){console.log(no, type)
		if(type&&(type=='age')){
			if(no>1){
				/*if(type=='reserve'){
					no=parseInt(e.target.value);
					if(no<this.pcaOp.reserve){
						Swal.fire({
							icon:'warning',
							title: 'Any costs in the years being eliminated will be deleted. User action may be required to adjust the costs. Are you sure you want to continue?',
							confirmButtonText: 'Continue',
							showLoaderOnConfirm: true,
							showCancelButton: true,
							confirmButtonColor: "#F78181",
  							cancelButtonColor: "#5cb85c",
							backdrop:false,
							preConfirm: () => {
								this.pcaOp[type]=no;
							}
						}).then((result) => {
							if (result.isDismissed){
								e.target.value=this.pcaOp[type];
							}
						});
					}
					if(this.reportInfo.PCA_INDICATOR=='4099e'&&no>15){
						this.pcaOp[type]=15;
					}else if(no>30){
						this.pcaOp[type]=30;
					}
				}*/
				if(!Number.isInteger(no)){
					this.pcaOp[type]=Math.ceil(no);
				}
				
			}else{
				this.pcaOp[type]=1;
			}
		}	
		console.log(this.pcaOp[type])
		this.afterPcaChange(this.pcaOp[type], type);
		/*if(this.reportInfo.PCA_INDICATOR=='4099e'){
			this.getTotalCost1();
		}else if(this.reportInfo.PCA_INDICATOR=='Y'){
			this.getTotalCost();
		}else if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			if(type=='reserve'){
				this.reserveTerm=this.pcaOp.reserve;console.log(this.reserveTerm)
			}
			if(type='quantity'){
				this.pcaQuantity=this.pcaOp.quantity;
			}
		}
		if(this.summaryStatus){
			this.getTotalSummary();
			this.changeOpItem();
		}
		this.autoSave('PCA Factor Update',no.toString(),"PCA Factor Update");*/
	}
	changeReserve(type, e){
		this.logUsers(null, null);
		setTimeout(() => {
		if(this.rptUser.length>1){
			$('input#reserveInput').val(this.pcaOp.reserve);
			return
		} 
		let inputval=$('input#reserveInput').val(); console.log(inputval);//parseFloat(e.target.value);
		let no=Math.floor(inputval);
		if(no<1) {
			no=1;
			$('input#reserveInput').val(no);
		}
		if(no<this.pcaOp.reserve){
				Swal.fire({
					icon:'warning',
					text: 'Any costs in the years being eliminated will be deleted. User action may be required to adjust the costs. Are you sure you want to continue?',
					confirmButtonText: 'Continue',
					showLoaderOnConfirm: true,
					showCancelButton: true,
					confirmButtonColor: "#F78181",
  					cancelButtonColor: "#5cb85c",
					backdrop:false,
					preConfirm: () => {
						this.pcaOp[type]=no;						
					}
				}).then((result) => {
					if (result.isDismissed){
						$('input#reserveInput').val(this.pcaOp[type]);//e.target.value=this.pcaOp[type];
						return
					}else if(result.isConfirmed){
						this.pcaOp[type]=no;
						this.modifyAllCost();
						this.afterPcaChange(no, type);
					}
				});
			}else if(this.reportInfo.PCA_INDICATOR=='4099e'&&no>=15){
				this.pcaOp[type]=15;
				$('input#reserveInput').val(15);
				this.modifyAllCost();
				this.afterPcaChange(15,type);
			}else if(no>=30){
				this.pcaOp[type]=30;
				$('input#reserveInput').val(30);
				this.modifyAllCost();
				this.afterPcaChange(30, type);
			}else{
				this.pcaOp[type]=no;
				this.modifyAllCost();
				this.afterPcaChange(no, type);
			}
		}, 500);
		
	}
	afterPcaChange(no, type){
		if(this.reportInfo.PCA_INDICATOR=='4099e'){
			this.getTotalCost1();
		}else if(this.reportInfo.PCA_INDICATOR=='Y'){
			this.getTotalCost();
		}else if(this.reportInfo.PCA_INDICATOR=='frm1105'){
			if(type=='reserve'){
				this.reserveTerm=this.pcaOp.reserve;console.log(this.reserveTerm)
			}
			if(type='quantity'){
				this.pcaQuantity=this.pcaOp.quantity;
			}
		}
		if(this.summaryStatus){
			this.getTotalSummary();
			this.changeOpItem();
		}
		this.autoSave('PCA Factor Update',no.toString(),"PCA Factor Update");
	}
	toolPanelToggle(e){
		let ele=$(e.target).children('i');//console.log(ele)
		if(ele.hasClass('fa-angle-double-right')){
			ele.removeClass('fa-angle-double-right');
			ele.addClass('fa-angle-double-left');
		$("#editPanel").removeClass('col-md-7');
		$("#editPanel").addClass('col-md-9');
		$("#toolPanel").toggle();
		//$("#toolPanel").
		}else{
			ele.removeClass('fa-angle-double-left');
			ele.addClass('fa-angle-double-right');
			
		$("#editPanel").removeClass('col-md-9');
		$("#editPanel").addClass('col-md-7');
		$("#toolPanel").toggle();
		}
	}
	saveMargin(type?){
		let margin={
				"TOC_MARGIN_TOP":this.tocMargin.top.toString(),
				"TOC_MARGIN_BOTTOM":this.tocMargin.bottom.toString(),
				"TOC_MARGIN_LEFT":this.tocMargin.left.toString(),
				"TOC_MARGIN_RIGHT":this.tocMargin.right.toString(),
				"REPORT_MARGIN_TOP":this.pageMargin.top.toString(),
				"REPORT_MARGIN_BOTTOM":this.pageMargin.bottom.toString(),
				"REPORT_MARGIN_LEFT":this.pageMargin.left.toString(),
				"REPORT_MARGIN_RIGHT":this.pageMargin.right.toString(),
			
		}
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,...margin};
		//let inputJson={ "PROCEDURE": "updaterwprofile", "USER_ID": parseInt(this.userId), 'REPORT_ID': this.curReport.REPORT_ID, "COMPANY_ID": this.userInfo.COMPANY_ID.toString(), ...margin };
			//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log("profile", data);
			if(data.RESPONSE_STATUS=='Y'){
				this.reportInfo=data;
				$('#marginModal').modal('hide');
			}else{
				this.throwError(data)
			}
		});
		
	}
	setToc(e){
		let val=e.target.value;
		let	inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"TOC_IND":val};
			//console.log(inputJson);
			this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
				//console.log(data);
				if(data.RESPONSE_STATUS=="Y"){
					this.reportInfo=data;
				}else{
					this.throwError(data)
				}
			})
	}
	getHash(doc){//console.log(doc)
		let newdoc=JSON.parse(JSON.stringify(doc));
		/*if(doc.id=="frm_sec"){
			doc=this.getSecbyId(this.contents, 'frm_sec');
		}*/
		//console.log(newdoc);
		if(newdoc.SUB_SECTIONS){
			newdoc.SUB_SECTIONS=[];
		}
		
		newdoc.hash='';
		//newdoc.READ_ONLY='';
		/*if(this.selectedEditor=='F'){
			newdoc.wcompleted='';
			newdoc.rcompleted='';
		}*/
		let content=JSON.stringify(newdoc);
		let hash = Md5.hashStr(content);//console.log(hash)
		return hash;
	}
	checkHash(doc, doc2){//console.log(doc, JSON.parse(doc2))
		let oldhash=doc.hash;//console.log(oldhash)
		let newdoc=JSON.parse(doc2).data;
		let hash=this.getHash(newdoc);//console.log(hash)
		//if(doc.id=="frm_sec"){
		//	this.listid="frm_sec";
		//}
		if(oldhash!=hash&&(this.listid||doc.id=='frm_sec')){
			doc.hash=hash;
			return true
		}else{
			return false
		}
	}
	getContentHash(doc){
		let newdoc=JSON.parse(JSON.stringify(doc));
		//if(newdoc.SUB_SECTIONS){
		//	newdoc.SUB_SECTIONS=[];
		//}
		//newdoc.hash='';
		let selectedContent='';
		if(typeof newdoc.text === "string"){
			selectedContent=newdoc.text;
		}else if(newdoc.TYPE=='TABLE'&&newdoc.data){
			let item={'cols':newdoc.data.cols, 'rows':newdoc.data.rows};
			if(newdoc.data.filters){
				item['filters']=newdoc.data.filters;
			}
			selectedContent=JSON.stringify(item);
		}		
		let hash = Md5.hashStr(selectedContent);//console.log(hash)
		return hash;
	}
	confirmExit(user) {
		let that = this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to sign [' + user.USER_FULLNAME + '] out of this report?',
			confirmButtonText: 'Continue',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				that.exitReport(user.USER_ID);
			}
		});
	}
	exitReport(userId) {
		let	inputJson = {"PROCEDURE":"expireuserinreport","USER_ID":this.userId,"REPORT_ID":this.curReport.REPORT_ID.toString(),"EXPIRE_USER_ID":userId};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=="Y"){
				if (this.userId == userId)
					window.top.close();
				else {
					const idx = this.rptUser.findIndex(u => u.USER_ID == userId);
					if (idx > -1)
						this.rptUser.splice(idx, 1);
				}
			}else{
				this.throwError(data)
			}
		});
	}
	blockMultiUser(block?) {
		this.logUsers(null, null);
		if ((block == undefined || block) && this.rptUser.length > 1) {
			Swal.fire({
				icon:'warning',
				html: `<div style="text-align:left; font-size:1rem;">
						<h5 style="margin:1rem 0">IMPORTANT: There are now multiple users in this report!</h5>
						<p style="margin:1rem 0">To protect your work, the following operations have been temporarily limited:</p>
						<ul>
							<li>Updating <u>Repeat Fields</u></li>
							<li>Adding, deleting, or rearranging <u>Sections</u> and <u>Tables</u></li>
							<li><u>Importing</u> data from a different report</li>
							<li>Updating your ERIS Order Number</li>
							<li>Restoring your report to a previous version in full</li>
							<li>Find and Replace</li>
							<li>Spelling Check for Entire Report</li>
							<li>Update All Signatures with Same Role</li>
						</ul>
					</div>`
			});
			return true;
		} else {
			return false;
		}
	}
	comparisonTable() {
		if (this.blockMultiUser(true))
			return;

		this.loading=false;
		this.updateShow=true;
		this.compareRpts=[];
		this.compareSlots=[];
		this.exSlots=[];
		this.compareTitles=[];
		this.updatedSlots=[];
		this.projectRpts=[];
		this.getProjectRpts();
	}
	logTab(id, ifPop?){
		let inputJson={"PROCEDURE":"loguserinreporttab", "USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"TAB_ID":id}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data)
			if(data.RESPONSE_STATUS=='Y'){
				this.secUser=data.RW_SECTION_USERS;
				if(data.ALLOWED_TO_EDIT=='Y'){
						this.listLocked = false;
						let id=data.TAB_ID; //console.log(id)
						if(id=='appendix'&&this.allowAdd){
							this.appEditable='Y';
						}else if(id=='PCA'&&this.allowAdd){
							this.PCAEditable='Y';
						}
					}else if(data.ALLOWED_TO_EDIT=='N'){
						this.listLocked = true;
						let id=data.TAB_ID; //console.log(id)
						if(id=='appendix'){
							this.appEditable='N';
						}else if(id=='PCA'){
							this.PCAEditable='N';
						}
						let users="other user";
							for (let user of this.secUser){
								if(user.ALLOWED_TO_EDIT=="Y"){
									users=user.USER_FULLNAME;
									break;
								}
							}
							//console.log('log fire')
							if(!ifPop){
								Swal.fire({
								icon: 'info',
								title: 'Section is locked by '+users+' who is currently working on it.' ,
							});
							}
							
					}
			}else{
				this.throwError(data)
			}
		})
	}
	coverImages=[];
	coverHtml:any;
	editCover(){
		this.coverHtml=null;
		let index=this.covercopy.findIndex(item=>item['COVERPAGE_ID']==this.selectedCover.COVERPAGE_ID);
		if(index>-1){
			this.coverHtml=JSON.parse(this.covercopy[index].COVERPAGE_DATA); 
			this.coverImages=[];
			for(let item of this.coverHtml.html){
				let images=$(item).find('img');
				if(images.length>0){
					for(let image of images){
						if(image.className!="nonEditable" && (!image.className.includes('signature'))){
							this.coverImages.push(image);
						}
					}
				}
			}
			
		}
	}
	coverSigns=[];
	coversignShow=false;
	selectedCoverSign='';
	editCoverSign(){
		this.coverHtml=null;
		let index=this.covercopy.findIndex(item=>item['COVERPAGE_ID']==this.selectedCover.COVERPAGE_ID);
		if(index>-1){
			this.coverHtml=JSON.parse(this.covercopy[index].COVERPAGE_DATA); 
			this.coverSigns=[];
			for(let item of this.coverHtml.html){
				let images=$(item).find('img');
				if(images.length>0){
					for(let image of images){
						if(image.id.includes('sig-img')){
							let set=image.id.split('-')[2];
							let item={'set':set, 'img':image.src};
						    this.coverSigns.push(item)
						}
					}
				}
				let signset=$(item).find('.signature'); 
				if(signset.length>0){
					for(let sign of signset){
						if(sign.tagName!='IMG'){
							let set=sign.id.split('-');
						    let index=this.coverSigns.findIndex(ele=>ele.set==set[2]);
						    if(index>-1){
							    this.coverSigns[index][set[1]]=$(sign).text();
						    }
						}
												
					}
				}
			}
			if(this.coverSigns.length==0){
				Swal.fire({
					html: 'Please select cover page with signatures.'
				})
				return
			}
			this.coversignShow=true;
			//console.log(this.coverSigns)
		}
	}
	getSigns(index){
		this.getSign();
		this.sealShow=true; 
		this.selectedCoverSign=index;
	}
	toCoverSign(photo){
		let index=this.coverSigns.findIndex(sign=>sign.set==this.selectedCoverSign)
		this.coverSigns[index].img=photo.SIGNATURE_URL;
		this.coverSigns[index].name=photo.FULL_NAME;
		this.coverSigns[index].title=photo.JOB_TITLE;	
	}
	coverChange=false;
	coverImageIndex=-1;
	openPhoto(image, index){
		this.fileShow=true;
		$('.nav-tabs a[href="#photos"]').tab('show');
		this.getPhotos();
		this.uploadType="PHOTO";
		this.coverChange=true;
		this.coverImageIndex=index;
		this.ifPhoto=false;
	}
	changeImage(photo){
			
			let url=photo.FILE_URL;
			let old=this.coverImages[this.coverImageIndex].outerHTML.replace(/&amp;/g, "&");
			let oldUrl=this.coverImages[this.coverImageIndex].currentSrc;
		let items=[];
		for(let item of this.coverHtml.html){
			let index=item.indexOf(oldUrl); 
			item=item.replace(oldUrl, url);
			items.push(item)
		}
		
		this.coverImages[this.coverImageIndex].src=url;
		this.coverHtml.html=items;
	}
	changeCoverLabel(){
        let items=[];
		for(let item of this.coverHtml.html){
			/*let labels=$(item).find('.signature');
			if($(labels)[i]){
				let oldtext=labels[i].outerHTML;
				$(labels)[i].innerHTML=text.trim();
				let newtext=labels[i].outerHTML;
				let index=item.indexOf(oldtext);
				item=item.replace(oldtext, newtext);
			    items.push(item)
          	}*/
			  let signset=$(item).find('.signature'); 
			  if(signset.length>0){
				  for(let sign of signset){
					let set=sign.id.split('-');
					let index=this.coverSigns.findIndex(ele=>ele.set==set[2]);
					if(index>-1){
						if(sign.tagName=='IMG'){
							let oldtext=sign.outerHTML;
							sign.src=this.coverSigns[index][set[1]];
							let newtext=sign.outerHTML;
							item=item.replace(oldtext, newtext);
						}else{
							let oldtext=sign.outerHTML;
							sign.innerHTML=this.coverSigns[index][set[1]];
							let newtext=sign.outerHTML;
							item=item.replace(oldtext, newtext);
						}							
					}							  
				  }
				 
				  items.push(item)
			  }
		}
		setTimeout(() => {
			//console.log(this.coverSigns)
			this.coverHtml.html=items;
			this.updateCover();
		},100);
		
	}
	updateCoverSign(){
		this.changeCoverLabel()
		this.coversignShow=false;
		//console.log(this.coverSigns);		
	}
	updateCover(){
		$('#overlay').css('display','block');
		
		let coverdata=JSON.stringify(this.coverHtml);
		let inputJson={"PROCEDURE":"updatecoverpage", "USER_ID":parseInt(this.userId), "COVERPAGE_ID":this.selectedCover.COVERPAGE_ID, "COVERPAGE_TITLE":this.selectedCover.COVERPAGE_TITLE, "COVERPAGE_DATA":coverdata};
		
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{
			
			if(result.RESPONSE_STATUS!="Y"){
				this.throwError(result)
			}else{
				let index=this.covercopy.findIndex(item=>item['COVERPAGE_ID']==this.selectedCover.COVERPAGE_ID);
				this.covercopy[index]=result;
			}
			$('#overlay').css('display','none');
			this.coverImages=[];
			this.coverChange=false;
			this.coverImageIndex=-1;
			this.fileShow=false;			
		})
	}
	copyUrl(url){
		navigator.clipboard.writeText(url);
		let Toast=Swal.mixin({
			toast: true,						
				position: 'center',
				showConfirmButton: false,
				timer: 3000
			})
			Toast.fire({
			icon: 'success',
			title: "Photo URL is Copied."
		})
	}
	pdfSpin(e){
		if(e=='start'){
			this.pdfspin.nativeElement.style.display='inline-block';
			this.noPrint=true;
		}else{
			this.pdfspin.nativeElement.style.display='none'
			this.noPrint=false;
		}
	}
	
	showErrMsg(e){
		this.errMsg=e;
	}
	saveBlack(){
		let printblack='N'
		if(this.blackText){
			printblack='Y';
		}
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"PRINT_BLACKWHITE":printblack};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{			
			if(result.RESPONSE_STATUS!="Y"){
				this.throwError(result)
			}		
		})
	}
	contentIndent=false;
	/*saveIndent(){
		let ifIndent='N'
		if(this.contentIndent){
			ifIndent='Y';
		}
		console.log(ifIndent)
		let inputJson={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"BODYINDENT_SAME_STITLE":ifIndent}
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(result=>{console.log(result)	
			if(result.RESPONSE_STATUS!="Y"){
				this.throwError(result)
			}		
		})
	}*/
	getLink(doc){
		let link='#'+doc.id;console.log(link)
		navigator.clipboard.writeText(link);
		this.optionShow=false;
	}
	toimportTable(){
		Swal.fire({
			icon:'info',
			html: '<p>WARNING: Uploading an excel file will overwrite <span style="color:red">any information  & table format</span> currently in this table. Do you want to proceed?</p>',
			confirmButtonText: 'Continue',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {
				this.file5.nativeElement.click();
			}
		})
		
	}
	async importTable(){
		let that=this;
			const file = this.file5.nativeElement.files[0]; //console.log(file);
			const data = await file.arrayBuffer();console.log(data);
			/* data is an ArrayBuffer */
			const workbook = read(data);
			const sheets = workbook.SheetNames;

                if (sheets.length) {
					const rowdata=workbook.Sheets[sheets[0]];
                    const rows = utils.sheet_to_json(rowdata, {header:1});console.log(rows)
					if(rows.length>0){
						this.curDoc.data=this.toTableData(rows);
						this.autoSave('modify', this.curDoc.id, this.curDoc.SECTION_TITLE,this.selectedEditor);
						this.optionShow=false;
					}else{
						Swal.fire({
							html: ' <span style="color:red; text-align:left">Table has no data</span>'
						})
					}
                    
                }/**/
			/*let reader = new FileReader();
				reader.onloadend = function(e) {				
					let filedata = e.target.result.toString().split(',')[1];//console.log(filedata)//
					let tabledata = atob(filedata); console.log(tabledata);
					//let data=that.sanitizer.bypassSecurityTrustHtml(tabledata);
					//that.toContentData('text', tabledata, '');
					//that.toContentData('htmltext', data, '');					
			}
			reader.readAsDataURL(file);*/
			
	}
	toTableData(sheetRows){
		let sheetcols=sheetRows[0];
		let cols=[];
		let rows=[];
		for(let i=0; i<sheetcols.length; i++){
			let colwidth=Math.floor(100/sheetcols.length);
			let item={'INTERNALNAME':'col'+i.toString(), 'NAME':sheetcols[i],'TYPE':'text', 'width':colwidth, 'unit':'%', 'dir':'default','colAlign':'Left','celAllign':'Left','text':''};
			item.text=item.NAME;
			item['htmltext']=this.sanitizer.bypassSecurityTrustHtml(item.text);
			cols.push(item);
		}
		sheetRows.shift();
		if(sheetRows.length>0){console.log(sheetRows)
			for(let sheetitem of sheetRows){
					let row={'items':[]};
					//if(sheetitem.length>1){
						for(let i=0; i<cols.length; i++){
						let colIndex='col'+i.toString();
						//row[colIndex]=sheetitem[cols[i].NAME];
						let val=sheetitem[i];
						if(!val){
							val='';
						}
						let item={'COLUMNINTERNALNAME':colIndex,'data':val,'htmltext':''};
						item.htmltext='<p>'+item.data+'</p>';
						item['DATA']=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
						row.items.push(item);
						}
					/*}else if(sheetitem.length==1){
						let colIndex='col0';
						row[colIndex]=sheetitem[0];
						
						let item={'COLUMNINTERNALNAME':colIndex,'data':sheetitem[0],'htmltext':'','colspan':cols.length,'celAllign':'Center' };
						item.htmltext='<p>'+item.data+'</p>';
						item['DATA']=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
						row.items.push(item);
						console.log(row)
					}*/
					
					rows.push(row)
			}		
			
		}
		let data={'cols':cols, 'rows':rows};
		return data

	}
	public exportAsExcelFile(json: any[], excelFileName: string, headers:any): void {
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);//, {header:headers, skipHeader:true});
		//console.log('worksheet',worksheet);
		//const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['Summary'] };
		let workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Summary')
		//const excelBuffer: any =XLSX.writeFile(workbook, 'Summary');
		const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
		//const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
		this.saveAsExcelFile(excelBuffer, excelFileName);
	  }
	  saveAsExcelFile(buffer: any, fileName: string): void {
		
		  let EXCEL_TYPE =
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
		  let EXCEL_EXTENSION = ".xlsx";
		  const data: Blob = new Blob([buffer], {
			type: EXCEL_TYPE
		  });
		  fileSaver.saveAs(
			data,
			fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
		  );
		  //this.loading5=false;
		
	  }
	private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
	  fmeCat=[];
	  immiCategory=[];
	  capitalCategory=[];
	  capitalItems=[];
	  ratingOps=[];
	  conditionOps=[];
	  actionItemOps=[];
	  ulGroup=[]; 
	  selFmeCost(type, e, doc? ){console.log(type,e.target.value, doc,)
		let index=parseInt(e.target.value);
		if(index>-1){
			if(type=='long'){
				doc.long=this.capitalCategory[index].id;
				this.rowItem['catIndex']=index;
				this.rowItem['catLabel']=this.capitalCategory[index].label;	
				if(!this.rowItem['ACTION']){
					this.rowItem['ACTION']='';
				}
					
				if(doc.data&&doc.data.COST&&doc.data.COST.length>0){
						
						this.updateCostItem(doc, index);
						this.getTotalUl();			
				}else{
					this.autoSave('modify', doc.id, doc.SECTION_TITLE,'O');
				}
										
			}else if(type=='capital'){
				//doc['longCat']=this.capitalCategory[this.rowItem['catIndex']].subCat[index].id;
				this.rowItem.longCat=this.capitalCategory[this.rowItem['catIndex']].subCat[index].id;
				this.rowItem['longCatIndex']=index;
				this.rowItem['longCatLabel']=this.capitalCategory[this.rowItem['catIndex']].subCat[index].label;
			}else if(type=='capitalitem'){
				this.rowItem['catItem']=index;				
			}else if(type=='ACTION'){
				this.rowItem['ACTION']=this.actionItemOps[index].name;console.log(this.rowItem['ACTION']);
				//toFmeUl
			}
		}else{			
			if(type=='long'){
				doc.long='';
				this.rowItem['catIndex']=-1;
				this.rowItem['catLabel']='';
				this.rowItem['ACTION']='';
				this.autoSave('modify', doc.id, doc.SECTION_TITLE,'O');		  
			}else if(type=='capital'){
				this.rowItem['longCatIndex']=-1;
				this.rowItem['longCatLabel']='';
				this.rowItem.longCat='';
			}else if(type=='capitalitem'){
				this.rowItem['catItem']=-1;				
			}else if(type=='ACTION'){
				this.rowItem['ACTION']='';
				//toFmeUl
			}
		}
		//console.log(doc.long);	
	}
	updateCostItem(doc, index){
		for(let item of doc.data.COST){
			item['catIndex']=index;
			item['catLabel']=this.capitalCategory[index].label;	
		}
		this.getTotalCost1();
		this.autoSave('cost update', doc.id, doc.SECTION_TITLE,'O');	
	}
	fmeOp(e){console.log(this.rowItem['NTCHK'])
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		if(this.rowItem['NTCHK']){
			this.rowItem.CRCHK=false;
			this.rowItem.DMCHK=false;
			this.rowItem.LSCHK=false;
			this.rowItem.CR=0;
			this.rowItem.DM=0;
			this.rowItem.LS=0;
			this.rowItem.CRBD='';
			this.rowItem.DMBD='';
			this.rowItem.LSBD='';
			this.rowItem.longCat='';
			//this.rowItem.EUL=0;
			//this.rowItem.EFF=0;
			//this.rowItem.RUL=0;
			this.rowItem.Cost=0;
			this.rowItem.Quantity=0;
			this.rowItem.Total=0;
			this.rowItem.Unit='';
			this.rowItem.Percent=100;
			this.rowItem.allow=false;
			this.rowItem.reserve=0;
			this.rowItem.catItem=-1;
			this.rowItem['ACTION']='';

			$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
				if($(this).prop('checked')){
					$(this).prop('checked',false);
				}
			})
			for(let i=0; i<this.rowItem.allocate.length; i++){
				this.rowItem.allocate[i]=0;
			}
			console.log(this.rowItem.allocate);
		}
		
	}
	passAction=['No','NA','R&M'];
	async saveFME(type?){
		//console.log(this.rowItem);
		if(this.reserveWarn){
			if(!this.rowItem.allow){
				return
			}
		}
		const sum =this.rowItem.allocate.reduceRight((acc, cur) => acc + cur, 0); //console.log(sum)
		//let allCost=sum+this.rowItem.LS+this.rowItem.CR+this.rowItem.DM; //console.log(allCost);
		//let condition=!((this.rowItem['longCat'].length>0&&sum>0&&this.rowItem['catItem']>-1||(sum==0)))&&(!this.rowItem.NTCHK);  console.log(condition)
		if(!(this.reportInfo?.PCA_INDICATOR=='4099e'&&(this.passAction.indexOf(this.rowItem['ACTION'])>-1))){
			if(this.rowItem.Item==''||((this.rowItem.Quantity==0||this.rowItem.Unit==''||this.rowItem.Cost==0)&&(!this.rowItem.NTCHK))||(this.rowItem.NTCHK&&this.rowItem.NT.length==0)||(!((this.rowItem['longCat'].length>0&&this.rowItem['catItem']>-1))&&(!this.rowItem.NTCHK))){
				this.validateWarn1=true;
				return
			}
		}else{
			if(this.rowItem.Item==''||(this.rowItem.NTCHK&&this.rowItem.NT.length==0)||(!((this.rowItem['longCat'].length>0&&this.rowItem['catItem']>-1))&&(!this.rowItem.NTCHK))){
				this.validateWarn1=true;
				return
			}
		}
		if((this.rowItem.LSCHK&&this.rowItem.LSBD.length==0)||(this.rowItem.CRCHK&&this.rowItem.CRBD.length==0)||(this.rowItem.DMCHK&&this.rowItem.DMBD.length==0)){
			this.validateWarn1=true;
			return
		}
		if(this.reportInfo?.PCA_INDICATOR=='4099e'&&this.rowItem['ACTION'].length==0&&(!this.rowItem.NTCHK)){
			this.validateWarn1=true;
			return
		}
		//this.rowItem.Cycle=this.getRound(this.rowItem.Quantity*this.rowItem.Cost,2); 
		this.rowItem.RUL=this.getRound(this.rowItem.EUL-this.rowItem.EFF, 0);//this.rowItem.EUL-this.rowItem.EFF;
		this.rowItem.Year=this.pcaOp.reserve;
		let data=this.getContentData('data'); //console.log(data);
		let id=this.getContentData('id');
		let title=this.getContentData('SECTION_TITLE');
		let info=JSON.parse(JSON.stringify(this.rowItem));
			info['costId']=Utils.uniqueIdGenerator();
		if(!data['COST']){
			data['COST']=[];
			data['COST'].push(info);
		}else{
			data['COST'].push(info);
		}
		let row=[]
		let total=this.rowItem.Total;
		//console.log(data);
		for(let col of data.cols){
			let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'', 'KEY':''};
			item.COLUMNINTERNALNAME=col.INTERNALNAME;
			if(this.rowItem[col.KEY]||this.rowItem[col.KEY]==0){
				if(col.KEY=='Immediate'){
					item.DATA=this.rowItem[col.KEY].toString();
				}else if(col.KEY=='short'){
					item.DATA=this.rowItem[col.KEY].toString();
				}else if(col.KEY=='RUL'&&this.rowItem.RULtext.length>0){
					item.DATA=this.rowItem.RULtext;
				}else{
					item.DATA=this.rowItem[col.KEY].toString();
				}
				
			}
			item.KEY=col.KEY;
			if(col.KEY=='Cost'||col.KEY=='Cycle'||col.KEY=='Immediate'||col.KEY=='Short'||col.KEY=='Reserve'){
				item.sign=this.currSign;
			}else if(col.KEY=='Percent'){
				item.sign='%';
			}
			if((this.pcaOp.term=='Exclude')&&(col.KEY=='Short')){
				item['hide']='Y';
			}
			if(col.KEY=='Cycle'||col.KEY=='Percent'){
				item['hide']='Y';
			}
			row.push(item);
		}

		let rowBase=JSON.parse(JSON.stringify(row));
			let keep=true;
			if(this.rowItem.LSCHK){
				let val1='Life Safety';
				let val2=this.rowItem.LS;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );//console.log(v2row)
				data.rows.push(v2row);
				keep=false;
			}
			if(this.rowItem.CRCHK){
				let val1='Critical Repair';
				let val2=this.rowItem.CR;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );//console.log(v2row)
				data.rows.push(v2row);
				keep=false;
			}
			if(this.rowItem.DMCHK){
				let val1='Deferred Maintenance';
				let val2=this.rowItem.DM;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );//console.log(v2row)
				data.rows.push(v2row);
				keep=false;
			}
			
			if(this.rowItem.NTCHK){
				let val1='Items of Note';
				let val2=this.rowItem.NT;
				let v2row=JSON.parse(JSON.stringify(row));
				for(let row of v2row){
				if(row.KEY=='Year'){
					row.DATA=val1;
				}
				if(row.KEY=='Total'){
					row.DATA='';
				}
			}
				v2row[0]['KEEP']=keep;
				v2row[0]['costId']=info['costId'];
				data.rows.push(v2row);
				keep=false;				
			}
			//console.log(data.rows)
			if(info.allocate){//console.log(info.allocate)
				for(let i=0; i<info.allocate.length; i++){
					if(info.allocate[i]>0){//console.log(info.allocate[i])
						let val1=i+1;
						let val2=info.allocate[i];//console.log(val1,val2)
						let v2row=this.addV1(rowBase,val1,val2, keep,info['costId']);
						
						data.rows.push(v2row);
						keep=false;
					}
					
				}
			}
			if(keep){
				let val1='one';
				let val2=this.rowItem.reserve;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );//console.log(v2row)
				data.rows.push(v2row);
				keep=false;
			}
			//console.log(data.rows)
		if(type&&type=='new'){
			this.resetCostTable1(id);
		}else{
			$('#costDetailModal').modal('hide');
		}
		
		await this.getTotalCost1();
		this.getTotalUl();	
		this.autoSave('modify',id, title, "O" );
	}
	resetCostTable1(id){
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		this.rowItem=JSON.parse(JSON.stringify(this.newRow));
		this.rowItem.EFF=this.pcaOp.age;
		//this.rowItem.data[1].data=this.pcaOp.quantity
		this.rowItem['ACTION']='';		
		for(let i=0; i<this.pcaOp.reserve; i++){
			this.rowItem.allocate.push(0);
		}
		this.curCost=null;
		$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
			$(this).prop('checked', false);
		})
		$("#costDetailModal textarea").each(function(e){
			$(this)[0].style.height = "40px";
		});
		this.rowItem.index=this.curIndex;
		this.rowItem['id']=id;
		//this.curCosts=data.rows[0][0].choice; //console.log(that.curCosts);
			let cat=this.getContentData('long'); console.log(cat);
			let catIndex=this.capitalCategory.findIndex(item=>item.id==cat); console.log(catIndex)
			if(catIndex>-1){
				this.rowItem['catIndex']=catIndex;
				this.rowItem['catLabel']=this.capitalCategory[catIndex].label; console.log(this.rowItem['catLabel'])
			}
			const sec=this.getSecbyId(this.contents, id); console.log(sec);
			
				this.rowItem.NTCHK=false;
				this.rowItem.NT='';
				this.rowItem.LSCHK=false;
				this.rowItem.LS=0;
				this.rowItem.DMCHK=false;
				this.rowItem.DM=0;
				this.rowItem.CRCHK=false;
				this.rowItem.CR=0;
				this.rowItem.CRBD='';
				this.rowItem.DMBD='';
				this.rowItem.LSBD='';
				this.rowItem.allow=false;
				this.rowItem.reserve=0;						
			if(sec.long){
				this.rowItem.long=sec.long;
			}
			if(sec.longCat){
				this.rowItem.longCat=sec.longCat;
			}
			if(sec.catItem>-1){
				this.rowItem.catItem=sec.catItem;
			}else{
				this.rowItem.catItem=-1
			}
			
	}
	getReserve1(key?){
		if(this.reportInfo.PCA_INDICATOR=='Y'){
			if(key){
				this.getReserve(key);
			}else{
				this.getReserve();
			}
			
			
		}else{
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;//console.log(key,this.rowItem )
		let rounded=this.getRound(this.rowItem[key],2);//console.log(rounded)
		this.rowItem[key]=rounded;
		let rate=this.pcaOp.inflation;//3/100;////console.log(rate);
		this.rowItem.Cycle=this.getRound(this.rowItem.Quantity*this.rowItem.Cost,2)
		this.rowItem.Total=this.getRound(this.rowItem.Percent*this.rowItem.Quantity*this.rowItem.Cost/100, 2);
		/*if(!this.rowItem.Short){
			this.rowItem.Short=0
		}*/
		//if(!this.rowItem.Immediate){
		//	this.rowItem.Immediate=0
		//}
		this.rowItem.Immediate=0
		if(this.rowItem.DMCHK){
			this.rowItem.Immediate+=this.rowItem.DM;			
		}
		if(this.rowItem.CRCHK){
			this.rowItem.Immediate+=this.rowItem.CR;
		}
		if(this.rowItem.LSCHK){
			this.rowItem.Immediate+=this.rowItem.LS;
		}
		let val=this.rowItem.Total-this.rowItem.Immediate
		this.rowItem.Reserve=this.getRound(val,2);
		let selectedYear=[];
		$('input.yearbox').each(function(e){////console.log($(this)[0].checked);
			if($(this).prop('checked')){
				selectedYear.push(parseInt($(this).val()));
			}
		})
		this.rowItem['selectedYear']=selectedYear;
		////console.log(selectedYear);
		let remain=val%selectedYear.length;
		if(this.pcaOp.decimal==2){
			remain=(val*100%selectedYear.length)/100;
		}
		let data=this.getRound((val-remain)/selectedYear.length,this.pcaOp.decimal);////console.log(selectedYear.length);
		 ////console.log(remain);
		let otherTotal=0;
		if(this.pcaOp.reserve>0){
			for(let i=0; i<this.pcaOp.reserve; i++){////console.log(selectedYear.indexOf(i+1));
				if(selectedYear.indexOf(i+1)>-1){
					if(selectedYear[0]==i+1){
						this.rowItem.allocate[i]= this.getRound(data+remain,this.pcaOp.decimal);
					}else{
						this.rowItem.allocate[i]= data;
						otherTotal+=data
					}
				}else{
					this.rowItem.allocate[i]= 0;
				}
			}
		
		}
	
		if(selectedYear.length>0){
			this.rowItem.reserve=0;
		}else{
			this.rowItem.reserve=val;
		}
		this.rowItem.averageReserve=this.getRound(val/this.rowItem.Quantity/this.pcaOp.reserve,this.pcaOp.decimal);
		let total=0;
		for(let i=0; i<this.rowItem.allocate.length; i++){
			if(i==0){
				total+=this.rowItem.allocate[i];
			}else{
				total+=this.getRound(this.rowItem.allocate[i]*this.getRound(Math.pow((1+rate),i), 3),this.pcaOp.decimal);
			}
		
		}
		this.rowItem.inReserve=this.getRound(total,this.pcaOp.decimal);
		this.rowItem.averageINReserve=this.getRound(this.rowItem.inReserve/this.rowItem.Quantity/this.pcaOp.reserve,this.pcaOp.decimal);
		
		if(this.rowItem.reserve!=0){
			this.reserveWarn=true;
		}
		if(!this.rowItem.Immediate){
			this.rowItem.Immediate=0
		}
		if(this.reserveWarn){
			if(!this.rowItem.allow){
				return
			}
		}
	}
	}
	addV1(row, year, cost, keep, id){//console.log(row, year, cost, keep, id)
		let newRow=JSON.parse(JSON.stringify(row));
		if(year==0){
			for(let item of newRow){
				if(item.KEY=='Year'){
					item.DATA='';
				}else if(item.KEY=='Total'){
					item.DATA=cost;
					item.sign=this.currSign;
				}else if(item.KEY=='Item'){
					item.DATA='Total';
				}else{
					if(!keep){
					item.DATA='';
					}
				}
			}
		}else if(year=='one'){
			for(let item of newRow){
				if(item.KEY=='Year'){
					item.DATA='';
				}else if(item.KEY=='Total'){
					item.DATA=cost;
					item.sign=this.currSign;
				}
			}
		}else{
			for(let item of newRow){
				if(item.KEY=='Year'){
					item.DATA=year;
				}else if(item.KEY=='Total'){//console.log(cost);
					item.DATA=cost;
					item.sign=this.currSign;
				}else{
					if(!keep){
					item.DATA='';
					}
				}
			}
		}
		newRow[0]['KEEP']=keep;
		newRow[0]['costId']=id;
		
		return newRow
	}
	async getTotalCost1(){
	this.clearAllFmeTable();
		let allpca=[];
			let pcaTable:any;
			let repairTable:any
			let sid:string;
			let stitle:string;
			if (this.contents)
			for(let sec of this.contents){
			if(sec.SUB_SECTIONS){
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.TYPE=='COSTTABLE'){
							allpca.push(sec1);
							
						}
							if(sec1.SUB_SECTIONS){
								for(let sec2 of sec1.SUB_SECTIONS){
									if(sec2.TYPE=='COSTTABLE'){
										allpca.push(sec2);
									}
					
								}
							}
						
					}
				}
			}
			//console.log(allpca);
			if(allpca.length==0){
				this.clearAllFmeTable();
				return
			}
			let totalItem=0;
			for(let pcaItem of allpca){
				if(pcaItem.data&&pcaItem.data.COST&&pcaItem.data.COST.length>0){
				totalItem+=pcaItem.data.COST.length;
				}
			}
			if(totalItem==0){
				this.clearAllFmeTable();
				return
			}
			for(let sec of this.contents){
					sid=sec.id;
					stitle=sec.SECTION_TITLE;
					let uls=[];
					let costEMs=[];
					let immis=[];
					let captials=[];
					for(let sec1 of sec.SUB_SECTIONS){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.TYPE=='4099e'){//console.log(sec2)
								let index1=this.allimmis.indexOf(sec2.id);
								let index2=this.allcaptials.indexOf(sec2.id)
								if(index1>-1){
									let index=
									immis.push(sec2.id)
								}else if(index2>-1){
									captials.push(sec2.id)
								}
							}
						}
					}
				}
				
			let rows=[];
			let totalShort=0;
			let totalImmi=0;
			this.resetFMEtable();
			let needlast=false;
			for(let pca of allpca){	//console.log(pca)
				if(pca.data&&pca.data.COST&&pca.data.COST.length>0){
					let items=pca.data.COST;//console.log(items)
					for(let item of items){
						if(item.LSCHK&&item.LS>0){
							this.addFMErow('fme_exec_sum_ir_1', item, 'LS');
							needlast=true;
						}
						if(item.CRCHK&&item.CR>0){
							this.addFMErow('fme_exec_sum_ir_2', item, 'CR');
							needlast=true;
						}
						if(item.DMCHK&&item.DM>0){
							this.addFMErow('fme_exec_sum_ir_3', item, 'DM');
							needlast=true;						}
						
						if(item.NTCHK&&item.NT.length>0){
							this.addFMErow('fme_exec_sum_ir_5', item, 'NT');
						}else{
							if(item.allocate&&item.Reserve>0){
								this.addFMErow('fme_exec_sum_capital_needs_1', item, 'long');
							}
							needlast=true;
						}

					}
					
					
				}
						
			}
			if(needlast){
				this.addLastRows();
			}
			
			
	}
	allcostEMs=[];
	allimmis=[];
	allcaptials=[];
	capitalGroup=[];
	async getFMEtable(){
		this.capitalGroup=this.getGroup();		//console.log(this.capitalGroup)
		this.ulGroup=this.getGroup();	
		this.allcostEMs=this.getFMEtableIds('fme_exec_sum_cost_estimates');//Summary of Recommended Repairs and Replacement Cost Estimates
		this.allimmis=this.getFMEtableIds('fme_exec_sum_ir');//Section 2.1: Immediate Repairs	
		this.allcaptials=this.getFMEtableIds('fme_exec_sum_capital_needs');//Section 2.2 Replacement of Capital Items Schedule
		
	}
	getFMEtableIds(key){
		let tables=this.fmeService.dataset[key];
		let ids=[];
		for(let table of tables){
			ids.push(table.id)
		}
		return ids
	}
	getGroup(){
		let arr=[];
		for(let cat of this.capitalCategory){
			let item={"label":cat.label,'id':cat.id, 'tag':cat.tag, 'othertag':cat.othertag, "subRow":[], "subData":[]}
			arr.push(item)
		}
		return arr
	}
	addFMErow(tid, val, key){//console.log(tid,key, val)
		let tableData=this.getSecbyId(this.contents,tid); //console.log(tableData);
		let rows=tableData.data.rows;//console.log(rows);
		//let row=JSON.parse(JSON.stringify(tableData.data.rows[0]));console.log(row);
		let cols=tableData.data.cols;//console.log(cols);
		/*if(key=='UL'){
			let overallrow=JSON.parse(JSON.stringify(tableData.data.rows[tableData.data.rows.length-1]));
			tableData.data.rows=[];
			let row=[]
			let baserow=this.fmeService.ulrow;
			for(let i=0; i<cols.length; i++){
				let item=JSON.parse(JSON.stringify(baserow[i]));
				item['KEY']=cols[i].KEY;
				if(item.KEY=='SecRef'||item.KEY=='secRef'){
					item.data=this.getItem(val.index, 'seq')
				}else if(item.KEY=='RERatio'){
					item.data=this.getRound(val.RUL/val.EUL).toString()+'%'
				}else if(item.KEY=='No'){
					let order=0;
					for(let i=0; i<val.catIndex; i++){
						order+=this.ulGroup[i].subRow.length;
					}
					item.data=order+this.ulGroup[val.catIndex].subRow.length+1;
				}else{
					item['data']=val[cols[i].KEY];
				}				
				console.log(item)
				row.push(item)
			}
			this.ulGroup[val.catIndex].subRow.push(row)
			let titlebase=this.fmeService.capitalTitleRow;
			for(let group of this.ulGroup){
				let titlerow=JSON.parse(JSON.stringify(titlebase));
				titlerow[0].data='';
				titlerow[1].data=group.label;
				titlerow[1].colspan=titlebase[1].colspan+this.pcaOp.reserve;
				tableData.data.rows.push(titlerow);
				for(let sub of group.subRow){
					tableData.data.rows.push(sub);
				}
			}
			tableData.data.rows.push(overallrow);
		}else */if(key=='long'){
			tableData['ZOOM']=true;
			let index=cols.findIndex(col=>col.NAME=='Year X');//console.log(index)
			if(index>-1){
				cols.pop();
				//for(let i=0; i<val.Year; i++){console.log(i)
				for(let i=0; i<this.pcaOp.reserve; i++){//console.log(i)
					let colName='col'+cols.length;
					let yearName="Year "+(i+1);
					let item= {'INTERNALNAME':colName,'KEY':i,'NAME':yearName,'TYPE':"text",'bk':'fme-yellowcell', 'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':3, 'sign':'$'}; 
					if(i>2){
						item['hide']=true;
					}
					cols.push(item)
				}
				//console.log(cols)
			}else{
				let newindex=cols.findIndex(col=>col.NAME=='Year 1');//console.log(newindex)
				cols=cols.slice(0,newindex);//console.log(cols)
				for(let i=0; i<this.pcaOp.reserve; i++){//console.log(i)
					let colName='col'+cols.length;
					let yearName="Year "+(i+1);
					let item= {'INTERNALNAME':colName,'KEY':i,'NAME':yearName,'TYPE':"text",'bk':'fme-yellowcell', 'celAllign':"Center",'colAlign':"Center",'dir':"default",'unit':"%",'width':3, 'sign':'$'}; 
					if(i>2){
						item['hide']=true;
					}
					cols.push(item)
				}
			}
			//console.log(cols)
			tableData.data.cols=cols;
			tableData.data.rows=[];
			let row=[]
			//long:"fme_exec_sum_capital_needs_2"
			//longCat:"fme_exec_sum_capital_needs_1_0"
			for(let i=0; i<cols.length; i++){
				let item={'COLUMNINTERNALNAME': cols[i].INTERNALNAME, 'data': '', 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
				//let item=row[i];
			
				if(!isNaN(parseInt(cols[i].KEY))){//console.log(cols[i].KEY)
					item['KEY']=cols[i].KEY;
					if(val.allocate && val.allocate[cols[i].KEY] !== undefined){
						item['data']=val.allocate[cols[i].KEY];
					}else if(i>9){
						item['data']='0';
					}
					if(i>12){
						item['hide']=true;
					}
				}else{//console.log(cols[i].KEY)
					item['KEY']=cols[i].KEY;
					if(item.KEY=='Total'){
						/*let total=val[cols[i].KEY];
						if(val.CRCHK){
							total-=val.CR
						}
						if(val.DMCHK){
							total-=val.DM.CR
						}
						if(val.LSCHK){
							total-=val.LS.CR
						}
						item['data']=total;*/
						item['data']=val.Reserve;
					}else if(item.KEY=='SecRef'){
						item.data=this.getItem(val.index, 'seq')
						item['RF']=true;
					}else if(item.KEY=='RUL'&&val.RULtext.length>0){
						item['data']=val.RULtext;
					}else{
						item['data']=val[cols[i].KEY];
					}
					
				}
				
				if(cols[i]['sign']){
					item['sign']=cols[i]['sign'];
				}
				//console.log(item)
				row.push(item)
			}
			this.capitalGroup[val.catIndex].subRow.push(row);
			this.capitalGroup[val.catIndex].subData.push(val);
			let titlebase=this.fmeService.capitalTitleRow;
			for(let group of this.capitalGroup){
				let titlerow=JSON.parse(JSON.stringify(titlebase));
				titlerow[0].data='';
				titlerow[1].data=group.label;
				//if(this.pcaOp.reserve>2){
				//	titlerow[1].colspan=titlebase[1].colspan+3;
				//}else{
					titlerow[1].colspan=titlebase[1].colspan+this.pcaOp.reserve;
				//}
				
				tableData.data.rows.push(titlerow);
				for(let sub of group.subRow){
					tableData.data.rows.push(sub);
				}
			}
			//tableData.data.rows.push(row);
			/*if(tableData.data.rows.length<10){
				tableData.data.rows[0]=row;
			}else if(tableData.data.rows.length>9&&tableData.data.rows[0][0].data==''){
				tableData.data.rows[0]=row;
			}else{
				//tableData.data.rows.push(row);
				tableData.data.rows.splice(tableData.data.rows.length-10,0,row)
			}*/
			tableData.data['xmldata']=JSON.parse(JSON.stringify(this.capitalGroup)); //console.log(this.capitalGroup);
		}else{
		let row=JSON.parse(JSON.stringify(tableData.data.rows[0]));//console.log(row);
		let newRow=[];
		let i=0;
		let j=0;
			while (i < cols.length) {
				let item=JSON.parse(JSON.stringify(row[j]));
				item['KEY']=cols[i].KEY;
				if(item.KEY=='SecRef'){
					item['data']=this.getItem(val.index, 'seq');//console.log(item['data']);
					item['RF']=true;
				}else if(item.KEY=='BD'){
					item['data']=val[key+'BD'];
				}else{//console.log(val)
					let key=cols[i].KEY;//console.log(key);
					item['data']=val[key];//console.log(val[key]);
				}
				//item['data']=val[cols[i].KEY];
				if(cols[i]['sign']){
					item['sign']=cols[i]['sign'];
				}
				//console.log(item)
				newRow.push(item)
				if(item.colspan){
					i+=item.colspan; 
				}else{
					i++;
				}
				j++
				//console.log(i)
		  }
		
			/*for(let i=0; i<cols.length; i++){
			let item=row[i];
			item['KEY']=cols[i].KEY;
			item['data']='123';//val[cols[i].KEY];
			if(cols[i]['sign']){
				item['sign']=cols[i]['sign'];
			}
			console.log(item)
			newRow.push(item)
			}*/
			//console.log(newRow);
			//console.log(tableData.data.rows[0])
			if(tableData.data.rows[0][newRow.length-1].data==''){
				tableData.data.rows[0]=newRow;
			}else{
				tableData.data.rows.push(newRow);
			}
		}
		//console.log(tableData.data)
		
	}
	resetFMEtable(){
		let tableIds=['fme_exec_sum_ir_1',
		'fme_exec_sum_ir_2',
		'fme_exec_sum_ir_3',
		//'fme_exec_sum_ir_4',
		'fme_exec_sum_ir_5',
		'fme_exec_sum_capital_needs_1'];
		for(let tableId of tableIds){
			let table=this.getSecbyId(this.contents,tableId);//console.log(table)
			if(!table) continue
			if(table.data&&table.data.rows.length>1){
				table.data.rows.splice(1,table.data.rows.length-1);
			}
			if(table.data&&table.data.rows.length>0){
				let cols=table.data.rows[0].length;
				table.data.rows[0][cols-1].data='';
				table.data.rows[0][0].data='';
				table.data.rows[0][1].data='';
			}
			for(let group of this.capitalGroup){
				group.subRow=[];
				group.subData=[];
			}
			for(let group of this.ulGroup){
				group.subRow=[];
				group.subData=[];
			}
			
		}
	}
	addLastRows(){
		let tableIds=['fme_exec_sum_ir_1',
		'fme_exec_sum_ir_2',
		'fme_exec_sum_ir_3'];
		let TotalAll=0;
		let sumtable=this.getSecbyId(this.contents,'fme_exec_sum_cost_estimates_0');
		let sumrow=0
		let index=this.getIdIndex('fme_exec_sum_ir_1')
		let ref=this.getItem(index, 'seq')
		for(let tableId of tableIds){
			let item=this.fmeService.summaryRows[tableId];//console.log(item)
			let table=this.getSecbyId(this.contents,tableId);//console.log(table);
			//item[1]=table.data.rows[0][3];
			let Total=0;			
			for(let row of table.data.rows){//console.log(row[4])
				if(row[4].data>0){
					Total+=row[4].data;
				}
				
			}
			//console.log(Total)
			item[2].data=Total;
			TotalAll+=Total;
			//console.log(item)
			table.data.rows.push(item)
			sumtable.data.rows[sumrow][1].data=Total;
			sumtable.data.rows[sumrow][2].data='Section ' +ref;
			sumrow++
		}
		//console.log(TotalAll);
		let tableSubTotal=this.getSecbyId(this.contents,'fme_exec_sum_ir_4');//console.log(tableSubTotal.data.rows[0])
		//tableSubTotal.data.rows[0][1]=Total;
		tableSubTotal.data.rows[0][2].data=TotalAll;
		sumtable.data.rows[sumrow][1].data=TotalAll;
		/*let capitalTable=this.getSecbyId(this.contents,'fme_exec_sum_capital_needs_1');
		let allItem=capitalTable.data.rows;
		for(let item of allItem){

		}*/
		let capitalLastRows=JSON.parse(JSON.stringify(this.fmeService.totalrow));
		let table=this.getSecbyId(this.contents,'fme_exec_sum_capital_needs_1');
		let tatalrow=[];
		let index2=this.getIdIndex('fme_exec_sum_capital_needs_1')
		let ref2=this.getItem(index2, 'seq');
		let startpoint=-1;
		for(let i=0;  i<table.data.cols.length; i++){			
			if(table.data.cols[i].KEY=='Total'){
				startpoint=i-1
			}
			if(i>8){
				tatalrow.push(0);
			}
			
		}
		//console.log(JSON.stringify(tatalrow))
		for(let row of table.data.rows){//console.log(row)		
			for(let i=0; i<row.length; i++){
				if(i>startpoint){
					if (typeof row[i].data === 'number') {
						tatalrow[i-startpoint-1]+=row[i].data;
					}else{
						tatalrow[i-startpoint-1]+=parseFloat(row[i].data);
					}
				}
				
			}
		}
		//console.log(JSON.stringify(tatalrow))
		let precelldata=0;
		for(let row of capitalLastRows){//console.log(row)
			for(let j=0; j<row.length; j++){
				if(row[j].KEY=='Total'){
					if(row[1].KEY=='AU'){
						row[j].data=this.getRound(tatalrow[0]/this.pcaOp.quantity/this.pcaOp.reserve,this.pcaOp.decimal).toString();
						sumtable.data.rows[4][1].data=row[j].data;
						sumtable.data.rows[4][2].data='Section ' +ref2;
					}else{
						let total=tatalrow.slice(1); //console.log(total)
						row[j].data=total.reduce(function (accumVariable, curValue) {
						return accumVariable + curValue
					}, 0);
					}
					
				}
			}
			/*if(row[9]&&row[9].KEY=='Total'){
				let total=tatalrow.slice(1); console.log(total)
				row[9].data=total.reduce(function (accumVariable, curValue) {
					return accumVariable + curValue
					}, 0);
				
			}
			if(row[3].KEY=='Total'&&row[1].KEY=='AU'){
				row[3].data=this.getRound(tatalrow[0]/this.pcaOp.quantity/this.pcaOp.reserve).toString();
				sumtable.data.rows[4][1].data=row[3].data;
				sumtable.data.rows[4][2].data='See Table ' +ref2;
			}*/
			let last=row.length-1;
			//let borderProp=row[last].border;
			let item=JSON.parse(JSON.stringify(row[last]));//console.log(item)
			row.pop();			
			if(item.KEY=='yearx'){				
				for(let i=0; i<tatalrow.length-1; i++){
					let cell=JSON.parse(JSON.stringify(item));
					cell.COLUMNINTERNALNAME='col'+(i+startpoint+1);
					cell.KEY=i+1;//
					if((row[1].KEY=='AU'||row[1].KEY=='AI')&&i>2){
						if(row[startpoint+1]['colspan']>-1){
							row[startpoint+1]['colspan']+=1;
						}else{
							row[startpoint+1]['colspan']=0;;
						}
						if(row[1].KEY=='AU'){
							row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Uninflated)'
						}
						if(row[1].KEY=='AI'){
							row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Inflated)'
						}
					}else{
						if(row[1].KEY=='TI'){
						if(tatalrow[i+1]>0){
							let rate=this.getRound(Math.pow(1+3/100, i),3);
							//cell.data=this.getRound(tatalrow[i+1]*(Math.pow(1+3/100, i)),this.pcaOp.decimal);console.log(cell)
							cell.data=this.getRound(tatalrow[i+1]*rate,this.pcaOp.decimal);//console.log(cell)
						}else{
							cell.data=0
						}
					}else if(row[1].KEY=='CT'){
						if(tatalrow[i+1]>0){
							let rate=this.getRound(Math.pow(1+3/100, i),3);
							//let data=this.getRound(tatalrow[i+1]*(Math.pow(1+3/100, i)),this.pcaOp.decimal);
							let data=this.getRound(tatalrow[i+1]*rate,this.pcaOp.decimal);
							precelldata=this.getRound(precelldata+data,this.pcaOp.decimal);
						}						
						cell.data=precelldata;//console.log(cell);						
					}else{
						cell.data=tatalrow[i+1];//console.log(cell)
					}
					if(i>2){
						cell['hide']=true;
					}
					row.push(cell)
					}
					
				};
				
			}else{	
				let totalpoint=row.length;			
				for(let i=0; i<tatalrow.length-1; i++){
					let cell=JSON.parse(JSON.stringify(item));
					cell.COLUMNINTERNALNAME='col'+(i+10);//console.log(cell)
					if(i>2){
						cell['hide']=true;
					}
					
					if((row[1].KEY=='AU'||row[1].KEY=='AI')&&i>0){
						if(row[totalpoint]['colspan']>-1){
							row[totalpoint]['colspan']+=1;
						}else{
							row[totalpoint]['colspan']=2;
						}
						if(row[1].KEY=='AU'){
							row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Uninflated)'
						}
						if(row[1].KEY=='AI'){
							row[1].data='Annual Cost Per '+this.pcaOp.multiplier+' / Year (Inflated)'
						}
					}else{
						row.push(cell);
					}
					
				}
			}
			for(let j=0; j<row.length; j++){
				if(row[j].KEY=='Total'&&row[1].KEY=='AI'){
					row[j].data=this.getRound(precelldata/this.pcaOp.quantity/this.pcaOp.reserve,this.pcaOp.decimal).toString();
					sumtable.data.rows[5][1].data=row[j].data;
					sumtable.data.rows[5][2].data='Section ' +ref2;
				}
			}
			/*if(row[3].KEY=='Total'&&row[1].KEY=='AI'){
				row[3].data=this.getRound(precelldata/this.pcaOp.quantity/this.pcaOp.reserve).toString();
				sumtable.data.rows[5][1].data=row[3].data;
				sumtable.data.rows[5][2].data='See Table ' +ref2;
			}*/
			sumtable.data.rows[6][1].data='3.0%';//this.pcaOp.inflation;
			//sumtable.data.rows[6][2].data='See Table ' +ref2;
			if(row[1].KEY=='TU'){
				table.data['xmltotal']=JSON.parse(JSON.stringify(row));
			}else if(row[1].KEY=='TI'){
				table.data['xmlinflation']=JSON.parse(JSON.stringify(row));
			}
			table.data.rows.push(row)
		}
		//console.log(capitalLastRows)
		//table.data.rows=[table.data.rows,...capitalLastRows];
		//console.log(table.data.rows)
	}
	editPcaRow1(index){//console.log(index)
		//console.log(this.rowItem);
		if(!this.rowItem.allow&&this.rowItem.reserve>0){
			this.reserveWarn=true;
			return
		}
		this.rowItem.RUL=this.getRound(this.rowItem.EUL-this.rowItem.EFF, 0);//this.rowItem.EUL-this.rowItem.EFF;
		if(this.reserveWarn){
			if(!this.rowItem.allow){
				return
			}
		}
		const sum =this.rowItem.allocate.reduceRight((acc, cur) => acc + cur, 0); //console.log(sum)
		//let allCost=sum+this.rowItem.LS+this.rowItem.CR+this.rowItem.DM; //console.log(allCost);
		//let condition=!((this.rowItem['longCat'].length>0&&sum>0&&this.rowItem['catItem']>-1||(sum==0))&&(!this.rowItem.NTCHK));  console.log(condition)
		/*if(this.rowItem.Item==''||((this.rowItem.Quantity==0||this.rowItem.Unit==''||this.rowItem.Cost==0)&&(!this.rowItem.NTCHK))||(this.rowItem.NTCHK&&this.rowItem.NT.length==0)||(!((this.rowItem['longCat'].length>0&&this.rowItem['catItem']>-1))&&(!this.rowItem.NTCHK))){
			this.validateWarn1=true;
			return
		}*/
		if(!(this.reportInfo?.PCA_INDICATOR=='4099e'&&(this.passAction.indexOf(this.rowItem['ACTION'])>-1))){
			if(this.rowItem.Item==''||((this.rowItem.Quantity==0||this.rowItem.Unit==''||this.rowItem.Cost==0)&&(!this.rowItem.NTCHK))||(this.rowItem.NTCHK&&this.rowItem.NT.length==0)||(!((this.rowItem['longCat'].length>0&&this.rowItem['catItem']>-1))&&(!this.rowItem.NTCHK))){
				this.validateWarn1=true;
				return
			}
		}else{
			if(this.rowItem.Item==''||(this.rowItem.NTCHK&&this.rowItem.NT.length==0)||(!((this.rowItem['longCat'].length>0&&this.rowItem['catItem']>-1))&&(!this.rowItem.NTCHK))){
				this.validateWarn1=true;
				return
			}
		}
		if((this.rowItem.LSCHK&&this.rowItem.LSBD.length==0)||(this.rowItem.CRCHK&&this.rowItem.CRBD.length==0)||(this.rowItem.DMCHK&&this.rowItem.DMBD.length==0)){
			this.validateWarn1=true;
			return
		}
		if(this.reportInfo?.PCA_INDICATOR=='4099e'&&this.rowItem['ACTION'].length==0&&(!this.rowItem.NTCHK)){
			this.validateWarn1=true;
			return
		}
		//this.rowItem.Cycle=this.rowItem.Quantity*this.rowItem.Cost;
		let data=this.getContentData('data');
		let id=this.getContentData('id');
		let title=this.getContentData('SECTION_TITLE');
		//console.log(data);
		let info=JSON.parse(JSON.stringify(this.rowItem));
		
			let cid=data.rows[index][0].costId;
			let v2Index=data.COST.findIndex(item=>item.costId==cid);
			data.rows = data.rows.filter(row => row[0].costId!=cid);
			//console.log(data.rows);
			let row=[]
			for(let col of data.cols){
			let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'', 'KEY':''};
			item.COLUMNINTERNALNAME=col.INTERNALNAME;
			if(this.rowItem[col.KEY]||this.rowItem[col.KEY]==0){
				item.DATA=this.rowItem[col.KEY].toString();
			}
			item.KEY=col.KEY;
			if(col.KEY=='Cost'||col.KEY=='Cycle'||col.KEY=='Immediate'||col.KEY=='Short'){
				item.sign=this.currSign;
			}else if(col.KEY=='Percent'){
				item.sign='%';
			}else if(col.KEY=='RUL'&&this.rowItem.RULtext.length>0){
				item.DATA=this.rowItem.RULtext;
			}
			if((this.pcaOp.term=='Exclude')&&(col.KEY=='Short')){
				item['hide']='Y';
			}
			if(col.KEY=='Cycle'||col.KEY=='Percent'){
				item['hide']='Y';
			}
			
			//console.log(item)
			row.push(item);
			
		}
		let rowBase=JSON.parse(JSON.stringify(row));
			let keep=true;
			if(this.rowItem.LSCHK){
				let val1='Life Safety';
				let val2=this.rowItem.LS;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );
				data.rows.push(v2row);
				keep=false;
			}
			if(this.rowItem.CRCHK){
				let val1='Critical Repair';
				let val2=this.rowItem.CR;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );
				data.rows.push(v2row);
				keep=false;
			}
			if(this.rowItem.DMCHK){
				let val1='Deferred Maintenance';
				let val2=this.rowItem.DM;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );
				data.rows.push(v2row);
				keep=false;
			}
			
			if(this.rowItem.NTCHK){
				let val1='Items of Note';
				let val2=this.rowItem.NT;
				let v2row=JSON.parse(JSON.stringify(row));
				for(let row of v2row){
				if(row.KEY=='Year'){
					row.DATA=val1;
				}
				if(row.KEY=='Total'){
					row.DATA='';
				}
			}
				v2row[0]['KEEP']=keep;
				v2row[0]['costId']=cid;
				data.rows.push(v2row);
				keep=false;				
			}
			//console.log(data.rows)
			
			if(this.rowItem.Reserve>0&&info.allocate){//console.log(info.allocate)
				for(let i=0; i<info.allocate.length; i++){
					if(i<this.pcaOp.reserve){
						if(info.allocate[i]>0){//console.log(info.allocate[i])
							let val1=i+1;
							let val2=info.allocate[i];//console.log(val1,val2)
							let v2row=this.addV1(rowBase,val1,val2, keep,info['costId']);
							
							data.rows.push(v2row);
							keep=false;
						}
					}
				}
			}
			if(keep){
				let val1='one';
				let val2=this.rowItem.reserve;
				let v2row=this.addV1(rowBase,val1,val2, keep,info['costId'] );//console.log(v2row)
				data.rows.push(v2row);
				keep=false;
			}
			data.COST[v2Index]=info;
		this.getTotalUl();	
		this.getTotalCost1();
		$('#costDetailModal').modal('hide');
		this.autoSave('modify',id, title, "O" );
	}
	appendFMErow(doc){//console.log(doc)
		if(doc['appendtitle']){
			let firstrow=true;
			for(let row of doc.data.rows){
				if(row[0].data==doc['appendtitle']){
					firstrow=false;
					break
				}
			}
			let lastRow=doc.data.rows[0];
			if(firstrow){
				let first=JSON.parse(JSON.stringify(lastRow))
				for(let cell of first){
					cell.data=doc['appendtitle'];
					cell.bk='none';
					delete cell['ops'];
					delete cell['manual'];
					delete cell['RF'];
				}
				doc.data.rows.push(first)
			}
			
			let item=JSON.parse(JSON.stringify(lastRow))
			for(let cell of item){
				cell.data='';
				if(cell.htmltext){
					cell.htmltext='';
				}
				if(cell.DATA){
					delete cell['DATA'];
				}
				if(cell.slots){
					cell.slots=[];
				}				
			}
			item[0]['RF']=true;
			doc.data.rows.push(item)
		}else{
			let lastRow=doc.data.rows[0];
			let item=JSON.parse(JSON.stringify(lastRow))
			for(let cell of item){
				cell.data='';
				cell.bk='none';
				if(cell.htmltext){
					cell.htmltext='';
				}
				if(cell.DATA){
					delete cell['DATA'];
				}
				if(cell.slots){
					cell.slots=[];
				}
			}
			item[0]['RF']=true;
			doc.data.rows.push(item)
		}
	}
	getCompanyProfiles(id){
		let inputJson={"PROCEDURE":"getcompanystylelist","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID };
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.profiles=data.STYLE_LIST;
			
		})
	  }
	  clearAllFmeTable(){
		
		let tableIds=['fme_exec_sum_ir_1',
		'fme_exec_sum_ir_2',
		'fme_exec_sum_ir_3',
		//'fme_exec_sum_ir_4',
		'fme_exec_sum_ir_5',
		'fme_exec_sum_capital_needs_1'];
		for(let tableId of tableIds){
			let table=this.getSecbyId(this.contents,tableId);//console.log(table)
			if(table&&table.data&&table.data.rows.length>1){
				table.data.rows.splice(1,table.data.rows.length-1);
			}
			if(table&&table.data&&table.data.rows.length>0){
				let cols=table.data.rows[0].length;
				for(let cell of table.data.rows[0]){
					cell.data='';
				}
			}
		}
		let table1=this.getSecbyId(this.contents,'fme_exec_sum_ir_4');
		if(table1){
			table1.data.rows[0][2].data='';
		//let table2=this.getSecbyId(this.contents,'fme_exec_sum_ul_0');
		//let overallrow=JSON.parse(JSON.stringify(table2.data.rows[table2.data.rows.length-1]));
		//table2.data.rows=[overallrow];
		let table3=this.getSecbyId(this.contents,'fme_exec_sum_cost_estimates_0')
		
		for(let row of table3.data.rows){
			for(let i=0; i<row.length; i++){
				if(i>0){
					row[i].data=''
				}
			}
		}
		for(let group of this.capitalGroup){
				group.subRow=[];
				group.subData=[];
			}
			for(let group of this.ulGroup){
				group.subRow=[];
				group.subData=[];
			}
			
		
	  }
	}
	selFmeUl(doc, e, type){//console.log(doc, e)
		let val:any;
		if(type=='ACTION'){
			val=e.value;
		}else if(type=='EUL'||type=='EFF'){
			val=e.target.value;
			if(val>0){
				if(!Number.isInteger(val)){
					val=Math.ceil(val).toString();
				}else{
					val=val.toString();
				}
			}else{
				val='0';
			}
			//console.log(val)
		}else{
			val=e.target.value;
		}
		if(!doc['ul']){
			doc['ul']={'id':doc.id,'No':'', 'Item':doc.SECTION_TITLE, 'EUL':'', 'EFF':'','RUL':'', 'RATING':'','RERatio':'NA', 'ACTION':[], 'SecRef':doc.SECTION_SEQUENCE, 'cat':val};
		}
		if(val.length>0){
			doc['ul'][type]=val;
		}else{
			if(type=='cat'){
				delete doc.ul;
			}else{
				doc['ul'][type]='';
			}			
		}
		this.autoSave('modify',doc.id, doc.SECTION_TITLE,'O');	
		//console.log(doc['ul']);	
		this.getTotalUl();	
	}
	getTotalUl(){
		this.getAllAction();
		let allUls=[];
		let ulgps=JSON.parse(JSON.stringify(this.ulGroup));//console.log(ulgps)
		if (this.contents){
			for(let sec of this.contents){
				if(sec.ul&&sec.ul.Item.length>0){
					let item=JSON.parse(JSON.stringify(sec.ul))
					item['catIndex']=ulgps.findIndex(gp=>gp.label==item.cat);
					
					allUls.push(item)
				}
				if(sec.SUB_SECTIONS){				
					for(let sec1 of sec.SUB_SECTIONS){
						if(sec1.ul&&sec1.ul.Item.length>0){
							let item=JSON.parse(JSON.stringify(sec1.ul));
							item['catIndex']=ulgps.findIndex(gp=>gp.label==item.cat);
							
							allUls.push(item)
						}
						if(sec1.SUB_SECTIONS){
								for(let sec2 of sec1.SUB_SECTIONS){
									if(sec2.ul&&sec2.ul.Item.length>0){
										let item=JSON.parse(JSON.stringify(sec2.ul));
										item['catIndex']=ulgps.findIndex(gp=>gp.label==item.cat);
										
										allUls.push(item)
									}
					
								}
						}
						
					}
				}
			}
		}
		//console.log(allUls)
		allUls.sort(function(a, b){
			return a.catIndex - b.catIndex;
		});
		let tableData=this.getSecbyId(this.contents,'fme_exec_sum_ul_0');//console.log(tableData)
		let overallrow=JSON.parse(JSON.stringify(tableData.data.rows[tableData.data.rows.length-1]));
		
		let rows=tableData.data.rows;//console.log(rows);
		let cols=tableData.data.cols;//console.log(cols);
		tableData.data.rows=[];
		if(allUls.length>0){		
		for(let ul of allUls){//console.log(ul)
			let row=[]
			let baserow=this.fmeService.ulrow;
			for(let i=0; i<cols.length; i++){
				let item=JSON.parse(JSON.stringify(baserow[i]));
				item['KEY']=cols[i].KEY;
				
				if(item.KEY=='No'){
					let order=0;
					for(let j=0; j<ul.catIndex+1; j++){
						if(j>0){
							order+=ulgps[j-1].subRow.length;
						}
						
					}
					item.data=order+ulgps[ul.catIndex].subRow.length+1;				
					item['id']=ul.id;
					item['index']=this.getIdIndex(ul.id);
					item['htmltext']=order+ulgps[ul.catIndex].subRow.length+1;
				}else if(item.KEY=='RUL'){
					let val=(parseInt(row[i-2].data)-parseInt(row[i-1].data));
					if(isNaN(val)){
						item.data='';
						item['htmltext']='';
					}else{
						item.data=val.toString();
						item['htmltext']=val.toString();;
					}					
				}else if(item.KEY=='RERatio'){
					let val=this.getRound((row[i-1].data/row[i-3].data)*100,this.pcaOp.decimal);//console.log(val)
					if(isNaN(val)){
						item.data='';
						item['htmltext']='';
					}else{
						item.data=val+'%';
						item['htmltext']=val+'%';
					}
					
				}else if(item.KEY=='ACTION'){
					let val='';
					if(ul.ACTION&&ul.ACTION.length>0){
						val=ul.ACTION[0];
						for(let i=1; i<ul.ACTION.length; i++){
							val+=', '+ul.ACTION[i];
						}
					}
					item.data=val;
					item['htmltext']=val;
				}else if(item.KEY=='Srouce'){
					item['data']=ul['Source'];
					item['htmltext']=ul['Source'];
				}else{
					item['data']=ul[cols[i].KEY];
					item['htmltext']=ul[cols[i].KEY];
				}				
				//console.log(item)
				row.push(item)
			}
			ulgps[ul.catIndex].subRow.push(row)
		}
	}
			let titlebase=this.fmeService.capitalTitleRow;
			for(let group of ulgps){
				let titlerow=JSON.parse(JSON.stringify(titlebase));
				titlerow[0].data='';
				titlerow[1].data=group.label;
				titlerow[1].colspan=titlebase[1].colspan;
				tableData.data.rows.push(titlerow);
				for(let sub of group.subRow){
					tableData.data.rows.push(sub);
				}
			}
			tableData.data.rows.push(overallrow);//console.log('ul');
			this.autoSave('modify','fme_exec_sum_ul_0', '','O');
		
	}
	getAllAction(){
		
		for(let sec of this.contents){
			
			if(sec.ul&&sec.ul.ACTION){
				sec.ul.ACTION=[];
				let tosec1=true;
				
				if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
					let tosec2=true;
					let uppersec2:any;
					for(let sec1 of sec.SUB_SECTIONS){						
						if(this.otherTypes.indexOf(sec1.TYPE)==-1&&(!sec1.data)){
							if(sec1.ul&&sec1.ul.cat){
								tosec1=false;
								tosec2=true;
								sec1.ul.ACTION=[];
								uppersec2=sec1;								
								if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
									let uppersec3:any;	
									for(let sec2 of sec1.SUB_SECTIONS){
										let tosec3=true;	
																		
										if(this.otherTypes.indexOf(sec2.TYPE)==-1&&(!sec2.data)){
											tosec2=false;
											if(sec2.ul&&sec2.ul.cat){
												tosec3=true;
												sec2.ul.ACTION=[];
												uppersec3=sec2;
												
											}else{
												tosec3=false;
											}
										}else if(sec2.TYPE=='COSTTABLE'){
											if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
												for(let costitem of sec2.data.COST){//console.log(sec.ul, uppersec2, uppersec3, costitem, tosec1, tosec2, tosec3)
													if(tosec1){
															if(costitem.catLabel==sec.ul.cat){
																if(costitem['ACTION']&&sec.ul.ACTION.indexOf(costitem['ACTION'])==-1){
																	sec.ul.ACTION.push(costitem['ACTION'])
																}
															}
														}else if(tosec2){
															if(uppersec2&&costitem.catLabel==uppersec2.ul.cat){//console.log(uppersec2)
																if(costitem['ACTION']&&uppersec2.ul.ACTION.indexOf(costitem['ACTION'])==-1){
																	uppersec2.ul.ACTION.push(costitem['ACTION'])
																}
															}
														}else if(tosec3){
															if(uppersec3&&costitem.catLabel==uppersec3.ul.cat){
																if(costitem['ACTION']&&uppersec3.ul.ACTION.indexOf(costitem['ACTION'])==-1){
																	uppersec3.ul.ACTION.push(costitem['ACTION'])
																}
															}
														}
														
																										
												}
											}											
										}
									}
								}
							}else{
								tosec2=false;
								if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
									let uppersec3:any;	
									for(let sec2 of sec1.SUB_SECTIONS){
										let tosec3=true;	
																		
										if(this.otherTypes.indexOf(sec2.TYPE)==-1&&(!sec2.data)){
											if(sec2.ul&&sec2.ul.cat){
												tosec3=true;
												sec2.ul.ACTION=[];
												uppersec3=sec2;
											}else{
												tosec3=false;
											}
										}else if(sec2.TYPE=='COSTTABLE'){
											if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
												for(let costitem of sec2.data.COST){//console.log(sec.ul, uppersec2, uppersec3, costitem, tosec1, tosec2, tosec3)
													if(tosec3){
															if(uppersec3&&costitem.catLabel==uppersec3.ul.cat){
																if(costitem['ACTION']&&uppersec3.ul.ACTION.indexOf(costitem['ACTION'])==-1){
																	uppersec3.ul.ACTION.push(costitem['ACTION'])
																}
															}
														}
														
																										
												}
											}											
										}
									}
								}
							}
														
						}else if(sec1.TYPE=='COSTTABLE'){
							if(sec1.data&&sec1.data.COST&&sec1.data.COST.length>0){
								for(let costitem of sec1.data.COST){//console.log(sec.ul, costitem, tosec1)
										if(tosec1){
											if(costitem.catLabel==sec.ul.cat){
												if(costitem['ACTION']&&sec.ul.ACTION.indexOf(costitem['ACTION'])==-1){
													sec.ul.ACTION.push(costitem['ACTION'])
												}
											}
										}else if(tosec2){
											if(uppersec2&&costitem.catLabel==uppersec2.ul.cat){
												if(costitem['ACTION']&&uppersec2.ul.ACTION.indexOf(costitem['ACTION'])==-1){
													uppersec2.ul.ACTION.push(costitem['ACTION'])
												}
											}
										}
										
									
									
								}
							}
							if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
								let uppersec3:any;	
								for(let sec2 of sec1.SUB_SECTIONS){
									let tosec3:boolean;	
																	
									if(this.otherTypes.indexOf(sec2.TYPE)==-1&&(!sec2.data)){
										if(sec2.ul&&sec2.ul.cat){
											tosec3=true;
											sec2.ul.ACTION=[];
											uppersec3=sec2;
											
										}else{
											tosec3=false;
										}
									}else if(sec2.TYPE=='COSTTABLE'){
										if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
											for(let costitem of sec2.data.COST){//console.log(sec.ul, uppersec2, uppersec3, costitem, tosec2, tosec3)
												if(tosec1){
													if(costitem.catLabel==sec.ul.cat){
														if(costitem['ACTION']&&sec.ul.ACTION.indexOf(costitem['ACTION'])==-1){
															sec.ul.ACTION.push(costitem['ACTION'])
														}
													}
												}else if(tosec2){
													if(uppersec2&&costitem.catLabel==uppersec2.ul.cat){
														if(costitem['ACTION']&&uppersec2.ul.ACTION.indexOf(costitem['ACTION'])==-1){
															uppersec2.ul.ACTION.push(costitem['ACTION'])
														}
													}
												}else if(tosec3){
														if(uppersec3&&costitem.catLabel==uppersec3.ul.cat){
															if(costitem['ACTION']&&uppersec3.ul.ACTION.indexOf(costitem['ACTION'])==-1){
																uppersec3.ul.ACTION.push(costitem['ACTION'])
															}
														}
													}
													
																									
											}
										}											
									}
								}
							}
						}						
				}				
			
			}
		}else if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
			let tosec2=false;
			let uppersec2:any;
			for(let sec1 of sec.SUB_SECTIONS){						
				if(this.otherTypes.indexOf(sec1.TYPE)==-1&&(!sec1.data)){
					if(sec1.ul&&sec1.ul.cat){
						tosec2=true;
						sec1.ul.ACTION=[];
						uppersec2=sec1;								
						if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
							let uppersec3:any;	
							for(let sec2 of sec1.SUB_SECTIONS){
								let tosec3=true;	
																
								if(this.otherTypes.indexOf(sec2.TYPE)==-1&&(!sec2.data)){
									tosec2=false;
									if(sec2.ul&&sec2.ul.cat){
										tosec3=true;
										sec2.ul.ACTION=[];
										uppersec3=sec2;
									}else{
										tosec3=false;
									}
								}else if(sec2.TYPE=='COSTTABLE'){
									if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
										for(let costitem of sec2.data.COST){//console.log(uppersec2, uppersec3, costitem, tosec2, tosec3)
											if(tosec2&&uppersec2){
													if(uppersec2&&costitem.catLabel==uppersec2.ul.cat){//console.log(uppersec2)
														if(costitem['ACTION']&&uppersec2.ul.ACTION.indexOf(costitem['ACTION'])==-1){
															uppersec2.ul.ACTION.push(costitem['ACTION'])
														}
													}
												}else if(tosec3&&uppersec3){
													if(uppersec3&&costitem.catLabel==uppersec3.ul.cat){
														if(costitem['ACTION']&&uppersec3.ul.ACTION.indexOf(costitem['ACTION'])==-1){
															uppersec3.ul.ACTION.push(costitem['ACTION'])
														}
													}
												}
												
																								
										}
									}											
								}
							}
						}
					}else{
						tosec2=false;
						if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
							let uppersec3:any;	
							for(let sec2 of sec1.SUB_SECTIONS){
								let tosec3=true;	
																
								if(this.otherTypes.indexOf(sec2.TYPE)==-1&&(!sec2.data)){
									if(sec2.ul&&sec2.ul.cat){
										tosec3=true;
										sec2.ul.ACTION=[];
										uppersec3=sec2;
										
									}else{
										tosec3=false;
									}
								}else if(sec2.TYPE=='COSTTABLE'){
									if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
										for(let costitem of sec2.data.COST){//console.log(sec.ul, uppersec2, uppersec3, costitem, tosec2, tosec3)
											if(tosec3){
													if(uppersec3&&costitem.catLabel==uppersec3.ul.cat){
														if(costitem['ACTION']&&uppersec3.ul.ACTION.indexOf(costitem['ACTION'])==-1){
															uppersec3.ul.ACTION.push(costitem['ACTION'])
														}
													}
												}
												
																								
										}
									}											
								}
							}
						}
					}
												
				}else if(sec1.TYPE=='COSTTABLE'){
					if(sec1.data&&sec1.data.COST&&sec1.data.COST.length>0){
						for(let costitem of sec1.data.COST){//console.log(sec.ul, costitem)
								if(tosec2){
									if(uppersec2&&costitem.catLabel==uppersec2.ul.cat){
										if(costitem['ACTION']&&uppersec2.ul.ACTION.indexOf(costitem['ACTION'])==-1){
											uppersec2.ul.ACTION.push(costitem['ACTION'])
										}
									}
								}
								
							
							
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						let uppersec3:any;	
						for(let sec2 of sec1.SUB_SECTIONS){
							let tosec3:boolean;	
															
							if(this.otherTypes.indexOf(sec2.TYPE)==-1&&(!sec2.data)){
								if(sec2.ul&&sec2.ul.cat){
									tosec3=true;
									sec2.ul.ACTION=[];
									uppersec3=sec2;
									
								}else{
									tosec3=false;
								}
							}else if(sec2.TYPE=='COSTTABLE'){
								if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
									for(let costitem of sec2.data.COST){//console.log(sec.ul, uppersec2, uppersec3, costitem, tosec2, tosec3)
										if(tosec2){
											if(uppersec2&&costitem.catLabel==uppersec2.ul.cat){
												if(costitem['ACTION']&&uppersec2.ul.ACTION.indexOf(costitem['ACTION'])==-1){
													uppersec2.ul.ACTION.push(costitem['ACTION'])
												}
											}
										}else if(tosec3){
												if(uppersec3&&costitem.catLabel==uppersec3.ul.cat){
													if(costitem['ACTION']&&uppersec3.ul.ACTION.indexOf(costitem['ACTION'])==-1){
														uppersec3.ul.ACTION.push(costitem['ACTION'])
													}
												}
											}
											
																							
									}
								}											
							}
						}
					}
				}						
			}				
	
	

		}
	}
	//console.log(this.contents)	
	}
	//ifCloser=false;
	toggleCloser(e){
		//this.ifCloser=!this.ifCloser;
		let userSelected=e.target.checked?"Y":"N";
		let inputJson = {"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"REQUEST_CLOSER_XML":userSelected};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}else{
				this.reportInfo=data
			}			
		})
	}
	
	closerInputQuestion=[];
	closerXmlName='';
	allowCloser='N';
	async getCloserinput(){
		this.logCloser()
		this.closerPassed='';
		let inputJson={"PROCEDURE":"getreportcloserquestions","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID };
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.addFormControl2(data.CLOSER_QUESTIONS);
			this.getCloserFormula(data.CLOSER_QUESTIONS[0].CLOSER_QUESTIONS);		
			
			this.closerInputQuestion=JSON.parse(JSON.stringify(data.CLOSER_QUESTIONS));
			this.closerXmlName=data.CLOSER_XML_FILE_NAME.replace(/[^a-zA-Z0-9]/g, "_");			
			
			$("#closerModal").modal('show');
	}
	addFormControl2(questions){
		this.closerForm = new FormGroup({}); //console.log(this.closerForm)
		for(let question of questions){
			for(let q of question.CLOSER_QUESTIONS){
				let allV=[];
				if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);			
				}				
				if(q.CLOSER_FIELD_TYPE=='Text'){
					
					let max=q.FME_MAX_FIELD_LENGTH;//console.log(max)
					let min=q.FME_MIN_FIELD_LENGTH;//console.log(min)
					
					if(max){
						allV.push(Validators.maxLength(max));					
					}
					if(min){
						allV.push(Validators.minLength(min));					
					}
					if(q.CLOSER_DECIMAL_IND=='Y'){
						if(q.CLOSER_DECIMAL_LENGTH){
							let numPattern="^\d+\.\d{0,"+q.CLOSER_DECIMAL_LENGTH+"}$"; console.log(numPattern)
							allV.push(Validators.pattern(numPattern));
						}
					}					
				}else if(q.CLOSER_FIELD_TYPE=='Number'){				
					let max=q.CLOSER_NUMBER_MAXVALUE;
					let min=q.CLOSER_NUMBER_MINVALUE;
					if(q.CLOSER_DECIMAL_IND=='Y'){
						if(q.CLOSER_DECIMAL_LENGTH>0){
							let pattern='\\-?\\d*\\.?\\d{1,'+q.CLOSER_DECIMAL_LENGTH+'}';
							allV.push(Validators.pattern(pattern));
						}					
					}else{
						let pattern=/^-?(0|[1-9]\d*)?$/;
						allV.push(Validators.pattern(pattern));
						
					}
					if(max>min){
						allV.push(Validators.max(max));
					}
					if(min){
						allV.push(Validators.min(min));
					}				
				}else if(q.CLOSER_FIELD_TYPE=='Date'){	
					let max=q.CLOSER_MAX_FIELD_LENGTH;
					if(max){
						allV.push(Validators.maxLength(max));					
					}			
					let f=q.CLOSER_DATE_FORMAT;
					let min=q.CLOSER_MIN_DATE_VALUE;
					if(q.CLOSER_FIELD_REQUIRED=='Y'){
						allV.push(Validators.required);
					}
					if(f=='MM/DD/YYYY'){
						let finalPattern=/^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/;
						allV.push(Validators.pattern(finalPattern));
					}else if(f=='YYYY'&&min){
						allV.push(Validators.min(min));
					}else if(f=="YYYY-MM-DDT12:00:00"){
						let finalPattern=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
						allV.push(Validators.pattern(finalPattern));
					}
				}else if(q.CLOSER_FIELD_TYPE=="Selection"){
					if(q.CLOSER_FIELD_REQUIRED=='Y'){
						allV.push(Validators.required);
					}
				}
				if(allV.length>0){
					this.closerForm.addControl(q.CLOSER_ID, new FormControl('', allV));				
				}else{
					this.closerForm.addControl(q.CLOSER_ID, new FormControl('', Validators.nullValidator));
				}
							
			}
     	
		}
		for(let question of questions){
			for(let q of question.CLOSER_QUESTIONS){
				this.closerForm.controls[q.CLOSER_ID].setValue(q.CLOSER_VALUE);
			}
		}
	}
	closerFormulas=[];
	allFormulaInputs=[];
	getCloserFormula(items){
		this.closerFormulas=[];
		this.allFormulaInputs=[];
		for(let item of items){
			if(item.CLOSER_FIELD_TYPE=='Formula'){
				let inputs=item.CLOSER_FORMULA.split('+');
				let formulaItem={'CLOSER_ID':item.CLOSER_ID, 'INPUTS':inputs};
				this.closerFormulas.push(formulaItem);
				this.allFormulaInputs=[...this.allFormulaInputs, ...inputs];
			}
		}
	}
	updateCloserQ(item,e){
		const type=item.CLOSER_FIELD_TYPE
		let val=e.target.value;
		if(type&&type=='Text'){
			val=e.target.value.trim();
		}else if(type&&type=='Date'){
			if(val.length>0){
				val=val+item.CLOSER_DATE_FORMAT.substring(10);	
			}		
		}else if(type&&type=="Number"&&this.allFormulaInputs.length>0){
			if(this.allFormulaInputs.indexOf(item.CLOSER_ID.toString())!=-1){
				this.calculateCloserFormulas(item.CLOSER_ID, val);	
			}			
		}		
		item.CLOSER_VALUE=val;		
		let inputJson={"PROCEDURE":"updatereportcloserquestion","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID ,"CLOSER_ID":item.CLOSER_ID,"CLOSER_VALUE":val};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}else{
				this.updateCloserEdits(data.CLOSER_QUESTIONS);				
			}
					
		})
	}
	calculateCloserFormulas(changedId, changedVal){
		//if(!changedVal){
		//	changedVal=0;
		//}
		for(let formula of this.closerFormulas){
			if(formula.INPUTS.indexOf(changedId.toString())!=-1){
				let allValues=[];
				for(let inputId of formula.INPUTS){
					if(inputId==changedId.toString()){
						allValues.push(parseFloat(changedVal));
					}else{
						let val=this.closerForm.controls[parseInt(inputId)].value;
						if(val&&val.length>0){
							allValues.push(parseFloat(val));
						}
					}
				}
				let result=0;
					for(let v of allValues){
						result+=v;
					}
					result=this.getRound(result, this.pcaOp.decimal);
					this.closerForm.controls[formula.CLOSER_ID].setValue(result.toString());
					let item=this.findCloserById(formula.CLOSER_ID);
					item.CLOSER_VALUE=result.toString();
					let inputJson={"PROCEDURE":"updatereportcloserquestion","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID ,"CLOSER_ID":item.CLOSER_ID,"CLOSER_VALUE":result.toString()};
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
						console.log(data);
						if (data.RESPONSE_STATUS=='N') {
							this.throwError(data)
							return
						}else{
							this.updateCloserEdits(data.CLOSER_QUESTIONS);
						}
					})
				
			}
		}
	}
	findCloserById(id){
		for(let i=0; i<this.closerInputQuestion.length; i++){	
			for(let j=0; j<this.closerInputQuestion[i].CLOSER_QUESTIONS.length; j++){
				let q=this.closerInputQuestion[i].CLOSER_QUESTIONS[j];
				if(q.CLOSER_ID==id){
					return q;
				}
			}	
		}
		return null;		
	}
	updateCloserEdits(edits){
		for(let i=0; i<edits.length; i++){
			for(let j=0; j<edits[i].CLOSER_QUESTIONS.length; j++){
				let a=edits[i].CLOSER_QUESTIONS[j];
				let b=this.closerInputQuestion[i].CLOSER_QUESTIONS[j]
				if(a.CLOSER_FIELD_REQUIRED!=b.CLOSER_FIELD_REQUIRED){
					this.updateCloserControl(a);
					b.CLOSER_FIELD_REQUIRED=a.CLOSER_FIELD_REQUIRED;
				}
				if(a.CLOSER_NUMBER_MAXVALUE!=b.CLOSER_NUMBER_MAXVALUE||a.CLOSER_NUMBER_MINVALUE!=b.CLOSER_NUMBER_MINVALUE){
					this.updateCloserControl(a);
					b.CLOSER_NUMBER_MAXVALUE=a.CLOSER_NUMBER_MAXVALUE;
					b.CLOSER_NUMBER_MINVALUE=a.CLOSER_NUMBER_MINVALUE;
				}
				if(a.CLOSER_VALUE!=b.CLOSER_VALUE){
					if(a.CLOSER_VALUE){
						this.closerForm.controls[b.CLOSER_ID].setValue(a.CLOSER_VALUE);
						b.CLOSER_VALUE=a.CLOSER_VALUE;
					}else{
						this.closerForm.controls[b.CLOSER_ID].setValue('');
						b.CLOSER_VALUE='';
					}
					
				}
			}
		}

	}
	updateCloserControl(q){
		let allV=[]					
		this.closerForm.controls[q.CLOSER_ID].clearValidators();
			if(q.CLOSER_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);			
			}				
			if(q.CLOSER_FIELD_TYPE=='Text'){
				let max=q.CLOSER_MAX_FIELD_LENGTH;
				let min=q.CLOSER_MIN_FIELD_LENGTH;
				if(max){
					allV.push(Validators.maxLength(max));					
				}
				if(min){
					allV.push(Validators.minLength(min));					
				}
				if(q.CLOSER_DECIMAL_IND=='Y'){
					if(q.CLOSER_DECIMAL_LENGTH){
						let numPattern="^\d+\.\d{0,"+q.CLOSER_DECIMAL_LENGTH+"}$"; console.log(numPattern)
						allV.push(Validators.pattern(numPattern));
					}
				}					
			}else if(q.CLOSER_FIELD_TYPE=='Number'){				
				let max=q.CLOSER_NUMBER_MAXVALUE;
				let min=q.CLOSER_NUMBER_MINVALUE;
				if(q.CLOSER_DECIMAL_IND=='Y'){
					if(q.CLOSER_DECIMAL_LENGTH>0){
						let pattern='\\-?\\d*\\.?\\d{1,'+q.CLOSER_DECIMAL_LENGTH+'}';
						allV.push(Validators.pattern(pattern));
					}					
				}else{
					let pattern=/^-?(0|[1-9]\d*)?$/;
					allV.push(Validators.pattern(pattern));
					
				}
				if(max>min){
					allV.push(Validators.max(max));
				}
				if(min){
					allV.push(Validators.min(min));
				}				
			}else if(q.CLOSER_FIELD_TYPE=='Date'){
				let max=q.CLOSER_MAX_FIELD_LENGTH;
				if(max){
					allV.push(Validators.maxLength(max));					
				}
				let f=q.CLOSER_DATE_FORMAT;
				let min=q.CLOSER_MIN_DATE_VALUE;
				if(q.CLOSER_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);
				}
				if(f=='MM/DD/YYYY'){
					let finalPattern=/^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/;
					allV.push(Validators.pattern(finalPattern));
				}else if(f=='YYYY'&&min){
					allV.push(Validators.min(min));
				}else if(f=="YYYY-MM-DDT12:00:00"){
						let finalPattern=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
						allV.push(Validators.pattern(finalPattern));
				}
			}else if(q.CLOSER_FIELD_TYPE=="Selection"){
				if(q.CLOSER_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);
				}
			}
			
			if(allV.length>0){
				this.myForm.addControl(q.CLOSER_ID, new FormControl('', allV));				
			}else{
				this.myForm.addControl(q.CLOSER_ID, new FormControl('', Validators.nullValidator));
			}
			this.myForm.controls[q.CLOSER_ID].setValidators(allV);
			this.myForm.controls[q.CLOSER_ID].updateValueAndValidity({onlySelf: true});
		
	}	
	closerPassed='';
	closerInputValidate(type?){
		let invalidi=$('.redBorder').length; //console.log(invalidi);
		//let invalids=$('.closerSlotNoContent').length; //console.log(invalids);
		//let allInvalid=invalidi+invalids;
		//console.log(this.closerForm.valid)
		if(invalidi==0){
			this.closerPassed='Y';
		}else{
			this.closerPassed='N';
		}
		return this.closerPassed;
	  }	
	async toPrintCloserXml(){
		this.closerPassed='';
		if(this.closerInputQuestion.length==0){
			await this.getCloserinput();
		}else{
			$("#closerModal").modal('show');
		}	
		setTimeout(() => {
			this.closerPassed=this.closerInputValidate('print');
			if(this.closerPassed=='Y'){
				this.printCloserXml();
				$("#closerModal").modal('hide');
			}
		}, 1000);		
	  }
	
	async printCloserXml(){
		this.closerPassed=this.closerInputValidate('print');
		if(this.closerPassed=='N') return
		this.pdfSpin('start')
		let xml = '<?xml version="1.0" encoding="utf-8"?>\n'+
		'<ThirdPartyReports schemaVersion="3.0">\n'
		//xml+='\t<'+this.reportInfo.CLOSER_XML_TYPE+'>\n';
		let type=this.closerInputQuestion[0].CLOSER_QUESTIONS[0].CLOSER_TYPE
		xml+='\t<'+type+'>\n';
		for(let question of this.closerInputQuestion){//formatdata.group
			if(question.CLOSER_QUESTIONS!.length){
				if(question['CLOSER_CATEGORY_TAG']){
					xml += "\t\t<"+question['CLOSER_CATEGORY_TAG'] + ">\n";					
				}				
				for(let q of question.CLOSER_QUESTIONS){
					if(q['CLOSER_CATEGORY_TAG']){
						xml += "\t"
					}	
					xml += "\t\t<" + q.CLOSER_FIELD_TAG + ">";
					if(q.CLOSER_VALUE){
						xml += q.CLOSER_VALUE;
					}else{
						xml +='';
					}
					
					xml += "</"+q.CLOSER_FIELD_TAG + ">\n";	
				}
				if(question['CLOSER_CATEGORY_TAG']){
					xml += "\t\t</"+question['CLOSER_CATEGORY_TAG'] + ">\n";
				}
				
			}
		}	       
		//xml += '\t</'+this.reportInfo.CLOSER_XML_TYPE+'>\n</ThirdPartyReports>';
		xml += '\t</'+type+'>\n</ThirdPartyReports>';
		let xmldata=btoa(encodeURIComponent(xml).replace(/%([0-9A-F]{2})/g, function (match, p1) {
			return String.fromCharCode(parseInt('0x' + p1, 16));
		}));
		//let inputJson={"PROCEDURE":"GenerateCloserXML","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"CLOSER_XML_FILE":xmldata};
		let company_id=this.reportInfo.REPORT_COMPANY_ID.toString()
		let report_id=this.reportInfo.REPORT_ID.toString();
		let user_id=this.userId.toString();
		const result =await this.reportService.generateCloserXML(company_id,user_id,report_id,this.closerXmlName,xmldata).toPromise();
		//console.log(result)
		this.pdfSpin('end')
		if (result.RESPONSE_STATUS=='N') {
			this.throwError(result)
			return										
		}else{
			this.reportInfo=result;
			if(result.CLOSER_XML_FILE){
				this.popInfo(result.CLOSER_XML_FILE, this.closerXmlName, 'xml');
			}
		}			
	}
	fmeInputQuestion=[];
	async getFMEinput(){
		this.logFmeInput();
		this.passed='';
		let inputJson={"PROCEDURE":"getreportfmequestions","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID };
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		//this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			$("#fmeModal").modal('show');
			this.fmeInputQuestion=JSON.parse(JSON.stringify(data.FME_QUESTIONS));
			this.addFormControl(data.FME_QUESTIONS);
			//this.fmeInputQuestion=data.FME_QUESTIONS;//console.log(JSON.stringify(data.FME_QUESTIONS))
			
			
		//})
	}
	conditiongroup=[];
	calculategroup1=[];
	calculategroup2=[];
	targetgroup1=[];
	targetgroup2=[];
	targetIds=[118, 104];//[118,104, 27];//[48,34, 115];
	addFormControl(questions){//console.log(this.myForm)
		this.myForm = new FormGroup({}); //console.log(this.myForm)
		this.conditiongroup=[];
		this.calculategroup1=[];
		this.calculategroup2=[];
		this.targetgroup1=[];
		this.targetgroup2=[];
		for(let question of questions){
			for(let q of question.FME_QUESTIONS){
				let allV=[];
				if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);			
				}
				if(q.FME_FIELD_TAG=='NumberOfExistingParkingSpaces'||q.FME_FIELD_TAG=='NumberOfHandicapAccessibleParkingSpaces'||q.FME_FIELD_TAG=='NumberOfUnits'){
					this.calculategroup1.push(q);
				}
				if(q.FME_FIELD_TAG=='NumberOfUnitsInspected'||q.FME_FIELD_TAG=='NumberOfUnits'){
					this.calculategroup2.push(q);
				}
				if(q.FME_FIELD_TAG=='ParkingRatio'){
					this.targetgroup1.push(q);
				}
				if(q.FME_FIELD_TAG=='PercentOfUnitsInspected'){
					this.targetgroup2.push(q);
				}
				
			if(q.FME_FIELD_TYPE=='Text'){
				
				let max=q.FME_MAX_FIELD_LENGTH;//console.log(max)
				let min=q.FME_MIN_FIELD_LENGTH;//console.log(min)
				
				if(max){
					allV.push(Validators.maxLength(max));					
				}
				if(min){
					allV.push(Validators.minLength(min));					
				}
				if(q.FME_DECIMAL_IND=='Y'){
					if(q.FME_DECIMAL_LENGTH){
						let numPattern="^\d+\.\d{0,"+q.FME_DECIMAL_LENGTH+"}$"; console.log(numPattern)
						allV.push(Validators.pattern(numPattern));
					}
				}					
			}else if(q.FME_FIELD_TYPE=='Number'){				
				let max=q.FME_NUMBER_MAXVALUE;
				let min=q.FME_NUMBER_MINVALUE;
				if(q.FME_DECIMAL_IND=='Y'){
					if(q.FME_DECIMAL_LENGTH>0){
						if(q.FME_DECIMAL_LENGTH_REQUIRED=='Y'){
							let decimals=q.FME_DECIMAL_LENGTH;
							const pattern = `^\\d+\\.\\d{${decimals}}$`;// `\\d+\\.\\d{1, `+ q.CLOSER_DECIMAL_LENGTH+`}`;///^\d+\.\d{2}$/;
							allV.push(Validators.pattern(pattern));
						}else{
							let pattern='\\-?\\d*\\.?\\d{1,'+q.FME_DECIMAL_LENGTH+'}';
							allV.push(Validators.pattern(pattern));
						}
						/*let pattern='\\-?\\d*\\.?\\d{1,'+q.FME_DECIMAL_LENGTH+'}';
						allV.push(Validators.pattern(pattern));*/
					}					
				}else{
					let pattern=/^-?(0|[1-9]\d*)?$/;
					allV.push(Validators.pattern(pattern));
					
				}
				//console.log(max, min);
				if(max>min){
					allV.push(Validators.max(max));
				}
				if(min){
					allV.push(Validators.min(min));
				}				
			}else if(q.FME_FIELD_TYPE=='Date'){	
				let max=q.FME_MAX_FIELD_LENGTH;
				if(max){
					allV.push(Validators.maxLength(max));					
				}			
				let f=q.FME_DATE_FORMAT;
				let min=q.FME_MIN_DATE_VALUE;
				if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);
				}
				if(f=='MM/DD/YYYY'){
					let finalPattern=/^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/;
					allV.push(Validators.pattern(finalPattern));
				}else if(f=='YYYY'&&min){
					allV.push(Validators.min(min));
				}
			}else if(q.FME_FIELD_TYPE=="Selection"){
				if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);
				}
			}
			//console.log(allV)
			if(allV.length>0){
				this.myForm.addControl(q.FME_FIELD_TAG, new FormControl('', allV));				
			}else{
				this.myForm.addControl(q.FME_FIELD_TAG, new FormControl('', Validators.nullValidator));
			}
						
		}
     	
	}
	for(let question of questions){
				for(let q of question.FME_QUESTIONS){
				this.myForm.controls[q.FME_FIELD_TAG].setValue(q.FME_VALUE);
				}
			}
			//console.log(this.conditiongroup);
			//console.log(this.calculategroup1);
			//console.log(this.calculategroup2);
			//console.log(this.targetgroup1);
			//console.log(this.targetgroup2);		
}
async printXml(){
		const outputxmltype=this.reportInfo.OUTPUT_XML_TYPE;
		let schemaLocation='';
		if(outputxmltype=='PCA'){
			schemaLocation=`${environment.api.pcaschema}`;
		}else if(outputxmltype=='ESA'){
			schemaLocation=`${environment.api.esaschema}`;
		}else if(outputxmltype=='SRA'){
			schemaLocation=`${environment.api.sraschema}`;
		}
		else if(outputxmltype=='ZON'){
			schemaLocation=`${environment.api.zonschema}`;
		}
		let formatdata=JSON.parse(JSON.stringify(this.fmeService.outputFormat[outputxmltype]));// console.log(formatdata);
		//console.log(schemaLocation)
		//console.log(this.fmeInputQuestion)
		let xml = '<'+formatdata.tag+' xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:nns1="http://www.w3.org/2001/XMLSchema-instance" nns1:noNamespaceSchemaLocation="'+schemaLocation+'">\n';
		//console.log(this.fmeInputQuestion);
		//for(let items of formatdata.group){
			let index1=this.fmeInputQuestion.findIndex(question=>question['FME CATEGORY_TAG']=='FannieMaeIdentifiers');//console.log(index1)
			if(index1>-1){
				
					let index2=this.fmeInputQuestion[index1].FME_QUESTIONS.findIndex(question=>question['FME_FIELD_TAG']=='DealIdentifier');//console.log(index2)
					if(index2>-1){
						//item['value']=this.fmeInputQuestion[index1].FME_QUESTIONS[index2].FME_VALUE;
						//if(item.tag=="DealIdentifier"){
							this.xmlName=this.fmeInputQuestion[index1].FME_QUESTIONS[index2].FME_VALUE+'_'+outputxmltype;
						//}
					}
				
			}			
		//}
		let pcagroup=[];
		if(formatdata['pcagroup']){
			for(let items of formatdata.pcagroup){//console.log(items)
				let sec={'tag':items.tag, 'sub':[]};
				let othersItems=[];
				if(items.id){//Replacement of Capital Items
					let tabledata=this.getSecbyId(this.contents, items.id).data;//console.log(tabledata);
					for(let item of items.sub){console.log(item)//'key':'xmldata',						
						if(item.key){
							let xmldata=tabledata[item.key];console.log(xmldata);
							if(!xmldata) continue
							if(!item.tag){console.log(item)							
							for(let group of xmldata){
								let sec1:any;
								let other1:any
								let keys=JSON.parse(JSON.stringify(item.sub[0]));
								if(group.subData.length>0){
									sec1={'tag':group.tag,'sub':[]};
									other1={'tag':group.othertag,'sub':[]};
									let sec2:any;
									let othersItem=[];
									for(let rowdata of group.subData){console.log(rowdata)
										if(rowdata.catItem>-1){

										
										let tag=this.capitalItems[rowdata.catIndex][rowdata.catItem].FME_CATEGORY_TAG;//console.log(tag)
										let index=sec1.sub.findIndex(row=>row.tag==tag); //console.log(index);
										//console.log(sec1);
										//console.log(sec2);						
										if(index==-1){
											sec2={'tag':tag,'sub':[{'tag':item.sub[0].tag, 'sub':[]}]};
												//console.log(item.sub)
												for(let cells of item.sub){//console.log(cells)
													for(let cell of cells.sub){
													if(cell.key){console.log(cell.key)
														let cellValue=rowdata[cell.key];
														if(cell.key=='RUL'&&rowdata['RULtext'].length>0){
															cellValue=rowdata['RULtext'];
														}
														let cellitem={'tag':cell.tag, 'value':cellValue};
														sec2.sub[0].sub.push(cellitem); //console.log(sec2)
													}else if(cell.total){
														let year=15;//rowdata.Year;
														let captag=cell.tag1+year+cell.tag2;
														let cap={'tag':captag,'sub':[]};
														for(let yearitem of cell.sub){
															if(yearitem.key){
																let yeartotal={'tag':yearitem.tag,'value':rowdata[yearitem.key]}
																cap.sub.push(yeartotal);
															}else if(yearitem.range){
																for(let i=0; i<15; i++){
																	if(rowdata.allocate[i]>0&&i<this.pcaOp.reserve){
																		let yeartag=yearitem.tag1+(i+1);
																		let yearrow={'tag':yeartag,'value':rowdata.allocate[i]}
																		cap.sub.push(yearrow);
																	}else{
																		let yeartag=yearitem.tag1+(i+1);
																		let yearrow={'tag':yeartag,'value':0}
																		cap.sub.push(yearrow);
																	}
																}
															}
														}
														sec2.sub[0].sub.push(cap);//console.log(sec2)
													}
												}
											}											
											sec1.sub.push(sec2)
										}else{//console.log(rowdata)//add to othersItems	
											//sec1={'tag':group.tag,'sub':[]};
											othersItem.push(rowdata);	//console.log(othersItem)									
											//let othertag=this.capitalItems[rowdata.catItem].othertag;
											//sec2={'tag':othertag,'sub':[{'tag':item.sub.othertag, 'sub':[]}]};
											//other1.sub.push(sec2)
											
										}
									}
									}
									let othersub={'tag':group.othertag,'sub':othersItem, 'keys':keys};
									othersItems.push(othersub);	
									sec.sub.push(sec1);	
								}								
							}
							let othersecs={'tag':'OtherCapitalItems', 'sub':[]}
							for(let other of othersItems){
								let othersec={'tag':other.tag, 'sub':[]};//console.log(othersec)
								for(let i=0; i<other.sub.length; i++){
									let sec1={'tag':'', 'sub':[]};
									let index=this.capitalCategory.findIndex(item=>item.othertag==other.tag);
									if(index>-1){
										sec1.tag=this.capitalCategory[index].othersubtag+(i+1).toString();
										let tag1=this.capitalCategory[index].othergdtag;
										let value1=this.capitalCategory[index].otherlabel;//this.capitalCategory[index].label.toLowerCase();//other.sub[i].longCatLabel;
										let tag2=this.capitalCategory[index].othergsubtag;
										let value2=this.capitalItems[index][other.sub[i].catItem].FME_FIELD_NAME;
										sec1.sub.push({'tag':tag1, 'value':value1});
										sec1.sub.push({'tag':tag2, 'value':value2});
										let sec2={'tag':other.keys.tag, 'sub':[]};
										let rowdata=other.sub[i];
												let keys=JSON.parse(JSON.stringify(other.keys.sub));
													for(let cell of keys){
													if(cell.key){
														let cellValue=rowdata[cell.key];
														if(cell.key=='RUL'&&rowdata['RULtext'].length>0){
															cellValue=rowdata['RULtext'];
														}
														let cellitem={'tag':cell.tag, 'value':cellValue};
														//let cellitem={'tag':cell.tag, 'value':rowdata[cell.key]};
														sec2.sub.push(cellitem); //console.log(sec2)
													}else if(cell.total){
														let year=15;//rowdata.Year;
														let captag=cell.tag1+year+cell.tag2;
														let cap={'tag':captag,'sub':[]};
														for(let yearitem of cell.sub){
															if(yearitem.key){
																let yeartotal={'tag':yearitem.tag,'value':rowdata[yearitem.key]}
																cap.sub.push(yeartotal);
															}else if(yearitem.range){
																for(let j=0; j<15; j++){
																	if(rowdata.allocate[j]>0&&j<this.pcaOp.reserve){
																		let yeartag=yearitem.tag1+(j+1);
																		let yearrow={'tag':yeartag,'value':rowdata.allocate[j]}
																		cap.sub.push(yearrow);
																	}else{
																		let yeartag=yearitem.tag1+(j+1);
																		let yearrow={'tag':yeartag,'value':0}
																		cap.sub.push(yearrow);
																	}
																}
															}
														}
														sec2.sub.push(cap);//console.log(sec2)
													}
												}
												sec1.sub.push(sec2)
											
									}
									othersec.sub.push(sec1)
									
								}
								if(othersec['sub'].length>0){
									othersecs.sub.push(othersec)
								}
								
							}
							if(othersecs['sub'].length>0){
								sec.sub.push(othersecs);
							}

						}else{//capital total 
							let sec1={'tag':item.tag, 'sub':[]};
							let year=15;//xmldata[xmldata.length-1].KEY;
							for(let rows of item.sub){
								if(rows.total){
									let tag=rows.tag1+year+rows.tag2;
									let sec2={'tag':tag,'sub':[]}
									for(let row of rows.sub){
										if(row.key){
											let index=xmldata.findIndex(cell=>cell.KEY==row.key);
											if(index>-1){
												let sec3={'tag':row.tag,'value':xmldata[index].data};
												sec2.sub.push(sec3);
											}else if(row.tag=="CapitalItemTotalCostOverEvaluationPeriod"&&row.key=='Total'){//for inflated part at end of xml, wait for cumstomer response
												let total=0;
												for(let i=3; i<xmldata.length; i++){
													total+=xmldata[i].data;													
												}
												let sec3={'tag':row.tag, "value":total.toFixed(2)};
												sec2.sub.push(sec3);
											}
										}else if(row.range){
											/*for(let i=0; i<year+1; i++){
												let index=xmldata.findIndex(cell=>cell.KEY==i);
												if(index>-1){
													if(xmldata[index].data>0){
														let rowtag=row.tag1+i;
														let sec3={'tag':rowtag, "value":xmldata[index].data}
														sec2.sub.push(sec3);
													}
													
												}												
											}*/
											for(let i=1; i<15+1; i++){
												let index=xmldata.findIndex(cell=>cell.KEY==i);
												if(index>-1){
													if(xmldata[index].data>0){
														let rowtag=row.tag1+i;
														let sec3={'tag':rowtag, "value":xmldata[index].data}
														sec2.sub.push(sec3);
													}else{
														let rowtag=row.tag1+i;
														let sec3={'tag':rowtag, "value":0}
														sec2.sub.push(sec3);
													}
													
												}else{
													let rowtag=row.tag1+i;
													let sec3={'tag':rowtag, "value":0}
													sec2.sub.push(sec3);
												}												
											}
										}
									}
									sec1.sub.push(sec2)
								}								
							}
							sec.sub.push(sec1);	
						}
						}else if(item.value){
							let sec1={'tag':item.tag, 'value':item.value};
							sec.sub.push(sec1);								
						}											
					}					
				}else{//Immediate Repairs estimation
					//console.log(items)
					let other=[];
					for(let item of items.sub){
						
						if(item.id){
							let tabledata=this.getSecbyId(this.contents, item.id).data;
							if(tabledata.rows.length>0&&((tabledata.rows[0][0].KEY=='Item'&&tabledata.rows[0][0].data.length>0)||item.id=="fme_exec_sum_ir_4")){	
							if(item.sub){
								let subitem=JSON.parse(JSON.stringify(item.sub));
								for(let v of item.sub){
									
										let index=tabledata.rows[0].findIndex(cell=>cell.KEY==v.key);
										if(index>-1){
											v.value=tabledata.rows[0][index].data;
										}else if(tabledata.rows[0][1].KEY=='NT'){//if has key but not found in data, set value to empty
											if(item.tag=='ItemsOfNote'){
												if(!v.key||v.key=='Cost'){
													v.value=0;
												}else if(v.key=='Quantity'){
													v.value=1;
												}else if(v.key=='Unit'){
													v.value='EA';
												}
											}
										}
										/*if(item.tag=='ItemsOfNote'){
											if(!v.key||v.key=='Cost'){
												v.value=0;
											}else if(v.key=='Quantity'){
												v.value=1;
											}else if(v.key=='Unit'){
												v.value='EA';
											}else{
												let index=tabledata.rows[0].findIndex(cell=>cell.KEY==v.key);
												if(index>-1){
													v.value=tabledata.rows[0][index].data;
												}
											}
												
										}else{									
											let index=tabledata.rows[0].findIndex(cell=>cell.KEY==v.key);
											if(index>-1){
												v.value=tabledata.rows[0][index].data;
											}
										}*/
																	
								}							
								if(tabledata.id=="fme_exec_sum_ir_5"){
									if(tabledata.rows.length>1){
										let rest=JSON.parse(JSON.stringify(tabledata.rows));
										rest.shift();
										let immi={'id':item.id,'rests':rest, 'subitems':subitem};
										other.push(immi);
									}
								}else if(tabledata.rows.length>2){
									let rest=JSON.parse(JSON.stringify(tabledata.rows));
									rest.shift();rest.pop(); //console.log(rest)
									let immi={'id':item.id,'rests':rest, 'subitems':subitem};//console.log(immi)
									other.push(immi);//console.log(other)								
								}
								
							}else if(item.key){
								let tabledata=this.getSecbyId(this.contents, item.id).data;//console.log(tabledata);
								let index=tabledata.rows[0].findIndex(cell=>cell.KEY==item.key);
								if(index>-1){
									item['value']=tabledata.rows[0][index].data
								}

							}
						}else{
							item['empty']=true;
						}
						
						}else{
								item.sub=[];
								for(let immis of other){
									let index=this.immiCategory.findIndex(cat=>cat.id==immis.id);									
									if(index>-1){
										let immicat=this.immiCategory[index];
										let cats={'tag':immicat.othertag, 'sub':[]};
										for(let immi of immis.rests){
											let cat={'tag':immicat.othersubtag, 'sub':[]};
											let immiitem={'tag':immicat.othergdtag, 'value':immicat.label};
											cat.sub.push(immiitem);
											for(let restItem of immis.subitems){
												let indexi=immi.findIndex(cell=>cell.KEY==restItem.key);
												let restimmi:any;
												if(indexi>-1){
													let immival=immi[indexi].data
													restimmi={'tag':restItem.tag, 'value':immival};
												}else{
													if(immis.subitems[0].key=='NT'){//if has key but not found in data, set value to empty
														if(restItem.tag=='ImmediateRepairUnitCost'||restItem.tag=='ImmediateRepairCost'){
															restimmi={'tag':restItem.tag, 'value':0};
														}else if(restItem.tag=='ImmediateRepairQuantity'){
															restimmi={'tag':restItem.tag, 'value':1};
														}else if(restItem.tag=='ImmediateRepairUnitOfMeasure'){
															restimmi={'tag':restItem.tag, 'value':'EA'};
														}
													}
													
												}
												cat.sub.push(restimmi);
											}
											cats.sub.push(cat);
										}
										item.sub.push(cats);
									}									
								}
							}
						}
						sec=JSON.parse(JSON.stringify(items));				
				}
				pcagroup.push(sec);				
			}
		}
		for(let question of this.fmeInputQuestion){//formatdata.group
			xml += "\t<"+question['FME CATEGORY_TAG'] + ">\n";
			/*for(let q of question.FME_QUESTIONS){
				xml += "\t\t<" + q.FME_FIELD_TAG + ">";
				if(q.FME_VALUE){
					let inputValue=q.FME_VALUE;
					if(q.FME_FIELD_TYPE!='Number'&&q.FME_VALUE.length>0){
						inputValue = this.removeXMLSpecialChar(q.FME_VALUE);
					}
					xml += inputValue;
				}else{
					xml +='';
				}
				
				xml += "</"+q.FME_FIELD_TAG + ">\n";	
			}*/
			for(let q of question.FME_QUESTIONS){
				
				if(q.FME_VALUE){
					xml += "\t\t<" + q.FME_FIELD_TAG + ">";
					let inputValue=q.FME_VALUE;
					if(q.FME_FIELD_TYPE!='Number'&&q.FME_VALUE.length>0){
						inputValue = this.removeXMLSpecialChar(q.FME_VALUE);
					}
					xml += inputValue;
					xml += "</"+q.FME_FIELD_TAG + ">\n";
				}else{
					//xml += "\t\t<" + q.FME_FIELD_TAG + "/>\n"; remove empty tag as per customer request
				}
				
					
			}
			xml += "\t</"+question['FME CATEGORY_TAG'] + ">\n";
		}
		//console.log(pcagroup)
		if(pcagroup.length>0) {
			/*for(let question of pcagroup){
			xml += "\t<"+question['tag'] + ">\n";
			for(let q of question.sub){
				xml += "\t\t<" + q.tag + ">";
				if(q.value>=0||q.value){
					xml += this.removeXMLSpecialChar(q.value, q.tag);
				}else if(q.sub){
					xml += "\n";
					for(let r of q.sub){
						xml += "\t\t\t<" + r.tag + ">";
						if(r.value>=0||r.value){
							xml += this.removeXMLSpecialChar(r.value, r.tag);
						}else if(r.sub){
							xml += "\n";
							for(let s of r.sub){
								xml += "\t\t\t\t<" + s.tag + ">";
								if(s.value>=0||s.value){
									xml += this.removeXMLSpecialChar(s.value, s.tag);
								}else if(s.sub){
									xml += "\n";
									for(let t of s.sub){
										xml += "\t\t\t\t\t<" + t.tag + ">";
										if(t.value>=0||t.value){
											xml += this.removeXMLSpecialChar(t.value, t.tag	);
										}else if(t.sub){
											xml += "\n";
											for(let u of t.sub){
												xml += "\t\t\t\t\t\t<" + u.tag + ">";
												if(u.value>=0||u.value){
													xml += this.removeXMLSpecialChar(u.value, u.tag);
												}else if(u.sub){
													xml += "\n";
													for(let v of u.sub){
														xml += "\t\t\t\t\t\t\t<" + v.tag + ">";
														if(v.value>=0||v.value){
															xml += this.removeXMLSpecialChar(v.value, v.tag);
														}else{
															xml +='';
														}
														xml += "</"+v.tag + ">\n";
													}
													xml += "\t\t\t\t\t\t";
												}else{
													xml +='';
												}
												xml += "</"+u.tag + ">\n";
											}
											xml += "\t\t\t\t\t";
										}else{
											xml +='';
										}
										xml += "</"+t.tag + ">\n";
									}
									xml += "\t\t\t\t";
								}else{
									xml +='';
								}
								xml += "</"+s.tag + ">\n";
							}
							xml += "\t\t\t";
						}else{
							xml +='';
						}
						xml += "</"+r.tag + ">\n";
					}
					xml += "\t\t";
				}else{
					xml +='';
				}
				
				xml += "</"+q.tag + ">\n";	
			}
			xml += "\t</"+question['tag'] + ">\n";
		} 
		}*/  
		 for(let question of pcagroup){
			if(question.sub.length>0){
			xml += "\t<"+question['tag'] + ">\n";
			for(let q of question.sub){				
				if((q.value !== '' && !isNaN(Number(q.value)) && Number(q.value) >= 0)|| (typeof q.value === 'string' && q.value.trim().length > 0)){
					xml += "\t\t<" + q.tag + ">";
					xml += this.removeXMLSpecialChar(q.value, q.tag);
					xml += "</"+q.tag + ">\n";	
				}else if(!q['empty']&&q.sub&&q.sub.length>0){
					xml += "\t\t<" + q.tag + ">\n";		
					for(let r of q.sub){
						
						if((r.value !== '' && !isNaN(Number(r.value)) && Number(r.value) >= 0)|| (typeof r.value === 'string' && r.value.trim().length > 0)){
							xml += "\t\t\t<" + r.tag + ">";
							xml += this.removeXMLSpecialChar(r.value, r.tag);
							xml += "</"+r.tag + ">\n";
						}else if(r.sub&&r.sub.length>0){
							xml += "\t\t\t<" + r.tag + ">\n";
							for(let s of r.sub){

								if((s.value !== '' && !isNaN(Number(s.value)) && Number(s.value) >= 0)|| (typeof s.value === 'string' && s.value.trim().length > 0)){
									xml += "\t\t\t\t<" + s.tag + ">";
									xml += this.removeXMLSpecialChar(s.value, s.tag);
									xml += "</"+s.tag + ">\n";
								}else if(s.sub&&s.sub.length>0){
									xml += "\t\t\t\t<" + s.tag + ">\n";									
									for(let t of s.sub){

										if((t.value !== '' && !isNaN(Number(t.value)) && Number(t.value) >= 0)|| (typeof t.value === 'string' && t.value.trim().length > 0)){
											xml += "\t\t\t\t\t<" + t.tag + ">";
											xml += this.removeXMLSpecialChar(t.value, t.tag	);
											xml += "</"+t.tag + ">\n";
										}else if(t.sub&&t.sub.length>0){
											xml += "\t\t\t\t\t<" + t.tag + ">\n";
											for(let u of t.sub){

												if((u.value !== '' && !isNaN(Number(u.value)) && Number(u.value) >= 0)|| (typeof u.value === 'string' && u.value.trim().length > 0)){
													xml += "\t\t\t\t\t\t<" + u.tag + ">";
													xml += this.removeXMLSpecialChar(u.value, u.tag);
													xml += "</"+u.tag + ">\n";
												}else if(u.sub&&u.sub.length>0){
													xml += "\t\t\t\t\t\t<" + u.tag + ">\n";													
													for(let v of u.sub){

														if((v.value !== '' && !isNaN(Number(v.value)) && Number(v.value) >= 0)|| (typeof v.value === 'string' && v.value.trim().length > 0)){
															xml += "\t\t\t\t\t\t\t<" + v.tag + ">";
															xml += this.removeXMLSpecialChar(v.value, v.tag);
															xml += "</"+v.tag + ">\n";
														}else{
															//xml += "\t\t\t\t\t\t\t<" + v.tag + "/>\n"; remove empty tag as per customer request
														}
														
													}
													xml += "\t\t\t\t\t\t</"+u.tag + ">\n";
												}else{
													//xml += "\t\t\t\t\t\t<" + u.tag + "/>\n"; remove empty tag as per customer request
												}
												
											}
											xml += "\t\t\t\t\t</"+t.tag + ">\n";
										}else{
											//xml += "\t\t\t\t\t<" + t.tag + "/>\n"; remove empty tag as per customer request
										}										
									}
									xml += "\t\t\t\t</"+s.tag + ">\n";
								}else{
									//xml += "\t\t\t\t<" + s.tag + "/>\n"; remove empty tag as per customer request
								}								
							}
							xml += "\t\t\t</"+r.tag + ">\n";
						}else{
							//xml += "\t\t\t<"+r.tag + "/>\n"; remove empty tag as per customer request
						}
						
					}
					xml += "\t\t</"+q.tag + ">\n";	
				}else{//here is OtherImmediateRepairs closure, not sure if needed when there is not other immi
					if(q.tag=='TotalImmediateRepairsCost'){
						//xml += "\t\t<"+q.tag + "/>\n"; remove empty tag as per customer request
					}
					/*if(q.tag!=='OtherImmediateRepairs'&&q.tag!=='ItemsOfNote'){
						xml += "\t\t<"+q.tag + "/>\n";
					}*/
				}				
				
			}
			xml += "\t</"+question['tag'] + ">\n";
		}else{
			//xml += "\t<"+question['tag'] + "/>\n"; remove empty tag as per customer request
		} 
		}   
	}   
		xml += '</'+formatdata.tag+'>';
		console.log(xml);
		this.xmlContent=xml;		
		//this.preview('xml')

		//here you can rewrite the xmlstring to a new document
		//or use the hide control to store the xml text, call the text in code behind.
		//also, you can call ajax to excuet codebehind and sava the xml file                
		// window.open('data:text/xml,' + xml);
	  }
	  
	  calFME(group, type){			
		//!isNaN(parseInt(id))
	  	//const ft=['ParkingRatio','PercentOfUnitsInspected'];
		if(type=='group1'){
			const fg1=['NumberOfExistingParkingSpaces', 'NumberOfHandicapAccessibleParkingSpaces','NumberOfUnits'];
			let a=parseInt(group[fg1[0]]);//console.log(a);
			let b=parseInt(group[fg1[1]]);//console.log(b);
			let c=parseInt(group[fg1[2]]);//console.log(c);
			if(!isNaN(a)&&!isNaN(b)&&!isNaN(c)&&c>0){
				//let val=this.getRound(((a+b)/c)*100, 0)/100
				let val=this.getRound((a+b)/c, 2).toFixed(2);//console.log(val);
				//let val=this.getRound((a-b)/c, 2).toString()//console.log(val);
				//this.targetgroup1[0].FME_VALUE=val;
				//this.setTarget(val, this.targetgroup1[0]);
				this.updateFmeQ1(val, this.targetgroup1[0])
			}else{
				//this.targetgroup1[0].FME_VALUE='';
				//this.setTarget('', this.targetgroup1[0]);
				this.updateFmeQ1('', this.targetgroup1[0])
			}
			
			
		}else if(type=='group2'){
			const fg2=['NumberOfUnitsInspected', 'NumberOfUnits'];
			let a=parseInt(group[fg2[0]]);//console.log(a);
			let b=parseInt(group[fg2[1]]);//console.log(b);
			if(!isNaN(a)&&!isNaN(b)&&b>0){
				//let val=this.getRound((a/b)*100, 2);
				let val=this.getRound((a/b)*100, 2).toFixed(2);
				//let val=this.getRound(a/b, 2).toString();//console.log(val);
				//this.targetgroup2[0].FME_VALUE=val;
				//this.setTarget(val, this.targetgroup2[0]);
				this.updateFmeQ1(val, this.targetgroup2[0])
			}else{
				//this.targetgroup2[0].FME_VALUE='';
				//this.setTarget('', this.targetgroup2[0]);
				this.updateFmeQ1('', this.targetgroup2[0])
			}			
		}

	  }
	  setTarget(val,item){
		//console.log(val, item, this.targetIds)
		let index=this.fmeInputQuestion.findIndex(cat=>cat['FME CATEGORY_TAG']==item.FME_CATEGORY_TAG);//console.log(index)
		if(index>-1){
			let cat=this.fmeInputQuestion[index].FME_QUESTIONS;//console.log(cat)
			let index1=cat.findIndex(cat1=>cat1.FME_ID==item.FME_ID);//console.log(index1)
			if(index1>-1){
				cat[index1].FME_VALUE=val;
			}
		}
	  }
	  updateFmeQ1(val, item){
		let inputJson={"PROCEDURE":"updatereportfmequestion","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID ,"FME_ID":item.FME_ID,"FME_VALUE":val};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}else{
				this.setTarget(val, item);
			}
		})
	  }
	updateFmeEdits(edits){
		for(let i=0; i<edits.length; i++){
			for(let j=0; j<edits[i].FME_QUESTIONS.length; j++){
				let a=edits[i].FME_QUESTIONS[j];
				let b=this.fmeInputQuestion[i].FME_QUESTIONS[j]
				if(a.FME_FIELD_REQUIRED!=b.FME_FIELD_REQUIRED){//console.log(a.FME_FIELD_REQUIRED)
					this.updatecontrol(a);
					b.FME_FIELD_REQUIRED=a.FME_FIELD_REQUIRED;
				}
				if(a.FME_NUMBER_MAXVALUE!=b.FME_NUMBER_MAXVALUE||a.FME_NUMBER_MINVALUE!=b.FME_NUMBER_MINVALUE){
					this.updatecontrol(a);
					b.FME_NUMBER_MAXVALUE=a.FME_NUMBER_MAXVALUE;
					b.FME_NUMBER_MINVALUE=a.FME_NUMBER_MINVALUE;
				}
				if(a.FME_VALUE!=b.FME_VALUE){//console.log(a.FME_VALUE);
					if(a.FME_VALUE){
						this.myForm.controls[b.FME_FIELD_TAG].setValue(a.FME_VALUE);
						b.FME_VALUE=a.FME_VALUE;
					}else{
						this.myForm.controls[b.FME_FIELD_TAG].setValue('');
						b.FME_VALUE='';
					}
					
				}
			}
		}

	}
	updatecontrol(q){
		//console.log(this.myForm.controls);
		//for(let q of children){	
			let allV=[]					
			this.myForm.controls[q.FME_FIELD_TAG].clearValidators();
			if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);			
			}				
			if(q.FME_FIELD_TYPE=='Text'){
				let max=q.FME_MAX_FIELD_LENGTH;
				let min=q.FME_MIN_FIELD_LENGTH;
				if(max){
					allV.push(Validators.maxLength(max));					
				}
				if(min){
					allV.push(Validators.minLength(min));					
				}
				if(q.FME_DECIMAL_IND=='Y'){
					if(q.FME_DECIMAL_LENGTH){
						let numPattern="^\d+\.\d{0,"+q.FME_DECIMAL_LENGTH+"}$"; //console.log(numPattern)
						allV.push(Validators.pattern(numPattern));
					}
				}					
			}else if(q.FME_FIELD_TYPE=='Number'){				
				let max=q.FME_NUMBER_MAXVALUE;
				let min=q.FME_NUMBER_MINVALUE;
				if(q.FME_DECIMAL_IND=='Y'){
					if(q.FME_DECIMAL_LENGTH>0){
						if(q.FME_DECIMAL_LENGTH_REQUIRED=='Y'){
							let decimals=q.FME_DECIMAL_LENGTH;
							const pattern = `^\\d+\\.\\d{${decimals}}$`;// `\\d+\\.\\d{1, `+ q.CLOSER_DECIMAL_LENGTH+`}`;///^\d+\.\d{2}$/;
							allV.push(Validators.pattern(pattern));
						}else{
							let pattern='\\-?\\d*\\.?\\d{1,'+q.FME_DECIMAL_LENGTH+'}';
							allV.push(Validators.pattern(pattern));
						}
						//let pattern='\\-?\\d*\\.?\\d{1,'+q.FME_DECIMAL_LENGTH+'}';
						//allV.push(Validators.pattern(pattern));
					}					
				}else{
					let pattern=/^-?(0|[1-9]\d*)?$/;
					allV.push(Validators.pattern(pattern));
					
				}
				if(max>min){
					allV.push(Validators.max(max));
				}
				if(min){
					allV.push(Validators.min(min));
				}				
			}else if(q.FME_FIELD_TYPE=='Date'){
				let max=q.FME_MAX_FIELD_LENGTH;
				if(max){
					allV.push(Validators.maxLength(max));					
				}
				let f=q.FME_DATE_FORMAT;
				let min=q.FME_MIN_DATE_VALUE;
				if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);
				}
				if(f=='MM/DD/YYYY'){
					let finalPattern=/^(0[1-9]|1[012])[\/](0[1-9]|[12][0-9]|3[01])[\/](19|20)\d\d$/;
					allV.push(Validators.pattern(finalPattern));
				}else if(f=='YYYY'&&min){
					allV.push(Validators.min(min));
				}
			}else if(q.FME_FIELD_TYPE=="Selection"){
				if(q.FME_FIELD_REQUIRED=='Y'){
					allV.push(Validators.required);
				}
			}
			//console.group(allV)
			if(allV.length>0){
				this.myForm.addControl(q.FME_FIELD_TAG, new FormControl('', allV));				
			}else{
				this.myForm.addControl(q.FME_FIELD_TAG, new FormControl('', Validators.nullValidator));
			}
			this.myForm.controls[q.FME_FIELD_TAG].setValidators(allV);
			this.myForm.controls[q.FME_FIELD_TAG].updateValueAndValidity({onlySelf: true});
		//}
	}
	  updateFmeQ(item, e, type?){//console.log(item, e.target.value);
		let val=e.target.value;
		if(type&&type=='text'){
			val=e.target.value.trim();
		}
		//let val=e.target.value.trim();
		item.FME_VALUE=val;
		
		//item.FME_VALUE=val;
		/*let invalid=true;
		if(item.FME_SELECTION_CHOICES.length>0){
			if(item.FME_VALUE&&item.FME_FIELD_REQUIRED=='Y'){
				invalid=false;
				val=item.FME_VALUE;
			}
		}else{//console.log(this.myForm.controls[item.FME_FIELD_TAG]);
			if(this.myForm.controls[item.FME_FIELD_TAG].status=="VALID"){
				invalid=false;
				val=this.myForm.controls[item.FME_FIELD_TAG].value;
			}else{
				let index1=this.calculategroup1.findIndex(q=>q.FME_ID==item.FME_ID);console.log(index1)
				let index2=this.calculategroup2.findIndex(q=>q.FME_ID==item.FME_ID);console.log(index2)
				if(index1>-1){
					this.targetgroup1[0].FME_VALUE='';
					this.setTarget('', this.targetgroup1[0]);
				}
				if(index2>-1){
					this.targetgroup2[0].FME_VALUE='';
					this.setTarget('', this.targetgroup2[0]);
				}
			}
		}*/
		
		//if(invalid){
		//	return
		//}
		let inputJson={"PROCEDURE":"updatereportfmequestion","USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID ,"FME_ID":item.FME_ID,"FME_VALUE":val};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}else{//console.log(item)
				this.updateFmeEdits(data.FME_QUESTIONS);
				/*if(data.FME_CHILD_LIST){
					this.updatecontrol(data.FME_CHILD_LIST);					
				}
				this.setTarget(val,item);*/
				//this.fmeInputQuestion=JSON.parse(JSON.stringify(data.FME_QUESTIONS));
				//this.addFormControl(data.FME_QUESTIONS);
				let index1=this.calculategroup1.findIndex(q=>q.FME_ID==item.FME_ID);//console.log(index1)
				let index2=this.calculategroup2.findIndex(q=>q.FME_ID==item.FME_ID);//console.log(index2)
				let index3=this.conditiongroup.findIndex(q=>q.id=item.id);//console.log(index3)
				if(index1>-1){
					let hasVal=false;
					let count=0;
					let items={};
				for(let q of this.calculategroup1){
					if(q.FME_ID==item.FME_ID){
						q.FME_VALUE=val;
					}
					if(q.FME_VALUE){					
						items[q.FME_FIELD_TAG]=q.FME_VALUE;
						count++
					}
				}
				//console.log(count)
				if(count==3){
					this.calFME(items, 'group1');
				}			
				}
				if(index2>-1){
					let hasVal=false;
					let count=0;
					let items={};
					for(let q of this.calculategroup2){
						if(q.FME_ID==item.FME_ID){
							q.FME_VALUE=val;
						}
						if(q.FME_VALUE){					
							items[q.FME_FIELD_TAG]=q.FME_VALUE;
							count++
						}
					}
					//console.log(count)
					if(count==2){
						this.calFME(items, 'group2');
					}
				}
				/*if(index3>-1){
					let data=this.conditiongroup[index3];
					if(val==data.value){
						this.addFormControl(questions)
					}
				}*/
			}
					
		})
	  }
	  passed='';
	  fmeInputValidate(type?){
		let invalidi=$('.redBorder').length;
		//let invalids=$('.fmeSlotNoContent').length;
		let allInvalid=invalidi//+invalids;
		//console.log(this.myForm.valid)
		if(allInvalid==0){
			this.passed='Y';
			//$('#fmeModal').modal('hide');
			/*if(type){
				$("#fmeModal").on('shown.bs.modal', function () { $('#fmeModal').modal('hide'); });
			}*/
		}else{
			this.passed='N';
		}
		return this.passed;
	  }	
	fmeSelect($event, id){
		let val=$event.target.value; console.log(val);
		//this.autoSave('modify','fme_exec_sum_title_2', '','O');					
		this.autoSave('modify',id, '', 'O');
	}
	
	noDataConfig(e){
		if(e.target.checked){
			this.printnodataforAppendix='N';
		}else{
			this.printnodataforAppendix='Y';
		}
		let inputJson={"PROCEDURE":"updatereport", "USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID, "APPENDIX_NODATA_MESSAGE":this.printnodataforAppendix};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)
				return										
			}
			this.reportInfo=data;
			this.autoSave('appendix Factor update','appendix Factor update', 'appendix Factor update');			
		})
	}
	/*summaryShow=false;
	curSummary:any;
	ulProp:any;
	summaryData(e){console.log(e)
		this.curSummary.html=e;
		this.curSummary.secHtml=this.sanitizer.bypassSecurityTrustHtml(e);	
		this.curSummary.slots=this.getAllSlotId(e);
		console.log(this.curSummary)
	}
	summaryText(e){
		this.curSummary.data=e;
		if(this.curSummary.id){
			let keys=["Good","Fair","Poor","ACTION"];
			let doc=this.getSecbyId(this.contents,this.curSummary.id);console.log(doc)
			doc['summaryPara'][keys[this.curSummary.index-1]]=this.curSummary.data;
			this.curId=doc.id;
			this.listid=doc.id;
			this.autoSave('modify', doc.id, doc.SECTION_TITLE,'O');
		}
	}
	toSummaryAction(e){console.log(e)
		if(e.id){
			let doc=this.getSecbyId(this.contents,e.id);console.log(doc)
			doc['summaryPara']['ACTION']=e.data;
		}
	}*/
	summaryCols=[];
	summaryColsType=[];
	summaryType='';
	haveSummary(){
		let status=false;
		for(let doc of this.frontpages){
			if(doc.TYPE=='SUMMARY'||doc.TYPE=='PISUMMARY'){//console.log(doc)
				if(!this.summaryCols||this.summaryCols.length==0){
					this.summaryCols=[];
					if(doc.SUB_SECTIONS.length>0&&doc.SUB_SECTIONS[0].data&&doc.SUB_SECTIONS[0].data.cols){
						for(let col of doc.SUB_SECTIONS[0].data.cols){
						this.summaryCols.push(col.NAME);
						this.summaryColsType.push(col.inputType);
					}
					}
					
				}
				this.summaryType='PHASE I';				
				status=true;
				break
			}
		}
		for(let doc of this.contents){
			if(doc.TYPE=='SUMMARY'||doc.TYPE=='PISUMMARY'){console.log(doc)
				if(!this.summaryCols||this.summaryCols.length==0){
					this.summaryCols=[];
					if(doc.SUB_SECTIONS.length>0&&doc.SUB_SECTIONS[0].data&&doc.SUB_SECTIONS[0].data.cols){
						for(let col of doc.SUB_SECTIONS[0].data.cols){
						this.summaryCols.push(col.NAME);
						this.summaryColsType.push(col.inputType);
					}
					}
					
				}
				this.summaryType='PHASE I';				
				status=true;
				break
			}else if(doc.TYPE=='PCASUMMARY'){
				this.pcaSummaryCols=this.reportService.pcaSummaryCols;
				this.summaryType='PCA';
				status=true;
				break
			}
		}
		return status;
	}
	
	allSummarys=[];
	getallsummaryItems(){
		let allUls=[];
		
		if (this.contents){
			let summaryItem:any;
			for(let i=0; i<this.contents.length; i++){
				
				let sec=this.contents[i];
				if(this.contents[i].pcasummarydata){
					let item=JSON.parse(JSON.stringify(this.contents[i].pcasummarydata));
					item[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item[0].cat);
					item[0].SecRef=this.contents[i].SECTION_SEQUENCE;
					item[0].data=this.contents[i].SECTION_SEQUENCE+' '+this.contents[i].SECTION_TITLE;
					summaryItem=item;
					allUls.push(item)
				}else if((!sec.OSNAME&&sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0)||sec.SECTION_SEQUENCE.length>0){
					summaryItem=null
				}
				if(this.contents[i].SUB_SECTIONS&&this.contents[i].SUB_SECTIONS.length>0){	
					let summaryItem1:any;			
					for(let j=0; j<this.contents[i].SUB_SECTIONS.length; j++){
						let sec1=this.contents[i].SUB_SECTIONS[j];//console.log(sec1)
						if(sec1.TYPE=='COSTTABLE'){
							if(summaryItem1&&summaryItem1[0].cat==sec1['summaryCat']){
								if(!summaryItem1[0].COSTS){
									summaryItem1[0]['COSTS']=[];
								}
								summaryItem1[0].COSTS.push(sec1.id);
							}else if(!summaryItem1&&summaryItem&&summaryItem[0].cat==sec1['summaryCat']){
								if(!summaryItem[0].COSTS){
									summaryItem[0]['COSTS']=[];
								}
								summaryItem[0].COSTS.push(sec1.id);
								if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
									let summaryItem2:any;
									for(let k=0; k<sec1.SUB_SECTIONS.length; k++){
										
										let sec2=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k];
										if(sec2.TYPE=='COSTTABLE'){
											if(summaryItem2&&summaryItem2[0].cat==sec2['summaryCat']){
												if(!summaryItem2[0].COSTS){
													summaryItem2[0]['COSTS']=[];
												}
												summaryItem2[0].COSTS.push(sec2.id);
											}else if(!summaryItem2&&summaryItem1&&summaryItem1[0].cat==sec2['summaryCat']){
												if(!summaryItem1[0].COSTS){
													summaryItem1[0]['COSTS']=[];
												}
												summaryItem1[0].COSTS.push(sec2.id);
											}else if(!summaryItem2&&(!summaryItem1)&&summaryItem&&summaryItem[0].cat==sec2['summaryCat']){
												if(!summaryItem[0].COSTS){
													summaryItem[0]['COSTS']=[];
												}
												summaryItem[0].COSTS.push(sec2.id);
											}											
										}else if((!sec2.OSNAME&&sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0)||sec2.SECTION_SEQUENCE.length>0){
											if(sec2.pcasummarydata){
												let item2=JSON.parse(JSON.stringify(sec2.pcasummarydata));
												item2[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item2[0].cat);
												item2[0].SecRef=sec2.SECTION_SEQUENCE;
												item2[0].data=sec2.SECTION_SEQUENCE+' '+sec2.SECTION_TITLE;
												allUls.push(item2)
												summaryItem2=item2;								
											}else if((!sec2.OSNAME&&sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0)||sec2.SECTION_SEQUENCE.length>0){
												if(summaryItem2&&summaryItem2.refId!=sec2.id){
													summaryItem2=null;
												}	
												summaryItem1=null;
												summaryItem=null;
											}
										}
									}
								}
							}
								
						}else if(sec1.SECTION_SEQUENCE.length==0&&(sec1.OSNAME||(!sec1.SECTION_TITLE)||sec1.SECTION_TITLE.length==0)){
							if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
								let summaryItem2:any;
								for(let k=0; k<sec1.SUB_SECTIONS.length; k++){
									let sec2=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k];
									if(sec2.TYPE=='COSTTABLE'){
										
										if(summaryItem2&&summaryItem2[0].cat==sec2['summaryCat']){
											if(!summaryItem2[0].COSTS){
												summaryItem2[0]['COSTS']=[];
											}
											summaryItem2[0].COSTS.push(sec2.id);console.log(summaryItem2)
										}else if(!summaryItem2&&summaryItem1&&summaryItem1[0].cat==sec2['summaryCat']){
											if(!summaryItem1[0].COSTS){
												summaryItem1[0]['COSTS']=[];
											}
											summaryItem1[0].COSTS.push(sec2.id);console.log(summaryItem1)
										}else if(!summaryItem2&&(!summaryItem1)&&summaryItem&&summaryItem[0].cat==sec2['summaryCat']){
											if(!summaryItem[0].COSTS){
												summaryItem[0]['COSTS']=[];
											}
											summaryItem[0].COSTS.push(sec2.id);console.log(summaryItem)
										}											
									}else if((!sec2.OSNAME&&sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0)||sec2.SECTION_SEQUENCE.length>0){
										if(sec2.pcasummarydata){
											let item2=JSON.parse(JSON.stringify(sec2.pcasummarydata));
											item2[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item2[0].cat);
											item2[0].SecRef=sec2.SECTION_SEQUENCE;
											item2[0].data=sec2.SECTION_SEQUENCE+' '+sec2.SECTION_TITLE;
											allUls.push(item2)
											summaryItem2=item2;									
										}else  if((!sec2.OSNAME&&sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0)||sec2.SECTION_SEQUENCE.length>0){
											if(summaryItem2&&summaryItem2.refId!=sec2.id){
												summaryItem2=null;
											}	
											summaryItem1=null;
											summaryItem=null;
										}										
							
									}

								}
							}


						}else{
							
							if(sec1.pcasummarydata){
								let item1=JSON.parse(JSON.stringify(sec1.pcasummarydata));
								item1[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item1[0].cat);
								item1[0].SecRef=sec1.SECTION_SEQUENCE;
								item1[0].data=sec1.SECTION_SEQUENCE+' '+sec1.SECTION_TITLE;
								allUls.push(item1)
								summaryItem1=item1;
							}else if((!sec1.OSNAME&&sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0)||sec1.SECTION_SEQUENCE.length>0){
								//summaryItem1=null;
								if(summaryItem1&&summaryItem1.refId!=sec1.id){
									summaryItem1=null;
								}
								summaryItem=null;
							}
							if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
								let summaryItem2:any;
								for(let k=0; k<sec1.SUB_SECTIONS.length; k++){
									let sec2=this.contents[i].SUB_SECTIONS[j].SUB_SECTIONS[k];
									if(sec2.TYPE=='COSTTABLE'){
										if(summaryItem2&&summaryItem2[0].cat==sec2['summaryCat']){
											if(!summaryItem2[0].COSTS){
												summaryItem2[0]['COSTS']=[];
											}
											summaryItem2[0].COSTS.push(sec2.id);
										}else if(!summaryItem2&&summaryItem1&&summaryItem1[0].cat==sec2['summaryCat']){
											if(!summaryItem1[0].COSTS){
												summaryItem1[0]['COSTS']=[];
											}
											summaryItem1[0].COSTS.push(sec2.id);
										}else{
											continue
										}
									}else if((!sec2.OSNAME&&sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0)||sec2.SECTION_SEQUENCE.length>0){
										if(sec2.pcasummarydata){
											let item2=JSON.parse(JSON.stringify(sec2.pcasummarydata));
											item2[0]['catIndex']=this.summaryCategory.findIndex(gp=>gp==item2[0].cat);
											item2[0].SecRef=sec2.SECTION_SEQUENCE;
											item2[0].data=sec2.SECTION_SEQUENCE+' '+sec2.SECTION_TITLE;
											allUls.push(item2)
											summaryItem2=item2;										
										}else  if((!sec2.OSNAME&&sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0)||sec2.SECTION_SEQUENCE.length>0){
											//summaryItem2=null;
											if(summaryItem2&&summaryItem2.refId!=sec2.id){
												summaryItem2=null;
											}						
											summaryItem1=null;
											summaryItem=null;
										}										
							
									}
					
								}
						}
						
					}
				}
			}
		}
		
		return allUls
	}
}
	getTotalSummary(){//console.log(this.summaryCategory)
		this.getAllCostTable();
		let allUls=this.getallsummaryItems();
		console.log(allUls)
		allUls.sort(function(a, b){
			return a[0].catIndex - b[0].catIndex;
		});
		this.toUL1(allUls);
	}
	toUL(allitems){console.log(allitems)
		let table1=this.getSecbyId(this.contents,'pca_summary_1');console.log(table1);
		table1.data.rows=[];
		let totalrow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].totalrow));    
		let catData=[];
		for(let item of allitems){
		  if(item[0].catIndex>-1){
			let index=catData.findIndex(group=>group.index==item[0].catIndex);
			if(index>-1){
			  catData[index].children.push(item)
			}else{
			  let sub={'index':item[0].catIndex, 'children':[item]};
			  catData.push(sub)
			}
		  }
		}  
		console.log(catData)
		for(let rowgroup of catData){
		  let firstrow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].firstrow));
		  firstrow[0].data=this.summaryCategory[rowgroup.index];
		  table1.data.rows.push(firstrow);
		  for(let row of rowgroup.children){
			let baserow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].baserow));
			for(let i=0; i<5; i++){
				if(row[i].inputType=='Checkmark'){
					baserow[i].data=row[i].data;
					//row[i].html=row[i].html;
				}else if(row[i].inputType=='text'||row[i].inputType=='option'){
					baserow[i].data=row[i].data;
					baserow[i].html=row[i].html;
					if(row[i].secHtml){
						baserow[i].secHtml=row[i].secHtml;
					}
					if(row[i].slots){
						baserow[i].slots=row[i].slots;
					}
					if(row[i].refId){
						baserow[i].refId=row[i].refId;
					}					
				}
			}						
			table1.data.rows.push(baserow);
		  }
		}  
		table1.data.rows.push(totalrow); 
		console.log(table1) 	
	  }
	  toUL1(allitems){//console.log(allitems)
		let table1=this.getSecbyId(this.contents,'pca_summary_1');//console.log(table1);
		let table2=this.getSecbyId(this.contents,'pca_summary_2');//console.log(table1);
		let table3=this.getSecbyId(this.contents,'pca_summary_3');//console.log(table1);
		table1.data.rows=[];
		let totalrow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].totalrow));    
		let catData=[];
		for(let item of allitems){
		  if(item[0].catIndex>-1){
			let index=catData.findIndex(group=>group.index==item[0].catIndex);
			if(index>-1){
			  catData[index].children.push(item)
			}else{
			  let sub={'index':item[0].catIndex, 'children':[item]};
			  catData.push(sub)
			}
		  }
		}  
		//console.log(catData)
		let allimmiunchek=true;
		let allshortuncheck=true;
		let totalImmidiate=0;
		let totalShort=0;
		let totalReserve=0;
		let totalInflated=0;
		let totalAllocate=[];
		let totalSelectedYear=0;
		for(let rowgroup of catData){
			let allSelectedYear=0;
			let firstrow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].firstrow));
			firstrow[0].data=this.summaryCategory[rowgroup.index];
			if(this.pcaOp.term=='Exclude'){
				firstrow[0]['colspan']=7;
			}else{
				firstrow[0]['colspan']=8;
			}
			table1.data.rows.push(firstrow);
			for(let row of rowgroup.children){
				let allSelectedYear=0;
				let baserow=JSON.parse(JSON.stringify(this.reportService.summaryTable[1].baserow));
				for(let i=0; i<row.length; i++){
					baserow[i].data=row[i].data;
					if(row[i].refId){
						baserow[i]['refId']=row[i].refId;
					}				
				}
			
				if(this.pcaOp.term=='Exclude'){
					baserow[6]['hide']=true;
				}else{
					baserow[6]['hide']=false;
				}
			
			/*baserow[0].data=row[0].SecRef+' '+row.Item;
			baserow[0]['refId']=row[0].id;
			baserow[1].data=row.Good;
			baserow[2].data=row.Fair;
			baserow[3].data=row.Poor;
			baserow[4].data=row.ACTION;
			baserow[1].html=row.Good;
			baserow[2].html=row.Fair;
			baserow[3].html=row.Poor;
			baserow[4].html=row.ACTION;*/
			if(row[0]['COSTS']&&row[0]['COSTS'].length>0){
			  let immi=0;
			  let short=0;
			  let immiunchek=true;
			  let shortuncheck=true;
			  let rowallocate=[];
				for(let items of row[0]['COSTS']){
					let index=this.costTables.findIndex(table=>table.id==items);//console.log(index)
					if(index>-1){
					let costIems=this.costTables[index].data.COST;
					if(costIems&&costIems.length>0){
						for(let item of costIems){//console.log(item)
							if(item.immiCHK){
								immi+=item.Immediate;
								if(immiunchek){
									immiunchek=false
									allimmiunchek=false;
								}
								
							}
						if(item.shortCHK){
							short+=item.Short;
							if(shortuncheck){
								shortuncheck=false;
								allshortuncheck=false;
							}
						}					  
						//reserve+=item.Reserve;
						rowallocate.push(item.allocate);
						totalAllocate.push(item.allocate);
						allSelectedYear+=item.selectedYear.reduce(function(acc, val) { return acc + val; }, 0);//console.log(allSelectedYear)
						totalSelectedYear+=allSelectedYear;
						}
					}
					
					}
				}
			  
			  
			  if(immiunchek){
				baserow[5].data='';
			  }else{
				baserow[5].data=this.getRound(immi,this.pcaOp.decimal).toString();
			  }
			  if(shortuncheck){
				baserow[6].data='';
			  }else{
				baserow[6].data=this.getRound(short,this.pcaOp.decimal).toString();
			  }
			  //console.log(allSelectedYear)
			  if(allSelectedYear>0){
				baserow[7].data=this.getTotalAllocate(rowallocate).toString();//reserve;
			  }else{
				baserow[7].data='';
			  }
			  
			  if(immi>0){
				totalImmidiate+=immi;
			  }
			  if(short){
				totalShort+=short;
			  }
			  totalReserve+=this.getTotalAllocate(rowallocate);//console.log(totalReserve)//baserow[7].data;//reserve;
			  totalInflated=this.getInflated(totalAllocate);//console.log(totalInflated)
			}
			table1.data.rows.push(baserow);
		  }
		}
		if(allimmiunchek){
			totalrow[1].data='';
		}else{
			totalrow[1].data=this.getRound(totalImmidiate,this.pcaOp.decimal).toString();
		}
		if(allshortuncheck){
			totalrow[2].data='';
		}else{
			totalrow[2].data=this.getRound(totalShort,this.pcaOp.decimal).toString();
		}
		//totalrow[1].data=this.getRound(totalImmidiate,this.pcaOp.decimal).toString();//totalImmidiate; 
		//totalrow[2].data=this.getRound(totalShort,this.pcaOp.decimal).toString();//totalShort;
		//console.log(totalSelectedYear)
		if(totalSelectedYear>0){
			totalrow[3].data=this.getRound(totalReserve,this.pcaOp.decimal).toString();//totalReserve;
		}else{
			totalrow[3].data='';
		}
		
		if(this.pcaOp.term=='Exclude'){
			totalrow[2]['hide']=true;
		}else{
			totalrow[2]['hide']=false;
		}
		table1.data.rows.push(totalrow);   
	   // console.log(this.summaryData[1])
		let table1row=table2.data.rows;
		if(allimmiunchek){
			table1row[0][1].data='';
			table1row[0][2].data='';
		}else{
			table1row[0][1].data=this.getRound(totalImmidiate,this.pcaOp.decimal).toString();//totalImmidiate;
			table1row[0][2].data=this.getRound(totalImmidiate/this.pcaOp.quantity,2).toFixed(2);
		}
		if(allshortuncheck){
			table1row[1][1].data='';
			table1row[1][2].data='';
		}else{
			table1row[1][1].data=this.getRound(totalShort,this.pcaOp.decimal).toString();//totalShort;
			table1row[1][2].data=this.getRound(totalShort/this.pcaOp.quantity,2).toFixed(2);
		}
		/*table1row[0][1].data=this.getRound(totalImmidiate,this.pcaOp.decimal).toString();//totalImmidiate;
		table1row[0][2].data=this.getRound(totalImmidiate/this.pcaOp.quantity,2).toFixed(2);
		table1row[1][1].data=this.getRound(totalShort,this.pcaOp.decimal).toString();//totalShort;
		table1row[1][2].data=this.getRound(totalShort/this.pcaOp.quantity,2).toFixed(2);*/
		if(this.pcaOp.term=='Exclude'){
			table1row[1][0]['rowhide']=true;
		}else{
			table1row[1][0]['rowhide']=false;
		}
		let table2row=table3.data.rows;
		if(totalSelectedYear>0){
			table2row[0][1].data=this.getRound(totalReserve,2);//totalReserve;
			table2row[0][2].data=this.getRound(totalReserve/this.pcaOp.quantity,2).toFixed(2);
			table2row[0][3].data=this.getRound(totalReserve/this.pcaOp.quantity/this.pcaOp.reserve,2).toFixed(2);
			table2row[1][1].data=totalInflated.toString();
			table2row[1][2].data=this.getRound(totalInflated/this.pcaOp.quantity,2).toFixed(2);
			table2row[1][3].data=this.getRound(totalInflated/this.pcaOp.quantity/this.pcaOp.reserve,2).toFixed(2);
		}else{
			table2row[0][1].data='';
			table2row[0][2].data='';
			table2row[0][3].data='';
			table2row[1][1].data='';
			table2row[1][2].data='';
			table2row[1][3].data='';
		}
			
		
	  }
	  getTotalAllocate(arrs){
		let total=0;
		if(arrs.length>0){
			for(let arr of arrs){//console.log(arr)
				if(arr.length>0){
					for(let item of arr){
						if(item>0){
							total+=item;
						}
					}
				}
				
			}
		}
		//console.log(total);
		total=this.getRound(total, this.pcaOp.decimal)
		return total

	}
	getAllCostTable(){//console.log(this.contents)
		this.costTables=[];
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						if(this.reportInfo.PCA_INDICATOR=='frm1105'){
							sec1['pre']=this.getPre(sec1.id)
						}						
						this.costTables.push(sec1)
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.TYPE=='COSTTABLE'){
								if(this.reportInfo.PCA_INDICATOR=='frm1105'){
									sec2['pre']=this.getPre(sec2.id)
								}	
								this.costTables.push(sec2)
							}
						}
					}
				}
			}
		}
		//console.log(this.costTables)
	}
	selCostCat(key, e, doc){
		let val=e.target.value;
		if(val.length>0){
			doc[key]=e.target.value;
		}else{
			if(doc[key]){
				delete doc[key];
			}
			
		}
		this.getTotalSummary();
		this.autoSave('modify', doc.id, doc.SECTION_TITLE,'O');	
	}
	/*catShow=false;
	catItems='';
	catInfo:any;*/
	//getCatItems(){
		//this.catInfo='';
		/*let inputJson={"PROCEDURE":"gettemplatesummarycategory","USER_ID":parseInt(this.userId),"TEMPLATE_ID":this.tempInfo.TEMPLATE_ID,};
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if (data.RESPONSE_STATUS=='N') {
				this.throwError(data)							
			}else{
				//this.summaryCategory=this.catItems.split(',');
			}		
		})*/
	//	this.catItems=this.summaryCategory.join(',');
	//}
	/*saveCategory(){console.log(this.catItems)
		this.loading=true;
		this.catInfo=null;
		let inputJson={"PROCEDURE":"updatereport", "USER_ID":parseInt(this.userId), 'REPORT_ID':this.curReport.REPORT_ID, "SUMMARY_CATEGORY":this.catItems};
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			this.loading=false;
			if (data.RESPONSE_STATUS=='N') {
				this.catInfo={'status':data.RESPONSE_STATUS, 'msg':'Summary Categories Update Failed!'}
				this.throwError(data)							
			}else{
				this.summaryCategory=data.SUMMARY_CATEGORY.split(',');
				this.catInfo={'status':data.RESPONSE_STATUS, 'msg':"Summary Categories Saved Successfully!"}
				
			}		
		})
	}
	addCatItem(){
		let ele='#'+'catItem';
		let text=$(ele).val();	
		if(text.trim().length>0){
			if(this.catItems.length>0){
				this.catItems+=',';
			}
			this.catItems+=text.trim();					
		}
		$(ele).val('');
	}
	addToCat(label){
		let ele='#'+'catItem';
		$(ele).val(label);	
	}
	removeCatItem(index){
		let cats=this.catItems.split(',');
		cats.splice(index, 1);
		this.catItems=cats.join(',');
		console.log(this.catItems);
	}
	
	
	toSummarySec(costItem){console.log(costItem)
		this.getTotalSummary();
	};
	
	addToSummary(e, doc){console.log(e, doc)
		doc.summaryData=JSON.parse(JSON.stringify(e));
		let that=this;
		this.curId=doc.id;
		this.listid=doc.id;
		setTimeout(() => {
			that.autoSave('modify',doc.id, doc.SECTION_TITLE, 'O');
		}, 3000);
		
	}*/
	getPre(id){
		let index=this.getIdIndex(id);
		let index1=index[0];
		let index2=index[1];
		let index3=index[2];
		let dest:any;
		if(this.contents&&index3&&index3>-1){
			for(let i=index3; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[index2]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1]&&this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1].DISPLAY_SEQUENCE=='Y'){
					let item=this.contents[index1].SUB_SECTIONS[index2].SUB_SECTIONS[i-1];
					dest={'id':item.id, 'SECTION_SEQUENCE':item.SECTION_SEQUENCE,'SECTION_TITLE':item.SECTION_TITLE,}
					break;
				}
			}
		}
		if(!dest){
			for(let i=index2; i>-1; i--){
				if(this.contents[index1].SUB_SECTIONS[i]&&this.contents[index1].SUB_SECTIONS[i].DISPLAY_SEQUENCE=='Y'){
					let item=this.contents[index1].SUB_SECTIONS[i]
					dest={'id':item.id, 'SECTION_SEQUENCE':item.SECTION_SEQUENCE,'SECTION_TITLE':item.SECTION_TITLE,}
					break;
				}
			}
			if(!dest){
				for(let i=index1; i>-1; i--){
					if(this.contents[i].DISPLAY_SEQUENCE=='Y'){
						let item=this.contents[i];
						dest={'id':item.id, 'SECTION_SEQUENCE':item.SECTION_SEQUENCE,'SECTION_TITLE':item.SECTION_TITLE,}
						break;
					}
				}
			}
		}
				
		return dest;
	
	}
	removePISummay(){
		if(this.summaryType=='PHASE I'){
			delete this.curSec.pisummarydata;
			this.toTatalPISummary();
		}else if(this.summaryType=='PCA'){
			delete this.curSec.pcasummarydata;
			this.getTotalSummary();
		}
		this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, 'O');
	}
	catReq:string;
	savePISummay(){
		if(this.summaryType=='PHASE I'){
			this.curSec['pisummarydata']=JSON.parse(JSON.stringify(this.picurSummary));
			this.toTatalPISummary();
			this.psShow=false;			
		}else if(this.summaryType=='PCA'){
			this.catReq='';
			if(this.pcacurSummary[0]['cat']&&this.pcacurSummary[0]['cat'].length>0){
				if(this.pcacurSummary[4]['ACTION']){
					let action='';
					for(let item of this.pcacurSummary[4]['ACTION']){
						if(action.length>0){
							action+=', '+item;
						}else{
							action=item;
						}
					}
					this.pcacurSummary[4]['data']=action;
				}
			
				
				this.curSec['pcasummarydata']=JSON.parse(JSON.stringify(this.pcacurSummary));
				this.getTotalSummary();
				this.psShow=false;
			}else{
				this.catReq='Category is required!'
			}
			
		}
		console.log(this.curSec);
		this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, 'O');
	}
	toTatalPISummary(){
		let summarytable=this.getSecbyId(this.contents,'phaseI_project_summary_table');
		if(!summarytable){
			summarytable=this.getSecbyId(this.frontpages,'phaseI_project_summary_table');
		}
		summarytable.data.rows=[];
		
		let cols=summarytable.data.cols; //console.log(cols)
		for(let doc of this.contents){
			if(doc.pisummarydata&&doc.pisummarydata[0]['refId']){
				let row=[];
				doc.pisummarydata[0].data=doc.SECTION_SEQUENCE+' '+doc.SECTION_TITLE;
				for(let i=0; i<cols.length; i++){
					let item={'COLUMNINTERNALNAME': 'col'+i, 'data': doc.pisummarydata[i].data, 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
					if(doc.pisummarydata[i]['refId']){
						item['refId']=doc.pisummarydata[i]['refId'];
					}
					if(doc.pisummarydata[i]['slots']){
						item['slots']=doc.pisummarydata[i]['slots'];
					}
					if(doc.pisummarydata[i]['html']){
						item['html']=doc.pisummarydata[i]['html'];
					}
					if(doc.pisummarydata[i]['secHtml']){
						item['secHtml']=doc.pisummarydata[i]['secHtml'];
					}
					row.push(item);
				}
				summarytable.data.rows.push(row);
			}
			if(doc.SUB_SECTIONS&&doc.SUB_SECTIONS.length>0){
				for(let doc1 of doc.SUB_SECTIONS){
					if(doc1.pisummarydata&&doc1.pisummarydata[0]['refId']){
						let row1=[];
						doc1.pisummarydata[0].data=doc1.SECTION_SEQUENCE+' '+doc1.SECTION_TITLE;
						for(let j=0; j<cols.length; j++){
							let item={'COLUMNINTERNALNAME': 'col'+j, 'data': doc1.pisummarydata[j].data, 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
							if(doc1.pisummarydata[j]['refId']){
								item['refId']=doc1.pisummarydata[j]['refId'];
							}
							if(doc1.pisummarydata[j]['slots']){
								item['slots']=doc1.pisummarydata[j]['slots'];
							}
							if(doc1.pisummarydata[j]['html']){
								item['html']=doc1.pisummarydata[j]['html'];
							}
							if(doc1.pisummarydata[j]['secHtml']){
								item['secHtml']=doc1.pisummarydata[j]['secHtml'];
							}
							row1.push(item);
						}
						summarytable.data.rows.push(row1);
					}

					if(doc1.SUB_SECTIONS&&doc1.SUB_SECTIONS.length>0){
						for(let doc2 of doc1.SUB_SECTIONS){
							if(doc2.pisummarydata&&doc2.pisummarydata[0]['refId']){
								let row2=[];
								doc2.pisummarydata[0].data=doc2.SECTION_SEQUENCE+' '+doc2.SECTION_TITLE;
								for(let k=0; k<cols.length; k++){
									let item={'COLUMNINTERNALNAME': 'col'+k, 'data': doc2.pisummarydata[k].data, 'KEY': '', 'bk':'none', 'weight':'normal', 'border':'1px solid black'};
									if(doc2.pisummarydata[k]['refId']){
										item['refId']=doc2.pisummarydata[k]['refId'];
									}
									if(doc2.pisummarydata[k]['slots']){
										item['slots']=doc2.pisummarydata[k]['slots'];
									}
									if(doc2.pisummarydata[k]['html']){
										item['html']=doc2.pisummarydata[k]['html'];
									}
									if(doc2.pisummarydata[k]['secHtml']){
										item['secHtml']=doc2.pisummarydata[k]['secHtml'];
									}
									row2.push(item);
								}
								summarytable.data.rows.push(row2);
							}
						}
					}

				}
				
			}
		}
		//console.log(summarytable.data.rows);
		
	}
	/*addPICol(e, col?){
		if(col){
			this.summaryCols.push(col)
		}else{
			let ele='#'+'scolInput';
			let text=$(ele).val().trim();//console.log(text);
			if(text.length>0){
				this.summaryCols.push(text);
				$(ele).val('');
			}
		}
		this.summaryColsType.push('text');	
	}
	removeSummaryCol(index){
		this.summaryCols.splice(index, 1);
		this.summaryColsType.splice(index, 1);
	}
	
	addColType(e, i){
		this.summaryColsType[i]=e.target.value;
	}*/
	pisummaryShow=false;
	picurSummary=[];
	picurcol:any;
	psShow=false;
	pcacurSummary=[];
	pcaSummaryCols=[];
	editPs(doc){console.log(this.summaryCols, this.summaryColsType)
		this.curSec=doc;
		if(this.summaryStatus&&this.summaryType=='PCA'){
			if(doc.pcasummarydata){
				this.pcacurSummary=JSON.parse(JSON.stringify(doc.pcasummarydata));
			}else{
				this.pcacurSummary=[{'col':'Project Summary Category','data':doc.SECTION_SEQUENCE+" "+doc.SECTION_TITLE, 'refId':doc.id, 'inputType':'option', 'cat':''}]
					for(let col of this.pcaSummaryCols){
						let item:any;
						if(col.Type=='text'){
							item={'data':'', 'html':'', 'secHtml':null, 'col':col.Name, 'inputType':col.Type, 'slots':[]};				
						}else if(col.Type=='option'){				
							item={'data':'', 'col':col.Name, 'inputType':col.Type, 'ops':this.reportService.actionItemOps, 'ACTION':[]};
						}else{				
							item={'data':'', 'col':col.Name, 'inputType':col.Type};
						}
						this.pcacurSummary.push(item);
					}
				console.log(this.pcacurSummary);
			}
		}else{
			if(doc.pisummarydata){
				this.picurSummary=JSON.parse(JSON.stringify(doc.pisummarydata));
			}else{
				this.picurSummary=[{'col':'Report Section','data':doc.SECTION_SEQUENCE+" "+doc.SECTION_TITLE, 'refId':doc.id, 'inputType':'text'}]
				for(let i=1; i<this.summaryCols.length; i++){
					let item:any;
					if(this.summaryColsType[i]=='RF'){
						item={'data':'', 'html':'', 'secHtml':null, 'col':this.summaryCols[i], 'inputType':this.summaryColsType[i], 'slots':[]};				
					}else{				
						item={'data':'', 'col':this.summaryCols[i], 'inputType':this.summaryColsType[i]};
					}
					this.picurSummary.push(item);
				}
			}
			console.log(this.picurSummary)
		}

		this.catReq='';
		this.psShow=true;
	}
	picurSummaryItem:any
	toSummaryEdit(doc, col){
		this.picurSummaryItem=doc;
		this.pisummaryShow=true;
		this.picurcol=col;		
	}
	pisummaryData(e){
		if(e.length>0){
			this.picurSummaryItem['html']=e;
			this.picurSummaryItem['secHtml']=this.sanitizer.bypassSecurityTrustHtml(e);
			this.picurSummaryItem['slots']=this.getAllSlotId(e)
		}else{
			this.picurSummaryItem['html']='';
			this.picurSummaryItem['secHtml']=null;
			this.picurSummaryItem['slots']=[];
		}			
	}
	pisummaryText(e){
		if(e.length>0){
			this.picurSummaryItem['data']=e;
		}else{
			this.picurSummaryItem['data']='';
		}		
	}
	changeOpItem(type?){console.log(this.pcaOp.inflation)
		let data1=this.getSecbyId(this.contents, 'pca_summary_2');
		let data2=this.getSecbyId(this.contents, 'pca_summary_3');
		let data='Replacement Reserves, w/'+this.pcaOp.reserve+' year, '+this.pcaOp.inflation.toString()+'% escalation';
		let header1='$/'+this.pcaOp.multiplier;
		let header2='$/'+this.pcaOp.multiplier+'/Year';
		data2.data.rows[0][0].data='Replacement Reserves';
		data2.data.rows[1][0].data=data;
		data1.data.cols[2].NAME=header1;
		data2.data.cols[2].NAME=header1;
		data2.data.cols[3].NAME=header2;		
	  }
	  addActionItem(item){
		let ele='#'+'actionItem';
		let text=$(ele).val().trim();	
		if(text.length>0){
			item.ACTION.push(text);			
		}
		$(ele).val('');
	}
	addToAction(label){
		this.pcacurSummary[4].ACTION.push(label);
	}
	removeActionItem(index){
		this.pcacurSummary[4].ACTION.splice(index, 1);
	}
	getInflated(allItems){//console.log(allItems)
		let yearRate=this.pcaOp.inflation/100;
		let total=0;
		let allsum=[];
		   for(let items of allItems){
			for(let i=0; i<items.length; i++){//console.log(items[i])
			  if(isNaN(allsum[i])){
				allsum[i]=0
			  }
			  if(items[i]>0){
				allsum[i]+=items[i];
			  }
			  
			}
		  }
		 //console.log(allsum);
		  	let rate=1
			for(let i=0; i<this.pcaOp.reserve; i++){
				
			  if(i==0){
				total=allsum[0];
			  }else{
				if(allsum[i]>=0){
				  rate=this.getRound(rate*(1+yearRate),3);//console.log(rate);
				  //let value1=this.getRound(Math.pow((1+yearRate), i),3);//this.getRound(Math.pow((1+yearRate), i),3);console.log(i, value1);
				  //let value=allsum[i]*rate;console.log(value);
				  let value2=this.getRound(allsum[i]*rate, this.pcaOp.decimal);//console.log(value2)
				 total+=value2;
			   }
			  
			  
			}
		  }
		  total=this.getRound(total,this.pcaOp.decimal); //console.log(total)
		return total
	  }
	  changeCostFactor(no, type?){//console.log(no, type)
		if(type){
			if(no>0){
				if(!Number.isInteger(no)){
					this.rowItem[type]=Math.ceil(no);
				}
				
			}else{
				this.rowItem[type]=1;
			}
		}else{
			no.target.value=this.getRound(this.rowItem.EUL-this.rowItem.EFF, 0);
			//this.rowItem.RUL=this.getRound(this.rowItem.EUL-this.rowItem.EFF, 0);
		}
			
			
	}
	initEris(doc){
		this.erisCheck=true;
		let inputJson={
			"PROCEDURE": "checkslotreport",
			"USER_ID": parseInt(this.userId),
			"REPORT_ID": this.curReport.REPORT_ID,
			"SLOT_ID": doc.data.SLOT_ID.toString(),
			"ORDER_NUM": this.reportInfo.ORDER_NUM,
			"REPORT_SECTION_ID": doc.id,
			"DETAILS_LIST": doc.data.rows,			
		}
		console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			this.erisCheck=false;
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)								
			}else{

			}
		})
	}
	erisShow=false;
	showHidden=false;
	erisCols=[];
	curEris:any;
	curErisData:any;
	erispage=1;
	curerispage=1;
	erisstart=0;
	erisend=50;
	erisCheck=false;
	modifyEris(doc){
		this.showHidden=false;
		this.curEris=doc; //JSON.parse(JSON.stringify(doc));
		this.curErisData=this.curEris.data;console.log(this.curErisData)
		this.initEris(doc);
		this.erisCols = this.curEris.data.cols;
		this.erispage=Math.ceil(this.curErisData.rows.length/50);
		this.erisShow=true;
		this.erisstart=0;
		this.erisend=50;
		this.curerispage=1;
		this.filterData=this.curEris.data?.filters;
		this.filterSlot=this.curEris.data.SLOT_ID.toString();
		//this.filterShow=true;
		this.addBefore=false;
		this.selectedRow=-1;
		this.selectedFilters=this.getContentData('selectedFilters');
		if(!this.selectedFilters){
			this.selectedFilters=[];
			if(this.curEris.data.filters&&this.curEris.data?.filters.length>0){
				for(let filter of this.curEris.data?.filters){
					let chked=[];
					for(let item of filter.FILTER_ITEM){
						if(item.CHECKED=='Y'){
							chked.push(item);
						}
					}
					this.selectedFilters.push(chked);
				}
			}
			
		}			
	}
	resetTableModify(doc){
		this.curCell=null;
		this.curCol=null;
		//this.curCap=null;
		this.selectedHeaderType
		this.curHeader
		this.selectedHeaderType='';
   		this.selectedHRow=-1;
		this.preCell={'row':0,'col':0};
		if(doc.data){
			for(let row of doc.data.rows){
				if(row.selected){
					delete row.selected;
				}
			}
		}
	}
	tableShow=false;
	preCell:any;
	modifyTable(doc){console.log(doc);
		this.resetTableModify(doc);
		this.curSec=doc;
		this.pageIndex=this.getFrontIdIndex(doc.id);//console.log('first',this.pageIndex);
		this.curIndex=this.getIdIndex(doc.id);//console.log('first',this.curIndex)
		this.tableShow=true;
		this.addHBefore=false;
		let that=this;
		//setTimeout(() => {
		//	this.hotkeyIcon.nativeElement.click();
		//},1000)
		//this.selectCell(doc, 0, doc.data.cols[0], doc.data.rows[0].items[0]);		
	}
	naviCell(e){
		//console.log(e);
		const container = this.edittableContainer.nativeElement; 
		const editrows= $(".editrow");//console.log(editrows)
		const h=editrows[this.preCell.row].offsetHeight+2; //console.log(h)		
		this.curCell=null;
		let rows=this.curSec.data.rows.length-1;
		let cols=this.curSec.data.cols.length-1;
		if(e=='ArrowDown'&&this.preCell.row<rows){
			this.preCell.row++;
			if(this.curSec.data.rows[this.preCell.row].items[0].colspan){
				this.preCell.col=0;
			}
			if(this.preCell.row>1){							
				if(container){
					container.scrollBy({ top: h, behavior: 'smooth' }); // Scrolls down by 100 pixels
				}				
			}
		}
		if(e=='ArrowRight'){
			if(this.preCell.col<cols){
				if(!this.curSec.data.rows[this.preCell.row].items[0].colspan){
					this.preCell.col++;
				}
			}else if(this.preCell.col==cols&&this.preCell.row<rows){
				this.preCell.row++;
				this.preCell.col=0;
			}			
		}
		if(e=='ArrowUp'&&this.preCell.row>0){
			this.preCell.row--;
			if(this.curSec.data.rows[this.preCell.row].items[0].colspan){
				this.preCell.col=0;
			}
			if(this.preCell.row>1){	
				const h1=editrows[this.preCell.row-1].offsetHeight-2; 				
				if(container){
					container.scrollBy({ top: -h1, behavior: 'smooth' }); // Scrolls down by 100 pixels
				}
				
			}
		}
		if(e=='ArrowLeft'&&this.preCell.col>0){
			this.preCell.col--;
		}
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];
		let col=this.curSec.data.cols[this.preCell.col];
		//this.selectCell(this.curSec, this.preCell.row, col, cell);
	}
	shortCut(type){
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];console.log(cell)
		switch(type) {
			case 'c':
				this.copyCell(cell);
			 	break;
			case 'v':
				this.pasteCell(cell);
			  	break;
			case 'm':
				this.addCheckmark(cell);
			  	break;
			case ' ':
				this.clearCheckmark(cell);
			  	break;
			default:
			  // code block
		}
	}
	editCell(){
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];console.log(cell)
		let col=this.curSec.data.cols[this.preCell.col];console.log(col)
		this.selectCell(this.curSec, this.preCell.row, col, cell);
	}
	toNextCell(){
		this.curCell=null;
		let rows=this.curSec.data.rows.length-1;
		let cols=this.curSec.data.cols.length-1;
		if(this.preCell.col<cols){
			this.preCell.col++;
		}else if(this.preCell.col==cols&&this.preCell.row<rows){
			this.preCell.row++;
			this.preCell.col=0;
		}
		let cell=this.curSec.data.rows[this.preCell.row].items[this.preCell.col];
		let col=this.curSec.data.cols[this.preCell.col];
		this.selectCell(this.curSec, this.preCell.row, col, cell);
	}
	toEditCell(doc, index, col, cell){//console.log(cell)
		if(!cell['colspan']&&col['lock']){
			//Swal.fire('Column is locked, can not edit');
			return
		}
		/*if(doc.data['locked']&&doc.data['locked']['row'].indexOf(index)>-1){
			Swal.fire('Row is locked, can not edit');
			return
		}*/
		if(doc.data&&doc.data.rows[index]&&doc.data.rows[index]['lock']){
			//Swal.fire('Row is locked, can not edit');
			return
		}
		if(this.curCell&&(index!=this.selectedCell.row!=index||this.selectedCell.col!=col)){
			$('#overlay2').css('display','block');
				this.saveCell(doc);
				//this.toCell(doc)
				//this.zone.run(()=>{
				setTimeout(() => {		console.log(this.curCell)	
					this.selectCell(doc, index, col, cell)
					$('#overlay2').css('display','none');
				}, 500);	
			//})
		}else{
			this.selectCell(doc, index, col, cell)
		}
		/*setTimeout(() => {
			this.hotkeyIcon.nativeElement.click();
		},1000)*/
	}
	getPageData(pageNo){
		this.erisstart=pageNo*50;
		this.erisend=pageNo*50+50;
		this.curerispage=pageNo+1;			
	}
	items: any[] = [];
    pageOfItems?: Array<any>;
    sortProperty: string = 'id';
    sortOrder = 1;
    sortBy(col) {
		this.erisCheck=true;
		let rows=this.curErisData.rows;
        this.sortOrder = col.INTERNALNAME === this.sortProperty ? (this.sortOrder * -1) : 1;console.log(this.sortOrder)
        this.sortProperty = col.INTERNALNAME;console.log(this.sortProperty);
		let order=this.sortOrder>0?'DESC':'ASC';
       	let inputJson={
			'PROCEDURE': 'sortslotreport',
			'USER_ID': parseInt(this.userId),
			'REPORT_ID': this.curReport.REPORT_ID,
			'SLOT_ID': this.curErisData.SLOT_ID.toString(),
			'ORDER_NUM': this.reportInfo.ORDER_NUM,			
			'SORTING': [{'INTERNALNAME': col.INTERNALNAME,'DISPLAY_NAME': col.NAME,'ORDER': order}],
			'REPORT_SECTION_ID':this.curEris.id,
			'SHOW_HIDDEN_RECORD':this.showHidden?'Y':'N',
		}
		console.log(JSON.stringify(inputJson))
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			this.erisCheck=false;
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				let arr=[];
				if(response.rows&&response.rows.length>0){
					for(let row of response.rows){
						let arr1=[];
						for(let col of this.curErisData.cols){
							let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
							if(col.INTERNALNAME=='ES_RID'){
								row[index]['hide']=true;
							}
							arr1.push(row[index]);
						}
						arr.push(arr1);
					}
				}
				
				this.curErisData.rows=arr; 
				this.saveErisRecord(arr);					
			}
		})
    }

    sortIcon(property: string) {
        if (property === this.sortProperty) {
            //return this.sortOrder === 1 ? '☝️' : '👇';
			return this.sortOrder === 1 ? '⬆️' : '⬇️';
        }
        return '⇅';
    }
	/*erismoveUp(index){
		this.selectedRow=(this.curerispage-1)*50+index;
		let rows=this.curErisData.rows;
		if(this.selectedRow>0){
			this.array_move(rows,this.selectedRow, this.selectedRow-1 );
			this.selectedRow-=1;
		}
		this.saveErisRecord(rows);		
	}
	erismoveDown(index){
		this.selectedRow=(this.curerispage-1)*50+index;
		let rows=this.curErisData.rows;
		if(this.selectedRow<(rows.length-1)){
			this.array_move(rows,this.selectedRow, this.selectedRow+1 );
			this.selectedRow+=1;
		}
		this.saveErisRecord(rows);	
	}*/	
	deleteerisRow(index, id){
		//this.selectedRow=(this.curerispage-1)*50+index;console.log(this.selectedRow)
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: async () => {
				let rows=this.curErisData.rows;
				let inputJson=	{
					'PROCEDURE':'deleteSlotReportRecord',
					'USER_ID':parseInt(this.userId),
					'REPORT_ID':this.curReport.REPORT_ID,
					'SLOT_ID':this.curErisData.SLOT_ID.toString(),
					'ORDER_NUM':this.reportInfo.ORDER_NUM,
					'ES_RID':id.toString(),
					'REPORT_SECTION_ID':this.curEris.id
					}
					console.log(JSON.stringify(inputJson))
					this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
						console.log(response);
						if (response.RESPONSE_STATUS=='N') {
							this.throwError(response)											
						}else{
							rows.splice((this.curerispage-1)*50+index,1);
							this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);
							
						}
					})
				
			}
		})	
			
	}
	
	hideerisRow(cell, index){console.log(cell.HIDDEN_FLAG, index)
		let inputJson={
			'PROCEDURE':'hideSlotReportRecord',
			'USER_ID':parseInt(this.userId),
			'REPORT_ID':this.curReport.REPORT_ID,
			'SLOT_ID':this.curErisData.SLOT_ID.toString(),
			'ORDER_NUM':this.reportInfo.ORDER_NUM,
			'ES_RID':cell.DATA,
			'HIDDEN_FLAG':cell.HIDDEN_FLAG!='Y'?'Y': 'N',
			'REPORT_SECTION_ID':this.curEris.id
		}	
		console.log(inputJson)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				if(cell.HIDDEN_FLAG=='Y'){
					cell.HIDDEN_FLAG='N';		
				}else{
					cell.HIDDEN_FLAG='Y';
					if(!this.showHidden){
						this.curErisData.rows.splice((this.curerispage-1)*50+index, 1);	
					}
					
				}
				this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);		
			}
		})
	}
	addErisRows(e, index, id){console.log(this.curerispage)
		let no=$(e.target).prevAll('input').val(); //console.log($(e.target).prev('input'));//console.log(no);
		//this.selectedRow=(this.curerispage-1)*50+index; console.log(this.selectedRow)
		let rows=[];
			if(no>0){
				let data=this.curErisData;
				for(let i=0; i<no; i++){
					let row=[]
					for(let j=0; j<data.cols.length; j++){
						let item={'COLUMNINTERNALNAME':'','DATA':''};
						item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
						if(data.cols[j].DefaultFO&&data.cols[j].DefaultFO.html){
							item.DATA=data.cols[j].DefaultFO.data
							item['HTML']=data.cols[j].DefaultFO.html;
							item['SEC']=data.cols[j].DefaultFO['secHtml'];
							item['slots']=data.cols[j].DefaultFO.slots;
							//console.log(item)
						}					
						row.push(item);
					}
					//row[0]['hide']=true;console.log(row)
					row[0]['SUBHEADER']="N";console.log(row)
					row[0]['HIDDEN_FLAG']="N";console.log(row)
					rows.push(row);
					/*if(this.selectedRow>-1){
						if(this.addBefore){
							data.rows.splice(this.selectedRow,0,row);
							this.selectedRow+=1;
						}else{
							data.rows.splice(this.selectedRow+1,0,row);
						}
					}else{
						data.rows.push(row);
					}*/					
				}
			}
		this.insertErisRow(rows, this.addBefore, id, index);	
	}
	insertErisRow(row, posi, id, index){//console.log(posi)
		let inputJson={'PROCEDURE':'insertSlotReportRecord',
			'USER_ID':parseInt(this.userId),
			'REPORT_ID':this.curReport.REPORT_ID,
			'SLOT_ID':this.curErisData.SLOT_ID.toString(),
			'ORDER_NUM':this.reportInfo.ORDER_NUM,
			"BASE_ES_RID":id,
			'REPORT_SECTION_ID':this.curEris.id,
			'DETAILS_LIST':row,//no id field
			"INSERT_POSITION":posi?"ABOVE":"BELOW",
		};
		//console.log(JSON.stringify(inputJson))
		index=(this.curerispage-1)*50+index;console.log(index)
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				for(let added of response.DETAILS_LIST){
					added[0]['hide']=true;
					if(posi){
						this.curErisData.rows.splice(index, 0, added);
						index++	
					}else{
						if(index+1==this.curErisData.rows.length){
							this.curErisData.rows.push(added)
						}else{
							this.curErisData.rows.splice(index+1, 0, added);
							index++	
						}
						
					}
					
				}
				this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);
			}
		})
	}
	addErisSub(e, index, id){console.log()
		let posi=$(e.target).prev('select').val();console.log(posi)
		
			let data=this.curErisData;
			let row=[]
					for(let j=0; j<data.cols.length; j++){
						let item={'COLUMNINTERNALNAME':'','DATA':''};
						item.COLUMNINTERNALNAME=data.cols[j].INTERNALNAME;
						row.push(item);
					}
					//row[0]['hide']=true;console.log(row)
					row[0]['SUBHEADER']="Y";console.log(row)
					row[0]['HIDDEN_FLAG']="N";console.log(row)
					row[0]['celAllign']=posi;console.log(row)
					this.insertErisRow([row], this.addBefore, id, index);
			
	}
	updateEirsRecord(row){console.log(row)
		let details=JSON.parse(JSON.stringify(row));
		//details.splice(0,1);
		let inputJson={'PROCEDURE':'updateSlotReportRecord',
			'USER_ID':parseInt(this.userId),
			'REPORT_ID':this.curReport.REPORT_ID,
			'SLOT_ID':this.curErisData.SLOT_ID.toString(),
			'ORDER_NUM':this.reportInfo.ORDER_NUM,
			'ES_RID':row[0].DATA,
			'REPORT_SECTION_ID':this.curEris.id,
			'DETAIL':details//.splice(0,1),//without id
		}
		//console.log(JSON.stringify(inputJson))
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);	
			}
		})
	}
	saveErisRecord(rows){
		this.selectedCell=null;
		let inputJson={'PROCEDURE':'saveSlotReportRecords',
			'USER_ID':parseInt(this.userId),
			'REPORT_ID':this.curReport.REPORT_ID,
			'SLOT_ID':this.curErisData.SLOT_ID.toString(),
			'ORDER_NUM':this.reportInfo.ORDER_NUM,
			'REPORT_SECTION_ID':this.curEris.id,
			'DETAILS_LIST':rows,
        }
		
		//console.log(inputJson)
		//console.log(JSON.stringify(inputJson))
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				
				this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);	
			}
		})
	}
	saveErisEdit(){
		console.log(this.curErisData);
		this.selectedCell=null;
		let iftc=this.curEris['tcflag']?'Y':'N';
		this.updateErisTable(this.curEris.id, iftc);
	}
	
	resetErisFilter(){console.log(this.filterData)
		let inputJson={'PROCEDURE':'filterslotreport',
				'USER_ID':parseInt(this.userId),
				'REPORT_ID':this.curReport.REPORT_ID,
				'SLOT_ID':this.filterSlot,
				'ORDER_NUM':this.reportInfo.ORDER_NUM,
				'FILTER':this.curErisData.filters,
				'REPORT_SECTION_ID':this.curEris.id,
				'SHOW_HIDDEN_RECORD':this.showHidden?'Y':'N',
			}
		console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)								
			}else{
				this.curErisData.rows=[];
				let arr=[]
				for(let row of data.rows){
					let arr1=[];
					for(let col of this.curErisData.cols){
						let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
						if(col.INTERNALNAME=='ES_RID'){
							row[index]['hide']=true;
						}
						arr1.push(row[index]);
					}
					arr.push(arr1);
				}
				this.curErisData.rows=arr;
				this.selectedFilters=[];
				if(data.filters&&data.filters.length>0){
					for(let filter of data.filters){
						let chked=[];
						for(let item of filter.FILTER_ITEM){
							if(item.CHECKED=='Y'){
								chked.push(item);
							}
						}
						this.selectedFilters.push(chked);
					}
				}
				this.filterData=JSON.parse(JSON.stringify(data.filters));
				this.toContentData('selectedFilters', this.selectedFilters, '');
				this.filtering=false;
				this.erispage=Math.ceil(arr.length/50);
				this.erisstart=0;
				this.erisend=50;
				this.getPageData(0);
				this.autoSave('erisDataUpdate', this.curEris.id, this.curEris.SECTION_TITLE);
			}
		})	
		
	}
	resetErisTable(){
		Swal.fire({
			icon:'warning',
			html: '<b>WARNING:</b> Resetting this ERIS table will erase all edits previously made, including comments and filters.',
			confirmButtonText: 'Continue to Reset',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
		preConfirm: () => {
			this.erisCheck=true;
		let inputJson={'PROCEDURE':'resetSlotReport','USER_ID':parseInt(this.userId),'REPORT_ID':this.curReport.REPORT_ID,'SLOT_ID':this.curErisData.SLOT_ID,'ORDER_NUM':this.reportInfo.ORDER_NUM,'REPORT_SECTION_ID':this.curEris.id};
		console.log(JSON.stringify(inputJson))
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			this.erisCheck=false;
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				this.filterData=JSON.parse(JSON.stringify(response.filters));
				this.selectedFilters=[];
				this.selectedCell=null;
				if(response.filters&&response.filters.length>0){
					for(let filter of response.filters){
						let chked=[];
						for(let item of filter.FILTER_ITEM){
							if(item.CHECKED=='Y'){
								chked.push(item);
							}
						}
						this.selectedFilters.push(chked);
					}
				}
				this.curEris.cols=response.headers;
				this.curEris.displaying=response.displaying;
				this.curEris.total=response.total;
				this.curEris.totalPages=response.total_pages;
				let arr=[]
				if(response.rows&&response.rows.length>0){
					for(let row of response.rows){
						let arr1=[];
						for(let col of this.curErisData.cols){
							let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
							if(col.INTERNALNAME=='ES_RID'){
								row[index]['hide']=true;
							}
							arr1.push(row[index]);
						}
						arr.push(arr1);
					}
				}
				this.curErisData.rows=arr; 
				this.erispage=Math.ceil(arr.length/50);
				this.erisstart=0;
				this.erisend=50;
				this.getPageData(0);	
				//console.log(this.filterData, this.curErisData)
				this.toContentData('selectedFilters', this.selectedFilters, '');
				this.autoSave("erisDataUpdate", this.curEris.id, this.curEris.SECTION_TITLE);			
			}
		})
	}})
	}
	curErisCell:any;
	curErisCol:any;
	erisCellShow=false;
	tempHtml:string;
	tempText:string;
	tempSecHtml:any;
	tempComms=[];
	tempSuggestions=[];
	tempUsers=[];
	selectErisCell(cell, i, j){
		this.cellsaveErr=false;
		this.erisCellShow=true;
		this.curErisCol=this.curErisData.cols[j];
		this.curErisCell=cell;
		this.curCellBK=JSON.parse(JSON.stringify(cell))
		if(cell['tcusers']){
			this.tempUsers=cell['tcusers']
		}else{
			this.tempUsers=[];
		}
		if(cell['suggestions']){
			this.tempSuggestions=cell['suggestions']
		}else{
			this.tempSuggestions=[];
		}
		if(cell['comments']){
			this.tempComms=cell['comments']
		}else{
			this.tempComms=[]
		}
		if(cell.HTML){
			this.tempHtml=cell.HTML;
		}else{
			this.tempHtml=cell.DATA;
		}
		this.allRow=false;
		this.allCol=false;
		let x=i;
		let y=j;//this.curErisData.cols.findIndex(data=>data.INTERNALNAME==cell.COLUMNINTERNALNAME);
		this.selectedCell={'row':x,'col':y}; console.log(this.selectedCell);
	}
	closeErisCell(){
		setTimeout(() => {
			let id=this.curEris.id;
			if(this.curCellBK['tcusers']){
				let item={'html':'', 'text':'', 'tcusers':[], 'suggestions':[], 'comments':[]};
				if(this.curCellBK['NAME']){
					item['html']=this.curCellBK['NAME']
				}
				if(this.curCellBK['text']){
					item['text']=this.curCellBK['text'];
				}
				if(this.curCellBK['tcusers']){
					item['tcusers']=this.curCellBK['tcusers'];
				}
				if(this.curCellBK['suggestions']){
					item['suggestions']=this.curCellBK['suggestions'];
				}
				if(this.curCellBK['comments']){
					item['comments']=this.curCellBK['comments'];
				}
				this.erisCellSuggest(item, id)
				//this.curEris.tcflag=true;
			}else{
				let text="";
				if(this.curCellBK['htmltext']){
					text=this.curCellBK['htmltext']
				}	
				this.erisCellHtml(text);
				//this.checkTc(this.curEris, 'eris')
			}			
			//this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);
			this.curCellBK=null;
			}, 200);
	}
	cellsaveErr=false;
	toErisCell(){
		//console.log(this.selectedCell)
		this.cellsaveErr=false;
		try{
			setTimeout(() => {
			if(this.tempHtml!=this.tempSecHtml['changingThisBreaksApplicationSecurity']){
				this.cellsaveErr=true;
				return
			}
			let x=(this.curerispage-1)*50+this.selectedCell.row;
			let y=this.selectedCell.col;
			let cell=this.curErisData.rows[x][y];
			cell['DATA']=this.tempText;
			cell['HTML']=this.tempHtml;
			cell['SEC']=this.tempSecHtml;	
			if(this.tempUsers&&this.tempUsers.length>0){
				cell['suggestions']=this.tempSuggestions;	
				cell['comments']=this.tempComms;
				cell['tcusers']=this.tempUsers;					
			}else{
				delete cell['suggestions'];	
				delete cell['comments'];
				delete cell['tcusers'];					
			}
			if(cell['suggestions']&&cell['suggestions'].length>0){
				this.curEris['tcflag']=true;
			}else{
				if(this.curEris['tcflag']){
					this.checkTc(this.curEris, 'eris');
				}				
			}	
			//console.log(cell)
			this.updateEirsRecord(this.curErisData.rows[x]);
			this.selectedCell=null;
			this.erisCellShow=false
		},200)
		} catch (e) {
			console.log('Eris Edit Error: ' + e);
		}
		
	}
	erisCellSuggest(e, id){
		let users=[];
			if(e['suggestions']&&e['suggestions'].length>0 ){
				for(let item of e['suggestions']){
					if(!users.includes(item.authorId)){
						users.push(item.authorId);	
					}
				}
			}
			if(e['comments']&&e['comments'].length>0 ){
				for(let item of e['comments']){
					for(let comm of item['comments']){
						if(!users.includes(comm.authorId)){
							users.push(comm.authorId);	
						}
					}
				}
			}	
			let htmlcontent=e['html'];
			if(users.length>0){
				this.tempSuggestions=e['suggestions'];	
				this.tempComms=e['comments'];
				this.tempUsers=users;
			}else{
				htmlcontent=this.trackErrorFix(htmlcontent)
			}	
			let data=this.sanitizer.bypassSecurityTrustHtml(htmlcontent);			
			this.tempText=e['text'];
			this.tempHtml=htmlcontent;
			this.tempSecHtml=data;	
				
				
	}
	erisCellHtml(e){
		console.log(e)
		this.tempHtml=e;
		this.tempSecHtml=this.sanitizer.bypassSecurityTrustHtml(e)	
		this.tempSuggestions=[];	
		this.tempComms=[];
		this.tempUsers=[];	
	}
	erisCellText(e){
		//console.log(e)
		this.tempText=e;	
	}
	hiddenToggle(){console.log(this.curEris, this.showHidden)
		this.showHidden=!this.showHidden;
		let inputJson={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":this.curErisData.SLOT_ID.toString(),"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':this.curEris.id,'SHOW_HIDDEN_RECORD':this.showHidden?'Y':'N',};
		console.log(JSON.stringify(inputJson));
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			console.log(response);
			if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)											
			}else{
				if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
					let info=JSON.parse(response.RW_SLOTS[0].CONTENT); console.log(info);
					let arr=[];
					if(info.rows&&info.rows.length>0){
						for(let row of info.rows){
							let arr1=[];
							for(let col of this.curErisData.cols){
								let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
								if(col.INTERNALNAME=='ES_RID'){
									row[index]['hide']=true;
								}
								arr1.push(row[index]);
							}
							arr.push(arr1);
						}
					}
					this.curErisData.rows=arr; //console.log(this.curTableData.rows)
				}
			}
		})
	}
	updateErisTable(id, iftc){
		this.erisCheck=true;
			let doc=this.getSecbyId(this.contents, id);
			if(iftc=='Y'){
				doc['tcflag']=true;
			}else{
				delete doc['tcflag'];
			}
			let inputJson={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":doc.data.SLOT_ID.toString(),"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':id,'SHOW_HIDDEN_RECORD':'N',};
				console.log(inputJson);
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
					console.log(response);
					this.erisCheck=false;
					if (response.RESPONSE_STATUS=='N') {
						this.throwError(response)											
					}else{
						if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
							let info=JSON.parse(response.RW_SLOTS[0].CONTENT); console.log(info);
							let arr=[];
							if(info.rows&&info.rows.length>0){
								for(let row of info.rows){
									let arr1=[];
									for(let col of doc.data.cols){
										let index=row.findIndex(item=>item.COLUMNINTERNALNAME==col.INTERNALNAME);
										if(col.INTERNALNAME=='ES_RID'){
											row[index]['hide']=true;
										}
										arr1.push(row[index]);
									}
									arr.push(arr1);
								}
							
							}
							doc.data.rows=arr; //console.log(doc.data.rows)
							if(info.filters&&info.filters.length>0){							
								doc.data['filters']=info.filters;
							}
							/*if(info.parent_table){
								doc.data['parent_table']=info.parent_table;
							}else{
								doc.data['parent_table']=info.PARENT_TABLE;
							}*/
						}else{
							Swal.fire({
								icon:'warning',
								title: 'No Data',
							})
							doc.data.rows=[];
						}
					}	
				})
				//console.log(this.curTableData.erisName);
		
	}
	dropRow(event){
		moveItemInArray(this.curErisData.rows, event.previousIndex+this.erisstart, event.currentIndex+this.erisstart);
		//console.log(this.curErisData.rows)
		this.saveErisRecord(this.curErisData.rows);	
	}
	addFOItem(e, item){
		let ele=$(e.target).prev('input')
		let text=ele.val().trim();
		if(!item.FO){
			item.FO=[];
		}	
		if(text.length>0){
			item.FO.push(text);			
		}
		ele.val('');
	}
	removeFOItem(item, index){
		item.FO.splice(index, 1);
	}
	insertFOItem(item){//console.log(text)
		this.itemIndex++;
		let text='';
		if(item.html){
			text=item.html.slice(3, -4);;
		}else{
			text=item;
		}
		let data={'index':this.itemIndex,'content':text, 'type':'FO'};			
		this.curSec['addedItem']=data;
		this.curSec['reqIndex']=this.itemIndex;
	}
	insertFOItemEris(item){//console.log(text)
		this.itemIndex++;
		let text='';
		if(item.html){
			text=item.html.slice(3, -4);;
		}else{
			text=item;
		}
		let data={'index':this.itemIndex,'content':text, 'type':'FO'};			
		this.curEris['addedItem']=data;
		this.curEris['reqIndex']=this.itemIndex;
	}
	setPageSize(doc,e){
		if(e.target.checked){
			doc['landscape']=true;
		}else{
			doc['landscape']=false;
		}		
	}
	defaultShow=false;
	eriscurcol=null;
	toDefaultEdit(col){
		this.defaultShow=true;
		this.eriscurcol=col;
		if(!this.eriscurcol.DefaultFO){
			this.eriscurcol['DefaultFO']={'html':'','data':'', 'slots':[]};	
		}
	}
	defaultData(e){
		if(this.eriscurcol['DefaultFO'].length>0){
			this.eriscurcol['DefaultFO']={'html':'','data':'', 'slots':[]};	
		}
		if(e.length>0){
			this.eriscurcol['DefaultFO']['html']=e;
			this.eriscurcol['DefaultFO']['secHtml']=this.sanitizer.bypassSecurityTrustHtml(e);
			this.eriscurcol['DefaultFO']['slots']=this.getAllSlotId(e)
		}else{
			this.eriscurcol['DefaultFO']['html']='';
			this.eriscurcol['DefaultFO']['secHtml']=null;
			this.eriscurcol['DefaultFO']['slots']=[];
		}
	}
	defaultText(e){
		if(e.length>0){
			this.eriscurcol['DefaultFO']['data']=e;
		}else{
			this.eriscurcol['DefaultFO']['data']='';
		}
	}
	toFrmData(e){
		if(e.length>0){
			this.curFrm.html=e;
			this.curFrm.secHtml=this.sanitizer.bypassSecurityTrustHtml(e);
			if($(e).find('.placeholder').length>0){
				this.curFrm.data=$(e.replace('<p>','').replace('</p>',''))[0].innerHTML;	
			}else{
				this.curFrm.data=e.replace('<p>','').replace('</p>','');
			}
			
		}else{
			this.curFrm.data='';
			this.curFrm.html='';
			this.curFrm.text='';
			this.curFrm.secHtml=null;
		}
		
		
		//this.curFrm.reqIndex++;
	}
	ulProp:any;
	selFrmUl(doc, e, type, type1?){
		/*if(doc.data&&doc.data.rows&&doc.data.rows.length>0){
			Swal.fire({
				icon:'info',
				text: 'Can not change catergory with non-empty table.',
			})
			return
		}*/
		let ifLinked=this.checkFrmItem(doc.id);
		if(ifLinked){
			Swal.fire({
					icon:'info',
					title: 'This table is referenced by Freddie Mac Section, Please remove the reference first.',
				})
				let index=this.capitalCategory.findIndex(data=>data.tag==doc.cat);  
				e.target.value=index;
			return
			
		}
		let index=parseInt(e.target.value);
			if(index>-1){
				let tablesrc=this.frmService.tableSet.sec2tables.rowItem[index]; //console.log(tablesrc);
				const key = 'key';
				const costitems = this.getAllItem(tablesrc);
				const val=this.capitalCategory[index].tag;
				doc[type]=val;
				doc['costitems']=costitems;
		
			}else{
				delete doc.cat;
				delete doc.costitems;			
			}
		
		this.getAllCostTable();
		this.autoSave('modify', doc.id, doc.SECTION_TITLE, 'O');
	}
	getAllItem(table){
		let allitems=[];
		for(let item of table){
			let recItem={'key':item.key,'checkvalue':item.key}
			allitems.push(recItem);
			if(item.sub&&item.sub.length>0){
				for(let subitem of item.sub){
					let recItem1={'key':subitem, 'parent':item.key, 'checkvalue':item.key+"--"+subitem};
					if(item.key=='Mechanical HVAC'){
						recItem1['describe']=true;
					}
					allitems.push(recItem1);
				}
				if(item.key=='Flooring'||item.key=='Cabinetry'||item.key=='Countertops and sinks'){
					let recItem1={'key':'Other', 'parent':item.key, 'other':true,'checkvalue':'other'}
					allitems.push(recItem1);					
				}				 
			}
		}
		return allitems
	}
	toCost(item){
		
		if(item.costtable){
		let sec=this.getSecbyId(this.contents, item.costtable); 
		let newItem=JSON.parse(JSON.stringify(this.frmrowItem));
		newItem.costId=Utils.uniqueIdGenerator();
		newItem.Item=item.data;
		newItem.id=sec.id;
		newItem.cat=sec.cat;
		if(item['parent']){
			newItem['parent']=item['parent']
		}
		if(item.data=='Heating system (describe)'||item.data=='Cooling system (describe)'){
			newItem['describe']=true;
			newItem['describeInput']='';
			item['describe']=true;
			item['describeInput']='';
		}
		if(sec.data['COST']){
			sec.data['COST'].push(newItem)
		}else{
			sec.data['COST']=[newItem];
		}
		let row=[];
		for(let col of sec.data.cols){
			let cell={'OLUMNINTERNALNAME':col.INTERNALNAME, 'DATA': '', 'KEY': col.KEY, 'costId': newItem.costId, 'sign':'', 'text-align':'center'};
			if(col.sign){
				cell['sign']=col.sign;
			}
			row.push(cell)
		}
		row[0].DATA=item.data;
		if(item['parent']){
			row[0].DATA=item['parent']+"--"+item.data;
		}
		row[0]['FRM']=true;
		sec.data.rows.push(row);
		//this.getFrmCostData(item.costtable);
		}
	}
	getAddedItems(e?){
		if(e){
			e.target.value='';
			let index=this.frmService.capitalCategory.findIndex(item=>item.tag==this.frmrowItem['cat']);
			if(index>-1){
				let tablesrc=this.frmService.tableSet.sec2tables.rowItem[index];
				const costitems = this.getAllItem(tablesrc);
				this.frmrowItem['costitems']=costitems;
			}
			
		}
		
		let index=this.capitalCategory.findIndex(item=>item.tag==this.frmrowItem['cat']);
		let sec=this.getSecbyId(this.contents,'frm_sec');
		let addedItem=[];
		if(index>-1){
			let table2=sec.frmData.sec2tablesdata[index];
			for(let row of table2.rows){
				if(row[0].costtable&&row[0].costtable.length>0){
					if(!row[0].parent){
						addedItem.push(row[0].data)
					}else if(row[0].parent&&row[0].parent.length>0){
						if(row[0].oridata){
							let item=row[0].parent+"--"+row[0].oridata;
						addedItem.push(item)
						}else{
							let item=row[0].parent+"--"+row[0].data;
							addedItem.push(item)
						}
						
					}
					
				}
			}
		}
		this.frmrowItem['addedItem']=addedItem;
	}
	selFrmCost(type, e){
		let val:any
		if(type=='ACTION'){
			val=e.value;
		}else{
			val=e.target.value.trim();
		}
		if(val<0) return
		
		if(type=='Item'){//call get all same item in this sec
			let selectedItem=this.frmrowItem['costitems'][val];
			this.frmrowItem[type]=selectedItem.key;
			if(selectedItem.parent){
				this.frmrowItem['parent']=selectedItem.parent;
			}else{
				if(this.frmrowItem['parent']){
					delete this.frmrowItem['parent']
				}
			}
			if(selectedItem.other){
				this.frmrowItem['other']=true;
				this.frmrowItem['otherInput']='';
			}else{
				if(this.frmrowItem['other']){
					delete this.frmrowItem['other']
					delete this.frmrowItem['otherInput']
				}
			} 
			if(selectedItem.describe){
				this.frmrowItem['describe']=true;
				this.frmrowItem['describeInput']='';
			}else{
				if(this.frmrowItem['describe']){
					delete this.frmrowItem['describe']
					delete this.frmrowItem['describeInput']
				}
			} 
			this.getSameItem(this.frmrowItem);
		}else{
			this.frmrowItem[type]=val;
		}
		
		/*if(val.length){
			let id=this.curCosts[index].COST_LIBRARY_ID.toString();
		let inputJson={"PROCEDURE":"getpcacostlibraryentrybyidlist","USER_ID":parseInt(this.userId),"COST_LIBRARY_LIST":id}
		//console.log(inputJson);
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			//console.log(data);
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data)
			}else{
				this.curCost=data.RW_PCA_COST_LIBRARIES[0]
				//this.frmrowItem.Item=this.curCost.ITEM_TITLE;
				let unitIndex=this.units.findIndex(unit=>unit.COST_UNIT_NAME==this.curCost.UNIT);
				if(unitIndex>-1){
					this.frmrowItem.Unit=this.curCost.UNIT;
				}
				//console.log(parseFloat(this.curCost.COST))
				if(!isNaN(parseFloat(this.curCost.COST))){
					this.frmrowItem.Cost=parseFloat(this.curCost.COST);
				}else{
					this.frmrowItem.Cost=0;
				}
				if(!isNaN(parseInt(this.curCost.EUL))){
					this.frmrowItem.EUL=parseInt(this.curCost.EUL);
				}else{
					this.frmrowItem.EUL=0;
				}
				//this.rowItem.Immediate=0;
				//this.rowItem.Short=0;
				this.getReserve2();				
			}
		})
		}else{
			this.curCost=null
			//this.frmrowItem.Item='';
			this.frmrowItem.Unit='';
			this.frmrowItem.Cost=0;
			this.frmrowItem.EUL=0;
			this.getReserve2();				
		}
		*/
				
	}
	filledItems={'CR':false, 'PR':false, 'PR-90':false, 'RR':false, 'ADDED':false, 'ALL':false};
	optionalItems=['EFF', 'EUL', 'RUL', 'RULtext','Percent', 'parent', 'describe', 'describeInput','condition','other', 'otherInput'];//,'other', 'otherInput' 'Cost', 'Unit', 'Cycle', 'Total', 'CommentText', 
	addedItems={'CR':null, 'PR':null, 'PR-90':null, 'RR':null};
	getSameItem(item, type?){
		let sec=this.getSecbyId(this.contents, item.id);
		this.filledItems={'CR':false, 'PR':false, 'PR-90':false, 'RR':false, 'ADDED':false, 'ALL':false};
		this.addedItems={'CR':null, 'PR':null, 'PR-90':null, 'RR':null};
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='COSTTABLE'){
						if(sec1.data&&sec1.data.COST&&sec1.data.COST.length>0){
							for(let cost of sec1.data.COST){
								if(type&&type=='edit'&&cost.costId==this.frmrowItem['costId']) continue
								if(cost.cat==item.cat&&cost.Item==item.Item){
									if((!item.other&&!cost.other)||(cost.other==item.other&&cost.parent==item.parent&&cost.otherInput==item.otherInput)){
										if(cost.CRCHK){
											this.filledItems.CR=true;
											this.filledItems.ADDED=true;
											this.addedItems.CR=cost;
										}
										if(cost.PRCHK){
											this.filledItems.PR=true;
											this.filledItems.ADDED=true;
											this.addedItems.PR=cost;
										}
										if(cost.PR90CHK){
											this.filledItems['PR-90']=true;
											this.filledItems.ADDED=true;
											this.addedItems['PR-90']=cost;
										}
										if(cost.selectedYear&&cost.selectedYear.length>0){
											this.filledItems.RR=true;
											this.filledItems.ADDED=true;
											this.addedItems.RR=cost;
										}									
										for(let key of this.optionalItems){
											if((cost[key]&&(cost[key].toString().trim()!='')||cost[key]>=0||cost[key]===false||cost[key]===true)){
												this.filledItems[key]=cost[key];
											}
										}
									}
								}
							}
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){	
							if(sec2.TYPE=='COSTTABLE'){
								if(sec2.data&&sec2.data.COST&&sec2.data.COST.length>0){
									for(let cost of sec2.data.COST){
										if(type&&type=='edit'&&cost.costId==this.frmrowItem['costId']) continue
										if(cost.cat==item.cat&&cost.Item==item.Item){
											if((!item.other&&!cost.other)||(cost.other==item.other&&cost.parent==item.parent&&cost.otherInput==item.otherInput)){
												if(cost.CRCHK){
													this.filledItems.CR=true;
													this.filledItems.ADDED=true;
													this.addedItems.CR=cost;
												}
												if(cost.PRCHK){
													this.filledItems.PR=true;
													this.filledItems.ADDED=true;
													this.addedItems.PR=cost;
												}
												if(cost.PR90CHK){
													this.filledItems['PR-90']=true;
													this.filledItems.ADDED=true;
													this.addedItems['PR-90']=cost;
												}
												if(cost.selectedYear&&cost.selectedYear.length>0){
													this.filledItems.RR=true;
													this.filledItems.ADDED=true;
													this.addedItems.RR=cost;
												}										
												for(let key of this.optionalItems){
													if((cost[key]&&(cost[key].toString().trim()!='')||cost[key]>=0||cost[key]===false||cost[key]===true)){
														this.filledItems[key]=cost[key];
													}
												}
											}
										}
									}
								}
							}
						}
					}
					
				}
			}
		}
		let itemLists=['CR', 'PR', 'PR-90', 'RR'];
		this.filledItems.ALL = itemLists.every(key => this.filledItems[key] === true);
		if(!type){
			if(!this.filledItems.ALL){
				if(Object.values(this.filledItems).some(value => value === true)){
					this.resetFrmCostTable();
					this.frmrowItem.Item=item.Item;
					for(let key of this.optionalItems){
						this.frmrowItem[key]=this.filledItems[key];
					}
					/*if(item.parent){
						this.frmrowItem['parent']=item.parent;
					}else{
						if(this.frmrowItem['parent']){
							delete this.frmrowItem['parent']
						}
					}
					if(item.other){
						this.frmrowItem['other']=item.other;						
					}else{
						if(this.frmrowItem['other']){
							delete this.frmrowItem['other']
							delete this.frmrowItem['otherInput']
						}
					} 
					if(item.describe){
						this.frmrowItem['describe']=item.describe;
						this.frmrowItem['describeInput']=item.describeInput;
					}else{
						if(this.frmrowItem['describe']){
							delete this.frmrowItem['describe']
							delete this.frmrowItem['describeInput']
						}
					} */				
				}
			}else{
				this.resetFrmCostTable();
				this.frmrowItem.Item=item.Item;
				let needItems=this.optionalItems;//.slice(5); console.log(needItems)
				for(let key of needItems){
					if((this.filledItems[key]&&(this.filledItems[key].toString().trim()!='')||this.filledItems[key]>=0||this.filledItems[key]===false||this.filledItems[key]===true)){
						this.frmrowItem[key]=this.filledItems[key];
					}
				}
			}
		}
			
	}
	checkFrmTotal(){
		
		let total=0;
		for(let i=0; i<this.frmrowItem.allocate.length; i++){
			if(this.frmrowItem.selectedYear.indexOf(i+1)>-1){
				total+=this.frmrowItem.allocate[i];
			}else{
				this.frmrowItem.allocate[i]=0;				
			}
		}
		//console.log(this.frmrowItem.allocate);
		let immishort=0;
		if(this.frmrowItem.CRCHK){
			immishort+=this.frmrowItem.CR
		}
		if(this.frmrowItem.PRCHK){
			immishort+=this.frmrowItem.PR
		}
		if(this.frmrowItem.PR90CHK){
			immishort+=this.frmrowItem.PR90
		}		
		let val=this.frmrowItem.Percent*this.frmrowItem.Quantity*this.frmrowItem.Cost/100-immishort;
		this.frmrowItem.reserve=this.getRound(val-total, 2);
		if(this.frmrowItem.reserve==0){
			this.reserveWarn=false;
		}else{
			this.reserveWarn=true;
		}
	}
	checkAllQuantity(){
		let itemQuantity=0;
		this.quantityWarn=false;
		if(this.frmrowItem.CRCHK&&this.frmrowItem.CRQuantity&&this.frmrowItem.CRQuantity.trim()!=''){
			if(!isNaN(parseInt(this.frmrowItem.CRQuantity))){
				itemQuantity+=parseInt(this.frmrowItem.CRQuantity);
			}else{
				this.quantityWarn=true;
			}		
		}
		if(this.frmrowItem.PRCHK&&this.frmrowItem.PRQuantity&&this.frmrowItem.PRQuantity.trim()!=''){
			if(!isNaN(parseInt(this.frmrowItem.PRQuantity))){
				itemQuantity+=parseInt(this.frmrowItem.PRQuantity);
			}else{
				this.quantityWarn=true;
			}
		}
		if(this.frmrowItem.PR90CHK&&this.frmrowItem.PR90Quantity&&this.frmrowItem.PR90Quantity.trim()!=''){
			if(!isNaN(parseInt(this.frmrowItem.PR90Quantity))){
				itemQuantity+=parseInt(this.frmrowItem.PR90Quantity);
			}else{
				this.quantityWarn=true;
			}
		}
		if(this.frmrowItem.RRQuantity&&this.frmrowItem.RRQuantity.trim()!=''){
			if(!isNaN(parseInt(this.frmrowItem.RRQuantity))){
				itemQuantity+=parseInt(this.frmrowItem.RRQuantity);
			}else{
				this.quantityWarn=true;
			}
		}
		if(itemQuantity>this.frmrowItem.Quantity){
			this.quantityWarn=true;
		}
	}
	getReserve2(key?){
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		this.quantityWarn=false;
		if(key){
			if(key=='Cost'){
				let rounded=this.getRound(this.frmrowItem[key],2);
				this.frmrowItem[key]=rounded;
			}else if(key=='Quantity'){
				let rounded=this.getRound(this.frmrowItem[key],0);
				this.frmrowItem[key]=rounded;
				this.checkAllQuantity();
			}else if(key=='CRQuantity'||key=='PRQuantity'||key=='PR90Quantity'||key=='RRQuantity'){
				if(this.frmrowItem[key].trim()!=''){
					let val=this.frmrowItem[key];
					if(isNaN(parseInt(val))){
						this.frmrowItem[key]='NaN';
						return
					}
					if(val.indexOf('.')>-1){
						this.frmrowItem[key]=parseInt(val);
					}
					if(val.indexOf('-')>-1){
						this.frmrowItem[key]=Math.abs(parseInt(val));
					}									
				}
				this.checkAllQuantity();
			}else{
				let rounded=this.getRound(this.frmrowItem[key],this.pcaOp.decimal);
				this.frmrowItem[key]=rounded;
			}
		}
		let rate=this.pcaOp.inflation/100;////console.log(rate);
		this.frmrowItem.Cycle=this.getRound(this.frmrowItem.Quantity*this.frmrowItem.Cost,this.pcaOp.decimal)
		this.frmrowItem.Total=this.getRound(this.frmrowItem.Percent*this.frmrowItem.Quantity*this.frmrowItem.Cost/100,this.pcaOp.decimal);
		if(!this.frmrowItem.CR){
			this.frmrowItem.CR=0
		}
		if(!this.frmrowItem.PR){
			this.frmrowItem.PR=0
		}
		if(!this.frmrowItem.PR90){
			this.frmrowItem.PR90=0
		}
		if(!this.frmrowItem.ORBP){
			this.frmrowItem.ORBP='';
		}
		let immishort=0;
		if(this.frmrowItem.CRCHK){
			immishort+=this.frmrowItem.CR;
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='CR');
			if(index==-1){
				this.frmrowItem['ACTION'].push({name: 'CR', code: 'CR'})
			}
		}else{
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='CR');
			if(index>-1){
				this.frmrowItem['ACTION'].splice(index,1)
			}
		}
		if(this.frmrowItem.PRCHK){
			immishort+=this.frmrowItem.PR;
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='PR');
			if(index==-1){
				this.frmrowItem['ACTION'].push({name: 'PR', code: 'PR'})
			}
		}else{
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='PR');
			if(index>-1){
				this.frmrowItem['ACTION'].splice(index,1)
			}
		}
		if(this.frmrowItem.PR90CHK){
			immishort+=this.frmrowItem.PR90;
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='PR-90');
			if(index==-1){
				this.frmrowItem['ACTION'].push({name: 'PR-90', code: 'PR-90'})
			}
		}else{
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='PR-90');
			if(index>-1){
				this.frmrowItem['ACTION'].splice(index,1)
			}
		}
		if(this.frmrowItem.ORCHK){
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='OR');
			if(index==-1){
				this.frmrowItem['ACTION'].push({name: 'OR', code: 'OR'})
			}
		}else{
			let index=this.frmrowItem['ACTION'].findIndex(item=>item.code=='OR');
			if(index>-1){
				this.frmrowItem['ACTION'].splice(index,1)
			}
		}
		let entries = Object.entries(this.frmrowItem['ACTION'])
		let actiontext= this.frmrowItem['ACTION'].map (function (item) {
			return item.name;
		  });		  
		this.frmrowItem['actions']=actiontext;
		this.frmrowItem['actiontext']=actiontext.join(', ');
		let val=this.frmrowItem.Total-immishort;//this.rowItem.Immediate-this.rowItem.Short;
		this.frmrowItem.Reserve=this.getRound(val,this.pcaOp.decimal)
		let selectedYear=[];
		$('input.yearbox1').each(function(e){////console.log($(this)[0].checked);
			if($(this).prop('checked')){
				selectedYear.push(parseInt($(this).val()));
			}
		})
		this.frmrowItem['selectedYear']=selectedYear;
		//let remain=val%selectedYear.length;
		/*if(this.pcaOp.decimal==2){
			remain=(val*100%selectedYear.length)/100;
		}*/
		let data=this.getRound(val/selectedYear.length,this.pcaOp.decimal);
		 ////console.log(remain);
		let otherTotal=0;
		if(this.pcaOp.reserve>0){
			for(let i=0; i<this.pcaOp.reserve; i++){////console.log(selectedYear.indexOf(i+1));
				if(selectedYear.indexOf(i+1)>-1){
					if(selectedYear[0]==i+1){
						this.frmrowItem.allocate[i]= data;//this.getRound(data+remain,this.pcaOp.decimal);
					}else{
						this.frmrowItem.allocate[i]= data;
						otherTotal+=data
					}
				}else{
					this.frmrowItem.allocate[i]= 0;
				}
			}
			this.frmrowItem.allocate[selectedYear[0]-1]=this.getRound(val-otherTotal,this.pcaOp.decimal);
		}
		/*let data=this.getRound(val/this.pcaOp.reserve);//console.log(this.rowItem.reserve);
		let remain=this.getRound(val%this.pcaOp.reserve); //console.log(remain);
		if(this.pcaOp.reserve>0){
			for(let i=0; i<this.pcaOp.reserve; i++){
				if(i==0){
					this.rowItem.allocate[i]= data+remain;
				}else{
					this.rowItem.allocate[i]= data;
				}
			}
		}*/		
		////console.log(this.rowItem);
		if(selectedYear.length>0){
			this.frmrowItem.reserve=0;
		}else{
			this.frmrowItem.reserve=this.getRound(val,this.pcaOp.decimal);
		}
		this.frmrowItem.averageReserve=this.getRound(val/this.frmrowItem.Quantity/this.pcaOp.reserve,2);
		let total=0;
		for(let i=0; i<this.frmrowItem.allocate.length; i++){
			if(i==0){
				total+=this.frmrowItem.allocate[i];
			}else{
				total+=this.getRound(this.frmrowItem.allocate[i]*this.getRound(Math.pow((1+rate),i),3),2);
			}
			////console.log(total)
		}
		this.frmrowItem.inReserve=this.getRound(total,2);
		this.frmrowItem.averageINReserve=this.getRound(this.frmrowItem.inReserve/this.frmrowItem.Quantity/this.pcaOp.reserve,2);
		////console.log(val);
		if(this.frmrowItem.reserve!=0){
			this.reserveWarn=true;
		}
		//if(!this.rowItem.Immediate){
		//	this.rowItem.Immediate=0
		//}
		if(this.reserveWarn){
			if(!this.frmrowItem.allow){
				return
			}
		}
	
	}	
	resetFrmCostTable(){
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		this.quantityWarn=false;
		let cat='';
		let items=[];
		if(this.frmrowItem['cat']){
			cat=this.frmrowItem['cat'];
			items=this.frmrowItem['costitems'];
		}
		
		this.frmrowItem=JSON.parse(JSON.stringify(this.newFrmRow));
		this.frmrowItem.EFF=this.pcaOp.age;
		if(this.frmrowItem['other']){	
			delete this.frmrowItem['other'];	
			delete this.frmrowItem['otherInput'];
			delete this.frmrowItem['parent'];
		}
		
		//this.rowItem.data[1].data=this.pcaOp.quantity
		
		for(let i=0; i<this.pcaOp.reserve; i++){
			this.frmrowItem.allocate.push(0);
		}
		this.curCost=null;
		$('input.yearbox1').each(function(e){////console.log($(this)[0].checked);
			$(this).prop('checked', false);
		})
		$("#frmCostModal textarea").each(function(e){
			$(this)[0].style.height = "40px";
		});
		this.frmrowItem['cat']=cat;
		this.frmrowItem['costitems']=items;
	}
	async getFrmCostData(id){
		let that=this;
		await this.getPCAData();
		let ifOpen=$('.nav-tabs a[href="#pca"]').hasClass('active');
		if(ifOpen){
			this.logTab('PCA','noPop');
			
		}else{
			this.logTab('PCA');
		}
		$('.nav-tabs a[href="#pca"]').tab('show');
		this.filledItems={'CR':false, 'PR':false, 'PR-90':false, 'RR':false, 'ADDED':false, 'ALL':false};
		this.addedItems={'CR':null, 'PR':null, 'PR-90':null, 'RR':null};
		setTimeout(function(){
			if(that.pcaOp.quantity>0){
			$("#frmCostModal").modal('show');
			//let data=that.getContentData('data'); console.log(data);
			that.resetFrmCostTable();
			//that.rowItem=this.frmrowItem
			//that.frmrowItem.index=that.curIndex;
			that.frmrowItem['id']=id;
			const sec=that.getSecbyId(that.contents, id); 
			if(sec.cat){
				that.frmrowItem['cat']=sec.cat;
				that.frmrowItem['costitems']=sec.costitems;
			}
			that.reserveWarn=false;
			that.validateWarn=false;
			that.validateWarn1=false;
			that.quantityWarn=false;
		}else{
			Swal.fire({
				icon: 'info',
				text: "Please check 'Cost Table Multiplier' and 'Quantity for Cost Table Multiplier' value",				
            })
		}
		}, 500);
	}
	async editFrmCostRow(sec, index){
		this.reserveWarn=false;
		this.validateWarn=false;
		this.validateWarn1=false;
		this.quantityWarn=false;
		if(this.pcaOp.quantity>0){
		this.resetFrmCostTable();
		
		let data=sec['data'];
		
		//this.curCosts=data.rows[0][0].choice; console.log(this.curCosts);
		
			let id=data.rows[index][0].costId;
			let ifFRM=data.rows[index][0]['FRM'];
			let v2Index=data.COST.findIndex(item=>item.costId==id);
			this.frmrowItem=JSON.parse(JSON.stringify(data.COST[v2Index]));
			if(sec['cat']){
				this.frmrowItem['cat']=sec['cat'];
			}
			if(sec['costitems']){
				this.frmrowItem['costitems']=sec['costitems'];
			}
		let that=this;
		
		this.frmrowItem['edit']=true;
		this.frmrowItem['editIndex']=index;
		if(ifFRM){
			this.frmrowItem['FRM']=true;
		}else{
			this.frmrowItem['FRM']=false;
		}
		
			let years=$('input.yearbox1');//console.log(years);
			setTimeout(() => {
				for(let i=0; i<this.frmrowItem.allocate.length; i++){
			if(that.frmrowItem.selectedYear.indexOf(i+1)>-1){
				years[i].checked=true;
			}else{
				years[i].checked=false;
			}
		}
			}, 100);
		
		this.getSameItem(this.frmrowItem, 'edit');
		
		
		await this.getPCAData();
		$("#frmCostModal").modal('show');
		}else{
			Swal.fire({
				icon: 'info',
				text: "Please check 'Cost Table Multiplier' and 'Quantity for Cost Table Multiplier' value",				
            })
		}
	}
	addtoFrm(type?){
		
		this.frmrowItem.RUL=this.getRound(this.frmrowItem.EUL-this.frmrowItem.EFF, 0);//this.frmrowItem.EUL-this.frmrowItem.EFF;
		if(this.reserveWarn){
			if(!this.frmrowItem.allow){
				return
			}
		}
		if(this.frmrowItem.Item==''||this.frmrowItem.Quantity==0||this.frmrowItem.Unit==''){
			this.validateWarn1=true;
			return
		}
		if((this.frmrowItem['describe']&&this.frmrowItem['describeInput'].length==0)||(this.frmrowItem['other']&&this.frmrowItem['otherInput'].length==0)){
			this.validateWarn1=true;
			return
		}
		if((this.frmrowItem.CRCHK&&this.frmrowItem.CRBP.length==0)||(this.frmrowItem.PRCHK&&this.frmrowItem.PRBP.length==0)||(this.frmrowItem.PR90CHK&&this.frmrowItem.PR90BP.length==0)||(this.frmrowItem.ORCHK&&this.frmrowItem.ORBP.length==0)){
			this.validateWarn1=true;
			return
		}
		this.checkAllQuantity();
		if(this.quantityWarn) return
		/*this.getAddedItems();
		if(this.frmrowItem['addedItem']){
			let index2=this.frmrowItem['addedItem'].indexOf(this.frmrowItem.Item);
		
			if(index2>-1){
				Swal.fire({
					icon: 'info',
					title: 'This item is already added, Please revise your Cost Recommendation',
				})
				this.frmrowItem.Item='';			
				return
			}
		}*/
		let data=this.getContentData('data');
		let sid=this.getContentData('id');
		let title=this.getContentData('SECTION_TITLE');
		//console.log(data);
		let info=JSON.parse(JSON.stringify(this.frmrowItem));
		info['costId']=Utils.uniqueIdGenerator();
		if(!data['COST']){
			data['COST']=[];
			data['COST'].push(info);
		}else{
			data['COST'].push(info);
		}
			let row=[]
			let total=this.rowItem.Total;
			for(let col of data.cols){
			let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'', 'KEY':'', };
			item.COLUMNINTERNALNAME=col.INTERNALNAME;
			if(this.frmrowItem[col.KEY]||this.frmrowItem[col.KEY]==0){
				item.DATA=this.frmrowItem[col.KEY].toString();
				if(col.KEY=='Item'&&this.frmrowItem['other']){
					item.DATA=this.frmrowItem['parent']+"--"+this.frmrowItem['otherInput'];
				}else if(col.KEY=='Item'&&this.frmrowItem['describe']){
					let label=item.DATA;
					label=label.replace('describe', this.frmrowItem['describeInput']);    
					item.DATA=this.frmrowItem['parent']+"--"+label;//this.frmrowItem['describeInput'];
				}else if(col.KEY=='Item'&&this.frmrowItem['parent']){
					item.DATA=this.frmrowItem['parent']+"--"+item.DATA;
				}
			}
			item.KEY=col.KEY;
			if(col.KEY=='Cost'||col.KEY=='Cycle'||col.KEY=='Immediate'||col.KEY=='Short'){
				item.sign=this.currSign;
			}else if(col.KEY=='Percent'){
				item.sign='%';
			}
			if((this.pcaOp.term=='Exclude')&&(col.KEY=='Short')){
				item['hide']='Y';
			}
			if(col.KEY=='Cycle'||col.KEY=='Percent'){
				item['hide']='Y';
			}			
			//console.log(item)
			if(col.KEY=='RUL'){
				if(this.frmrowItem.RULtext){
					item.DATA=this.frmrowItem.RULtext;
				}
			}
			row.push(item);
			
		}
		let rowBase=JSON.parse(JSON.stringify(row));
			let keep=true;
			if(this.frmrowItem.CR>=0&&this.frmrowItem.CRCHK){
				let val1='CR';
				let val2=this.frmrowItem.CR;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.push(v2row);
				keep=false;				
			}
			if(this.frmrowItem.PR>=0&&this.frmrowItem.PRCHK){
				let val1='PR';
				let val2=this.frmrowItem.PR;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.push(v2row);
				keep=false;				
			}
			if(this.frmrowItem.PR90>=0&&this.frmrowItem.PR90CHK){
				let val1='PR90';
				let val2=this.frmrowItem.PR90;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.push(v2row);
				keep=false;				
			}			
			if(info.selectedYear.length>0&&info.allocate){
				for(let i of info.selectedYear){
					let val1=i;
					let val2=0; 
					if(info.allocate[i-1]>0){
						val2=info.allocate[i-1];
					}
					
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
					if(keep&&this.frmrowItem['FRM']){
						v2row[0]['FRM']=true;
					}
					data.rows.push(v2row);;
					keep=false;
				}
			}
			if((!this.frmrowItem.CRCHK)&&(!this.frmrowItem.PRCHK)&&(!this.frmrowItem.PR90CHK)&&info.selectedYear.length==0){
				let val1='N/A';
				let val2=0;//console.log(val1,val2)
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.push(v2row);
				keep=false;

		}	
		if(type&&type=='new'){
			this.resetFrmCostTable();
		}else{
			$('#frmCostModal').modal('hide');
		}
		this.getAllCostTable();
		this.autoSave('modify',sid, title, "O" );
	}
	editFrmRow(index){
	
		this.frmrowItem.RUL=this.getRound(this.frmrowItem.EUL-this.frmrowItem.EFF, 0);//this.frmrowItem.EUL-this.frmrowItem.EFF;
		if(this.reserveWarn){
			if(!this.frmrowItem.allow){
				return
			}
		}
		
		if(this.frmrowItem.Item==''||this.frmrowItem.Quantity==0||this.frmrowItem.Unit==''){
			this.validateWarn1=true;
			return
		}
		if((this.frmrowItem['describe']&&this.frmrowItem['describeInput'].length==0)||(this.frmrowItem['other']&&this.frmrowItem['otherInput'].length==0)){
			this.validateWarn1=true;
			return
		}
		if((this.frmrowItem.CRCHK&&this.frmrowItem.CRBP.length==0)||(this.frmrowItem.PRCHK&&this.frmrowItem.PRBP.length==0)||(this.frmrowItem.PR90CHK&&this.frmrowItem.PR90BP.length==0)||(this.frmrowItem.ORCHK&&this.frmrowItem.ORBP.length==0)){
			this.validateWarn1=true;
			return
		}
		this.checkAllQuantity();
		if(this.quantityWarn) return
		let data=this.getContentData('data');
		let sid=this.getContentData('id');
		let title=this.getContentData('SECTION_TITLE');
		//console.log(data);
		let info=JSON.parse(JSON.stringify(this.frmrowItem));
		
			let id=data.rows[index][0].costId;
			let v2Index=data.COST.findIndex(item=>item.costId==id);
			data.rows = data.rows.filter(row => row[0].costId!=id);
			//console.log(data.rows);
			let row=[]
			for(let col of data.cols){
			let item={'COLUMNINTERNALNAME':'','DATA':'', 'sign':'', 'KEY':'', };
			item.COLUMNINTERNALNAME=col.INTERNALNAME;
			if(this.frmrowItem[col.KEY]||this.frmrowItem[col.KEY]==0){
				item.DATA=this.frmrowItem[col.KEY].toString();
				if(col.KEY=='Item'&&this.frmrowItem['other']){
					item.DATA=this.frmrowItem['parent']+"--"+this.frmrowItem['otherInput'];
				}else if(col.KEY=='Item'&&this.frmrowItem['describe']){
					let label=item.DATA;
					label=label.replace('describe', this.frmrowItem['describeInput']);    
					item.DATA=this.frmrowItem['parent']+"--"+label;//this.frmrowItem['describeInput'];
				}else if(col.KEY=='Item'&&this.frmrowItem['parent']){
					item.DATA=this.frmrowItem['parent']+"--"+item.DATA;
				}
			}
			item.KEY=col.KEY;
			if(col.KEY=='Cost'||col.KEY=='Cycle'||col.KEY=='Immediate'||col.KEY=='Short'){
				item.sign=this.currSign;
			}else if(col.KEY=='Percent'){
				item.sign='%';
			}
			if((this.pcaOp.term=='Exclude')&&(col.KEY=='Short')){
				item['hide']='Y';
			}
			if(col.KEY=='Cycle'||col.KEY=='Percent'){
				item['hide']='Y';
			}
			if(col.KEY=='RUL'){
				if(this.frmrowItem.RULtext){
					item.DATA=this.frmrowItem.RULtext;
				}
			}			
			//console.log(item)
			row.push(item);
			
		}
		let rowBase=JSON.parse(JSON.stringify(row));
			let keep=true;
			if(this.frmrowItem.CR>=0&&this.frmrowItem.CRCHK){
				let val1='CR';
				let val2=this.frmrowItem.CR;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.splice(index, 0, v2row);
				keep=false;
				index++
			}
			if(this.frmrowItem.PR>=0&&this.frmrowItem.PRCHK){
				let val1='PR';
				let val2=this.frmrowItem.PR;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.splice(index, 0, v2row);
				keep=false;
				index++
			}
			if(this.frmrowItem.PR90>=0&&this.frmrowItem.PR90CHK){
				let val1='PR90';
				let val2=this.frmrowItem.PR90;
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.splice(index, 0, v2row);
				keep=false;
				index++
			}
			
			if(info.selectedYear.length>0&&info.allocate){
				for(let i of info.selectedYear){
					let val1=i;
					let val2=0; 
					if(info.allocate[i-1]>0){
						val2=info.allocate[i-1];
					}
					//console.log(val1,val2)
					let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
					if(keep&&this.frmrowItem['FRM']){
						v2row[0]['FRM']=true;
					}
					data.rows.splice(index, 0, v2row);
					index++
					keep=false;
				}
			}
			if((!this.frmrowItem.CRCHK)&&(!this.frmrowItem.PRCHK)&&(!this.frmrowItem.PR90CHK)&&info.selectedYear.length==0){
				let val1='N/A';
				let val2=0;//console.log(val1,val2)
				let v2row=this.addV(rowBase,val1,val2, keep,info['costId']);
				if(keep&&this.frmrowItem['FRM']){
					v2row[0]['FRM']=true;
				}
				data.rows.push(v2row);
				keep=false;

		}
			data.COST[v2Index]=info;			
		$('#frmCostModal').modal('hide');
		this.getAllCostTable();
		//this.getAllCostTable();
		//this.getTotalCost();
		this.autoSave('modify',sid, title, "O" );
	}
	reorderTableData(tabledata){
		for(let i=0; i<tabledata.cols.length; i++){
			tabledata.cols[i].INTERNALNAME='col'+i;			
		}
		for(let row of tabledata.rows){
			for(let i=0; i<tabledata.cols.length; i++){
				if(row.items[i]){
					row.items[i].COLUMNINTERNALNAME=tabledata.cols[i].INTERNALNAME;	
				}		
			}
		}
	}
	iniFrmCostData(){
		for(let sec of this.contents){
			if(sec.TYPE=="1105"&&sec.frmData){
				for(let table of sec.frmData.sec2tablesdata){
					for(let row of table.rows){
						if(row[0].costtable&&row[0].costtable.length>0){
							this.toCost(row[0])
						}
					}
				}
			}
		}
	}
	checkFrmItem(id){
		let linked=false;
		for(let sec of this.contents){
			if(sec.TYPE=='1105'){
				let secdata=sec.frmData.sec2tablesdata;
				for(let sec1 of secdata){
					for(let row of sec1.rows){
						if(row[0].costtables&&row[0].costtables.indexOf(id)>-1){
							linked=true;
							break
						}
					}
				}
			}
		}
		return linked
	}
	addToFrmAction(e){
		let items=$('.frmAction:checkbox:checked');
		let actions=[];
		let actiontext=[];
		let that=this;
		items.each(function(){
			actions.push(that.actionItemOps[$(this).val()]);
			actiontext.push(that.actionItemOps[$(this).val()].code);	
		})
		this.frmrowItem['ACTION']=actions;
		this.frmrowItem['actions']=actiontext;
		this.frmrowItem['actiontext']=actiontext.join(', ');
		if(this.actionItemOps[e.target.value].code=='CR'){
			if(e.target.checked){
				this.frmrowItem.CRCHK=true;
			}else{
				this.frmrowItem.CRCHK=false
			}
			this.getReserve2()
		} 
		if(this.actionItemOps[e.target.value].code=='PR'){
			if(e.target.checked){
				this.frmrowItem.PRCHK=true;
			}else{
				this.frmrowItem.PRCHK=false
			}
			this.getReserve2()
		} 
		if(this.actionItemOps[e.target.value].code=='PR-90'){
			if(e.target.checked){
				this.frmrowItem.PR90CHK=true;
			}else{
				this.frmrowItem.PR90CHK=false
			}
			this.getReserve2()
		}
		if(this.actionItemOps[e.target.value].code=='OR'){
			if(e.target.checked){
				this.frmrowItem.ORCHK=true;
			}else{
				this.frmrowItem.ORCHK=false
			}
			this.getReserve2()
		}
	}
	checkAllFrmAction(e, type){
		if(type){
			let actions=[];
			let actiontext=[];
			let that=this;
			$('.frmAction:checkbox').each(function(){
				let actionName=that.actionItemOps[$(this).val()];
				if(that.filledItems&&that.filledItems[actionName.name]){
					$(this).prop('checked', false);
				}else{
					$(this).prop('checked', true);
					actions.push(actionName);
					actiontext.push(that.actionItemOps[$(this).val()].code);
				}
				
			})
			this.frmrowItem.CRCHK=this.filledItems['CR']? false:true;
			this.frmrowItem.PRCHK=this.filledItems['PR']? false:true;
			this.frmrowItem.PR90CHK=this.filledItems['PR-90']? false:true;
			//this.frmrowItem.ORCHK=true;
			this.frmrowItem['ACTION']=actions;
			this.frmrowItem['actions']=actiontext;
			this.frmrowItem['actiontext']=actiontext.join(', ');
		}else{
			$('.frmAction:checkbox').each(function(){
				$(this).prop('checked', false);
			})
			this.frmrowItem.CRCHK=false;
			this.frmrowItem.PRCHK=false;
			this.frmrowItem.PR90CHK=false;
			//this.frmrowItem.ORCHK=true;
			this.frmrowItem['ACTION']=[];
			this.frmrowItem['actions']=[];
			this.frmrowItem['actiontext']='';
		}
		this.getReserve2()
	}
	saveFrmData(frmData, doc){
		doc['frmData']=frmData;
		//this.autoSave('frm',doc.id, doc.SECTION_TITLE, "O" );		
		if(this.onlock!=='frm_sec'&&this.onlock.indexOf('frm_sec')>-1){
			let sec=this.getSecbyId(this.contents, this.onlock);
			let data=this.getfrmSecData(frmData, this.onlock);
			sec['data']=data;
		}
	}
	getfrmSecData(frmData, secId){
		let data={};
		const dataset=this.frmService.secDataSet[secId];
		if(dataset){
			let keys=Object.keys(dataset);
			for(let key of keys){
				let val=dataset[key];
				if(key==='PropertyConditionAssessment'){
					data[key]=[{}];
				}
				if(val.length>0){
					for(let item of val){
						if(key==='PropertyConditionAssessment'){//console.log(item)
							if(frmData[key][0][item]){
								data[key][0][item]=JSON.parse(JSON.stringify(frmData[key][0][item]));
							}
							
						}else{
							if(!data[key]){							
								data[key]={};
							}
							
							if(frmData[key][item]){
								data[key][item]=JSON.parse(JSON.stringify(frmData[key][item]));
							}
						}
					}
				}else{
					if(frmData[key]){//console.log(key)
						data[key]=JSON.parse(JSON.stringify(frmData[key]));
					}
					
				}
			}
		}
		return data
	}
	updateFrmData:any;
	secToFrmdata(sec){
		let data=sec.data;
		const dataset=this.frmService.secDataSet[sec.id];
		let frmsec=this.getSecbyId(this.contents, 'frm_sec');
		let localsec=this.getSecbyId(this.contents, sec.id);
		localsec.data=structuredClone(data);
		let frmData=frmsec.frmData;
		if(dataset){
			let keys=Object.keys(dataset);
			for(let key of keys){
				let val=dataset[key];
				if(data[key]){
					if(val.length>0){
						for(let item of val){
							if(key==='PropertyConditionAssessment'){
								if(data[key][0][item]&&data[key][0][item]!==frmData[key][0][item]){
									frmData[key][0][item]=JSON.parse(JSON.stringify(data[key][0][item]));
								}
								
							}else{
								if(data[key][item]&&data[key][item]!==frmData[key][item]){
									frmData[key][item]=JSON.parse(JSON.stringify(data[key][item]));
								}
							}
						}
					}else{
						if(data[key]!==frmData[key]){
							frmData[key]=JSON.parse(JSON.stringify(data[key]));
						}
					}
				}
			}
		}
		frmsec.frmData=frmData;
		this.updateFrmData={id:sec.id, data:structuredClone(data)};
	}
	deleteFrmRow(index,sec?){
		let type:string;
		let tabledata:any;
		if(sec.data){
			tabledata=sec.data;
		}			
		let that=this;
		Swal.fire({
			icon:'warning',
			title: 'Are you sure you want to delete this item?',
			confirmButtonText: 'Delete',
			showLoaderOnConfirm: true,
			showCancelButton: true,
			backdrop:false,
			preConfirm: async () => {
				let id=tabledata.rows[index][0].costId;
				tabledata.rows=tabledata.rows.filter(row => row[0].costId!=id);
				tabledata.COST=tabledata.COST.filter(item => item.costId!=id);
				that.getAllCostTable();						
				this.autoSave('modify',sec.id, sec.SECTION_TITLE,'O');								
			}
		})
	
	}
	/*WEBSPELLCHECKER_CONFIG = {     
        serviceId:'dumdnwpRp8c3aSc',
        autoSearch:true,
        autoStartup:false,
    };*/
	searchText='';
	replaceText="";
	checkOn=true;
	caseOn=false;
	matchShow=false;
	allMatchtext='';
	allMatch=0;
	checkOnAll=false;
	checking=false;
	spellCheckErr=''
	async spellCheckAll(){
		if (this.blockMultiUser()) return;
		this.checkOnAll=!this.checkOnAll;
		if(!this.checkOnAll){
			this.matchShow=false;
			this.allMatch=0;
			this.allMatchtext='';
			return
		}		
		this.checking=true;
		this.matchShow=true;
		this.spellCheckErr='';
		this.curId=null; 
		this.allMatchtext='';
		this.searchText="";
		this.replaceText="";
		this.replaceShow=false;
		//let allMatched=[]
		let data:string;
		data=this.getAllText();
		let textarray=this.divideText2(data);// console.log(textarray)
		try {
			let arr=[]	
			for(let chunk of textarray){
				//this.reportService.checkAll(data).subscribe(response => {
				//console.log(chunk.length)
				const response = await this.reportService.checkAll(chunk).toPromise();
				let allMatched=response['result'][0]['matches'];//console.log(allMatched)
				let chunkarr=this.getAllMatch(chunk, allMatched);	//console.log(chunkarr)
				if(chunkarr.length>0){
					arr.push(... chunkarr);
				}			
				//console.log(this.allMatchtext);
			}
			//console.log(arr.length)
			let uniqueArray = arr.filter(function(item, pos) {
				return arr.indexOf(item) == pos;
			})
			this.allMatch=uniqueArray.length;
			if(this.allMatchtext.length>0){
				for(let key of uniqueArray){
					this.allMatchtext+='|'+key;
				}
			}else{
				this.allMatchtext=uniqueArray[0]
				for(let key of uniqueArray.slice(0)){
					this.allMatchtext+='|'+key;
				}
			}	
			//console.log(this.allMatch);
			//console.log(this.allMatchtext);
			this.checkOnAll=true;
			this.checking=false;
		} catch (error) {//console.log(error)	
			this.spellCheckErr='There was an error! '+ error;
			this.checking=false;	
		}		
	}
	getAllMatch(data, allMatched){
		//this.allMatch+=allMatched.length;
			let arr=[];
			if(allMatched&&allMatched.length>0){
				for(let item of allMatched){
					let word=data.substring ( item.offset, item.offset+item.length);
					let t={'text':word, 'suggestions':item.suggestions};
					arr.push(word);					
				}				
			}
			return arr
	}
	spellCheck(){
		if (this.blockMultiUser()) return;
		this.checkOn=!this.checkOn;//console.log(this.checkOn)
		let wscInstances = WEBSPELLCHECKER.getInstances()[0];//console.log(wscInstances)
		//console.log(wscInstances.isDisabled())
		if(this.checkOn){
			wscInstances.enable();
			/*WEBSPELLCHECKER.init({			
				autoStartup: true,
			})*/
		}else{
			wscInstances.disable();
			/*WEBSPELLCHECKER.init({			
				autoStartup: false,
			})*/
		}
		
		/*console.log(sapling)
		window.Sapling.init({
			key: 'VVYUUOR3NFRBWCS6A6E7B22AKYXJ04TZ',
			endpointHostname: 'https://api.sapling.ai',
			editPathname: '/api/v1/edits',
			statusBadge: true,
			mode: 'dev',
		  });
		console.log(this.editor1)
		const editor = this.editor1.nativeElement;//.querySelectorAll('app-edit-input')//document.getElementById('editor1');
		if (editor) {
			//sapling.observe(editor);
			sapling.unobserve(editor);
		}
		*/
	}
	/*changeText(e){
		e.preventDefault();
		console.log(e)
		let data = e.detail.text;console.log(data)
		let selection = window.getSelection();console.log(selection);
		e.keepHighlight =true;
	}*/
	async replaceAllRF(text){
		//if(this.replaceText.length==0) return
		let allRF=this.getAllSlotInfo(); 
		for(let rf of allRF){
			const re = new RegExp("\\b("+text+"\\b)", 'igm');
			const searchString=' '+text+' ';
			const replaceString=this.replaceText;
			let newString='';
			let result = rf.CONTENT.match(re);
			if(result&&result.length>0){
				newString=rf.CONTENT.replace(re, replaceString);
				await this.updateSlot(rf.SLOT_ID, newString, 'local');	//this.newreplaceContent(response, 'local');			
			}
		}
	}
	replacing=false;
	async replaceAllText(){
		if (this.blockMultiUser()) return;
		this.searchText=this.searchText.trim();
		if(!this.searchText) return
		let validstext= this.checkCha(this.searchText);
		if(validstext){
			Swal.fire({
				icon: 'info',
				title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
            })
			return
		}
		if(this.replaceText.length>0){
			let validtext=this.checkCha(this.replaceText);
			if(validtext){
				Swal.fire({
					icon: 'info',
					title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
				})
				return
			}
		}
		
		await this.replaceAllRF(this.searchText);//change rf content
		//const re = new RegExp("\\b("+this.searchText+"\\b)", 'igm');
		this.replacing=true;
		//const re = new RegExp("\\b("+this.searchText+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", 'igm');
		const re = new RegExp("\\b"+this.searchText+"(?!([^<]*?)>)\\b",'igm');
		const replaceString=this.replaceText;
		//const replaceHtml=' '+this.replaceText+' ';
		let ifReplace=false;
		let ifsummary=false;
		let iftitle=false;
		try{
		for(let appendix of this.appendices.SUB_SECTIONS){
			let result = appendix.SECTION_TITLE.match(re);
			if(result&&result.length>0){
				appendix.SECTION_TITLE=appendix.SECTION_TITLE.replace(re, replaceString);
				ifReplace=true;					
			}
		}
		if(ifReplace){
			this.autoSave('appendix update',"appendix update","appendix update");
			ifReplace=false
		}
		
		//for(let doc of this.contents){
			if(this.pdfFname['text'].length>0){	
				let result = this.pdfFname['text'].match(re);
				if(result&&result.length>0){			
				this.pdfFname['text']= this.pdfFname['text'].replace(re, replaceString);	
				}
			}
			for(let sec of this.frontpages){
				if(sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0){
					let result = sec.SECTION_TITLE.match(re);
					if(result&&result.length>0){
						sec.SECTION_TITLE=sec.SECTION_TITLE.replace(re, replaceString);					
					}
				}
				if(sec.text&&sec.text.length>0){
					let result = sec.text.match(re);
					if(result&&result.length>0){
						sec.text=sec.text.replace(re, replaceString);
						sec.text=this.retriveRFKEY(sec.text)
						sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
					}
				}
				if(sec.SUB_SECTIONS){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0){
						let result = sec1.SECTION_TITLE.match(re);
						if(result&&result.length>0){
							sec1.SECTION_TITLE=sec1.SECTION_TITLE.replace(re, replaceString);					
						}
					}
					if(sec1.text&&sec1.text.length>0){
						sec1.text=sec1.text.replace(re, replaceString);
						sec1.text=this.retriveRFKEY(sec1.text)
						sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
					}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])&&(sec1.id!='phaseI_project_summary_table')){
						this.checkExtraHeaderLock(re, replaceString, sec1.data);
						if(!sec1.data['locked']||(!sec1.data['locked']['header'])){//no header Lock
							for(let col of sec1.data.cols){
								let result = col.NAME.match(re);
								if(result&&result.length>0){
									col.NAME=col.NAME.replace(re, replaceString);
									col.text=col.text.replace(re, replaceString);
									col.NAME=this.retriveRFKEY(col.NAME)
									if(col.htmltext){
										col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
									}
								}
							}
						}
						for(let row of sec1.data.rows){
							if(row['lock']){//row Lock
								continue
							}else{
								if(row.items&&row.items.length>0){
									for(let i=0; i<row.items.length; i++){//console.log(item)
										let item=row.items[i]
										if(sec1.data.cols[i]['lock']||item['lock']){//column lock/cell lock
											continue
										}else{
											if(item.htmltext&&item.htmltext.length>0){
												//item.DATA=item.DATA.replace(re, replaceString);
												let result = item.htmltext.match(re);
												if(result&&result.length>0){
													item.htmltext=item.htmltext.replace(re, replaceString);	
													item.htmltext=this.retriveRFKEY(item.htmltext)
													item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
												}
											}	
										}								
									}
								}
							}
						}
						
					}/*else if(sec1.id=='phaseI_project_summary_table'){
						for(let row of sec1.data.rows){//console.log(row)
							for(let item of row){//console.log(item)
								if(item.html&&item.html.length>0){
									item.html=item.html.replace(re, replaceString);
									item.secHtml=item.secHtml.replace(re, replaceString);	
								}
							}
							
						}
					}*/else if(sec1.TYPE=='PHOTOS'&&sec1.photos.length>0){
						for(let photo of sec1.photos){
							if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
								let result = photo.FILE_DESCRIPTION.match(re);
								if(result&&result.length>0){
									photo.FILE_DESCRIPTION=photo.FILE_DESCRIPTION.replace(re, replaceString);	
								}								
							}
						}
					}
				}
				}
			}
			for(let sec of this.contents){
				if(sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0){
					let result = sec.SECTION_TITLE.match(re);
					if(result&&result.length>0){
						sec.SECTION_TITLE=sec.SECTION_TITLE.replace(re, replaceString);
						iftitle=true
					}
				}
				if(sec.text&&sec.text.length>0){
					let result = sec.text.match(re);
					if(result&&result.length>0){
						sec.text=sec.text.replace(re, replaceString);
						sec.text=this.retriveRFKEY(sec.text)
						//sec.htmltext=sec.htmltext.replace(re, replaceString);	
						sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
					}
				}
				if(sec.pisummarydata&&sec.pisummarydata.length>1){
					for(let item of sec.pisummarydata){//console.log(row)
						if(item.html&&item.html.length>0){
							let result = item.html.match(re);
							if(result&&result.length>0){
								item.html=item.html.replace(re, replaceString);
								item.secHtml=item.secHtml.replace(re, replaceString);
								ifsummary=true
							}	
						}					
					}
				}else if(sec.pcasummarydata&&sec.pcasummarydata.length>1){
					for(let item of sec.pcasummarydata){//console.log(row)
						if(!item.cat&&item.inputType!='Checkmark'){
							let result = item.data.match(re);
							if(result&&result.length>0){
								item.data=item.data.replace(re, replaceString);
								//item.secHtml=item.secHtml.replace(re, replaceString);
								ifsummary=true	
							}
						}					
					}
				}
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0){
						let result = sec1.SECTION_TITLE.match(re);
						if(result&&result.length>0){
							sec1.SECTION_TITLE=sec1.SECTION_TITLE.replace(re, replaceString);
							iftitle=true
						}
					}
					if(sec1.text&&sec1.text.length>0){
						sec1.text=sec1.text.replace(re, replaceString);
						sec1.text=this.retriveRFKEY(sec1.text)
						//sec1.htmltext=sec1.htmltext.replace(re, replaceString);	
						sec1.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec1.text);
					}else if(sec1.TYPE=='TABLE'&&sec1.data&&(!sec1.data['erisName'])){
						this.checkExtraHeaderLock(re, replaceString, sec1.data);
						if(!sec1.data['locked']||(!sec1.data['locked']['header'])){//no header Lock
							for(let col of sec1.data.cols){
								let result = col.NAME.match(re);
								if(result&&result.length>0){
									col.NAME=col.NAME.replace(re, replaceString);
									col.NAME=this.retriveRFKEY(col.NAME)
									col.text=col.text.replace(re, replaceString);
									if(col.htmltext){
										col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
									}
								}
							}
						}
						for(let row of sec1.data.rows){
							if(row['lock']){//row Lock
								continue
							}else{
								if(row.items&&row.items.length>0){
									for(let i=0; i<row.items.length; i++){//console.log(item)
										let item=row.items[i]
										if(sec1.data.cols[i]['lock']||item['lock']){//column lock/cell lock
											continue
										}else{
											if(item.htmltext&&item.htmltext.length>0){
												//item.DATA=item.DATA.replace(re, replaceString);
												let result = item.htmltext.match(re);
												if(result&&result.length>0){
													item.htmltext=item.htmltext.replace(re, replaceString);	
													item.htmltext=this.retriveRFKEY(item.htmltext)
													item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
												}
											}
										}
									}
								}
							}
						}
					
					}else if(sec1.TYPE=='TABLE'&&sec1.data&&sec1.data['erisName']){console.log(sec1.data)
						for(let col of sec1.data.cols){
							if(col.NAME&&col.INTERNALNAME!="ES_RID"&&col.NAME.length>0){
								let result = col.NAME.match(re);
								if(result&&result.length>0){
									col.NAME=col.NAME.replace(re, replaceString);
									if(col.text){
										col.text=col.text.replace(re, replaceString);
									}
									ifReplace=true;		
								}
							}
						}
						for(let row of sec1.data.rows){
							for(let cell of row){
								if(cell.COLUMNINTERNALNAME!="ES_RID"&&cell.DATA&&cell.DATA.length>0){
									let result = cell.DATA.match(re);
									if(result&&result.length>0){
										cell.DATA=cell.DATA.replace(re, replaceString);
										if(cell.HTML&&cell.HTML.length>0){
											cell.HTML=cell.HTML.replace(re, replaceString);	
											cell.HTML=this.retriveRFKEY(cell.HTML)
											cell.SEC=this.sanitizer.bypassSecurityTrustHtml(cell.HTML);
										}
										ifReplace=true;	
									}	
								}
							}
							
						}
						if(ifReplace){
							//console.log(sec1.data)
							this.curErisData=sec1.data,
							this.curEris=sec1,
							this.saveErisRecord(sec1.data.rows)
							ifReplace=false
						}
						
					}/*else if(sec1.id=='phaseI_project_summary_table'){
						for(let row of sec1.data.rows){//console.log(row)
							for(let item of row){//console.log(item)
								if(item.html&&item.html.length>0){
									item.html=item.html.replace(re, replaceString);
									item.secHtml=item.secHtml.replace(re, replaceString);	
								}
							}
							
						}
					}*/else if(sec1.id=='pca_summary_0'){
						for(let row of sec1.data.rows){//console.log(row)
							for(let item of row){//console.log(item)
								if(item.htmltext&&item.htmltext.length>0){
									let result = item.htmltext.match(re);
									if(result&&result.length>0){
										item.htmltext=item.htmltext.replace(re, replaceString);
										item.htmltext=this.retriveRFKEY(item.htmltext);
										item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);	
									}								
								}
							}
							
						}
					}else if(sec1.TYPE=='PHOTOS'&&sec1.photos.length>0){
						for(let photo of sec1.photos){
							if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
								let result = photo.FILE_DESCRIPTION.match(re);
									if(result&&result.length>0){
										photo.FILE_DESCRIPTION=photo.FILE_DESCRIPTION.replace(re, replaceString);	
									}								
							}
						}
					}
					if(sec1.pisummarydata&&sec1.pisummarydata.length>1){
						for(let item of sec1.pisummarydata){//console.log(row)
							if(item.html&&item.html.length>0){
								let result = item.html.match(re);
								if(result&&result.length>0){
									item.html=item.html.replace(re, replaceString);
									item.html=this.retriveRFKEY(item.html);
									item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.html);		
									ifsummary=true
								}	
							}					
						}
					}else if(sec1.pcasummarydata&&sec1.pcasummarydata.length>1){
						for(let item of sec1.pcasummarydata){//console.log(row)
							if(!item.cat&&item.inputType!='Checkmark'){
								let result = item.data.match(re);
								if(result&&result.length>0){
									item.data=item.data.replace(re, replaceString);
									//item.secHtml=item.secHtml.replace(re, replaceString);	
									ifsummary=true
								}
							}					
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
					for(let sec2 of sec1.SUB_SECTIONS){	
						if(sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0){
							let result = sec2.SECTION_TITLE.match(re);
							if(result&&result.length>0){
								sec2.SECTION_TITLE=sec2.SECTION_TITLE.replace(re, replaceString);
								iftitle=true
							}
						}				
						if(sec2.text&&sec2.text.length>0){
							let result = sec2.text.match(re);
							if(result&&result.length>0){
								sec2.text=sec2.text.replace(re, replaceString);
								sec2.text=this.retriveRFKEY(sec2.text);
								//sec2.htmltext=sec2.htmltext.replace(re, replaceString);	
								sec2.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec2.text);
							}
						}else if(sec2.TYPE=='TABLE'&&sec2.data&&(!sec2.data['erisName'])){
							this.checkExtraHeaderLock(re, replaceString, sec2.data);
							if(!sec2.data['locked']||(!sec2.data['locked']['header'])){//no header Lock
								for(let col of sec2.data.cols){
									let result = col.NAME.match(re);
									if(result&&result.length>0){
										col.NAME=col.NAME.replace(re, replaceString);
										col.NAME=this.retriveRFKEY(col.NAME)
										col.text=col.text.replace(re, replaceString);
										if(col.htmltext){
											col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
										}
									}
								}
							}
						for(let row of sec2.data.rows){
							if(row['lock']){//row Lock
								continue
							}else{
								if(row.items&&row.items.length>0){
									for(let i=0; i<row.items.length; i++){//console.log(item)
										let item=row.items[i]
										if(sec2.data.cols[i]['lock']||item['lock']){//column lock/cell lock
											continue
										}else{
											if(item.htmltext&&item.htmltext.length>0){
												//item.DATA=item.DATA.replace(re, replaceString);
												let result = item.htmltext.match(re);
												if(result&&result.length>0){
														item.htmltext=item.htmltext.replace(re, replaceString);	
														item.htmltext=this.retriveRFKEY(item.htmltext)
														item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
												}
											}
										}
									}
								}
							}
						}
					
						}else if(sec2.TYPE=='TABLE'&&sec2.data&&sec2.data['erisName']){
							for(let col of sec2.data.cols){//console.log(col)
								if(col.NAME&&col.INTERNALNAME!="ES_RID"&&col.NAME.length>0){
									let result = col.NAME.match(re);
									if(result&&result.length>0){console.log(col)
										col.NAME=col.NAME.replace(re, replaceString);
										if(col.text){
											col.text=col.text.replace(re, replaceString);
										}
										ifReplace=true;		
									}										
								}
							}
							for(let row of sec2.data.rows){
								for(let cell of row){
										//cell.DATA=cell.DATA.replace(re, replaceString);
										if(cell.COLUMNINTERNALNAME!="ES_RID"&&cell.DATA&&cell.DATA.length>0){
											let result = cell.DATA.match(re);
											if(result&&result.length>0){
												cell.DATA=cell.DATA.replace(re, replaceString);
												if(cell.HTML&&cell.HTML.length>0){
													cell.HTML=cell.HTML.replace(re, replaceString);	
													cell.HTML=this.retriveRFKEY(cell.HTML)
													cell.SEC=this.sanitizer.bypassSecurityTrustHtml(cell.HTML);
												}
												ifReplace=true;	
											}							
										
									}
								}
							}
							if(ifReplace){
								this.curErisData=sec2.data,
								this.curEris=sec2,
								this.saveErisRecord(sec2.data.rows)
								ifReplace=false
							}
						}/*else if(sec2.TYPE=='4099e'){
							for(let row of sec2.data.rows){
								for(let cell of row){
									if(cell.DATA&&cell.DATA.length>0){
										cell.DATA=cell.DATA.replace(re, replaceString);
										cell.htmltext=cell.htmltext.replace(re, replaceString);	
										let val=$('<div>'+cell['htmltext']+'</div>')[0].innerText
										cell.data=val;console.log(cell.data);
									}
								}					
							}
				
						}*/else if(sec2.TYPE=='PHOTOS'&&sec2.photos.length>0){
							for(let photo of sec2.photos){
								if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
									let result = photo.FILE_DESCRIPTION.match(re);
									if(result&&result.length>0){
										photo.FILE_DESCRIPTION=photo.FILE_DESCRIPTION.replace(re, replaceString);	
									}								
								}
							}
						}
						if(sec2.pisummarydata&&sec2.pisummarydata.length>1){
							for(let item of sec2.pisummarydata){//console.log(row)
								if(item.html&&item.html.length>0){
									let result = item.html.match(re);
									if(result&&result.length>0){
										item.html=item.html.replace(re, replaceString);
										item.html=this.retriveRFKEY(item.html)
										item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.html);		
										ifsummary=true
									}
								}					
							}
						}else if(sec2.pcasummarydata&&sec2.pcasummarydata.length>1){
							for(let item of sec2.pcasummarydata){//console.log(row)
								if(!item.cat&&item.inputType!='Checkmark'){
									let result = item.data.match(re);
									if(result&&result.length>0){
										item.data=item.data.replace(re, replaceString);
										//item.secHtml=item.secHtml.replace(re, replaceString);	
										ifsummary=true
									}
								}					
							}
						}
				
					}
				}}
				}
			}
		
	} catch (e) {
		console.log('Replace All Error: ' + e);
		Swal.fire({
			icon: 'info',
			text: "Replacing encounter some errors, please try again",				
		})
		this.replacing=false;
	}
		if(this.summaryStatus&&ifReplace){
			if(this.summaryType=='PHASE I'){
				this.toTatalPISummary();
			}else if(this.summaryType=='PCA'){
				this.getTotalSummary();
			}
		}
		if(this.reportInfo.PCA_INDICATOR=='Y'&&iftitle){
			this.getTotalCost();
		}else if(this.reportInfo.PCA_INDICATOR=='4099e'&&iftitle){
			this.getTotalUl();
			this.getTotalCost1();
		}
		this.replacedSave();
		
	}
	curMatch=0;
	findNext(){
		let matches=$('mark');
		for(let matche of matches){
			matche.style['border']='none'
		}
		if(this.curMatch<matches.length-1){
			this.curMatch++
		}else{
			this.curMatch=0
		}
		//console.log(matches[this.curMatch]);
		if(matches[this.curMatch]){
			this.scroll(matches[this.curMatch].id);	
			matches[this.curMatch].style['border']='#f88411 4px solid';
		}
		//matches[this.curMatch].style['background-color']='red'	;
	}
	replaceShow=false;
	replaceShow1=false;
	findPrev(){
		let matches=$('mark');
		for(let matche of matches){
			matche.style['border']='none'
		}
		if(this.curMatch>0){
			this.curMatch--
		}else{
			this.curMatch=matches.length-1
		}
		//console.log(matches[this.curMatch]);
		//matches[this.curMatch].style['background-color']='red';
		if(matches[this.curMatch]){
			
			this.scroll(matches[this.curMatch].id);	
			matches[this.curMatch].style['border']='#f88411 4px solid';
		}
		
	}
	seclectedId='';
	async replaceSingle(){
		if (this.blockMultiUser()) return;
		this.searchText=this.searchText.trim();
		if(!this.searchText) return
		let validstext= this.checkCha(this.searchText);
		if(validstext){
			Swal.fire({
				icon: 'info',
				title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
            })
			return
		}
		if(this.replaceText){
			let valietext=this.checkCha(this.replaceText);
			if(valietext){
				Swal.fire({
					icon: 'info',
					title: "Find and Replace cannot run using Special Characters !@#$%^&*()+=\[\]{}:\\|<>\/?~. Please adjust your search.",				
				})
				return
			}
		}
		
		let matches=$('mark');
		if(matches.length==0) return
		this.replacing=true;
		//const re = new RegExp("\\b("+this.searchText+"\\b)", 'igm');
		//const re = new RegExp("\\b("+this.searchText+"(?=(?:[^><]*<[^<>]*>)*[^><]*$))\\b", 'igm');
		const re = new RegExp("\\b"+this.searchText+"(?!([^<]*?)>)\\b",'igm');
		const replaceString=this.replaceText;
		//let matches=$('mark'); console.log(matches)
		//console.log(matches[0].id)
		//this.scroll(matches[0].id)	
		let selectedele= matches[this.curMatch];
		let newid=Utils.uniqueIdGenerator();
		selectedele.id=newid;
		let rf=$(selectedele).parent(); console.log(rf); console.log(rf.attr('class'))
		let ele=$(selectedele).closest(".replaceContainer");console.log(ele)
		let secx=$(selectedele).closest(".replaceContainer").attr('data-x');//console.log(secx)
		let secy=$(selectedele).closest(".replaceContainer").attr('data-y');//console.log(secy)
		let secv=$(selectedele).closest(".replaceContainer").attr('data-v');//console.log(secv)
		let secw=$(selectedele).closest(".replaceContainer").attr('data-w');//console.log(secw)
		let secz=$(selectedele).closest(".replaceContainer").attr('data-z');//console.log(secz)
		let id=$(selectedele).closest(".replaceContainer").attr('data-id');	//console.log(id)//$(elem).parents(".myClass");
		let type=$(selectedele).closest(".replaceContainer").attr('data-type');	//console.log(type)
		let sec=this.getSecbyId(this.contents,id);
		let secMatchs=[];
		for(let item of matches){
			let itemid=$(item).closest(".replaceContainer").attr('data-id');
			if(type=='text'||type=='title'){
				if(itemid==id){
					secMatchs.push(item)
				}
			}else if(type=='table'||type=='pitable'||type=='pstable'||type=='eris'){
				let x=parseInt($(item).closest(".replaceContainer").attr('data-x'));
				let y=parseInt($(item).closest(".replaceContainer").attr('data-y'));
				let v=parseInt($(item).closest(".replaceContainer").attr('data-v'));
				let w=parseInt($(item).closest(".replaceContainer").attr('data-w'));
				let z=parseInt($(item).closest(".replaceContainer").attr('data-z'));
				if(secv>-1||secw>-1||secz>-1){//console.log(itemid, x, y)
					if(itemid==id&&((secx==x&&(secz==z||secw==w))||secv==v)){//console.log(itemid, x, y)
						secMatchs.push(item)
					}
				}else if(secy>-1&&y>-1){
					if(itemid==id&&secx==x&&secy==y){//console.log(itemid, x, y)
						secMatchs.push(item)
					}
				}else if(!(secy>-1)&&(!(y>-1))){//console.log(itemid, x, y)
					if(itemid==id&&secx==x){
						secMatchs.push(item)
					}
				}			
			}else if(type=='photo'){
				let x=parseInt($(item).closest(".replaceContainer").attr('data-x'));
				if(itemid==id&&secx==x){
					secMatchs.push(item)
				}
			}			
		}
		//console.log(secMatchs)
		let secIndex=secMatchs.findIndex(item=>item.id==newid); console.log(secIndex);
		if(secIndex==-1) return
		if(!sec){
			sec=this.getSecbyId(this.frontpages,id); console.log(sec);
		}
		try{
		if(rf.attr('class')&&rf.attr('class')=='placeholder'){
			console.log(rf)
			let status=rf.attr('data-status');
			if(status=='N'){
				this.replacing=false;
				Swal.fire({
					html: 'Repeat Field has no content!'
				})
				return
			}
			let id=parseInt(rf.attr('data-id'));		
			let index=this.allSlots.findIndex(slot=>slot.SLOT_ID==id);	
			if(index>-1){
				if(this.allSlots[index].TYPE=="Narrative"){
					//let newString=this.allSlots[index].CONTENT.replace(re, replaceString);
					let newString=this.replaceIndex(this.allSlots[index].CONTENT, re, secIndex, replaceString);
					await this.updateSlot(id, newString, 'local');
					this.replacing=false;
				}			
			}								
			return
		}
		if(type=='text'){
			//sec.text=sec.text.replace(re, replaceString);
			//sec.htmltext=sec.htmltext.replace(re, replaceString);	
			sec.text=this.replaceIndex(sec.text, re, secIndex, replaceString);
			sec.text=this.retriveRFKEY(sec.text)
			sec.htmltext=this.sanitizer.bypassSecurityTrustHtml(sec.text);
		}else if(type=='title'){
			//sec.SECTION_TITLE=sec.SECTION_TITLE.replace(re, replaceString);	
			sec.SECTION_TITLE=this.replaceIndex(sec.SECTION_TITLE, re, secIndex, replaceString);
			if(this.summaryStatus){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}
			}
			if(this.reportInfo.PCA_INDICATOR=='Y'){
				this.getTotalCost();
			}else if(this.reportInfo.PCA_INDICATOR=='4099e'){
				this.getTotalUl();
				this.getTotalCost1();
			}		
		}else if(type=='table'){
			let x=parseInt(ele.attr('data-x'));//console.log(x)
			let y=parseInt(ele.attr('data-y'));//console.log(y)
			let w=parseInt(ele.attr('data-w'));
			let z=parseInt(ele.attr('data-z'));
			let v=parseInt(ele.attr('data-v'));
			console.log(x, y, w, z, v)
			console.log(sec.data)
			if(v>-1){//caption
				let item=sec.data.caption;console.log(item)
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);
				if(item.NAME&&item.NAME.length>0){
					//item.text=item.text.replace(re, replaceString);	
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}
			}else if(w>-1){//after header
				if(sec.data&&sec.data['locked']&&sec.data['locked']['afterHeaders'].length>0){
					if(sec.data['locked']['afterHeaders'].indexOf(x)>-1){
						this.replacing=false;
						//Swal.fire('Header is locked, can not edit');
						return
					}					
				}
				let item=sec.data['afterHeaders'][x][w];console.log(item)
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);console.log(item.text)
				if(item.NAME&&item.NAME.length>0){
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);console.log(item.NAME)
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}	
			}else if(z>-1){//before header
				if(sec.data&&sec.data['locked']&&sec.data['locked']['beforeHeaders'].length>0){
					if(sec.data['locked']['beforeHeaders'].indexOf(x)>-1){
						this.replacing=false;
						//Swal.fire('Header is locked, can not edit');
						return
					}					
				}
				let item=sec.data['beforeHeaders'][x][z];console.log(item)
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);
				if(item.NAME&&item.NAME.length>0){
					//item.text=item.text.replace(re, replaceString);	
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);
					item.NAME=this.retriveRFKEY(item.NAME);
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}
			}else if(y>-1){
				if(sec.data&&sec.data.rows[x]&&sec.data.rows[x]['lock']){
					this.replacing=false;
					//Swal.fire('Row is locked, can not edit');
					return				
				}
				if(sec.data&&sec.data.cols[y]&&sec.data.cols[y]['lock']){
					this.replacing=false;
					//Swal.fire('Column is locked, can not edit');
					return
				}
				let item=sec.data.rows[x].items[y];
				if(item['lock']){
					this.replacing=false;
					//Swal.fire('Cell content is locked, can not edit');
					return
				}
				//let item=sec.data.rows[x].items[y];//console.log(item)
				//item.data=item.data.replace(re, replaceString);
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				if(item.htmltext&&item.htmltext.length>0){
					//item.htmltext=item.htmltext.replace(re, replaceString);	
					item.htmltext=this.replaceIndex(item.htmltext, re, secIndex, replaceString);
					item.htmltext=this.retriveRFKEY(item.htmltext)
					item.DATA=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
				}	
			}else{
				if(sec.data&&sec.data['locked']&&sec.data['locked']['header']){
					this.replacing=false;
					//Swal.fire('Header is locked, can not edit');
					return
				}
				let item=sec.data.cols[x];//console.log(item)
				//item.NAME=item.NAME.replace(re, replaceString);
				item.text=this.replaceIndex(item.text, re, secIndex, replaceString);
				if(item.NAME&&item.NAME.length>0){
					//item.text=item.text.replace(re, replaceString);	
					item.NAME=this.replaceIndex(item.NAME, re, secIndex, replaceString);
					item.NAME=this.retriveRFKEY(item.NAME)
					item.htmltext=this.sanitizer.bypassSecurityTrustHtml(item.NAME);
				}	
			}			
		}else if(type=='pitable'){
			let x=parseInt(ele.attr('data-x'));console.log(x)
			let y=parseInt(ele.attr('data-y'));console.log(y)
			let id=sec.data.rows[x][0].refId;
			let oriSec=this.getSecbyId(this.contents, id);
			let item:any;
			if(oriSec.pisummarydata){
				item=oriSec.pisummarydata[y];
			}else if(oriSec.pcasummarydata){
				item=oriSec.pcasummarydata[y];
			}
			console.log(oriSec)
			if(item.secHtml){
				//item.data=item.data.replace(re, replaceString);
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				//item.html=item.html.replace(re, replaceString);	
				item.html=this.replaceIndex(item.html, re, secIndex, replaceString);
				item.html=this.retriveRFKEY(item.html)
				item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.html);
			}else{
				//item.data=item.data.replace(re, replaceString);
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				if(item.ACTION){
					item.ACTION=item.data.split(',')
				}
				//item.html=item.html.replace(re, replaceString);	
			}	
			if(this.summaryStatus){
				if(this.summaryType=='PHASE I'){
					this.toTatalPISummary();
				}else if(this.summaryType=='PCA'){
					this.getTotalSummary();
				}
			}
		}else if(type=='pstable'){
			let x=parseInt(ele.attr('data-x'));console.log(x)
			let y=parseInt(ele.attr('data-y'));console.log(y)
			let item=sec.data.rows[x][y];console.log(item)
			if(item.htmltext&&item.htmltext.length>0){
				//item.data=item.data.replace(re, replaceString);	
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				//item.htmltext=item.htmltext.replace(re, replaceString);	
				item.htmltext=this.replaceIndex(item.htmltext, re, secIndex, replaceString);
				item.htmltext=this.retriveRFKEY(item.htmltext)
				item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
			}else{
				//item.data=item.data.replace(re, replaceString);	
				item.data=this.replaceIndex(item.data, re, secIndex, replaceString);
				//item.htmltext=item.htmltext.replace(re, replaceString);	
				//item.secHtml=this.sanitizer.bypassSecurityTrustHtml(item.htmltext);
			}	
		}else if(type=='eris'){
			let ifReplace=false
			let x=parseInt(ele.attr('data-x'));//console.log(x)
			let y=parseInt(ele.attr('data-y'));//console.log(y)
			
			if(!y){
				let col=sec.data.cols[x];//console.log(item)
				//col.NAME=col.NAME.replace(re, replaceString);
				col.NAME=this.replaceIndex(col.NAME, re, secIndex, replaceString);
			}else{
				let cell=sec.data.rows[x][y];//console.log(item)
				//cell.DATA=cell.DATA.replace(re, replaceString);
				cell.DATA=this.replaceIndex(cell.DATA, re, secIndex, replaceString);
				if(cell.HTML&&cell.HTML.length>0){
					//cell.HTML=cell.HTML.replace(re, replaceString);	
					cell.HTML=this.replaceIndex(cell.HTML, re, secIndex, replaceString);
					cell.HTML=this.retriveRFKEY(cell.HTML)
					cell.SEC=this.sanitizer.bypassSecurityTrustHtml(cell.HTML);	
				}			
			}
			this.curErisData=sec.data,
			this.curEris=sec,
			this.saveErisRecord(sec.data.rows)
			
		}else if(type=='photo'){
			let index=parseInt(ele.attr('data-x'));
			//sec.photos[index].FILE_DESCRIPTION=sec.photos[index].FILE_DESCRIPTION.replace(re, replaceString);		
			sec.photos[index].FILE_DESCRIPTION=this.replaceIndex(sec.photos[index].FILE_DESCRIPTION, re, secIndex, replaceString);	
		}
	} catch (e) {
		console.log('Replace Error: ' + e);
		this.replacing=false;
	}
		this.replacedSave();
	}
	getAllText(){
		if (this.blockMultiUser()) return;
		let data="";
		for(let page of this.frontpages){
			if(page.SECTION_TITLE&&page.SECTION_TITLE.length>0){
				data+=page.SECTION_TITLE+" "
			}
			if(page.text&&page.text.length>0){
				data+=page.text+" ";
			}
			if(page.SUB_SECTIONS&&page.SUB_SECTIONS.length>0){
				for(let page1 of page.SUB_SECTIONS){
					if(page1.SECTION_TITLE&&page1.SECTION_TITLE.length>0){
						data+=page1.SECTION_TITLE+" "
					}
					if(page1.text&&page1.text.length>0){
						data+=page1.text+" "
					}
					if(page1.TYPE=='TABLE'){
						if(page1.data){
							for(let header of this.headertype){
								if(page1.data[header]&&page1.data[header].length>0){
									for(let hrow of page1.data[header]){
										for(let hcell of hrow){
											data+=hcell.text+" "
										}
									}	
								}
							}
							for(let col of page1.data.cols){
								data+=col.text+" "
							}
							for(let row of page1.data.rows){
								if(row.items){
									for(let cell of row.items){
										if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.htmltext+" ";
										}
									}
								}else{
									for(let cell of row){
										if(cell.html&&cell.html.length>0){
											data+=cell.html+" ";
										}else if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.data+" ";
										}
									}
								}
								
								
							}
						}
						
					}
				}
			}
			
			
		}
		for(let sec of this.contents){
			if(sec.SECTION_TITLE&&sec.SECTION_TITLE.length>0){
				data+=sec.SECTION_TITLE+" ";
			}
			if(sec.text&&sec.text.length>0){
				data+=sec.text+" "
			}
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.SECTION_TITLE&&sec1.SECTION_TITLE.length>0){
						data+=sec1.SECTION_TITLE+" ";
					}
					if(sec1.text&&sec1.text.length>0){
						data+=sec1.text+" "
					}
					if(sec1.TYPE=='TABLE'||sec1.TYPE=='PITABLE'||sec1.id=='pca_summary_1'||sec1.id=='pca_summary_0'){
						if(sec1.data){
							if(sec1.TYPE=='TABLE'){
								for(let header of this.headertype){
									if(sec1.data[header]&&sec1.data[header].length>0){
										for(let hrow of sec1.data[header]){
											for(let hcell of hrow){
												data+=hcell.text+" "
											}
										}	
									}
								}
								for(let col of sec1.data.cols){
									if(col.NAME&&col.NAME.length>0){
										if(col.INTERNALNAME&&col.INTERNALNAME=="ES_RID") continue
										data+=col.NAME+" "
									}else if(col.text&&col.text.length>0){
										data+=col.text+" "
									}
									
								}
							}
							for(let row of sec1.data.rows){
								if(row.items&&row.items.length>0){
									for(let cell of row.items){//console.log(cell)
										if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.data+" ";
										}
									}
								}else{
									for(let cell of row){
										if(cell.html&&cell.html.length>0){
											data+=cell.html+" ";
										}else if(cell.htmltext&&cell.htmltext.length>0){
											data+=cell.htmltext+" ";
										}else if(cell.HTML&&cell.HTML.length>0){
											data+=cell.HTML+" ";
										}else if(cell.DATA&&cell.DATA.length>0){
											if(cell.COLUMNINTERNALNAME&&cell.COLUMNINTERNALNAME=="ES_RID") continue
											data+=cell.DATA+" ";
										}else if(cell.data&&cell.data.length>0){
											data+=cell.data+" ";
										}
									}
								}								
							}
						}						
					}
					if(sec1.TYPE=='PHOTOS'&&sec1.photos.length>0){
						for(let photo of sec1.photos){
							if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
								data+=photo.FILE_DESCRIPTION+" ";									
							}
						}
					}
					if(sec1.SUB_SECTIONS&&sec1.SUB_SECTIONS.length>0){
						for(let sec2 of sec1.SUB_SECTIONS){
							if(sec2.SECTION_TITLE&&sec2.SECTION_TITLE.length>0){
								data+=sec2.SECTION_TITLE+" ";
							}
							if(sec2.text){
								data+=sec2.text+" "
							}
							if(sec2.TYPE=='TABLE'){
								if(sec2.data){
									for(let header of this.headertype){
										if(sec2.data[header]&&sec2.data[header].length>0){
											for(let hrow of sec2.data[header]){
												for(let hcell of hrow){
													data+=hcell.text+" "
												}
											}	
										}
									}
									for(let col of sec2.data.cols){
										if(col.NAME&&col.NAME.length>0){
											if(col.INTERNALNAME&&col.INTERNALNAME=="ES_RID") continue
											data+=col.NAME+" "
										}else if(col.text&&col.text.length>0){
											data+=col.text+" "
										}
									}
									for(let row of sec2.data.rows){
										if(row.items){
											for(let cell of row.items){
												if(cell.htmltext&&cell.htmltext.length>0){
													data+=cell.htmltext+" ";
												}else if(cell.data&&cell.data.length>0){
													data+=cell.data+" ";
												}												
											}
										}else{
											for(let cell of row){
												if(cell.html&&cell.html.length>0){
													data+=cell.html+" ";
												}else if(cell.htmltext&&cell.htmltext.length>0){
													data+=cell.htmltext+" ";
												}else if(cell.HTML&&cell.HTML.length>0){
													data+=cell.HTML+" ";
												}else if(cell.DATA&&cell.DATA.length>0){
													if(cell.COLUMNINTERNALNAME&&cell.COLUMNINTERNALNAME=="ES_RID") continue
													data+=cell.DATA+" ";
												}else if(cell.data&&cell.data.length>0){
													data+=cell.data+" ";
												}
											}
										}								
									}
								}						
							}
							if(sec2.TYPE=='PHOTOS'&&sec2.photos.length>0){
								for(let photo of sec2.photos){
									if(photo.FILE_DESCRIPTION&&photo.FILE_DESCRIPTION.length>0){
										data+=photo.FILE_DESCRIPTION+" ";									
									}
								}
							}
							
						}
					}
				}
			}
			
			
		}
		//console.log(data)
		data=data.replace(/\&nbsp;/g, ' ').replace(/<[^>]*>?/gm, '').replace(/[^a-zA-Z0-9]/g, " ");//console.log(data)
		return data
	}
	replaceToggle(){
		if (this.blockMultiUser()) return;
		this.curId=null; 
		this.listid=null;
		this.replaceShow=!this.replaceShow;
		this.searchText="";
		this.replaceText="";
		this.allMatchtext='';
		this.matchShow=false;
		this.checkOnAll=false;
		this.caseOn=false;
		this.curMatch=0
	}
	retriveRFKEY(text){//console.log(text)
		let that=this;
		//let cleanText = text.replace(/[,\/#!$%\^&\*;:=\-_`~]/g, '');
		let cleanText = text.replace(/[,#!$%\^&\*;.:_`~]/g, '');//console.log(cleanText)//replace(/[,\/#!$%\^&\*;:{}=\-_`~()]/g, '');
		let slots=$(cleanText).find('.placeholder'); //console.log('toslot',slots);
		slots.each(function(){//console.log(this);
			let id=$(this).data('id'); //console.log(id);
			let status=$(this).data('status');//console.log(status)
			let index=that.allSlots.findIndex(slot=>slot.SLOT_ID==id);//console.log(index);
			if(index>-1){
				let slotItem=that.allSlots[index];//console.log(slotItem.KEY, slotItem.CONTENT)
				if(!slotItem.CONTENT&&slotItem.CONTENT.length==0){
					let a1=$(this).prop('outerHTML');	//console.log(a1);			
					$(this).html('{'+slotItem.KEY+'}');
					let a2=$(this).prop('outerHTML');	//console.log(a2);		
					text=text.replaceAll(a1, a2);//console.log(text);		
				}else if(status=='N'){
					let a1=$(this).prop('outerHTML');			
					$(this).html('{'+slotItem.KEY+'}');
					let a2=$(this).prop('outerHTML');	
					text=text.replaceAll(a1, a2);
				}else if(slotItem.TYPE=='Selection'){
					let a1=$(this).prop('outerHTML');
					$(this).html(slotItem.CONTENT);
					let a2=$(this).prop('outerHTML');
					text=text.replaceAll(a1, a2);
				}
			}			
		})
		
		return text		
	}
	replaceIndex(text, string, at, repl) {
		let m=0;
		let newtext=text.replace(string, function(match) {
			m++
			 if(m === at+1 ) return repl;
	 
			 return match;
		 });
		 return newtext
	}
	async replacedSave(){
		let beforeToc='';
			if(this.frontpages.length>0){
				beforeToc=JSON.stringify(this.frontpages);
			}
			let app=JSON.stringify(this.appendices);
			let pdfInfo={'text':this.pdfFname['text'], "name":this.pdfFname.name};
			let inputJson:any;
			if(this.curReport){
				inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":this.curReport.REPORT_ID,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(this.contents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":app,'PCA_DATA':JSON.stringify(this.pcaOp), 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'', "PERCENT_COMPLETE":'0%',"REVIEWER_PROGRESS":'0%'};
				console.log(inputJson);
			}
			const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log(data);
			if(this.replacing){
				this.replacing=false;
			}
			if (data.RESPONSE_STATUS=='N') {			
				this.throwError(data);
				return							
			}

			if (environment.api.autoSave.toUpperCase() == "Y"){
				
				let that=this;
				window.clearInterval(that.saveTimer);
				window.setTimeout(function() {}, environment.api.autoSaveInterval);
				that.saveTimer = window.setInterval(function () {
					that.autoSave('auto save');
				}, environment.api.autoSaveInterval);
			}
	}
	async replaceCheck(){
		if(this.listid||this.curId){
			//if (this.blockMultiUser()) return;
			await this.autoSave('manual save');
			this.curId=null;
			this.listid=null;
		}		
	}
	checkCha(str){//console.log(str)
		const specialChars =this.reportService.specialChar;//console.log(specialChars)// /[`!@#$%^&*()+=\[\]{}:\\|<>\/~]/;///[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
		const result = specialChars.split('').some(specialChar1 => {
			if (str.includes(specialChar1)) {
			  return true;
			}
		
			return false;
		  });
		//let result = specialChars.test(str);
		//console.log(result)
		return result
	}
	table6label=["SITE","STRUCTURAL, BUILDING ENVELOPE AND COMMON AREA FURNITURE, FIXTURES AND EQUIPMENT","MECHANICAL AND ELECTRICAL","DWELLING UNITS", 'TOTALS'];
	frmZoomTitle='';
	frmZoomData:any;
	frmTableZoom(e){
		//console.log(data)
		let index=parseInt(e);
		let sec=this.getSecbyId(this.contents, 'frm_sec');
		$("#frmZoomModal").modal('show');
		this.frmZoomTitle=this.table6label[index]
		this.frmZoomData=sec.frmData.sec6tablesdata[index];	
	}
	validateInput(e, data, field, type?){
		if(e && e.target){
			e.stopPropagation();      
		}
		let value=e.target.value;
		if(value&&parseInt(value)>-1){
			if(type){
				e.target.value=this.getRound1(value, 1);
			}else{
				e.target.value=this.getRound1(value, 0);				
			}
		}else{
			e.target.value=0;			
		}
		
		data[field]=e.target.value;
	  }
	curUnit={
		"BedroomCount": 0,
		"BathroomCount": 0,
		"AvgSquareFeetNumber": 0,
		"StyleType": "Garden or Flat",
		"PptyUnitTypeOccupiedUnitCount": 0,
		"VacantUnitCount": 0,
		"PptyUnitTypeDownUnitCount": 0,
		"PptyUnitTypeOtherUnitCount": 0,
		"PptyUnitTypeOccupiedInspectedUnitCount": 0,
		"PptyUnitTypeVacantInspectedUnitCount": 0,
		"PptyUnitTypeDownInspectedUnitCount": 0,
		"PptyUnitTypeOtherInspectedUnitCount": 0
		};
	insertUnit(){
		let group=this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; console.log(group)
		let newUnit=JSON.parse(JSON.stringify(this.curUnit))
		group.push(newUnit);
	  }
	  deleteUnit(){
		Swal.fire({
				icon:'warning',
				title: 'This will erase the last line. Is this what you want to do?',
				confirmButtonText: 'Yes',
				showCancelButton: true,
				backdrop:false,
			preConfirm: () => {
		  let group=this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix; console.log(group)
		  group.pop();
		  this.addUnit1();
		  this.addUnit2();
		  this.getTotalUnit();	
		  this.getTotalUnit1();	  
		}
	  })
	  }	
	  addUnit1(e?, index?, field?){
		if(index>-1){
		  let value=e.target.value;
		  if(value&&parseInt(value)>-1){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=parseInt(value);
		  }else{
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=0;
		  }
		}    
		console.log(this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix)
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOccupiedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalVacantUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.PptyTotalDownUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount=0;
		for(let row of this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOccupiedUnitCount+=row.PptyUnitTypeOccupiedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalVacantUnitCount+=row.VacantUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.PptyTotalDownUnitCount+=row.PptyUnitTypeDownUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount+=row.PptyUnitTypeOtherUnitCount;
		}
		this.getTotalUnit();	
		this.getTotalUnit1();	
	  }
	  addUnit2(e?, index?, field?){
		if(index>-1){
		  let value=e.target.value;
		  if(value&&parseInt(value)>-1){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=parseInt(value);
		  }else{
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix[index][field]=0;
		  }
		}  
		console.log(this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix)
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOccupiedInspectedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlVacantInspectedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlDownInspectedUnitCount=0;
		this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOtherInspectedUnitCount=0;
		for(let row of this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMix){
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOccupiedInspectedUnitCount+=row.PptyUnitTypeOccupiedInspectedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlVacantInspectedUnitCount+=row.PptyUnitTypeVacantInspectedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlDownInspectedUnitCount+=row.PptyUnitTypeDownInspectedUnitCount;
			this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.RsdntlOtherInspectedUnitCount+=row.PptyUnitTypeOtherInspectedUnitCount;
		}
		this.getTotalUnit();
		
	  }
	  addUnit3(index,e?, field?){
		if(index>-1){
		  let value=e.target.value;
		  if(value&&parseInt(value)>-1){
			this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[index][field]=parseInt(value);
		  }else{
			this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[index][field]=0;
		  }
		}
		//console.log(this.PropertyTotalRentRollSummary[0].PropertyCommercialUsageMix[0])
		let item=this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix[index];
		item.UnitCount=item.OccupiedUnitCount+item.VacantUnitCount+item.DownUnitCount;
		this.getTotalUnit();		
	  }
	  getTotalUnit(){
		let item1=this.contents[1].SUB_SECTIONS[0].data.summary;
		let item2=this.contents[1].SUB_SECTIONS[0].data.PropertyCommercialUsageMix;
		let item3=this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal;
		/*item1.RsdntlTotalUnitCount=item3.TotalOccupiedUnitCount+item3.TotalVacantUnitCount+item3.PptyTotalDownUnitCount+item3.TotalOtherUnitCount;//+item2.RsdntlOccupiedInspectedUnitCount+item2.RsdntlVacantInspectedUnitCount+item2.RsdntlDownInspectedUnitCount+item2.RsdntlOtherInspectedUnitCount;
		item1.CommercialTotalUnitCount=item2[0].UnitCount+item2[1].UnitCount;
		item1.TotalUnitCount=item1.RsdntlTotalUnitCount+item1.CommercialTotalUnitCount*/
		item1.RsdntlTotalUnitCount=item3.TotalOccupiedUnitCount+item3.TotalOtherUnitCount+item2[0].OccupiedUnitCount+item2[1].OccupiedUnitCount;//+item2.RsdntlOccupiedInspectedUnitCount+item2.RsdntlVacantInspectedUnitCount+item2.RsdntlDownInspectedUnitCount+item2.RsdntlOtherInspectedUnitCount;
		item1.CommercialTotalUnitCount=item3.TotalVacantUnitCount+item3.PptyTotalDownUnitCount+item2[0].VacantUnitCount+item2[0].DownUnitCount+item2[1].VacantUnitCount+item2[1].DownUnitCount;
		item1.TotalUnitCount=item1.RsdntlTotalUnitCount+item1.CommercialTotalUnitCount
	  }
	  
	  getTotalUnit1(){
		let dataset=this.contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail;console.log(dataset)
		let total=0;
		const keys=Object.keys(dataset);
		for(let key of keys){
			if(dataset[key]>0){
				/*if(key=='unequal'){
					delete dataset.unequal;
				}*/
				total+=dataset[key];
			}
		}
		console.log(total);
		console.log(this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount);
		if(total==this.contents[1].SUB_SECTIONS[0].data.PropertyResidentialUnitMixTotal.TotalOtherUnitCount){
			this.contents[1].SUB_SECTIONS[0].data['unequal']=false;
		}else{
			this.contents[1].SUB_SECTIONS[0].data['unequal']=true;
		}		
	  }
	  addUnit4(e,field){
		let value=e.target.value;
		let dataset=this.contents[1].SUB_SECTIONS[0].data.PropertyOtherDetail;
		if(value&&parseInt(value)>-1){
			dataset[field]=parseInt(value);
		}else{
			dataset[field]=0;
		}
		this.getTotalUnit1();		
	  }
	  unitrow=1;
	  toFlat(){
		if(this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=='1103'){
			if(this.contents[2].SUB_SECTIONS[0].data.units.length==0){
				this.unitrow=5;
				for(let i=0; i<20; i++){
					this.contents[2].SUB_SECTIONS[0].data.units.push("");
				} 
			}else{
				this.unitrow=Math.ceil(this.contents[2].SUB_SECTIONS[0].data.units.length/4);  
				//if(this.unitrow<5){
				//	this.unitrow=5
				//}    
			}
			return
		}
		if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length==0){
			this.unitrow=1
		}else{
			this.unitrow=Math.ceil(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length/4);      
		}
	  }
	  public bedroomList=['0BR', '1BR', '2BR', '3BR', '4BR', '5BR'];
	  public bedroomStatus=['O = occupied', 'V = vacant', 'D = down','R = Other'];
	  insertUnitRow(){
		this.unitrow++;
			if(this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=="1103"){
			for(let i=0; i<4; i++){
				this.contents[2].SUB_SECTIONS[0].data.units.push("");
			} 
			return
		}
		let item={
			"UnitType": "",
			"SlrDesignatedUnitId": "",
			"OccupancyStatusType": ""
			}
			for(let i=0; i<4; i++){
				this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.push(JSON.parse(JSON.stringify(item)));
			} 
	  }
	  deleteUnitRow(){
		Swal.fire({
				icon:'warning',
				title: 'This will erase the last line. Is this what you want to do?',
				confirmButtonText: 'Yes',
				showCancelButton: true,
				backdrop:false,
			preConfirm: () => {    
				if(this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=="1103"){
					for(let i=0; i<4; i++){
						this.contents[2].SUB_SECTIONS[0].data.units.pop();
					} 
					this.unitrow--;
					return
				}     
				for(let i=0; i<4; i++){
					if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[i]){
						this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.pop();
					}     
				}
			this.unitrow--;
			}
		})
	  } 
	  public sec3type1=[0,1,4,5]; //[0,1,4,5,6,7]; 
	  public sec3type2=[2,3]; 
	  insertVoliationRow(){
		let item={
			'Location':'',
			"OnRecord":'',
			"Description":''
		  }
		  this.contents[1].SUB_SECTIONS[1].data.ViolationRecord.push(item);
	  }
	  deleteVoliationRow(){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {      
				this.contents[1].SUB_SECTIONS[1].data.ViolationRecord.pop();
			}
		})
	  }
	  clearOther(secInfo){
		secInfo.detail.status='';
		if(secInfo.needRepair){
			secInfo.needRepair.status='';
		}
		
	  }
	  insertViolationRow(doc){
		let baserow=JSON.parse(JSON.stringify(doc.baserow));
		doc.list.push(baserow)
	  }
	  deleteViolationRow(doc){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {      
				doc.list.pop();
			}
		})
	  }
	  insertMaterials(doc){
		let baserow=JSON.parse(JSON.stringify(doc.baserow));
		doc.materials.push(baserow)
	  }
	  deleteMaterials(doc){
		Swal.fire({
			icon:'warning',
			title: 'This will erase the last line. Is this what you want to do?',
			confirmButtonText: 'Yes',
			showCancelButton: true,
			backdrop:false,
			preConfirm: () => {      
				doc.materials.pop();
			}
		})
	  }
	  addBedroomType(val, rowIndex, colindex,  field){
		let index=4*rowIndex+colindex;; console.log(index)
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;				
	  }
	  addStaus(val, rowIndex, colindex,  field){
		let index=4*rowIndex+colindex; console.log(index)
		let status=Array.from(val)[0];
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=status;				
	  }
	  addinput(e, rowIndex, colindex,  field){
		let val=e.target.value.trim();
		let index=4*rowIndex+colindex; console.log(index)
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;
	  }
	  addinput1(e, rowIndex, colindex,  field){
		let val=e.target.value.trim().slice(0,1);
		let index=4*rowIndex+colindex; console.log(index)
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;
	  }
	  addUnitId(e, rowIndex, colindex, field?){
		let val=e.target.value.trim();
		let index=4*rowIndex+colindex;
		if(this.reportInfo.PHASE1_TYPE&&this.reportInfo.PHASE1_TYPE=="1103"){
			this.contents[2].SUB_SECTIONS[0].data.units[index]=val;
			return
		}
		this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit[index][field]=val;
	  }
	  addListParties(data){
		let item= {
		  "Name":{'html':'', 'secHtml':null, 'text':''},
		  "Title":{'html':'', 'secHtml':null, 'text':''},
		  "Company":{'html':'', 'secHtml':null, 'text':''},
		  "Affiliation":{'html':'', 'secHtml':null, 'text':''},
		  "Comment":{'html':'', 'secHtml':null, 'text':''},
		};
		data.push(item);
	  }
	  deleteListParties(data){
		Swal.fire({
				icon:'warning',
				title: 'This will erase the last line. Is this what you want to do?',
				confirmButtonText: 'Yes',
				showCancelButton: true,
				backdrop:false,
			preConfirm: () => {		  
				data.pop();	  
			}
	  	})		
	  }
	  selectNone(e, data){
		if(e.target.value=="X"){
			data.checkItem=['','','','','','','','',''];
		}
	  }
	  selectItem(e, data){
		if(e.target.value=="X"){
			data.None='';
		}
	  }
	  getAllDeficiencies(id, title){
		let crs=[];
		let prs=[];
		let pr90s=[];
		let ors=[];
		let adds=[];
		let crstotal=0;
		let prstotal=0;
		let pr90stotal=0;
		//let orstotal=0;
		let addstotal=0;
		if(this.reportInfo?.PCA_INDICATOR!='frm1104') return
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.data.otherDetail&&sec1.data.otherDetail.hasDeficiencies=='YES'){
						for(let item of sec1.data.otherDetail.deficiencies){
							if(item.status=='YES'){
								if(item.cost&&item.cost>0){
									item.cost=this.getRound1(item.cost, 2);
								}else if(item.cost&&item.cost<0){
									item.cost=0;
								}
								item['location']=sec1.SECTION_TITLE;
								if(item.type=="crs"){
									crs.push(item);
									crstotal+=item.cost;
								}else if(item.type=="pr90s"){
									pr90s.push(item);
									pr90stotal+=item.cost;
								}else if(item.type=="prs"){
									prs.push(item);
									prstotal+=item.cost;
								}else if(item.type=="ors"){
									ors.push(item);
								}else if(item.type=="adds"){
									adds.push(item);
									addstotal+=item.cost;
								}
							}
						}
					}else if(sec1.data.deficiencies){
						for(let item of sec1.data.deficiencies){
							if(item.status=='YES'){
								if(item.cost&&item.cost>0){
									item.cost=this.getRound1(item.cost, 2);
								}else if(item.cost&&item.cost<0){
									item.cost=0;
								}
								console.log(item)
								item['location']=sec1.SECTION_TITLE;
								if(item.type=="crs"){
									crs.push(item);
									crstotal+=item.cost;
								}else if(item.type=="pr90s"){
									pr90s.push(item);
									pr90stotal+=item.cost;
								}else if(item.type=="prs"){
									prs.push(item);
									prstotal+=item.cost;
								}else if(item.type=="ors"){
									ors.push(item);
								}else if(item.type=="adds"){
									adds.push(item);
									addstotal+=item.cost;
								}
							}
						}
					}
					if(sec1.id=='frm1104-3-2'){
						for(let items of sec1.data){
						for(let item of items.otherDetail.deficiencies){
							if(item.status=='YES'){
								if(item.cost&&item.cost>0){
									item.cost=this.getRound1(item.cost, 2);
								}else if(item.cost&&item.cost<0){
									item.cost=0;
								}
								console.log(item)
								item['location']=sec1.SECTION_TITLE;
								if(item.type=="crs"){
									crs.push(item);
									crstotal+=item.cost;
								}else if(item.type=="pr90s"){
									pr90s.push(item);
									pr90stotal+=item.cost;
								}else if(item.type=="prs"){
									prs.push(item);
									prstotal+=item.cost;
								}else if(item.type=="ors"){
									ors.push(item);
								}else if(item.type=="adds"){
									adds.push(item);
									addstotal+=item.cost;
								}
							}
						}
						}
					}
					if(sec1.data.sub&&sec1.data.sub.length>0){
						for(let sec2 of sec1.data.sub){
							if(sec2.otherDetail&&sec2.otherDetail.hasDeficiencies=='YES'){
								for(let item of sec2.otherDetail.deficiencies){//console.log(sec2)
									if(item.cost&&item.cost>0){
										item.cost=this.getRound1(item.cost, 2);
									}else if(item.cost&&item.cost<0){
										item.cost=0;
									}
									item['location']=sec2.subcat;
									if(item.status=='YES'){
										if(item.type=="crs"){
											crs.push(item);
											crstotal+=item.cost;
										}else if(item.type=="pr90s"){
											pr90s.push(item);
											pr90stotal+=item.cost;
										}else if(item.type=="prs"){
											prs.push(item);
											prstotal+=item.cost;
										}else if(item.type=="ors"){
											ors.push(item);
										}else if(item.type=="adds"){
											adds.push(item);
											addstotal+=item.cost;
										}
									}
								}
							}
						}
					}
				}
				
			}
			
		}
		let doc=this.contents[4].SUB_SECTIONS[0].data;
		doc.summarydata['adds']=adds;
		doc.summarydata['crs']=crs;
		doc.summarydata['pr90s']=pr90s;
		doc.summarydata['prs']=prs;
		doc.summarydata['ors']=ors;
		doc.summarylabel[0].total=addstotal;
		doc.summarylabel[1].total=crstotal;
		doc.summarylabel[2].total=pr90stotal;
		doc.summarylabel[3].total=prstotal;
		//console.log(doc)
		//console.log(id,title)
		if(id&&title){
			this.autoSave('modify',id, title, "O");
		}
	}
	async singleUserSaveRpt(type?){console.log('singleuser')
		//console.log(this.contents)
		//if(type&&type=='import'){
			//await this.replaceContents('local');			
		//}
		
		let beforeToc='';
				if(this.frontpages.length>0){
					beforeToc=JSON.stringify(this.frontpages);
				}
				let app=JSON.stringify(this.appendices);
				let pdfInfo={'text':this.pdfFname['text'], "name":this.pdfFname.name};
				let inputJson:any;
				if(this.curReport){
					inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":this.curReport.REPORT_ID,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(this.contents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":app,'PCA_DATA':JSON.stringify(this.pcaOp), 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'', "PERCENT_COMPLETE":this.wPercentage+'%',"REVIEWER_PROGRESS":this.rPercentage+'%'};
					console.log(inputJson);
				}
				if(type&&type=='addcopy'){
					inputJson["SAVE_COPY_IND"]="Y";
				}
				const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
				console.log(data);
				if (data.RESPONSE_STATUS=='N') {			
					this.throwError(data);
					return							
				}
	
				if (environment.api.autoSave.toUpperCase() == "Y"){
					
					let that=this;
					window.clearInterval(that.saveTimer);
					window.setTimeout(function() {}, environment.api.autoSaveInterval);
					that.saveTimer = window.setInterval(function () {
						that.autoSave('auto save');
					}, environment.api.autoSaveInterval);
				}
		
	}
	summaryCheck(e, item, field){
		if(e.target.checked){
			item[field]='Y';
			if(field=="acceptable"){
				item.notacceptable='N';
				item.requireFurther='N';
			}else if(field=="notacceptable"){
				item.acceptable='N';
			}else if(field=="requireFurther"){
				item.acceptable='N';
			}
		}else{
			item[field]='N';
		}
	}
	selectRate(e, item, rate){
		item.rate=rate;  		
	}
	openPara(e, field, index1, index2, index3?){console.log(this.contents, field, index1, index2)
		if(e && e.target){
			e.stopPropagation();      
		}
		if(!field){
			this.curFrm={'html':'<p></p>','data':'', 'secHtml':null, 'addedItem':null,'text':''};
			this.curFrm['index1']=index1;
			this.curFrm['index2']=index2;
		}else{
			if(index3>-1){
				let id=this.contents[index1].SUB_SECTIONS[index2].id;
				if(id=='frm1104-2-2'){
					this.curFrm=this.contents[index1].SUB_SECTIONS[index2].data.sub[10].otherDetail.providers[index3]
					this.curFrm['index1']=index1;
					this.curFrm['index2']=index2;
					this.curFrm['index3']=index3;
				}
			}else{
				this.curFrm=this.contents[index1].SUB_SECTIONS[index2].data[field];
				this.curFrm['index1']=index1;
				this.curFrm['index2']=index2;
			}
			
		}
		this.frmShow=true;				
	  }
	  getRound1(val, decimal, type?){//console.log(val, decimal, type)
		let data=0;
			if(this.pcaOp.round=='Round'){
				if(type){
					data=Math.round(val*1000)/1000;
				}else if(decimal==2){
					data=Math.round(val*100)/100;
				}else if(decimal==1){
					data=Math.round(val*10)/10;
				}else if(decimal==0){
					data=Math.round(val);
				}
				
			}else if(this.pcaOp.round=='Round Up'){
				if(type){
					data=Math.ceil(val*1000)/1000;
				}else if(decimal==2){
					data=Math.ceil(val*100)/100;
				}else if(decimal==1){
					data=Math.round(val*10)/10;
				}else if(decimal==0){
					data=Math.ceil(val);
				}
				
			}else if(this.pcaOp.round=='Round Down'){
				if(type){
					data=Math.floor(val*1000)/1000;
				}else if(decimal==2){
					data=Math.floor(val*100)/100;
				}else if(decimal==1){
					data=Math.round(val*10)/10;
				}else if(decimal==0){
					data=Math.floor(val);
				}
				
			}
			//console.log(data)
			return data;
		}
	selectedSignField="";	
	removeName(field?){console.log(field)
		if(field){
			this.contents[0].SUB_SECTIONS[7].data[field].name="";
		}else{
			this.contents[2].SUB_SECTIONS[1].data['name']="";
		}
		
	}
	removeSign(field?){
		if(field){
			this.contents[0].SUB_SECTIONS[7].data[field]['name']='';
			this.contents[0].SUB_SECTIONS[7].data[field]['title']='';
			this.contents[0].SUB_SECTIONS[7].data[field]['sign']='';
			this.contents[0].SUB_SECTIONS[7].data[field].date='';
		}else{
			this.contents[2].SUB_SECTIONS[1].data['name']='';
			this.contents[2].SUB_SECTIONS[1].data['title']='';
			this.contents[2].SUB_SECTIONS[1].data['sign']='';
			this.contents[2].SUB_SECTIONS[1].data['date']='';
			//this.contents[2].SUB_SECTIONS[1].data['firm']='';
		}
	
    }
	addTitle(e, key, field?){console.log(key, field)
		let val=(e.target.value).trim();
		if(field){
			this.contents[0].SUB_SECTIONS[7].data[field][key]=val;
		}else{
			this.contents[2].SUB_SECTIONS[1].data[key]=val;
		}
	}
	ifdeficiencies(e, doc){
		if(e.target.value=='YES'){
			doc.otherDetail.hasDeficiencies='YES';
		}else{
			doc.otherDetail.hasDeficiencies='NO';
		}		
	}
	setvalue(e, item){//console.log(e.target.value)
		let value=e.target.value;
		if(value&&parseInt(value)>-1){
			item.cost=this.getRound1(value, 0);	
			e.target.value=item.cost;
		}else{
			e.target.value=0;
		}
		//console.log(item)
	}
	lawCheck(e, doc, value){
		if(e.target.checked){
			doc.status=value;
		}else{
			doc.status=''
		}
	}
	expandToggle1(e, name){		
		let classId='.'+name
		if(!$(e.target).hasClass('active')){
			$(classId).each(function(){
				$(this).css('display','block');
			})
			$(e.target).addClass('active');
			$(e.target).text('Collapse All');
		}else{
			$(classId).each(function(){
				$(this).css('display','none');
			})
			$(e.target).removeClass('active');
			$(e.target).text('Expand All');
		}
		
	}
	addTableClass(e){
		//console.log(e.target.value, type);
		let val=e.target.value.trim();
		if(val){
				this.curDoc['borderClass']=val;
			}else if(this.curDoc['borderClass']){
				delete this.curDoc.borderClass;
			}
			//this.autoSave('modify',this.curDoc.id, this.curDoc.SECTION_TITLE, this.selectedEditor);
		//console.log(this.curDoc)
	}
	trackErrorFix(inputhtml){console.log('track change error!')
		//console.log(inputhtml)
		let html='<div>'+inputhtml+'</div>'
		let oldFigure, newFigure;
		let figures=$(html).find('figure');
		if(inputhtml.indexOf('data-comment-start-before')>-1){
			let figures=$(html).find('figure');
			if(figures.length>0){
				figures.each(function(){
					oldFigure=this.outerHTML;
					$(this).removeAttr('data-comment-start-before');
					$(this).removeAttr('data-comment-end-after');
					newFigure=this.outerHTML;
					inputhtml=inputhtml.replace(oldFigure,newFigure);
				})				
			}
			
		}
		if(inputhtml.indexOf('data-suggestion-start-before')>-1){
			let figures=$(html).find('figure');
			if(figures.length>0){
				figures.each(function(){
					oldFigure=this.outerHTML;
					$(this).removeAttr('data-suggestion-start-before');
					$(this).removeAttr('data-suggestion-end-after');
					newFigure=this.outerHTML;
					inputhtml=inputhtml.replace(oldFigure,newFigure );
				})				
			}
			
		}
		if(inputhtml.indexOf('<suggestion-start name')>-1||inputhtml.indexOf('<comment-start name=')>-1){
			//const re = new RegExp("\\b"+this.searchText+"(?!([^<]*?)>)\\b",'igm');
			const re1 = new RegExp("<suggestion-start\\b[^>]*>(.*?)<\/suggestion-start>",'igm');//"/<tag\b[^>]*>(.*?)<\/tag>/
			const re2 = new RegExp("<suggestion-end\\b[^>]*>(.*?)<\/suggestion-end>",'igm');
			const re3 = new RegExp("<comment-start\\b[^>]*>(.*?)<\/comment-start>",'igm');
			const re4 = new RegExp("comment-end\\b[^>]*>(.*?)<\/comment-end>",'igm');
			
			let result1 = inputhtml.match(re1); console.log(result1)
			if(result1&&result1.length>0){
				inputhtml=inputhtml.replace(re1, '').replace(re2,'');							
			}
			let result2 = inputhtml.match(re3);console.log(result2)
			if(result2&&result2.length>0){
				inputhtml=inputhtml.replace(re3, '').replace(re4,'');							
			}				
		}
		console.log(inputhtml)
		return inputhtml;
	}
	processing=false;
	async generateKml(photos){
		this.processing=true;
		const result =await this.reportService.generateMobilKML(this.userInfo.COMPANY_ID.toString(),this.userInfo.USER_ID.toString(),this.curReport.REPORT_ID.toString()).toPromise();
			//console.log(result)
			this.processing=false;
			if((result.RESPONSE_STATUS=="Y")){
				Swal.fire({
					html: result.MESSAGE
				})
			}else{
				this.throwError(result);			
			}
	}
	getNoDataErisTable(){
		let tables=[];
		for(let sec of this.contents){
			if(sec.SUB_SECTIONS&&sec.SUB_SECTIONS.length>0){
				for(let sec1 of sec.SUB_SECTIONS){
					if(sec1.TYPE=='TABLE'&&sec1.data&&sec1.data.erisName&&sec1.data.rows.length==0){
						tables.push(sec1.id)
					}
					for(let sec2 of sec1.SUB_SECTIONS){
						if(sec2.TYPE=='TABLE'&&sec2.data&&sec2.data.erisName&&sec2.data.rows.length==0){
							tables.push(sec2.id)
						}						
					}
				}
			}
		}
		return tables
	}
	toUpdatedEris=[];
	async getErisUpdate(id){
		let tables=this.getNoDataErisTable();console.log(tables)
		if(tables.length>0){
			let inputJson={"PROCEDURE":"getSlotByIdListForRefreshOnly", "USER_ID":this.userInfo.USER_ID, "ORDER_NUM":this.reportInfo.ORDER_NUM, "REPORT_ID":id,"TABLE_LIST":tables};
			console.log(inputJson);
			const result = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log(result)
			if(result.TABLE_READY_FOR_REFRESH.length>0){
				this.toUpdatedEris=result.TABLE_READY_FOR_REFRESH;
				//this.toUpdatedEris=result.TABLE_NOT_READY_FOR_REFRESH;console.log(this.toUpdatedEris);
			}
		}
	}
	async updateErisTables(){
		if (this.blockMultiUser()) return;
		$('#overlay2').css('display','block');
		this.loading=true;console.log(this.toUpdatedEris)
		for(let item of this.toUpdatedEris){
			let inputJson={"PROCEDURE":"getslotsbyidlist","USER_ID":parseInt(this.userId),"SLOT_LIST":item.SLOT_ID,"REPORT_ID":this.curReport.REPORT_ID, 'REPORT_SECTION_ID':item.REPORT_SECTION_ID, 'SHOW_HIDDEN_RECORD':'N'};
			console.log(inputJson);
			const response =  await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log('tableslot',response);
			if (response.RESPONSE_STATUS=='N') {
				$('#overlay2').css('display','none');
				this.throwError(response);											
			}else{
				let data=[];
				if(response.RW_SLOTS&&response.RW_SLOTS.length>0&&response.RW_SLOTS[0].CONTENT.length>0){
					let info=JSON.parse(response.RW_SLOTS[0].CONTENT);console.log(info);
					data=info.rows; 					
					let arr=[];
					if(data&&data.length>0){
						let item2=this.getSecbyId(this.contents, item.REPORT_SECTION_ID);
						for(let row of data){
							let arr1=[];
							for(let col of item2.data.cols){
								let index=row.findIndex(cell=>cell.COLUMNINTERNALNAME==col.INTERNALNAME);
								if(col.INTERNALNAME=="ES_RID"){
									row[index]['hide']=true;
								}
								arr1.push(row[index]);									
							}
							arr.push(arr1);
						}
						item2.data.rows=arr;//.push(data.slice(0, 11));
						item2.data['parent_table']=info.parent_table;
						if(info.filters&&info.filters.length>0){
							item2.data['filters']=info.filters;
						}
					}						
					
				}
			}
		}
		let that=this;
		this.zone.run(()=>{
			setTimeout(function(){ 
				$('#overlay2').css('display','none');	
				that.singleUserSaveRpt('addcopy');	
				that.toUpdatedEris=[];						
			}, 5000);
		})
	}
	/*dividedText=[];
	divideText(text: string, maxBytes: number): void {
		let startIndex = 0;
		while (startIndex < text.length) {
		  let endIndex = startIndex + maxBytes;
		  if (endIndex > text.length) {
			endIndex = text.length;
		  }
		  this.dividedText.push(text.slice(startIndex, endIndex));
		  startIndex = endIndex;
		}
	}
	divideText1(text: string, maxBytes: number): string[] {
		const encoder = new TextEncoder();
		const words = text.split(' ');
		let parts: string[] = [];
		let currentPart = '';
	  
		for (let word of words) {
		  const currentPartBytes = encoder.encode(currentPart + ' ' + word).length;
		  if (currentPartBytes > maxBytes) {
			parts.push(currentPart.trim());
			currentPart = word;
		  } else {
			currentPart += ' ' + word;
		  }
		}
	  
		if (currentPart) {
		  parts.push(currentPart.trim());
		}
	  
		return parts;
	  }*/

	divideText2(text) {
		let maxBytes=environment.api.spellcheckmaxbyte;
		const encoder = new TextEncoder();
		const words = text.split(/\s+/);//console.log(words) 
		//const words=this.splitAndRemoveDuplicates(text); console.log(words) 
		let parts = [];
		let currentPart = [];
		let currentSize = 0;

		for (let word of words) {
			let wordSize = encoder.encode(word + ' ').length;

			if (currentSize + wordSize > maxBytes) {
				parts.push(currentPart.join(' '));
				currentPart = [];
				currentSize = 0;
			}

			currentPart.push(word);
			currentSize += wordSize;
		}

		if (currentPart.length > 0) {
			parts.push(currentPart.join(' '));
		}
		//console.log(parts.length)
    	return parts;
	}
	splitAndRemoveDuplicates(inputString) {
		// Split the string into an array of words
		let wordsArray = inputString.split(/\s+/);
	
		// Use a Set to remove duplicates
		let uniqueWords = [...new Set(wordsArray)];
	
		return uniqueWords;
	}
	openHFPage(id){
		let inputJson={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
			if(data.RESPONSE_STATUS=='N'){
				this.throwError(data);					
			}else{console.log(data)
				if(data.HF_DATA&&data.HF_DATA.length>0){
					let htData=JSON.parse(data.HF_DATA);
					if(htData.inputType&&htData.inputType=='HTML'){
						let dataInput=htData.inputType;
 						let savedHTML=this.sanitizer.bypassSecurityTrustHtml(htData.text); 
					
					//this.titleService.setTitle("Footer"+' - ');
					//this.location.go('/cover/Footer-'+data.HEADERFOOTER_ID.toString());
					let newWin = window.open('',data.HF_TITLE);
					newWin.document.write(htData.text);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
				}				
			}
		})		
	}
	openCoverPage(id){
		let inputJson={"PROCEDURE":"getcoverpage", "USER_ID":parseInt(this.userId), "COVERPAGE_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
			if(response.RESPONSE_STATUS=='N'){
				this.throwError(response);					
			}else{console.log(response)
				let data=JSON.parse(response.COVERPAGE_DATA);
				if(data.html&&data.html.length>0){
					let newWin = window.open('',response.HF_TITLE);
					newWin.document.write(data.html);
					newWin.document.close()
					//let new_window = window.open(URL.createObjectURL(new Blob([htData.text], { type: "text/html" })))
					
				}
			}			
		})		
	}
	checkTc(doc, type){
		//console.log(doc, type)
		if(doc.TYPE=='TABLE'&&doc.data){
			if(type=='cap'&&doc.data['caption']){
				if(doc.data['caption']['suggestions']&&doc.data['caption']['suggestions'].length>0){
					doc.tcflag=true;
					return
				}				
			}
			if(type=='col'){
				for(let col of doc.data.cols){
					if(col['suggestions']&&col['suggestions'].length>0){
						doc.tcflag=true;
						return
					}
				}
			}			
			for(let row of doc.data.rows){
				if(type=='eris'){
					for(let cell of row){
						if(cell['suggestions']&&cell['suggestions'].length>0){
							doc.tcflag=true;
							return
						}
					}
				}else{
					for(let cell of row.items){
						if(cell['suggestions']&&cell['suggestions'].length>0){
							doc.tcflag=true;
							return
						}
					}
				}
				
				
			}
			delete doc.tcflag;
		}
	}
	checkExtraHeaderLock(re, replaceString, data){
		if(data['caption']){
			let col =data['caption']
			let result = col.NAME.match(re);
			if(result&&result.length>0){
				col.NAME=col.NAME.replace(re, replaceString);
				col.NAME=this.retriveRFKEY(col.NAME);
				col.text=col.text.replace(re, replaceString);
				if(col.htmltext){
					col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
				}
			}							
		}
		if(data['beforeHeaders']&&data['beforeHeaders'].length>0){
			for(let i=0; i<data['beforeHeaders'].length; i++){
				if(data['locked']&&data['locked']['beforeHeaders'].length>0){//beforeHeaders lock
					if(data['locked']['beforeHeaders'].indexOf(i)>-1){
						continue
					}
				}
				for(let col of data['beforeHeaders'][i]){
					let result = col.NAME.match(re);
					if(result&&result.length>0){
						col.NAME=col.NAME.replace(re, replaceString);
						col.NAME=this.retriveRFKEY(col.NAME);
						col.text=col.text.replace(re, replaceString);
						if(col.htmltext){
							col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
						}
					}
				}
			}
		}
		if(data['afterHeaders']&&data['afterHeaders'].length>0){
			for(let i=0; i<data['afterHeaders'].length; i++){
				if(data['locked']&&data['locked']['afterHeaders'].length>0){//afterHeaders lock
					if(data['locked']['afterHeaders'].indexOf(i)>-1){
						continue
					}
				}
				for(let col of data['afterHeaders'][i]){
					let result = col.NAME.match(re);
					if(result&&result.length>0){
						col.NAME=col.NAME.replace(re, replaceString);
						col.NAME=this.retriveRFKEY(col.NAME);
						col.text=col.text.replace(re, replaceString);
						if(col.htmltext){
							col.htmltext=this.sanitizer.bypassSecurityTrustHtml(col.NAME);
						}
					}
				}
			}
		}
	}
	customizedTablesave(){
		if(this.curCell){
			this.itemIndex++;
			this.curCell['reqIndex']=this.itemIndex;
			this.toCell(this.curSec.id);	
		}else if(this.selectedHeaderType&&this.curHeader){
			this.toCol(this.curSec.id,this.selectedHeaderType)
		}else if(!this.selectedHeaderType&&this.curHeader){
			this.toCol(this.curSec.id)
		}else{
			this.autoSave('modify',this.curSec.id, this.curSec.SECTION_TITLE, this.selectedEditor);	
		}		
	}
	resumeSec(e, item){
		if(e.target.checked){
			let hasResumeSection = this.appendices.SUB_SECTIONS.some(sec => sec['resume']);
			if(hasResumeSection){
				Swal.fire({
					icon:'info',
					html:'<p>Only One Resume Appendix Section Allowed</p>'
				});
				e.target.checked=false;
			}else{
				item["resume"]=true;
				this.appendices['addedResume']=true;				
			}
		}else{
			delete item["resume"];
			let hasResumeSection = this.appendices.SUB_SECTIONS.some(sec => sec['resume']);
			this.appendices['addedResume']=hasResumeSection;
		}
	}
	addResume(info){
		if(info.RESUME_ID&&info.RESUME_ID>-1){
			let item={"TYPE":'resume', "USER_ID":info.USER_ID, "RESUME_ID":info.RESUME_ID,"RESUME_TITLE":info.RESUME_TITLE, "RESUME_URL":info.RESUME_URL,"FIRST_NAME":info.FIRST_NAME,"LAST_NAME":info.LAST_NAME, "USER_EMAIL":info.USER_EMAIL, "selectedfile":true};
			for(let sec of this.appendices.SUB_SECTIONS){
				if(sec['resume']){
					if(!sec['app']){
						sec['app']=[];
					}
					let index=sec['app'].findIndex(item=>item.USER_ID==info.USER_ID);
					if(index==-1){
						/*this.logTab('appendix','noPop');
						setTimeout(() => {
							if(this.appEditable=='Y'){
								sec['app'].push(item);
								sec['nodata']=false;
								this.autoSave('appendix update',"appendix update","appendix update");
							}else{
								Swal.fire({
								icon:'info',
								html:'Cannot add resume to Appendix since another user is currently working on it.' ,
							});
							}	
						}, 300);*/																																																																														
						const sessionId = JSON.parse(this.cookieService.getCookie("userInfo")).SESSION_ID;
						let inputJson={"PROCEDURE":"checkreportappendixlocked","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SESSION_ID":sessionId};
						this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
							if(data.RESPONSE_STATUS=='Y'){
								if(data.ALLOW_UPDATE=='Y'){
									sec['app'].push(item);
									sec['nodata']=false;
									this.autoSave('appendix update',"appendix update","appendix update");
								}else{
									Swal.fire({
									icon:'info',
									html:'Cannot add resume to Appendix since another user is currently working on it.' ,
								});
								}
							}
						});
					
						
						
					}					
				}
			}
		}
		

	}
	/*async shareRpt(url){
			const { value: email } = await Swal.fire({
				title: 'Input email address',
				input: 'text',//'email',
				inputLabel: 'Your email address',
				inputPlaceholder: 'Enter your email address',
				confirmButtonText: 'Share',
				inputValidator: (value) => {
					if (!value) {
					  return 'You need to write something!'
					}else if(value.indexOf('@')==-1||value.indexOf('.')==-1){
						return 'Please input a valid email'
					}
				},
			  })
			  
			  if (email) {this.pdfSpin('start')
				let inputJson={"PROCEDURE":"sharereportbyemail","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,"SHARE_EMAIL":email}; 
				this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data=>{
					this.pdfSpin('end')
					if(data.RESPONSE_STATUS=='Y'){						
						Swal.fire({
							title:"Success",
							html: '<p style="font-size:16px;">'+data.MESSAGE+ '</p>',
							showConfirmButton:true,
						})										
					}else{
						this.throwError(data);
					}
				}) 
				//Swal.fire(`Entered email: ${email}`)
			  }
		}*/
	/*downloadFile(url, name){
		const link = document.createElement('a');
		link.setAttribute('target', '_blank');
		link.setAttribute('href', url);
		link.setAttribute('download', name);
		document.body.appendChild(link);
		link.click();
		link.remove();
	}*/
	public downloadFile(url, fileName){
    //let indexOfUrl = url.indexOf("?");
    //const fileName = url.substring(url.lastIndexOf('/') + 1, indexOfUrl);
    fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    });
  }
	popInfo(url, title, type?){console.log(type)
			let msg1='Your XML file has been generated!'
			let msg2='Get XML file URL';
			let msg3='XML file URL copied!';		
			Swal.fire({
				icon:'success',
				title: msg1,
				html: 'Would you like to download it or get a link?',
				confirmButtonText: 'Download XML file',
				showLoaderOnConfirm: true,
				//showDenyButton: true,
				showCancelButton: true,
				cancelButtonText: msg2,
				//denyButtonText:msg4,
				//denyButtonColor:"#4DB6AC",
				backdrop:false,													
			}).then((response) => {
				if (response.isConfirmed) {
					this.downloadFile(url, title);
				} else if ( response.dismiss === Swal.DismissReason.cancel) {
					navigator.clipboard.writeText(url);
					Swal.fire(
						msg3,									
					)
				}
			})
		}
	async logCloser(){
		let inputJson={"PROCEDURE":"opencloserformforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID}
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if(data.RESPONSE_STATUS=='Y'){
			this.allowCloser=data.ALLOWED_TO_EDIT				
		}else{
			this.throwError(data)
		} 		
	}
	async closeCloser(){
		let inputJson={"PROCEDURE":"closecloserformforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID}
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if(data.RESPONSE_STATUS=='N'){
			this.throwError(data)		
		}	
	}
	
	async logFmeInput(){
		let inputJson={"PROCEDURE":"openfanniemaeforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID}
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if(data.RESPONSE_STATUS=='Y'){
			this.allowFmeInput=data.ALLOWED_TO_EDIT;				
		}else{
			this.throwError(data)
		} 		
	}
	async closeFmeInput(){
		let inputJson={"PROCEDURE":"closefanniemaeforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID}
		const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if(data.RESPONSE_STATUS=='N'){
			this.throwError(data)		
		}
	}
	/*signhtml=`<div style="padding:10px; border: 1px solid black">
	<div class="gallery4" style="height:60px; line-height:60px; margin:0;" >
		<img [src]="photo.FILE_URL" alt="signature" width="200" height="50" style="max-height:90%;width:auto;vertical-align:bottom; margin: 4px;">
		</div>
		<p style="font-weight:normal; margin: 10px 0 0 0;font-size:12px; font-family:Arial; text-align:center">{{photo.NAME}}</p>
		<p style="font-weight:normal; margin: 0 0 0 0;font-size:12px; font-family:Arial; text-align:center" [innerHTML]="photo.TITLE"></p>
		<p style="font-weight:normal; margin: 0 0 0 0;font-size:12px; font-family:Arial; text-align:center" >{{photo.date}}</p>
	</div>`;*/
	/*mockhtml=`<div>
		<div style="display:flex;width:100%; text-align: left; height: 40px" class="alignLeft">
			<div style="height:20px; height:20px; align-self: flex-end; white-space: nowrap"><label id="sig-label" style="font-family:Arial;font-size:10pt">Signature Label</label></div>
			<div style="border-bottom: 1px solid black;flex: 1;align-self: flex-end; height: 40px">
				<img id="sig-img" src="/assets/images/signature.jpg" alt="signature" style="height:38px; max-width:100%; margin-bottom: 2px; margin-left: 10px">
			</div>		
		</div>
		<p id="sig-name" style="font-family:Arial;font-weight:bold;margin-top: 10px;font-size:10pt">Add Your Name Here</p>
		<p id="sig-title" style="font-family:Arial;font-weight:bold;margin-top: 5px;font-size:10pt">Add Your Title Here</p>
	</div>`;
	mockhtml=`<div>
		<div style="display:flex;width:100%; font-size:11px; font-family: Arial; text-align: left" class="alignLeft">
			<div style="height:20px; height:20px; align-self: flex-end; white-space: nowrap"><label id="sig-label">Signature Label</label>:</div>
			<div style="border-bottom: 1px solid black;flex: 1;align-self: flex-end; height: 40px">
				<img id="sig-img" src="/assets/images/signature.jpg" alt="signature" style="height:38px; max-width:100%; margin-bottom: 2px; margin-left: 10px">
			</div>		
		</div>
		<label id="sig-name" style="font-size:11px; font-weight:bold; margin:5px 0; font-family:Arial">Add Your Name Here</label><br>
		<label id="sig-title" style="font-size:11px; font-weight:bold; margin:5px 0; font-family:Arial">Add Your Title Here</label>
	</div>`;*/
	/*`<div>
		<div style="display:flex;width:100%; font-weight:bold; font-size:10px; font-family: Arial; text-align: left" class="alignLeft">
			<div style="height:20px; height:20px; align-self: flex-end; white-space: nowrap"><label id="sig-label">{{LABEL}}</label>:</div>
			<div style="border-bottom: 1px solid black;flex: 1;align-self: flex-end; height: 40px">
				<img id="sig-img" src="/assets/images/signature.jpg" alt="signature" style="height:38px; max-width:100%; margin-bottom: 2px; margin-left: 10px">
			</div>		
		</div>
		<label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial">{{NAME}}</label><br>
		<label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial">{{TITLE}}</label>
	</div>`*/;
	/*`<div>
		<div style="height:40px; line-height:40px; margin:0;">
                <img id="sig-img" src="/assets/images/signature.jpg" alt="signature" width="200" height="50" style="height:38px;width:auto;vertical-align:bottom; margin: 4px;">
        </div>
        <label id="sig-name" style="font-size:11px; margin:5px; font-family:Arial;">{{NAME}}</label><br>
        <label id="sig-title" style="font-size:11px; margin:5px; font-family:Arial;">{{TITLE}}</label>
		</div>`;*/
	frmSwitch(id){
		if (this.listid==id) return
		let index=this.getIdIndex(id);
		let doc=this.getSecbyId(this.contents, id)
		this.getPosition(doc, false, index[0], index[1])
	}
	costFields=["TotalImmediateRepairsCost", "CapitalItemTotalCostOverEvaluationPeriod", "ImmediateRepairUnitCost", "ImmediateRepairCost"];
	costString='CapitalItemYear'
	removeXMLSpecialChar(str, field?){
		if(field&&(this.costFields.indexOf(field)>-1||field.includes(this.costString))){
			if (typeof str === 'number' && !Number.isNaN(str) && str >= 0){
				str=str.toFixed(2);
			}			
		}else if(str&&str.length>0){
			str = str.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll("'", "&apos;").replaceAll('"', "&quot;");
		}
		return str;
	}
	async initCopiedReport(){//refer to importRpt(info)
		this.disableCopiedErisTables()//disable eris table if copied report has eris table with no data to avoid error
		//await this.copiedAppendix(this.curReport);		
		if(this.allSlots.length>0){
			let that=this;
			setTimeout(() => {
				that.fromTemplate=false;
			}, 2000);
			await this.replaceSlots();
			setTimeout(() => {
				that.saveCopiedReport();
			}, 4000);
		}else{
			this.fromTemplate=true;
		}
		
	}
	async copiedAppendix(){
		//this.pdfs=[];
		//await this.getAppendixData();
		for(let item of this.appendices.SUB_SECTIONS){
			if(item.app&&item.app.length>0){
				for(let rf of item.app){
					if(rf.ERIS_FILE=="Y" && rf.url&&rf.url.length>0){
						rf['COPIED']=true						
					}					
				}			
			}			
		}
		if(this.reportInfo.ORDER_NUM&&this.reportInfo.ORDER_NUM.length>0){			
			/*await this.getErisPdfs();
			let inputJson6={"PROCEDURE":"geterisproducts","USER_ID":parseInt(this.userId),"ORDER_NUM":this.reportInfo.ORDER_NUM};
			this.reportService.univeralService(JSON.stringify(inputJson6)).subscribe(result=>{
				if (result.RESPONSE_STATUS=='N') {
					this.throwError(result)											
				}else{
					this.erisPdfs=result.PRODUCT_LINKS;
				}
			})	*/	
			this.addCopiedErisPdfs();
		}
	}
	addCopiedErisPdfs(){
		for(let item of this.appendices.SUB_SECTIONS){
				let newErisPdfs=[];
				if(item.app&&item.app.length>0){
					for(let rf of item.app){
						if(rf.ERIS_FILE=="Y"){
							if(rf['COPIED']){
								let index=this.pdfs.findIndex(pdf=>pdf.REPORT_NAME==rf.name);
									let appInfex=item.app.findIndex(app=>app.name==rf.name&&!app.COPIED);
									if(index>-1){
										let pdfsrc=this.pdfs[index];
										if(appInfex>-1){
											item.app[appInfex].url=pdfsrc.REPORT_URL;
										}else{											
											let addedIndex=newErisPdfs.findIndex(app=>app.name==pdfsrc.REPORT_NAME);
											if(addedIndex==-1){
												let info={"url":pdfsrc.REPORT_URL,"name":pdfsrc.REPORT_NAME,'selected':true, 'type':pdfsrc.FILE_EXTENSION, 'selectedfile':true,"ERIS_FILE":'Y'};
												newErisPdfs.push(info);
											}
											
										}
									}else if(appInfex>-1){
										item.app[appInfex].url="";
									}					
								
							}else{
								let index=this.pdfs.findIndex(pdf=>pdf.REPORT_NAME==rf.name);
								let pdfsrc=this.pdfs[index];
								if(index>-1){
									//if(appInfex>-1){
										rf.url=pdfsrc.REPORT_URL;
									//}
								}
							}
						}					
					}
					if(newErisPdfs.length>0){
						item.app.push(...newErisPdfs);
					}
				}			
			}
	}
	disableCopiedErisTables(){//with set 'disableCopiedEris' to true, will not allow edit eris data and table property and not allow paste data
		if(this.contents){
			for(let item1 of this.contents){
				for(let item2 of item1.SUB_SECTIONS){
					if (item2.TYPE=='TABLE'&&item2.data&&item2.data.SLOT_ID&&item2.data.SLOT_ID>-1&&item2.data.erisName){////console.log(item2);
						item2.data.disableCopiedEris=true;
					}
					if(item2.SUB_SECTIONS&&item2.SUB_SECTIONS.length>0){
						for(let item3 of item2.SUB_SECTIONS){
							if (item3.TYPE=='TABLE'&&item3.data&&item3.data.SLOT_ID&&item3.data.SLOT_ID>-1&&item3.data.erisName){////console.log(item3);
								item3.data.disableCopiedEris=true;
							}					
						}
					}
				}
			}		
		}
	}
	copiedPhotoLog(){	
		let oldUrl=this.reportInfo.ORIGINAL_REPORT_PHOTOLOG_PDF_URL;	
		for(let item of this.appendices.SUB_SECTIONS){
			let ifCopied=false;
			let exist=false;			
			if(item.app&&item.app.length>0){				
				for(let rf of item.app){					
					if(rf.name=='Photo log'||rf.name=='Photo Log'){
						if(rf['COPIED']){
							ifCopied=true;							
						}else if(oldUrl&&oldUrl.length>0){
							rf.url=oldUrl;
							rf['COPIED']=true;	
							ifCopied=true
						}else{
							rf.url='';
							exist=true;
						}											
					}
				}	
				if(!exist&&ifCopied){	
					let info={"name":'Photo log', "url":'', 'selected':true, 'type':'PDF', 'selectedfile':true};
					item.app.push(info);
				}					
			}
			this.checkNoData(item);			
		}
		this.autoSave('appendix update',"appendix update","appendix update");//update appendx to save new photolog copied and url information
	}
	async saveCopiedReport(){		
		let beforeToc='';
			if(this.frontpages.length>0){
				beforeToc=JSON.stringify(this.frontpages);
			}
			let app=JSON.stringify(this.appendices);//need to modify for copied report if eris table in appendix
			let pdfInfo={'text':this.pdfFname['text'], "name":this.pdfFname.name};
			let inputJson:any;
			if(this.curReport){
				inputJson= {"PROCEDURE":"savereportdata","REPORT_ID":this.curReport.REPORT_ID,"USER_ID":parseInt(this.userId),"REPORT_DATA":JSON.stringify(this.contents),"SECTION_ID":'', "SECTION_TITLE":'', "APPENDIX_DATA":app,'PCA_DATA':JSON.stringify(this.pcaOp), 'OVERWRITTEN':'N',"BEFORE_TOC":beforeToc,'SECTION_MODIFIED':'','SECTION_DATA':'', "PERCENT_COMPLETE":'0%',"REVIEWER_PROGRESS":'0%'};
			}
			const data = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			console.log('copiedDataSaved')
			$('#overlay').css('display','none');
			if (data.RESPONSE_STATUS=='N') {			
				this.throwError(data);
				return							
			}

			let inputJson1={"PROCEDURE":"updatereport","USER_ID":parseInt(this.userId), "REPORT_ID":this.curReport.REPORT_ID,"COPIED_REPORT_OPENED":"Y"};
			const result = await this.reportService.univeralService(JSON.stringify(inputJson1)).toPromise();
			console.log('result',result)
			$('#overlay').css('display','none');
			if (result.RESPONSE_STATUS=='N') {			
				this.throwError(data);
				return							
			}
			if (environment.api.autoSave.toUpperCase() == "Y"){
				
				let that=this;
				window.clearInterval(that.saveTimer);
				window.setTimeout(function() {}, environment.api.autoSaveInterval);
				that.saveTimer = window.setInterval(function () {
					that.autoSave('auto save');
				}, environment.api.autoSaveInterval);
			}
			
	}
	/*async getAppendixData(){
		let inputJson4= {"PROCEDURE":"getreportappendix","USER_ID":parseInt(this.userId),"REPORT_ID":this.curReport.REPORT_ID,};
		const response= await this.reportService.univeralService(JSON.stringify(inputJson4)).toPromise();
		
		if (response.RESPONSE_STATUS=='N') {
			this.throwError(response)
		}else{
			if(response.APPENDIX_DATA&&response.APPENDIX_DATA.length>0){
				this.appendices=JSON.parse(response.APPENDIX_DATA);console.log('app',this.appendices);
			}
		}		
	}
	async getErisPdfs(){
		let inputJson={"PROCEDURE":"geterisreportlinks","USER_ID":parseInt(this.userId),"ORDER_NUM":this.reportInfo.ORDER_NUM}
		const result = await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
		if (result.RESPONSE_STATUS=='N') {
			this.throwError(result)
		}else{
			this.pdfs=result.REPORT_LINKS;
		}				
	}*/
	calQuantity(){
		Swal.fire({
				icon:'warning',
				title: 'The quantities for the Repair Actions listed below will be overwritten. Please confirm if you want to continue.',
				confirmButtonText: 'Confirm',
				showLoaderOnConfirm: true,
				showCancelButton: true,
				backdrop:true,
				preConfirm: () => {					
					if(this.frmrowItem){
						let cost=this.frmrowItem['Cost'];
						if(cost&&cost>0){
							let items=['CR', 'PR', 'PR90']; 
							let quantitys=['CRQuantity',"PRQuantity", "PR90Quantity"];						
							for(let i=0; i<items.length; i++){
								let val=this.frmrowItem[items[i]]?parseFloat(this.frmrowItem[items[i]]):0;
								let quantity=Math.round(val/cost);
								this.frmrowItem[quantitys[i]]=quantity.toString();
							}	
							if(this.frmrowItem.selectedYear.length>0){
								let RRval=0;
								for(let year of this.frmrowItem.selectedYear){
									if(this.frmrowItem.allocate[year.toString()]>0){
										RRval+=parseFloat(this.frmrowItem.allocate[year.toString()]);
									}
								}
								if(RRval>0){
									let quantity=Math.round(RRval/cost);
									this.frmrowItem['RRQuantity']=quantity.toString();
								}
							}else{
								this.frmrowItem['RRQuantity']='0';
							}
							let reveseVal=this.frmrowItem.Reserve-this.frmrowItem.reserve;
							if(reveseVal&&reveseVal>0){
								let quantity=Math.round(reveseVal/cost);
								this.frmrowItem['RRQuantity']=quantity.toString();
							}
						}else{
							Swal.fire({
								icon:'info',	
								html:'Unit Cost is 0, cannot calculate quantity',
							})
						}
					}
				}
		})
	}
	modifyAllCost(){
		this.getAllCostTable();
		for(let costtable of this.costTables){
			if(costtable.data&&costtable.data.rows&&costtable.data.rows.length>0){
				if(costtable.data['COST']){
					let items=costtable.data['COST'];console.log(items)
					for(let item of items){
						if(item.allocate&&item.allocate.length>0&&item.allocate.length>this.pcaOp.reserve){
							let splitIndex=this.pcaOp.reserve;
							const firstPart = item.allocate.slice(0, splitIndex);
							const secondPart = item.allocate.slice(splitIndex);
							let sum=0;
							for(let i=0; i<secondPart.length; i++){	
								sum+=secondPart[i];
								//sum+=parseFloat(secondPart[i].toString());
							}
							item.allocate=firstPart;
							item.reserve+=this.getRound(sum,this.pcaOp.decimal);
							item.Year =  this.pcaOp.reserve;
						}else if(item.allocate&&item.allocate.length>0&&item.allocate.length<this.pcaOp.reserve){
							let diff=this.pcaOp.reserve-item.allocate.length;
							for(let i=0; i<diff; i++){
								item.allocate.push(0);
							}
						}
						if(item.selectedYear.length>0){
							let removePart = [];
							for(let year of item.selectedYear){
								if(year>this.pcaOp.reserve){
									let index=item.selectedYear.findIndex(item=>item==year);
									if(index>-1){
										const firstPart = item.selectedYear.slice(0, index);
										removePart = item.selectedYear.slice(index);
										item.selectedYear = firstPart;
									}
									break;
								}
								
							}
							if(removePart.length>0){
								let targetCostId = item.costId;
								let selectedItemsrows = costtable.data.rows.filter(row => row[0] && row[0].costId === targetCostId);
								let remainItemRowLength=selectedItemsrows.length-removePart.length
								let needDeleteIndex=[];
								let remainItemrowIndex=0
								for(let i=0; i<costtable.data.rows.length; i++){
									if(costtable.data.rows[i][0].costId === targetCostId){
										if(remainItemrowIndex<remainItemRowLength){
											remainItemrowIndex++
										}else{
											needDeleteIndex.push(i);
										}										
									}
								}
								costtable.data.rows = costtable.data.rows.filter((_, index) => !needDeleteIndex.includes(index));
							}
							
						}					
					}
				}
			}
		}
	}
}
